var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// api.ts
import globalAxios2 from "axios";

// base.ts
import globalAxios from "axios";
var BASE_PATH = "/api/v1".replace(/\/+$/, "");
var COLLECTION_FORMATS = {
  csv: ",",
  ssv: " ",
  tsv: "	",
  pipes: "|"
};
var BaseAPI = class {
  constructor(configuration, basePath = BASE_PATH, axios2 = globalAxios) {
    this.basePath = basePath;
    this.axios = axios2;
    if (configuration) {
      this.configuration = configuration;
      this.basePath = configuration.basePath || this.basePath;
    }
  }
};
var RequiredError = class extends Error {
  constructor(field, msg) {
    super(msg);
    this.field = field;
    this.name = "RequiredError";
  }
};

// common.ts
var DUMMY_BASE_URL = "https://example.com";
var assertParamExists = function(functionName, paramName, paramValue) {
  if (paramValue === null || paramValue === void 0) {
    throw new RequiredError(paramName, `Required parameter ${paramName} was null or undefined when calling ${functionName}.`);
  }
};
var setApiKeyToObject = function(object, keyParamName, configuration) {
  return __async(this, null, function* () {
    if (configuration && configuration.apiKey) {
      const localVarApiKeyValue = typeof configuration.apiKey === "function" ? yield configuration.apiKey(keyParamName) : yield configuration.apiKey;
      object[keyParamName] = localVarApiKeyValue;
    }
  });
};
var setBearerAuthToObject = function(object, configuration) {
  return __async(this, null, function* () {
    if (configuration && configuration.accessToken) {
      const accessToken = typeof configuration.accessToken === "function" ? yield configuration.accessToken() : yield configuration.accessToken;
      object["Authorization"] = "Bearer " + accessToken;
    }
  });
};
var serializeDataIfNeeded = function(value, requestOptions, configuration) {
  const nonString = typeof value !== "string";
  const needsSerialization = nonString && configuration && configuration.isJsonMime ? configuration.isJsonMime(requestOptions.headers["Content-Type"]) : nonString;
  return needsSerialization ? JSON.stringify(value !== void 0 ? value : {}) : value || "";
};
var toPathString = function(url) {
  return url.pathname + url.search + url.hash;
};
var createRequestFunction = function(axiosArgs, globalAxios3, BASE_PATH2, configuration) {
  return (axios2 = globalAxios3, basePath = BASE_PATH2) => {
    const axiosRequestArgs = __spreadProps(__spreadValues({}, axiosArgs.options), { url: ((configuration == null ? void 0 : configuration.basePath) || basePath) + axiosArgs.url });
    return axios2.request(axiosRequestArgs);
  };
};

// client/ServerConfig.ts
import { merge } from "lodash";
var defaultConfig = {
  basePath: "http://localhost",
  accessToken: ""
};
var _ServerConfig = class _ServerConfig {
  static update(params) {
    const clientHeaders = __spreadValues(__spreadValues({}, _ServerConfig.config.clientHeaders), params.clientHeaders);
    merge(_ServerConfig.config, params, { clientHeaders });
  }
  static get basePath() {
    return _ServerConfig.config.basePath;
  }
  static get accessToken() {
    return _ServerConfig.config.accessToken;
  }
  static getRequestHeaders() {
    if (_ServerConfig.config.getRequestHeaders) {
      return _ServerConfig.config.getRequestHeaders();
    }
    return Promise.resolve({});
  }
  static get onTokenExpired() {
    return _ServerConfig.config.onTokenExpired;
  }
  static get clientHeaders() {
    var _a;
    return (_a = _ServerConfig.config.clientHeaders) != null ? _a : {};
  }
  static reset() {
    _ServerConfig.config = __spreadValues({}, defaultConfig);
  }
};
_ServerConfig.config = __spreadValues({}, defaultConfig);
var ServerConfig = _ServerConfig;

// client/http-client.ts
import axios from "axios";
import { isFunction, merge as merge2 } from "lodash";
import { stringify } from "qs";

// client/utils/date-utils.ts
import { isArray, isDate, isObject, isString } from "lodash";
var DATE_PATTERN = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/;
function replaceDate(src) {
  return DATE_PATTERN.test(src) ? new Date(src) : src;
}
function convertDates(entity) {
  if (isDate(entity)) {
    return entity;
  } else if (isString(entity)) {
    return replaceDate(entity);
  } else if (isArray(entity)) {
    return entity.map(convertDates);
  } else if (isObject(entity)) {
    return Object.entries(entity).reduce(
      (target, [key, value]) => __spreadProps(__spreadValues({}, target), {
        [key]: convertDates(value)
      }),
      {}
    );
  } else
    return entity;
}

// client/http-client.ts
var serializeSearch = (search) => typeof search === "string" ? search : JSON.stringify(search);
var paramsSerializer = (params = {}) => stringify(__spreadValues(__spreadValues({}, params), "search" in params ? { search: serializeSearch(params.search) } : {}));
var responseHandler = (response) => {
  response.data = convertDates(response.data);
  return response;
};
var axiosInstance = axios.create({ paramsSerializer });
var refreshTokenRequest = void 0;
axiosInstance.interceptors.request.use(
  (config) => __async(void 0, null, function* () {
    var _a, _b;
    return merge2({}, config, {
      baseURL: ServerConfig.basePath,
      headers: __spreadValues(__spreadValues(__spreadValues({
        "Idempotency-Key": (_b = (_a = config.headers) == null ? void 0 : _a["Idempotency-Key"]) != null ? _b : "11111"
      }, ServerConfig.accessToken ? { Authorization: `Bearer ${ServerConfig.accessToken}` } : {}), ServerConfig.clientHeaders), yield ServerConfig.getRequestHeaders())
    });
  })
);
axiosInstance.interceptors.response.use(responseHandler);
axiosInstance.interceptors.response.use(void 0, (error) => {
  var _a, _b;
  const config = error.config;
  if (((_a = error.response) == null ? void 0 : _a.status) === 401 && config && !(config == null ? void 0 : config._retried) && !!ServerConfig.accessToken && !!ServerConfig.onTokenExpired) {
    if (!refreshTokenRequest) {
      config._retried = true;
      refreshTokenRequest = ServerConfig.onTokenExpired().then(
        () => new Promise((resolve) => {
          setTimeout(() => resolve(refreshTokenRequest = void 0), 1);
        })
      );
    }
    return refreshTokenRequest.then(() => axiosInstance(config));
  }
  throw isValidationError(error) ? __spreadProps(__spreadValues({}, (_b = error.response) == null ? void 0 : _b.data.error), { rawError: __spreadValues({}, error) }) : __spreadValues({}, error);
});
var createApiFromFp = (fp) => Object.entries(fp()).reduce(
  (target, [key, fn]) => __spreadProps(__spreadValues({}, target), {
    [key]: (...args) => __async(void 0, null, function* () {
      return fn(...args).then((factory) => factory(axiosInstance, `${ServerConfig.basePath}/v1`));
    })
  }),
  {}
);
function _getMethodNamesFromClassInstance(instance) {
  let properties = /* @__PURE__ */ new Set();
  let currentObj = instance;
  do {
    Object.getOwnPropertyNames(currentObj).map((item) => properties.add(item));
  } while (currentObj = Object.getPrototypeOf(currentObj));
  return [...properties.keys()].filter((item) => isFunction(instance[item]));
}
function getMethodNamesFromClassInstance(instance) {
  const target = _getMethodNamesFromClassInstance(instance);
  const genericMethods = [..._getMethodNamesFromClassInstance(new class {
  }()), "constructor", "axios"];
  return target.filter((name2) => !genericMethods.includes(name2));
}
var createInstanceFromApiIClass = (API) => {
  const instance = new API();
  return getMethodNamesFromClassInstance(instance).reduce(
    (target, key) => __spreadProps(__spreadValues({}, target), {
      [key]: (...args) => {
        const method = instance[key];
        return wait(1).then(
          () => method.apply(new API({}, `${ServerConfig.basePath}/v1`, axiosInstance), args)
        );
      }
    }),
    {}
  );
};
var wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
function isValidationError(error) {
  var _a;
  return axios.isAxiosError(error) && !!((_a = error.response) == null ? void 0 : _a.data.error);
}

// package.json
var name = "@melio/ar-api-axios-client";
var version = "0.2.0-beta.1da6ff18a.0";

// api.ts
ServerConfig.update({
  clientHeaders: { "X-Client-Name": name, "X-Client-Version": version }
});
var ApiKeys = {
  AccountantsFirmClientApi: "AccountantsFirmClientApi",
  AccountantsUserServicesApi: "AccountantsUserServicesApi",
  AccountingFirmOrganizationBillingFeeApi: "AccountingFirmOrganizationBillingFeeApi",
  AccountingPlatformsApi: "AccountingPlatformsApi",
  AccountsApi: "AccountsApi",
  AccountsLimitationsApi: "AccountsLimitationsApi",
  AgreementsApi: "AgreementsApi",
  AllowedMccApi: "AllowedMccApi",
  ApprovalWorkflowsApi: "ApprovalWorkflowsApi",
  AuthApi: "AuthApi",
  AutoPayApi: "AutoPayApi",
  BankAccountsApi: "BankAccountsApi",
  BillApi: "BillApi",
  BillSubscriptionsApi: "BillSubscriptionsApi",
  BillingFeeSettingsApi: "BillingFeeSettingsApi",
  BillsApi: "BillsApi",
  BillsSyncApi: "BillsSyncApi",
  BillsSyncAmazonApi: "BillsSyncAmazonApi",
  BillsSyncGmailApi: "BillsSyncGmailApi",
  BusinessDirectoryApi: "BusinessDirectoryApi",
  BusinessesApi: "BusinessesApi",
  CatalogItemsApi: "CatalogItemsApi",
  CustomersApi: "CustomersApi",
  CustomersDashboardApi: "CustomersDashboardApi",
  DefaultApi: "DefaultApi",
  DeliveryMethodTypeOptionsApi: "DeliveryMethodTypeOptionsApi",
  DeliveryMethodsApi: "DeliveryMethodsApi",
  DemoRequestsApi: "DemoRequestsApi",
  EBillsSubscriptionsApi: "EBillsSubscriptionsApi",
  EncryptionApi: "EncryptionApi",
  FeatureFlagsApi: "FeatureFlagsApi",
  FeeCatalogsApi: "FeeCatalogsApi",
  FeesApi: "FeesApi",
  FilesApi: "FilesApi",
  FinancingApi: "FinancingApi",
  FundingSourcesApi: "FundingSourcesApi",
  GetBillsBillIdAttachmentsApi: "GetBillsBillIdAttachmentsApi",
  InboxItemsApi: "InboxItemsApi",
  IndustriesApi: "IndustriesApi",
  IndustryApi: "IndustryApi",
  InternationalApi: "InternationalApi",
  InvoiceDiscountsApi: "InvoiceDiscountsApi",
  InvoiceExpandedApi: "InvoiceExpandedApi",
  InvoicePreferencesApi: "InvoicePreferencesApi",
  InvoiceTimelineApi: "InvoiceTimelineApi",
  InvoicesApi: "InvoicesApi",
  JoinOrganizationRequestsApi: "JoinOrganizationRequestsApi",
  MicroDepositApi: "MicroDepositApi",
  NotificationPreferencesApi: "NotificationPreferencesApi",
  NotificationsApi: "NotificationsApi",
  OnboardingApi: "OnboardingApi",
  OnboardingStatusApi: "OnboardingStatusApi",
  OrganizationBeneficialOwnersApi: "OrganizationBeneficialOwnersApi",
  OrganizationPreferencesApi: "OrganizationPreferencesApi",
  OrganizationsApi: "OrganizationsApi",
  PartnersApi: "PartnersApi",
  PaymentApi: "PaymentApi",
  PaymentGetRequiredDocumentsApi: "PaymentGetRequiredDocumentsApi",
  PaymentIntentsApi: "PaymentIntentsApi",
  PaymentIntentsFromBillApi: "PaymentIntentsFromBillApi",
  PaymentIntentsFromPaymentApi: "PaymentIntentsFromPaymentApi",
  PaymentRequestsApi: "PaymentRequestsApi",
  PaymentsApi: "PaymentsApi",
  PaymentsAttachFilesRequestApi: "PaymentsAttachFilesRequestApi",
  PayorApi: "PayorApi",
  PersonasApi: "PersonasApi",
  PlansApi: "PlansApi",
  PublicPayorApi: "PublicPayorApi",
  ReceivingMethodsApi: "ReceivingMethodsApi",
  RecommendedVendorsApi: "RecommendedVendorsApi",
  ReportsApi: "ReportsApi",
  ScannedInvoicesApi: "ScannedInvoicesApi",
  ServiceChargeCatalogsApi: "ServiceChargeCatalogsApi",
  ServicesApi: "ServicesApi",
  SignaturesApi: "SignaturesApi",
  SubscriptionOrganizationsApi: "SubscriptionOrganizationsApi",
  SubscriptionSyncedPaymentsApi: "SubscriptionSyncedPaymentsApi",
  SubscriptionsApi: "SubscriptionsApi",
  SupportApi: "SupportApi",
  SyncApi: "SyncApi",
  TaxRatesApi: "TaxRatesApi",
  TaxpayerIdentificationRequestsApi: "TaxpayerIdentificationRequestsApi",
  TaxpayerInfoApi: "TaxpayerInfoApi",
  TodosApi: "TodosApi",
  UnilateralRequestsApi: "UnilateralRequestsApi",
  UserPreferencesApi: "UserPreferencesApi",
  VendorGroupsApi: "VendorGroupsApi",
  VendorsApi: "VendorsApi",
  VexAuthenticationApi: "VexAuthenticationApi",
  VexDeliveryMethodsApi: "VexDeliveryMethodsApi",
  VexFTIApi: "VexFTIApi",
  VexGuestApi: "VexGuestApi",
  VexGuestDeliveryMethodsApi: "VexGuestDeliveryMethodsApi",
  VexGuestPaymentApi: "VexGuestPaymentApi",
  VexGuestVendorApi: "VexGuestVendorApi",
  VexGuestW9Api: "VexGuestW9Api",
  VexLinkStatusApi: "VexLinkStatusApi",
  VexOrganizationsApi: "VexOrganizationsApi",
  VexOwnedVendorsApi: "VexOwnedVendorsApi",
  VexPaymentsApi: "VexPaymentsApi"
};
var ARCombinedInvoicePaymentRequestStatusEnum = {
  Created: "created",
  Pending: "pending",
  Fulfilled: "fulfilled",
  Canceled: "canceled",
  Draft: "draft",
  Issued: "issued"
};
var ARCombinedInvoicePaymentRequestDisplayStatusEnum = {
  InProcess: "inProcess",
  Open: "open",
  Overdue: "overdue",
  Paid: "paid",
  Draft: "draft",
  Canceled: "canceled"
};
var ARCurrency = {
  Cad: "CAD",
  Eur: "EUR",
  Gbp: "GBP",
  Usd: "USD"
};
var AREnrollmentStatusEnum = {
  Active: "active",
  Inactive: "inactive",
  Pending: "pending",
  Failed: "failed",
  NotSubmitted: "notSubmitted",
  AwaitDocument: "awaitDocument",
  AwaitMoreInfo: "awaitMoreInfo"
};
var ARErrorCode = {
  CustomerEmailNotUnique: "customerEmailNotUnique",
  DuplicateInvoiceNumber: "duplicateInvoiceNumber",
  InvalidTaxRate: "invalidTaxRate",
  InvalidDiscountValue: "invalidDiscountValue",
  InvalidServiceChargeValue: "invalidServiceChargeValue",
  NotificationNotFound: "notificationNotFound",
  MissingCustomerEmail: "missingCustomerEmail",
  InvoiceCancelled: "invoiceCancelled",
  InvalidScheduledDate: "invalidScheduledDate",
  InvalidImportCustomersFileType: "invalidImportCustomersFileType",
  InvalidCsvCatalogItemsFile: "invalidCsvCatalogItemsFile",
  InvalidCsvCustomersFile: "invalidCsvCustomersFile",
  FeatureFlagDisabled: "featureFlagDisabled",
  PaymentRequestAlreadyPaid: "paymentRequestAlreadyPaid",
  PaymentRequestIsNotPayable: "paymentRequestIsNotPayable"
};
var ARFeeValueTypeEnum = {
  Fixed: "fixed",
  Percent: "percent"
};
var ARInvoiceStatusEnum = {
  Created: "created",
  Pending: "pending",
  Fulfilled: "fulfilled",
  Canceled: "canceled",
  Draft: "draft",
  Issued: "issued"
};
var ARInvoiceDisplayStatusEnum = {
  InProcess: "inProcess",
  Open: "open",
  Overdue: "overdue",
  Paid: "paid",
  Draft: "draft",
  Canceled: "canceled"
};
var ARInvoiceExpandedStatusEnum = {
  Created: "created",
  Pending: "pending",
  Fulfilled: "fulfilled",
  Canceled: "canceled",
  Draft: "draft",
  Issued: "issued"
};
var ARInvoiceExpandedDisplayStatusEnum = {
  InProcess: "inProcess",
  Open: "open",
  Overdue: "overdue",
  Paid: "paid",
  Draft: "draft",
  Canceled: "canceled"
};
var ARPaymentRequestApprovalStatusEnum = {
  Pending: "pending",
  Approved: "approved",
  Denied: "denied",
  Skipped: "skipped"
};
var ARPaymentRequestFeesPaidByEnum = {
  Payor: "payor",
  Vendor: "vendor"
};
var ARPaymentRequestCreateOriginEnum = {
  MelioMe: "melio-me",
  MelioMeGenericLink: "melio-me-generic-link",
  PaymentRequest: "payment-request",
  File: "file",
  QuickbooksOnline: "quickbooks-online",
  CheckoutButton: "checkout-button",
  MelioMeExternalApi: "melio-me-external-api",
  CodatIntegration: "codat-integration",
  MerchantCheckout: "merchant-checkout",
  AccountReceivable: "account-receivable"
};
var ARPaymentRequestSentFromEnum = {
  MelioMe: "melio-me",
  MelioPro: "melio-pro",
  Partner: "partner",
  MelioOnBehalfPartnerApi: "melio-on-behalf-partner-api",
  MerchantCheckout: "merchant-checkout"
};
var ARPaymentRequestStatusEnum = {
  Created: "created",
  Pending: "pending",
  Fulfilled: "fulfilled",
  NonPayable: "non-payable"
};
var ARSortQueryParamOrderEnum = {
  Asc: "Asc",
  Desc: "Desc"
};
var AccountStatusEnum = {
  Pending: "pending",
  Approved: "approved",
  Declined: "declined",
  Suspended: "suspended"
};
var AccountAllOfStatusEnum = {
  Pending: "pending",
  Approved: "approved",
  Declined: "declined",
  Suspended: "suspended"
};
var AccountingPlatformBillLabelOptionStatusEnum = {
  Active: "active",
  Archived: "archived"
};
var AccountingPlatformBillLineItemLabelStatusEnum = {
  Active: "active",
  Archived: "archived"
};
var AccountingPlatformBillLineItemLabelOptionStatusEnum = {
  Active: "active",
  Archived: "archived"
};
var AccountingPlatformConnectionStatus = {
  Connected: "connected",
  Disconnected: "disconnected",
  NotEligibleToSyncPay: "notEligibleToSyncPay",
  Unlinked: "unlinked",
  InvalidCredentials: "invalidCredentials",
  InvalidSubscription: "invalidSubscription",
  Error: "error"
};
var AccountingPlatformPostSyncEntityRequestSyncEntityEnum = {
  Bill: "bill"
};
var AccountingPlatformPostSyncEntityResponseDataEntityEnum = {
  Bill: "bill"
};
var AccountingPlatformSlug = {
  QuickBooksOnline: "quickBooksOnline",
  QuickBooksDesktop: "quickBooksDesktop",
  Xero: "xero",
  QuickBooksDesktopInApp: "quickBooksDesktopInApp",
  FreshBooks: "freshBooks",
  DynamicsBusinessCentral: "dynamicsBusinessCentral"
};
var AccountingPlatformSyncStatus = {
  Done: "done",
  Running: "running",
  Error: "error"
};
var ActionTokenTarget = {
  MicroDeposit: "microDeposit",
  ScheduledPayment: "scheduledPayment",
  PaidPayment: "paidPayment"
};
var AgreementType = {
  PrivacyPolicy: "privacy-policy",
  TermsOfService: "terms-of-service",
  BillsSegregationMessage: "bills-segregation-message",
  DemoRequest: "demo-request"
};
var ApplyForFinancingBusinessType = {
  Corporation: "Corporation",
  Federal: "Federal",
  Llc: "LLC",
  Municipal: "Municipal",
  NonprofitCorporation: "Nonprofit corporation",
  Partnership: "Partnership",
  SoleProprietorship: "Sole Proprietorship"
};
var ApplyForFinancingStatus = {
  AlreadyHasEligibility: "AlreadyHasEligibility",
  Eligible: "Eligible",
  Ineligible: "Ineligible",
  Pending: "Pending"
};
var ApprovalDecisionActionIneligibleReasonEnum = {
  NotPendingPayment: "not-pending-payment",
  PendingOtherApprover: "pending-other-approver"
};
var ApprovalDecisionStatus = {
  Pending: "pending",
  Skip: "skip",
  Approved: "approved",
  Declined: "declined"
};
var ApprovalRequirementStatus = {
  Skip: "skip",
  Pending: "pending"
};
var AssociatedType = {
  User: "user",
  Bill: "bill",
  PaymentRequest: "paymentRequest"
};
var AutoPayStatus = {
  NotCapable: "not_capable",
  Capable: "capable",
  Active: "active"
};
var AutoPaymentAmountTypeEnum = {
  FixedAmount: "fixedAmount",
  TotalAmount: "totalAmount",
  MinimumAmountDue: "minimumAmountDue",
  AccountBalance: "accountBalance"
};
var AutoPaymentDeliveryDateTypeEnum = {
  DueDate: "dueDate",
  UponReceipt: "uponReceipt",
  DaysBeforeDueDate: "daysBeforeDueDate"
};
var BankAccountVerifiedStatusEnum = {
  PlaidVerified: "plaid-verified",
  PlaidNotVerified: "plaid-not-verified",
  NotVerified: "not-verified",
  MicroDepositVerified: "micro-deposit-verified",
  SoftVerified: "soft-verified"
};
var BankAccountType = {
  Checking: "checking",
  Savings: "savings"
};
var BankFsTypeOptionTypeEnum = {
  BankAccount: "bank-account"
};
var BillSubscriptionEndPolicyEnum = {
  NumOfOccurrences: "num-of-occurrences",
  EndDate: "end-date",
  NoEndDate: "no-end-date"
};
var BillSubscriptionErrorCode = {
  DuplicateBillSubscription: "duplicateBillSubscription",
  UnauthorizedSubscription: "unauthorizedSubscription",
  MaxSubscriptionAmountLimit: "maxSubscriptionAmountLimit",
  IneligibleCardNetworkForBillSubscription: "ineligibleCardNetworkForBillSubscription",
  DeliveryMethodChangedForBillSubscription: "deliveryMethodChangedForBillSubscription"
};
var BillSubscriptionIntervalTypeEnum = {
  Weekly: "weekly",
  Monthly: "monthly",
  Yearly: "yearly",
  Every2Weeks: "every_2_weeks",
  Every4Weeks: "every_4_weeks",
  TwiceAMonth: "twice_a_month",
  Every2Months: "every_2_months",
  Every3Months: "every_3_months",
  Every4Months: "every_4_months",
  Every6Months: "every_6_months"
};
var BillSubscriptionManagedBy = {
  Fiserv: "fiserv"
};
var BillSubscriptionRequestNoEndPolicyEndPolicyEnum = {
  NoEndDate: "no-end-date"
};
var BillSubscriptionRequestNoEndPolicyAllOfEndPolicyEnum = {
  NoEndDate: "no-end-date"
};
var BillSubscriptionRequestWithEndDateEndPolicyEnum = {
  EndDate: "end-date"
};
var BillSubscriptionRequestWithEndDateAllOfEndPolicyEnum = {
  EndDate: "end-date"
};
var BillSubscriptionRequestWithNumOfOccurrencesEndPolicyEnum = {
  NumOfOccurrences: "num-of-occurrences"
};
var BillSubscriptionRequestWithNumOfOccurrencesAllOfEndPolicyEnum = {
  NumOfOccurrences: "num-of-occurrences"
};
var BillSubscriptionStatus = {
  Created: "created",
  Stopped: "stopped",
  Done: "done",
  Canceled: "canceled",
  InProgress: "in-progress"
};
var BillingFeeSettingBillingFeeTypeEnum = {
  AchToCheck: "ach_to_check",
  AchToAch: "ach_to_ach"
};
var BillsSortQueryParamFieldEnum = {
  CreatedAt: "createdAt",
  InvoiceNumber: "invoiceNumber",
  VendorName: "vendor.name",
  DueDate: "dueDate",
  TotalAmount: "totalAmount"
};
var BillsSortQueryParamOrderEnum = {
  Asc: "asc",
  Desc: "desc"
};
var BillsSortQueryParamAllOfFieldEnum = {
  CreatedAt: "createdAt",
  InvoiceNumber: "invoiceNumber",
  VendorName: "vendor.name",
  DueDate: "dueDate",
  TotalAmount: "totalAmount"
};
var BillsSyncStatusEnum = {
  Disconnected: "disconnected",
  NotStarted: "not-started",
  InProgress: "in-progress",
  Done: "done",
  Error: "error"
};
var BulkErrorResponseStatusEnum = {
  Error: "error"
};
var BusinessGeography = {
  International: "international",
  Domestic: "domestic"
};
var BusinessStructure = {
  Proprietorship: "Proprietorship",
  LimitedLiabilityCo: "Limited Liability Co",
  Partnership: "Partnership",
  TaxExemptOrganization: "Tax Exempt Organization",
  AssociationEstateTrust: "Association/Estate/Trust",
  Government: "Government",
  PublicCorp: "Public Corp",
  PrivateCorp: "Private Corp"
};
var BusinessType = {
  StandaloneBusiness: "StandaloneBusiness",
  PartOfLargerOrganization: "PartOfLargerOrganization",
  NotSure: "NotSure"
};
var CancelActionInEligibleReasonEnum = {
  UnknownIneligibilityReasonPayments: "unknown-ineligibility-reason-payments"
};
var CapitalOneProviderAllowedPartners = {
  CapitalOne: "capital-one",
  Sbb: "sbb"
};
var CardDirection = {
  Push: "push",
  Pull: "pull"
};
var CardFsTypeOptionTypeEnum = {
  Card: "card"
};
var CardNetwork = {
  Visa: "visa",
  Mastercard: "mastercard",
  Amex: "amex",
  Discover: "discover",
  Other: "other"
};
var CardType = {
  Debit: "debit",
  Credit: "credit"
};
var CategoryBasedBillLineItemTypeEnum = {
  Category: "category"
};
var CategoryBasedBillLineItemBaseTypeEnum = {
  Category: "category"
};
var CategoryBasedBillLineItemResponseTypeEnum = {
  Category: "category"
};
var CompanyComplianceEntityInformationMissingFieldsNameEnum = {
  ContactFirstName: "contactFirstName",
  ContactLastName: "contactLastName",
  CompanyName: "companyName",
  Address: "address",
  LegalCompanyName: "legalCompanyName",
  LegalAddress: "legalAddress",
  TaxInfoType: "taxInfoType",
  TaxInfoIdentifier: "taxInfoIdentifier",
  PhoneNumber: "phoneNumber",
  Industry: "industry",
  BusinessType: "businessType",
  LegalDateOfBirth: "legalDateOfBirth"
};
var CompanyType = {
  AccountingFirm: "accounting-firm",
  Smb: "smb"
};
var ConflictedFieldType = {
  Missing: "Missing",
  Invalid: "Invalid"
};
var CreateFeePaymentParametersCreateMethodEnum = {
  PaymentFee: "payment_fee",
  SubscriptionFee: "subscription_fee"
};
var CreatedByTypeEnum = {
  Vendor: "vendor",
  Payor: "payor"
};
var Currency = {
  Usd: "USD"
};
var CustomerTypeEnum = {
  Customer: "customer",
  Vendor: "vendor",
  Lead: "lead",
  Consumer: "consumer",
  Business: "business"
};
var CustomerTypeRequestPayloadEnum = {
  Consumer: "consumer",
  Business: "business"
};
var CustomersDashboardSortQueryParamFieldEnum = {
  CompanyName: "companyName"
};
var CustomersDashboardSortQueryParamOrderEnum = {
  Asc: "Asc",
  Desc: "Desc"
};
var CustomersDashboardSortQueryParamAllOfFieldEnum = {
  CompanyName: "companyName"
};
var CustomersSortQueryParamFieldEnum = {
  UpdatedAt: "updatedAt"
};
var CustomersSortQueryParamOrderEnum = {
  Asc: "Asc",
  Desc: "Desc"
};
var CustomersSortQueryParamAllOfFieldEnum = {
  UpdatedAt: "updatedAt"
};
var DeleteActionInEligibleReasonEnum = {
  PaymentInProgress: "payment-in-progress"
};
var DeliveryMethodAccountType = {
  Plaid: "plaid"
};
var DeliveryMethodType = {
  BankAccount: "bank-account",
  Card: "card",
  PaperCheck: "paper-check",
  VirtualAccount: "virtual-account",
  BillerAccount: "biller-account",
  DomesticWireAccount: "domestic-wire-account",
  InternationalAccount: "international-account",
  VirtualCard: "virtual-card",
  ManagedAccount: "managed-account"
};
var DeliveryMethodUpdateType = {
  BankAccount: "bank-account",
  PaperCheck: "paper-check",
  Plaid: "plaid"
};
var DeliveryPreferenceType = {
  Ach: "ach",
  Check: "check",
  Virtual: "virtual",
  Card: "card",
  DomesticWire: "domestic-wire",
  OvernightCheck: "overnight-check",
  ExpressCheck: "express-check",
  ExpeditedAch: "expedited-ach",
  Rpps: "rpps",
  International: "international",
  VirtualCard: "virtual-card",
  OvernightAch: "overnight-ach",
  Rtp: "rtp",
  FastVc: "fast-vc",
  ExpressCard: "express-card"
};
var EBillStatus = {
  NotCapable: "not_capable",
  Capable: "capable",
  Pending: "pending",
  Active: "active",
  Rejected: "rejected"
};
var EbillsSubscriptionOptionsReceivingOptionNameEnum = {
  Ebill: "ebill",
  Dual: "dual",
  Trial: "trial"
};
var EditActionInEligibleReasonEnum = {
  UnknownIneligibilityReasonPayments: "unknown-ineligibility-reason-payments"
};
var ExternalTarget = {
  Onboarding: "onboarding",
  JustPay: "justPay",
  ViewVendors: "viewVendors",
  ViewSettings: "viewSettings",
  SchedulePayment: "schedulePayment",
  ScheduleBatchPayments: "scheduleBatchPayments",
  EditPayment: "editPayment",
  ViewBill: "viewBill",
  ViewScheduledPayment: "viewScheduledPayment",
  ViewPaidPayment: "viewPaidPayment",
  ViewScannedInvoice: "viewScannedInvoice"
};
var FeeCatalogValueTypeEnum = {
  Fixed: "fixed",
  Percent: "percent"
};
var FeeFundingSourceType = {
  Ach: "ach",
  DebitCard: "debitCard",
  CreditCard: "creditCard"
};
var FeeType = {
  Ach: "ach",
  Check: "check",
  Virtual: "virtual",
  Credit: "credit",
  Debit: "debit",
  International: "international",
  InternationalFx: "international-fx",
  PushToDebit: "push-to-debit",
  DomesticWire: "domestic-wire",
  OvernightCheck: "overnight-check",
  OvernightAch: "overnight-ach",
  ExpressCheck: "express-check",
  ExpeditedAch: "expedited-ach",
  ExpeditedAchVendor: "expedited-ach-vendor",
  AchToCheck: "ach-to-check",
  Card: "card",
  Rtp: "rtp",
  RtpOrganization: "rtp-organization"
};
var FeesPaidByEnum = {
  Vendor: "vendor",
  Payor: "payor"
};
var FileOCRDataLineItemTypeEnum = {
  Item: "item",
  Category: "category"
};
var FinancingEligibilityStatus = {
  Pending: "pending",
  Declined: "declined",
  Eligible: "eligible",
  Suspended: "suspended",
  Ineligible: "ineligible"
};
var FinancingPaymentIneligibilityReason = {
  VendorIneligible: "vendor-ineligible",
  InsufficientBalance: "insufficient-balance",
  PaymentIneligible: "payment-ineligible"
};
var FinancingProvider = {
  CreditKey: "CreditKey"
};
var FirmAccessLevel = {
  Full: "full",
  None: "none"
};
var FiservBusinessesResultDirectoryNameEnum = {
  Fiserv: "Fiserv"
};
var FiservProviderAllowedPartners = {
  FiservUsBank: "fiserv_us-bank",
  FiservXdDemo: "fiserv_xd-demo",
  FiservFirstFinancial: "fiserv_first-financial"
};
var FlexFsTypeOptionTypeEnum = {
  FlexAccount: "flex-account"
};
var FundingSourceBankAccountTypeEnum = {
  BankAccount: "bank-account"
};
var FundingSourceBankAccountAllOfTypeEnum = {
  BankAccount: "bank-account"
};
var FundingSourceCardTypeEnum = {
  Card: "card"
};
var FundingSourceCardAllOfTypeEnum = {
  Card: "card"
};
var FundingSourceEntitlementType = {
  All: "all",
  Selective: "selective"
};
var FundingSourceFlexAccountTypeEnum = {
  FlexAccount: "flex-account"
};
var FundingSourceFlexAccountAllOfTypeEnum = {
  FlexAccount: "flex-account"
};
var FundingSourceOptionTypeEnum = {
  Ach: "ach",
  Card: "card"
};
var FundingSourceType = {
  BankAccount: "bank-account",
  Card: "card",
  FlexAccount: "flex-account"
};
var FundingSourcesIncludeEnum = {
  FirmBillingFeeMethod: "firmBillingFeeMethod"
};
var FundingSourcesVerifyRequestMicroDepositsTypeEnum = {
  MicroDeposits: "micro-deposits"
};
var FundingSourcesVerifyRequestPlaidTypeEnum = {
  Plaid: "plaid"
};
var GetSyncMigrationResponseDataStatusEnum = {
  Running: "running",
  Success: "success",
  Error: "error",
  NotTriggered: "notTriggered"
};
var GetVexGuestPaymentResponseDataStatusEnum = {
  Scheduled: "scheduled",
  InProgress: "in-progress",
  Completed: "completed",
  Failed: "failed",
  Blocked: "blocked"
};
var GetVirtualCardAcceptanceResponseDataStatusEnum = {
  Active: "active",
  Cleared: "cleared",
  Expired: "expired",
  Canceled: "canceled",
  Authorized: "authorized",
  Posted: "posted"
};
var InboxEmailOriginEnum = {
  BillsInbox: "bills_inbox",
  GmailSync: "gmail_sync"
};
var InboxEmailAllOfOriginEnum = {
  BillsInbox: "bills_inbox",
  GmailSync: "gmail_sync"
};
var InboxItemBillTypeEnum = {
  Bill: "bill"
};
var InboxItemPaymentTypeEnum = {
  Payment: "payment"
};
var InboxItemPaymentRequestTypeEnum = {
  PaymentRequest: "paymentRequest"
};
var InboxItemScannedInvoiceTypeEnum = {
  ScannedInvoice: "scannedInvoice"
};
var InboxItemTypesEnum = {
  ScannedInvoice: "scannedInvoice",
  Payment: "payment",
  PaymentRequest: "paymentRequest",
  Bill: "bill"
};
var InboxItemsSortQueryParamFieldEnum = {
  CreatedAt: "createdAt",
  InvoiceNumber: "invoiceNumber",
  VendorName: "vendor.name",
  DueDate: "dueDate",
  Amount: "amount"
};
var InboxItemsSortQueryParamOrderEnum = {
  Asc: "asc",
  Desc: "desc"
};
var InboxItemsSortQueryParamAllOfFieldEnum = {
  CreatedAt: "createdAt",
  InvoiceNumber: "invoiceNumber",
  VendorName: "vendor.name",
  DueDate: "dueDate",
  Amount: "amount"
};
var InitialManagedByType = {
  Managed: "managed",
  Unmanaged: "unmanaged"
};
var InstallmentStatus = {
  Scheduled: "scheduled",
  Completed: "completed",
  Failed: "failed",
  HandledByCreditKey: "handled-by-credit-key",
  Canceled: "canceled"
};
var InternationalAccountIdentifierTypeEnum = {
  V2: "v2"
};
var InternationalAccountBicSwiftIdentifierTypeEnum = {
  BicSwift: "bicSwift"
};
var InternationalAccountIbanIdentifierTypeEnum = {
  Iban: "iban"
};
var InternationalBillingEnum = {
  BicSwift: "bicSwift",
  Iban: "iban"
};
var InvalidReason = {
  AddressNotFound: "AddressNotFound",
  InvalidAddress: "invalidAddress",
  InvalidPoBox: "invalidPoBox"
};
var InvitationStatus = {
  Pending: "pending",
  Approved: "approved",
  Canceled: "canceled"
};
var InvoiceDataSourceEntityTypeEnum = {
  Bill: "bill",
  PaymentRequest: "payment-request",
  BillSubscription: "bill-subscription"
};
var InvoiceDiscountTypeEnum = {
  Amount: "amount",
  Percentage: "percentage"
};
var InvoiceExpandedSummaryStatusEnum = {
  Created: "created",
  Pending: "pending",
  Fulfilled: "fulfilled",
  Canceled: "canceled",
  Draft: "draft",
  Issued: "issued"
};
var InvoiceExpandedSummaryDisplayStatusEnum = {
  InProcess: "inProcess",
  Open: "open",
  Overdue: "overdue",
  Paid: "paid",
  Draft: "draft",
  Canceled: "canceled"
};
var InvoiceSortQueryParamFieldEnum = {
  CreatedAt: "createdAt",
  InvoiceNumber: "invoiceNumber",
  DueDate: "dueDate",
  TotalAmount: "totalAmount",
  UpdatedAt: "updatedAt"
};
var InvoiceSortQueryParamOrderEnum = {
  Asc: "Asc",
  Desc: "Desc"
};
var InvoiceSortQueryParamAllOfFieldEnum = {
  CreatedAt: "createdAt",
  InvoiceNumber: "invoiceNumber",
  DueDate: "dueDate",
  TotalAmount: "totalAmount",
  UpdatedAt: "updatedAt"
};
var InvoiceStatus = {
  Draft: "draft",
  Overdue: "overdue",
  Canceled: "canceled",
  Open: "open",
  Paid: "paid"
};
var InvoiceTimelineEmailTypeEnum = {
  ArPaymentRequestShared: "ar-payment-request-shared",
  ArInvoiceUpdated: "ar-invoice-updated",
  ArInvoiceReminderApproachingDueDate: "ar-invoice-reminder-approaching-due-date",
  ArInvoiceReminderOnDueDate: "ar-invoice-reminder-on-due-date",
  ArInvoiceReminderOverdue: "ar-invoice-reminder-overdue",
  ArInvoiceReminderManual: "ar-invoice-reminder-manual"
};
var ItemBasedBillLineItemTypeEnum = {
  Item: "item"
};
var ItemBasedBillLineItemBaseTypeEnum = {
  Item: "item"
};
var ItemBasedBillLineItemResponseTypeEnum = {
  Item: "item"
};
var JoinOrganizationRequestRole = {
  Owner: "owner",
  Admin: "admin",
  Contributor: "contributor",
  Accountant: "accountant"
};
var JoinOrganizationRequestStatus = {
  Pending: "pending",
  Approved: "approved",
  Canceled: "canceled"
};
var LoanStatus = {
  Active: "active",
  Completed: "completed",
  Failed: "failed",
  HandledByCreditKey: "handled-by-credit-key",
  Canceled: "canceled"
};
var ManagedAccountDeliveryTypeEnum = {
  Ach: "ach",
  Check: "check"
};
var MeasurementUnit = {
  Seat: "Seat"
};
var MsnOrigin = {
  PUBLIC_FORM: "public-form",
  SALES_FORM: "sales-form",
  EXISTING_GET_PAID_VENDOR: "existing_get-paid_vendor",
  SALES_GET_PAID_WIZARD: "sales_get_paid_wizard",
  UNILATERAL_AND_ENROLLMENT: "unilateral_and_enrollment",
  AR_ERP_FORM: "ar_erp_form"
};
var NotificationsNames = {
  InvoiceDueDateApproachingReminder: "invoiceDueDateApproachingReminder",
  InvoiceDueDateTodayReminder: "invoiceDueDateTodayReminder",
  InvoiceOverdueReminder: "invoiceOverdueReminder"
};
var NullableInternationalBillingEnum = {
  BicSwift: "bicSwift",
  Iban: "iban"
};
var NullableInternationalRiskEnum = {
  Low: "low",
  Medium: "medium",
  High: "high"
};
var OAuthAccountNotCreatedReason = {
  RequireNonMelioEmail: "require-non-melio-email",
  RequireMelioEmail: "require-melio-email",
  UserAlreadyExists: "user-already-exists",
  MissingFirstName: "missing-first-name",
  MissingLastName: "missing-last-name",
  MissingCompanyName: "missing-company-name",
  MissingAddress: "missing-address",
  HasMultipleOrganizations: "has-multiple-organizations",
  UserConsent: "user-consent",
  MissingCompanyPhoneNumber: "missing-company-phone-number",
  MissingUserPhoneNumber: "missing-user-phone-number",
  MissingDateOfBirth: "missing-date-of-birth"
};
var OAuthAccountStatus = {
  Created: "created",
  NotCreated: "not-created"
};
var OTPVerifyForbiddenErrorCode = {
  ExpiredMfaSession: "EXPIRED_MFA_SESSION",
  ExpiredAuthenticator: "EXPIRED_AUTHENTICATOR",
  MaxAttemptsReached: "MAX_ATTEMPTS_REACHED",
  ExpiredCode: "EXPIRED_CODE",
  Denied: "DENIED",
  UsernameRequired: "USERNAME_REQUIRED",
  Forbidden: "FORBIDDEN",
  WrongCode: "WRONG_CODE",
  GeneralErrorCode: "GENERAL_ERROR_CODE"
};
var OrgFinancingIneligibilityReason = {
  OrganizationIneligible: "organization-ineligible",
  PreEligibility: "pre-eligibility",
  Unknown: "unknown",
  UnresolvedInstallments: "unresolved-installments"
};
var OrgFinancingProviderStatusProviderEnum = {
  CreditKey: "CreditKey"
};
var OrgFinancingProviderStatusStatusEnum = {
  Approved: "APPROVED",
  Pending: "PENDING",
  Declined: "DECLINED",
  Hold: "HOLD",
  Unknown: "UNKNOWN",
  New: "NEW",
  Suspended: "SUSPENDED"
};
var OrgFinancingProviderStatusAllOf1ProviderEnum = {
  CreditKey: "CreditKey"
};
var OrgFinancingProviderStatusAllOf1StatusEnum = {
  Approved: "APPROVED",
  Pending: "PENDING",
  Declined: "DECLINED",
  Hold: "HOLD",
  Unknown: "UNKNOWN",
  New: "NEW",
  Suspended: "SUSPENDED"
};
var OrganizationBusinessType = {
  SoleProprietorship: "sole-proprietorship",
  Partnership: "partnership",
  LimitedLiabilityCompany: "limited-liability-company",
  Corporation: "corporation",
  NonProfit: "non-profit",
  NonGovernmentalOrganization: "non-governmental-organization",
  MunicipalCorporation: "municipal-corporation",
  TrustOrEstate: "trust-or-estate"
};
var OrganizationFailureReason = {
  Nsf: "NSF",
  TechnicalError: "TechnicalError",
  ExpiredCard: "ExpiredCard"
};
var OrganizationToBusinessLinkStatus = {
  PENDING_TO_CREATE: "pending_to_create",
  VERIFIED: "verified",
  REJECTED: "rejected",
  OPT_OUT: "opt_out"
};
var OrganizationVerifiedPersonaTypeEnum = {
  Ubo: "ubo",
  Director: "director",
  FxAccountHolder: "fxAccountHolder",
  FinancingApplicant: "financingApplicant"
};
var PartnerName = {
  WellsFargo: "wells-fargo",
  CapitalOne: "capital-one",
  Clover: "clover",
  Melio: "melio",
  Shopify: "shopify",
  Sbb: "sbb",
  Fiserv: "fiserv",
  BuiltTechnologies: "built-technologies",
  FiservUsBank: "fiserv_us-bank",
  FiservXdDemo: "fiserv_xd-demo",
  FiservFirstFinancial: "fiserv_first-financial",
  DeploymentsDemo: "deployments-demo",
  Paypal: "paypal"
};
var PatchBillSubscriptionsRequestEndPolicyEnum = {
  EndDate: "end-date",
  NumOfOccurrences: "num-of-occurrences",
  NoEndDate: "no-end-date"
};
var PatchBillsBillIdRequestLineItemCreateOperationEnum = {
  Create: "create"
};
var PatchBillsBillIdRequestLineItemDeleteOperationEnum = {
  Delete: "delete"
};
var PatchBillsBillIdRequestLineItemLabelCreateOperationEnum = {
  Create: "create"
};
var PatchBillsBillIdRequestLineItemLabelDeleteOperationEnum = {
  Delete: "delete"
};
var PatchBillsBillIdRequestLineItemLabelUpdateOperationEnum = {
  Update: "update"
};
var PatchBillsBillIdRequestLineItemUpdateOperationEnum = {
  Update: "update"
};
var PatchCategoryBillLineItemUpdateTypeEnum = {
  Category: "category"
};
var PatchItemBillLineItemUpdateTypeEnum = {
  Item: "item"
};
var PatchMarkedAsPaidRequestMethodEnum = {
  Ach: "ach",
  Check: "check",
  Card: "card",
  Cash: "cash",
  Other: "other"
};
var PaymentStatusEnum = {
  Scheduled: "scheduled",
  InProgress: "in-progress",
  Completed: "completed",
  Failed: "failed",
  Blocked: "blocked",
  Canceled: "canceled"
};
var PaymentApprovalDecisionStatusEnum = {
  Pending: "pending",
  Approved: "approved",
  Declined: "declined",
  Skip: "skip"
};
var PaymentAllOfStatusEnum = {
  Scheduled: "scheduled",
  InProgress: "in-progress",
  Completed: "completed",
  Failed: "failed",
  Blocked: "blocked",
  Canceled: "canceled"
};
var PaymentAllOfApprovalDecisionStatusEnum = {
  Pending: "pending",
  Approved: "approved",
  Declined: "declined",
  Skip: "skip"
};
var PaymentCreateMethodEnum = {
  Single: "single",
  Batch: "batch",
  AutoPayment: "auto_payment",
  PaymentFee: "payment_fee",
  SubscriptionFee: "subscription_fee",
  JustPay: "just_pay",
  SingleSync: "single_sync",
  JustPayBatch: "just_pay_batch",
  JustPaySync: "just_pay_sync",
  Recurring: "recurring",
  SyncRecurring: "sync_recurring"
};
var PaymentDeliveryPreferenceEnum = {
  ExpeditedAch: "expedited-ach",
  OvernightCheck: "overnight-check",
  ExpressCheck: "express-check",
  InternalExpressCheck: "internal-express-check",
  FastVc: "fast-vc",
  OvernightAch: "overnight-ach",
  Rtp: "rtp",
  ExpressCard: "express-card"
};
var PaymentDisabledActionNameEnum = {
  EditAmount: "edit-amount",
  Financing: "financing"
};
var PaymentErrorCode = {
  DuplicatePayment: "duplicatePayment",
  AccountFrozen: "accountFrozen",
  AccountClosed: "accountClosed",
  DateTooEarly: "dateTooEarly",
  UnauthorizedPayment: "unauthorizedPayment",
  PaymentEditingLocked: "paymentEditingLocked",
  FailedPaymentEditingLocked: "failedPaymentEditingLocked",
  InsufficientFunds: "insufficientFunds",
  MaxPaymentAmountLimit: "maxPaymentAmountLimit",
  DeliveryMethodChanged: "deliveryMethodChanged",
  IneligibleCardNetworkForPayment: "ineligibleCardNetworkForPayment"
};
var PaymentFailureReason = {
  AccountFrozen: "accountFrozen",
  BalancesNotAvailable: "balancesNotAvailable",
  BankAccountUnauthorized: "bankAccountUnauthorized",
  CardNetworkRestrictions: "cardNetworkRestrictions",
  DoNotHonor: "doNotHonor",
  ExceedsWithdrawalAmountLimit: "exceedsWithdrawalAmountLimit",
  Expired: "expired",
  InsufficientFunds: "insufficientFunds",
  InvalidBankAccountNumber: "invalidBankAccountNumber",
  InvalidTransaction: "invalidTransaction",
  NoBankAccount: "noBankAccount",
  NonTransactionAccount: "nonTransactionAccount",
  PaymentNotAllowedConsumer: "paymentNotAllowedConsumer",
  PaymentNotAllowedDuplicate: "paymentNotAllowedDuplicate",
  PaymentNotAllowedOther: "paymentNotAllowedOther",
  PaymentNotAllowedPayroll: "paymentNotAllowedPayroll",
  PaymentNotAllowedTechnical: "paymentNotAllowedTechnical",
  PaymentNotAllowedVendorDetails: "paymentNotAllowedVendorDetails",
  PaymentStoppedByVendor: "paymentStoppedByVendor",
  ReceiverAccountClosed: "receiverAccountClosed",
  ReceiverRefusedCreditEntry: "receiverRefusedCreditEntry",
  RetrySupportedFundingSource: "retrySupportedFundingSource",
  ReturnedCheck: "returnedCheck",
  RoutingNumberIncorrect: "routingNumberIncorrect",
  UnauthorizedDebitToConsumerAccount: "unauthorizedDebitToConsumerAccount",
  UncollectedFunds: "uncollectedFunds",
  UnilateralDeliveryMethodNotProvided: "unilateralDeliveryMethodNotProvided",
  UnilateralPaymentExpired: "unilateralPaymentExpired",
  UserBlockedMelioAccount: "userBlockedMelioAccount",
  VendorCanceled: "vendorCanceled",
  VirtualCardExpired: "virtualCardExpired"
};
var PaymentFailureType = {
  CollectFailure: "collectFailure",
  DeliveryFailure: "deliveryFailure",
  ContactSupport: "contactSupport"
};
var PaymentIntentStatusEnum = {
  Unpaid: "unpaid",
  Paid: "paid",
  PartiallyPaid: "partially-paid",
  Scheduled: "scheduled",
  Draft: "draft"
};
var PaymentIntentAllOfStatusEnum = {
  Unpaid: "unpaid",
  Paid: "paid",
  PartiallyPaid: "partially-paid",
  Scheduled: "scheduled",
  Draft: "draft"
};
var PaymentIntentPatchBulkSuccessStatusEnum = {
  Success: "success"
};
var PaymentProcessStatusEnum = {
  Blocked: "blocked",
  Scheduled: "scheduled",
  Invalid: "invalid",
  InProgress: "in-progress",
  Sent: "sent",
  Failed: "failed",
  Retry: "retry",
  Cleared: "cleared",
  Settled: "settled",
  CancelScheduled: "cancel-scheduled",
  CancelInProgress: "cancel-in-progress",
  CancelSent: "cancel-sent",
  CancelCleared: "cancel-cleared",
  CancelSettled: "cancel-settled",
  CancelFailed: "cancel-failed",
  Acknowledged: "acknowledged",
  CancelAcknowledged: "cancel-acknowledged",
  Committed: "committed"
};
var PaymentRequestStatusEnum = {
  Created: "created",
  Pending: "pending",
  Fulfilled: "fulfilled",
  CancelledByCustomer: "cancelledByCustomer",
  NonPayable: "non-payable"
};
var PaymentRequestAllOfStatusEnum = {
  Created: "created",
  Pending: "pending",
  Fulfilled: "fulfilled",
  CancelledByCustomer: "cancelledByCustomer",
  NonPayable: "non-payable"
};
var PaymentStatus = {
  Scheduled: "scheduled",
  InProgress: "in-progress",
  Completed: "completed",
  Failed: "failed",
  Blocked: "blocked",
  Canceled: "canceled"
};
var PaymentTimelineItemTargetAccountTypeEnum = {
  FundingSource: "funding-source",
  DeliverMethod: "deliver-method",
  OurAccount: "our-account"
};
var PaymentTimelineItemStatusEnum = {
  Scheduled: "scheduled",
  Committed: "committed",
  Completed: "completed",
  Sent: "sent",
  Failed: "failed",
  Acknowledged: "acknowledged",
  Cleared: "cleared",
  Settled: "settled"
};
var PaymentTimelineItemFlowEnum = {
  Collect: "collect",
  Deliver: "deliver",
  CancelCollect: "cancel-collect",
  CancelDeliver: "cancel-deliver",
  Balancing: "balancing"
};
var PaymentUpgradeOfferOptionEnum = {
  Rtp: "RTP",
  Fach: "FACH",
  Debit: "DEBIT",
  FastVc: "FAST_VC"
};
var PaymentWidgetFundingSourceType = {
  BANK: "bank",
  CARD: "card"
};
var PaymentsSortQueryParamFieldEnum = {
  ScheduledDate: "scheduledDate",
  VendorName: "vendor.name",
  Amount: "amount",
  CreatedAt: "createdAt",
  UpdatedAt: "updatedAt",
  DeliveryDate: "deliveryDate",
  EstimatedDelivery: "estimatedDelivery"
};
var PaymentsSortQueryParamOrderEnum = {
  Asc: "asc",
  Desc: "desc"
};
var PaymentsSortQueryParamAllOfFieldEnum = {
  ScheduledDate: "scheduledDate",
  VendorName: "vendor.name",
  Amount: "amount",
  CreatedAt: "createdAt",
  UpdatedAt: "updatedAt",
  DeliveryDate: "deliveryDate",
  EstimatedDelivery: "estimatedDelivery"
};
var PermissionLevel = {
  Full: "full",
  Blocked: "blocked",
  Readonly: "readonly"
};
var PlaidAccountVerificationStatusEnum = {
  PendingDeposit: "pending_deposit",
  DepositPosted: "deposit_posted",
  DepositFailed: "deposit_failed",
  DepositCanceled: "deposit_canceled",
  DepositReversed: "deposit_reversed",
  Verified: "verified",
  Failed: "failed"
};
var PostAccountingPlatformPaymentAccountRequestTypeEnum = {
  Bank: "bank",
  Credit: "credit"
};
var PostApprovalDecisionEnum = {
  Approved: "approved",
  Declined: "declined"
};
var PostBillingFeeSettingsRequestBillingFeeTypeEnum = {
  AchToCheck: "ach_to_check",
  AchToAch: "ach_to_ach"
};
var PostDeliveryMethodsPlaidLinkTokenRequestTypeEnum = {
  Registration: "registration",
  Verification: "verification"
};
var PostFundingSourcesRequestTypeEnum = {
  Plaid: "plaid",
  BankAccount: "bank-account",
  Card: "card"
};
var PostMarkedAsPaidRequestMethodEnum = {
  Ach: "ach",
  Check: "check",
  Card: "card",
  Cash: "cash",
  Other: "other"
};
var PostPayorFundingSourceRequestTypeEnum = {
  Plaid: "plaid",
  Card: "card"
};
var PostPlaidLinkTokenRegistrationRequestTypeEnum = {
  Registration: "registration"
};
var PostPlaidLinkTokenVerificationRequestTypeEnum = {
  Verification: "verification"
};
var PostShareInvoiceRequestSentFromEnum = {
  MelioPro: "melio-pro",
  MelioMe: "melio-me",
  Partner: "partner",
  MelioOnBehalfPartnerApi: "melio-on-behalf-partner-api"
};
var PostShareInvoiceRequestTypeEnum = {
  CreateInvoice: "createInvoice",
  UpdateInvoice: "updateInvoice",
  Reminder: "reminder"
};
var PostVendorEbillsSubscriptionRequestReceivingOptionEnum = {
  Ebill: "ebill",
  Dual: "dual",
  Trial: "trial"
};
var PostVendorsManagedFiservManagedByEnum = {
  Fiserv: "Fiserv"
};
var PostVendorsRequestAnalyticsMetadataFlowEnum = {
  Vendor: "vendor",
  Bill: "bill",
  Payment: "payment"
};
var PromoCodeStatusEnum = {
  Valid: "valid",
  Invalid: "invalid",
  Expired: "expired"
};
var PromoCodeUpToPeriodsUpToPeriodsTypeEnum = {
  BillingPeriods: "billingPeriods",
  Days: "days",
  Weeks: "weeks",
  Months: "months",
  Years: "years"
};
var PushToDebitActionInEligibleReasonEnum = {
  PaymentDeclinedByRisk: "payment-declined-by-risk",
  PaymentNotEligibleByRisk: "payment-not-eligible-by-risk",
  PaymentFailedToDeliver: "payment-failed-to-deliver",
  PaymentNotCollected: "payment-not-collected",
  DeliveryMethodNotSupported: "delivery-method-not-supported",
  PaymentDelivered: "payment-delivered",
  AlreadyDebitDeliveryMethod: "already-debit-delivery-method",
  MaxDateExpired: "max-date-expired",
  PaymentFailed: "payment-failed"
};
var ReceivablePaymentDetailsMethodEnum = {
  Ach: "ach",
  Check: "check",
  Card: "card",
  Cash: "cash",
  Other: "other"
};
var ReceivablePaymentDetailsSourceEnum = {
  Manual: "manual",
  System: "system"
};
var ReceivablePaymentDetailsPaymentStatusEnum = {
  Scheduled: "scheduled",
  InProgress: "in-progress",
  Completed: "completed",
  Failed: "failed",
  Blocked: "blocked"
};
var ReceivablePaymentDetailsBaseMethodEnum = {
  Ach: "ach",
  Check: "check",
  Card: "card",
  Cash: "cash",
  Other: "other"
};
var ReceivablePaymentDetailsBaseSourceEnum = {
  Manual: "manual",
  System: "system"
};
var ReceivablePaymentDetailsBasePaymentStatusEnum = {
  Scheduled: "scheduled",
  InProgress: "in-progress",
  Completed: "completed",
  Failed: "failed",
  Blocked: "blocked"
};
var ReceivingMethodType = {
  Ach: "ach",
  Card: "card"
};
var RecommendedVendorTypeEnum = {
  VendorWithUnilateral: "vendorWithUnilateral",
  Business: "business"
};
var RefundStatusEnum = {
  InProgress: "in-progress",
  Completed: "completed",
  Failed: "failed"
};
var RepaymentTermsIneligibilityReason = {
  OrganizationIneligible: "organization-ineligible",
  PreEligibility: "pre-eligibility",
  Unknown: "unknown",
  VendorIneligible: "vendor-ineligible",
  InsufficientBalance: "insufficient-balance",
  PaymentIneligible: "payment-ineligible",
  UnresolvedInstallments: "unresolved-installments"
};
var ResponseStatusError = {
  Error: "error"
};
var ResponseStatusSuccess = {
  Success: "success"
};
var RoleType = {
  VicePresident: "VicePresident",
  President: "President",
  Treasurer: "Treasurer",
  Owner: "Owner",
  Partner: "Partner",
  Ceo: "CEO",
  Secretary: "Secretary",
  Director: "Director",
  SoleProprietor: "SoleProprietor",
  Coo: "COO",
  Cfo: "CFO",
  MemberLlc: "MemberLLC",
  Other: "Other"
};
var RoleUniqueNames = {
  MelioOwner: "melio-owner",
  MelioAdmin: "melio-admin",
  MelioAccountant: "melio-accountant",
  MelioContributor: "melio-contributor",
  CapitalOnePrimary: "capital-one-primary",
  CapitalOneAm: "capital-one-am",
  CloverOwner: "clover-owner",
  CloverAdmin: "clover-admin",
  FiservLevel1: "fiserv-level-1",
  FiservLevel2: "fiserv-level-2",
  FiservLevel3: "fiserv-level-3",
  ShopifyOwner: "shopify-owner",
  ShopifyNonOwner: "shopify-non-owner",
  DeploymentsDemoOwner: "deployments-demo-owner"
};
var ScannedInvoiceLineItemTypeEnum = {
  Item: "item",
  Category: "category"
};
var ScannedInvoiceLineItemAllOfTypeEnum = {
  Item: "item",
  Category: "category"
};
var ServiceChargeTypeEnum = {
  Amount: "amount",
  Percentage: "percentage"
};
var SignatureCreateParamsAgreeEnum = {
  Yes: "yes"
};
var SortQueryParamOrderEnum = {
  Asc: "asc",
  Desc: "desc"
};
var SubscriptionBillingCycleEnum = {
  Monthly: "monthly",
  Annual: "annual"
};
var SubscriptionBillingHistoryItemStatusEnum = {
  Paid: "paid",
  Failed: "failed",
  Pending: "pending",
  Refunded: "refunded"
};
var SubscriptionBillingItemChargeTypeEnum = {
  MeasurementUnit: "measurementUnit",
  BasePrice: "basePrice",
  FreeTrial: "freeTrial"
};
var SubscriptionBillingItemMeasurementUnit = {
  Seat: "Seat"
};
var SubscriptionErrorCode = {
  ZipCodeDoesntMatchState: "ZipCodeDoesntMatchState"
};
var TaxIdTypeEnum = {
  Ssn: "SSN",
  Itin: "ITIN",
  Ein: "EIN"
};
var TaxpayerIdentificationRequestStatusEnum = {
  Pending: "pending",
  Completed: "completed",
  Canceled: "canceled"
};
var TaxpayerIdentificationRequestAllOfStatusEnum = {
  Pending: "pending",
  Completed: "completed",
  Canceled: "canceled"
};
var TaxpayerIdentificationRequestErrorCode = {
  MaxAllowedEmailsSentCountByVendor: "maxAllowedEmailsSentCountByVendor",
  MaxAllowedEmailsSentCountPerRequest: "maxAllowedEmailsSentCountPerRequest"
};
var TaxpayerIdentificationRequestStatus = {
  PENDING: "pending",
  COMPLETED: "completed",
  CANCELED: "canceled"
};
var Tier = {
  MelioBasic: "MELIO_BASIC",
  MelioPlus: "MELIO_PLUS",
  MelioPro: "MELIO_PRO",
  MelioVip: "MELIO_VIP",
  MelioAccountingClientCore: "MELIO_ACCOUNTING_CLIENT_CORE",
  MelioAccountingClientBoost: "MELIO_ACCOUNTING_CLIENT_BOOST",
  FiservApBasic: "FISERV_AP_BASIC",
  FiservApPro: "FISERV_AP_PRO",
  FiservApArBasic: "FISERV_AP_AR_BASIC",
  FiservApArPro: "FISERV_AP_AR_PRO"
};
var TodoActivateCollaboratorsTypeEnum = {
  ActivateCollaborators: "activate-collaborators"
};
var TodoFailedPaymentTypeEnum = {
  FailedPayments: "failed-payments"
};
var TodoOverdueIn7DaysInboxItemsTypeEnum = {
  OverdueIn7DaysInboxItems: "overdue-in-7-days-inbox-items"
};
var TodoOverdueInMoreThan7DaysInboxItemsTypeEnum = {
  OverdueInMoreThan7DaysInboxItems: "overdue-in-more-than-7-days-inbox-items"
};
var TodoOverdueInboxItemsTypeEnum = {
  OverdueInboxItems: "overdue-inbox-items"
};
var TodoPaymentsToApproveTypeEnum = {
  PaymentsToApprove: "payments-to-approve"
};
var TokenProvider = {
  Tabapay: "tabapay",
  Basistheory: "basistheory"
};
var TrackerTimelineStatusEnum = {
  SCHEDULED: "scheduled",
  SENT: "sent",
  DEPOSITED: "deposited",
  FAILED: "failed"
};
var UnilateralRequestStatusEnum = {
  Created: "created",
  Sent: "sent",
  Completed: "completed"
};
var UnilateralRequestAllOfStatusEnum = {
  Created: "created",
  Sent: "sent",
  Completed: "completed"
};
var UnsupportedDeliveryMethodTypeReason = {
  FundingSourceNotSupported: "fundingSourceNotSupported",
  CardFundingSourceNotSupported: "cardFundingSourceNotSupported",
  FundingSourceNotVerified: "fundingSourceNotVerified",
  VendorHasDeliveryMethod: "vendorHasDeliveryMethod",
  RecurringPaymentNotSupported: "recurringPaymentNotSupported",
  AccountAddressNotValid: "accountAddressNotValid",
  VendorIsDomestic: "vendorIsDomestic",
  VendorIsInternational: "vendorIsInternational",
  VendorHasNoVirtualCard: "vendorHasNoVirtualCard",
  VendorIsManaged: "vendorIsManaged",
  FinancingPaymentNotSupported: "financingPaymentNotSupported",
  VendorIsBank: "vendorIsBank",
  MissingInvoiceNumberForStpSuvc: "missingInvoiceNumberForStpSuvc",
  VendorDeliveryMethodCapLimitReached: "vendorDeliveryMethodCapLimitReached",
  DeliveryMethodNotSupportedForState: "deliveryMethodNotSupportedForState"
};
var UnsupportedDeliveryPreferenceReason = {
  OutsideManualReviewHours: "outsideManualReviewHours",
  NoFutureDateScheduling: "noFutureDateScheduling",
  RoutingNumberNotCovered: "routingNumberNotCovered",
  PaymentRequiresApproval: "paymentRequiresApproval"
};
var UnsupportedFsReasons = {
  InternationalPaymentRestrictions: "internationalPaymentRestrictions",
  PaymentAmountLimit: "paymentAmountLimit",
  CardsNotAllowedForManagedVendor: "cardsNotAllowedForManagedVendor",
  ProhibitedMcc: "prohibitedMcc",
  ProhibitedCardNetwork: "prohibitedCardNetwork"
};
var UploadErrorCode = {
  InternalServerError: "INTERNAL_SERVER_ERROR",
  InvalidFileSize: "INVALID_FILE_SIZE",
  UnsupportedMimeType: "UNSUPPORTED_MIME_TYPE",
  UploadFailed: "UPLOAD_FAILED"
};
var UploadRequestObjectCompletedUploadStatusEnum = {
  Completed: "COMPLETED"
};
var UploadRequestObjectFailedUploadStatusEnum = {
  Failed: "FAILED"
};
var UploadRequestObjectPendingUploadStatusEnum = {
  Pending: "PENDING"
};
var UserComplianceEntityInformationMissingFieldsNameEnum = {
  FirstName: "firstName",
  LastName: "lastName",
  DateOfBirth: "dateOfBirth",
  Email: "email"
};
var UserRegistrationFlowEnum = {
  Regular: "regular",
  Vendor: "vendor",
  Guest: "guest",
  Quickbooks: "quickbooks",
  Google: "google",
  UserInvited: "user-invited",
  PushToDebit: "push-to-debit",
  SyngencyIntegration: "syngency-integration",
  BuiltPartnership: "built-partnership",
  MerchantCheckout: "merchant-checkout",
  AccountsPayablePlatform: "accounts-payable-platform",
  MsnPortalSalesForm: "msn-portal-sales-form",
  MsnPortalPublicForm: "msn-portal-public-form",
  UnilateralWithEnrollment: "unilateral-with-enrollment",
  SpendManagement: "spend-management",
  PushToFastAch: "push-to-fast-ach",
  PushToRtp: "push-to-rtp",
  ErpVendorOnboarding: "erp-vendor-onboarding"
};
var UserRole = {
  Owner: "owner",
  Admin: "admin",
  Contributor: "contributor",
  Accountant: "accountant"
};
var UserRoleErrorErrorCodeEnum = {
  NoUserRole: "NoUserRole",
  BadUserRole: "BadUserRole",
  UnknownUserRole: "UnknownUserRole",
  ForbiddenUserRole: "ForbiddenUserRole",
  DuplicateUserRole: "DuplicateUserRole",
  PrimaryRoleAlreadyExists: "PrimaryRoleAlreadyExists",
  AmNotAllowedForOrganization: "AmNotAllowedForOrganization"
};
var UserRoleErrorAllOfErrorCodeEnum = {
  NoUserRole: "NoUserRole",
  BadUserRole: "BadUserRole",
  UnknownUserRole: "UnknownUserRole",
  ForbiddenUserRole: "ForbiddenUserRole",
  DuplicateUserRole: "DuplicateUserRole",
  PrimaryRoleAlreadyExists: "PrimaryRoleAlreadyExists",
  AmNotAllowedForOrganization: "AmNotAllowedForOrganization"
};
var UserTypes = {
  REGISTERED: "registered",
  REGISTERED_AND_MATCHED: "registered-and-matched",
  REGISTERED_GUEST: "registered-guest",
  ANONYMOUS: "anonymous"
};
var VEXErrorCodes = {
  VendorOnboardingAlreadyCompleted: "vendor-onboarding.already-completed",
  VendorOnboardingMissingDeliveryMethod: "vendor-onboarding.missing-delivery-method",
  VendorOnboardingMissingBusinessDetails: "vendor-onboarding.missing-business-details"
};
var VendorManagedBy = {
  Msn: "msn",
  Fiserv: "fiserv",
  VirtualCard: "virtual-card",
  Shared: "shared",
  Biller: "biller"
};
var VendorPersistentFastEligibilityTypeEnum = {
  GLOBAL: "global",
  LOCAL: "local",
  NOT_ELIGIBLE: "not-eligible"
};
var VendorPreferredPremiumMethodsEnum = {
  RTP: "rtp",
  FAST_ACH: "fast-ach"
};
var VendorPremiumMethodsStateEnum = {
  OPT_IN: "opt_in",
  OPT_OUT: "opt_out"
};
var VendorWarningCodeEnum = {
  AchDeliveryMethodWasNotCreated: "AchDeliveryMethodWasNotCreated"
};
var VendorsSortQueryParamFieldEnum = {
  Name: "name",
  LastPaymentDate: "lastPaymentDate",
  OpenBalance: "openBalance"
};
var VendorsSortQueryParamOrderEnum = {
  Asc: "asc",
  Desc: "desc"
};
var VendorsSortQueryParamAllOfFieldEnum = {
  Name: "name",
  LastPaymentDate: "lastPaymentDate",
  OpenBalance: "openBalance"
};
var VerifyQuickBooksDesktopConnectionStatus = {
  NotInitialized: "not-initialized",
  NotAvailable: "not-available",
  Available: "available",
  Disabled: "disabled"
};
var VoidAndRefundActionIneligibleReasonEnum = {
  PaymentNotVoidableCheck: "payment-not-voidable-check",
  PaymentNotEligible: "payment-not-eligible",
  GeneralError: "general-error"
};
var VoidAndResendActionIneligibleReasonEnum = {
  PaymentNotVoidableCheck: "payment-not-voidable-check",
  PaymentNotEligible: "payment-not-eligible",
  GeneralError: "general-error"
};
var VoidCheckStatusEnum = {
  InProgress: "in-progress",
  Completed: "completed",
  Failed: "failed"
};
var WorkflowActionsRolesTypeEnum = {
  Role: "role"
};
var WorkflowActionsUsersTypeEnum = {
  User: "user"
};
var WorkflowCollaboratorsConditionTypeEnum = {
  WorkflowCollaboratorsCondition: "workflowCollaboratorsCondition"
};
var WorkflowCollaboratorsRolesFilterByEnum = {
  Role: "role"
};
var WorkflowCollaboratorsSpecificFilterByEnum = {
  User: "user"
};
var WorkflowCriteriaOperatorEnum = {
  And: "AND"
};
var WorkflowNumericConditionTypeEnum = {
  WorkflowNumericCondition: "workflowNumericCondition"
};
var WorkflowNumericConditionConfigurationOperatorEnum = {
  GreaterEqual: "greaterEqual",
  BelowEqual: "belowEqual"
};
var WorkflowPaymentAmountConditionAttributeEnum = {
  PaymentAmount: "payment.amount"
};
var WorkflowPaymentCreatedByConditionAttributeEnum = {
  PaymentCreatedBy: "payment.createdBy"
};
var WorkflowPaymentVendorConditionAttributeEnum = {
  PaymentVendor: "payment.vendor"
};
var WorkflowVendorsConditionTypeEnum = {
  WorkflowVendorsCondition: "workflowVendorsCondition"
};
var AccountantsFirmClientApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * Create accountant firm client
     * @summary Create accountant firm client
     * @param {PostCreateFirmClientRequest} [postCreateFirmClientRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createAccountantFirmClient: (_0, ..._1) => __async(this, [_0, ..._1], function* (postCreateFirmClientRequest, options = {}) {
      const localVarPath = `/accountants/firm-clients`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postCreateFirmClientRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Retrieve all accoutning firm clients handled by the currenct user
     * @summary Retrieve all accoutning firm clients handled by the current user
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAccountantFirmClients: (_0, ..._1) => __async(this, [_0, ..._1], function* (expand, options = {}) {
      const localVarPath = `/accountants/firm-clients`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (expand !== void 0) {
        localVarQueryParameter["expand"] = expand;
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Update an existing client of an accounting firm.
     * @summary Update a firm client
     * @param {string} id ID of the entity
     * @param {PatchFirmClientRequest} [patchFirmClientRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchAccountantFirmClient: (_0, _1, _2, ..._3) => __async(this, [_0, _1, _2, ..._3], function* (id, patchFirmClientRequest, idempotencyKey, options = {}) {
      assertParamExists("patchAccountantFirmClient", "id", id);
      const localVarPath = `/accountants/firm-clients/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "PATCH" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (idempotencyKey !== void 0 && idempotencyKey !== null) {
        localVarHeaderParameter["Idempotency-Key"] = String(idempotencyKey);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(patchFirmClientRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Request access to existing account
     * @summary Request access to existing account
     * @param {PostFirmClientRequestAccessRequest} [postFirmClientRequestAccessRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    requestAccountAccess: (_0, ..._1) => __async(this, [_0, ..._1], function* (postFirmClientRequestAccessRequest, options = {}) {
      const localVarPath = `/accountants/firm-clients/request-access`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postFirmClientRequestAccessRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    })
  };
};
var AccountantsFirmClientApiFp = function(configuration) {
  const localVarAxiosParamCreator = AccountantsFirmClientApiAxiosParamCreator(configuration);
  return {
    /**
     * Create accountant firm client
     * @summary Create accountant firm client
     * @param {PostCreateFirmClientRequest} [postCreateFirmClientRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createAccountantFirmClient(postCreateFirmClientRequest, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.createAccountantFirmClient(postCreateFirmClientRequest, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Retrieve all accoutning firm clients handled by the currenct user
     * @summary Retrieve all accoutning firm clients handled by the current user
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAccountantFirmClients(expand, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getAccountantFirmClients(expand, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Update an existing client of an accounting firm.
     * @summary Update a firm client
     * @param {string} id ID of the entity
     * @param {PatchFirmClientRequest} [patchFirmClientRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchAccountantFirmClient(id, patchFirmClientRequest, idempotencyKey, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.patchAccountantFirmClient(id, patchFirmClientRequest, idempotencyKey, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Request access to existing account
     * @summary Request access to existing account
     * @param {PostFirmClientRequestAccessRequest} [postFirmClientRequestAccessRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    requestAccountAccess(postFirmClientRequestAccessRequest, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.requestAccountAccess(postFirmClientRequestAccessRequest, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    }
  };
};
var AccountantsFirmClientApiClient = createApiFromFp(AccountantsFirmClientApiFp);
var AccountantsFirmClientApiFactory = function(configuration, basePath, axios2) {
  const localVarFp = AccountantsFirmClientApiFp(configuration);
  return {
    /**
     * Create accountant firm client
     * @summary Create accountant firm client
     * @param {PostCreateFirmClientRequest} [postCreateFirmClientRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createAccountantFirmClient(postCreateFirmClientRequest, options) {
      return localVarFp.createAccountantFirmClient(postCreateFirmClientRequest, options).then((request) => request(axios2, basePath));
    },
    /**
     * Retrieve all accoutning firm clients handled by the currenct user
     * @summary Retrieve all accoutning firm clients handled by the current user
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAccountantFirmClients(expand, options) {
      return localVarFp.getAccountantFirmClients(expand, options).then((request) => request(axios2, basePath));
    },
    /**
     * Update an existing client of an accounting firm.
     * @summary Update a firm client
     * @param {string} id ID of the entity
     * @param {PatchFirmClientRequest} [patchFirmClientRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchAccountantFirmClient(id, patchFirmClientRequest, idempotencyKey, options) {
      return localVarFp.patchAccountantFirmClient(id, patchFirmClientRequest, idempotencyKey, options).then((request) => request(axios2, basePath));
    },
    /**
     * Request access to existing account
     * @summary Request access to existing account
     * @param {PostFirmClientRequestAccessRequest} [postFirmClientRequestAccessRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    requestAccountAccess(postFirmClientRequestAccessRequest, options) {
      return localVarFp.requestAccountAccess(postFirmClientRequestAccessRequest, options).then((request) => request(axios2, basePath));
    }
  };
};
var AccountantsFirmClientApi = class extends BaseAPI {
  /**
   * Create accountant firm client
   * @summary Create accountant firm client
   * @param {AccountantsFirmClientApiCreateAccountantFirmClientRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountantsFirmClientApi
   */
  createAccountantFirmClient(requestParameters = {}, options) {
    return AccountantsFirmClientApiFp(this.configuration).createAccountantFirmClient(requestParameters.postCreateFirmClientRequest, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Retrieve all accoutning firm clients handled by the currenct user
   * @summary Retrieve all accoutning firm clients handled by the current user
   * @param {AccountantsFirmClientApiGetAccountantFirmClientsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountantsFirmClientApi
   */
  getAccountantFirmClients(requestParameters = {}, options) {
    return AccountantsFirmClientApiFp(this.configuration).getAccountantFirmClients(requestParameters.expand, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Update an existing client of an accounting firm.
   * @summary Update a firm client
   * @param {AccountantsFirmClientApiPatchAccountantFirmClientRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountantsFirmClientApi
   */
  patchAccountantFirmClient(requestParameters, options) {
    return AccountantsFirmClientApiFp(this.configuration).patchAccountantFirmClient(requestParameters.id, requestParameters.patchFirmClientRequest, requestParameters.idempotencyKey, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Request access to existing account
   * @summary Request access to existing account
   * @param {AccountantsFirmClientApiRequestAccountAccessRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountantsFirmClientApi
   */
  requestAccountAccess(requestParameters = {}, options) {
    return AccountantsFirmClientApiFp(this.configuration).requestAccountAccess(requestParameters.postFirmClientRequestAccessRequest, options).then((request) => request(this.axios, this.basePath));
  }
};
var AccountantsFirmClientApiInstance = createInstanceFromApiIClass(AccountantsFirmClientApi);
var AccountantsUserServicesApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * Check email
     * @summary Check email
     * @param {PostCheckEmailRequest} [postCheckEmailRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    checkEmail: (_0, ..._1) => __async(this, [_0, ..._1], function* (postCheckEmailRequest, options = {}) {
      const localVarPath = `/accountants/user-services/check-email`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postCheckEmailRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    })
  };
};
var AccountantsUserServicesApiFp = function(configuration) {
  const localVarAxiosParamCreator = AccountantsUserServicesApiAxiosParamCreator(configuration);
  return {
    /**
     * Check email
     * @summary Check email
     * @param {PostCheckEmailRequest} [postCheckEmailRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    checkEmail(postCheckEmailRequest, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.checkEmail(postCheckEmailRequest, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    }
  };
};
var AccountantsUserServicesApiClient = createApiFromFp(AccountantsUserServicesApiFp);
var AccountantsUserServicesApiFactory = function(configuration, basePath, axios2) {
  const localVarFp = AccountantsUserServicesApiFp(configuration);
  return {
    /**
     * Check email
     * @summary Check email
     * @param {PostCheckEmailRequest} [postCheckEmailRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    checkEmail(postCheckEmailRequest, options) {
      return localVarFp.checkEmail(postCheckEmailRequest, options).then((request) => request(axios2, basePath));
    }
  };
};
var AccountantsUserServicesApi = class extends BaseAPI {
  /**
   * Check email
   * @summary Check email
   * @param {AccountantsUserServicesApiCheckEmailRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountantsUserServicesApi
   */
  checkEmail(requestParameters = {}, options) {
    return AccountantsUserServicesApiFp(this.configuration).checkEmail(requestParameters.postCheckEmailRequest, options).then((request) => request(this.axios, this.basePath));
  }
};
var AccountantsUserServicesApiInstance = createInstanceFromApiIClass(AccountantsUserServicesApi);
var AccountingFirmOrganizationBillingFeeApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * Delete billing fee item
     * @summary Delete billing fee item
     * @param {string} id ID of the entity
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteAccountingFirmBillingFees: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (id, idempotencyKey, options = {}) {
      assertParamExists("deleteAccountingFirmBillingFees", "id", id);
      const localVarPath = `/accountants/billing-fees/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "DELETE" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (idempotencyKey !== void 0 && idempotencyKey !== null) {
        localVarHeaderParameter["Idempotency-Key"] = String(idempotencyKey);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Retrieve all organization billing fee items related to an accounting firm
     * @summary Retrieve all organization billing fee items related to an accounting firm
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAccountingFirmBillingFees: (..._0) => __async(this, [..._0], function* (options = {}) {
      const localVarPath = `/accountants/billing-fees`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Create organization billing fee item related to an accounting firm
     * @summary Create organization billing fee item related to an accounting firm
     * @param {PostAccountingFirmBillingFeesRequest} [postAccountingFirmBillingFeesRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postAccountingFirmBillingFees: (_0, ..._1) => __async(this, [_0, ..._1], function* (postAccountingFirmBillingFeesRequest, options = {}) {
      const localVarPath = `/accountants/billing-fees`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postAccountingFirmBillingFeesRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Update organization billing fee item related to an accounting firm
     * @summary Update organization billing fee item related to an accounting firm
     * @param {string} id ID of the entity
     * @param {PutAccountingFirmBillingFeesRequest} [putAccountingFirmBillingFeesRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    putAccountingFirmBillingFees: (_0, _1, _2, ..._3) => __async(this, [_0, _1, _2, ..._3], function* (id, putAccountingFirmBillingFeesRequest, idempotencyKey, options = {}) {
      assertParamExists("putAccountingFirmBillingFees", "id", id);
      const localVarPath = `/accountants/billing-fees/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "PUT" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (idempotencyKey !== void 0 && idempotencyKey !== null) {
        localVarHeaderParameter["Idempotency-Key"] = String(idempotencyKey);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(putAccountingFirmBillingFeesRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    })
  };
};
var AccountingFirmOrganizationBillingFeeApiFp = function(configuration) {
  const localVarAxiosParamCreator = AccountingFirmOrganizationBillingFeeApiAxiosParamCreator(configuration);
  return {
    /**
     * Delete billing fee item
     * @summary Delete billing fee item
     * @param {string} id ID of the entity
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteAccountingFirmBillingFees(id, idempotencyKey, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteAccountingFirmBillingFees(id, idempotencyKey, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Retrieve all organization billing fee items related to an accounting firm
     * @summary Retrieve all organization billing fee items related to an accounting firm
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAccountingFirmBillingFees(options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getAccountingFirmBillingFees(options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Create organization billing fee item related to an accounting firm
     * @summary Create organization billing fee item related to an accounting firm
     * @param {PostAccountingFirmBillingFeesRequest} [postAccountingFirmBillingFeesRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postAccountingFirmBillingFees(postAccountingFirmBillingFeesRequest, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postAccountingFirmBillingFees(postAccountingFirmBillingFeesRequest, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Update organization billing fee item related to an accounting firm
     * @summary Update organization billing fee item related to an accounting firm
     * @param {string} id ID of the entity
     * @param {PutAccountingFirmBillingFeesRequest} [putAccountingFirmBillingFeesRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    putAccountingFirmBillingFees(id, putAccountingFirmBillingFeesRequest, idempotencyKey, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.putAccountingFirmBillingFees(id, putAccountingFirmBillingFeesRequest, idempotencyKey, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    }
  };
};
var AccountingFirmOrganizationBillingFeeApiClient = createApiFromFp(AccountingFirmOrganizationBillingFeeApiFp);
var AccountingFirmOrganizationBillingFeeApiFactory = function(configuration, basePath, axios2) {
  const localVarFp = AccountingFirmOrganizationBillingFeeApiFp(configuration);
  return {
    /**
     * Delete billing fee item
     * @summary Delete billing fee item
     * @param {string} id ID of the entity
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteAccountingFirmBillingFees(id, idempotencyKey, options) {
      return localVarFp.deleteAccountingFirmBillingFees(id, idempotencyKey, options).then((request) => request(axios2, basePath));
    },
    /**
     * Retrieve all organization billing fee items related to an accounting firm
     * @summary Retrieve all organization billing fee items related to an accounting firm
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAccountingFirmBillingFees(options) {
      return localVarFp.getAccountingFirmBillingFees(options).then((request) => request(axios2, basePath));
    },
    /**
     * Create organization billing fee item related to an accounting firm
     * @summary Create organization billing fee item related to an accounting firm
     * @param {PostAccountingFirmBillingFeesRequest} [postAccountingFirmBillingFeesRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postAccountingFirmBillingFees(postAccountingFirmBillingFeesRequest, options) {
      return localVarFp.postAccountingFirmBillingFees(postAccountingFirmBillingFeesRequest, options).then((request) => request(axios2, basePath));
    },
    /**
     * Update organization billing fee item related to an accounting firm
     * @summary Update organization billing fee item related to an accounting firm
     * @param {string} id ID of the entity
     * @param {PutAccountingFirmBillingFeesRequest} [putAccountingFirmBillingFeesRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    putAccountingFirmBillingFees(id, putAccountingFirmBillingFeesRequest, idempotencyKey, options) {
      return localVarFp.putAccountingFirmBillingFees(id, putAccountingFirmBillingFeesRequest, idempotencyKey, options).then((request) => request(axios2, basePath));
    }
  };
};
var AccountingFirmOrganizationBillingFeeApi = class extends BaseAPI {
  /**
   * Delete billing fee item
   * @summary Delete billing fee item
   * @param {AccountingFirmOrganizationBillingFeeApiDeleteAccountingFirmBillingFeesRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountingFirmOrganizationBillingFeeApi
   */
  deleteAccountingFirmBillingFees(requestParameters, options) {
    return AccountingFirmOrganizationBillingFeeApiFp(this.configuration).deleteAccountingFirmBillingFees(requestParameters.id, requestParameters.idempotencyKey, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Retrieve all organization billing fee items related to an accounting firm
   * @summary Retrieve all organization billing fee items related to an accounting firm
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountingFirmOrganizationBillingFeeApi
   */
  getAccountingFirmBillingFees(options) {
    return AccountingFirmOrganizationBillingFeeApiFp(this.configuration).getAccountingFirmBillingFees(options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Create organization billing fee item related to an accounting firm
   * @summary Create organization billing fee item related to an accounting firm
   * @param {AccountingFirmOrganizationBillingFeeApiPostAccountingFirmBillingFeesRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountingFirmOrganizationBillingFeeApi
   */
  postAccountingFirmBillingFees(requestParameters = {}, options) {
    return AccountingFirmOrganizationBillingFeeApiFp(this.configuration).postAccountingFirmBillingFees(requestParameters.postAccountingFirmBillingFeesRequest, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Update organization billing fee item related to an accounting firm
   * @summary Update organization billing fee item related to an accounting firm
   * @param {AccountingFirmOrganizationBillingFeeApiPutAccountingFirmBillingFeesRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountingFirmOrganizationBillingFeeApi
   */
  putAccountingFirmBillingFees(requestParameters, options) {
    return AccountingFirmOrganizationBillingFeeApiFp(this.configuration).putAccountingFirmBillingFees(requestParameters.id, requestParameters.putAccountingFirmBillingFeesRequest, requestParameters.idempotencyKey, options).then((request) => request(this.axios, this.basePath));
  }
};
var AccountingFirmOrganizationBillingFeeApiInstance = createInstanceFromApiIClass(AccountingFirmOrganizationBillingFeeApi);
var AccountingPlatformsApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * Parse auth params after OAuth redirec and returns data to continue connect accounting platform flow
     * @summary Parse auth params
     * @param {string} id ID of the entity
     * @param {AccountingPlatformParseAuthParamsRequest} [accountingPlatformParseAuthParamsRequest] 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountingPlatformParseAuthParams: (_0, _1, _2, ..._3) => __async(this, [_0, _1, _2, ..._3], function* (id, accountingPlatformParseAuthParamsRequest, melioAccount, options = {}) {
      assertParamExists("accountingPlatformParseAuthParams", "id", id);
      const localVarPath = `/accounting-platforms/{id}/parse-auth-params`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(accountingPlatformParseAuthParamsRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Create link to authorize user in accounting platform
     * @summary Create link to authorize user in accounting platform
     * @param {string} id ID of the entity
     * @param {PostAccountingPlatformAuthLinkRequest} [postAccountingPlatformAuthLinkRequest] 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createAccountingPlatformAuthLink: (_0, _1, _2, ..._3) => __async(this, [_0, _1, _2, ..._3], function* (id, postAccountingPlatformAuthLinkRequest, melioAccount, options = {}) {
      assertParamExists("createAccountingPlatformAuthLink", "id", id);
      const localVarPath = `/accounting-platforms/{id}/auth-link`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postAccountingPlatformAuthLinkRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Create accounting platform bank account
     * @summary Create accounting platform bank account
     * @param {CreateAccountingPlatformBankAccountRequest} [createAccountingPlatformBankAccountRequest] 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createAccountingPlatformBankAccount: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (createAccountingPlatformBankAccountRequest, melioAccount, options = {}) {
      const localVarPath = `/accounting-platforms/bank-accounts`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(createAccountingPlatformBankAccountRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * This operation create payment account in the accounting platform
     * @summary Create accounting platform\'s payment account
     * @param {string} id ID of the entity
     * @param {PostAccountingPlatformPaymentAccountRequest} [postAccountingPlatformPaymentAccountRequest] 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createAccountingPlatformsPaymentAccount: (_0, _1, _2, ..._3) => __async(this, [_0, _1, _2, ..._3], function* (id, postAccountingPlatformPaymentAccountRequest, melioAccount, options = {}) {
      assertParamExists("createAccountingPlatformsPaymentAccount", "id", id);
      const localVarPath = `/accounting-platforms/{id}/payment-accounts`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postAccountingPlatformPaymentAccountRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Delete request to disconnect from accounting platform (this will also revoke the token from the organization).
     * @summary Delete request to disconnect from accounting platform
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    disconnectAccountingPlatform: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (id, melioAccount, options = {}) {
      assertParamExists("disconnectAccountingPlatform", "id", id);
      const localVarPath = `/accounting-platforms/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "DELETE" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * This operation disconnects accounting platform
     * @summary Disconnect accounting platform
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    disconnectAccountingPlatformById: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (id, melioAccount, options = {}) {
      assertParamExists("disconnectAccountingPlatformById", "id", id);
      const localVarPath = `/accounting-platforms/{id}/disconnect`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * List of all accounting platform bank accounts
     * @summary List of all accounting platform bank accounts
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAccountingPlatformBankAccounts: (_0, ..._1) => __async(this, [_0, ..._1], function* (melioAccount, options = {}) {
      const localVarPath = `/accounting-platforms/bank-accounts`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * get the status of the current or last sync (in case there isn\'t sync that currently run)
     * @summary Get accounting platform sync status
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAccountingPlatformSyncStatus: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (id, melioAccount, options = {}) {
      assertParamExists("getAccountingPlatformSyncStatus", "id", id);
      const localVarPath = `/accounting-platforms/{id}/status`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * List of all accounting platforms that was Melio support, each accounting platform has id to work with the rest of the calls.
     * @summary List of all accounting platforms
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAccountingPlatforms: (_0, ..._1) => __async(this, [_0, ..._1], function* (melioAccount, options = {}) {
      const localVarPath = `/accounting-platforms`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * get bill labels data by accounting platforms id
     * @summary accounting platform
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAccountingPlatformsBillLabelsById: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (id, melioAccount, options = {}) {
      assertParamExists("getAccountingPlatformsBillLabelsById", "id", id);
      const localVarPath = `/accounting-platforms/{id}/bill-labels`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * get bill line item labels data by accounting platforms id
     * @summary accounting platform
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAccountingPlatformsBillLineItemLabelsById: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (id, melioAccount, options = {}) {
      assertParamExists("getAccountingPlatformsBillLineItemLabelsById", "id", id);
      const localVarPath = `/accounting-platforms/{id}/bill-line-item-labels`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * get data for accounting platforms bu id.
     * @summary accounting platform
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAccountingPlatformsById: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (id, melioAccount, options = {}) {
      assertParamExists("getAccountingPlatformsById", "id", id);
      const localVarPath = `/accounting-platforms/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * get categories data for accounting platforms by id
     * @summary accounting platform
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAccountingPlatformsCategoriesById: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (id, melioAccount, options = {}) {
      assertParamExists("getAccountingPlatformsCategoriesById", "id", id);
      const localVarPath = `/accounting-platforms/{id}/categories`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * get items data for accounting platforms by id
     * @summary accounting platform
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAccountingPlatformsItemsById: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (id, melioAccount, options = {}) {
      assertParamExists("getAccountingPlatformsItemsById", "id", id);
      const localVarPath = `/accounting-platforms/{id}/items`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * get payment account data for accounting platforms by id
     * @summary accounting platform
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAccountingPlatformsPaymentAccountsById: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (id, melioAccount, options = {}) {
      assertParamExists("getAccountingPlatformsPaymentAccountsById", "id", id);
      const localVarPath = `/accounting-platforms/{id}/payment-accounts`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * This operation initializes the QuickBooks Desktop accounting platform.
     * @summary Init QuickBooks Desktop accounting platform
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    initQuickbooksDesktop: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (id, melioAccount, options = {}) {
      assertParamExists("initQuickbooksDesktop", "id", id);
      const localVarPath = `/accounting-platforms/{id}/init-quickbooks-desktop`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Connect accounting platform organization with Melio organization
     * @summary Register accounting platform organization
     * @param {string} id ID of the entity
     * @param {RegisterAccountingPlatformOrganizationRequest} [registerAccountingPlatformOrganizationRequest] 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    registerAccountingPlatformOrganization: (_0, _1, _2, ..._3) => __async(this, [_0, _1, _2, ..._3], function* (id, registerAccountingPlatformOrganizationRequest, melioAccount, options = {}) {
      assertParamExists("registerAccountingPlatformOrganization", "id", id);
      const localVarPath = `/accounting-platforms/{id}/register-organization`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(registerAccountingPlatformOrganizationRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * This operation trigger sync between Melio and the selected accounting platform (it\'s will work only if there is connection with the accounting platform)
     * @summary Post request to trigger sync
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    syncAccountingPlatform: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (id, melioAccount, options = {}) {
      assertParamExists("syncAccountingPlatform", "id", id);
      const localVarPath = `/accounting-platforms/{id}/sync`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * This operation trigger sync entity between Melio and the selected accounting platform (it\'s will work only if there is connection with the accounting platform)
     * @summary Post request to trigger sync entity
     * @param {string} id ID of the entity
     * @param {AccountingPlatformPostSyncEntityRequest} [accountingPlatformPostSyncEntityRequest] 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    syncAccountingPlatformEntity: (_0, _1, _2, ..._3) => __async(this, [_0, _1, _2, ..._3], function* (id, accountingPlatformPostSyncEntityRequest, melioAccount, options = {}) {
      assertParamExists("syncAccountingPlatformEntity", "id", id);
      const localVarPath = `/accounting-platforms/{id}/sync-entity`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(accountingPlatformPostSyncEntityRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * 
     * @summary Returns the sync mechanism version if connected to an accounting platform
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    syncVersion: (_0, ..._1) => __async(this, [_0, ..._1], function* (melioAccount, options = {}) {
      const localVarPath = `/accounting-platforms/version`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Retrieve the setup information for QuickBooks Desktop for the current organization
     * @summary Retrieve QuickBooks Desktop Setup Information
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    verifyQuickbooksDesktopConnection: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (id, melioAccount, options = {}) {
      assertParamExists("verifyQuickbooksDesktopConnection", "id", id);
      const localVarPath = `/accounting-platforms/{id}/verify-quickbooks-desktop-connection`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    })
  };
};
var AccountingPlatformsApiFp = function(configuration) {
  const localVarAxiosParamCreator = AccountingPlatformsApiAxiosParamCreator(configuration);
  return {
    /**
     * Parse auth params after OAuth redirec and returns data to continue connect accounting platform flow
     * @summary Parse auth params
     * @param {string} id ID of the entity
     * @param {AccountingPlatformParseAuthParamsRequest} [accountingPlatformParseAuthParamsRequest] 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountingPlatformParseAuthParams(id, accountingPlatformParseAuthParamsRequest, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.accountingPlatformParseAuthParams(id, accountingPlatformParseAuthParamsRequest, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Create link to authorize user in accounting platform
     * @summary Create link to authorize user in accounting platform
     * @param {string} id ID of the entity
     * @param {PostAccountingPlatformAuthLinkRequest} [postAccountingPlatformAuthLinkRequest] 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createAccountingPlatformAuthLink(id, postAccountingPlatformAuthLinkRequest, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.createAccountingPlatformAuthLink(id, postAccountingPlatformAuthLinkRequest, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Create accounting platform bank account
     * @summary Create accounting platform bank account
     * @param {CreateAccountingPlatformBankAccountRequest} [createAccountingPlatformBankAccountRequest] 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createAccountingPlatformBankAccount(createAccountingPlatformBankAccountRequest, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.createAccountingPlatformBankAccount(createAccountingPlatformBankAccountRequest, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * This operation create payment account in the accounting platform
     * @summary Create accounting platform\'s payment account
     * @param {string} id ID of the entity
     * @param {PostAccountingPlatformPaymentAccountRequest} [postAccountingPlatformPaymentAccountRequest] 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createAccountingPlatformsPaymentAccount(id, postAccountingPlatformPaymentAccountRequest, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.createAccountingPlatformsPaymentAccount(id, postAccountingPlatformPaymentAccountRequest, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Delete request to disconnect from accounting platform (this will also revoke the token from the organization).
     * @summary Delete request to disconnect from accounting platform
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    disconnectAccountingPlatform(id, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.disconnectAccountingPlatform(id, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * This operation disconnects accounting platform
     * @summary Disconnect accounting platform
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    disconnectAccountingPlatformById(id, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.disconnectAccountingPlatformById(id, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * List of all accounting platform bank accounts
     * @summary List of all accounting platform bank accounts
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAccountingPlatformBankAccounts(melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getAccountingPlatformBankAccounts(melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * get the status of the current or last sync (in case there isn\'t sync that currently run)
     * @summary Get accounting platform sync status
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAccountingPlatformSyncStatus(id, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getAccountingPlatformSyncStatus(id, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * List of all accounting platforms that was Melio support, each accounting platform has id to work with the rest of the calls.
     * @summary List of all accounting platforms
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAccountingPlatforms(melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getAccountingPlatforms(melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * get bill labels data by accounting platforms id
     * @summary accounting platform
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAccountingPlatformsBillLabelsById(id, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getAccountingPlatformsBillLabelsById(id, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * get bill line item labels data by accounting platforms id
     * @summary accounting platform
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAccountingPlatformsBillLineItemLabelsById(id, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getAccountingPlatformsBillLineItemLabelsById(id, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * get data for accounting platforms bu id.
     * @summary accounting platform
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAccountingPlatformsById(id, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getAccountingPlatformsById(id, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * get categories data for accounting platforms by id
     * @summary accounting platform
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAccountingPlatformsCategoriesById(id, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getAccountingPlatformsCategoriesById(id, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * get items data for accounting platforms by id
     * @summary accounting platform
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAccountingPlatformsItemsById(id, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getAccountingPlatformsItemsById(id, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * get payment account data for accounting platforms by id
     * @summary accounting platform
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAccountingPlatformsPaymentAccountsById(id, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getAccountingPlatformsPaymentAccountsById(id, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * This operation initializes the QuickBooks Desktop accounting platform.
     * @summary Init QuickBooks Desktop accounting platform
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    initQuickbooksDesktop(id, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.initQuickbooksDesktop(id, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Connect accounting platform organization with Melio organization
     * @summary Register accounting platform organization
     * @param {string} id ID of the entity
     * @param {RegisterAccountingPlatformOrganizationRequest} [registerAccountingPlatformOrganizationRequest] 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    registerAccountingPlatformOrganization(id, registerAccountingPlatformOrganizationRequest, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.registerAccountingPlatformOrganization(id, registerAccountingPlatformOrganizationRequest, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * This operation trigger sync between Melio and the selected accounting platform (it\'s will work only if there is connection with the accounting platform)
     * @summary Post request to trigger sync
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    syncAccountingPlatform(id, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.syncAccountingPlatform(id, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * This operation trigger sync entity between Melio and the selected accounting platform (it\'s will work only if there is connection with the accounting platform)
     * @summary Post request to trigger sync entity
     * @param {string} id ID of the entity
     * @param {AccountingPlatformPostSyncEntityRequest} [accountingPlatformPostSyncEntityRequest] 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    syncAccountingPlatformEntity(id, accountingPlatformPostSyncEntityRequest, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.syncAccountingPlatformEntity(id, accountingPlatformPostSyncEntityRequest, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * 
     * @summary Returns the sync mechanism version if connected to an accounting platform
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    syncVersion(melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.syncVersion(melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Retrieve the setup information for QuickBooks Desktop for the current organization
     * @summary Retrieve QuickBooks Desktop Setup Information
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    verifyQuickbooksDesktopConnection(id, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.verifyQuickbooksDesktopConnection(id, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    }
  };
};
var AccountingPlatformsApiClient = createApiFromFp(AccountingPlatformsApiFp);
var AccountingPlatformsApiFactory = function(configuration, basePath, axios2) {
  const localVarFp = AccountingPlatformsApiFp(configuration);
  return {
    /**
     * Parse auth params after OAuth redirec and returns data to continue connect accounting platform flow
     * @summary Parse auth params
     * @param {string} id ID of the entity
     * @param {AccountingPlatformParseAuthParamsRequest} [accountingPlatformParseAuthParamsRequest] 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountingPlatformParseAuthParams(id, accountingPlatformParseAuthParamsRequest, melioAccount, options) {
      return localVarFp.accountingPlatformParseAuthParams(id, accountingPlatformParseAuthParamsRequest, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Create link to authorize user in accounting platform
     * @summary Create link to authorize user in accounting platform
     * @param {string} id ID of the entity
     * @param {PostAccountingPlatformAuthLinkRequest} [postAccountingPlatformAuthLinkRequest] 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createAccountingPlatformAuthLink(id, postAccountingPlatformAuthLinkRequest, melioAccount, options) {
      return localVarFp.createAccountingPlatformAuthLink(id, postAccountingPlatformAuthLinkRequest, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Create accounting platform bank account
     * @summary Create accounting platform bank account
     * @param {CreateAccountingPlatformBankAccountRequest} [createAccountingPlatformBankAccountRequest] 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createAccountingPlatformBankAccount(createAccountingPlatformBankAccountRequest, melioAccount, options) {
      return localVarFp.createAccountingPlatformBankAccount(createAccountingPlatformBankAccountRequest, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * This operation create payment account in the accounting platform
     * @summary Create accounting platform\'s payment account
     * @param {string} id ID of the entity
     * @param {PostAccountingPlatformPaymentAccountRequest} [postAccountingPlatformPaymentAccountRequest] 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createAccountingPlatformsPaymentAccount(id, postAccountingPlatformPaymentAccountRequest, melioAccount, options) {
      return localVarFp.createAccountingPlatformsPaymentAccount(id, postAccountingPlatformPaymentAccountRequest, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Delete request to disconnect from accounting platform (this will also revoke the token from the organization).
     * @summary Delete request to disconnect from accounting platform
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    disconnectAccountingPlatform(id, melioAccount, options) {
      return localVarFp.disconnectAccountingPlatform(id, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * This operation disconnects accounting platform
     * @summary Disconnect accounting platform
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    disconnectAccountingPlatformById(id, melioAccount, options) {
      return localVarFp.disconnectAccountingPlatformById(id, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * List of all accounting platform bank accounts
     * @summary List of all accounting platform bank accounts
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAccountingPlatformBankAccounts(melioAccount, options) {
      return localVarFp.getAccountingPlatformBankAccounts(melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * get the status of the current or last sync (in case there isn\'t sync that currently run)
     * @summary Get accounting platform sync status
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAccountingPlatformSyncStatus(id, melioAccount, options) {
      return localVarFp.getAccountingPlatformSyncStatus(id, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * List of all accounting platforms that was Melio support, each accounting platform has id to work with the rest of the calls.
     * @summary List of all accounting platforms
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAccountingPlatforms(melioAccount, options) {
      return localVarFp.getAccountingPlatforms(melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * get bill labels data by accounting platforms id
     * @summary accounting platform
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAccountingPlatformsBillLabelsById(id, melioAccount, options) {
      return localVarFp.getAccountingPlatformsBillLabelsById(id, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * get bill line item labels data by accounting platforms id
     * @summary accounting platform
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAccountingPlatformsBillLineItemLabelsById(id, melioAccount, options) {
      return localVarFp.getAccountingPlatformsBillLineItemLabelsById(id, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * get data for accounting platforms bu id.
     * @summary accounting platform
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAccountingPlatformsById(id, melioAccount, options) {
      return localVarFp.getAccountingPlatformsById(id, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * get categories data for accounting platforms by id
     * @summary accounting platform
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAccountingPlatformsCategoriesById(id, melioAccount, options) {
      return localVarFp.getAccountingPlatformsCategoriesById(id, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * get items data for accounting platforms by id
     * @summary accounting platform
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAccountingPlatformsItemsById(id, melioAccount, options) {
      return localVarFp.getAccountingPlatformsItemsById(id, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * get payment account data for accounting platforms by id
     * @summary accounting platform
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAccountingPlatformsPaymentAccountsById(id, melioAccount, options) {
      return localVarFp.getAccountingPlatformsPaymentAccountsById(id, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * This operation initializes the QuickBooks Desktop accounting platform.
     * @summary Init QuickBooks Desktop accounting platform
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    initQuickbooksDesktop(id, melioAccount, options) {
      return localVarFp.initQuickbooksDesktop(id, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Connect accounting platform organization with Melio organization
     * @summary Register accounting platform organization
     * @param {string} id ID of the entity
     * @param {RegisterAccountingPlatformOrganizationRequest} [registerAccountingPlatformOrganizationRequest] 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    registerAccountingPlatformOrganization(id, registerAccountingPlatformOrganizationRequest, melioAccount, options) {
      return localVarFp.registerAccountingPlatformOrganization(id, registerAccountingPlatformOrganizationRequest, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * This operation trigger sync between Melio and the selected accounting platform (it\'s will work only if there is connection with the accounting platform)
     * @summary Post request to trigger sync
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    syncAccountingPlatform(id, melioAccount, options) {
      return localVarFp.syncAccountingPlatform(id, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * This operation trigger sync entity between Melio and the selected accounting platform (it\'s will work only if there is connection with the accounting platform)
     * @summary Post request to trigger sync entity
     * @param {string} id ID of the entity
     * @param {AccountingPlatformPostSyncEntityRequest} [accountingPlatformPostSyncEntityRequest] 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    syncAccountingPlatformEntity(id, accountingPlatformPostSyncEntityRequest, melioAccount, options) {
      return localVarFp.syncAccountingPlatformEntity(id, accountingPlatformPostSyncEntityRequest, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * 
     * @summary Returns the sync mechanism version if connected to an accounting platform
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    syncVersion(melioAccount, options) {
      return localVarFp.syncVersion(melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Retrieve the setup information for QuickBooks Desktop for the current organization
     * @summary Retrieve QuickBooks Desktop Setup Information
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    verifyQuickbooksDesktopConnection(id, melioAccount, options) {
      return localVarFp.verifyQuickbooksDesktopConnection(id, melioAccount, options).then((request) => request(axios2, basePath));
    }
  };
};
var AccountingPlatformsApi = class extends BaseAPI {
  /**
   * Parse auth params after OAuth redirec and returns data to continue connect accounting platform flow
   * @summary Parse auth params
   * @param {AccountingPlatformsApiAccountingPlatformParseAuthParamsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountingPlatformsApi
   */
  accountingPlatformParseAuthParams(requestParameters, options) {
    return AccountingPlatformsApiFp(this.configuration).accountingPlatformParseAuthParams(requestParameters.id, requestParameters.accountingPlatformParseAuthParamsRequest, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Create link to authorize user in accounting platform
   * @summary Create link to authorize user in accounting platform
   * @param {AccountingPlatformsApiCreateAccountingPlatformAuthLinkRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountingPlatformsApi
   */
  createAccountingPlatformAuthLink(requestParameters, options) {
    return AccountingPlatformsApiFp(this.configuration).createAccountingPlatformAuthLink(requestParameters.id, requestParameters.postAccountingPlatformAuthLinkRequest, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Create accounting platform bank account
   * @summary Create accounting platform bank account
   * @param {AccountingPlatformsApiCreateAccountingPlatformBankAccountRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountingPlatformsApi
   */
  createAccountingPlatformBankAccount(requestParameters = {}, options) {
    return AccountingPlatformsApiFp(this.configuration).createAccountingPlatformBankAccount(requestParameters.createAccountingPlatformBankAccountRequest, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * This operation create payment account in the accounting platform
   * @summary Create accounting platform\'s payment account
   * @param {AccountingPlatformsApiCreateAccountingPlatformsPaymentAccountRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountingPlatformsApi
   */
  createAccountingPlatformsPaymentAccount(requestParameters, options) {
    return AccountingPlatformsApiFp(this.configuration).createAccountingPlatformsPaymentAccount(requestParameters.id, requestParameters.postAccountingPlatformPaymentAccountRequest, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Delete request to disconnect from accounting platform (this will also revoke the token from the organization).
   * @summary Delete request to disconnect from accounting platform
   * @param {AccountingPlatformsApiDisconnectAccountingPlatformRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountingPlatformsApi
   */
  disconnectAccountingPlatform(requestParameters, options) {
    return AccountingPlatformsApiFp(this.configuration).disconnectAccountingPlatform(requestParameters.id, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * This operation disconnects accounting platform
   * @summary Disconnect accounting platform
   * @param {AccountingPlatformsApiDisconnectAccountingPlatformByIdRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountingPlatformsApi
   */
  disconnectAccountingPlatformById(requestParameters, options) {
    return AccountingPlatformsApiFp(this.configuration).disconnectAccountingPlatformById(requestParameters.id, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * List of all accounting platform bank accounts
   * @summary List of all accounting platform bank accounts
   * @param {AccountingPlatformsApiGetAccountingPlatformBankAccountsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountingPlatformsApi
   */
  getAccountingPlatformBankAccounts(requestParameters = {}, options) {
    return AccountingPlatformsApiFp(this.configuration).getAccountingPlatformBankAccounts(requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * get the status of the current or last sync (in case there isn\'t sync that currently run)
   * @summary Get accounting platform sync status
   * @param {AccountingPlatformsApiGetAccountingPlatformSyncStatusRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountingPlatformsApi
   */
  getAccountingPlatformSyncStatus(requestParameters, options) {
    return AccountingPlatformsApiFp(this.configuration).getAccountingPlatformSyncStatus(requestParameters.id, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * List of all accounting platforms that was Melio support, each accounting platform has id to work with the rest of the calls.
   * @summary List of all accounting platforms
   * @param {AccountingPlatformsApiGetAccountingPlatformsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountingPlatformsApi
   */
  getAccountingPlatforms(requestParameters = {}, options) {
    return AccountingPlatformsApiFp(this.configuration).getAccountingPlatforms(requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * get bill labels data by accounting platforms id
   * @summary accounting platform
   * @param {AccountingPlatformsApiGetAccountingPlatformsBillLabelsByIdRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountingPlatformsApi
   */
  getAccountingPlatformsBillLabelsById(requestParameters, options) {
    return AccountingPlatformsApiFp(this.configuration).getAccountingPlatformsBillLabelsById(requestParameters.id, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * get bill line item labels data by accounting platforms id
   * @summary accounting platform
   * @param {AccountingPlatformsApiGetAccountingPlatformsBillLineItemLabelsByIdRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountingPlatformsApi
   */
  getAccountingPlatformsBillLineItemLabelsById(requestParameters, options) {
    return AccountingPlatformsApiFp(this.configuration).getAccountingPlatformsBillLineItemLabelsById(requestParameters.id, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * get data for accounting platforms bu id.
   * @summary accounting platform
   * @param {AccountingPlatformsApiGetAccountingPlatformsByIdRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountingPlatformsApi
   */
  getAccountingPlatformsById(requestParameters, options) {
    return AccountingPlatformsApiFp(this.configuration).getAccountingPlatformsById(requestParameters.id, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * get categories data for accounting platforms by id
   * @summary accounting platform
   * @param {AccountingPlatformsApiGetAccountingPlatformsCategoriesByIdRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountingPlatformsApi
   */
  getAccountingPlatformsCategoriesById(requestParameters, options) {
    return AccountingPlatformsApiFp(this.configuration).getAccountingPlatformsCategoriesById(requestParameters.id, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * get items data for accounting platforms by id
   * @summary accounting platform
   * @param {AccountingPlatformsApiGetAccountingPlatformsItemsByIdRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountingPlatformsApi
   */
  getAccountingPlatformsItemsById(requestParameters, options) {
    return AccountingPlatformsApiFp(this.configuration).getAccountingPlatformsItemsById(requestParameters.id, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * get payment account data for accounting platforms by id
   * @summary accounting platform
   * @param {AccountingPlatformsApiGetAccountingPlatformsPaymentAccountsByIdRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountingPlatformsApi
   */
  getAccountingPlatformsPaymentAccountsById(requestParameters, options) {
    return AccountingPlatformsApiFp(this.configuration).getAccountingPlatformsPaymentAccountsById(requestParameters.id, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * This operation initializes the QuickBooks Desktop accounting platform.
   * @summary Init QuickBooks Desktop accounting platform
   * @param {AccountingPlatformsApiInitQuickbooksDesktopRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountingPlatformsApi
   */
  initQuickbooksDesktop(requestParameters, options) {
    return AccountingPlatformsApiFp(this.configuration).initQuickbooksDesktop(requestParameters.id, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Connect accounting platform organization with Melio organization
   * @summary Register accounting platform organization
   * @param {AccountingPlatformsApiRegisterAccountingPlatformOrganizationRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountingPlatformsApi
   */
  registerAccountingPlatformOrganization(requestParameters, options) {
    return AccountingPlatformsApiFp(this.configuration).registerAccountingPlatformOrganization(requestParameters.id, requestParameters.registerAccountingPlatformOrganizationRequest, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * This operation trigger sync between Melio and the selected accounting platform (it\'s will work only if there is connection with the accounting platform)
   * @summary Post request to trigger sync
   * @param {AccountingPlatformsApiSyncAccountingPlatformRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountingPlatformsApi
   */
  syncAccountingPlatform(requestParameters, options) {
    return AccountingPlatformsApiFp(this.configuration).syncAccountingPlatform(requestParameters.id, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * This operation trigger sync entity between Melio and the selected accounting platform (it\'s will work only if there is connection with the accounting platform)
   * @summary Post request to trigger sync entity
   * @param {AccountingPlatformsApiSyncAccountingPlatformEntityRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountingPlatformsApi
   */
  syncAccountingPlatformEntity(requestParameters, options) {
    return AccountingPlatformsApiFp(this.configuration).syncAccountingPlatformEntity(requestParameters.id, requestParameters.accountingPlatformPostSyncEntityRequest, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Returns the sync mechanism version if connected to an accounting platform
   * @param {AccountingPlatformsApiSyncVersionRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountingPlatformsApi
   */
  syncVersion(requestParameters = {}, options) {
    return AccountingPlatformsApiFp(this.configuration).syncVersion(requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Retrieve the setup information for QuickBooks Desktop for the current organization
   * @summary Retrieve QuickBooks Desktop Setup Information
   * @param {AccountingPlatformsApiVerifyQuickbooksDesktopConnectionRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountingPlatformsApi
   */
  verifyQuickbooksDesktopConnection(requestParameters, options) {
    return AccountingPlatformsApiFp(this.configuration).verifyQuickbooksDesktopConnection(requestParameters.id, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
};
var AccountingPlatformsApiInstance = createInstanceFromApiIClass(AccountingPlatformsApi);
var AccountsApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * 
     * @summary Cancels an invitation
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cancelInvitation: (_0, _1, _2, ..._3) => __async(this, [_0, _1, _2, ..._3], function* (id, melioAccount, idempotencyKey, options = {}) {
      assertParamExists("cancelInvitation", "id", id);
      const localVarPath = `/invitations/{id}/cancel`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      if (idempotencyKey !== void 0 && idempotencyKey !== null) {
        localVarHeaderParameter["Idempotency-Key"] = String(idempotencyKey);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * 
     * @summary Delete a collaborator from an organization
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteCollaborator: (_0, _1, _2, _3, ..._4) => __async(this, [_0, _1, _2, _3, ..._4], function* (id, melioAccount, expand, idempotencyKey, options = {}) {
      assertParamExists("deleteCollaborator", "id", id);
      const localVarPath = `/collaborators/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "DELETE" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      if (expand !== void 0 && expand !== null) {
        localVarHeaderParameter["expand"] = String(JSON.stringify(expand));
      }
      if (idempotencyKey !== void 0 && idempotencyKey !== null) {
        localVarHeaderParameter["Idempotency-Key"] = String(idempotencyKey);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Retrieve a list of all Accounts the current Partner manages
     * @summary Retrieve all Accounts
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAccounts: (_0, ..._1) => __async(this, [_0, ..._1], function* (expand, options = {}) {
      const localVarPath = `/accounts`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (expand !== void 0) {
        localVarQueryParameter["expand"] = expand;
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Retrieve an Account using its ID
     * @summary Retrieve an Account
     * @param {string} id ID of the entity
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAccountsAccountId: (_0, _1, _2, _3, ..._4) => __async(this, [_0, _1, _2, _3, ..._4], function* (id, expand, organizationId, userId, options = {}) {
      assertParamExists("getAccountsAccountId", "id", id);
      const localVarPath = `/accounts/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (expand !== void 0) {
        localVarQueryParameter["expand"] = expand;
      }
      if (organizationId !== void 0 && organizationId !== null) {
        localVarHeaderParameter["Organization-id"] = String(organizationId);
      }
      if (userId !== void 0 && userId !== null) {
        localVarHeaderParameter["User-id"] = String(userId);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Retrieves a Melio account identified by a partner\'s ID rather than a Melio Account ID.  Use the `data.id` property from the response as the account identifier in the `Melio-Account` header in all succeeding API calls against this Account.  If the user or organization provided don\'t exist in Melio\'s system, or if this [organization, user] combination does not exist in Melio\'s organization, the call will fail.  * 400 - Either the `userId` or the `orgId` was omitted. * 403 - This [`userID`, `orgId`] _pair_ does not exist   for this partner. * 404 - The `userID` and/or the `orgId` are not known   to Melio. 
     * @summary Retrieve the account of a given orgId and userId
     * @param {string} userId The ID of the user in the partner\&#39;s system.
     * @param {string} orgId The organization (business) ID.
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAccountsIdentify: (_0, _1, _2, ..._3) => __async(this, [_0, _1, _2, ..._3], function* (userId, orgId, expand, options = {}) {
      assertParamExists("getAccountsIdentify", "userId", userId);
      assertParamExists("getAccountsIdentify", "orgId", orgId);
      const localVarPath = `/accounts/identify`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (expand !== void 0) {
        localVarQueryParameter["expand"] = expand;
      }
      if (userId !== void 0) {
        localVarQueryParameter["userId"] = userId;
      }
      if (orgId !== void 0) {
        localVarQueryParameter["orgId"] = orgId;
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Retrieve the account of the current active user
     * @summary Retrieve the account of the current active user
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAccountsMe: (_0, _1, _2, ..._3) => __async(this, [_0, _1, _2, ..._3], function* (expand, organizationId, userId, options = {}) {
      const localVarPath = `/accounts/me`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (expand !== void 0) {
        localVarQueryParameter["expand"] = expand;
      }
      if (organizationId !== void 0 && organizationId !== null) {
        localVarHeaderParameter["Organization-id"] = String(organizationId);
      }
      if (userId !== void 0 && userId !== null) {
        localVarHeaderParameter["User-id"] = String(userId);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Get a map of id <> name of the user\'s organizations
     * @summary Get a map of id <> name of the user\'s organizations
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAccountsMeOrgs: (..._0) => __async(this, [..._0], function* (options = {}) {
      const localVarPath = `/accounts/me/orgs`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * 
     * @summary Retrieve a collaborator by id
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCollaborator: (_0, _1, _2, ..._3) => __async(this, [_0, _1, _2, ..._3], function* (id, melioAccount, expand, options = {}) {
      assertParamExists("getCollaborator", "id", id);
      const localVarPath = `/collaborators/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      if (expand !== void 0 && expand !== null) {
        localVarHeaderParameter["expand"] = String(JSON.stringify(expand));
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * 
     * @summary Retrieve the collaborator of the current active user
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCollaboratorMe: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (melioAccount, expand, options = {}) {
      const localVarPath = `/collaborators/me`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      if (expand !== void 0 && expand !== null) {
        localVarHeaderParameter["expand"] = String(JSON.stringify(expand));
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Retrieve all collaborators with in the same organization of the active account
     * @summary Retrieve all collaborators of an organization
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCollaborators: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (expand, melioAccount, options = {}) {
      const localVarPath = `/collaborators`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (expand !== void 0) {
        localVarQueryParameter["expand"] = expand;
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * 
     * @summary Get all invitations for the actor\'s organization.
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {InvitationStatus} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getInvitations: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (melioAccount, status, options = {}) {
      const localVarPath = `/invitations`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (status !== void 0) {
        localVarQueryParameter["status"] = status;
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * 
     * @summary Get all of the selected organization\'s delivery methods
     * @param {string} id ID of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOrganizationDeliveryMethodsById: (_0, ..._1) => __async(this, [_0, ..._1], function* (id, options = {}) {
      assertParamExists("getOrganizationDeliveryMethodsById", "id", id);
      const localVarPath = `/accounts/me/orgs/{id}/delivery-methods`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Update an existing Account.  #### Note For compliance reasons, the fields `legalName`, `legalAddress`, and `taxInfo` can be updated only once.  In case of an attempt to overwrite those fields an error will be returned.  Additionally, please remembe that those data points must be populated before this Account can perform certain operations, such as creating a Payment.  The request\'s body can be partial, and only provided fields will be overwritten. Set an optional field to `null` in order to remove its contents.
     * @summary Update Account details
     * @param {string} id ID of the entity
     * @param {PatchAccountsAccountIdRequest} [patchAccountsAccountIdRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchAccountsAccountId: (_0, _1, _2, _3, ..._4) => __async(this, [_0, _1, _2, _3, ..._4], function* (id, patchAccountsAccountIdRequest, idempotencyKey, expand, options = {}) {
      assertParamExists("patchAccountsAccountId", "id", id);
      const localVarPath = `/accounts/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "PATCH" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (idempotencyKey !== void 0 && idempotencyKey !== null) {
        localVarHeaderParameter["Idempotency-Key"] = String(idempotencyKey);
      }
      if (expand !== void 0 && expand !== null) {
        localVarHeaderParameter["expand"] = String(JSON.stringify(expand));
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(patchAccountsAccountIdRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Update active user\'s Account details  #### Note For compliance reasons, the fields `legalName`, `legalAddress`, and `taxInfo` can be updated only once.  In case of an attempt to overwrite those fields an error will be returned.  Additionally, please remembe that those data points must be populated before this Account can perform certain operations, such as creating a Payment.  The request\'s body can be partial, and only provided fields will be overwritten. Set an optional field to `null` in order to remove its contents.
     * @summary Update active user\'s Account details
     * @param {PatchAccountsAccountIdRequest} [patchAccountsAccountIdRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchAccountsMe: (_0, _1, _2, ..._3) => __async(this, [_0, _1, _2, ..._3], function* (patchAccountsAccountIdRequest, idempotencyKey, expand, options = {}) {
      const localVarPath = `/accounts/me`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "PATCH" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (idempotencyKey !== void 0 && idempotencyKey !== null) {
        localVarHeaderParameter["Idempotency-Key"] = String(idempotencyKey);
      }
      if (expand !== void 0 && expand !== null) {
        localVarHeaderParameter["expand"] = String(JSON.stringify(expand));
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(patchAccountsAccountIdRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Update an existing user.
     * @summary Update a collaborator of an organization
     * @param {string} id ID of the entity
     * @param {PatchCollaboratorRequest} [patchCollaboratorRequest] 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchCollaborator: (_0, _1, _2, _3, _4, ..._5) => __async(this, [_0, _1, _2, _3, _4, ..._5], function* (id, patchCollaboratorRequest, melioAccount, expand, idempotencyKey, options = {}) {
      assertParamExists("patchCollaborator", "id", id);
      const localVarPath = `/collaborators/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "PATCH" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (expand !== void 0) {
        localVarQueryParameter["expand"] = expand;
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      if (idempotencyKey !== void 0 && idempotencyKey !== null) {
        localVarHeaderParameter["Idempotency-Key"] = String(idempotencyKey);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(patchCollaboratorRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Update an existing user funding sources entitlements.
     * @summary Update funding source entitlements for a collaborator
     * @param {PatchCollaboratorEntitlementsFundingSourcesRequest} [patchCollaboratorEntitlementsFundingSourcesRequest] 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchCollaboratorEntitlementsFundingSources: (_0, _1, _2, _3, ..._4) => __async(this, [_0, _1, _2, _3, ..._4], function* (patchCollaboratorEntitlementsFundingSourcesRequest, melioAccount, expand, idempotencyKey, options = {}) {
      const localVarPath = `/collaborators/entitlements/funding-sources`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "PATCH" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (expand !== void 0) {
        localVarQueryParameter["expand"] = expand;
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      if (idempotencyKey !== void 0 && idempotencyKey !== null) {
        localVarHeaderParameter["Idempotency-Key"] = String(idempotencyKey);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(patchCollaboratorEntitlementsFundingSourcesRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Create an Account with a company and a user.  Note that you can submit a Partner internal ID in the ID `id` field, in order to set it in Melio system as well. If not supplied, a random ID will be generated.
     * @summary Create an Account
     * @param {PostAccountsRequest} [postAccountsRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postAccounts: (_0, _1, _2, _3, _4, ..._5) => __async(this, [_0, _1, _2, _3, _4, ..._5], function* (postAccountsRequest, idempotencyKey, expand, organizationId, userId, options = {}) {
      const localVarPath = `/accounts`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (idempotencyKey !== void 0 && idempotencyKey !== null) {
        localVarHeaderParameter["Idempotency-Key"] = String(idempotencyKey);
      }
      if (expand !== void 0 && expand !== null) {
        localVarHeaderParameter["expand"] = String(JSON.stringify(expand));
      }
      if (organizationId !== void 0 && organizationId !== null) {
        localVarHeaderParameter["Organization-id"] = String(organizationId);
      }
      if (userId !== void 0 && userId !== null) {
        localVarHeaderParameter["User-id"] = String(userId);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postAccountsRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Create an invitation with the purpose of inviting a user to an organization.
     * @summary Create an Invitation
     * @param {PostInvitationsRequest} [postInvitationsRequest] 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postInvitations: (_0, _1, _2, ..._3) => __async(this, [_0, _1, _2, ..._3], function* (postInvitationsRequest, melioAccount, idempotencyKey, options = {}) {
      const localVarPath = `/invitations`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      if (idempotencyKey !== void 0 && idempotencyKey !== null) {
        localVarHeaderParameter["Idempotency-Key"] = String(idempotencyKey);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postInvitationsRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * 
     * @summary Resend an invitation
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    resendInvitation: (_0, _1, _2, ..._3) => __async(this, [_0, _1, _2, ..._3], function* (id, melioAccount, idempotencyKey, options = {}) {
      assertParamExists("resendInvitation", "id", id);
      const localVarPath = `/invitations/{id}/resend`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      if (idempotencyKey !== void 0 && idempotencyKey !== null) {
        localVarHeaderParameter["Idempotency-Key"] = String(idempotencyKey);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Transfer ownership of an organization to the provided collaborator
     * @summary Transfer ownership of an organization
     * @param {string} id ID of the entity
     * @param {TransferOrganizationOwnershipRequest} [transferOrganizationOwnershipRequest] 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    transferOrganizationOwnership: (_0, _1, _2, _3, _4, ..._5) => __async(this, [_0, _1, _2, _3, _4, ..._5], function* (id, transferOrganizationOwnershipRequest, melioAccount, expand, idempotencyKey, options = {}) {
      assertParamExists("transferOrganizationOwnership", "id", id);
      const localVarPath = `/collaborators/{id}/transfer-ownership`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (expand !== void 0) {
        localVarQueryParameter["expand"] = expand;
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      if (idempotencyKey !== void 0 && idempotencyKey !== null) {
        localVarHeaderParameter["Idempotency-Key"] = String(idempotencyKey);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(transferOrganizationOwnershipRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    })
  };
};
var AccountsApiFp = function(configuration) {
  const localVarAxiosParamCreator = AccountsApiAxiosParamCreator(configuration);
  return {
    /**
     * 
     * @summary Cancels an invitation
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cancelInvitation(id, melioAccount, idempotencyKey, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.cancelInvitation(id, melioAccount, idempotencyKey, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * 
     * @summary Delete a collaborator from an organization
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteCollaborator(id, melioAccount, expand, idempotencyKey, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteCollaborator(id, melioAccount, expand, idempotencyKey, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Retrieve a list of all Accounts the current Partner manages
     * @summary Retrieve all Accounts
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAccounts(expand, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getAccounts(expand, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Retrieve an Account using its ID
     * @summary Retrieve an Account
     * @param {string} id ID of the entity
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAccountsAccountId(id, expand, organizationId, userId, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getAccountsAccountId(id, expand, organizationId, userId, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Retrieves a Melio account identified by a partner\'s ID rather than a Melio Account ID.  Use the `data.id` property from the response as the account identifier in the `Melio-Account` header in all succeeding API calls against this Account.  If the user or organization provided don\'t exist in Melio\'s system, or if this [organization, user] combination does not exist in Melio\'s organization, the call will fail.  * 400 - Either the `userId` or the `orgId` was omitted. * 403 - This [`userID`, `orgId`] _pair_ does not exist   for this partner. * 404 - The `userID` and/or the `orgId` are not known   to Melio. 
     * @summary Retrieve the account of a given orgId and userId
     * @param {string} userId The ID of the user in the partner\&#39;s system.
     * @param {string} orgId The organization (business) ID.
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAccountsIdentify(userId, orgId, expand, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getAccountsIdentify(userId, orgId, expand, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Retrieve the account of the current active user
     * @summary Retrieve the account of the current active user
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAccountsMe(expand, organizationId, userId, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getAccountsMe(expand, organizationId, userId, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Get a map of id <> name of the user\'s organizations
     * @summary Get a map of id <> name of the user\'s organizations
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAccountsMeOrgs(options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getAccountsMeOrgs(options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * 
     * @summary Retrieve a collaborator by id
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCollaborator(id, melioAccount, expand, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getCollaborator(id, melioAccount, expand, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * 
     * @summary Retrieve the collaborator of the current active user
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCollaboratorMe(melioAccount, expand, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getCollaboratorMe(melioAccount, expand, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Retrieve all collaborators with in the same organization of the active account
     * @summary Retrieve all collaborators of an organization
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCollaborators(expand, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getCollaborators(expand, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * 
     * @summary Get all invitations for the actor\'s organization.
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {InvitationStatus} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getInvitations(melioAccount, status, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getInvitations(melioAccount, status, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * 
     * @summary Get all of the selected organization\'s delivery methods
     * @param {string} id ID of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOrganizationDeliveryMethodsById(id, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getOrganizationDeliveryMethodsById(id, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Update an existing Account.  #### Note For compliance reasons, the fields `legalName`, `legalAddress`, and `taxInfo` can be updated only once.  In case of an attempt to overwrite those fields an error will be returned.  Additionally, please remembe that those data points must be populated before this Account can perform certain operations, such as creating a Payment.  The request\'s body can be partial, and only provided fields will be overwritten. Set an optional field to `null` in order to remove its contents.
     * @summary Update Account details
     * @param {string} id ID of the entity
     * @param {PatchAccountsAccountIdRequest} [patchAccountsAccountIdRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchAccountsAccountId(id, patchAccountsAccountIdRequest, idempotencyKey, expand, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.patchAccountsAccountId(id, patchAccountsAccountIdRequest, idempotencyKey, expand, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Update active user\'s Account details  #### Note For compliance reasons, the fields `legalName`, `legalAddress`, and `taxInfo` can be updated only once.  In case of an attempt to overwrite those fields an error will be returned.  Additionally, please remembe that those data points must be populated before this Account can perform certain operations, such as creating a Payment.  The request\'s body can be partial, and only provided fields will be overwritten. Set an optional field to `null` in order to remove its contents.
     * @summary Update active user\'s Account details
     * @param {PatchAccountsAccountIdRequest} [patchAccountsAccountIdRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchAccountsMe(patchAccountsAccountIdRequest, idempotencyKey, expand, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.patchAccountsMe(patchAccountsAccountIdRequest, idempotencyKey, expand, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Update an existing user.
     * @summary Update a collaborator of an organization
     * @param {string} id ID of the entity
     * @param {PatchCollaboratorRequest} [patchCollaboratorRequest] 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchCollaborator(id, patchCollaboratorRequest, melioAccount, expand, idempotencyKey, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.patchCollaborator(id, patchCollaboratorRequest, melioAccount, expand, idempotencyKey, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Update an existing user funding sources entitlements.
     * @summary Update funding source entitlements for a collaborator
     * @param {PatchCollaboratorEntitlementsFundingSourcesRequest} [patchCollaboratorEntitlementsFundingSourcesRequest] 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchCollaboratorEntitlementsFundingSources(patchCollaboratorEntitlementsFundingSourcesRequest, melioAccount, expand, idempotencyKey, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.patchCollaboratorEntitlementsFundingSources(patchCollaboratorEntitlementsFundingSourcesRequest, melioAccount, expand, idempotencyKey, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Create an Account with a company and a user.  Note that you can submit a Partner internal ID in the ID `id` field, in order to set it in Melio system as well. If not supplied, a random ID will be generated.
     * @summary Create an Account
     * @param {PostAccountsRequest} [postAccountsRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postAccounts(postAccountsRequest, idempotencyKey, expand, organizationId, userId, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postAccounts(postAccountsRequest, idempotencyKey, expand, organizationId, userId, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Create an invitation with the purpose of inviting a user to an organization.
     * @summary Create an Invitation
     * @param {PostInvitationsRequest} [postInvitationsRequest] 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postInvitations(postInvitationsRequest, melioAccount, idempotencyKey, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postInvitations(postInvitationsRequest, melioAccount, idempotencyKey, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * 
     * @summary Resend an invitation
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    resendInvitation(id, melioAccount, idempotencyKey, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.resendInvitation(id, melioAccount, idempotencyKey, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Transfer ownership of an organization to the provided collaborator
     * @summary Transfer ownership of an organization
     * @param {string} id ID of the entity
     * @param {TransferOrganizationOwnershipRequest} [transferOrganizationOwnershipRequest] 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    transferOrganizationOwnership(id, transferOrganizationOwnershipRequest, melioAccount, expand, idempotencyKey, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.transferOrganizationOwnership(id, transferOrganizationOwnershipRequest, melioAccount, expand, idempotencyKey, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    }
  };
};
var AccountsApiClient = createApiFromFp(AccountsApiFp);
var AccountsApiFactory = function(configuration, basePath, axios2) {
  const localVarFp = AccountsApiFp(configuration);
  return {
    /**
     * 
     * @summary Cancels an invitation
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cancelInvitation(id, melioAccount, idempotencyKey, options) {
      return localVarFp.cancelInvitation(id, melioAccount, idempotencyKey, options).then((request) => request(axios2, basePath));
    },
    /**
     * 
     * @summary Delete a collaborator from an organization
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteCollaborator(id, melioAccount, expand, idempotencyKey, options) {
      return localVarFp.deleteCollaborator(id, melioAccount, expand, idempotencyKey, options).then((request) => request(axios2, basePath));
    },
    /**
     * Retrieve a list of all Accounts the current Partner manages
     * @summary Retrieve all Accounts
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAccounts(expand, options) {
      return localVarFp.getAccounts(expand, options).then((request) => request(axios2, basePath));
    },
    /**
     * Retrieve an Account using its ID
     * @summary Retrieve an Account
     * @param {string} id ID of the entity
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAccountsAccountId(id, expand, organizationId, userId, options) {
      return localVarFp.getAccountsAccountId(id, expand, organizationId, userId, options).then((request) => request(axios2, basePath));
    },
    /**
     * Retrieves a Melio account identified by a partner\'s ID rather than a Melio Account ID.  Use the `data.id` property from the response as the account identifier in the `Melio-Account` header in all succeeding API calls against this Account.  If the user or organization provided don\'t exist in Melio\'s system, or if this [organization, user] combination does not exist in Melio\'s organization, the call will fail.  * 400 - Either the `userId` or the `orgId` was omitted. * 403 - This [`userID`, `orgId`] _pair_ does not exist   for this partner. * 404 - The `userID` and/or the `orgId` are not known   to Melio. 
     * @summary Retrieve the account of a given orgId and userId
     * @param {string} userId The ID of the user in the partner\&#39;s system.
     * @param {string} orgId The organization (business) ID.
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAccountsIdentify(userId, orgId, expand, options) {
      return localVarFp.getAccountsIdentify(userId, orgId, expand, options).then((request) => request(axios2, basePath));
    },
    /**
     * Retrieve the account of the current active user
     * @summary Retrieve the account of the current active user
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAccountsMe(expand, organizationId, userId, options) {
      return localVarFp.getAccountsMe(expand, organizationId, userId, options).then((request) => request(axios2, basePath));
    },
    /**
     * Get a map of id <> name of the user\'s organizations
     * @summary Get a map of id <> name of the user\'s organizations
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAccountsMeOrgs(options) {
      return localVarFp.getAccountsMeOrgs(options).then((request) => request(axios2, basePath));
    },
    /**
     * 
     * @summary Retrieve a collaborator by id
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCollaborator(id, melioAccount, expand, options) {
      return localVarFp.getCollaborator(id, melioAccount, expand, options).then((request) => request(axios2, basePath));
    },
    /**
     * 
     * @summary Retrieve the collaborator of the current active user
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCollaboratorMe(melioAccount, expand, options) {
      return localVarFp.getCollaboratorMe(melioAccount, expand, options).then((request) => request(axios2, basePath));
    },
    /**
     * Retrieve all collaborators with in the same organization of the active account
     * @summary Retrieve all collaborators of an organization
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCollaborators(expand, melioAccount, options) {
      return localVarFp.getCollaborators(expand, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * 
     * @summary Get all invitations for the actor\'s organization.
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {InvitationStatus} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getInvitations(melioAccount, status, options) {
      return localVarFp.getInvitations(melioAccount, status, options).then((request) => request(axios2, basePath));
    },
    /**
     * 
     * @summary Get all of the selected organization\'s delivery methods
     * @param {string} id ID of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOrganizationDeliveryMethodsById(id, options) {
      return localVarFp.getOrganizationDeliveryMethodsById(id, options).then((request) => request(axios2, basePath));
    },
    /**
     * Update an existing Account.  #### Note For compliance reasons, the fields `legalName`, `legalAddress`, and `taxInfo` can be updated only once.  In case of an attempt to overwrite those fields an error will be returned.  Additionally, please remembe that those data points must be populated before this Account can perform certain operations, such as creating a Payment.  The request\'s body can be partial, and only provided fields will be overwritten. Set an optional field to `null` in order to remove its contents.
     * @summary Update Account details
     * @param {string} id ID of the entity
     * @param {PatchAccountsAccountIdRequest} [patchAccountsAccountIdRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchAccountsAccountId(id, patchAccountsAccountIdRequest, idempotencyKey, expand, options) {
      return localVarFp.patchAccountsAccountId(id, patchAccountsAccountIdRequest, idempotencyKey, expand, options).then((request) => request(axios2, basePath));
    },
    /**
     * Update active user\'s Account details  #### Note For compliance reasons, the fields `legalName`, `legalAddress`, and `taxInfo` can be updated only once.  In case of an attempt to overwrite those fields an error will be returned.  Additionally, please remembe that those data points must be populated before this Account can perform certain operations, such as creating a Payment.  The request\'s body can be partial, and only provided fields will be overwritten. Set an optional field to `null` in order to remove its contents.
     * @summary Update active user\'s Account details
     * @param {PatchAccountsAccountIdRequest} [patchAccountsAccountIdRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchAccountsMe(patchAccountsAccountIdRequest, idempotencyKey, expand, options) {
      return localVarFp.patchAccountsMe(patchAccountsAccountIdRequest, idempotencyKey, expand, options).then((request) => request(axios2, basePath));
    },
    /**
     * Update an existing user.
     * @summary Update a collaborator of an organization
     * @param {string} id ID of the entity
     * @param {PatchCollaboratorRequest} [patchCollaboratorRequest] 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchCollaborator(id, patchCollaboratorRequest, melioAccount, expand, idempotencyKey, options) {
      return localVarFp.patchCollaborator(id, patchCollaboratorRequest, melioAccount, expand, idempotencyKey, options).then((request) => request(axios2, basePath));
    },
    /**
     * Update an existing user funding sources entitlements.
     * @summary Update funding source entitlements for a collaborator
     * @param {PatchCollaboratorEntitlementsFundingSourcesRequest} [patchCollaboratorEntitlementsFundingSourcesRequest] 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchCollaboratorEntitlementsFundingSources(patchCollaboratorEntitlementsFundingSourcesRequest, melioAccount, expand, idempotencyKey, options) {
      return localVarFp.patchCollaboratorEntitlementsFundingSources(patchCollaboratorEntitlementsFundingSourcesRequest, melioAccount, expand, idempotencyKey, options).then((request) => request(axios2, basePath));
    },
    /**
     * Create an Account with a company and a user.  Note that you can submit a Partner internal ID in the ID `id` field, in order to set it in Melio system as well. If not supplied, a random ID will be generated.
     * @summary Create an Account
     * @param {PostAccountsRequest} [postAccountsRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postAccounts(postAccountsRequest, idempotencyKey, expand, organizationId, userId, options) {
      return localVarFp.postAccounts(postAccountsRequest, idempotencyKey, expand, organizationId, userId, options).then((request) => request(axios2, basePath));
    },
    /**
     * Create an invitation with the purpose of inviting a user to an organization.
     * @summary Create an Invitation
     * @param {PostInvitationsRequest} [postInvitationsRequest] 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postInvitations(postInvitationsRequest, melioAccount, idempotencyKey, options) {
      return localVarFp.postInvitations(postInvitationsRequest, melioAccount, idempotencyKey, options).then((request) => request(axios2, basePath));
    },
    /**
     * 
     * @summary Resend an invitation
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    resendInvitation(id, melioAccount, idempotencyKey, options) {
      return localVarFp.resendInvitation(id, melioAccount, idempotencyKey, options).then((request) => request(axios2, basePath));
    },
    /**
     * Transfer ownership of an organization to the provided collaborator
     * @summary Transfer ownership of an organization
     * @param {string} id ID of the entity
     * @param {TransferOrganizationOwnershipRequest} [transferOrganizationOwnershipRequest] 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    transferOrganizationOwnership(id, transferOrganizationOwnershipRequest, melioAccount, expand, idempotencyKey, options) {
      return localVarFp.transferOrganizationOwnership(id, transferOrganizationOwnershipRequest, melioAccount, expand, idempotencyKey, options).then((request) => request(axios2, basePath));
    }
  };
};
var AccountsApi = class extends BaseAPI {
  /**
   * 
   * @summary Cancels an invitation
   * @param {AccountsApiCancelInvitationRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountsApi
   */
  cancelInvitation(requestParameters, options) {
    return AccountsApiFp(this.configuration).cancelInvitation(requestParameters.id, requestParameters.melioAccount, requestParameters.idempotencyKey, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Delete a collaborator from an organization
   * @param {AccountsApiDeleteCollaboratorRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountsApi
   */
  deleteCollaborator(requestParameters, options) {
    return AccountsApiFp(this.configuration).deleteCollaborator(requestParameters.id, requestParameters.melioAccount, requestParameters.expand, requestParameters.idempotencyKey, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Retrieve a list of all Accounts the current Partner manages
   * @summary Retrieve all Accounts
   * @param {AccountsApiGetAccountsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountsApi
   */
  getAccounts(requestParameters = {}, options) {
    return AccountsApiFp(this.configuration).getAccounts(requestParameters.expand, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Retrieve an Account using its ID
   * @summary Retrieve an Account
   * @param {AccountsApiGetAccountsAccountIdRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountsApi
   */
  getAccountsAccountId(requestParameters, options) {
    return AccountsApiFp(this.configuration).getAccountsAccountId(requestParameters.id, requestParameters.expand, requestParameters.organizationId, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Retrieves a Melio account identified by a partner\'s ID rather than a Melio Account ID.  Use the `data.id` property from the response as the account identifier in the `Melio-Account` header in all succeeding API calls against this Account.  If the user or organization provided don\'t exist in Melio\'s system, or if this [organization, user] combination does not exist in Melio\'s organization, the call will fail.  * 400 - Either the `userId` or the `orgId` was omitted. * 403 - This [`userID`, `orgId`] _pair_ does not exist   for this partner. * 404 - The `userID` and/or the `orgId` are not known   to Melio. 
   * @summary Retrieve the account of a given orgId and userId
   * @param {AccountsApiGetAccountsIdentifyRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountsApi
   */
  getAccountsIdentify(requestParameters, options) {
    return AccountsApiFp(this.configuration).getAccountsIdentify(requestParameters.userId, requestParameters.orgId, requestParameters.expand, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Retrieve the account of the current active user
   * @summary Retrieve the account of the current active user
   * @param {AccountsApiGetAccountsMeRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountsApi
   */
  getAccountsMe(requestParameters = {}, options) {
    return AccountsApiFp(this.configuration).getAccountsMe(requestParameters.expand, requestParameters.organizationId, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Get a map of id <> name of the user\'s organizations
   * @summary Get a map of id <> name of the user\'s organizations
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountsApi
   */
  getAccountsMeOrgs(options) {
    return AccountsApiFp(this.configuration).getAccountsMeOrgs(options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Retrieve a collaborator by id
   * @param {AccountsApiGetCollaboratorRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountsApi
   */
  getCollaborator(requestParameters, options) {
    return AccountsApiFp(this.configuration).getCollaborator(requestParameters.id, requestParameters.melioAccount, requestParameters.expand, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Retrieve the collaborator of the current active user
   * @param {AccountsApiGetCollaboratorMeRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountsApi
   */
  getCollaboratorMe(requestParameters = {}, options) {
    return AccountsApiFp(this.configuration).getCollaboratorMe(requestParameters.melioAccount, requestParameters.expand, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Retrieve all collaborators with in the same organization of the active account
   * @summary Retrieve all collaborators of an organization
   * @param {AccountsApiGetCollaboratorsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountsApi
   */
  getCollaborators(requestParameters = {}, options) {
    return AccountsApiFp(this.configuration).getCollaborators(requestParameters.expand, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Get all invitations for the actor\'s organization.
   * @param {AccountsApiGetInvitationsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountsApi
   */
  getInvitations(requestParameters = {}, options) {
    return AccountsApiFp(this.configuration).getInvitations(requestParameters.melioAccount, requestParameters.status, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Get all of the selected organization\'s delivery methods
   * @param {AccountsApiGetOrganizationDeliveryMethodsByIdRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountsApi
   */
  getOrganizationDeliveryMethodsById(requestParameters, options) {
    return AccountsApiFp(this.configuration).getOrganizationDeliveryMethodsById(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Update an existing Account.  #### Note For compliance reasons, the fields `legalName`, `legalAddress`, and `taxInfo` can be updated only once.  In case of an attempt to overwrite those fields an error will be returned.  Additionally, please remembe that those data points must be populated before this Account can perform certain operations, such as creating a Payment.  The request\'s body can be partial, and only provided fields will be overwritten. Set an optional field to `null` in order to remove its contents.
   * @summary Update Account details
   * @param {AccountsApiPatchAccountsAccountIdRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountsApi
   */
  patchAccountsAccountId(requestParameters, options) {
    return AccountsApiFp(this.configuration).patchAccountsAccountId(requestParameters.id, requestParameters.patchAccountsAccountIdRequest, requestParameters.idempotencyKey, requestParameters.expand, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Update active user\'s Account details  #### Note For compliance reasons, the fields `legalName`, `legalAddress`, and `taxInfo` can be updated only once.  In case of an attempt to overwrite those fields an error will be returned.  Additionally, please remembe that those data points must be populated before this Account can perform certain operations, such as creating a Payment.  The request\'s body can be partial, and only provided fields will be overwritten. Set an optional field to `null` in order to remove its contents.
   * @summary Update active user\'s Account details
   * @param {AccountsApiPatchAccountsMeRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountsApi
   */
  patchAccountsMe(requestParameters = {}, options) {
    return AccountsApiFp(this.configuration).patchAccountsMe(requestParameters.patchAccountsAccountIdRequest, requestParameters.idempotencyKey, requestParameters.expand, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Update an existing user.
   * @summary Update a collaborator of an organization
   * @param {AccountsApiPatchCollaboratorRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountsApi
   */
  patchCollaborator(requestParameters, options) {
    return AccountsApiFp(this.configuration).patchCollaborator(requestParameters.id, requestParameters.patchCollaboratorRequest, requestParameters.melioAccount, requestParameters.expand, requestParameters.idempotencyKey, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Update an existing user funding sources entitlements.
   * @summary Update funding source entitlements for a collaborator
   * @param {AccountsApiPatchCollaboratorEntitlementsFundingSourcesRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountsApi
   */
  patchCollaboratorEntitlementsFundingSources(requestParameters = {}, options) {
    return AccountsApiFp(this.configuration).patchCollaboratorEntitlementsFundingSources(requestParameters.patchCollaboratorEntitlementsFundingSourcesRequest, requestParameters.melioAccount, requestParameters.expand, requestParameters.idempotencyKey, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Create an Account with a company and a user.  Note that you can submit a Partner internal ID in the ID `id` field, in order to set it in Melio system as well. If not supplied, a random ID will be generated.
   * @summary Create an Account
   * @param {AccountsApiPostAccountsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountsApi
   */
  postAccounts(requestParameters = {}, options) {
    return AccountsApiFp(this.configuration).postAccounts(requestParameters.postAccountsRequest, requestParameters.idempotencyKey, requestParameters.expand, requestParameters.organizationId, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Create an invitation with the purpose of inviting a user to an organization.
   * @summary Create an Invitation
   * @param {AccountsApiPostInvitationsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountsApi
   */
  postInvitations(requestParameters = {}, options) {
    return AccountsApiFp(this.configuration).postInvitations(requestParameters.postInvitationsRequest, requestParameters.melioAccount, requestParameters.idempotencyKey, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Resend an invitation
   * @param {AccountsApiResendInvitationRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountsApi
   */
  resendInvitation(requestParameters, options) {
    return AccountsApiFp(this.configuration).resendInvitation(requestParameters.id, requestParameters.melioAccount, requestParameters.idempotencyKey, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Transfer ownership of an organization to the provided collaborator
   * @summary Transfer ownership of an organization
   * @param {AccountsApiTransferOrganizationOwnershipRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountsApi
   */
  transferOrganizationOwnership(requestParameters, options) {
    return AccountsApiFp(this.configuration).transferOrganizationOwnership(requestParameters.id, requestParameters.transferOrganizationOwnershipRequest, requestParameters.melioAccount, requestParameters.expand, requestParameters.idempotencyKey, options).then((request) => request(this.axios, this.basePath));
  }
};
var AccountsApiInstance = createInstanceFromApiIClass(AccountsApi);
var AccountsLimitationsApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * 
     * @summary Get current account limitations
     * @param {'dashboard' | 'payment'} [stage] The phase of the account limitations to retrieve
     * @param {boolean} [isInitiator] If this is the initiator of the payment stage
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAccountsMeLimitations: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (stage, isInitiator, options = {}) {
      const localVarPath = `/accounts/me/limitations`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (stage !== void 0) {
        localVarQueryParameter["stage"] = stage;
      }
      if (isInitiator !== void 0) {
        localVarQueryParameter["isInitiator"] = isInitiator;
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    })
  };
};
var AccountsLimitationsApiFp = function(configuration) {
  const localVarAxiosParamCreator = AccountsLimitationsApiAxiosParamCreator(configuration);
  return {
    /**
     * 
     * @summary Get current account limitations
     * @param {'dashboard' | 'payment'} [stage] The phase of the account limitations to retrieve
     * @param {boolean} [isInitiator] If this is the initiator of the payment stage
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAccountsMeLimitations(stage, isInitiator, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getAccountsMeLimitations(stage, isInitiator, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    }
  };
};
var AccountsLimitationsApiClient = createApiFromFp(AccountsLimitationsApiFp);
var AccountsLimitationsApiFactory = function(configuration, basePath, axios2) {
  const localVarFp = AccountsLimitationsApiFp(configuration);
  return {
    /**
     * 
     * @summary Get current account limitations
     * @param {'dashboard' | 'payment'} [stage] The phase of the account limitations to retrieve
     * @param {boolean} [isInitiator] If this is the initiator of the payment stage
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAccountsMeLimitations(stage, isInitiator, options) {
      return localVarFp.getAccountsMeLimitations(stage, isInitiator, options).then((request) => request(axios2, basePath));
    }
  };
};
var AccountsLimitationsApi = class extends BaseAPI {
  /**
   * 
   * @summary Get current account limitations
   * @param {AccountsLimitationsApiGetAccountsMeLimitationsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountsLimitationsApi
   */
  getAccountsMeLimitations(requestParameters = {}, options) {
    return AccountsLimitationsApiFp(this.configuration).getAccountsMeLimitations(requestParameters.stage, requestParameters.isInitiator, options).then((request) => request(this.axios, this.basePath));
  }
};
var AccountsLimitationsApiInstance = createInstanceFromApiIClass(AccountsLimitationsApi);
var AgreementsApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * Delete an Agreement.
     * @summary Delete an Agreement
     * @param {string} id ID of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteAgreementsAgreementId: (_0, ..._1) => __async(this, [_0, ..._1], function* (id, options = {}) {
      assertParamExists("deleteAgreementsAgreementId", "id", id);
      const localVarPath = `/agreements/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "DELETE" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Retrieve a list of all Agreements
     * @summary Retrieve all Agreements
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAgreements: (..._0) => __async(this, [..._0], function* (options = {}) {
      const localVarPath = `/agreements`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Retrieve an Agreement using its ID.
     * @summary Retrieve an Agreement
     * @param {string} id ID of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAgreementsAgreementId: (_0, ..._1) => __async(this, [_0, ..._1], function* (id, options = {}) {
      assertParamExists("getAgreementsAgreementId", "id", id);
      const localVarPath = `/agreements/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Update an Agreement.
     * @summary Update an Agreement
     * @param {string} id ID of the entity
     * @param {PatchAgreementsRequest} [patchAgreementsRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchAgreementsAgreementId: (_0, _1, _2, ..._3) => __async(this, [_0, _1, _2, ..._3], function* (id, patchAgreementsRequest, idempotencyKey, options = {}) {
      assertParamExists("patchAgreementsAgreementId", "id", id);
      const localVarPath = `/agreements/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "PATCH" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (idempotencyKey !== void 0 && idempotencyKey !== null) {
        localVarHeaderParameter["Idempotency-Key"] = String(idempotencyKey);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(patchAgreementsRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Create an Agreement.
     * @summary Create an Agreement
     * @param {PostAgreementsRequest} [postAgreementsRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postAgreements: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (postAgreementsRequest, idempotencyKey, options = {}) {
      const localVarPath = `/agreements`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (idempotencyKey !== void 0 && idempotencyKey !== null) {
        localVarHeaderParameter["Idempotency-Key"] = String(idempotencyKey);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postAgreementsRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    })
  };
};
var AgreementsApiFp = function(configuration) {
  const localVarAxiosParamCreator = AgreementsApiAxiosParamCreator(configuration);
  return {
    /**
     * Delete an Agreement.
     * @summary Delete an Agreement
     * @param {string} id ID of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteAgreementsAgreementId(id, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteAgreementsAgreementId(id, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Retrieve a list of all Agreements
     * @summary Retrieve all Agreements
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAgreements(options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getAgreements(options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Retrieve an Agreement using its ID.
     * @summary Retrieve an Agreement
     * @param {string} id ID of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAgreementsAgreementId(id, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getAgreementsAgreementId(id, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Update an Agreement.
     * @summary Update an Agreement
     * @param {string} id ID of the entity
     * @param {PatchAgreementsRequest} [patchAgreementsRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchAgreementsAgreementId(id, patchAgreementsRequest, idempotencyKey, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.patchAgreementsAgreementId(id, patchAgreementsRequest, idempotencyKey, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Create an Agreement.
     * @summary Create an Agreement
     * @param {PostAgreementsRequest} [postAgreementsRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postAgreements(postAgreementsRequest, idempotencyKey, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postAgreements(postAgreementsRequest, idempotencyKey, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    }
  };
};
var AgreementsApiClient = createApiFromFp(AgreementsApiFp);
var AgreementsApiFactory = function(configuration, basePath, axios2) {
  const localVarFp = AgreementsApiFp(configuration);
  return {
    /**
     * Delete an Agreement.
     * @summary Delete an Agreement
     * @param {string} id ID of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteAgreementsAgreementId(id, options) {
      return localVarFp.deleteAgreementsAgreementId(id, options).then((request) => request(axios2, basePath));
    },
    /**
     * Retrieve a list of all Agreements
     * @summary Retrieve all Agreements
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAgreements(options) {
      return localVarFp.getAgreements(options).then((request) => request(axios2, basePath));
    },
    /**
     * Retrieve an Agreement using its ID.
     * @summary Retrieve an Agreement
     * @param {string} id ID of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAgreementsAgreementId(id, options) {
      return localVarFp.getAgreementsAgreementId(id, options).then((request) => request(axios2, basePath));
    },
    /**
     * Update an Agreement.
     * @summary Update an Agreement
     * @param {string} id ID of the entity
     * @param {PatchAgreementsRequest} [patchAgreementsRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchAgreementsAgreementId(id, patchAgreementsRequest, idempotencyKey, options) {
      return localVarFp.patchAgreementsAgreementId(id, patchAgreementsRequest, idempotencyKey, options).then((request) => request(axios2, basePath));
    },
    /**
     * Create an Agreement.
     * @summary Create an Agreement
     * @param {PostAgreementsRequest} [postAgreementsRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postAgreements(postAgreementsRequest, idempotencyKey, options) {
      return localVarFp.postAgreements(postAgreementsRequest, idempotencyKey, options).then((request) => request(axios2, basePath));
    }
  };
};
var AgreementsApi = class extends BaseAPI {
  /**
   * Delete an Agreement.
   * @summary Delete an Agreement
   * @param {AgreementsApiDeleteAgreementsAgreementIdRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgreementsApi
   */
  deleteAgreementsAgreementId(requestParameters, options) {
    return AgreementsApiFp(this.configuration).deleteAgreementsAgreementId(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Retrieve a list of all Agreements
   * @summary Retrieve all Agreements
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgreementsApi
   */
  getAgreements(options) {
    return AgreementsApiFp(this.configuration).getAgreements(options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Retrieve an Agreement using its ID.
   * @summary Retrieve an Agreement
   * @param {AgreementsApiGetAgreementsAgreementIdRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgreementsApi
   */
  getAgreementsAgreementId(requestParameters, options) {
    return AgreementsApiFp(this.configuration).getAgreementsAgreementId(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Update an Agreement.
   * @summary Update an Agreement
   * @param {AgreementsApiPatchAgreementsAgreementIdRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgreementsApi
   */
  patchAgreementsAgreementId(requestParameters, options) {
    return AgreementsApiFp(this.configuration).patchAgreementsAgreementId(requestParameters.id, requestParameters.patchAgreementsRequest, requestParameters.idempotencyKey, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Create an Agreement.
   * @summary Create an Agreement
   * @param {AgreementsApiPostAgreementsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgreementsApi
   */
  postAgreements(requestParameters = {}, options) {
    return AgreementsApiFp(this.configuration).postAgreements(requestParameters.postAgreementsRequest, requestParameters.idempotencyKey, options).then((request) => request(this.axios, this.basePath));
  }
};
var AgreementsApiInstance = createInstanceFromApiIClass(AgreementsApi);
var AllowedMccApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * Get allowed MCCs by card type - Return a static list for amex cards
     * @summary Retrieve allowed MCCs by card type
     * @param {CardNetwork} cardNetwork Card Network
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAllowedMcc: (_0, ..._1) => __async(this, [_0, ..._1], function* (cardNetwork, options = {}) {
      assertParamExists("getAllowedMcc", "cardNetwork", cardNetwork);
      const localVarPath = `/allowed-mcc`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (cardNetwork !== void 0) {
        localVarQueryParameter["cardNetwork"] = cardNetwork;
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    })
  };
};
var AllowedMccApiFp = function(configuration) {
  const localVarAxiosParamCreator = AllowedMccApiAxiosParamCreator(configuration);
  return {
    /**
     * Get allowed MCCs by card type - Return a static list for amex cards
     * @summary Retrieve allowed MCCs by card type
     * @param {CardNetwork} cardNetwork Card Network
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAllowedMcc(cardNetwork, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getAllowedMcc(cardNetwork, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    }
  };
};
var AllowedMccApiClient = createApiFromFp(AllowedMccApiFp);
var AllowedMccApiFactory = function(configuration, basePath, axios2) {
  const localVarFp = AllowedMccApiFp(configuration);
  return {
    /**
     * Get allowed MCCs by card type - Return a static list for amex cards
     * @summary Retrieve allowed MCCs by card type
     * @param {CardNetwork} cardNetwork Card Network
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAllowedMcc(cardNetwork, options) {
      return localVarFp.getAllowedMcc(cardNetwork, options).then((request) => request(axios2, basePath));
    }
  };
};
var AllowedMccApi = class extends BaseAPI {
  /**
   * Get allowed MCCs by card type - Return a static list for amex cards
   * @summary Retrieve allowed MCCs by card type
   * @param {AllowedMccApiGetAllowedMccRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AllowedMccApi
   */
  getAllowedMcc(requestParameters, options) {
    return AllowedMccApiFp(this.configuration).getAllowedMcc(requestParameters.cardNetwork, options).then((request) => request(this.axios, this.basePath));
  }
};
var AllowedMccApiInstance = createInstanceFromApiIClass(AllowedMccApi);
var ApprovalWorkflowsApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * Delete an approval workflow by id  <!-- theme: info -->         > The `Melio-Account` header is required when using API Key security. 
     * @summary Delete an approval workflow
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteApprovalWorkflowsApprovalWorkflowId: (_0, _1, _2, _3, ..._4) => __async(this, [_0, _1, _2, _3, ..._4], function* (id, melioAccount, organizationId, userId, options = {}) {
      assertParamExists("deleteApprovalWorkflowsApprovalWorkflowId", "id", id);
      const localVarPath = `/approval-workflows/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "DELETE" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      if (organizationId !== void 0 && organizationId !== null) {
        localVarHeaderParameter["Organization-id"] = String(organizationId);
      }
      if (userId !== void 0 && userId !== null) {
        localVarHeaderParameter["User-id"] = String(userId);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Return all approval workflows for this organization.  <!-- theme: info -->         > The `Melio-Account` header is required when using API Key security. 
     * @summary Retrieve all approval workflows
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getApprovalWorkflows: (_0, ..._1) => __async(this, [_0, ..._1], function* (melioAccount, options = {}) {
      const localVarPath = `/approval-workflows`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Return all approval workflows approval roles for this partner.  <!-- theme: info -->         > The `Melio-Account` header is required when using API Key security. 
     * @summary Retrieve all approval workflows approval roles
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getApprovalWorkflowsApprovalRoles: (_0, ..._1) => __async(this, [_0, ..._1], function* (melioAccount, options = {}) {
      const localVarPath = `/approval-workflows/roles/approval-roles`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Retrieve an approval workflow by id  <!-- theme: info -->         > The `Melio-Account` header is required when using API Key security. 
     * @summary Retrieve an approval workflow
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getApprovalWorkflowsApprovalWorkflowId: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (id, melioAccount, options = {}) {
      assertParamExists("getApprovalWorkflowsApprovalWorkflowId", "id", id);
      const localVarPath = `/approval-workflows/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Create an approval workflow  <!-- theme: info -->         > The `Melio-Account` header is required when using API Key security. 
     * @summary Create an approval workflow
     * @param {ApprovalWorkflowRequest} [approvalWorkflowRequest] 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postApprovalWorkflows: (_0, _1, _2, _3, ..._4) => __async(this, [_0, _1, _2, _3, ..._4], function* (approvalWorkflowRequest, melioAccount, organizationId, userId, options = {}) {
      const localVarPath = `/approval-workflows`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      if (organizationId !== void 0 && organizationId !== null) {
        localVarHeaderParameter["Organization-id"] = String(organizationId);
      }
      if (userId !== void 0 && userId !== null) {
        localVarHeaderParameter["User-id"] = String(userId);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(approvalWorkflowRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Set a payment approval limit for a scheduler - any payment exceeding this amount will require approval  <!-- theme: info -->         > The `Melio-Account` header is required when using API Key security. 
     * @summary set payment approval limit
     * @param {SetApprovalLimitRequest} [setApprovalLimitRequest] 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    setApprovalLimit: (_0, _1, _2, _3, ..._4) => __async(this, [_0, _1, _2, _3, ..._4], function* (setApprovalLimitRequest, melioAccount, organizationId, userId, options = {}) {
      const localVarPath = `/approval-workflows/set-approval-limit`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      if (organizationId !== void 0 && organizationId !== null) {
        localVarHeaderParameter["Organization-id"] = String(organizationId);
      }
      if (userId !== void 0 && userId !== null) {
        localVarHeaderParameter["User-id"] = String(userId);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(setApprovalLimitRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Update an approval workflow by id  <!-- theme: info -->         > The `Melio-Account` header is required when using API Key security. 
     * @summary Update an approval workflow
     * @param {string} id ID of the entity
     * @param {ApprovalWorkflowRequest} [approvalWorkflowRequest] 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateApprovalWorkflowsApprovalWorkflowId: (_0, _1, _2, ..._3) => __async(this, [_0, _1, _2, ..._3], function* (id, approvalWorkflowRequest, melioAccount, options = {}) {
      assertParamExists("updateApprovalWorkflowsApprovalWorkflowId", "id", id);
      const localVarPath = `/approval-workflows/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "PUT" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(approvalWorkflowRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    })
  };
};
var ApprovalWorkflowsApiFp = function(configuration) {
  const localVarAxiosParamCreator = ApprovalWorkflowsApiAxiosParamCreator(configuration);
  return {
    /**
     * Delete an approval workflow by id  <!-- theme: info -->         > The `Melio-Account` header is required when using API Key security. 
     * @summary Delete an approval workflow
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteApprovalWorkflowsApprovalWorkflowId(id, melioAccount, organizationId, userId, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteApprovalWorkflowsApprovalWorkflowId(id, melioAccount, organizationId, userId, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Return all approval workflows for this organization.  <!-- theme: info -->         > The `Melio-Account` header is required when using API Key security. 
     * @summary Retrieve all approval workflows
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getApprovalWorkflows(melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getApprovalWorkflows(melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Return all approval workflows approval roles for this partner.  <!-- theme: info -->         > The `Melio-Account` header is required when using API Key security. 
     * @summary Retrieve all approval workflows approval roles
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getApprovalWorkflowsApprovalRoles(melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getApprovalWorkflowsApprovalRoles(melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Retrieve an approval workflow by id  <!-- theme: info -->         > The `Melio-Account` header is required when using API Key security. 
     * @summary Retrieve an approval workflow
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getApprovalWorkflowsApprovalWorkflowId(id, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getApprovalWorkflowsApprovalWorkflowId(id, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Create an approval workflow  <!-- theme: info -->         > The `Melio-Account` header is required when using API Key security. 
     * @summary Create an approval workflow
     * @param {ApprovalWorkflowRequest} [approvalWorkflowRequest] 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postApprovalWorkflows(approvalWorkflowRequest, melioAccount, organizationId, userId, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postApprovalWorkflows(approvalWorkflowRequest, melioAccount, organizationId, userId, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Set a payment approval limit for a scheduler - any payment exceeding this amount will require approval  <!-- theme: info -->         > The `Melio-Account` header is required when using API Key security. 
     * @summary set payment approval limit
     * @param {SetApprovalLimitRequest} [setApprovalLimitRequest] 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    setApprovalLimit(setApprovalLimitRequest, melioAccount, organizationId, userId, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.setApprovalLimit(setApprovalLimitRequest, melioAccount, organizationId, userId, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Update an approval workflow by id  <!-- theme: info -->         > The `Melio-Account` header is required when using API Key security. 
     * @summary Update an approval workflow
     * @param {string} id ID of the entity
     * @param {ApprovalWorkflowRequest} [approvalWorkflowRequest] 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateApprovalWorkflowsApprovalWorkflowId(id, approvalWorkflowRequest, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.updateApprovalWorkflowsApprovalWorkflowId(id, approvalWorkflowRequest, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    }
  };
};
var ApprovalWorkflowsApiClient = createApiFromFp(ApprovalWorkflowsApiFp);
var ApprovalWorkflowsApiFactory = function(configuration, basePath, axios2) {
  const localVarFp = ApprovalWorkflowsApiFp(configuration);
  return {
    /**
     * Delete an approval workflow by id  <!-- theme: info -->         > The `Melio-Account` header is required when using API Key security. 
     * @summary Delete an approval workflow
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteApprovalWorkflowsApprovalWorkflowId(id, melioAccount, organizationId, userId, options) {
      return localVarFp.deleteApprovalWorkflowsApprovalWorkflowId(id, melioAccount, organizationId, userId, options).then((request) => request(axios2, basePath));
    },
    /**
     * Return all approval workflows for this organization.  <!-- theme: info -->         > The `Melio-Account` header is required when using API Key security. 
     * @summary Retrieve all approval workflows
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getApprovalWorkflows(melioAccount, options) {
      return localVarFp.getApprovalWorkflows(melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Return all approval workflows approval roles for this partner.  <!-- theme: info -->         > The `Melio-Account` header is required when using API Key security. 
     * @summary Retrieve all approval workflows approval roles
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getApprovalWorkflowsApprovalRoles(melioAccount, options) {
      return localVarFp.getApprovalWorkflowsApprovalRoles(melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Retrieve an approval workflow by id  <!-- theme: info -->         > The `Melio-Account` header is required when using API Key security. 
     * @summary Retrieve an approval workflow
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getApprovalWorkflowsApprovalWorkflowId(id, melioAccount, options) {
      return localVarFp.getApprovalWorkflowsApprovalWorkflowId(id, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Create an approval workflow  <!-- theme: info -->         > The `Melio-Account` header is required when using API Key security. 
     * @summary Create an approval workflow
     * @param {ApprovalWorkflowRequest} [approvalWorkflowRequest] 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postApprovalWorkflows(approvalWorkflowRequest, melioAccount, organizationId, userId, options) {
      return localVarFp.postApprovalWorkflows(approvalWorkflowRequest, melioAccount, organizationId, userId, options).then((request) => request(axios2, basePath));
    },
    /**
     * Set a payment approval limit for a scheduler - any payment exceeding this amount will require approval  <!-- theme: info -->         > The `Melio-Account` header is required when using API Key security. 
     * @summary set payment approval limit
     * @param {SetApprovalLimitRequest} [setApprovalLimitRequest] 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    setApprovalLimit(setApprovalLimitRequest, melioAccount, organizationId, userId, options) {
      return localVarFp.setApprovalLimit(setApprovalLimitRequest, melioAccount, organizationId, userId, options).then((request) => request(axios2, basePath));
    },
    /**
     * Update an approval workflow by id  <!-- theme: info -->         > The `Melio-Account` header is required when using API Key security. 
     * @summary Update an approval workflow
     * @param {string} id ID of the entity
     * @param {ApprovalWorkflowRequest} [approvalWorkflowRequest] 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateApprovalWorkflowsApprovalWorkflowId(id, approvalWorkflowRequest, melioAccount, options) {
      return localVarFp.updateApprovalWorkflowsApprovalWorkflowId(id, approvalWorkflowRequest, melioAccount, options).then((request) => request(axios2, basePath));
    }
  };
};
var ApprovalWorkflowsApi = class extends BaseAPI {
  /**
   * Delete an approval workflow by id  <!-- theme: info -->         > The `Melio-Account` header is required when using API Key security. 
   * @summary Delete an approval workflow
   * @param {ApprovalWorkflowsApiDeleteApprovalWorkflowsApprovalWorkflowIdRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ApprovalWorkflowsApi
   */
  deleteApprovalWorkflowsApprovalWorkflowId(requestParameters, options) {
    return ApprovalWorkflowsApiFp(this.configuration).deleteApprovalWorkflowsApprovalWorkflowId(requestParameters.id, requestParameters.melioAccount, requestParameters.organizationId, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Return all approval workflows for this organization.  <!-- theme: info -->         > The `Melio-Account` header is required when using API Key security. 
   * @summary Retrieve all approval workflows
   * @param {ApprovalWorkflowsApiGetApprovalWorkflowsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ApprovalWorkflowsApi
   */
  getApprovalWorkflows(requestParameters = {}, options) {
    return ApprovalWorkflowsApiFp(this.configuration).getApprovalWorkflows(requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Return all approval workflows approval roles for this partner.  <!-- theme: info -->         > The `Melio-Account` header is required when using API Key security. 
   * @summary Retrieve all approval workflows approval roles
   * @param {ApprovalWorkflowsApiGetApprovalWorkflowsApprovalRolesRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ApprovalWorkflowsApi
   */
  getApprovalWorkflowsApprovalRoles(requestParameters = {}, options) {
    return ApprovalWorkflowsApiFp(this.configuration).getApprovalWorkflowsApprovalRoles(requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Retrieve an approval workflow by id  <!-- theme: info -->         > The `Melio-Account` header is required when using API Key security. 
   * @summary Retrieve an approval workflow
   * @param {ApprovalWorkflowsApiGetApprovalWorkflowsApprovalWorkflowIdRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ApprovalWorkflowsApi
   */
  getApprovalWorkflowsApprovalWorkflowId(requestParameters, options) {
    return ApprovalWorkflowsApiFp(this.configuration).getApprovalWorkflowsApprovalWorkflowId(requestParameters.id, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Create an approval workflow  <!-- theme: info -->         > The `Melio-Account` header is required when using API Key security. 
   * @summary Create an approval workflow
   * @param {ApprovalWorkflowsApiPostApprovalWorkflowsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ApprovalWorkflowsApi
   */
  postApprovalWorkflows(requestParameters = {}, options) {
    return ApprovalWorkflowsApiFp(this.configuration).postApprovalWorkflows(requestParameters.approvalWorkflowRequest, requestParameters.melioAccount, requestParameters.organizationId, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Set a payment approval limit for a scheduler - any payment exceeding this amount will require approval  <!-- theme: info -->         > The `Melio-Account` header is required when using API Key security. 
   * @summary set payment approval limit
   * @param {ApprovalWorkflowsApiSetApprovalLimitRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ApprovalWorkflowsApi
   */
  setApprovalLimit(requestParameters = {}, options) {
    return ApprovalWorkflowsApiFp(this.configuration).setApprovalLimit(requestParameters.setApprovalLimitRequest, requestParameters.melioAccount, requestParameters.organizationId, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Update an approval workflow by id  <!-- theme: info -->         > The `Melio-Account` header is required when using API Key security. 
   * @summary Update an approval workflow
   * @param {ApprovalWorkflowsApiUpdateApprovalWorkflowsApprovalWorkflowIdRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ApprovalWorkflowsApi
   */
  updateApprovalWorkflowsApprovalWorkflowId(requestParameters, options) {
    return ApprovalWorkflowsApiFp(this.configuration).updateApprovalWorkflowsApprovalWorkflowId(requestParameters.id, requestParameters.approvalWorkflowRequest, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
};
var ApprovalWorkflowsApiInstance = createInstanceFromApiIClass(ApprovalWorkflowsApi);
var AuthApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * Create an intuit disconect link for sizzers api
     * @summary Create an intuit disconnect params
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAuthProvidersIntuitDisconnectLink: (..._0) => __async(this, [..._0], function* (options = {}) {
      const localVarPath = `/auth/providers/intuit/disconnect/link`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Create a login token for sizzers api
     * @summary Create a login token for sizzers api
     * @param {string} successReturnUrl Success return url
     * @param {string} errorReturnUrl Error return url
     * @param {boolean} [isAccountant] is accountant flag
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAuthProvidersIntuitLink: (_0, _1, _2, ..._3) => __async(this, [_0, _1, _2, ..._3], function* (successReturnUrl, errorReturnUrl, isAccountant, options = {}) {
      assertParamExists("getAuthProvidersIntuitLink", "successReturnUrl", successReturnUrl);
      assertParamExists("getAuthProvidersIntuitLink", "errorReturnUrl", errorReturnUrl);
      const localVarPath = `/auth/providers/intuit/link`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      if (successReturnUrl !== void 0) {
        localVarQueryParameter["successReturnUrl"] = successReturnUrl;
      }
      if (errorReturnUrl !== void 0) {
        localVarQueryParameter["errorReturnUrl"] = errorReturnUrl;
      }
      if (isAccountant !== void 0) {
        localVarQueryParameter["isAccountant"] = isAccountant;
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Redirect to provider\'s consent screen
     * @summary Redirect to provider\'s consent screen
     * @param {PartnerName} partnerName partner name
     * @param {string} [externalOrganizationId] external organization id
     * @param {string} [redirectUri] redirect uri
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAuthProvidersProviderRedirect: (_0, _1, _2, ..._3) => __async(this, [_0, _1, _2, ..._3], function* (partnerName, externalOrganizationId, redirectUri, options = {}) {
      assertParamExists("getAuthProvidersProviderRedirect", "partnerName", partnerName);
      const localVarPath = `/auth/providers/{partnerName}/start`.replace(`{${"partnerName"}}`, encodeURIComponent(String(partnerName)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      if (externalOrganizationId !== void 0) {
        localVarQueryParameter["external_organization_id"] = externalOrganizationId;
      }
      if (redirectUri !== void 0) {
        localVarQueryParameter["redirect_uri"] = redirectUri;
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * 
     * @summary Validate shopify\'s callback request and redirect to shopify-app
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAuthProvidersShopifyCallback: (..._0) => __async(this, [..._0], function* (options = {}) {
      const localVarPath = `/auth/providers/shopify/callback`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * 
     * @summary Get shopify status for shop
     * @param {string} data 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAuthProvidersShopifyStatus: (_0, ..._1) => __async(this, [_0, ..._1], function* (data, options = {}) {
      assertParamExists("getAuthProvidersShopifyStatus", "data", data);
      const localVarPath = `/auth/providers/shopify/status`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      if (data !== void 0) {
        localVarQueryParameter["data"] = data;
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Get correct current time for token validation.
     * @summary Get current time
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getHealthData: (..._0) => __async(this, [..._0], function* (options = {}) {
      const localVarPath = `/auth/health`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Serve JWKS public key for fiserv
     * @summary JWKS public key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getJwksPublicKey: (..._0) => __async(this, [..._0], function* (options = {}) {
      const localVarPath = `/auth/providers/fiserv/json-web-key-set/public-key`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * 
     * @summary Get all the roles of the current partner and the permissions policy of the current user.
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPermissions: (_0, ..._1) => __async(this, [_0, ..._1], function* (melioAccount, options = {}) {
      const localVarPath = `/permissions`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Exchange an action token with an access token
     * @summary Exchange action token with an access token
     * @param {PostAuthActionTokenExchangeRequest} [postAuthActionTokenExchangeRequest] Send email verification code data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postAuthActionTokenExchange: (_0, ..._1) => __async(this, [_0, ..._1], function* (postAuthActionTokenExchangeRequest, options = {}) {
      const localVarPath = `/auth/action/token/exchange`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postAuthActionTokenExchangeRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * A callback partners SSO flow
     * @summary A callback partners SSO flow
     * @param {PostAuthSsoRequest} [postAuthSsoRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postAuthOauth2Register: (_0, ..._1) => __async(this, [_0, ..._1], function* (postAuthSsoRequest, options = {}) {
      const localVarPath = `/auth/oauth2/register`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postAuthSsoRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * A callback to exchange short term token to long term token access
     * @summary A callback to exchange short term token to long term token access
     * @param {PostAuthProviderCallbackCapitalOneRequest} [postAuthProviderCallbackCapitalOneRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postAuthProvidersCapitaloneCallback: (_0, ..._1) => __async(this, [_0, ..._1], function* (postAuthProviderCallbackCapitalOneRequest, options = {}) {
      const localVarPath = `/auth/providers/capital-one/callback`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postAuthProviderCallbackCapitalOneRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * A callback to exchange short term token to long term token access
     * @summary A callback to exchange short term token to long term token access
     * @param {PostAuthProviderCallbackCloverRequest} [postAuthProviderCallbackCloverRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postAuthProvidersCloverCallback: (_0, ..._1) => __async(this, [_0, ..._1], function* (postAuthProviderCallbackCloverRequest, options = {}) {
      const localVarPath = `/auth/providers/clover/callback`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postAuthProviderCallbackCloverRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * A callback to exchange short term token to long term token access
     * @summary A callback to exchange short term token to long term token access
     * @param {PostAuthProviderCallbackFiservRequest} [postAuthProviderCallbackFiservRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postAuthProvidersFiservCallback: (_0, ..._1) => __async(this, [_0, ..._1], function* (postAuthProviderCallbackFiservRequest, options = {}) {
      const localVarPath = `/auth/providers/fiserv/callback`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postAuthProviderCallbackFiservRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * A callback to exchange short term token to long term token access
     * @summary A callback to exchange short term token to long term token access
     * @param {PostAuthProviderCallbackMelioRequest} [postAuthProviderCallbackMelioRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postAuthProvidersMelioCallback: (_0, ..._1) => __async(this, [_0, ..._1], function* (postAuthProviderCallbackMelioRequest, options = {}) {
      const localVarPath = `/auth/providers/melio/callback`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postAuthProviderCallbackMelioRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Logout from melio com
     * @summary Logout from melio com
     * @param {object} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postAuthProvidersMelioLogout: (_0, ..._1) => __async(this, [_0, ..._1], function* (body, options = {}) {
      const localVarPath = `/auth/providers/melio/logout`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * A callback to exchange short term token to long term token access
     * @summary A callback to exchange short term token to long term token access for paypal provider
     * @param {PostAuthProviderCallbackPaypalRequest} [postAuthProviderCallbackPaypalRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postAuthProvidersPaypalCallback: (_0, ..._1) => __async(this, [_0, ..._1], function* (postAuthProviderCallbackPaypalRequest, options = {}) {
      const localVarPath = `/auth/providers/paypal/callback`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postAuthProviderCallbackPaypalRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * 
     * @summary A callback to exchange short term token to long term token access
     * @param {PostAuthProviderCallbackShopifyRequest} [postAuthProviderCallbackShopifyRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postAuthProvidersShopifyCallback: (_0, ..._1) => __async(this, [_0, ..._1], function* (postAuthProviderCallbackShopifyRequest, options = {}) {
      const localVarPath = `/auth/providers/shopify/callback`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postAuthProviderCallbackShopifyRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * A callback to exchange short term token to long term token access
     * @summary A callback to exchange short term token to long term token access for standard provider
     * @param {PostAuthProviderCallbackStandardRequest} [postAuthProviderCallbackStandardRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postAuthProvidersStandardCallback: (_0, ..._1) => __async(this, [_0, ..._1], function* (postAuthProviderCallbackStandardRequest, options = {}) {
      const localVarPath = `/auth/providers/standard/callback`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postAuthProviderCallbackStandardRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * This operation resolves email verification code for a given email and code
     * @summary Resolve email verification code
     * @param {PostResolveEmailVerificationCodeRequest} [postResolveEmailVerificationCodeRequest] Resolve email verification code data
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postAuthResolveEmailValidationCode: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (postResolveEmailVerificationCodeRequest, idempotencyKey, options = {}) {
      const localVarPath = `/auth/resolve-email-validation-code`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      if (idempotencyKey !== void 0 && idempotencyKey !== null) {
        localVarHeaderParameter["Idempotency-Key"] = String(idempotencyKey);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postResolveEmailVerificationCodeRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * This operation sends email verification code to a given email
     * @summary Send email verification code
     * @param {PostSendEmailVerificationCodeRequest} [postSendEmailVerificationCodeRequest] Send email verification code data
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postAuthSendEmailValidationCode: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (postSendEmailVerificationCodeRequest, idempotencyKey, options = {}) {
      const localVarPath = `/auth/send-email-validation-code`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      if (idempotencyKey !== void 0 && idempotencyKey !== null) {
        localVarHeaderParameter["Idempotency-Key"] = String(idempotencyKey);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postSendEmailVerificationCodeRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * This operation changes the active organization
     * @summary Change the active organization
     * @param {string} id ID of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postAuthSwitchOrganization: (_0, ..._1) => __async(this, [_0, ..._1], function* (id, options = {}) {
      assertParamExists("postAuthSwitchOrganization", "id", id);
      const localVarPath = `/auth/switch-organization/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Create an access token that is scoped to a specific Account, and that can be used for client-side API calls. This is used to perform operations that require the user\'s involvment, without exposing the Partner\'s secret API key.
     * @summary Create an access token
     * @param {PostAuthTokenRequest} [postAuthTokenRequest] Create account access token
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postAuthToken: (_0, _1, _2, ..._3) => __async(this, [_0, _1, _2, ..._3], function* (postAuthTokenRequest, idempotencyKey, melioAccount, options = {}) {
      const localVarPath = `/auth/token`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (idempotencyKey !== void 0 && idempotencyKey !== null) {
        localVarHeaderParameter["Idempotency-Key"] = String(idempotencyKey);
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postAuthTokenRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Refreshes an access token that is scoped to a specific Account, and that can be used for client-side API calls.
     * @summary Refreshes an access token
     * @param {RefreshAccessTokenParameters} refreshAccessTokenParameters Token exchange data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postAuthTokenRefresh: (_0, ..._1) => __async(this, [_0, ..._1], function* (refreshAccessTokenParameters, options = {}) {
      assertParamExists("postAuthTokenRefresh", "refreshAccessTokenParameters", refreshAccessTokenParameters);
      const localVarPath = `/auth/token/refresh`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(refreshAccessTokenParameters, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * This route validates the email and validation code, and if successful returns an auth JWT
     * @summary Validate the email and 2FA code and return a JWT if valid
     * @param {PostValidateEmailCodeLoginRequest} [postValidateEmailCodeLoginRequest] Send email verification code data
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postAuthVerificationCode: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (postValidateEmailCodeLoginRequest, idempotencyKey, options = {}) {
      const localVarPath = `/auth/verification/code`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      if (idempotencyKey !== void 0 && idempotencyKey !== null) {
        localVarHeaderParameter["Idempotency-Key"] = String(idempotencyKey);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postValidateEmailCodeLoginRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    })
  };
};
var AuthApiFp = function(configuration) {
  const localVarAxiosParamCreator = AuthApiAxiosParamCreator(configuration);
  return {
    /**
     * Create an intuit disconect link for sizzers api
     * @summary Create an intuit disconnect params
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAuthProvidersIntuitDisconnectLink(options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getAuthProvidersIntuitDisconnectLink(options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Create a login token for sizzers api
     * @summary Create a login token for sizzers api
     * @param {string} successReturnUrl Success return url
     * @param {string} errorReturnUrl Error return url
     * @param {boolean} [isAccountant] is accountant flag
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAuthProvidersIntuitLink(successReturnUrl, errorReturnUrl, isAccountant, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getAuthProvidersIntuitLink(successReturnUrl, errorReturnUrl, isAccountant, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Redirect to provider\'s consent screen
     * @summary Redirect to provider\'s consent screen
     * @param {PartnerName} partnerName partner name
     * @param {string} [externalOrganizationId] external organization id
     * @param {string} [redirectUri] redirect uri
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAuthProvidersProviderRedirect(partnerName, externalOrganizationId, redirectUri, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getAuthProvidersProviderRedirect(partnerName, externalOrganizationId, redirectUri, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * 
     * @summary Validate shopify\'s callback request and redirect to shopify-app
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAuthProvidersShopifyCallback(options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getAuthProvidersShopifyCallback(options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * 
     * @summary Get shopify status for shop
     * @param {string} data 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAuthProvidersShopifyStatus(data, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getAuthProvidersShopifyStatus(data, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Get correct current time for token validation.
     * @summary Get current time
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getHealthData(options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getHealthData(options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Serve JWKS public key for fiserv
     * @summary JWKS public key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getJwksPublicKey(options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getJwksPublicKey(options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * 
     * @summary Get all the roles of the current partner and the permissions policy of the current user.
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPermissions(melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getPermissions(melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Exchange an action token with an access token
     * @summary Exchange action token with an access token
     * @param {PostAuthActionTokenExchangeRequest} [postAuthActionTokenExchangeRequest] Send email verification code data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postAuthActionTokenExchange(postAuthActionTokenExchangeRequest, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postAuthActionTokenExchange(postAuthActionTokenExchangeRequest, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * A callback partners SSO flow
     * @summary A callback partners SSO flow
     * @param {PostAuthSsoRequest} [postAuthSsoRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postAuthOauth2Register(postAuthSsoRequest, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postAuthOauth2Register(postAuthSsoRequest, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * A callback to exchange short term token to long term token access
     * @summary A callback to exchange short term token to long term token access
     * @param {PostAuthProviderCallbackCapitalOneRequest} [postAuthProviderCallbackCapitalOneRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postAuthProvidersCapitaloneCallback(postAuthProviderCallbackCapitalOneRequest, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postAuthProvidersCapitaloneCallback(postAuthProviderCallbackCapitalOneRequest, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * A callback to exchange short term token to long term token access
     * @summary A callback to exchange short term token to long term token access
     * @param {PostAuthProviderCallbackCloverRequest} [postAuthProviderCallbackCloverRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postAuthProvidersCloverCallback(postAuthProviderCallbackCloverRequest, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postAuthProvidersCloverCallback(postAuthProviderCallbackCloverRequest, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * A callback to exchange short term token to long term token access
     * @summary A callback to exchange short term token to long term token access
     * @param {PostAuthProviderCallbackFiservRequest} [postAuthProviderCallbackFiservRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postAuthProvidersFiservCallback(postAuthProviderCallbackFiservRequest, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postAuthProvidersFiservCallback(postAuthProviderCallbackFiservRequest, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * A callback to exchange short term token to long term token access
     * @summary A callback to exchange short term token to long term token access
     * @param {PostAuthProviderCallbackMelioRequest} [postAuthProviderCallbackMelioRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postAuthProvidersMelioCallback(postAuthProviderCallbackMelioRequest, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postAuthProvidersMelioCallback(postAuthProviderCallbackMelioRequest, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Logout from melio com
     * @summary Logout from melio com
     * @param {object} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postAuthProvidersMelioLogout(body, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postAuthProvidersMelioLogout(body, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * A callback to exchange short term token to long term token access
     * @summary A callback to exchange short term token to long term token access for paypal provider
     * @param {PostAuthProviderCallbackPaypalRequest} [postAuthProviderCallbackPaypalRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postAuthProvidersPaypalCallback(postAuthProviderCallbackPaypalRequest, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postAuthProvidersPaypalCallback(postAuthProviderCallbackPaypalRequest, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * 
     * @summary A callback to exchange short term token to long term token access
     * @param {PostAuthProviderCallbackShopifyRequest} [postAuthProviderCallbackShopifyRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postAuthProvidersShopifyCallback(postAuthProviderCallbackShopifyRequest, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postAuthProvidersShopifyCallback(postAuthProviderCallbackShopifyRequest, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * A callback to exchange short term token to long term token access
     * @summary A callback to exchange short term token to long term token access for standard provider
     * @param {PostAuthProviderCallbackStandardRequest} [postAuthProviderCallbackStandardRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postAuthProvidersStandardCallback(postAuthProviderCallbackStandardRequest, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postAuthProvidersStandardCallback(postAuthProviderCallbackStandardRequest, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * This operation resolves email verification code for a given email and code
     * @summary Resolve email verification code
     * @param {PostResolveEmailVerificationCodeRequest} [postResolveEmailVerificationCodeRequest] Resolve email verification code data
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postAuthResolveEmailValidationCode(postResolveEmailVerificationCodeRequest, idempotencyKey, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postAuthResolveEmailValidationCode(postResolveEmailVerificationCodeRequest, idempotencyKey, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * This operation sends email verification code to a given email
     * @summary Send email verification code
     * @param {PostSendEmailVerificationCodeRequest} [postSendEmailVerificationCodeRequest] Send email verification code data
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postAuthSendEmailValidationCode(postSendEmailVerificationCodeRequest, idempotencyKey, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postAuthSendEmailValidationCode(postSendEmailVerificationCodeRequest, idempotencyKey, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * This operation changes the active organization
     * @summary Change the active organization
     * @param {string} id ID of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postAuthSwitchOrganization(id, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postAuthSwitchOrganization(id, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Create an access token that is scoped to a specific Account, and that can be used for client-side API calls. This is used to perform operations that require the user\'s involvment, without exposing the Partner\'s secret API key.
     * @summary Create an access token
     * @param {PostAuthTokenRequest} [postAuthTokenRequest] Create account access token
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postAuthToken(postAuthTokenRequest, idempotencyKey, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postAuthToken(postAuthTokenRequest, idempotencyKey, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Refreshes an access token that is scoped to a specific Account, and that can be used for client-side API calls.
     * @summary Refreshes an access token
     * @param {RefreshAccessTokenParameters} refreshAccessTokenParameters Token exchange data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postAuthTokenRefresh(refreshAccessTokenParameters, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postAuthTokenRefresh(refreshAccessTokenParameters, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * This route validates the email and validation code, and if successful returns an auth JWT
     * @summary Validate the email and 2FA code and return a JWT if valid
     * @param {PostValidateEmailCodeLoginRequest} [postValidateEmailCodeLoginRequest] Send email verification code data
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postAuthVerificationCode(postValidateEmailCodeLoginRequest, idempotencyKey, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postAuthVerificationCode(postValidateEmailCodeLoginRequest, idempotencyKey, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    }
  };
};
var AuthApiClient = createApiFromFp(AuthApiFp);
var AuthApiFactory = function(configuration, basePath, axios2) {
  const localVarFp = AuthApiFp(configuration);
  return {
    /**
     * Create an intuit disconect link for sizzers api
     * @summary Create an intuit disconnect params
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAuthProvidersIntuitDisconnectLink(options) {
      return localVarFp.getAuthProvidersIntuitDisconnectLink(options).then((request) => request(axios2, basePath));
    },
    /**
     * Create a login token for sizzers api
     * @summary Create a login token for sizzers api
     * @param {string} successReturnUrl Success return url
     * @param {string} errorReturnUrl Error return url
     * @param {boolean} [isAccountant] is accountant flag
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAuthProvidersIntuitLink(successReturnUrl, errorReturnUrl, isAccountant, options) {
      return localVarFp.getAuthProvidersIntuitLink(successReturnUrl, errorReturnUrl, isAccountant, options).then((request) => request(axios2, basePath));
    },
    /**
     * Redirect to provider\'s consent screen
     * @summary Redirect to provider\'s consent screen
     * @param {PartnerName} partnerName partner name
     * @param {string} [externalOrganizationId] external organization id
     * @param {string} [redirectUri] redirect uri
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAuthProvidersProviderRedirect(partnerName, externalOrganizationId, redirectUri, options) {
      return localVarFp.getAuthProvidersProviderRedirect(partnerName, externalOrganizationId, redirectUri, options).then((request) => request(axios2, basePath));
    },
    /**
     * 
     * @summary Validate shopify\'s callback request and redirect to shopify-app
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAuthProvidersShopifyCallback(options) {
      return localVarFp.getAuthProvidersShopifyCallback(options).then((request) => request(axios2, basePath));
    },
    /**
     * 
     * @summary Get shopify status for shop
     * @param {string} data 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAuthProvidersShopifyStatus(data, options) {
      return localVarFp.getAuthProvidersShopifyStatus(data, options).then((request) => request(axios2, basePath));
    },
    /**
     * Get correct current time for token validation.
     * @summary Get current time
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getHealthData(options) {
      return localVarFp.getHealthData(options).then((request) => request(axios2, basePath));
    },
    /**
     * Serve JWKS public key for fiserv
     * @summary JWKS public key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getJwksPublicKey(options) {
      return localVarFp.getJwksPublicKey(options).then((request) => request(axios2, basePath));
    },
    /**
     * 
     * @summary Get all the roles of the current partner and the permissions policy of the current user.
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPermissions(melioAccount, options) {
      return localVarFp.getPermissions(melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Exchange an action token with an access token
     * @summary Exchange action token with an access token
     * @param {PostAuthActionTokenExchangeRequest} [postAuthActionTokenExchangeRequest] Send email verification code data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postAuthActionTokenExchange(postAuthActionTokenExchangeRequest, options) {
      return localVarFp.postAuthActionTokenExchange(postAuthActionTokenExchangeRequest, options).then((request) => request(axios2, basePath));
    },
    /**
     * A callback partners SSO flow
     * @summary A callback partners SSO flow
     * @param {PostAuthSsoRequest} [postAuthSsoRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postAuthOauth2Register(postAuthSsoRequest, options) {
      return localVarFp.postAuthOauth2Register(postAuthSsoRequest, options).then((request) => request(axios2, basePath));
    },
    /**
     * A callback to exchange short term token to long term token access
     * @summary A callback to exchange short term token to long term token access
     * @param {PostAuthProviderCallbackCapitalOneRequest} [postAuthProviderCallbackCapitalOneRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postAuthProvidersCapitaloneCallback(postAuthProviderCallbackCapitalOneRequest, options) {
      return localVarFp.postAuthProvidersCapitaloneCallback(postAuthProviderCallbackCapitalOneRequest, options).then((request) => request(axios2, basePath));
    },
    /**
     * A callback to exchange short term token to long term token access
     * @summary A callback to exchange short term token to long term token access
     * @param {PostAuthProviderCallbackCloverRequest} [postAuthProviderCallbackCloverRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postAuthProvidersCloverCallback(postAuthProviderCallbackCloverRequest, options) {
      return localVarFp.postAuthProvidersCloverCallback(postAuthProviderCallbackCloverRequest, options).then((request) => request(axios2, basePath));
    },
    /**
     * A callback to exchange short term token to long term token access
     * @summary A callback to exchange short term token to long term token access
     * @param {PostAuthProviderCallbackFiservRequest} [postAuthProviderCallbackFiservRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postAuthProvidersFiservCallback(postAuthProviderCallbackFiservRequest, options) {
      return localVarFp.postAuthProvidersFiservCallback(postAuthProviderCallbackFiservRequest, options).then((request) => request(axios2, basePath));
    },
    /**
     * A callback to exchange short term token to long term token access
     * @summary A callback to exchange short term token to long term token access
     * @param {PostAuthProviderCallbackMelioRequest} [postAuthProviderCallbackMelioRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postAuthProvidersMelioCallback(postAuthProviderCallbackMelioRequest, options) {
      return localVarFp.postAuthProvidersMelioCallback(postAuthProviderCallbackMelioRequest, options).then((request) => request(axios2, basePath));
    },
    /**
     * Logout from melio com
     * @summary Logout from melio com
     * @param {object} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postAuthProvidersMelioLogout(body, options) {
      return localVarFp.postAuthProvidersMelioLogout(body, options).then((request) => request(axios2, basePath));
    },
    /**
     * A callback to exchange short term token to long term token access
     * @summary A callback to exchange short term token to long term token access for paypal provider
     * @param {PostAuthProviderCallbackPaypalRequest} [postAuthProviderCallbackPaypalRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postAuthProvidersPaypalCallback(postAuthProviderCallbackPaypalRequest, options) {
      return localVarFp.postAuthProvidersPaypalCallback(postAuthProviderCallbackPaypalRequest, options).then((request) => request(axios2, basePath));
    },
    /**
     * 
     * @summary A callback to exchange short term token to long term token access
     * @param {PostAuthProviderCallbackShopifyRequest} [postAuthProviderCallbackShopifyRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postAuthProvidersShopifyCallback(postAuthProviderCallbackShopifyRequest, options) {
      return localVarFp.postAuthProvidersShopifyCallback(postAuthProviderCallbackShopifyRequest, options).then((request) => request(axios2, basePath));
    },
    /**
     * A callback to exchange short term token to long term token access
     * @summary A callback to exchange short term token to long term token access for standard provider
     * @param {PostAuthProviderCallbackStandardRequest} [postAuthProviderCallbackStandardRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postAuthProvidersStandardCallback(postAuthProviderCallbackStandardRequest, options) {
      return localVarFp.postAuthProvidersStandardCallback(postAuthProviderCallbackStandardRequest, options).then((request) => request(axios2, basePath));
    },
    /**
     * This operation resolves email verification code for a given email and code
     * @summary Resolve email verification code
     * @param {PostResolveEmailVerificationCodeRequest} [postResolveEmailVerificationCodeRequest] Resolve email verification code data
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postAuthResolveEmailValidationCode(postResolveEmailVerificationCodeRequest, idempotencyKey, options) {
      return localVarFp.postAuthResolveEmailValidationCode(postResolveEmailVerificationCodeRequest, idempotencyKey, options).then((request) => request(axios2, basePath));
    },
    /**
     * This operation sends email verification code to a given email
     * @summary Send email verification code
     * @param {PostSendEmailVerificationCodeRequest} [postSendEmailVerificationCodeRequest] Send email verification code data
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postAuthSendEmailValidationCode(postSendEmailVerificationCodeRequest, idempotencyKey, options) {
      return localVarFp.postAuthSendEmailValidationCode(postSendEmailVerificationCodeRequest, idempotencyKey, options).then((request) => request(axios2, basePath));
    },
    /**
     * This operation changes the active organization
     * @summary Change the active organization
     * @param {string} id ID of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postAuthSwitchOrganization(id, options) {
      return localVarFp.postAuthSwitchOrganization(id, options).then((request) => request(axios2, basePath));
    },
    /**
     * Create an access token that is scoped to a specific Account, and that can be used for client-side API calls. This is used to perform operations that require the user\'s involvment, without exposing the Partner\'s secret API key.
     * @summary Create an access token
     * @param {PostAuthTokenRequest} [postAuthTokenRequest] Create account access token
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postAuthToken(postAuthTokenRequest, idempotencyKey, melioAccount, options) {
      return localVarFp.postAuthToken(postAuthTokenRequest, idempotencyKey, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Refreshes an access token that is scoped to a specific Account, and that can be used for client-side API calls.
     * @summary Refreshes an access token
     * @param {RefreshAccessTokenParameters} refreshAccessTokenParameters Token exchange data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postAuthTokenRefresh(refreshAccessTokenParameters, options) {
      return localVarFp.postAuthTokenRefresh(refreshAccessTokenParameters, options).then((request) => request(axios2, basePath));
    },
    /**
     * This route validates the email and validation code, and if successful returns an auth JWT
     * @summary Validate the email and 2FA code and return a JWT if valid
     * @param {PostValidateEmailCodeLoginRequest} [postValidateEmailCodeLoginRequest] Send email verification code data
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postAuthVerificationCode(postValidateEmailCodeLoginRequest, idempotencyKey, options) {
      return localVarFp.postAuthVerificationCode(postValidateEmailCodeLoginRequest, idempotencyKey, options).then((request) => request(axios2, basePath));
    }
  };
};
var AuthApi = class extends BaseAPI {
  /**
   * Create an intuit disconect link for sizzers api
   * @summary Create an intuit disconnect params
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthApi
   */
  getAuthProvidersIntuitDisconnectLink(options) {
    return AuthApiFp(this.configuration).getAuthProvidersIntuitDisconnectLink(options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Create a login token for sizzers api
   * @summary Create a login token for sizzers api
   * @param {AuthApiGetAuthProvidersIntuitLinkRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthApi
   */
  getAuthProvidersIntuitLink(requestParameters, options) {
    return AuthApiFp(this.configuration).getAuthProvidersIntuitLink(requestParameters.successReturnUrl, requestParameters.errorReturnUrl, requestParameters.isAccountant, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Redirect to provider\'s consent screen
   * @summary Redirect to provider\'s consent screen
   * @param {AuthApiGetAuthProvidersProviderRedirectRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthApi
   */
  getAuthProvidersProviderRedirect(requestParameters, options) {
    return AuthApiFp(this.configuration).getAuthProvidersProviderRedirect(requestParameters.partnerName, requestParameters.externalOrganizationId, requestParameters.redirectUri, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Validate shopify\'s callback request and redirect to shopify-app
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthApi
   */
  getAuthProvidersShopifyCallback(options) {
    return AuthApiFp(this.configuration).getAuthProvidersShopifyCallback(options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Get shopify status for shop
   * @param {AuthApiGetAuthProvidersShopifyStatusRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthApi
   */
  getAuthProvidersShopifyStatus(requestParameters, options) {
    return AuthApiFp(this.configuration).getAuthProvidersShopifyStatus(requestParameters.data, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Get correct current time for token validation.
   * @summary Get current time
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthApi
   */
  getHealthData(options) {
    return AuthApiFp(this.configuration).getHealthData(options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Serve JWKS public key for fiserv
   * @summary JWKS public key
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthApi
   */
  getJwksPublicKey(options) {
    return AuthApiFp(this.configuration).getJwksPublicKey(options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Get all the roles of the current partner and the permissions policy of the current user.
   * @param {AuthApiGetPermissionsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthApi
   */
  getPermissions(requestParameters = {}, options) {
    return AuthApiFp(this.configuration).getPermissions(requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Exchange an action token with an access token
   * @summary Exchange action token with an access token
   * @param {AuthApiPostAuthActionTokenExchangeRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthApi
   */
  postAuthActionTokenExchange(requestParameters = {}, options) {
    return AuthApiFp(this.configuration).postAuthActionTokenExchange(requestParameters.postAuthActionTokenExchangeRequest, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * A callback partners SSO flow
   * @summary A callback partners SSO flow
   * @param {AuthApiPostAuthOauth2RegisterRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthApi
   */
  postAuthOauth2Register(requestParameters = {}, options) {
    return AuthApiFp(this.configuration).postAuthOauth2Register(requestParameters.postAuthSsoRequest, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * A callback to exchange short term token to long term token access
   * @summary A callback to exchange short term token to long term token access
   * @param {AuthApiPostAuthProvidersCapitaloneCallbackRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthApi
   */
  postAuthProvidersCapitaloneCallback(requestParameters = {}, options) {
    return AuthApiFp(this.configuration).postAuthProvidersCapitaloneCallback(requestParameters.postAuthProviderCallbackCapitalOneRequest, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * A callback to exchange short term token to long term token access
   * @summary A callback to exchange short term token to long term token access
   * @param {AuthApiPostAuthProvidersCloverCallbackRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthApi
   */
  postAuthProvidersCloverCallback(requestParameters = {}, options) {
    return AuthApiFp(this.configuration).postAuthProvidersCloverCallback(requestParameters.postAuthProviderCallbackCloverRequest, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * A callback to exchange short term token to long term token access
   * @summary A callback to exchange short term token to long term token access
   * @param {AuthApiPostAuthProvidersFiservCallbackRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthApi
   */
  postAuthProvidersFiservCallback(requestParameters = {}, options) {
    return AuthApiFp(this.configuration).postAuthProvidersFiservCallback(requestParameters.postAuthProviderCallbackFiservRequest, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * A callback to exchange short term token to long term token access
   * @summary A callback to exchange short term token to long term token access
   * @param {AuthApiPostAuthProvidersMelioCallbackRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthApi
   */
  postAuthProvidersMelioCallback(requestParameters = {}, options) {
    return AuthApiFp(this.configuration).postAuthProvidersMelioCallback(requestParameters.postAuthProviderCallbackMelioRequest, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Logout from melio com
   * @summary Logout from melio com
   * @param {AuthApiPostAuthProvidersMelioLogoutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthApi
   */
  postAuthProvidersMelioLogout(requestParameters = {}, options) {
    return AuthApiFp(this.configuration).postAuthProvidersMelioLogout(requestParameters.body, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * A callback to exchange short term token to long term token access
   * @summary A callback to exchange short term token to long term token access for paypal provider
   * @param {AuthApiPostAuthProvidersPaypalCallbackRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthApi
   */
  postAuthProvidersPaypalCallback(requestParameters = {}, options) {
    return AuthApiFp(this.configuration).postAuthProvidersPaypalCallback(requestParameters.postAuthProviderCallbackPaypalRequest, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * 
   * @summary A callback to exchange short term token to long term token access
   * @param {AuthApiPostAuthProvidersShopifyCallbackRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthApi
   */
  postAuthProvidersShopifyCallback(requestParameters = {}, options) {
    return AuthApiFp(this.configuration).postAuthProvidersShopifyCallback(requestParameters.postAuthProviderCallbackShopifyRequest, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * A callback to exchange short term token to long term token access
   * @summary A callback to exchange short term token to long term token access for standard provider
   * @param {AuthApiPostAuthProvidersStandardCallbackRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthApi
   */
  postAuthProvidersStandardCallback(requestParameters = {}, options) {
    return AuthApiFp(this.configuration).postAuthProvidersStandardCallback(requestParameters.postAuthProviderCallbackStandardRequest, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * This operation resolves email verification code for a given email and code
   * @summary Resolve email verification code
   * @param {AuthApiPostAuthResolveEmailValidationCodeRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthApi
   */
  postAuthResolveEmailValidationCode(requestParameters = {}, options) {
    return AuthApiFp(this.configuration).postAuthResolveEmailValidationCode(requestParameters.postResolveEmailVerificationCodeRequest, requestParameters.idempotencyKey, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * This operation sends email verification code to a given email
   * @summary Send email verification code
   * @param {AuthApiPostAuthSendEmailValidationCodeRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthApi
   */
  postAuthSendEmailValidationCode(requestParameters = {}, options) {
    return AuthApiFp(this.configuration).postAuthSendEmailValidationCode(requestParameters.postSendEmailVerificationCodeRequest, requestParameters.idempotencyKey, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * This operation changes the active organization
   * @summary Change the active organization
   * @param {AuthApiPostAuthSwitchOrganizationRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthApi
   */
  postAuthSwitchOrganization(requestParameters, options) {
    return AuthApiFp(this.configuration).postAuthSwitchOrganization(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Create an access token that is scoped to a specific Account, and that can be used for client-side API calls. This is used to perform operations that require the user\'s involvment, without exposing the Partner\'s secret API key.
   * @summary Create an access token
   * @param {AuthApiPostAuthTokenRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthApi
   */
  postAuthToken(requestParameters = {}, options) {
    return AuthApiFp(this.configuration).postAuthToken(requestParameters.postAuthTokenRequest, requestParameters.idempotencyKey, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Refreshes an access token that is scoped to a specific Account, and that can be used for client-side API calls.
   * @summary Refreshes an access token
   * @param {AuthApiPostAuthTokenRefreshRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthApi
   */
  postAuthTokenRefresh(requestParameters, options) {
    return AuthApiFp(this.configuration).postAuthTokenRefresh(requestParameters.refreshAccessTokenParameters, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * This route validates the email and validation code, and if successful returns an auth JWT
   * @summary Validate the email and 2FA code and return a JWT if valid
   * @param {AuthApiPostAuthVerificationCodeRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthApi
   */
  postAuthVerificationCode(requestParameters = {}, options) {
    return AuthApiFp(this.configuration).postAuthVerificationCode(requestParameters.postValidateEmailCodeLoginRequest, requestParameters.idempotencyKey, options).then((request) => request(this.axios, this.basePath));
  }
};
var AuthApiInstance = createInstanceFromApiIClass(AuthApi);
var AutoPayApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * Delete a managed vendor\'s auto payment
     * @summary Delete a managed vendor\'s auto payment
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteAutoPayment: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (id, melioAccount, options = {}) {
      assertParamExists("deleteAutoPayment", "id", id);
      const localVarPath = `/vendors/{id}/auto-payment`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "DELETE" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Get a managed vendor\'s auto payment
     * @summary Get a managed vendor\'s auto payment
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAutoPayment: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (id, melioAccount, options = {}) {
      assertParamExists("getAutoPayment", "id", id);
      const localVarPath = `/vendors/{id}/auto-payment`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Get a managed vendor\'s auto payment options
     * @summary Get a managed vendor\'s auto payment options
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAutoPaymentOptions: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (id, melioAccount, options = {}) {
      assertParamExists("getAutoPaymentOptions", "id", id);
      const localVarPath = `/vendors/{id}/auto-payment/options`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Update a managed vendor\'s auto payment
     * @summary Update a managed vendor\'s auto payment
     * @param {PatchVendorAutoPaymentRequest} patchVendorAutoPaymentRequest 
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchAutoPayment: (_0, _1, _2, ..._3) => __async(this, [_0, _1, _2, ..._3], function* (patchVendorAutoPaymentRequest, id, melioAccount, options = {}) {
      assertParamExists("patchAutoPayment", "patchVendorAutoPaymentRequest", patchVendorAutoPaymentRequest);
      assertParamExists("patchAutoPayment", "id", id);
      const localVarPath = `/vendors/{id}/auto-payment`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "PATCH" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(patchVendorAutoPaymentRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Create a managed vendor\'s auto payment
     * @summary Create a managed vendor\'s auto payment
     * @param {PostVendorAutoPaymentRequest} postVendorAutoPaymentRequest 
     * @param {string} id ID of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postAutoPayment: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (postVendorAutoPaymentRequest, id, options = {}) {
      assertParamExists("postAutoPayment", "postVendorAutoPaymentRequest", postVendorAutoPaymentRequest);
      assertParamExists("postAutoPayment", "id", id);
      const localVarPath = `/vendors/{id}/auto-payment`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postVendorAutoPaymentRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    })
  };
};
var AutoPayApiFp = function(configuration) {
  const localVarAxiosParamCreator = AutoPayApiAxiosParamCreator(configuration);
  return {
    /**
     * Delete a managed vendor\'s auto payment
     * @summary Delete a managed vendor\'s auto payment
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteAutoPayment(id, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteAutoPayment(id, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Get a managed vendor\'s auto payment
     * @summary Get a managed vendor\'s auto payment
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAutoPayment(id, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getAutoPayment(id, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Get a managed vendor\'s auto payment options
     * @summary Get a managed vendor\'s auto payment options
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAutoPaymentOptions(id, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getAutoPaymentOptions(id, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Update a managed vendor\'s auto payment
     * @summary Update a managed vendor\'s auto payment
     * @param {PatchVendorAutoPaymentRequest} patchVendorAutoPaymentRequest 
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchAutoPayment(patchVendorAutoPaymentRequest, id, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.patchAutoPayment(patchVendorAutoPaymentRequest, id, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Create a managed vendor\'s auto payment
     * @summary Create a managed vendor\'s auto payment
     * @param {PostVendorAutoPaymentRequest} postVendorAutoPaymentRequest 
     * @param {string} id ID of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postAutoPayment(postVendorAutoPaymentRequest, id, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postAutoPayment(postVendorAutoPaymentRequest, id, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    }
  };
};
var AutoPayApiClient = createApiFromFp(AutoPayApiFp);
var AutoPayApiFactory = function(configuration, basePath, axios2) {
  const localVarFp = AutoPayApiFp(configuration);
  return {
    /**
     * Delete a managed vendor\'s auto payment
     * @summary Delete a managed vendor\'s auto payment
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteAutoPayment(id, melioAccount, options) {
      return localVarFp.deleteAutoPayment(id, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Get a managed vendor\'s auto payment
     * @summary Get a managed vendor\'s auto payment
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAutoPayment(id, melioAccount, options) {
      return localVarFp.getAutoPayment(id, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Get a managed vendor\'s auto payment options
     * @summary Get a managed vendor\'s auto payment options
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAutoPaymentOptions(id, melioAccount, options) {
      return localVarFp.getAutoPaymentOptions(id, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Update a managed vendor\'s auto payment
     * @summary Update a managed vendor\'s auto payment
     * @param {PatchVendorAutoPaymentRequest} patchVendorAutoPaymentRequest 
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchAutoPayment(patchVendorAutoPaymentRequest, id, melioAccount, options) {
      return localVarFp.patchAutoPayment(patchVendorAutoPaymentRequest, id, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Create a managed vendor\'s auto payment
     * @summary Create a managed vendor\'s auto payment
     * @param {PostVendorAutoPaymentRequest} postVendorAutoPaymentRequest 
     * @param {string} id ID of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postAutoPayment(postVendorAutoPaymentRequest, id, options) {
      return localVarFp.postAutoPayment(postVendorAutoPaymentRequest, id, options).then((request) => request(axios2, basePath));
    }
  };
};
var AutoPayApi = class extends BaseAPI {
  /**
   * Delete a managed vendor\'s auto payment
   * @summary Delete a managed vendor\'s auto payment
   * @param {AutoPayApiDeleteAutoPaymentRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AutoPayApi
   */
  deleteAutoPayment(requestParameters, options) {
    return AutoPayApiFp(this.configuration).deleteAutoPayment(requestParameters.id, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Get a managed vendor\'s auto payment
   * @summary Get a managed vendor\'s auto payment
   * @param {AutoPayApiGetAutoPaymentRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AutoPayApi
   */
  getAutoPayment(requestParameters, options) {
    return AutoPayApiFp(this.configuration).getAutoPayment(requestParameters.id, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Get a managed vendor\'s auto payment options
   * @summary Get a managed vendor\'s auto payment options
   * @param {AutoPayApiGetAutoPaymentOptionsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AutoPayApi
   */
  getAutoPaymentOptions(requestParameters, options) {
    return AutoPayApiFp(this.configuration).getAutoPaymentOptions(requestParameters.id, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Update a managed vendor\'s auto payment
   * @summary Update a managed vendor\'s auto payment
   * @param {AutoPayApiPatchAutoPaymentRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AutoPayApi
   */
  patchAutoPayment(requestParameters, options) {
    return AutoPayApiFp(this.configuration).patchAutoPayment(requestParameters.patchVendorAutoPaymentRequest, requestParameters.id, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Create a managed vendor\'s auto payment
   * @summary Create a managed vendor\'s auto payment
   * @param {AutoPayApiPostAutoPaymentRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AutoPayApi
   */
  postAutoPayment(requestParameters, options) {
    return AutoPayApiFp(this.configuration).postAutoPayment(requestParameters.postVendorAutoPaymentRequest, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
  }
};
var AutoPayApiInstance = createInstanceFromApiIClass(AutoPayApi);
var BankAccountsApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * Create accounting platform bank account
     * @summary Create accounting platform bank account
     * @param {CreateAccountingPlatformBankAccountRequest} [createAccountingPlatformBankAccountRequest] 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createAccountingPlatformBankAccount: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (createAccountingPlatformBankAccountRequest, melioAccount, options = {}) {
      const localVarPath = `/accounting-platforms/bank-accounts`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(createAccountingPlatformBankAccountRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * List of all accounting platform bank accounts
     * @summary List of all accounting platform bank accounts
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAccountingPlatformBankAccounts: (_0, ..._1) => __async(this, [_0, ..._1], function* (melioAccount, options = {}) {
      const localVarPath = `/accounting-platforms/bank-accounts`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Get a `FundingSource` object by your own internal ID number, rather than Melio\'s ID. Ask your Melio account manager the source of this number. This method may not be available for all partners or all funding source types; if not, you will get a 404 response code to your requests. 
     * @summary Get FundingSource by partner\'s internal ID
     * @param {string} id Partner\&#39;s ID for this funding source.
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getFundingSourceIdentify: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (id, expand, options = {}) {
      assertParamExists("getFundingSourceIdentify", "id", id);
      const localVarPath = `/funding-sources/identify`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (expand !== void 0) {
        localVarQueryParameter["expand"] = expand;
      }
      if (id !== void 0) {
        localVarQueryParameter["id"] = id;
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    })
  };
};
var BankAccountsApiFp = function(configuration) {
  const localVarAxiosParamCreator = BankAccountsApiAxiosParamCreator(configuration);
  return {
    /**
     * Create accounting platform bank account
     * @summary Create accounting platform bank account
     * @param {CreateAccountingPlatformBankAccountRequest} [createAccountingPlatformBankAccountRequest] 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createAccountingPlatformBankAccount(createAccountingPlatformBankAccountRequest, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.createAccountingPlatformBankAccount(createAccountingPlatformBankAccountRequest, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * List of all accounting platform bank accounts
     * @summary List of all accounting platform bank accounts
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAccountingPlatformBankAccounts(melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getAccountingPlatformBankAccounts(melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Get a `FundingSource` object by your own internal ID number, rather than Melio\'s ID. Ask your Melio account manager the source of this number. This method may not be available for all partners or all funding source types; if not, you will get a 404 response code to your requests. 
     * @summary Get FundingSource by partner\'s internal ID
     * @param {string} id Partner\&#39;s ID for this funding source.
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getFundingSourceIdentify(id, expand, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getFundingSourceIdentify(id, expand, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    }
  };
};
var BankAccountsApiClient = createApiFromFp(BankAccountsApiFp);
var BankAccountsApiFactory = function(configuration, basePath, axios2) {
  const localVarFp = BankAccountsApiFp(configuration);
  return {
    /**
     * Create accounting platform bank account
     * @summary Create accounting platform bank account
     * @param {CreateAccountingPlatformBankAccountRequest} [createAccountingPlatformBankAccountRequest] 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createAccountingPlatformBankAccount(createAccountingPlatformBankAccountRequest, melioAccount, options) {
      return localVarFp.createAccountingPlatformBankAccount(createAccountingPlatformBankAccountRequest, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * List of all accounting platform bank accounts
     * @summary List of all accounting platform bank accounts
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAccountingPlatformBankAccounts(melioAccount, options) {
      return localVarFp.getAccountingPlatformBankAccounts(melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Get a `FundingSource` object by your own internal ID number, rather than Melio\'s ID. Ask your Melio account manager the source of this number. This method may not be available for all partners or all funding source types; if not, you will get a 404 response code to your requests. 
     * @summary Get FundingSource by partner\'s internal ID
     * @param {string} id Partner\&#39;s ID for this funding source.
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getFundingSourceIdentify(id, expand, options) {
      return localVarFp.getFundingSourceIdentify(id, expand, options).then((request) => request(axios2, basePath));
    }
  };
};
var BankAccountsApi = class extends BaseAPI {
  /**
   * Create accounting platform bank account
   * @summary Create accounting platform bank account
   * @param {BankAccountsApiCreateAccountingPlatformBankAccountRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BankAccountsApi
   */
  createAccountingPlatformBankAccount(requestParameters = {}, options) {
    return BankAccountsApiFp(this.configuration).createAccountingPlatformBankAccount(requestParameters.createAccountingPlatformBankAccountRequest, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * List of all accounting platform bank accounts
   * @summary List of all accounting platform bank accounts
   * @param {BankAccountsApiGetAccountingPlatformBankAccountsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BankAccountsApi
   */
  getAccountingPlatformBankAccounts(requestParameters = {}, options) {
    return BankAccountsApiFp(this.configuration).getAccountingPlatformBankAccounts(requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Get a `FundingSource` object by your own internal ID number, rather than Melio\'s ID. Ask your Melio account manager the source of this number. This method may not be available for all partners or all funding source types; if not, you will get a 404 response code to your requests. 
   * @summary Get FundingSource by partner\'s internal ID
   * @param {BankAccountsApiGetFundingSourceIdentifyRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BankAccountsApi
   */
  getFundingSourceIdentify(requestParameters, options) {
    return BankAccountsApiFp(this.configuration).getFundingSourceIdentify(requestParameters.id, requestParameters.expand, options).then((request) => request(this.axios, this.basePath));
  }
};
var BankAccountsApiInstance = createInstanceFromApiIClass(BankAccountsApi);
var BillApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * Create bill and scheduled payment for authenticated guest payor by payment request in order to pay a payment
     * @summary Create bill and scheduled payment for authenticated guest payor by payment request in order to pay a payment
     * @param {PostPayorPayPaymentRequest} [postPayorPayPaymentRequest] Provide payment request link and funding source id to allow payor to pay
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postPayorPayPayment: (_0, ..._1) => __async(this, [_0, ..._1], function* (postPayorPayPaymentRequest, options = {}) {
      const localVarPath = `/account-receivable/payor/pay`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postPayorPayPaymentRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    })
  };
};
var BillApiFp = function(configuration) {
  const localVarAxiosParamCreator = BillApiAxiosParamCreator(configuration);
  return {
    /**
     * Create bill and scheduled payment for authenticated guest payor by payment request in order to pay a payment
     * @summary Create bill and scheduled payment for authenticated guest payor by payment request in order to pay a payment
     * @param {PostPayorPayPaymentRequest} [postPayorPayPaymentRequest] Provide payment request link and funding source id to allow payor to pay
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postPayorPayPayment(postPayorPayPaymentRequest, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postPayorPayPayment(postPayorPayPaymentRequest, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    }
  };
};
var BillApiClient = createApiFromFp(BillApiFp);
var BillApiFactory = function(configuration, basePath, axios2) {
  const localVarFp = BillApiFp(configuration);
  return {
    /**
     * Create bill and scheduled payment for authenticated guest payor by payment request in order to pay a payment
     * @summary Create bill and scheduled payment for authenticated guest payor by payment request in order to pay a payment
     * @param {PostPayorPayPaymentRequest} [postPayorPayPaymentRequest] Provide payment request link and funding source id to allow payor to pay
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postPayorPayPayment(postPayorPayPaymentRequest, options) {
      return localVarFp.postPayorPayPayment(postPayorPayPaymentRequest, options).then((request) => request(axios2, basePath));
    }
  };
};
var BillApi = class extends BaseAPI {
  /**
   * Create bill and scheduled payment for authenticated guest payor by payment request in order to pay a payment
   * @summary Create bill and scheduled payment for authenticated guest payor by payment request in order to pay a payment
   * @param {BillApiPostPayorPayPaymentRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BillApi
   */
  postPayorPayPayment(requestParameters = {}, options) {
    return BillApiFp(this.configuration).postPayorPayPayment(requestParameters.postPayorPayPaymentRequest, options).then((request) => request(this.axios, this.basePath));
  }
};
var BillApiInstance = createInstanceFromApiIClass(BillApi);
var BillSubscriptionsApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * List of bill-subscriptions
     * @summary Retrieve all bill-subscriptions
     * @param {string} [q] search data
     * @param {number} [start] The number of items to include in the returned list
     * @param {number} [limit] The number of items to include in the returned list
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBillSubscriptions: (_0, _1, _2, _3, ..._4) => __async(this, [_0, _1, _2, _3, ..._4], function* (q, start, limit, expand, options = {}) {
      const localVarPath = `/bill-subscriptions`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (q !== void 0) {
        localVarQueryParameter["q"] = q;
      }
      if (start !== void 0) {
        localVarQueryParameter["start"] = start;
      }
      if (limit !== void 0) {
        localVarQueryParameter["limit"] = limit;
      }
      if (expand !== void 0) {
        localVarQueryParameter["expand"] = expand;
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Retrieve a Bill Subscription using its ID
     * @summary Retrieve a Bill Subscription by id
     * @param {string} billSubscriptionId 
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBillSubscriptionsSubscriptionId: (_0, _1, _2, ..._3) => __async(this, [_0, _1, _2, ..._3], function* (billSubscriptionId, expand, melioAccount, options = {}) {
      assertParamExists("getBillSubscriptionsSubscriptionId", "billSubscriptionId", billSubscriptionId);
      const localVarPath = `/bill-subscriptions/{billSubscriptionId}`.replace(`{${"billSubscriptionId"}}`, encodeURIComponent(String(billSubscriptionId)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (expand !== void 0) {
        localVarQueryParameter["expand"] = expand;
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Update Funding Source, Delivery Method or Delivery Preference of a Bill Subscription.
     * @summary Update a Bill Subscription
     * @param {string} billSubscriptionId 
     * @param {PatchBillSubscriptionsRequest} [patchBillSubscriptionsRequest] 
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchBillSubscriptionsSubscriptionId: (_0, _1, _2, _3, _4, ..._5) => __async(this, [_0, _1, _2, _3, _4, ..._5], function* (billSubscriptionId, patchBillSubscriptionsRequest, expand, idempotencyKey, melioAccount, options = {}) {
      assertParamExists("patchBillSubscriptionsSubscriptionId", "billSubscriptionId", billSubscriptionId);
      const localVarPath = `/bill-subscriptions/{billSubscriptionId}`.replace(`{${"billSubscriptionId"}}`, encodeURIComponent(String(billSubscriptionId)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "PATCH" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (expand !== void 0) {
        localVarQueryParameter["expand"] = expand;
      }
      if (idempotencyKey !== void 0 && idempotencyKey !== null) {
        localVarHeaderParameter["Idempotency-Key"] = String(idempotencyKey);
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(patchBillSubscriptionsRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Create a Bill Subscription.
     * @summary Create a Bill Subscription
     * @param {PostBillSubscriptionsRequest} [postBillSubscriptionsRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postBillBillBillBillSubscriptions: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (postBillSubscriptionsRequest, idempotencyKey, options = {}) {
      const localVarPath = `/bill-subscriptions`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (idempotencyKey !== void 0 && idempotencyKey !== null) {
        localVarHeaderParameter["Idempotency-Key"] = String(idempotencyKey);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postBillSubscriptionsRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Cancels a recurring bill payment by subscription ID. This subscription cannot be restarted.  This will cancel and delete any bills and payments scheduled for the future. If a payment is in progress but can still be canceled, it will be, and the payment and associated bill will be deleted. Canceling a recurring payment is final; you cannot restart a canceled bill subscription. The Melio-Account header is required when using API Key security. 
     * @summary Cancel a bill subscription by ID
     * @param {string} billSubscriptionId 
     * @param {PostBillSubscriptionCancelRequest} [postBillSubscriptionCancelRequest] 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postBillSubscriptionBillSubscriptionIdCancel: (_0, _1, _2, ..._3) => __async(this, [_0, _1, _2, ..._3], function* (billSubscriptionId, postBillSubscriptionCancelRequest, melioAccount, options = {}) {
      assertParamExists("postBillSubscriptionBillSubscriptionIdCancel", "billSubscriptionId", billSubscriptionId);
      const localVarPath = `/bill-subscriptions/{billSubscriptionId}/cancel`.replace(`{${"billSubscriptionId"}}`, encodeURIComponent(String(billSubscriptionId)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postBillSubscriptionCancelRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Bill subscription options.
     * @summary Bill subscription options
     * @param {PostBillSubscriptionOptionsRequest} postBillSubscriptionOptionsRequest 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postBillSubscriptionOptions: (_0, _1, _2, _3, ..._4) => __async(this, [_0, _1, _2, _3, ..._4], function* (postBillSubscriptionOptionsRequest, idempotencyKey, melioAccount, expand, options = {}) {
      assertParamExists("postBillSubscriptionOptions", "postBillSubscriptionOptionsRequest", postBillSubscriptionOptionsRequest);
      const localVarPath = `/bill-subscriptions/options`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (idempotencyKey !== void 0 && idempotencyKey !== null) {
        localVarHeaderParameter["Idempotency-Key"] = String(idempotencyKey);
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      if (expand !== void 0 && expand !== null) {
        localVarHeaderParameter["expand"] = String(JSON.stringify(expand));
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postBillSubscriptionOptionsRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    })
  };
};
var BillSubscriptionsApiFp = function(configuration) {
  const localVarAxiosParamCreator = BillSubscriptionsApiAxiosParamCreator(configuration);
  return {
    /**
     * List of bill-subscriptions
     * @summary Retrieve all bill-subscriptions
     * @param {string} [q] search data
     * @param {number} [start] The number of items to include in the returned list
     * @param {number} [limit] The number of items to include in the returned list
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBillSubscriptions(q, start, limit, expand, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getBillSubscriptions(q, start, limit, expand, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Retrieve a Bill Subscription using its ID
     * @summary Retrieve a Bill Subscription by id
     * @param {string} billSubscriptionId 
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBillSubscriptionsSubscriptionId(billSubscriptionId, expand, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getBillSubscriptionsSubscriptionId(billSubscriptionId, expand, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Update Funding Source, Delivery Method or Delivery Preference of a Bill Subscription.
     * @summary Update a Bill Subscription
     * @param {string} billSubscriptionId 
     * @param {PatchBillSubscriptionsRequest} [patchBillSubscriptionsRequest] 
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchBillSubscriptionsSubscriptionId(billSubscriptionId, patchBillSubscriptionsRequest, expand, idempotencyKey, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.patchBillSubscriptionsSubscriptionId(billSubscriptionId, patchBillSubscriptionsRequest, expand, idempotencyKey, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Create a Bill Subscription.
     * @summary Create a Bill Subscription
     * @param {PostBillSubscriptionsRequest} [postBillSubscriptionsRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postBillBillBillBillSubscriptions(postBillSubscriptionsRequest, idempotencyKey, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postBillBillBillBillSubscriptions(postBillSubscriptionsRequest, idempotencyKey, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Cancels a recurring bill payment by subscription ID. This subscription cannot be restarted.  This will cancel and delete any bills and payments scheduled for the future. If a payment is in progress but can still be canceled, it will be, and the payment and associated bill will be deleted. Canceling a recurring payment is final; you cannot restart a canceled bill subscription. The Melio-Account header is required when using API Key security. 
     * @summary Cancel a bill subscription by ID
     * @param {string} billSubscriptionId 
     * @param {PostBillSubscriptionCancelRequest} [postBillSubscriptionCancelRequest] 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postBillSubscriptionBillSubscriptionIdCancel(billSubscriptionId, postBillSubscriptionCancelRequest, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postBillSubscriptionBillSubscriptionIdCancel(billSubscriptionId, postBillSubscriptionCancelRequest, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Bill subscription options.
     * @summary Bill subscription options
     * @param {PostBillSubscriptionOptionsRequest} postBillSubscriptionOptionsRequest 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postBillSubscriptionOptions(postBillSubscriptionOptionsRequest, idempotencyKey, melioAccount, expand, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postBillSubscriptionOptions(postBillSubscriptionOptionsRequest, idempotencyKey, melioAccount, expand, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    }
  };
};
var BillSubscriptionsApiClient = createApiFromFp(BillSubscriptionsApiFp);
var BillSubscriptionsApiFactory = function(configuration, basePath, axios2) {
  const localVarFp = BillSubscriptionsApiFp(configuration);
  return {
    /**
     * List of bill-subscriptions
     * @summary Retrieve all bill-subscriptions
     * @param {string} [q] search data
     * @param {number} [start] The number of items to include in the returned list
     * @param {number} [limit] The number of items to include in the returned list
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBillSubscriptions(q, start, limit, expand, options) {
      return localVarFp.getBillSubscriptions(q, start, limit, expand, options).then((request) => request(axios2, basePath));
    },
    /**
     * Retrieve a Bill Subscription using its ID
     * @summary Retrieve a Bill Subscription by id
     * @param {string} billSubscriptionId 
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBillSubscriptionsSubscriptionId(billSubscriptionId, expand, melioAccount, options) {
      return localVarFp.getBillSubscriptionsSubscriptionId(billSubscriptionId, expand, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Update Funding Source, Delivery Method or Delivery Preference of a Bill Subscription.
     * @summary Update a Bill Subscription
     * @param {string} billSubscriptionId 
     * @param {PatchBillSubscriptionsRequest} [patchBillSubscriptionsRequest] 
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchBillSubscriptionsSubscriptionId(billSubscriptionId, patchBillSubscriptionsRequest, expand, idempotencyKey, melioAccount, options) {
      return localVarFp.patchBillSubscriptionsSubscriptionId(billSubscriptionId, patchBillSubscriptionsRequest, expand, idempotencyKey, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Create a Bill Subscription.
     * @summary Create a Bill Subscription
     * @param {PostBillSubscriptionsRequest} [postBillSubscriptionsRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postBillBillBillBillSubscriptions(postBillSubscriptionsRequest, idempotencyKey, options) {
      return localVarFp.postBillBillBillBillSubscriptions(postBillSubscriptionsRequest, idempotencyKey, options).then((request) => request(axios2, basePath));
    },
    /**
     * Cancels a recurring bill payment by subscription ID. This subscription cannot be restarted.  This will cancel and delete any bills and payments scheduled for the future. If a payment is in progress but can still be canceled, it will be, and the payment and associated bill will be deleted. Canceling a recurring payment is final; you cannot restart a canceled bill subscription. The Melio-Account header is required when using API Key security. 
     * @summary Cancel a bill subscription by ID
     * @param {string} billSubscriptionId 
     * @param {PostBillSubscriptionCancelRequest} [postBillSubscriptionCancelRequest] 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postBillSubscriptionBillSubscriptionIdCancel(billSubscriptionId, postBillSubscriptionCancelRequest, melioAccount, options) {
      return localVarFp.postBillSubscriptionBillSubscriptionIdCancel(billSubscriptionId, postBillSubscriptionCancelRequest, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Bill subscription options.
     * @summary Bill subscription options
     * @param {PostBillSubscriptionOptionsRequest} postBillSubscriptionOptionsRequest 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postBillSubscriptionOptions(postBillSubscriptionOptionsRequest, idempotencyKey, melioAccount, expand, options) {
      return localVarFp.postBillSubscriptionOptions(postBillSubscriptionOptionsRequest, idempotencyKey, melioAccount, expand, options).then((request) => request(axios2, basePath));
    }
  };
};
var BillSubscriptionsApi = class extends BaseAPI {
  /**
   * List of bill-subscriptions
   * @summary Retrieve all bill-subscriptions
   * @param {BillSubscriptionsApiGetBillSubscriptionsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BillSubscriptionsApi
   */
  getBillSubscriptions(requestParameters = {}, options) {
    return BillSubscriptionsApiFp(this.configuration).getBillSubscriptions(requestParameters.q, requestParameters.start, requestParameters.limit, requestParameters.expand, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Retrieve a Bill Subscription using its ID
   * @summary Retrieve a Bill Subscription by id
   * @param {BillSubscriptionsApiGetBillSubscriptionsSubscriptionIdRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BillSubscriptionsApi
   */
  getBillSubscriptionsSubscriptionId(requestParameters, options) {
    return BillSubscriptionsApiFp(this.configuration).getBillSubscriptionsSubscriptionId(requestParameters.billSubscriptionId, requestParameters.expand, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Update Funding Source, Delivery Method or Delivery Preference of a Bill Subscription.
   * @summary Update a Bill Subscription
   * @param {BillSubscriptionsApiPatchBillSubscriptionsSubscriptionIdRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BillSubscriptionsApi
   */
  patchBillSubscriptionsSubscriptionId(requestParameters, options) {
    return BillSubscriptionsApiFp(this.configuration).patchBillSubscriptionsSubscriptionId(requestParameters.billSubscriptionId, requestParameters.patchBillSubscriptionsRequest, requestParameters.expand, requestParameters.idempotencyKey, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Create a Bill Subscription.
   * @summary Create a Bill Subscription
   * @param {BillSubscriptionsApiPostBillBillBillBillSubscriptionsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BillSubscriptionsApi
   */
  postBillBillBillBillSubscriptions(requestParameters = {}, options) {
    return BillSubscriptionsApiFp(this.configuration).postBillBillBillBillSubscriptions(requestParameters.postBillSubscriptionsRequest, requestParameters.idempotencyKey, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Cancels a recurring bill payment by subscription ID. This subscription cannot be restarted.  This will cancel and delete any bills and payments scheduled for the future. If a payment is in progress but can still be canceled, it will be, and the payment and associated bill will be deleted. Canceling a recurring payment is final; you cannot restart a canceled bill subscription. The Melio-Account header is required when using API Key security. 
   * @summary Cancel a bill subscription by ID
   * @param {BillSubscriptionsApiPostBillSubscriptionBillSubscriptionIdCancelRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BillSubscriptionsApi
   */
  postBillSubscriptionBillSubscriptionIdCancel(requestParameters, options) {
    return BillSubscriptionsApiFp(this.configuration).postBillSubscriptionBillSubscriptionIdCancel(requestParameters.billSubscriptionId, requestParameters.postBillSubscriptionCancelRequest, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Bill subscription options.
   * @summary Bill subscription options
   * @param {BillSubscriptionsApiPostBillSubscriptionOptionsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BillSubscriptionsApi
   */
  postBillSubscriptionOptions(requestParameters, options) {
    return BillSubscriptionsApiFp(this.configuration).postBillSubscriptionOptions(requestParameters.postBillSubscriptionOptionsRequest, requestParameters.idempotencyKey, requestParameters.melioAccount, requestParameters.expand, options).then((request) => request(this.axios, this.basePath));
  }
};
var BillSubscriptionsApiInstance = createInstanceFromApiIClass(BillSubscriptionsApi);
var BillingFeeSettingsApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * Remove a Billing Fee Setting
     * @summary Delete a Billing Fee Setting
     * @param {string} id ID of the entity
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteBillingFeeSettingBillingFeeId: (_0, _1, _2, ..._3) => __async(this, [_0, _1, _2, ..._3], function* (id, idempotencyKey, melioAccount, options = {}) {
      assertParamExists("deleteBillingFeeSettingBillingFeeId", "id", id);
      const localVarPath = `/billing-fee-settings/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "DELETE" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (idempotencyKey !== void 0 && idempotencyKey !== null) {
        localVarHeaderParameter["Idempotency-Key"] = String(idempotencyKey);
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Retrieve a list of all Billing Fee Settings
     * @summary Retrieve all Billing Fee Settings
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBillingFeeSettings: (_0, ..._1) => __async(this, [_0, ..._1], function* (melioAccount, options = {}) {
      const localVarPath = `/billing-fee-settings`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Retrieve details about a specific Billing Fee Setting
     * @summary Retrieve a Billing Fee Setting
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBillingFeeSettingsBillingFeeId: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (id, melioAccount, options = {}) {
      assertParamExists("getBillingFeeSettingsBillingFeeId", "id", id);
      const localVarPath = `/billing-fee-settings/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Update a Billing Fee Setting
     * @summary Update a Billing Fee Setting
     * @param {string} id ID of the entity
     * @param {PatchBillingFeeSettingRequest} [patchBillingFeeSettingRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchBillingFeeSettingBillingFeeId: (_0, _1, _2, _3, ..._4) => __async(this, [_0, _1, _2, _3, ..._4], function* (id, patchBillingFeeSettingRequest, idempotencyKey, melioAccount, options = {}) {
      assertParamExists("patchBillingFeeSettingBillingFeeId", "id", id);
      const localVarPath = `/billing-fee-settings/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "PATCH" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (idempotencyKey !== void 0 && idempotencyKey !== null) {
        localVarHeaderParameter["Idempotency-Key"] = String(idempotencyKey);
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(patchBillingFeeSettingRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Add a new Billing Fee Setting
     * @summary Create a Billing Fee Setting
     * @param {PostBillingFeeSettingsRequest} [postBillingFeeSettingsRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postBillingFeeSettings: (_0, _1, _2, ..._3) => __async(this, [_0, _1, _2, ..._3], function* (postBillingFeeSettingsRequest, idempotencyKey, melioAccount, options = {}) {
      const localVarPath = `/billing-fee-settings`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (idempotencyKey !== void 0 && idempotencyKey !== null) {
        localVarHeaderParameter["Idempotency-Key"] = String(idempotencyKey);
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postBillingFeeSettingsRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    })
  };
};
var BillingFeeSettingsApiFp = function(configuration) {
  const localVarAxiosParamCreator = BillingFeeSettingsApiAxiosParamCreator(configuration);
  return {
    /**
     * Remove a Billing Fee Setting
     * @summary Delete a Billing Fee Setting
     * @param {string} id ID of the entity
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteBillingFeeSettingBillingFeeId(id, idempotencyKey, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteBillingFeeSettingBillingFeeId(id, idempotencyKey, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Retrieve a list of all Billing Fee Settings
     * @summary Retrieve all Billing Fee Settings
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBillingFeeSettings(melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getBillingFeeSettings(melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Retrieve details about a specific Billing Fee Setting
     * @summary Retrieve a Billing Fee Setting
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBillingFeeSettingsBillingFeeId(id, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getBillingFeeSettingsBillingFeeId(id, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Update a Billing Fee Setting
     * @summary Update a Billing Fee Setting
     * @param {string} id ID of the entity
     * @param {PatchBillingFeeSettingRequest} [patchBillingFeeSettingRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchBillingFeeSettingBillingFeeId(id, patchBillingFeeSettingRequest, idempotencyKey, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.patchBillingFeeSettingBillingFeeId(id, patchBillingFeeSettingRequest, idempotencyKey, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Add a new Billing Fee Setting
     * @summary Create a Billing Fee Setting
     * @param {PostBillingFeeSettingsRequest} [postBillingFeeSettingsRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postBillingFeeSettings(postBillingFeeSettingsRequest, idempotencyKey, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postBillingFeeSettings(postBillingFeeSettingsRequest, idempotencyKey, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    }
  };
};
var BillingFeeSettingsApiClient = createApiFromFp(BillingFeeSettingsApiFp);
var BillingFeeSettingsApiFactory = function(configuration, basePath, axios2) {
  const localVarFp = BillingFeeSettingsApiFp(configuration);
  return {
    /**
     * Remove a Billing Fee Setting
     * @summary Delete a Billing Fee Setting
     * @param {string} id ID of the entity
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteBillingFeeSettingBillingFeeId(id, idempotencyKey, melioAccount, options) {
      return localVarFp.deleteBillingFeeSettingBillingFeeId(id, idempotencyKey, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Retrieve a list of all Billing Fee Settings
     * @summary Retrieve all Billing Fee Settings
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBillingFeeSettings(melioAccount, options) {
      return localVarFp.getBillingFeeSettings(melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Retrieve details about a specific Billing Fee Setting
     * @summary Retrieve a Billing Fee Setting
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBillingFeeSettingsBillingFeeId(id, melioAccount, options) {
      return localVarFp.getBillingFeeSettingsBillingFeeId(id, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Update a Billing Fee Setting
     * @summary Update a Billing Fee Setting
     * @param {string} id ID of the entity
     * @param {PatchBillingFeeSettingRequest} [patchBillingFeeSettingRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchBillingFeeSettingBillingFeeId(id, patchBillingFeeSettingRequest, idempotencyKey, melioAccount, options) {
      return localVarFp.patchBillingFeeSettingBillingFeeId(id, patchBillingFeeSettingRequest, idempotencyKey, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Add a new Billing Fee Setting
     * @summary Create a Billing Fee Setting
     * @param {PostBillingFeeSettingsRequest} [postBillingFeeSettingsRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postBillingFeeSettings(postBillingFeeSettingsRequest, idempotencyKey, melioAccount, options) {
      return localVarFp.postBillingFeeSettings(postBillingFeeSettingsRequest, idempotencyKey, melioAccount, options).then((request) => request(axios2, basePath));
    }
  };
};
var BillingFeeSettingsApi = class extends BaseAPI {
  /**
   * Remove a Billing Fee Setting
   * @summary Delete a Billing Fee Setting
   * @param {BillingFeeSettingsApiDeleteBillingFeeSettingBillingFeeIdRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BillingFeeSettingsApi
   */
  deleteBillingFeeSettingBillingFeeId(requestParameters, options) {
    return BillingFeeSettingsApiFp(this.configuration).deleteBillingFeeSettingBillingFeeId(requestParameters.id, requestParameters.idempotencyKey, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Retrieve a list of all Billing Fee Settings
   * @summary Retrieve all Billing Fee Settings
   * @param {BillingFeeSettingsApiGetBillingFeeSettingsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BillingFeeSettingsApi
   */
  getBillingFeeSettings(requestParameters = {}, options) {
    return BillingFeeSettingsApiFp(this.configuration).getBillingFeeSettings(requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Retrieve details about a specific Billing Fee Setting
   * @summary Retrieve a Billing Fee Setting
   * @param {BillingFeeSettingsApiGetBillingFeeSettingsBillingFeeIdRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BillingFeeSettingsApi
   */
  getBillingFeeSettingsBillingFeeId(requestParameters, options) {
    return BillingFeeSettingsApiFp(this.configuration).getBillingFeeSettingsBillingFeeId(requestParameters.id, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Update a Billing Fee Setting
   * @summary Update a Billing Fee Setting
   * @param {BillingFeeSettingsApiPatchBillingFeeSettingBillingFeeIdRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BillingFeeSettingsApi
   */
  patchBillingFeeSettingBillingFeeId(requestParameters, options) {
    return BillingFeeSettingsApiFp(this.configuration).patchBillingFeeSettingBillingFeeId(requestParameters.id, requestParameters.patchBillingFeeSettingRequest, requestParameters.idempotencyKey, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Add a new Billing Fee Setting
   * @summary Create a Billing Fee Setting
   * @param {BillingFeeSettingsApiPostBillingFeeSettingsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BillingFeeSettingsApi
   */
  postBillingFeeSettings(requestParameters = {}, options) {
    return BillingFeeSettingsApiFp(this.configuration).postBillingFeeSettings(requestParameters.postBillingFeeSettingsRequest, requestParameters.idempotencyKey, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
};
var BillingFeeSettingsApiInstance = createInstanceFromApiIClass(BillingFeeSettingsApi);
var BillsApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * Mark as paid existing Bills. The request\'s body can be partial, and only provided fields will be overwritten. Set an optional field to `null` in order to remove its contents.
     * @summary create a marked as paid single payment for a batch of bills
     * @param {PostBatchMarkAsPaidSinglePaymentRequest} [postBatchMarkAsPaidSinglePaymentRequest] 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    batchMarkAsPaidSinglePayment: (_0, _1, _2, _3, _4, ..._5) => __async(this, [_0, _1, _2, _3, _4, ..._5], function* (postBatchMarkAsPaidSinglePaymentRequest, expand, melioAccount, organizationId, userId, options = {}) {
      const localVarPath = `/bills/batch-mark-as-paid-single-payment`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (expand !== void 0 && expand !== null) {
        localVarHeaderParameter["expand"] = String(JSON.stringify(expand));
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      if (organizationId !== void 0 && organizationId !== null) {
        localVarHeaderParameter["Organization-id"] = String(organizationId);
      }
      if (userId !== void 0 && userId !== null) {
        localVarHeaderParameter["User-id"] = String(userId);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postBatchMarkAsPaidSinglePaymentRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Delete a Bill. If a Payment is in progress for this Bill, the request will fail with a 400 error.  <!-- theme: info --> > The `Melio-Account` header is required when using API Key security. 
     * @summary Delete a Bill
     * @param {string} id ID of the entity
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteBillsBillId: (_0, _1, _2, ..._3) => __async(this, [_0, _1, _2, ..._3], function* (id, organizationId, userId, options = {}) {
      assertParamExists("deleteBillsBillId", "id", id);
      const localVarPath = `/bills/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "DELETE" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (organizationId !== void 0 && organizationId !== null) {
        localVarHeaderParameter["Organization-id"] = String(organizationId);
      }
      if (userId !== void 0 && userId !== null) {
        localVarHeaderParameter["User-id"] = String(userId);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Retrieve all Bills for this account.  [`searchTerm` parameter searches](https://docs.melio.com/docs/melio-data-api/getting-started#simple_search) can match the following fields: - `vendor.name` - `amount` - `invoice.number` - `balance`  [`search` parameter searches](https://docs.melio.com/docs/melio-data-api/getting-started#advanced_search) can be matched against the following result fields: - `vendor.name` - `vendor.contact.name` - `vendor.id` - `paymentIntent.id` - `payment.status` - `payment.approvalDecisionStatus` - `bill.balance` - `bill.status` - `payment.id` - `bill.id` - `bill.origin` - `bill.originId` - `payment.collectStatus`  <!-- theme: info --> > The `Melio-Account` header is required when using API Key security. 
     * @summary Retrieve all Bills
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [searchTerm] Limit returned objects to those that contain the specified search string. Search is a case-insensitive, substring match against a subset of fields in the object. See the method documentation to learn which fields can be matched by the &#x60;searchTerm&#x60; value. [Read more](https://docs.melio.com/docs/melio-data-api/getting-started#simple_search) 
     * @param {string} [search] Limit returned objects to those that satisfy the specified query. Query strings support logic and comparison against fields that you specify. See the method documentation to learn which fields can be included in your query, or [read more about query strings](https://docs.melio.com/docs/melio-data-api/getting-started#advanced_search).
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {Array<BillsSortQueryParam>} [sort] Sort query parameter - sort data by specified entity fields
     * @param {boolean} [shouldFilterPaidBills] If true, fetch only unpaid bills (eBills without related payments or bills with balance greater than 0)
     * @param {number} [limit] A limit on the number of records to be returned.
     * @param {PaginationCursor} [cursor] Used to page through page through results when the &#x60;totalCount&#x60; is more than the current set of results. To page, specify \&quot;cursor[prev]&#x3D;_&lt;prev_token&gt;_\&quot; or \&quot;cursor[next]&#x3D;_&lt;next_token&gt;_\&quot; as a URL parameter. 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBills: (_0, _1, _2, _3, _4, _5, _6, _7, ..._8) => __async(this, [_0, _1, _2, _3, _4, _5, _6, _7, ..._8], function* (expand, searchTerm, search, melioAccount, sort, shouldFilterPaidBills, limit, cursor, options = {}) {
      const localVarPath = `/bills`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (expand !== void 0) {
        localVarQueryParameter["expand"] = expand;
      }
      if (searchTerm !== void 0) {
        localVarQueryParameter["searchTerm"] = searchTerm;
      }
      if (search !== void 0) {
        localVarQueryParameter["search"] = search;
      }
      if (sort) {
        localVarQueryParameter["sort"] = sort;
      }
      if (shouldFilterPaidBills !== void 0) {
        localVarQueryParameter["shouldFilterPaidBills"] = shouldFilterPaidBills;
      }
      if (limit !== void 0) {
        localVarQueryParameter["limit"] = limit;
      }
      if (cursor !== void 0) {
        localVarQueryParameter["cursor"] = cursor;
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Retrieve a Bill
     * @summary Retrieve a Bill
     * @param {string} id ID of the entity
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBillsBillId: (_0, _1, _2, _3, _4, ..._5) => __async(this, [_0, _1, _2, _3, _4, ..._5], function* (id, expand, melioAccount, organizationId, userId, options = {}) {
      assertParamExists("getBillsBillId", "id", id);
      const localVarPath = `/bills/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (expand !== void 0) {
        localVarQueryParameter["expand"] = expand;
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      if (organizationId !== void 0 && organizationId !== null) {
        localVarHeaderParameter["Organization-id"] = String(organizationId);
      }
      if (userId !== void 0 && userId !== null) {
        localVarHeaderParameter["User-id"] = String(userId);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Get Bill attachments for synced bills and eBills.
     * @summary get bill attachments for synced bills and eBills
     * @param {string} id ID of the entity
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBillsBillIdAttachments: (_0, _1, _2, ..._3) => __async(this, [_0, _1, _2, ..._3], function* (id, expand, melioAccount, options = {}) {
      assertParamExists("getBillsBillIdAttachments", "id", id);
      const localVarPath = `/bills/{id}/attachments`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (expand !== void 0 && expand !== null) {
        localVarHeaderParameter["expand"] = String(JSON.stringify(expand));
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Update an existing Bill.  The request\'s body can be partial, and only provided fields will be overwritten. Set an optional field to `null` in order to remove its contents.
     * @summary Update a Bill
     * @param {string} id ID of the entity
     * @param {PatchBillsBillIdRequest} [patchBillsBillIdRequest] 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchBillsBillId: (_0, _1, _2, _3, _4, _5, ..._6) => __async(this, [_0, _1, _2, _3, _4, _5, ..._6], function* (id, patchBillsBillIdRequest, expand, melioAccount, organizationId, userId, options = {}) {
      assertParamExists("patchBillsBillId", "id", id);
      const localVarPath = `/bills/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "PATCH" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (expand !== void 0 && expand !== null) {
        localVarHeaderParameter["expand"] = String(JSON.stringify(expand));
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      if (organizationId !== void 0 && organizationId !== null) {
        localVarHeaderParameter["Organization-id"] = String(organizationId);
      }
      if (userId !== void 0 && userId !== null) {
        localVarHeaderParameter["User-id"] = String(userId);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(patchBillsBillIdRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Create a Bill
     * @summary Create a Bill
     * @param {PostBillsRequest} [postBillsRequest] 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postBills: (_0, _1, _2, _3, _4, ..._5) => __async(this, [_0, _1, _2, _3, _4, ..._5], function* (postBillsRequest, expand, melioAccount, organizationId, userId, options = {}) {
      const localVarPath = `/bills`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (expand !== void 0 && expand !== null) {
        localVarHeaderParameter["expand"] = String(JSON.stringify(expand));
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      if (organizationId !== void 0 && organizationId !== null) {
        localVarHeaderParameter["Organization-id"] = String(organizationId);
      }
      if (userId !== void 0 && userId !== null) {
        localVarHeaderParameter["User-id"] = String(userId);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postBillsRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * 
     * @summary delete bills
     * @param {PostBillsBatchDeleteRequest} [postBillsBatchDeleteRequest] 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postBillsBatchDelete: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (postBillsBatchDeleteRequest, melioAccount, options = {}) {
      const localVarPath = `/bills/batch-delete`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postBillsBatchDeleteRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Mark as paid existing Bills. The request\'s body can be partial, and only provided fields will be overwritten. Set an optional field to `null` in order to remove its contents.
     * @summary create a marked as paid payment/s
     * @param {PostBillsBatchMarkAsPaidRequest} [postBillsBatchMarkAsPaidRequest] 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postBillsBatchMarkAsPaid: (_0, _1, _2, ..._3) => __async(this, [_0, _1, _2, ..._3], function* (postBillsBatchMarkAsPaidRequest, expand, melioAccount, options = {}) {
      const localVarPath = `/bills/batch-mark-as-paid`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (expand !== void 0 && expand !== null) {
        localVarHeaderParameter["expand"] = String(JSON.stringify(expand));
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postBillsBatchMarkAsPaidRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Mark as unpaid existing Bills. The request\'s body can be partial, and only provided fields will be overwritten. Set an optional field to `null` in order to remove its contents.
     * @summary destroys the marked as paid payments
     * @param {PostBillsBatchMarkAsUnpaidRequest} [postBillsBatchMarkAsUnpaidRequest] 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postBillsBatchMarkAsUnpaid: (_0, _1, _2, ..._3) => __async(this, [_0, _1, _2, ..._3], function* (postBillsBatchMarkAsUnpaidRequest, expand, melioAccount, options = {}) {
      const localVarPath = `/bills/batch-mark-as-unpaid`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (expand !== void 0 && expand !== null) {
        localVarHeaderParameter["expand"] = String(JSON.stringify(expand));
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postBillsBatchMarkAsUnpaidRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Mark as paid existing Bill. The request\'s body can be partial, and only provided fields will be overwritten. Set an optional field to `null` in order to remove its contents.
     * @summary create a mark as paid payment
     * @param {string} id ID of the entity
     * @param {PostBillsBillIdMarkAsPaidRequest} [postBillsBillIdMarkAsPaidRequest] 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postBillsBillIdMarkAsPaid: (_0, _1, _2, _3, ..._4) => __async(this, [_0, _1, _2, _3, ..._4], function* (id, postBillsBillIdMarkAsPaidRequest, expand, melioAccount, options = {}) {
      assertParamExists("postBillsBillIdMarkAsPaid", "id", id);
      const localVarPath = `/bills/{id}/mark-as-paid`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (expand !== void 0 && expand !== null) {
        localVarHeaderParameter["expand"] = String(JSON.stringify(expand));
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postBillsBillIdMarkAsPaidRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Create multiple Bills
     * @summary Create multiple Bills
     * @param {PostBillsBulkRequest} [postBillsBulkRequest] 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postBillsBulk: (_0, _1, _2, ..._3) => __async(this, [_0, _1, _2, ..._3], function* (postBillsBulkRequest, expand, melioAccount, options = {}) {
      const localVarPath = `/bills/bulk`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (expand !== void 0 && expand !== null) {
        localVarHeaderParameter["expand"] = String(JSON.stringify(expand));
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postBillsBulkRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    })
  };
};
var BillsApiFp = function(configuration) {
  const localVarAxiosParamCreator = BillsApiAxiosParamCreator(configuration);
  return {
    /**
     * Mark as paid existing Bills. The request\'s body can be partial, and only provided fields will be overwritten. Set an optional field to `null` in order to remove its contents.
     * @summary create a marked as paid single payment for a batch of bills
     * @param {PostBatchMarkAsPaidSinglePaymentRequest} [postBatchMarkAsPaidSinglePaymentRequest] 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    batchMarkAsPaidSinglePayment(postBatchMarkAsPaidSinglePaymentRequest, expand, melioAccount, organizationId, userId, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.batchMarkAsPaidSinglePayment(postBatchMarkAsPaidSinglePaymentRequest, expand, melioAccount, organizationId, userId, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Delete a Bill. If a Payment is in progress for this Bill, the request will fail with a 400 error.  <!-- theme: info --> > The `Melio-Account` header is required when using API Key security. 
     * @summary Delete a Bill
     * @param {string} id ID of the entity
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteBillsBillId(id, organizationId, userId, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteBillsBillId(id, organizationId, userId, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Retrieve all Bills for this account.  [`searchTerm` parameter searches](https://docs.melio.com/docs/melio-data-api/getting-started#simple_search) can match the following fields: - `vendor.name` - `amount` - `invoice.number` - `balance`  [`search` parameter searches](https://docs.melio.com/docs/melio-data-api/getting-started#advanced_search) can be matched against the following result fields: - `vendor.name` - `vendor.contact.name` - `vendor.id` - `paymentIntent.id` - `payment.status` - `payment.approvalDecisionStatus` - `bill.balance` - `bill.status` - `payment.id` - `bill.id` - `bill.origin` - `bill.originId` - `payment.collectStatus`  <!-- theme: info --> > The `Melio-Account` header is required when using API Key security. 
     * @summary Retrieve all Bills
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [searchTerm] Limit returned objects to those that contain the specified search string. Search is a case-insensitive, substring match against a subset of fields in the object. See the method documentation to learn which fields can be matched by the &#x60;searchTerm&#x60; value. [Read more](https://docs.melio.com/docs/melio-data-api/getting-started#simple_search) 
     * @param {string} [search] Limit returned objects to those that satisfy the specified query. Query strings support logic and comparison against fields that you specify. See the method documentation to learn which fields can be included in your query, or [read more about query strings](https://docs.melio.com/docs/melio-data-api/getting-started#advanced_search).
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {Array<BillsSortQueryParam>} [sort] Sort query parameter - sort data by specified entity fields
     * @param {boolean} [shouldFilterPaidBills] If true, fetch only unpaid bills (eBills without related payments or bills with balance greater than 0)
     * @param {number} [limit] A limit on the number of records to be returned.
     * @param {PaginationCursor} [cursor] Used to page through page through results when the &#x60;totalCount&#x60; is more than the current set of results. To page, specify \&quot;cursor[prev]&#x3D;_&lt;prev_token&gt;_\&quot; or \&quot;cursor[next]&#x3D;_&lt;next_token&gt;_\&quot; as a URL parameter. 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBills(expand, searchTerm, search, melioAccount, sort, shouldFilterPaidBills, limit, cursor, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getBills(expand, searchTerm, search, melioAccount, sort, shouldFilterPaidBills, limit, cursor, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Retrieve a Bill
     * @summary Retrieve a Bill
     * @param {string} id ID of the entity
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBillsBillId(id, expand, melioAccount, organizationId, userId, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getBillsBillId(id, expand, melioAccount, organizationId, userId, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Get Bill attachments for synced bills and eBills.
     * @summary get bill attachments for synced bills and eBills
     * @param {string} id ID of the entity
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBillsBillIdAttachments(id, expand, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getBillsBillIdAttachments(id, expand, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Update an existing Bill.  The request\'s body can be partial, and only provided fields will be overwritten. Set an optional field to `null` in order to remove its contents.
     * @summary Update a Bill
     * @param {string} id ID of the entity
     * @param {PatchBillsBillIdRequest} [patchBillsBillIdRequest] 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchBillsBillId(id, patchBillsBillIdRequest, expand, melioAccount, organizationId, userId, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.patchBillsBillId(id, patchBillsBillIdRequest, expand, melioAccount, organizationId, userId, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Create a Bill
     * @summary Create a Bill
     * @param {PostBillsRequest} [postBillsRequest] 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postBills(postBillsRequest, expand, melioAccount, organizationId, userId, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postBills(postBillsRequest, expand, melioAccount, organizationId, userId, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * 
     * @summary delete bills
     * @param {PostBillsBatchDeleteRequest} [postBillsBatchDeleteRequest] 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postBillsBatchDelete(postBillsBatchDeleteRequest, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postBillsBatchDelete(postBillsBatchDeleteRequest, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Mark as paid existing Bills. The request\'s body can be partial, and only provided fields will be overwritten. Set an optional field to `null` in order to remove its contents.
     * @summary create a marked as paid payment/s
     * @param {PostBillsBatchMarkAsPaidRequest} [postBillsBatchMarkAsPaidRequest] 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postBillsBatchMarkAsPaid(postBillsBatchMarkAsPaidRequest, expand, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postBillsBatchMarkAsPaid(postBillsBatchMarkAsPaidRequest, expand, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Mark as unpaid existing Bills. The request\'s body can be partial, and only provided fields will be overwritten. Set an optional field to `null` in order to remove its contents.
     * @summary destroys the marked as paid payments
     * @param {PostBillsBatchMarkAsUnpaidRequest} [postBillsBatchMarkAsUnpaidRequest] 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postBillsBatchMarkAsUnpaid(postBillsBatchMarkAsUnpaidRequest, expand, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postBillsBatchMarkAsUnpaid(postBillsBatchMarkAsUnpaidRequest, expand, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Mark as paid existing Bill. The request\'s body can be partial, and only provided fields will be overwritten. Set an optional field to `null` in order to remove its contents.
     * @summary create a mark as paid payment
     * @param {string} id ID of the entity
     * @param {PostBillsBillIdMarkAsPaidRequest} [postBillsBillIdMarkAsPaidRequest] 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postBillsBillIdMarkAsPaid(id, postBillsBillIdMarkAsPaidRequest, expand, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postBillsBillIdMarkAsPaid(id, postBillsBillIdMarkAsPaidRequest, expand, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Create multiple Bills
     * @summary Create multiple Bills
     * @param {PostBillsBulkRequest} [postBillsBulkRequest] 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postBillsBulk(postBillsBulkRequest, expand, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postBillsBulk(postBillsBulkRequest, expand, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    }
  };
};
var BillsApiClient = createApiFromFp(BillsApiFp);
var BillsApiFactory = function(configuration, basePath, axios2) {
  const localVarFp = BillsApiFp(configuration);
  return {
    /**
     * Mark as paid existing Bills. The request\'s body can be partial, and only provided fields will be overwritten. Set an optional field to `null` in order to remove its contents.
     * @summary create a marked as paid single payment for a batch of bills
     * @param {PostBatchMarkAsPaidSinglePaymentRequest} [postBatchMarkAsPaidSinglePaymentRequest] 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    batchMarkAsPaidSinglePayment(postBatchMarkAsPaidSinglePaymentRequest, expand, melioAccount, organizationId, userId, options) {
      return localVarFp.batchMarkAsPaidSinglePayment(postBatchMarkAsPaidSinglePaymentRequest, expand, melioAccount, organizationId, userId, options).then((request) => request(axios2, basePath));
    },
    /**
     * Delete a Bill. If a Payment is in progress for this Bill, the request will fail with a 400 error.  <!-- theme: info --> > The `Melio-Account` header is required when using API Key security. 
     * @summary Delete a Bill
     * @param {string} id ID of the entity
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteBillsBillId(id, organizationId, userId, options) {
      return localVarFp.deleteBillsBillId(id, organizationId, userId, options).then((request) => request(axios2, basePath));
    },
    /**
     * Retrieve all Bills for this account.  [`searchTerm` parameter searches](https://docs.melio.com/docs/melio-data-api/getting-started#simple_search) can match the following fields: - `vendor.name` - `amount` - `invoice.number` - `balance`  [`search` parameter searches](https://docs.melio.com/docs/melio-data-api/getting-started#advanced_search) can be matched against the following result fields: - `vendor.name` - `vendor.contact.name` - `vendor.id` - `paymentIntent.id` - `payment.status` - `payment.approvalDecisionStatus` - `bill.balance` - `bill.status` - `payment.id` - `bill.id` - `bill.origin` - `bill.originId` - `payment.collectStatus`  <!-- theme: info --> > The `Melio-Account` header is required when using API Key security. 
     * @summary Retrieve all Bills
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [searchTerm] Limit returned objects to those that contain the specified search string. Search is a case-insensitive, substring match against a subset of fields in the object. See the method documentation to learn which fields can be matched by the &#x60;searchTerm&#x60; value. [Read more](https://docs.melio.com/docs/melio-data-api/getting-started#simple_search) 
     * @param {string} [search] Limit returned objects to those that satisfy the specified query. Query strings support logic and comparison against fields that you specify. See the method documentation to learn which fields can be included in your query, or [read more about query strings](https://docs.melio.com/docs/melio-data-api/getting-started#advanced_search).
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {Array<BillsSortQueryParam>} [sort] Sort query parameter - sort data by specified entity fields
     * @param {boolean} [shouldFilterPaidBills] If true, fetch only unpaid bills (eBills without related payments or bills with balance greater than 0)
     * @param {number} [limit] A limit on the number of records to be returned.
     * @param {PaginationCursor} [cursor] Used to page through page through results when the &#x60;totalCount&#x60; is more than the current set of results. To page, specify \&quot;cursor[prev]&#x3D;_&lt;prev_token&gt;_\&quot; or \&quot;cursor[next]&#x3D;_&lt;next_token&gt;_\&quot; as a URL parameter. 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBills(expand, searchTerm, search, melioAccount, sort, shouldFilterPaidBills, limit, cursor, options) {
      return localVarFp.getBills(expand, searchTerm, search, melioAccount, sort, shouldFilterPaidBills, limit, cursor, options).then((request) => request(axios2, basePath));
    },
    /**
     * Retrieve a Bill
     * @summary Retrieve a Bill
     * @param {string} id ID of the entity
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBillsBillId(id, expand, melioAccount, organizationId, userId, options) {
      return localVarFp.getBillsBillId(id, expand, melioAccount, organizationId, userId, options).then((request) => request(axios2, basePath));
    },
    /**
     * Get Bill attachments for synced bills and eBills.
     * @summary get bill attachments for synced bills and eBills
     * @param {string} id ID of the entity
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBillsBillIdAttachments(id, expand, melioAccount, options) {
      return localVarFp.getBillsBillIdAttachments(id, expand, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Update an existing Bill.  The request\'s body can be partial, and only provided fields will be overwritten. Set an optional field to `null` in order to remove its contents.
     * @summary Update a Bill
     * @param {string} id ID of the entity
     * @param {PatchBillsBillIdRequest} [patchBillsBillIdRequest] 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchBillsBillId(id, patchBillsBillIdRequest, expand, melioAccount, organizationId, userId, options) {
      return localVarFp.patchBillsBillId(id, patchBillsBillIdRequest, expand, melioAccount, organizationId, userId, options).then((request) => request(axios2, basePath));
    },
    /**
     * Create a Bill
     * @summary Create a Bill
     * @param {PostBillsRequest} [postBillsRequest] 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postBills(postBillsRequest, expand, melioAccount, organizationId, userId, options) {
      return localVarFp.postBills(postBillsRequest, expand, melioAccount, organizationId, userId, options).then((request) => request(axios2, basePath));
    },
    /**
     * 
     * @summary delete bills
     * @param {PostBillsBatchDeleteRequest} [postBillsBatchDeleteRequest] 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postBillsBatchDelete(postBillsBatchDeleteRequest, melioAccount, options) {
      return localVarFp.postBillsBatchDelete(postBillsBatchDeleteRequest, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Mark as paid existing Bills. The request\'s body can be partial, and only provided fields will be overwritten. Set an optional field to `null` in order to remove its contents.
     * @summary create a marked as paid payment/s
     * @param {PostBillsBatchMarkAsPaidRequest} [postBillsBatchMarkAsPaidRequest] 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postBillsBatchMarkAsPaid(postBillsBatchMarkAsPaidRequest, expand, melioAccount, options) {
      return localVarFp.postBillsBatchMarkAsPaid(postBillsBatchMarkAsPaidRequest, expand, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Mark as unpaid existing Bills. The request\'s body can be partial, and only provided fields will be overwritten. Set an optional field to `null` in order to remove its contents.
     * @summary destroys the marked as paid payments
     * @param {PostBillsBatchMarkAsUnpaidRequest} [postBillsBatchMarkAsUnpaidRequest] 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postBillsBatchMarkAsUnpaid(postBillsBatchMarkAsUnpaidRequest, expand, melioAccount, options) {
      return localVarFp.postBillsBatchMarkAsUnpaid(postBillsBatchMarkAsUnpaidRequest, expand, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Mark as paid existing Bill. The request\'s body can be partial, and only provided fields will be overwritten. Set an optional field to `null` in order to remove its contents.
     * @summary create a mark as paid payment
     * @param {string} id ID of the entity
     * @param {PostBillsBillIdMarkAsPaidRequest} [postBillsBillIdMarkAsPaidRequest] 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postBillsBillIdMarkAsPaid(id, postBillsBillIdMarkAsPaidRequest, expand, melioAccount, options) {
      return localVarFp.postBillsBillIdMarkAsPaid(id, postBillsBillIdMarkAsPaidRequest, expand, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Create multiple Bills
     * @summary Create multiple Bills
     * @param {PostBillsBulkRequest} [postBillsBulkRequest] 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postBillsBulk(postBillsBulkRequest, expand, melioAccount, options) {
      return localVarFp.postBillsBulk(postBillsBulkRequest, expand, melioAccount, options).then((request) => request(axios2, basePath));
    }
  };
};
var BillsApi = class extends BaseAPI {
  /**
   * Mark as paid existing Bills. The request\'s body can be partial, and only provided fields will be overwritten. Set an optional field to `null` in order to remove its contents.
   * @summary create a marked as paid single payment for a batch of bills
   * @param {BillsApiBatchMarkAsPaidSinglePaymentRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BillsApi
   */
  batchMarkAsPaidSinglePayment(requestParameters = {}, options) {
    return BillsApiFp(this.configuration).batchMarkAsPaidSinglePayment(requestParameters.postBatchMarkAsPaidSinglePaymentRequest, requestParameters.expand, requestParameters.melioAccount, requestParameters.organizationId, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Delete a Bill. If a Payment is in progress for this Bill, the request will fail with a 400 error.  <!-- theme: info --> > The `Melio-Account` header is required when using API Key security. 
   * @summary Delete a Bill
   * @param {BillsApiDeleteBillsBillIdRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BillsApi
   */
  deleteBillsBillId(requestParameters, options) {
    return BillsApiFp(this.configuration).deleteBillsBillId(requestParameters.id, requestParameters.organizationId, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Retrieve all Bills for this account.  [`searchTerm` parameter searches](https://docs.melio.com/docs/melio-data-api/getting-started#simple_search) can match the following fields: - `vendor.name` - `amount` - `invoice.number` - `balance`  [`search` parameter searches](https://docs.melio.com/docs/melio-data-api/getting-started#advanced_search) can be matched against the following result fields: - `vendor.name` - `vendor.contact.name` - `vendor.id` - `paymentIntent.id` - `payment.status` - `payment.approvalDecisionStatus` - `bill.balance` - `bill.status` - `payment.id` - `bill.id` - `bill.origin` - `bill.originId` - `payment.collectStatus`  <!-- theme: info --> > The `Melio-Account` header is required when using API Key security. 
   * @summary Retrieve all Bills
   * @param {BillsApiGetBillsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BillsApi
   */
  getBills(requestParameters = {}, options) {
    return BillsApiFp(this.configuration).getBills(requestParameters.expand, requestParameters.searchTerm, requestParameters.search, requestParameters.melioAccount, requestParameters.sort, requestParameters.shouldFilterPaidBills, requestParameters.limit, requestParameters.cursor, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Retrieve a Bill
   * @summary Retrieve a Bill
   * @param {BillsApiGetBillsBillIdRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BillsApi
   */
  getBillsBillId(requestParameters, options) {
    return BillsApiFp(this.configuration).getBillsBillId(requestParameters.id, requestParameters.expand, requestParameters.melioAccount, requestParameters.organizationId, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Get Bill attachments for synced bills and eBills.
   * @summary get bill attachments for synced bills and eBills
   * @param {BillsApiGetBillsBillIdAttachmentsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BillsApi
   */
  getBillsBillIdAttachments(requestParameters, options) {
    return BillsApiFp(this.configuration).getBillsBillIdAttachments(requestParameters.id, requestParameters.expand, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Update an existing Bill.  The request\'s body can be partial, and only provided fields will be overwritten. Set an optional field to `null` in order to remove its contents.
   * @summary Update a Bill
   * @param {BillsApiPatchBillsBillIdRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BillsApi
   */
  patchBillsBillId(requestParameters, options) {
    return BillsApiFp(this.configuration).patchBillsBillId(requestParameters.id, requestParameters.patchBillsBillIdRequest, requestParameters.expand, requestParameters.melioAccount, requestParameters.organizationId, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Create a Bill
   * @summary Create a Bill
   * @param {BillsApiPostBillsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BillsApi
   */
  postBills(requestParameters = {}, options) {
    return BillsApiFp(this.configuration).postBills(requestParameters.postBillsRequest, requestParameters.expand, requestParameters.melioAccount, requestParameters.organizationId, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * 
   * @summary delete bills
   * @param {BillsApiPostBillsBatchDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BillsApi
   */
  postBillsBatchDelete(requestParameters = {}, options) {
    return BillsApiFp(this.configuration).postBillsBatchDelete(requestParameters.postBillsBatchDeleteRequest, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Mark as paid existing Bills. The request\'s body can be partial, and only provided fields will be overwritten. Set an optional field to `null` in order to remove its contents.
   * @summary create a marked as paid payment/s
   * @param {BillsApiPostBillsBatchMarkAsPaidRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BillsApi
   */
  postBillsBatchMarkAsPaid(requestParameters = {}, options) {
    return BillsApiFp(this.configuration).postBillsBatchMarkAsPaid(requestParameters.postBillsBatchMarkAsPaidRequest, requestParameters.expand, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Mark as unpaid existing Bills. The request\'s body can be partial, and only provided fields will be overwritten. Set an optional field to `null` in order to remove its contents.
   * @summary destroys the marked as paid payments
   * @param {BillsApiPostBillsBatchMarkAsUnpaidRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BillsApi
   */
  postBillsBatchMarkAsUnpaid(requestParameters = {}, options) {
    return BillsApiFp(this.configuration).postBillsBatchMarkAsUnpaid(requestParameters.postBillsBatchMarkAsUnpaidRequest, requestParameters.expand, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Mark as paid existing Bill. The request\'s body can be partial, and only provided fields will be overwritten. Set an optional field to `null` in order to remove its contents.
   * @summary create a mark as paid payment
   * @param {BillsApiPostBillsBillIdMarkAsPaidRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BillsApi
   */
  postBillsBillIdMarkAsPaid(requestParameters, options) {
    return BillsApiFp(this.configuration).postBillsBillIdMarkAsPaid(requestParameters.id, requestParameters.postBillsBillIdMarkAsPaidRequest, requestParameters.expand, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Create multiple Bills
   * @summary Create multiple Bills
   * @param {BillsApiPostBillsBulkRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BillsApi
   */
  postBillsBulk(requestParameters = {}, options) {
    return BillsApiFp(this.configuration).postBillsBulk(requestParameters.postBillsBulkRequest, requestParameters.expand, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
};
var BillsApiInstance = createInstanceFromApiIClass(BillsApi);
var BillsSyncApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * Remove the connection between the current user/org and this bills sync provider
     * @summary Disconnect a user from their bills sync provider
     * @param {'gmail' | 'amazon'} provider The name of the bills sync provider
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteBillsSyncProvider: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (provider, melioAccount, options = {}) {
      assertParamExists("deleteBillsSyncProvider", "provider", provider);
      const localVarPath = `/bills-sync/{provider}`.replace(`{${"provider"}}`, encodeURIComponent(String(provider)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "DELETE" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Retrieve an up-to-date view of the connection to the provider with sync status
     * @summary Retrieve the status of the current provider connection for Bills Sync
     * @param {'gmail' | 'amazon'} provider The name of the bills sync provider
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBillsSyncProviderStatus: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (provider, melioAccount, options = {}) {
      assertParamExists("getBillsSyncProviderStatus", "provider", provider);
      const localVarPath = `/bills-sync/{provider}`.replace(`{${"provider"}}`, encodeURIComponent(String(provider)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Generate a URL to start oauth flow for the provider
     * @summary Connect provider by redirecting a user to oauth page
     * @param {'gmail' | 'amazon'} provider The name of the bills sync provider
     * @param {PostBillsSyncRequest} [postBillsSyncRequest] 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postBillsSyncProvider: (_0, _1, _2, ..._3) => __async(this, [_0, _1, _2, ..._3], function* (provider, postBillsSyncRequest, melioAccount, options = {}) {
      assertParamExists("postBillsSyncProvider", "provider", provider);
      const localVarPath = `/bills-sync/{provider}`.replace(`{${"provider"}}`, encodeURIComponent(String(provider)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postBillsSyncRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    })
  };
};
var BillsSyncApiFp = function(configuration) {
  const localVarAxiosParamCreator = BillsSyncApiAxiosParamCreator(configuration);
  return {
    /**
     * Remove the connection between the current user/org and this bills sync provider
     * @summary Disconnect a user from their bills sync provider
     * @param {'gmail' | 'amazon'} provider The name of the bills sync provider
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteBillsSyncProvider(provider, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteBillsSyncProvider(provider, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Retrieve an up-to-date view of the connection to the provider with sync status
     * @summary Retrieve the status of the current provider connection for Bills Sync
     * @param {'gmail' | 'amazon'} provider The name of the bills sync provider
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBillsSyncProviderStatus(provider, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getBillsSyncProviderStatus(provider, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Generate a URL to start oauth flow for the provider
     * @summary Connect provider by redirecting a user to oauth page
     * @param {'gmail' | 'amazon'} provider The name of the bills sync provider
     * @param {PostBillsSyncRequest} [postBillsSyncRequest] 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postBillsSyncProvider(provider, postBillsSyncRequest, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postBillsSyncProvider(provider, postBillsSyncRequest, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    }
  };
};
var BillsSyncApiClient = createApiFromFp(BillsSyncApiFp);
var BillsSyncApiFactory = function(configuration, basePath, axios2) {
  const localVarFp = BillsSyncApiFp(configuration);
  return {
    /**
     * Remove the connection between the current user/org and this bills sync provider
     * @summary Disconnect a user from their bills sync provider
     * @param {'gmail' | 'amazon'} provider The name of the bills sync provider
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteBillsSyncProvider(provider, melioAccount, options) {
      return localVarFp.deleteBillsSyncProvider(provider, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Retrieve an up-to-date view of the connection to the provider with sync status
     * @summary Retrieve the status of the current provider connection for Bills Sync
     * @param {'gmail' | 'amazon'} provider The name of the bills sync provider
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBillsSyncProviderStatus(provider, melioAccount, options) {
      return localVarFp.getBillsSyncProviderStatus(provider, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Generate a URL to start oauth flow for the provider
     * @summary Connect provider by redirecting a user to oauth page
     * @param {'gmail' | 'amazon'} provider The name of the bills sync provider
     * @param {PostBillsSyncRequest} [postBillsSyncRequest] 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postBillsSyncProvider(provider, postBillsSyncRequest, melioAccount, options) {
      return localVarFp.postBillsSyncProvider(provider, postBillsSyncRequest, melioAccount, options).then((request) => request(axios2, basePath));
    }
  };
};
var BillsSyncApi = class extends BaseAPI {
  /**
   * Remove the connection between the current user/org and this bills sync provider
   * @summary Disconnect a user from their bills sync provider
   * @param {BillsSyncApiDeleteBillsSyncProviderRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BillsSyncApi
   */
  deleteBillsSyncProvider(requestParameters, options) {
    return BillsSyncApiFp(this.configuration).deleteBillsSyncProvider(requestParameters.provider, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Retrieve an up-to-date view of the connection to the provider with sync status
   * @summary Retrieve the status of the current provider connection for Bills Sync
   * @param {BillsSyncApiGetBillsSyncProviderStatusRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BillsSyncApi
   */
  getBillsSyncProviderStatus(requestParameters, options) {
    return BillsSyncApiFp(this.configuration).getBillsSyncProviderStatus(requestParameters.provider, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Generate a URL to start oauth flow for the provider
   * @summary Connect provider by redirecting a user to oauth page
   * @param {BillsSyncApiPostBillsSyncProviderRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BillsSyncApi
   */
  postBillsSyncProvider(requestParameters, options) {
    return BillsSyncApiFp(this.configuration).postBillsSyncProvider(requestParameters.provider, requestParameters.postBillsSyncRequest, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
};
var BillsSyncApiInstance = createInstanceFromApiIClass(BillsSyncApi);
var BillsSyncAmazonApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * Retrieve an up-to-date view of the connection to the provider with sync status
     * @summary Retrieve the status of the current provider connection for Bills Sync
     * @param {'gmail' | 'amazon'} provider The name of the bills sync provider
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBillsSyncProviderStatus: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (provider, melioAccount, options = {}) {
      assertParamExists("getBillsSyncProviderStatus", "provider", provider);
      const localVarPath = `/bills-sync/{provider}`.replace(`{${"provider"}}`, encodeURIComponent(String(provider)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    })
  };
};
var BillsSyncAmazonApiFp = function(configuration) {
  const localVarAxiosParamCreator = BillsSyncAmazonApiAxiosParamCreator(configuration);
  return {
    /**
     * Retrieve an up-to-date view of the connection to the provider with sync status
     * @summary Retrieve the status of the current provider connection for Bills Sync
     * @param {'gmail' | 'amazon'} provider The name of the bills sync provider
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBillsSyncProviderStatus(provider, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getBillsSyncProviderStatus(provider, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    }
  };
};
var BillsSyncAmazonApiClient = createApiFromFp(BillsSyncAmazonApiFp);
var BillsSyncAmazonApiFactory = function(configuration, basePath, axios2) {
  const localVarFp = BillsSyncAmazonApiFp(configuration);
  return {
    /**
     * Retrieve an up-to-date view of the connection to the provider with sync status
     * @summary Retrieve the status of the current provider connection for Bills Sync
     * @param {'gmail' | 'amazon'} provider The name of the bills sync provider
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBillsSyncProviderStatus(provider, melioAccount, options) {
      return localVarFp.getBillsSyncProviderStatus(provider, melioAccount, options).then((request) => request(axios2, basePath));
    }
  };
};
var BillsSyncAmazonApi = class extends BaseAPI {
  /**
   * Retrieve an up-to-date view of the connection to the provider with sync status
   * @summary Retrieve the status of the current provider connection for Bills Sync
   * @param {BillsSyncAmazonApiGetBillsSyncProviderStatusRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BillsSyncAmazonApi
   */
  getBillsSyncProviderStatus(requestParameters, options) {
    return BillsSyncAmazonApiFp(this.configuration).getBillsSyncProviderStatus(requestParameters.provider, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
};
var BillsSyncAmazonApiInstance = createInstanceFromApiIClass(BillsSyncAmazonApi);
var BillsSyncGmailApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * Retrieve an up-to-date view of the connection to the provider with sync status
     * @summary Retrieve the status of the current provider connection for Bills Sync
     * @param {'gmail' | 'amazon'} provider The name of the bills sync provider
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBillsSyncProviderStatus: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (provider, melioAccount, options = {}) {
      assertParamExists("getBillsSyncProviderStatus", "provider", provider);
      const localVarPath = `/bills-sync/{provider}`.replace(`{${"provider"}}`, encodeURIComponent(String(provider)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    })
  };
};
var BillsSyncGmailApiFp = function(configuration) {
  const localVarAxiosParamCreator = BillsSyncGmailApiAxiosParamCreator(configuration);
  return {
    /**
     * Retrieve an up-to-date view of the connection to the provider with sync status
     * @summary Retrieve the status of the current provider connection for Bills Sync
     * @param {'gmail' | 'amazon'} provider The name of the bills sync provider
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBillsSyncProviderStatus(provider, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getBillsSyncProviderStatus(provider, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    }
  };
};
var BillsSyncGmailApiClient = createApiFromFp(BillsSyncGmailApiFp);
var BillsSyncGmailApiFactory = function(configuration, basePath, axios2) {
  const localVarFp = BillsSyncGmailApiFp(configuration);
  return {
    /**
     * Retrieve an up-to-date view of the connection to the provider with sync status
     * @summary Retrieve the status of the current provider connection for Bills Sync
     * @param {'gmail' | 'amazon'} provider The name of the bills sync provider
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBillsSyncProviderStatus(provider, melioAccount, options) {
      return localVarFp.getBillsSyncProviderStatus(provider, melioAccount, options).then((request) => request(axios2, basePath));
    }
  };
};
var BillsSyncGmailApi = class extends BaseAPI {
  /**
   * Retrieve an up-to-date view of the connection to the provider with sync status
   * @summary Retrieve the status of the current provider connection for Bills Sync
   * @param {BillsSyncGmailApiGetBillsSyncProviderStatusRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BillsSyncGmailApi
   */
  getBillsSyncProviderStatus(requestParameters, options) {
    return BillsSyncGmailApiFp(this.configuration).getBillsSyncProviderStatus(requestParameters.provider, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
};
var BillsSyncGmailApiInstance = createInstanceFromApiIClass(BillsSyncGmailApi);
var BusinessDirectoryApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * Accept organization id and local vendor id of the same business and match them at business directory
     * @summary Matching between local vendor and owned-by vendor at Business directory
     * @param {string} id ID of the entity
     * @param {PostVendorsCopyDeliveryMethodRequest} [postVendorsCopyDeliveryMethodRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    copyDeliveryMethodFromOwnedVendorToLocalVendor: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (id, postVendorsCopyDeliveryMethodRequest, options = {}) {
      assertParamExists("copyDeliveryMethodFromOwnedVendorToLocalVendor", "id", id);
      const localVarPath = `/vendors/{id}/copy-delivery-method-from-owned-vendor`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postVendorsCopyDeliveryMethodRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    })
  };
};
var BusinessDirectoryApiFp = function(configuration) {
  const localVarAxiosParamCreator = BusinessDirectoryApiAxiosParamCreator(configuration);
  return {
    /**
     * Accept organization id and local vendor id of the same business and match them at business directory
     * @summary Matching between local vendor and owned-by vendor at Business directory
     * @param {string} id ID of the entity
     * @param {PostVendorsCopyDeliveryMethodRequest} [postVendorsCopyDeliveryMethodRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    copyDeliveryMethodFromOwnedVendorToLocalVendor(id, postVendorsCopyDeliveryMethodRequest, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.copyDeliveryMethodFromOwnedVendorToLocalVendor(id, postVendorsCopyDeliveryMethodRequest, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    }
  };
};
var BusinessDirectoryApiClient = createApiFromFp(BusinessDirectoryApiFp);
var BusinessDirectoryApiFactory = function(configuration, basePath, axios2) {
  const localVarFp = BusinessDirectoryApiFp(configuration);
  return {
    /**
     * Accept organization id and local vendor id of the same business and match them at business directory
     * @summary Matching between local vendor and owned-by vendor at Business directory
     * @param {string} id ID of the entity
     * @param {PostVendorsCopyDeliveryMethodRequest} [postVendorsCopyDeliveryMethodRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    copyDeliveryMethodFromOwnedVendorToLocalVendor(id, postVendorsCopyDeliveryMethodRequest, options) {
      return localVarFp.copyDeliveryMethodFromOwnedVendorToLocalVendor(id, postVendorsCopyDeliveryMethodRequest, options).then((request) => request(axios2, basePath));
    }
  };
};
var BusinessDirectoryApi = class extends BaseAPI {
  /**
   * Accept organization id and local vendor id of the same business and match them at business directory
   * @summary Matching between local vendor and owned-by vendor at Business directory
   * @param {BusinessDirectoryApiCopyDeliveryMethodFromOwnedVendorToLocalVendorRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BusinessDirectoryApi
   */
  copyDeliveryMethodFromOwnedVendorToLocalVendor(requestParameters, options) {
    return BusinessDirectoryApiFp(this.configuration).copyDeliveryMethodFromOwnedVendorToLocalVendor(requestParameters.id, requestParameters.postVendorsCopyDeliveryMethodRequest, options).then((request) => request(this.axios, this.basePath));
  }
};
var BusinessDirectoryApiInstance = createInstanceFromApiIClass(BusinessDirectoryApi);
var BusinessesApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * Search businesses by a searchTerm  The `Melio-Account` header is required for any request using API Key security. 
     * @summary Search in businesses
     * @param {string} searchTerm Search term query parameters - filter data by a word or phrase
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBusinesses: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (searchTerm, melioAccount, options = {}) {
      assertParamExists("getBusinesses", "searchTerm", searchTerm);
      const localVarPath = `/businesses`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (searchTerm !== void 0) {
        localVarQueryParameter["searchTerm"] = searchTerm;
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    })
  };
};
var BusinessesApiFp = function(configuration) {
  const localVarAxiosParamCreator = BusinessesApiAxiosParamCreator(configuration);
  return {
    /**
     * Search businesses by a searchTerm  The `Melio-Account` header is required for any request using API Key security. 
     * @summary Search in businesses
     * @param {string} searchTerm Search term query parameters - filter data by a word or phrase
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBusinesses(searchTerm, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getBusinesses(searchTerm, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    }
  };
};
var BusinessesApiClient = createApiFromFp(BusinessesApiFp);
var BusinessesApiFactory = function(configuration, basePath, axios2) {
  const localVarFp = BusinessesApiFp(configuration);
  return {
    /**
     * Search businesses by a searchTerm  The `Melio-Account` header is required for any request using API Key security. 
     * @summary Search in businesses
     * @param {string} searchTerm Search term query parameters - filter data by a word or phrase
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBusinesses(searchTerm, melioAccount, options) {
      return localVarFp.getBusinesses(searchTerm, melioAccount, options).then((request) => request(axios2, basePath));
    }
  };
};
var BusinessesApi = class extends BaseAPI {
  /**
   * Search businesses by a searchTerm  The `Melio-Account` header is required for any request using API Key security. 
   * @summary Search in businesses
   * @param {BusinessesApiGetBusinessesRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BusinessesApi
   */
  getBusinesses(requestParameters, options) {
    return BusinessesApiFp(this.configuration).getBusinesses(requestParameters.searchTerm, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
};
var BusinessesApiInstance = createInstanceFromApiIClass(BusinessesApi);
var CatalogItemsApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * This operation deletes a catalog-item by ID
     * @summary Delete a catalog-item by id
     * @param {string} id Id of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteCatalogItemCatalogItemId: (_0, ..._1) => __async(this, [_0, ..._1], function* (id, options = {}) {
      assertParamExists("deleteCatalogItemCatalogItemId", "id", id);
      const localVarPath = `/account-receivable/catalog-items/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "DELETE" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * This operation gets a catalog item by ID
     * @summary Get a catalog item by id
     * @param {string} id Id of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCatalogItemCatalogItemId: (_0, ..._1) => __async(this, [_0, ..._1], function* (id, options = {}) {
      assertParamExists("getCatalogItemCatalogItemId", "id", id);
      const localVarPath = `/account-receivable/catalog-items/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Retrieve a list of catalog items of user organization
     * @summary Retrieve organization catalog items
     * @param {string} [melioAccount] The &#x60;Melio-Account&#x60; header is used when a Partner wants to perform an operation on behalf of one of its Accounts. It contains the Account\&#39;s ID which returned when creating the Account, or when retrieving all of the Partner\&#39;s Accounts. Note that most operations are not permitted without the presence of this header.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCatalogItems: (_0, ..._1) => __async(this, [_0, ..._1], function* (melioAccount, options = {}) {
      const localVarPath = `/account-receivable/catalog-items`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Create a new catalog-item.
     * @summary Create catalog item
     * @param {PostCatalogItemRequest} [postCatalogItemRequest] 
     * @param {string} [melioAccount] The &#x60;Melio-Account&#x60; header is used when a Partner wants to perform an operation on behalf of one of its Accounts. It contains the Account\&#39;s ID which returned when creating the Account, or when retrieving all of the Partner\&#39;s Accounts. Note that most operations are not permitted without the presence of this header.
     * @param {SchemasExpand} [expand] Expand header parameters - use for expanding responses for POST &amp; PATCH requests
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postCatalogItem: (_0, _1, _2, ..._3) => __async(this, [_0, _1, _2, ..._3], function* (postCatalogItemRequest, melioAccount, expand, options = {}) {
      const localVarPath = `/account-receivable/catalog-items`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      if (expand !== void 0 && expand !== null) {
        localVarHeaderParameter["expand"] = String(JSON.stringify(expand));
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postCatalogItemRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Import a list of catalog items from a CSV file.
     * @summary Import a list of catalog items
     * @param {any} [file] 
     * @param {string} [melioAccount] The &#x60;Melio-Account&#x60; header is used when a Partner wants to perform an operation on behalf of one of its Accounts. It contains the Account\&#39;s ID which returned when creating the Account, or when retrieving all of the Partner\&#39;s Accounts. Note that most operations are not permitted without the presence of this header.
     * @param {SchemasExpand} [expand] Expand header parameters - use for expanding responses for POST &amp; PATCH requests
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postImportCatalogItems: (_0, _1, _2, ..._3) => __async(this, [_0, _1, _2, ..._3], function* (file, melioAccount, expand, options = {}) {
      const localVarPath = `/account-receivable/catalog-items/import`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      const localVarFormParams = new (configuration && configuration.formDataCtor || FormData)();
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      if (expand !== void 0 && expand !== null) {
        localVarHeaderParameter["expand"] = String(JSON.stringify(expand));
      }
      if (file !== void 0) {
        localVarFormParams.append("file", file);
      }
      localVarHeaderParameter["Content-Type"] = "multipart/form-data";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = localVarFormParams;
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Update a Catalog Item
     * @summary Update a Catalog Item
     * @param {string} id Id of the entity
     * @param {PatchCatalogItemRequest} [patchCatalogItemRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateCatalogItemCatalogItemId: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (id, patchCatalogItemRequest, options = {}) {
      assertParamExists("updateCatalogItemCatalogItemId", "id", id);
      const localVarPath = `/account-receivable/catalog-items/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "PATCH" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(patchCatalogItemRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    })
  };
};
var CatalogItemsApiFp = function(configuration) {
  const localVarAxiosParamCreator = CatalogItemsApiAxiosParamCreator(configuration);
  return {
    /**
     * This operation deletes a catalog-item by ID
     * @summary Delete a catalog-item by id
     * @param {string} id Id of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteCatalogItemCatalogItemId(id, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteCatalogItemCatalogItemId(id, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * This operation gets a catalog item by ID
     * @summary Get a catalog item by id
     * @param {string} id Id of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCatalogItemCatalogItemId(id, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getCatalogItemCatalogItemId(id, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Retrieve a list of catalog items of user organization
     * @summary Retrieve organization catalog items
     * @param {string} [melioAccount] The &#x60;Melio-Account&#x60; header is used when a Partner wants to perform an operation on behalf of one of its Accounts. It contains the Account\&#39;s ID which returned when creating the Account, or when retrieving all of the Partner\&#39;s Accounts. Note that most operations are not permitted without the presence of this header.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCatalogItems(melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getCatalogItems(melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Create a new catalog-item.
     * @summary Create catalog item
     * @param {PostCatalogItemRequest} [postCatalogItemRequest] 
     * @param {string} [melioAccount] The &#x60;Melio-Account&#x60; header is used when a Partner wants to perform an operation on behalf of one of its Accounts. It contains the Account\&#39;s ID which returned when creating the Account, or when retrieving all of the Partner\&#39;s Accounts. Note that most operations are not permitted without the presence of this header.
     * @param {SchemasExpand} [expand] Expand header parameters - use for expanding responses for POST &amp; PATCH requests
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postCatalogItem(postCatalogItemRequest, melioAccount, expand, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postCatalogItem(postCatalogItemRequest, melioAccount, expand, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Import a list of catalog items from a CSV file.
     * @summary Import a list of catalog items
     * @param {any} [file] 
     * @param {string} [melioAccount] The &#x60;Melio-Account&#x60; header is used when a Partner wants to perform an operation on behalf of one of its Accounts. It contains the Account\&#39;s ID which returned when creating the Account, or when retrieving all of the Partner\&#39;s Accounts. Note that most operations are not permitted without the presence of this header.
     * @param {SchemasExpand} [expand] Expand header parameters - use for expanding responses for POST &amp; PATCH requests
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postImportCatalogItems(file, melioAccount, expand, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postImportCatalogItems(file, melioAccount, expand, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Update a Catalog Item
     * @summary Update a Catalog Item
     * @param {string} id Id of the entity
     * @param {PatchCatalogItemRequest} [patchCatalogItemRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateCatalogItemCatalogItemId(id, patchCatalogItemRequest, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.updateCatalogItemCatalogItemId(id, patchCatalogItemRequest, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    }
  };
};
var CatalogItemsApiClient = createApiFromFp(CatalogItemsApiFp);
var CatalogItemsApiFactory = function(configuration, basePath, axios2) {
  const localVarFp = CatalogItemsApiFp(configuration);
  return {
    /**
     * This operation deletes a catalog-item by ID
     * @summary Delete a catalog-item by id
     * @param {string} id Id of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteCatalogItemCatalogItemId(id, options) {
      return localVarFp.deleteCatalogItemCatalogItemId(id, options).then((request) => request(axios2, basePath));
    },
    /**
     * This operation gets a catalog item by ID
     * @summary Get a catalog item by id
     * @param {string} id Id of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCatalogItemCatalogItemId(id, options) {
      return localVarFp.getCatalogItemCatalogItemId(id, options).then((request) => request(axios2, basePath));
    },
    /**
     * Retrieve a list of catalog items of user organization
     * @summary Retrieve organization catalog items
     * @param {string} [melioAccount] The &#x60;Melio-Account&#x60; header is used when a Partner wants to perform an operation on behalf of one of its Accounts. It contains the Account\&#39;s ID which returned when creating the Account, or when retrieving all of the Partner\&#39;s Accounts. Note that most operations are not permitted without the presence of this header.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCatalogItems(melioAccount, options) {
      return localVarFp.getCatalogItems(melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Create a new catalog-item.
     * @summary Create catalog item
     * @param {PostCatalogItemRequest} [postCatalogItemRequest] 
     * @param {string} [melioAccount] The &#x60;Melio-Account&#x60; header is used when a Partner wants to perform an operation on behalf of one of its Accounts. It contains the Account\&#39;s ID which returned when creating the Account, or when retrieving all of the Partner\&#39;s Accounts. Note that most operations are not permitted without the presence of this header.
     * @param {SchemasExpand} [expand] Expand header parameters - use for expanding responses for POST &amp; PATCH requests
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postCatalogItem(postCatalogItemRequest, melioAccount, expand, options) {
      return localVarFp.postCatalogItem(postCatalogItemRequest, melioAccount, expand, options).then((request) => request(axios2, basePath));
    },
    /**
     * Import a list of catalog items from a CSV file.
     * @summary Import a list of catalog items
     * @param {any} [file] 
     * @param {string} [melioAccount] The &#x60;Melio-Account&#x60; header is used when a Partner wants to perform an operation on behalf of one of its Accounts. It contains the Account\&#39;s ID which returned when creating the Account, or when retrieving all of the Partner\&#39;s Accounts. Note that most operations are not permitted without the presence of this header.
     * @param {SchemasExpand} [expand] Expand header parameters - use for expanding responses for POST &amp; PATCH requests
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postImportCatalogItems(file, melioAccount, expand, options) {
      return localVarFp.postImportCatalogItems(file, melioAccount, expand, options).then((request) => request(axios2, basePath));
    },
    /**
     * Update a Catalog Item
     * @summary Update a Catalog Item
     * @param {string} id Id of the entity
     * @param {PatchCatalogItemRequest} [patchCatalogItemRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateCatalogItemCatalogItemId(id, patchCatalogItemRequest, options) {
      return localVarFp.updateCatalogItemCatalogItemId(id, patchCatalogItemRequest, options).then((request) => request(axios2, basePath));
    }
  };
};
var CatalogItemsApi = class extends BaseAPI {
  /**
   * This operation deletes a catalog-item by ID
   * @summary Delete a catalog-item by id
   * @param {CatalogItemsApiDeleteCatalogItemCatalogItemIdRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CatalogItemsApi
   */
  deleteCatalogItemCatalogItemId(requestParameters, options) {
    return CatalogItemsApiFp(this.configuration).deleteCatalogItemCatalogItemId(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * This operation gets a catalog item by ID
   * @summary Get a catalog item by id
   * @param {CatalogItemsApiGetCatalogItemCatalogItemIdRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CatalogItemsApi
   */
  getCatalogItemCatalogItemId(requestParameters, options) {
    return CatalogItemsApiFp(this.configuration).getCatalogItemCatalogItemId(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Retrieve a list of catalog items of user organization
   * @summary Retrieve organization catalog items
   * @param {CatalogItemsApiGetCatalogItemsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CatalogItemsApi
   */
  getCatalogItems(requestParameters = {}, options) {
    return CatalogItemsApiFp(this.configuration).getCatalogItems(requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Create a new catalog-item.
   * @summary Create catalog item
   * @param {CatalogItemsApiPostCatalogItemRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CatalogItemsApi
   */
  postCatalogItem(requestParameters = {}, options) {
    return CatalogItemsApiFp(this.configuration).postCatalogItem(requestParameters.postCatalogItemRequest, requestParameters.melioAccount, requestParameters.expand, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Import a list of catalog items from a CSV file.
   * @summary Import a list of catalog items
   * @param {CatalogItemsApiPostImportCatalogItemsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CatalogItemsApi
   */
  postImportCatalogItems(requestParameters = {}, options) {
    return CatalogItemsApiFp(this.configuration).postImportCatalogItems(requestParameters.file, requestParameters.melioAccount, requestParameters.expand, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Update a Catalog Item
   * @summary Update a Catalog Item
   * @param {CatalogItemsApiUpdateCatalogItemCatalogItemIdRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CatalogItemsApi
   */
  updateCatalogItemCatalogItemId(requestParameters, options) {
    return CatalogItemsApiFp(this.configuration).updateCatalogItemCatalogItemId(requestParameters.id, requestParameters.patchCatalogItemRequest, options).then((request) => request(this.axios, this.basePath));
  }
};
var CatalogItemsApiInstance = createInstanceFromApiIClass(CatalogItemsApi);
var CustomersApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * This operation deletes a customer by ID
     * @summary Delete a customer by id
     * @param {string} id Id of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteCustomerCustomerId: (_0, ..._1) => __async(this, [_0, ..._1], function* (id, options = {}) {
      assertParamExists("deleteCustomerCustomerId", "id", id);
      const localVarPath = `/account-receivable/customer/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "DELETE" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * This operation gets a customer by ID
     * @summary Get a customer by id
     * @param {string} id Id of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCustomerCustomerId: (_0, ..._1) => __async(this, [_0, ..._1], function* (id, options = {}) {
      assertParamExists("getCustomerCustomerId", "id", id);
      const localVarPath = `/account-receivable/customer/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Retrieve a list of customers of user organization
     * @summary Retrieve organization customers
     * @param {string} [melioAccount] The &#x60;Melio-Account&#x60; header is used when a Partner wants to perform an operation on behalf of one of its Accounts. It contains the Account\&#39;s ID which returned when creating the Account, or when retrieving all of the Partner\&#39;s Accounts. Note that most operations are not permitted without the presence of this header.
     * @param {Date} [after] get all results after the specified updatedAt date
     * @param {number} [pageNumber] 
     * @param {string | number} [searchTerm] Search term query parameters - filter data by a word or phrase
     * @param {number} [limit] A limit on the number of records to be returned.
     * @param {CustomersSortQueryParam} [sort] Sort query parameter - sort data by entity fields
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCustomers: (_0, _1, _2, _3, _4, _5, _6, _7, ..._8) => __async(this, [_0, _1, _2, _3, _4, _5, _6, _7, ..._8], function* (melioAccount, after, pageNumber, searchTerm, limit, sort, organizationId, userId, options = {}) {
      const localVarPath = `/account-receivable/customer`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (after !== void 0) {
        localVarQueryParameter["after"] = after instanceof Date ? after.toISOString() : after;
      }
      if (pageNumber !== void 0) {
        localVarQueryParameter["pageNumber"] = pageNumber;
      }
      if (searchTerm !== void 0) {
        localVarQueryParameter["searchTerm"] = searchTerm;
      }
      if (limit !== void 0) {
        localVarQueryParameter["limit"] = limit;
      }
      if (sort !== void 0) {
        localVarQueryParameter["sort"] = sort;
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      if (organizationId !== void 0 && organizationId !== null) {
        localVarHeaderParameter["Organization-id"] = String(organizationId);
      }
      if (userId !== void 0 && userId !== null) {
        localVarHeaderParameter["User-id"] = String(userId);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Create a new Customer.
     * @summary Create a Customer
     * @param {PostCustomerRequest} [postCustomerRequest] 
     * @param {string} [melioAccount] The &#x60;Melio-Account&#x60; header is used when a Partner wants to perform an operation on behalf of one of its Accounts. It contains the Account\&#39;s ID which returned when creating the Account, or when retrieving all of the Partner\&#39;s Accounts. Note that most operations are not permitted without the presence of this header.
     * @param {SchemasExpand} [expand] Expand header parameters - use for expanding responses for POST &amp; PATCH requests
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postCustomer: (_0, _1, _2, ..._3) => __async(this, [_0, _1, _2, ..._3], function* (postCustomerRequest, melioAccount, expand, options = {}) {
      const localVarPath = `/account-receivable/customer`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      if (expand !== void 0 && expand !== null) {
        localVarHeaderParameter["expand"] = String(JSON.stringify(expand));
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postCustomerRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Import a list of customers from a CSV file.
     * @summary Import a list of customers
     * @param {any} [file] 
     * @param {string} [melioAccount] The &#x60;Melio-Account&#x60; header is used when a Partner wants to perform an operation on behalf of one of its Accounts. It contains the Account\&#39;s ID which returned when creating the Account, or when retrieving all of the Partner\&#39;s Accounts. Note that most operations are not permitted without the presence of this header.
     * @param {SchemasExpand} [expand] Expand header parameters - use for expanding responses for POST &amp; PATCH requests
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postImportCustomers: (_0, _1, _2, ..._3) => __async(this, [_0, _1, _2, ..._3], function* (file, melioAccount, expand, options = {}) {
      const localVarPath = `/account-receivable/customers/import`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      const localVarFormParams = new (configuration && configuration.formDataCtor || FormData)();
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      if (expand !== void 0 && expand !== null) {
        localVarHeaderParameter["expand"] = String(JSON.stringify(expand));
      }
      if (file !== void 0) {
        localVarFormParams.append("file", file);
      }
      localVarHeaderParameter["Content-Type"] = "multipart/form-data";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = localVarFormParams;
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Update a Customer by id
     * @summary Update a Customer
     * @param {string} id Id of the entity
     * @param {PatchCustomerRequest} [patchCustomerRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateCustomerById: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (id, patchCustomerRequest, options = {}) {
      assertParamExists("updateCustomerById", "id", id);
      const localVarPath = `/account-receivable/customer/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "PATCH" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(patchCustomerRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    })
  };
};
var CustomersApiFp = function(configuration) {
  const localVarAxiosParamCreator = CustomersApiAxiosParamCreator(configuration);
  return {
    /**
     * This operation deletes a customer by ID
     * @summary Delete a customer by id
     * @param {string} id Id of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteCustomerCustomerId(id, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteCustomerCustomerId(id, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * This operation gets a customer by ID
     * @summary Get a customer by id
     * @param {string} id Id of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCustomerCustomerId(id, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getCustomerCustomerId(id, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Retrieve a list of customers of user organization
     * @summary Retrieve organization customers
     * @param {string} [melioAccount] The &#x60;Melio-Account&#x60; header is used when a Partner wants to perform an operation on behalf of one of its Accounts. It contains the Account\&#39;s ID which returned when creating the Account, or when retrieving all of the Partner\&#39;s Accounts. Note that most operations are not permitted without the presence of this header.
     * @param {Date} [after] get all results after the specified updatedAt date
     * @param {number} [pageNumber] 
     * @param {string | number} [searchTerm] Search term query parameters - filter data by a word or phrase
     * @param {number} [limit] A limit on the number of records to be returned.
     * @param {CustomersSortQueryParam} [sort] Sort query parameter - sort data by entity fields
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCustomers(melioAccount, after, pageNumber, searchTerm, limit, sort, organizationId, userId, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getCustomers(melioAccount, after, pageNumber, searchTerm, limit, sort, organizationId, userId, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Create a new Customer.
     * @summary Create a Customer
     * @param {PostCustomerRequest} [postCustomerRequest] 
     * @param {string} [melioAccount] The &#x60;Melio-Account&#x60; header is used when a Partner wants to perform an operation on behalf of one of its Accounts. It contains the Account\&#39;s ID which returned when creating the Account, or when retrieving all of the Partner\&#39;s Accounts. Note that most operations are not permitted without the presence of this header.
     * @param {SchemasExpand} [expand] Expand header parameters - use for expanding responses for POST &amp; PATCH requests
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postCustomer(postCustomerRequest, melioAccount, expand, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postCustomer(postCustomerRequest, melioAccount, expand, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Import a list of customers from a CSV file.
     * @summary Import a list of customers
     * @param {any} [file] 
     * @param {string} [melioAccount] The &#x60;Melio-Account&#x60; header is used when a Partner wants to perform an operation on behalf of one of its Accounts. It contains the Account\&#39;s ID which returned when creating the Account, or when retrieving all of the Partner\&#39;s Accounts. Note that most operations are not permitted without the presence of this header.
     * @param {SchemasExpand} [expand] Expand header parameters - use for expanding responses for POST &amp; PATCH requests
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postImportCustomers(file, melioAccount, expand, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postImportCustomers(file, melioAccount, expand, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Update a Customer by id
     * @summary Update a Customer
     * @param {string} id Id of the entity
     * @param {PatchCustomerRequest} [patchCustomerRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateCustomerById(id, patchCustomerRequest, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.updateCustomerById(id, patchCustomerRequest, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    }
  };
};
var CustomersApiClient = createApiFromFp(CustomersApiFp);
var CustomersApiFactory = function(configuration, basePath, axios2) {
  const localVarFp = CustomersApiFp(configuration);
  return {
    /**
     * This operation deletes a customer by ID
     * @summary Delete a customer by id
     * @param {string} id Id of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteCustomerCustomerId(id, options) {
      return localVarFp.deleteCustomerCustomerId(id, options).then((request) => request(axios2, basePath));
    },
    /**
     * This operation gets a customer by ID
     * @summary Get a customer by id
     * @param {string} id Id of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCustomerCustomerId(id, options) {
      return localVarFp.getCustomerCustomerId(id, options).then((request) => request(axios2, basePath));
    },
    /**
     * Retrieve a list of customers of user organization
     * @summary Retrieve organization customers
     * @param {string} [melioAccount] The &#x60;Melio-Account&#x60; header is used when a Partner wants to perform an operation on behalf of one of its Accounts. It contains the Account\&#39;s ID which returned when creating the Account, or when retrieving all of the Partner\&#39;s Accounts. Note that most operations are not permitted without the presence of this header.
     * @param {Date} [after] get all results after the specified updatedAt date
     * @param {number} [pageNumber] 
     * @param {string | number} [searchTerm] Search term query parameters - filter data by a word or phrase
     * @param {number} [limit] A limit on the number of records to be returned.
     * @param {CustomersSortQueryParam} [sort] Sort query parameter - sort data by entity fields
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCustomers(melioAccount, after, pageNumber, searchTerm, limit, sort, organizationId, userId, options) {
      return localVarFp.getCustomers(melioAccount, after, pageNumber, searchTerm, limit, sort, organizationId, userId, options).then((request) => request(axios2, basePath));
    },
    /**
     * Create a new Customer.
     * @summary Create a Customer
     * @param {PostCustomerRequest} [postCustomerRequest] 
     * @param {string} [melioAccount] The &#x60;Melio-Account&#x60; header is used when a Partner wants to perform an operation on behalf of one of its Accounts. It contains the Account\&#39;s ID which returned when creating the Account, or when retrieving all of the Partner\&#39;s Accounts. Note that most operations are not permitted without the presence of this header.
     * @param {SchemasExpand} [expand] Expand header parameters - use for expanding responses for POST &amp; PATCH requests
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postCustomer(postCustomerRequest, melioAccount, expand, options) {
      return localVarFp.postCustomer(postCustomerRequest, melioAccount, expand, options).then((request) => request(axios2, basePath));
    },
    /**
     * Import a list of customers from a CSV file.
     * @summary Import a list of customers
     * @param {any} [file] 
     * @param {string} [melioAccount] The &#x60;Melio-Account&#x60; header is used when a Partner wants to perform an operation on behalf of one of its Accounts. It contains the Account\&#39;s ID which returned when creating the Account, or when retrieving all of the Partner\&#39;s Accounts. Note that most operations are not permitted without the presence of this header.
     * @param {SchemasExpand} [expand] Expand header parameters - use for expanding responses for POST &amp; PATCH requests
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postImportCustomers(file, melioAccount, expand, options) {
      return localVarFp.postImportCustomers(file, melioAccount, expand, options).then((request) => request(axios2, basePath));
    },
    /**
     * Update a Customer by id
     * @summary Update a Customer
     * @param {string} id Id of the entity
     * @param {PatchCustomerRequest} [patchCustomerRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateCustomerById(id, patchCustomerRequest, options) {
      return localVarFp.updateCustomerById(id, patchCustomerRequest, options).then((request) => request(axios2, basePath));
    }
  };
};
var CustomersApi = class extends BaseAPI {
  /**
   * This operation deletes a customer by ID
   * @summary Delete a customer by id
   * @param {CustomersApiDeleteCustomerCustomerIdRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CustomersApi
   */
  deleteCustomerCustomerId(requestParameters, options) {
    return CustomersApiFp(this.configuration).deleteCustomerCustomerId(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * This operation gets a customer by ID
   * @summary Get a customer by id
   * @param {CustomersApiGetCustomerCustomerIdRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CustomersApi
   */
  getCustomerCustomerId(requestParameters, options) {
    return CustomersApiFp(this.configuration).getCustomerCustomerId(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Retrieve a list of customers of user organization
   * @summary Retrieve organization customers
   * @param {CustomersApiGetCustomersRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CustomersApi
   */
  getCustomers(requestParameters = {}, options) {
    return CustomersApiFp(this.configuration).getCustomers(requestParameters.melioAccount, requestParameters.after, requestParameters.pageNumber, requestParameters.searchTerm, requestParameters.limit, requestParameters.sort, requestParameters.organizationId, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Create a new Customer.
   * @summary Create a Customer
   * @param {CustomersApiPostCustomerRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CustomersApi
   */
  postCustomer(requestParameters = {}, options) {
    return CustomersApiFp(this.configuration).postCustomer(requestParameters.postCustomerRequest, requestParameters.melioAccount, requestParameters.expand, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Import a list of customers from a CSV file.
   * @summary Import a list of customers
   * @param {CustomersApiPostImportCustomersRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CustomersApi
   */
  postImportCustomers(requestParameters = {}, options) {
    return CustomersApiFp(this.configuration).postImportCustomers(requestParameters.file, requestParameters.melioAccount, requestParameters.expand, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Update a Customer by id
   * @summary Update a Customer
   * @param {CustomersApiUpdateCustomerByIdRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CustomersApi
   */
  updateCustomerById(requestParameters, options) {
    return CustomersApiFp(this.configuration).updateCustomerById(requestParameters.id, requestParameters.patchCustomerRequest, options).then((request) => request(this.axios, this.basePath));
  }
};
var CustomersApiInstance = createInstanceFromApiIClass(CustomersApi);
var CustomersDashboardApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * Retrieve a list of customers for dashboard
     * @summary Retrieve organization customers for dashboard
     * @param {string} [melioAccount] The &#x60;Melio-Account&#x60; header is used when a Partner wants to perform an operation on behalf of one of its Accounts. It contains the Account\&#39;s ID which returned when creating the Account, or when retrieving all of the Partner\&#39;s Accounts. Note that most operations are not permitted without the presence of this header.
     * @param {number} [limit] A limit on the number of records to be returned.
     * @param {number} [pageNumber] 
     * @param {CustomersDashboardSortQueryParam} [sort] Sort query parameter - sort data by entity fields
     * @param {string | number} [searchTerm] Search term query parameters - filter data by a word or phrase
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCustomersDashboard: (_0, _1, _2, _3, _4, ..._5) => __async(this, [_0, _1, _2, _3, _4, ..._5], function* (melioAccount, limit, pageNumber, sort, searchTerm, options = {}) {
      const localVarPath = `/account-receivable/dashboard/customers`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (limit !== void 0) {
        localVarQueryParameter["limit"] = limit;
      }
      if (pageNumber !== void 0) {
        localVarQueryParameter["pageNumber"] = pageNumber;
      }
      if (sort !== void 0) {
        localVarQueryParameter["sort"] = sort;
      }
      if (searchTerm !== void 0) {
        localVarQueryParameter["searchTerm"] = searchTerm;
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    })
  };
};
var CustomersDashboardApiFp = function(configuration) {
  const localVarAxiosParamCreator = CustomersDashboardApiAxiosParamCreator(configuration);
  return {
    /**
     * Retrieve a list of customers for dashboard
     * @summary Retrieve organization customers for dashboard
     * @param {string} [melioAccount] The &#x60;Melio-Account&#x60; header is used when a Partner wants to perform an operation on behalf of one of its Accounts. It contains the Account\&#39;s ID which returned when creating the Account, or when retrieving all of the Partner\&#39;s Accounts. Note that most operations are not permitted without the presence of this header.
     * @param {number} [limit] A limit on the number of records to be returned.
     * @param {number} [pageNumber] 
     * @param {CustomersDashboardSortQueryParam} [sort] Sort query parameter - sort data by entity fields
     * @param {string | number} [searchTerm] Search term query parameters - filter data by a word or phrase
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCustomersDashboard(melioAccount, limit, pageNumber, sort, searchTerm, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getCustomersDashboard(melioAccount, limit, pageNumber, sort, searchTerm, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    }
  };
};
var CustomersDashboardApiClient = createApiFromFp(CustomersDashboardApiFp);
var CustomersDashboardApiFactory = function(configuration, basePath, axios2) {
  const localVarFp = CustomersDashboardApiFp(configuration);
  return {
    /**
     * Retrieve a list of customers for dashboard
     * @summary Retrieve organization customers for dashboard
     * @param {string} [melioAccount] The &#x60;Melio-Account&#x60; header is used when a Partner wants to perform an operation on behalf of one of its Accounts. It contains the Account\&#39;s ID which returned when creating the Account, or when retrieving all of the Partner\&#39;s Accounts. Note that most operations are not permitted without the presence of this header.
     * @param {number} [limit] A limit on the number of records to be returned.
     * @param {number} [pageNumber] 
     * @param {CustomersDashboardSortQueryParam} [sort] Sort query parameter - sort data by entity fields
     * @param {string | number} [searchTerm] Search term query parameters - filter data by a word or phrase
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCustomersDashboard(melioAccount, limit, pageNumber, sort, searchTerm, options) {
      return localVarFp.getCustomersDashboard(melioAccount, limit, pageNumber, sort, searchTerm, options).then((request) => request(axios2, basePath));
    }
  };
};
var CustomersDashboardApi = class extends BaseAPI {
  /**
   * Retrieve a list of customers for dashboard
   * @summary Retrieve organization customers for dashboard
   * @param {CustomersDashboardApiGetCustomersDashboardRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CustomersDashboardApi
   */
  getCustomersDashboard(requestParameters = {}, options) {
    return CustomersDashboardApiFp(this.configuration).getCustomersDashboard(requestParameters.melioAccount, requestParameters.limit, requestParameters.pageNumber, requestParameters.sort, requestParameters.searchTerm, options).then((request) => request(this.axios, this.basePath));
  }
};
var CustomersDashboardApiInstance = createInstanceFromApiIClass(CustomersDashboardApi);
var DefaultApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * 
     * @param {string} id ID of the entity
     * @param {PostVexVendorsSetCapLimitRequest} [postVexVendorsSetCapLimitRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postVexVendorsCapLimit: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (id, postVexVendorsSetCapLimitRequest, options = {}) {
      assertParamExists("postVexVendorsCapLimit", "id", id);
      const localVarPath = `/vex/vendors/{id}/cap-limit`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postVexVendorsSetCapLimitRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    })
  };
};
var DefaultApiFp = function(configuration) {
  const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration);
  return {
    /**
     * 
     * @param {string} id ID of the entity
     * @param {PostVexVendorsSetCapLimitRequest} [postVexVendorsSetCapLimitRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postVexVendorsCapLimit(id, postVexVendorsSetCapLimitRequest, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postVexVendorsCapLimit(id, postVexVendorsSetCapLimitRequest, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    }
  };
};
var DefaultApiClient = createApiFromFp(DefaultApiFp);
var DefaultApiFactory = function(configuration, basePath, axios2) {
  const localVarFp = DefaultApiFp(configuration);
  return {
    /**
     * 
     * @param {string} id ID of the entity
     * @param {PostVexVendorsSetCapLimitRequest} [postVexVendorsSetCapLimitRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postVexVendorsCapLimit(id, postVexVendorsSetCapLimitRequest, options) {
      return localVarFp.postVexVendorsCapLimit(id, postVexVendorsSetCapLimitRequest, options).then((request) => request(axios2, basePath));
    }
  };
};
var DefaultApi = class extends BaseAPI {
  /**
   * 
   * @param {DefaultApiPostVexVendorsCapLimitRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  postVexVendorsCapLimit(requestParameters, options) {
    return DefaultApiFp(this.configuration).postVexVendorsCapLimit(requestParameters.id, requestParameters.postVexVendorsSetCapLimitRequest, options).then((request) => request(this.axios, this.basePath));
  }
};
var DefaultApiInstance = createInstanceFromApiIClass(DefaultApi);
var DeliveryMethodTypeOptionsApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * Retrieve Vendor supported delivery method types
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getVendorsVendorIdDeliveryMethodTypeOptions: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (id, melioAccount, options = {}) {
      assertParamExists("getVendorsVendorIdDeliveryMethodTypeOptions", "id", id);
      const localVarPath = `/vendors/{id}/delivery-method-type-options`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    })
  };
};
var DeliveryMethodTypeOptionsApiFp = function(configuration) {
  const localVarAxiosParamCreator = DeliveryMethodTypeOptionsApiAxiosParamCreator(configuration);
  return {
    /**
     * Retrieve Vendor supported delivery method types
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getVendorsVendorIdDeliveryMethodTypeOptions(id, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getVendorsVendorIdDeliveryMethodTypeOptions(id, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    }
  };
};
var DeliveryMethodTypeOptionsApiClient = createApiFromFp(DeliveryMethodTypeOptionsApiFp);
var DeliveryMethodTypeOptionsApiFactory = function(configuration, basePath, axios2) {
  const localVarFp = DeliveryMethodTypeOptionsApiFp(configuration);
  return {
    /**
     * Retrieve Vendor supported delivery method types
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getVendorsVendorIdDeliveryMethodTypeOptions(id, melioAccount, options) {
      return localVarFp.getVendorsVendorIdDeliveryMethodTypeOptions(id, melioAccount, options).then((request) => request(axios2, basePath));
    }
  };
};
var DeliveryMethodTypeOptionsApi = class extends BaseAPI {
  /**
   * Retrieve Vendor supported delivery method types
   * @param {DeliveryMethodTypeOptionsApiGetVendorsVendorIdDeliveryMethodTypeOptionsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DeliveryMethodTypeOptionsApi
   */
  getVendorsVendorIdDeliveryMethodTypeOptions(requestParameters, options) {
    return DeliveryMethodTypeOptionsApiFp(this.configuration).getVendorsVendorIdDeliveryMethodTypeOptions(requestParameters.id, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
};
var DeliveryMethodTypeOptionsApiInstance = createInstanceFromApiIClass(DeliveryMethodTypeOptionsApi);
var DeliveryMethodsApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * Remove a Delivery Method from the Account
     * @summary Delete a Delivery Method
     * @param {string} id ID of the entity
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteDeliveryMethodsDeliveryMethodId: (_0, _1, _2, ..._3) => __async(this, [_0, _1, _2, ..._3], function* (id, idempotencyKey, melioAccount, options = {}) {
      assertParamExists("deleteDeliveryMethodsDeliveryMethodId", "id", id);
      const localVarPath = `/delivery-methods/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "DELETE" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (idempotencyKey !== void 0 && idempotencyKey !== null) {
        localVarHeaderParameter["Idempotency-Key"] = String(idempotencyKey);
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Retrieve bank details```
     * @summary Retrieve international bank details from bank code and type (iban/swift)
     * @param {PostBankDetailsRequest} [postBankDetailsRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBankDetails: (_0, ..._1) => __async(this, [_0, ..._1], function* (postBankDetailsRequest, options = {}) {
      const localVarPath = `/delivery-methods/international/bank-details`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postBankDetailsRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Retrieve a list of countries and international billing
     * @summary Retrieve international countries\' SupportedInternationalCountriesInfo
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCountries: (..._0) => __async(this, [..._0], function* (options = {}) {
      const localVarPath = `/delivery-methods/international/countries`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Get a delivery method\'s unmasked account number
     * @summary Get a delivery method\'s unmasked account number
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDeliveryMethodUnmaskedAccountNumber: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (id, melioAccount, options = {}) {
      assertParamExists("getDeliveryMethodUnmaskedAccountNumber", "id", id);
      const localVarPath = `/delivery-methods/{id}/unmasked-account-number`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Retrieve a list of all Delivery Methods the Account has
     * @summary Retrieve all Delivery Methods
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDeliveryMethods: (_0, ..._1) => __async(this, [_0, ..._1], function* (melioAccount, options = {}) {
      const localVarPath = `/delivery-methods`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Retrieve the details about a specific Delivery Method the Account has
     * @summary Retrieve a Delivery Method
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDeliveryMethodsDeliveryMethodId: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (id, melioAccount, options = {}) {
      assertParamExists("getDeliveryMethodsDeliveryMethodId", "id", id);
      const localVarPath = `/delivery-methods/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Get a list of a Vendor\'s Delivery Methods, that can be used to sent funds to.
     * @summary Retrieve a Vendor\'s Delivery Methods
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getVendorsVendorIdDeliveryMethods: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (id, melioAccount, options = {}) {
      assertParamExists("getVendorsVendorIdDeliveryMethods", "id", id);
      const localVarPath = `/vendors/{id}/delivery-methods`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Update a Delivery Method from the Account
     * @summary Update a Delivery Method
     * @param {string} id ID of the entity
     * @param {PatchDeliveryMethodsRequest} [patchDeliveryMethodsRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchDeliveryMethodsDeliveryMethodId: (_0, _1, _2, _3, ..._4) => __async(this, [_0, _1, _2, _3, ..._4], function* (id, patchDeliveryMethodsRequest, idempotencyKey, melioAccount, options = {}) {
      assertParamExists("patchDeliveryMethodsDeliveryMethodId", "id", id);
      const localVarPath = `/delivery-methods/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "PATCH" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (idempotencyKey !== void 0 && idempotencyKey !== null) {
        localVarHeaderParameter["Idempotency-Key"] = String(idempotencyKey);
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(patchDeliveryMethodsRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Add a new Delivery Method for the Account.  The `type` field determines the contents of the `details` field, according to the following mapping: * `bank-account` => `BankAccount` * `paper-check` => `PaperCheck` * `virtual-account` => `VirtualAccount`
     * @summary Create a Delivery Method
     * @param {PostDeliveryMethodsRequest} [postDeliveryMethodsRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [userId] 
     * @param {string} [organizationId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postDeliveryMethods: (_0, _1, _2, _3, _4, ..._5) => __async(this, [_0, _1, _2, _3, _4, ..._5], function* (postDeliveryMethodsRequest, idempotencyKey, melioAccount, userId, organizationId, options = {}) {
      const localVarPath = `/delivery-methods`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (idempotencyKey !== void 0 && idempotencyKey !== null) {
        localVarHeaderParameter["Idempotency-Key"] = String(idempotencyKey);
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      if (userId !== void 0 && userId !== null) {
        localVarHeaderParameter["User-id"] = String(userId);
      }
      if (organizationId !== void 0 && organizationId !== null) {
        localVarHeaderParameter["Organization-id"] = String(organizationId);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postDeliveryMethodsRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Confirm a Delivery Method
     * @summary Confirm a Delivery Method
     * @param {string} id ID of the entity
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postDeliveryMethodsDeliveryMethodIdConfirm: (_0, _1, _2, ..._3) => __async(this, [_0, _1, _2, ..._3], function* (id, idempotencyKey, melioAccount, options = {}) {
      assertParamExists("postDeliveryMethodsDeliveryMethodIdConfirm", "id", id);
      const localVarPath = `/delivery-methods/{id}/confirm`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (idempotencyKey !== void 0 && idempotencyKey !== null) {
        localVarHeaderParameter["Idempotency-Key"] = String(idempotencyKey);
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * This operation returns an access token for using plaid link
     * @summary Create access token for plaid link
     * @param {PostDeliveryMethodsPlaidLinkTokenRequest} [postDeliveryMethodsPlaidLinkTokenRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postDeliveryMethodsPlaidLinkToken: (_0, _1, _2, ..._3) => __async(this, [_0, _1, _2, ..._3], function* (postDeliveryMethodsPlaidLinkTokenRequest, idempotencyKey, melioAccount, options = {}) {
      const localVarPath = `/delivery-methods/plaid/link/token`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (idempotencyKey !== void 0 && idempotencyKey !== null) {
        localVarHeaderParameter["Idempotency-Key"] = String(idempotencyKey);
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postDeliveryMethodsPlaidLinkTokenRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Verify Micro Deposit for the Delivery Method.
     * @summary Verify micro deposit
     * @param {PostDeliveryMethodsVerifyMicroDepositRequest} [postDeliveryMethodsVerifyMicroDepositRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postDeliveryMethodsVerifyMicroDeposit: (_0, _1, _2, ..._3) => __async(this, [_0, _1, _2, ..._3], function* (postDeliveryMethodsVerifyMicroDepositRequest, idempotencyKey, melioAccount, options = {}) {
      const localVarPath = `/delivery-methods/verify-micro-deposit`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (idempotencyKey !== void 0 && idempotencyKey !== null) {
        localVarHeaderParameter["Idempotency-Key"] = String(idempotencyKey);
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postDeliveryMethodsVerifyMicroDepositRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Create a Vendor\'s Delivery Method
     * @summary Create a Vendor\'s Delivery Method
     * @param {string} id ID of the entity
     * @param {PostDeliveryMethodsRequest} [body] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postVendorsVendorIdDeliveryMethods: (_0, _1, _2, _3, ..._4) => __async(this, [_0, _1, _2, _3, ..._4], function* (id, body, idempotencyKey, melioAccount, options = {}) {
      assertParamExists("postVendorsVendorIdDeliveryMethods", "id", id);
      const localVarPath = `/vendors/{id}/delivery-methods`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (idempotencyKey !== void 0 && idempotencyKey !== null) {
        localVarHeaderParameter["Idempotency-Key"] = String(idempotencyKey);
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Update delivery-methods plaid account
     * @summary Update delivery-methods plaid account
     * @param {string} id ID of the entity
     * @param {PutDeliveryMethodsUpdatePlaidAccountRequest} [putDeliveryMethodsUpdatePlaidAccountRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    putDeliveryMethodsUpdatePlaidAccount: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (id, putDeliveryMethodsUpdatePlaidAccountRequest, options = {}) {
      assertParamExists("putDeliveryMethodsUpdatePlaidAccount", "id", id);
      const localVarPath = `/delivery-methods/{id}/plaid-account`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "PUT" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(putDeliveryMethodsUpdatePlaidAccountRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    })
  };
};
var DeliveryMethodsApiFp = function(configuration) {
  const localVarAxiosParamCreator = DeliveryMethodsApiAxiosParamCreator(configuration);
  return {
    /**
     * Remove a Delivery Method from the Account
     * @summary Delete a Delivery Method
     * @param {string} id ID of the entity
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteDeliveryMethodsDeliveryMethodId(id, idempotencyKey, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteDeliveryMethodsDeliveryMethodId(id, idempotencyKey, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Retrieve bank details```
     * @summary Retrieve international bank details from bank code and type (iban/swift)
     * @param {PostBankDetailsRequest} [postBankDetailsRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBankDetails(postBankDetailsRequest, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getBankDetails(postBankDetailsRequest, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Retrieve a list of countries and international billing
     * @summary Retrieve international countries\' SupportedInternationalCountriesInfo
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCountries(options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getCountries(options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Get a delivery method\'s unmasked account number
     * @summary Get a delivery method\'s unmasked account number
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDeliveryMethodUnmaskedAccountNumber(id, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getDeliveryMethodUnmaskedAccountNumber(id, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Retrieve a list of all Delivery Methods the Account has
     * @summary Retrieve all Delivery Methods
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDeliveryMethods(melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getDeliveryMethods(melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Retrieve the details about a specific Delivery Method the Account has
     * @summary Retrieve a Delivery Method
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDeliveryMethodsDeliveryMethodId(id, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getDeliveryMethodsDeliveryMethodId(id, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Get a list of a Vendor\'s Delivery Methods, that can be used to sent funds to.
     * @summary Retrieve a Vendor\'s Delivery Methods
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getVendorsVendorIdDeliveryMethods(id, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getVendorsVendorIdDeliveryMethods(id, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Update a Delivery Method from the Account
     * @summary Update a Delivery Method
     * @param {string} id ID of the entity
     * @param {PatchDeliveryMethodsRequest} [patchDeliveryMethodsRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchDeliveryMethodsDeliveryMethodId(id, patchDeliveryMethodsRequest, idempotencyKey, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.patchDeliveryMethodsDeliveryMethodId(id, patchDeliveryMethodsRequest, idempotencyKey, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Add a new Delivery Method for the Account.  The `type` field determines the contents of the `details` field, according to the following mapping: * `bank-account` => `BankAccount` * `paper-check` => `PaperCheck` * `virtual-account` => `VirtualAccount`
     * @summary Create a Delivery Method
     * @param {PostDeliveryMethodsRequest} [postDeliveryMethodsRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [userId] 
     * @param {string} [organizationId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postDeliveryMethods(postDeliveryMethodsRequest, idempotencyKey, melioAccount, userId, organizationId, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postDeliveryMethods(postDeliveryMethodsRequest, idempotencyKey, melioAccount, userId, organizationId, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Confirm a Delivery Method
     * @summary Confirm a Delivery Method
     * @param {string} id ID of the entity
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postDeliveryMethodsDeliveryMethodIdConfirm(id, idempotencyKey, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postDeliveryMethodsDeliveryMethodIdConfirm(id, idempotencyKey, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * This operation returns an access token for using plaid link
     * @summary Create access token for plaid link
     * @param {PostDeliveryMethodsPlaidLinkTokenRequest} [postDeliveryMethodsPlaidLinkTokenRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postDeliveryMethodsPlaidLinkToken(postDeliveryMethodsPlaidLinkTokenRequest, idempotencyKey, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postDeliveryMethodsPlaidLinkToken(postDeliveryMethodsPlaidLinkTokenRequest, idempotencyKey, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Verify Micro Deposit for the Delivery Method.
     * @summary Verify micro deposit
     * @param {PostDeliveryMethodsVerifyMicroDepositRequest} [postDeliveryMethodsVerifyMicroDepositRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postDeliveryMethodsVerifyMicroDeposit(postDeliveryMethodsVerifyMicroDepositRequest, idempotencyKey, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postDeliveryMethodsVerifyMicroDeposit(postDeliveryMethodsVerifyMicroDepositRequest, idempotencyKey, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Create a Vendor\'s Delivery Method
     * @summary Create a Vendor\'s Delivery Method
     * @param {string} id ID of the entity
     * @param {PostDeliveryMethodsRequest} [body] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postVendorsVendorIdDeliveryMethods(id, body, idempotencyKey, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postVendorsVendorIdDeliveryMethods(id, body, idempotencyKey, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Update delivery-methods plaid account
     * @summary Update delivery-methods plaid account
     * @param {string} id ID of the entity
     * @param {PutDeliveryMethodsUpdatePlaidAccountRequest} [putDeliveryMethodsUpdatePlaidAccountRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    putDeliveryMethodsUpdatePlaidAccount(id, putDeliveryMethodsUpdatePlaidAccountRequest, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.putDeliveryMethodsUpdatePlaidAccount(id, putDeliveryMethodsUpdatePlaidAccountRequest, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    }
  };
};
var DeliveryMethodsApiClient = createApiFromFp(DeliveryMethodsApiFp);
var DeliveryMethodsApiFactory = function(configuration, basePath, axios2) {
  const localVarFp = DeliveryMethodsApiFp(configuration);
  return {
    /**
     * Remove a Delivery Method from the Account
     * @summary Delete a Delivery Method
     * @param {string} id ID of the entity
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteDeliveryMethodsDeliveryMethodId(id, idempotencyKey, melioAccount, options) {
      return localVarFp.deleteDeliveryMethodsDeliveryMethodId(id, idempotencyKey, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Retrieve bank details```
     * @summary Retrieve international bank details from bank code and type (iban/swift)
     * @param {PostBankDetailsRequest} [postBankDetailsRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBankDetails(postBankDetailsRequest, options) {
      return localVarFp.getBankDetails(postBankDetailsRequest, options).then((request) => request(axios2, basePath));
    },
    /**
     * Retrieve a list of countries and international billing
     * @summary Retrieve international countries\' SupportedInternationalCountriesInfo
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCountries(options) {
      return localVarFp.getCountries(options).then((request) => request(axios2, basePath));
    },
    /**
     * Get a delivery method\'s unmasked account number
     * @summary Get a delivery method\'s unmasked account number
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDeliveryMethodUnmaskedAccountNumber(id, melioAccount, options) {
      return localVarFp.getDeliveryMethodUnmaskedAccountNumber(id, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Retrieve a list of all Delivery Methods the Account has
     * @summary Retrieve all Delivery Methods
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDeliveryMethods(melioAccount, options) {
      return localVarFp.getDeliveryMethods(melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Retrieve the details about a specific Delivery Method the Account has
     * @summary Retrieve a Delivery Method
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDeliveryMethodsDeliveryMethodId(id, melioAccount, options) {
      return localVarFp.getDeliveryMethodsDeliveryMethodId(id, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Get a list of a Vendor\'s Delivery Methods, that can be used to sent funds to.
     * @summary Retrieve a Vendor\'s Delivery Methods
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getVendorsVendorIdDeliveryMethods(id, melioAccount, options) {
      return localVarFp.getVendorsVendorIdDeliveryMethods(id, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Update a Delivery Method from the Account
     * @summary Update a Delivery Method
     * @param {string} id ID of the entity
     * @param {PatchDeliveryMethodsRequest} [patchDeliveryMethodsRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchDeliveryMethodsDeliveryMethodId(id, patchDeliveryMethodsRequest, idempotencyKey, melioAccount, options) {
      return localVarFp.patchDeliveryMethodsDeliveryMethodId(id, patchDeliveryMethodsRequest, idempotencyKey, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Add a new Delivery Method for the Account.  The `type` field determines the contents of the `details` field, according to the following mapping: * `bank-account` => `BankAccount` * `paper-check` => `PaperCheck` * `virtual-account` => `VirtualAccount`
     * @summary Create a Delivery Method
     * @param {PostDeliveryMethodsRequest} [postDeliveryMethodsRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [userId] 
     * @param {string} [organizationId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postDeliveryMethods(postDeliveryMethodsRequest, idempotencyKey, melioAccount, userId, organizationId, options) {
      return localVarFp.postDeliveryMethods(postDeliveryMethodsRequest, idempotencyKey, melioAccount, userId, organizationId, options).then((request) => request(axios2, basePath));
    },
    /**
     * Confirm a Delivery Method
     * @summary Confirm a Delivery Method
     * @param {string} id ID of the entity
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postDeliveryMethodsDeliveryMethodIdConfirm(id, idempotencyKey, melioAccount, options) {
      return localVarFp.postDeliveryMethodsDeliveryMethodIdConfirm(id, idempotencyKey, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * This operation returns an access token for using plaid link
     * @summary Create access token for plaid link
     * @param {PostDeliveryMethodsPlaidLinkTokenRequest} [postDeliveryMethodsPlaidLinkTokenRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postDeliveryMethodsPlaidLinkToken(postDeliveryMethodsPlaidLinkTokenRequest, idempotencyKey, melioAccount, options) {
      return localVarFp.postDeliveryMethodsPlaidLinkToken(postDeliveryMethodsPlaidLinkTokenRequest, idempotencyKey, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Verify Micro Deposit for the Delivery Method.
     * @summary Verify micro deposit
     * @param {PostDeliveryMethodsVerifyMicroDepositRequest} [postDeliveryMethodsVerifyMicroDepositRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postDeliveryMethodsVerifyMicroDeposit(postDeliveryMethodsVerifyMicroDepositRequest, idempotencyKey, melioAccount, options) {
      return localVarFp.postDeliveryMethodsVerifyMicroDeposit(postDeliveryMethodsVerifyMicroDepositRequest, idempotencyKey, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Create a Vendor\'s Delivery Method
     * @summary Create a Vendor\'s Delivery Method
     * @param {string} id ID of the entity
     * @param {PostDeliveryMethodsRequest} [body] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postVendorsVendorIdDeliveryMethods(id, body, idempotencyKey, melioAccount, options) {
      return localVarFp.postVendorsVendorIdDeliveryMethods(id, body, idempotencyKey, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Update delivery-methods plaid account
     * @summary Update delivery-methods plaid account
     * @param {string} id ID of the entity
     * @param {PutDeliveryMethodsUpdatePlaidAccountRequest} [putDeliveryMethodsUpdatePlaidAccountRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    putDeliveryMethodsUpdatePlaidAccount(id, putDeliveryMethodsUpdatePlaidAccountRequest, options) {
      return localVarFp.putDeliveryMethodsUpdatePlaidAccount(id, putDeliveryMethodsUpdatePlaidAccountRequest, options).then((request) => request(axios2, basePath));
    }
  };
};
var DeliveryMethodsApi = class extends BaseAPI {
  /**
   * Remove a Delivery Method from the Account
   * @summary Delete a Delivery Method
   * @param {DeliveryMethodsApiDeleteDeliveryMethodsDeliveryMethodIdRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DeliveryMethodsApi
   */
  deleteDeliveryMethodsDeliveryMethodId(requestParameters, options) {
    return DeliveryMethodsApiFp(this.configuration).deleteDeliveryMethodsDeliveryMethodId(requestParameters.id, requestParameters.idempotencyKey, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Retrieve bank details```
   * @summary Retrieve international bank details from bank code and type (iban/swift)
   * @param {DeliveryMethodsApiGetBankDetailsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DeliveryMethodsApi
   */
  getBankDetails(requestParameters = {}, options) {
    return DeliveryMethodsApiFp(this.configuration).getBankDetails(requestParameters.postBankDetailsRequest, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Retrieve a list of countries and international billing
   * @summary Retrieve international countries\' SupportedInternationalCountriesInfo
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DeliveryMethodsApi
   */
  getCountries(options) {
    return DeliveryMethodsApiFp(this.configuration).getCountries(options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Get a delivery method\'s unmasked account number
   * @summary Get a delivery method\'s unmasked account number
   * @param {DeliveryMethodsApiGetDeliveryMethodUnmaskedAccountNumberRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DeliveryMethodsApi
   */
  getDeliveryMethodUnmaskedAccountNumber(requestParameters, options) {
    return DeliveryMethodsApiFp(this.configuration).getDeliveryMethodUnmaskedAccountNumber(requestParameters.id, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Retrieve a list of all Delivery Methods the Account has
   * @summary Retrieve all Delivery Methods
   * @param {DeliveryMethodsApiGetDeliveryMethodsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DeliveryMethodsApi
   */
  getDeliveryMethods(requestParameters = {}, options) {
    return DeliveryMethodsApiFp(this.configuration).getDeliveryMethods(requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Retrieve the details about a specific Delivery Method the Account has
   * @summary Retrieve a Delivery Method
   * @param {DeliveryMethodsApiGetDeliveryMethodsDeliveryMethodIdRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DeliveryMethodsApi
   */
  getDeliveryMethodsDeliveryMethodId(requestParameters, options) {
    return DeliveryMethodsApiFp(this.configuration).getDeliveryMethodsDeliveryMethodId(requestParameters.id, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Get a list of a Vendor\'s Delivery Methods, that can be used to sent funds to.
   * @summary Retrieve a Vendor\'s Delivery Methods
   * @param {DeliveryMethodsApiGetVendorsVendorIdDeliveryMethodsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DeliveryMethodsApi
   */
  getVendorsVendorIdDeliveryMethods(requestParameters, options) {
    return DeliveryMethodsApiFp(this.configuration).getVendorsVendorIdDeliveryMethods(requestParameters.id, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Update a Delivery Method from the Account
   * @summary Update a Delivery Method
   * @param {DeliveryMethodsApiPatchDeliveryMethodsDeliveryMethodIdRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DeliveryMethodsApi
   */
  patchDeliveryMethodsDeliveryMethodId(requestParameters, options) {
    return DeliveryMethodsApiFp(this.configuration).patchDeliveryMethodsDeliveryMethodId(requestParameters.id, requestParameters.patchDeliveryMethodsRequest, requestParameters.idempotencyKey, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Add a new Delivery Method for the Account.  The `type` field determines the contents of the `details` field, according to the following mapping: * `bank-account` => `BankAccount` * `paper-check` => `PaperCheck` * `virtual-account` => `VirtualAccount`
   * @summary Create a Delivery Method
   * @param {DeliveryMethodsApiPostDeliveryMethodsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DeliveryMethodsApi
   */
  postDeliveryMethods(requestParameters = {}, options) {
    return DeliveryMethodsApiFp(this.configuration).postDeliveryMethods(requestParameters.postDeliveryMethodsRequest, requestParameters.idempotencyKey, requestParameters.melioAccount, requestParameters.userId, requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Confirm a Delivery Method
   * @summary Confirm a Delivery Method
   * @param {DeliveryMethodsApiPostDeliveryMethodsDeliveryMethodIdConfirmRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DeliveryMethodsApi
   */
  postDeliveryMethodsDeliveryMethodIdConfirm(requestParameters, options) {
    return DeliveryMethodsApiFp(this.configuration).postDeliveryMethodsDeliveryMethodIdConfirm(requestParameters.id, requestParameters.idempotencyKey, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * This operation returns an access token for using plaid link
   * @summary Create access token for plaid link
   * @param {DeliveryMethodsApiPostDeliveryMethodsPlaidLinkTokenRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DeliveryMethodsApi
   */
  postDeliveryMethodsPlaidLinkToken(requestParameters = {}, options) {
    return DeliveryMethodsApiFp(this.configuration).postDeliveryMethodsPlaidLinkToken(requestParameters.postDeliveryMethodsPlaidLinkTokenRequest, requestParameters.idempotencyKey, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Verify Micro Deposit for the Delivery Method.
   * @summary Verify micro deposit
   * @param {DeliveryMethodsApiPostDeliveryMethodsVerifyMicroDepositRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DeliveryMethodsApi
   */
  postDeliveryMethodsVerifyMicroDeposit(requestParameters = {}, options) {
    return DeliveryMethodsApiFp(this.configuration).postDeliveryMethodsVerifyMicroDeposit(requestParameters.postDeliveryMethodsVerifyMicroDepositRequest, requestParameters.idempotencyKey, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Create a Vendor\'s Delivery Method
   * @summary Create a Vendor\'s Delivery Method
   * @param {DeliveryMethodsApiPostVendorsVendorIdDeliveryMethodsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DeliveryMethodsApi
   */
  postVendorsVendorIdDeliveryMethods(requestParameters, options) {
    return DeliveryMethodsApiFp(this.configuration).postVendorsVendorIdDeliveryMethods(requestParameters.id, requestParameters.body, requestParameters.idempotencyKey, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Update delivery-methods plaid account
   * @summary Update delivery-methods plaid account
   * @param {DeliveryMethodsApiPutDeliveryMethodsUpdatePlaidAccountRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DeliveryMethodsApi
   */
  putDeliveryMethodsUpdatePlaidAccount(requestParameters, options) {
    return DeliveryMethodsApiFp(this.configuration).putDeliveryMethodsUpdatePlaidAccount(requestParameters.id, requestParameters.putDeliveryMethodsUpdatePlaidAccountRequest, options).then((request) => request(this.axios, this.basePath));
  }
};
var DeliveryMethodsApiInstance = createInstanceFromApiIClass(DeliveryMethodsApi);
var DemoRequestsApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * Retrieve a list of all DemoRequests
     * @summary Retrieve all DemoRequests
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDemoRequests: (..._0) => __async(this, [..._0], function* (options = {}) {
      const localVarPath = `/demo-request`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Request a Demo.
     * @summary Request a Demo
     * @param {PostDemoRequestRequest} [postDemoRequestRequest] 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postDemoRequest: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (postDemoRequestRequest, melioAccount, options = {}) {
      const localVarPath = `/demo-request`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postDemoRequestRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    })
  };
};
var DemoRequestsApiFp = function(configuration) {
  const localVarAxiosParamCreator = DemoRequestsApiAxiosParamCreator(configuration);
  return {
    /**
     * Retrieve a list of all DemoRequests
     * @summary Retrieve all DemoRequests
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDemoRequests(options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getDemoRequests(options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Request a Demo.
     * @summary Request a Demo
     * @param {PostDemoRequestRequest} [postDemoRequestRequest] 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postDemoRequest(postDemoRequestRequest, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postDemoRequest(postDemoRequestRequest, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    }
  };
};
var DemoRequestsApiClient = createApiFromFp(DemoRequestsApiFp);
var DemoRequestsApiFactory = function(configuration, basePath, axios2) {
  const localVarFp = DemoRequestsApiFp(configuration);
  return {
    /**
     * Retrieve a list of all DemoRequests
     * @summary Retrieve all DemoRequests
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDemoRequests(options) {
      return localVarFp.getDemoRequests(options).then((request) => request(axios2, basePath));
    },
    /**
     * Request a Demo.
     * @summary Request a Demo
     * @param {PostDemoRequestRequest} [postDemoRequestRequest] 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postDemoRequest(postDemoRequestRequest, melioAccount, options) {
      return localVarFp.postDemoRequest(postDemoRequestRequest, melioAccount, options).then((request) => request(axios2, basePath));
    }
  };
};
var DemoRequestsApi = class extends BaseAPI {
  /**
   * Retrieve a list of all DemoRequests
   * @summary Retrieve all DemoRequests
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DemoRequestsApi
   */
  getDemoRequests(options) {
    return DemoRequestsApiFp(this.configuration).getDemoRequests(options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Request a Demo.
   * @summary Request a Demo
   * @param {DemoRequestsApiPostDemoRequestRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DemoRequestsApi
   */
  postDemoRequest(requestParameters = {}, options) {
    return DemoRequestsApiFp(this.configuration).postDemoRequest(requestParameters.postDemoRequestRequest, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
};
var DemoRequestsApiInstance = createInstanceFromApiIClass(DemoRequestsApi);
var EBillsSubscriptionsApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * 
     * @summary cancel vendor ebills subscription
     * @param {string} id ID of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteEbillsSubscription: (_0, ..._1) => __async(this, [_0, ..._1], function* (id, options = {}) {
      assertParamExists("deleteEbillsSubscription", "id", id);
      const localVarPath = `/vendors/{id}/ebills-subscription`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "DELETE" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Get a vendor\'s ebill subscription form
     * @summary Get a vendor\'s ebill subscription form
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getVendorEbillsSubscriptionForm: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (id, melioAccount, options = {}) {
      assertParamExists("getVendorEbillsSubscriptionForm", "id", id);
      const localVarPath = `/vendors/{id}/ebills-subscription/options`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * 
     * @summary create vendor ebills subscription
     * @param {PostVendorEbillsSubscriptionRequest} postVendorEbillsSubscriptionRequest vendor ebills subscription parameters
     * @param {string} id ID of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postEbillsSubscription: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (postVendorEbillsSubscriptionRequest, id, options = {}) {
      assertParamExists("postEbillsSubscription", "postVendorEbillsSubscriptionRequest", postVendorEbillsSubscriptionRequest);
      assertParamExists("postEbillsSubscription", "id", id);
      const localVarPath = `/vendors/{id}/ebills-subscription`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postVendorEbillsSubscriptionRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    })
  };
};
var EBillsSubscriptionsApiFp = function(configuration) {
  const localVarAxiosParamCreator = EBillsSubscriptionsApiAxiosParamCreator(configuration);
  return {
    /**
     * 
     * @summary cancel vendor ebills subscription
     * @param {string} id ID of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteEbillsSubscription(id, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteEbillsSubscription(id, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Get a vendor\'s ebill subscription form
     * @summary Get a vendor\'s ebill subscription form
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getVendorEbillsSubscriptionForm(id, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getVendorEbillsSubscriptionForm(id, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * 
     * @summary create vendor ebills subscription
     * @param {PostVendorEbillsSubscriptionRequest} postVendorEbillsSubscriptionRequest vendor ebills subscription parameters
     * @param {string} id ID of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postEbillsSubscription(postVendorEbillsSubscriptionRequest, id, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postEbillsSubscription(postVendorEbillsSubscriptionRequest, id, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    }
  };
};
var EBillsSubscriptionsApiClient = createApiFromFp(EBillsSubscriptionsApiFp);
var EBillsSubscriptionsApiFactory = function(configuration, basePath, axios2) {
  const localVarFp = EBillsSubscriptionsApiFp(configuration);
  return {
    /**
     * 
     * @summary cancel vendor ebills subscription
     * @param {string} id ID of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteEbillsSubscription(id, options) {
      return localVarFp.deleteEbillsSubscription(id, options).then((request) => request(axios2, basePath));
    },
    /**
     * Get a vendor\'s ebill subscription form
     * @summary Get a vendor\'s ebill subscription form
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getVendorEbillsSubscriptionForm(id, melioAccount, options) {
      return localVarFp.getVendorEbillsSubscriptionForm(id, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * 
     * @summary create vendor ebills subscription
     * @param {PostVendorEbillsSubscriptionRequest} postVendorEbillsSubscriptionRequest vendor ebills subscription parameters
     * @param {string} id ID of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postEbillsSubscription(postVendorEbillsSubscriptionRequest, id, options) {
      return localVarFp.postEbillsSubscription(postVendorEbillsSubscriptionRequest, id, options).then((request) => request(axios2, basePath));
    }
  };
};
var EBillsSubscriptionsApi = class extends BaseAPI {
  /**
   * 
   * @summary cancel vendor ebills subscription
   * @param {EBillsSubscriptionsApiDeleteEbillsSubscriptionRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EBillsSubscriptionsApi
   */
  deleteEbillsSubscription(requestParameters, options) {
    return EBillsSubscriptionsApiFp(this.configuration).deleteEbillsSubscription(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Get a vendor\'s ebill subscription form
   * @summary Get a vendor\'s ebill subscription form
   * @param {EBillsSubscriptionsApiGetVendorEbillsSubscriptionFormRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EBillsSubscriptionsApi
   */
  getVendorEbillsSubscriptionForm(requestParameters, options) {
    return EBillsSubscriptionsApiFp(this.configuration).getVendorEbillsSubscriptionForm(requestParameters.id, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * 
   * @summary create vendor ebills subscription
   * @param {EBillsSubscriptionsApiPostEbillsSubscriptionRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EBillsSubscriptionsApi
   */
  postEbillsSubscription(requestParameters, options) {
    return EBillsSubscriptionsApiFp(this.configuration).postEbillsSubscription(requestParameters.postVendorEbillsSubscriptionRequest, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
  }
};
var EBillsSubscriptionsApiInstance = createInstanceFromApiIClass(EBillsSubscriptionsApi);
var EncryptionApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * Creates an card public key so you can use it to encrypt the card data and create a card with the encrypted data
     * @summary Create an encryption card public key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createCardPublicKey: (..._0) => __async(this, [..._0], function* (options = {}) {
      const localVarPath = `/encryption/card/public-keys`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * This operation deletes an card public key by ID
     * @summary Delete an encryption card public key by id
     * @param {string} id ID of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteCardPublicKeyById: (_0, ..._1) => __async(this, [_0, ..._1], function* (id, options = {}) {
      assertParamExists("deleteCardPublicKeyById", "id", id);
      const localVarPath = `/encryption/card/public-keys/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "DELETE" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Get an card public key by id
     * @summary get an encryption card public key by id
     * @param {string} id ID of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPublicKeyById: (_0, ..._1) => __async(this, [_0, ..._1], function* (id, options = {}) {
      assertParamExists("getPublicKeyById", "id", id);
      const localVarPath = `/encryption/card/public-keys/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    })
  };
};
var EncryptionApiFp = function(configuration) {
  const localVarAxiosParamCreator = EncryptionApiAxiosParamCreator(configuration);
  return {
    /**
     * Creates an card public key so you can use it to encrypt the card data and create a card with the encrypted data
     * @summary Create an encryption card public key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createCardPublicKey(options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.createCardPublicKey(options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * This operation deletes an card public key by ID
     * @summary Delete an encryption card public key by id
     * @param {string} id ID of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteCardPublicKeyById(id, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteCardPublicKeyById(id, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Get an card public key by id
     * @summary get an encryption card public key by id
     * @param {string} id ID of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPublicKeyById(id, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getPublicKeyById(id, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    }
  };
};
var EncryptionApiClient = createApiFromFp(EncryptionApiFp);
var EncryptionApiFactory = function(configuration, basePath, axios2) {
  const localVarFp = EncryptionApiFp(configuration);
  return {
    /**
     * Creates an card public key so you can use it to encrypt the card data and create a card with the encrypted data
     * @summary Create an encryption card public key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createCardPublicKey(options) {
      return localVarFp.createCardPublicKey(options).then((request) => request(axios2, basePath));
    },
    /**
     * This operation deletes an card public key by ID
     * @summary Delete an encryption card public key by id
     * @param {string} id ID of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteCardPublicKeyById(id, options) {
      return localVarFp.deleteCardPublicKeyById(id, options).then((request) => request(axios2, basePath));
    },
    /**
     * Get an card public key by id
     * @summary get an encryption card public key by id
     * @param {string} id ID of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPublicKeyById(id, options) {
      return localVarFp.getPublicKeyById(id, options).then((request) => request(axios2, basePath));
    }
  };
};
var EncryptionApi = class extends BaseAPI {
  /**
   * Creates an card public key so you can use it to encrypt the card data and create a card with the encrypted data
   * @summary Create an encryption card public key
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EncryptionApi
   */
  createCardPublicKey(options) {
    return EncryptionApiFp(this.configuration).createCardPublicKey(options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * This operation deletes an card public key by ID
   * @summary Delete an encryption card public key by id
   * @param {EncryptionApiDeleteCardPublicKeyByIdRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EncryptionApi
   */
  deleteCardPublicKeyById(requestParameters, options) {
    return EncryptionApiFp(this.configuration).deleteCardPublicKeyById(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Get an card public key by id
   * @summary get an encryption card public key by id
   * @param {EncryptionApiGetPublicKeyByIdRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EncryptionApi
   */
  getPublicKeyById(requestParameters, options) {
    return EncryptionApiFp(this.configuration).getPublicKeyById(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
  }
};
var EncryptionApiInstance = createInstanceFromApiIClass(EncryptionApi);
var FeatureFlagsApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * 
     * @summary Retrieve all Feature Flags and their values based on the current Partner\'s configuration
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getFeatureFlags: (..._0) => __async(this, [..._0], function* (options = {}) {
      const localVarPath = `/feature-flags`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    })
  };
};
var FeatureFlagsApiFp = function(configuration) {
  const localVarAxiosParamCreator = FeatureFlagsApiAxiosParamCreator(configuration);
  return {
    /**
     * 
     * @summary Retrieve all Feature Flags and their values based on the current Partner\'s configuration
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getFeatureFlags(options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getFeatureFlags(options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    }
  };
};
var FeatureFlagsApiClient = createApiFromFp(FeatureFlagsApiFp);
var FeatureFlagsApiFactory = function(configuration, basePath, axios2) {
  const localVarFp = FeatureFlagsApiFp(configuration);
  return {
    /**
     * 
     * @summary Retrieve all Feature Flags and their values based on the current Partner\'s configuration
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getFeatureFlags(options) {
      return localVarFp.getFeatureFlags(options).then((request) => request(axios2, basePath));
    }
  };
};
var FeatureFlagsApi = class extends BaseAPI {
  /**
   * 
   * @summary Retrieve all Feature Flags and their values based on the current Partner\'s configuration
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FeatureFlagsApi
   */
  getFeatureFlags(options) {
    return FeatureFlagsApiFp(this.configuration).getFeatureFlags(options).then((request) => request(this.axios, this.basePath));
  }
};
var FeatureFlagsApiInstance = createInstanceFromApiIClass(FeatureFlagsApi);
var FeeCatalogsApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * Retrieve a list of the account fees catalog
     * @summary Retrieve all fees of an account
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getFeeCatalogs: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (organizationId, userId, options = {}) {
      const localVarPath = `/fee-catalogs`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (organizationId !== void 0 && organizationId !== null) {
        localVarHeaderParameter["Organization-id"] = String(organizationId);
      }
      if (userId !== void 0 && userId !== null) {
        localVarHeaderParameter["User-id"] = String(userId);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    })
  };
};
var FeeCatalogsApiFp = function(configuration) {
  const localVarAxiosParamCreator = FeeCatalogsApiAxiosParamCreator(configuration);
  return {
    /**
     * Retrieve a list of the account fees catalog
     * @summary Retrieve all fees of an account
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getFeeCatalogs(organizationId, userId, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getFeeCatalogs(organizationId, userId, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    }
  };
};
var FeeCatalogsApiClient = createApiFromFp(FeeCatalogsApiFp);
var FeeCatalogsApiFactory = function(configuration, basePath, axios2) {
  const localVarFp = FeeCatalogsApiFp(configuration);
  return {
    /**
     * Retrieve a list of the account fees catalog
     * @summary Retrieve all fees of an account
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getFeeCatalogs(organizationId, userId, options) {
      return localVarFp.getFeeCatalogs(organizationId, userId, options).then((request) => request(axios2, basePath));
    }
  };
};
var FeeCatalogsApi = class extends BaseAPI {
  /**
   * Retrieve a list of the account fees catalog
   * @summary Retrieve all fees of an account
   * @param {FeeCatalogsApiGetFeeCatalogsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FeeCatalogsApi
   */
  getFeeCatalogs(requestParameters = {}, options) {
    return FeeCatalogsApiFp(this.configuration).getFeeCatalogs(requestParameters.organizationId, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
  }
};
var FeeCatalogsApiInstance = createInstanceFromApiIClass(FeeCatalogsApi);
var FeesApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * Downloads the receipt the Account paid to Melio
     * @summary Download receipt as PDF file
     * @param {string} monthOfReceipts the month of receipts wanted
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    downloadReceiptPdf: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (monthOfReceipts, melioAccount, options = {}) {
      assertParamExists("downloadReceiptPdf", "monthOfReceipts", monthOfReceipts);
      const localVarPath = `/fees/receipts/{monthOfReceipts}/download`.replace(`{${"monthOfReceipts"}}`, encodeURIComponent(String(monthOfReceipts)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Get fees breakdown with available promotions
     * @summary fees breakdown
     * @param {FeesBreakdownRequest} feesBreakdownRequest Send payments params
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getFeesBreakdown: (_0, _1, _2, ..._3) => __async(this, [_0, _1, _2, ..._3], function* (feesBreakdownRequest, organizationId, userId, options = {}) {
      assertParamExists("getFeesBreakdown", "feesBreakdownRequest", feesBreakdownRequest);
      const localVarPath = `/fees/breakdown`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (organizationId !== void 0 && organizationId !== null) {
        localVarHeaderParameter["Organization-id"] = String(organizationId);
      }
      if (userId !== void 0 && userId !== null) {
        localVarHeaderParameter["User-id"] = String(userId);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(feesBreakdownRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Get the available free checks for organization
     * @summary Free checks
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getFreeChecks: (_0, _1, _2, ..._3) => __async(this, [_0, _1, _2, ..._3], function* (melioAccount, organizationId, userId, options = {}) {
      const localVarPath = `/fees/free-checks`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      if (organizationId !== void 0 && organizationId !== null) {
        localVarHeaderParameter["Organization-id"] = String(organizationId);
      }
      if (userId !== void 0 && userId !== null) {
        localVarHeaderParameter["User-id"] = String(userId);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Get receipt date as base64
     * @summary Get receipt date as base64
     * @param {string} monthOfReceipts the month of receipts wanted
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getReceiptData: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (monthOfReceipts, melioAccount, options = {}) {
      assertParamExists("getReceiptData", "monthOfReceipts", monthOfReceipts);
      const localVarPath = `/fees/receipts/{monthOfReceipts}`.replace(`{${"monthOfReceipts"}}`, encodeURIComponent(String(monthOfReceipts)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Retrieve the list of receipts the Account paid to Melio
     * @summary Retrieve receipts
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getReceipts: (_0, ..._1) => __async(this, [_0, ..._1], function* (melioAccount, options = {}) {
      const localVarPath = `/fees/receipts`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    })
  };
};
var FeesApiFp = function(configuration) {
  const localVarAxiosParamCreator = FeesApiAxiosParamCreator(configuration);
  return {
    /**
     * Downloads the receipt the Account paid to Melio
     * @summary Download receipt as PDF file
     * @param {string} monthOfReceipts the month of receipts wanted
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    downloadReceiptPdf(monthOfReceipts, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.downloadReceiptPdf(monthOfReceipts, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Get fees breakdown with available promotions
     * @summary fees breakdown
     * @param {FeesBreakdownRequest} feesBreakdownRequest Send payments params
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getFeesBreakdown(feesBreakdownRequest, organizationId, userId, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getFeesBreakdown(feesBreakdownRequest, organizationId, userId, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Get the available free checks for organization
     * @summary Free checks
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getFreeChecks(melioAccount, organizationId, userId, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getFreeChecks(melioAccount, organizationId, userId, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Get receipt date as base64
     * @summary Get receipt date as base64
     * @param {string} monthOfReceipts the month of receipts wanted
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getReceiptData(monthOfReceipts, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getReceiptData(monthOfReceipts, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Retrieve the list of receipts the Account paid to Melio
     * @summary Retrieve receipts
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getReceipts(melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getReceipts(melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    }
  };
};
var FeesApiClient = createApiFromFp(FeesApiFp);
var FeesApiFactory = function(configuration, basePath, axios2) {
  const localVarFp = FeesApiFp(configuration);
  return {
    /**
     * Downloads the receipt the Account paid to Melio
     * @summary Download receipt as PDF file
     * @param {string} monthOfReceipts the month of receipts wanted
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    downloadReceiptPdf(monthOfReceipts, melioAccount, options) {
      return localVarFp.downloadReceiptPdf(monthOfReceipts, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Get fees breakdown with available promotions
     * @summary fees breakdown
     * @param {FeesBreakdownRequest} feesBreakdownRequest Send payments params
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getFeesBreakdown(feesBreakdownRequest, organizationId, userId, options) {
      return localVarFp.getFeesBreakdown(feesBreakdownRequest, organizationId, userId, options).then((request) => request(axios2, basePath));
    },
    /**
     * Get the available free checks for organization
     * @summary Free checks
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getFreeChecks(melioAccount, organizationId, userId, options) {
      return localVarFp.getFreeChecks(melioAccount, organizationId, userId, options).then((request) => request(axios2, basePath));
    },
    /**
     * Get receipt date as base64
     * @summary Get receipt date as base64
     * @param {string} monthOfReceipts the month of receipts wanted
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getReceiptData(monthOfReceipts, melioAccount, options) {
      return localVarFp.getReceiptData(monthOfReceipts, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Retrieve the list of receipts the Account paid to Melio
     * @summary Retrieve receipts
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getReceipts(melioAccount, options) {
      return localVarFp.getReceipts(melioAccount, options).then((request) => request(axios2, basePath));
    }
  };
};
var FeesApi = class extends BaseAPI {
  /**
   * Downloads the receipt the Account paid to Melio
   * @summary Download receipt as PDF file
   * @param {FeesApiDownloadReceiptPdfRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FeesApi
   */
  downloadReceiptPdf(requestParameters, options) {
    return FeesApiFp(this.configuration).downloadReceiptPdf(requestParameters.monthOfReceipts, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Get fees breakdown with available promotions
   * @summary fees breakdown
   * @param {FeesApiGetFeesBreakdownRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FeesApi
   */
  getFeesBreakdown(requestParameters, options) {
    return FeesApiFp(this.configuration).getFeesBreakdown(requestParameters.feesBreakdownRequest, requestParameters.organizationId, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Get the available free checks for organization
   * @summary Free checks
   * @param {FeesApiGetFreeChecksRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FeesApi
   */
  getFreeChecks(requestParameters = {}, options) {
    return FeesApiFp(this.configuration).getFreeChecks(requestParameters.melioAccount, requestParameters.organizationId, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Get receipt date as base64
   * @summary Get receipt date as base64
   * @param {FeesApiGetReceiptDataRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FeesApi
   */
  getReceiptData(requestParameters, options) {
    return FeesApiFp(this.configuration).getReceiptData(requestParameters.monthOfReceipts, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Retrieve the list of receipts the Account paid to Melio
   * @summary Retrieve receipts
   * @param {FeesApiGetReceiptsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FeesApi
   */
  getReceipts(requestParameters = {}, options) {
    return FeesApiFp(this.configuration).getReceipts(requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
};
var FeesApiInstance = createInstanceFromApiIClass(FeesApi);
var FilesApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * Takes a list of file ids and converts them to scanned invoices
     * @summary Convert a list of files to scanned invoices
     * @param {BulkConvertToScannedInvoicesRequest} [bulkConvertToScannedInvoicesRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    convertToScannedInvoicesBulk: (_0, ..._1) => __async(this, [_0, ..._1], function* (bulkConvertToScannedInvoicesRequest, options = {}) {
      const localVarPath = `/files/convert-to-scanned-invoices/bulk`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(bulkConvertToScannedInvoicesRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Initiate multiple file upload requests and get signed upload urls
     * @summary Create bulk file upload request
     * @param {CreateBulkUploadRequestRequest} [createBulkUploadRequestRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createBulkUploadRequest: (_0, ..._1) => __async(this, [_0, ..._1], function* (createBulkUploadRequestRequest, options = {}) {
      const localVarPath = `/files/upload-requests/bulk`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(createBulkUploadRequestRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Get Upload Request object
     * @summary Bulk Get Upload Request
     * @param {Array<string> | string} uploadRequestIds upload request IDs
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBulkUploadRequest: (_0, ..._1) => __async(this, [_0, ..._1], function* (uploadRequestIds, options = {}) {
      assertParamExists("getBulkUploadRequest", "uploadRequestIds", uploadRequestIds);
      const localVarPath = `/files/upload-requests/bulk`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (uploadRequestIds !== void 0) {
        localVarQueryParameter["uploadRequestIds"] = uploadRequestIds;
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Retrieve the list of Files the Account uploaded to Melio
     * @summary Retrieve files
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getFiles: (_0, ..._1) => __async(this, [_0, ..._1], function* (melioAccount, options = {}) {
      const localVarPath = `/files`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Get a File object with a details and a URL for the actual file to download.
     * @summary Retrieve a File
     * @param {string} id ID of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getFilesFileId: (_0, ..._1) => __async(this, [_0, ..._1], function* (id, options = {}) {
      assertParamExists("getFilesFileId", "id", id);
      const localVarPath = `/files/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Retrieve data from a File using OCR
     * @summary Retrieve data from a File using OCR
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getFilesFileIdData: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (id, melioAccount, options = {}) {
      assertParamExists("getFilesFileIdData", "id", id);
      const localVarPath = `/files/{id}/data`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Upload a file as a File object, to be used by other operations
     * @summary Create / upload a File
     * @param {any} [file] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postFiles: (_0, _1, _2, ..._3) => __async(this, [_0, _1, _2, ..._3], function* (file, idempotencyKey, melioAccount, options = {}) {
      const localVarPath = `/files`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      const localVarFormParams = new (configuration && configuration.formDataCtor || FormData)();
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (idempotencyKey !== void 0 && idempotencyKey !== null) {
        localVarHeaderParameter["Idempotency-Key"] = String(idempotencyKey);
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      if (file !== void 0) {
        localVarFormParams.append("file", file);
      }
      localVarHeaderParameter["Content-Type"] = "multipart/form-data";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = localVarFormParams;
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    })
  };
};
var FilesApiFp = function(configuration) {
  const localVarAxiosParamCreator = FilesApiAxiosParamCreator(configuration);
  return {
    /**
     * Takes a list of file ids and converts them to scanned invoices
     * @summary Convert a list of files to scanned invoices
     * @param {BulkConvertToScannedInvoicesRequest} [bulkConvertToScannedInvoicesRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    convertToScannedInvoicesBulk(bulkConvertToScannedInvoicesRequest, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.convertToScannedInvoicesBulk(bulkConvertToScannedInvoicesRequest, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Initiate multiple file upload requests and get signed upload urls
     * @summary Create bulk file upload request
     * @param {CreateBulkUploadRequestRequest} [createBulkUploadRequestRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createBulkUploadRequest(createBulkUploadRequestRequest, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.createBulkUploadRequest(createBulkUploadRequestRequest, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Get Upload Request object
     * @summary Bulk Get Upload Request
     * @param {Array<string> | string} uploadRequestIds upload request IDs
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBulkUploadRequest(uploadRequestIds, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getBulkUploadRequest(uploadRequestIds, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Retrieve the list of Files the Account uploaded to Melio
     * @summary Retrieve files
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getFiles(melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getFiles(melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Get a File object with a details and a URL for the actual file to download.
     * @summary Retrieve a File
     * @param {string} id ID of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getFilesFileId(id, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getFilesFileId(id, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Retrieve data from a File using OCR
     * @summary Retrieve data from a File using OCR
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getFilesFileIdData(id, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getFilesFileIdData(id, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Upload a file as a File object, to be used by other operations
     * @summary Create / upload a File
     * @param {any} [file] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postFiles(file, idempotencyKey, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postFiles(file, idempotencyKey, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    }
  };
};
var FilesApiClient = createApiFromFp(FilesApiFp);
var FilesApiFactory = function(configuration, basePath, axios2) {
  const localVarFp = FilesApiFp(configuration);
  return {
    /**
     * Takes a list of file ids and converts them to scanned invoices
     * @summary Convert a list of files to scanned invoices
     * @param {BulkConvertToScannedInvoicesRequest} [bulkConvertToScannedInvoicesRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    convertToScannedInvoicesBulk(bulkConvertToScannedInvoicesRequest, options) {
      return localVarFp.convertToScannedInvoicesBulk(bulkConvertToScannedInvoicesRequest, options).then((request) => request(axios2, basePath));
    },
    /**
     * Initiate multiple file upload requests and get signed upload urls
     * @summary Create bulk file upload request
     * @param {CreateBulkUploadRequestRequest} [createBulkUploadRequestRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createBulkUploadRequest(createBulkUploadRequestRequest, options) {
      return localVarFp.createBulkUploadRequest(createBulkUploadRequestRequest, options).then((request) => request(axios2, basePath));
    },
    /**
     * Get Upload Request object
     * @summary Bulk Get Upload Request
     * @param {Array<string> | string} uploadRequestIds upload request IDs
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBulkUploadRequest(uploadRequestIds, options) {
      return localVarFp.getBulkUploadRequest(uploadRequestIds, options).then((request) => request(axios2, basePath));
    },
    /**
     * Retrieve the list of Files the Account uploaded to Melio
     * @summary Retrieve files
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getFiles(melioAccount, options) {
      return localVarFp.getFiles(melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Get a File object with a details and a URL for the actual file to download.
     * @summary Retrieve a File
     * @param {string} id ID of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getFilesFileId(id, options) {
      return localVarFp.getFilesFileId(id, options).then((request) => request(axios2, basePath));
    },
    /**
     * Retrieve data from a File using OCR
     * @summary Retrieve data from a File using OCR
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getFilesFileIdData(id, melioAccount, options) {
      return localVarFp.getFilesFileIdData(id, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Upload a file as a File object, to be used by other operations
     * @summary Create / upload a File
     * @param {any} [file] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postFiles(file, idempotencyKey, melioAccount, options) {
      return localVarFp.postFiles(file, idempotencyKey, melioAccount, options).then((request) => request(axios2, basePath));
    }
  };
};
var FilesApi = class extends BaseAPI {
  /**
   * Takes a list of file ids and converts them to scanned invoices
   * @summary Convert a list of files to scanned invoices
   * @param {FilesApiConvertToScannedInvoicesBulkRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FilesApi
   */
  convertToScannedInvoicesBulk(requestParameters = {}, options) {
    return FilesApiFp(this.configuration).convertToScannedInvoicesBulk(requestParameters.bulkConvertToScannedInvoicesRequest, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Initiate multiple file upload requests and get signed upload urls
   * @summary Create bulk file upload request
   * @param {FilesApiCreateBulkUploadRequestRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FilesApi
   */
  createBulkUploadRequest(requestParameters = {}, options) {
    return FilesApiFp(this.configuration).createBulkUploadRequest(requestParameters.createBulkUploadRequestRequest, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Get Upload Request object
   * @summary Bulk Get Upload Request
   * @param {FilesApiGetBulkUploadRequestRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FilesApi
   */
  getBulkUploadRequest(requestParameters, options) {
    return FilesApiFp(this.configuration).getBulkUploadRequest(requestParameters.uploadRequestIds, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Retrieve the list of Files the Account uploaded to Melio
   * @summary Retrieve files
   * @param {FilesApiGetFilesRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FilesApi
   */
  getFiles(requestParameters = {}, options) {
    return FilesApiFp(this.configuration).getFiles(requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Get a File object with a details and a URL for the actual file to download.
   * @summary Retrieve a File
   * @param {FilesApiGetFilesFileIdRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FilesApi
   */
  getFilesFileId(requestParameters, options) {
    return FilesApiFp(this.configuration).getFilesFileId(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Retrieve data from a File using OCR
   * @summary Retrieve data from a File using OCR
   * @param {FilesApiGetFilesFileIdDataRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FilesApi
   */
  getFilesFileIdData(requestParameters, options) {
    return FilesApiFp(this.configuration).getFilesFileIdData(requestParameters.id, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Upload a file as a File object, to be used by other operations
   * @summary Create / upload a File
   * @param {FilesApiPostFilesRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FilesApi
   */
  postFiles(requestParameters = {}, options) {
    return FilesApiFp(this.configuration).postFiles(requestParameters.file, requestParameters.idempotencyKey, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
};
var FilesApiInstance = createInstanceFromApiIClass(FilesApi);
var FinancingApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * 
     * @summary Apply for Financing
     * @param {ApplyForFinancingRequest} [applyForFinancingRequest] 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    applyForFinancing: (_0, _1, _2, ..._3) => __async(this, [_0, _1, _2, ..._3], function* (applyForFinancingRequest, melioAccount, idempotencyKey, options = {}) {
      const localVarPath = `/financing/applications`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      if (idempotencyKey !== void 0 && idempotencyKey !== null) {
        localVarHeaderParameter["Idempotency-Key"] = String(idempotencyKey);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(applyForFinancingRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * 
     * @summary Get an Organization\'s cached Eligibility
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOrgFinancingCachedEligibility: (..._0) => __async(this, [..._0], function* (options = {}) {
      const localVarPath = `/financing/org-cached-eligibility`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * 
     * @summary Get an Organization\'s Financing Eligibility
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOrgFinancingEligibility: (..._0) => __async(this, [..._0], function* (options = {}) {
      const localVarPath = `/financing/org-eligibility`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * 
     * @summary check financing eligibility and get repayment terms
     * @param {string} vendorId ID of vendor to check eligibility to pay with financing
     * @param {number} paymentAmount 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getRepaymentTerms: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (vendorId, paymentAmount, options = {}) {
      assertParamExists("getRepaymentTerms", "vendorId", vendorId);
      assertParamExists("getRepaymentTerms", "paymentAmount", paymentAmount);
      const localVarPath = `/financing/repayment-terms`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (vendorId !== void 0) {
        localVarQueryParameter["vendorId"] = vendorId;
      }
      if (paymentAmount !== void 0) {
        localVarQueryParameter["paymentAmount"] = paymentAmount;
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * 
     * @summary Set selected repayment option
     * @param {SelectRepaymentTermRequest} [selectRepaymentTermRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    selectRepaymentTerm: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (selectRepaymentTermRequest, idempotencyKey, options = {}) {
      const localVarPath = `/financing/repayment-terms/select`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (idempotencyKey !== void 0 && idempotencyKey !== null) {
        localVarHeaderParameter["Idempotency-Key"] = String(idempotencyKey);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(selectRepaymentTermRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    })
  };
};
var FinancingApiFp = function(configuration) {
  const localVarAxiosParamCreator = FinancingApiAxiosParamCreator(configuration);
  return {
    /**
     * 
     * @summary Apply for Financing
     * @param {ApplyForFinancingRequest} [applyForFinancingRequest] 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    applyForFinancing(applyForFinancingRequest, melioAccount, idempotencyKey, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.applyForFinancing(applyForFinancingRequest, melioAccount, idempotencyKey, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * 
     * @summary Get an Organization\'s cached Eligibility
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOrgFinancingCachedEligibility(options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getOrgFinancingCachedEligibility(options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * 
     * @summary Get an Organization\'s Financing Eligibility
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOrgFinancingEligibility(options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getOrgFinancingEligibility(options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * 
     * @summary check financing eligibility and get repayment terms
     * @param {string} vendorId ID of vendor to check eligibility to pay with financing
     * @param {number} paymentAmount 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getRepaymentTerms(vendorId, paymentAmount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getRepaymentTerms(vendorId, paymentAmount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * 
     * @summary Set selected repayment option
     * @param {SelectRepaymentTermRequest} [selectRepaymentTermRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    selectRepaymentTerm(selectRepaymentTermRequest, idempotencyKey, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.selectRepaymentTerm(selectRepaymentTermRequest, idempotencyKey, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    }
  };
};
var FinancingApiClient = createApiFromFp(FinancingApiFp);
var FinancingApiFactory = function(configuration, basePath, axios2) {
  const localVarFp = FinancingApiFp(configuration);
  return {
    /**
     * 
     * @summary Apply for Financing
     * @param {ApplyForFinancingRequest} [applyForFinancingRequest] 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    applyForFinancing(applyForFinancingRequest, melioAccount, idempotencyKey, options) {
      return localVarFp.applyForFinancing(applyForFinancingRequest, melioAccount, idempotencyKey, options).then((request) => request(axios2, basePath));
    },
    /**
     * 
     * @summary Get an Organization\'s cached Eligibility
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOrgFinancingCachedEligibility(options) {
      return localVarFp.getOrgFinancingCachedEligibility(options).then((request) => request(axios2, basePath));
    },
    /**
     * 
     * @summary Get an Organization\'s Financing Eligibility
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOrgFinancingEligibility(options) {
      return localVarFp.getOrgFinancingEligibility(options).then((request) => request(axios2, basePath));
    },
    /**
     * 
     * @summary check financing eligibility and get repayment terms
     * @param {string} vendorId ID of vendor to check eligibility to pay with financing
     * @param {number} paymentAmount 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getRepaymentTerms(vendorId, paymentAmount, options) {
      return localVarFp.getRepaymentTerms(vendorId, paymentAmount, options).then((request) => request(axios2, basePath));
    },
    /**
     * 
     * @summary Set selected repayment option
     * @param {SelectRepaymentTermRequest} [selectRepaymentTermRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    selectRepaymentTerm(selectRepaymentTermRequest, idempotencyKey, options) {
      return localVarFp.selectRepaymentTerm(selectRepaymentTermRequest, idempotencyKey, options).then((request) => request(axios2, basePath));
    }
  };
};
var FinancingApi = class extends BaseAPI {
  /**
   * 
   * @summary Apply for Financing
   * @param {FinancingApiApplyForFinancingRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FinancingApi
   */
  applyForFinancing(requestParameters = {}, options) {
    return FinancingApiFp(this.configuration).applyForFinancing(requestParameters.applyForFinancingRequest, requestParameters.melioAccount, requestParameters.idempotencyKey, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Get an Organization\'s cached Eligibility
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FinancingApi
   */
  getOrgFinancingCachedEligibility(options) {
    return FinancingApiFp(this.configuration).getOrgFinancingCachedEligibility(options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Get an Organization\'s Financing Eligibility
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FinancingApi
   */
  getOrgFinancingEligibility(options) {
    return FinancingApiFp(this.configuration).getOrgFinancingEligibility(options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * 
   * @summary check financing eligibility and get repayment terms
   * @param {FinancingApiGetRepaymentTermsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FinancingApi
   */
  getRepaymentTerms(requestParameters, options) {
    return FinancingApiFp(this.configuration).getRepaymentTerms(requestParameters.vendorId, requestParameters.paymentAmount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Set selected repayment option
   * @param {FinancingApiSelectRepaymentTermRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FinancingApi
   */
  selectRepaymentTerm(requestParameters = {}, options) {
    return FinancingApiFp(this.configuration).selectRepaymentTerm(requestParameters.selectRepaymentTermRequest, requestParameters.idempotencyKey, options).then((request) => request(this.axios, this.basePath));
  }
};
var FinancingApiInstance = createInstanceFromApiIClass(FinancingApi);
var FundingSourcesApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * Remove a Funding Source from the Account
     * @summary Delete a Funding Source
     * @param {string} id ID of the entity
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {boolean} [shouldDecrypt] Should decrypt the data
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteFundingSourcesFundingSourceId: (_0, _1, _2, _3, _4, ..._5) => __async(this, [_0, _1, _2, _3, _4, ..._5], function* (id, expand, shouldDecrypt, idempotencyKey, melioAccount, options = {}) {
      assertParamExists("deleteFundingSourcesFundingSourceId", "id", id);
      const localVarPath = `/funding-sources/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "DELETE" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (shouldDecrypt !== void 0) {
        localVarQueryParameter["shouldDecrypt"] = shouldDecrypt;
      }
      if (expand !== void 0 && expand !== null) {
        localVarHeaderParameter["expand"] = String(JSON.stringify(expand));
      }
      if (idempotencyKey !== void 0 && idempotencyKey !== null) {
        localVarHeaderParameter["Idempotency-Key"] = String(idempotencyKey);
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Get a `FundingSource` object by your own internal ID number, rather than Melio\'s ID. Ask your Melio account manager the source of this number. This method may not be available for all partners or all funding source types; if not, you will get a 404 response code to your requests. 
     * @summary Get FundingSource by partner\'s internal ID
     * @param {string} id Partner\&#39;s ID for this funding source.
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getFundingSourceIdentify: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (id, expand, options = {}) {
      assertParamExists("getFundingSourceIdentify", "id", id);
      const localVarPath = `/funding-sources/identify`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (expand !== void 0) {
        localVarQueryParameter["expand"] = expand;
      }
      if (id !== void 0) {
        localVarQueryParameter["id"] = id;
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Retrieve the Funding Sources of an Account
     * @summary Get all Funding Sources
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {FundingSourcesIncludeEnum} [include] 
     * @param {boolean} [shouldDecrypt] Should decrypt the data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getFundingSources: (_0, _1, _2, _3, ..._4) => __async(this, [_0, _1, _2, _3, ..._4], function* (expand, melioAccount, include, shouldDecrypt, options = {}) {
      const localVarPath = `/funding-sources`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (expand !== void 0) {
        localVarQueryParameter["expand"] = expand;
      }
      if (include !== void 0) {
        localVarQueryParameter["include"] = include;
      }
      if (shouldDecrypt !== void 0) {
        localVarQueryParameter["shouldDecrypt"] = shouldDecrypt;
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Retrieve details about a specific Funding Source
     * @summary Retrieve a Funding Source
     * @param {string} id ID of the entity
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {boolean} [shouldDecrypt] Should decrypt the data
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getFundingSourcesFundingSourceId: (_0, _1, _2, _3, ..._4) => __async(this, [_0, _1, _2, _3, ..._4], function* (id, expand, shouldDecrypt, melioAccount, options = {}) {
      assertParamExists("getFundingSourcesFundingSourceId", "id", id);
      const localVarPath = `/funding-sources/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (expand !== void 0) {
        localVarQueryParameter["expand"] = expand;
      }
      if (shouldDecrypt !== void 0) {
        localVarQueryParameter["shouldDecrypt"] = shouldDecrypt;
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Update a Funding Source.
     * @summary Update a Funding Source
     * @param {string} id ID of the entity
     * @param {PatchFundingSourcesRequest} [patchFundingSourcesRequest] 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {boolean} [shouldDecrypt] Should decrypt the data
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchFundingSourcesFundingSourceId: (_0, _1, _2, _3, _4, _5, ..._6) => __async(this, [_0, _1, _2, _3, _4, _5, ..._6], function* (id, patchFundingSourcesRequest, expand, shouldDecrypt, idempotencyKey, melioAccount, options = {}) {
      assertParamExists("patchFundingSourcesFundingSourceId", "id", id);
      const localVarPath = `/funding-sources/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "PATCH" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (shouldDecrypt !== void 0) {
        localVarQueryParameter["shouldDecrypt"] = shouldDecrypt;
      }
      if (expand !== void 0 && expand !== null) {
        localVarHeaderParameter["expand"] = String(JSON.stringify(expand));
      }
      if (idempotencyKey !== void 0 && idempotencyKey !== null) {
        localVarHeaderParameter["Idempotency-Key"] = String(idempotencyKey);
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(patchFundingSourcesRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Create a new Funding Source for the Account.  The `type` field determines the contents of the `details` field, according to the following mapping: * `bank-account` => `BankAccount` * `plaid` => `PlaidDetails` * `card` => `Card`
     * @summary Create a Funding Source
     * @param {PostFundingSourcesRequest} [postFundingSourcesRequest] 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postFundingSources: (_0, _1, _2, _3, _4, _5, ..._6) => __async(this, [_0, _1, _2, _3, _4, _5, ..._6], function* (postFundingSourcesRequest, expand, idempotencyKey, melioAccount, organizationId, userId, options = {}) {
      const localVarPath = `/funding-sources`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (expand !== void 0 && expand !== null) {
        localVarHeaderParameter["expand"] = String(JSON.stringify(expand));
      }
      if (idempotencyKey !== void 0 && idempotencyKey !== null) {
        localVarHeaderParameter["Idempotency-Key"] = String(idempotencyKey);
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      if (organizationId !== void 0 && organizationId !== null) {
        localVarHeaderParameter["Organization-id"] = String(organizationId);
      }
      if (userId !== void 0 && userId !== null) {
        localVarHeaderParameter["User-id"] = String(userId);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postFundingSourcesRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Verify a Funding Source with Micro Deposits
     * @summary Verify a Funding Source
     * @param {string} id ID of the entity
     * @param {PostFundingSourcesFundingSourceIdVerifyRequest | PostFundingSourcesVerifyRequest} [postFundingSourcesFundingSourceIdVerifyRequestPostFundingSourcesVerifyRequest] 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postFundingSourcesFundingSourceIdVerify: (_0, _1, _2, _3, _4, _5, _6, ..._7) => __async(this, [_0, _1, _2, _3, _4, _5, _6, ..._7], function* (id, postFundingSourcesFundingSourceIdVerifyRequestPostFundingSourcesVerifyRequest, expand, idempotencyKey, melioAccount, organizationId, userId, options = {}) {
      assertParamExists("postFundingSourcesFundingSourceIdVerify", "id", id);
      const localVarPath = `/funding-sources/{id}/verify`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (expand !== void 0 && expand !== null) {
        localVarHeaderParameter["expand"] = String(JSON.stringify(expand));
      }
      if (idempotencyKey !== void 0 && idempotencyKey !== null) {
        localVarHeaderParameter["Idempotency-Key"] = String(idempotencyKey);
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      if (organizationId !== void 0 && organizationId !== null) {
        localVarHeaderParameter["Organization-id"] = String(organizationId);
      }
      if (userId !== void 0 && userId !== null) {
        localVarHeaderParameter["User-id"] = String(userId);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postFundingSourcesFundingSourceIdVerifyRequestPostFundingSourcesVerifyRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * This operation returns an access token for using plaid link
     * @summary Create access token for plaid link
     * @param {PostPlaidLinkTokenRequest} [postPlaidLinkTokenRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postFundingSourcesPlaidLinkToken: (_0, _1, _2, _3, _4, ..._5) => __async(this, [_0, _1, _2, _3, _4, ..._5], function* (postPlaidLinkTokenRequest, idempotencyKey, melioAccount, organizationId, userId, options = {}) {
      const localVarPath = `/funding-sources/plaid/link/token`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (idempotencyKey !== void 0 && idempotencyKey !== null) {
        localVarHeaderParameter["Idempotency-Key"] = String(idempotencyKey);
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      if (organizationId !== void 0 && organizationId !== null) {
        localVarHeaderParameter["Organization-id"] = String(organizationId);
      }
      if (userId !== void 0 && userId !== null) {
        localVarHeaderParameter["User-id"] = String(userId);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postPlaidLinkTokenRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Link funding-source to an accounting platform\'s payment account.
     * @summary Link funding-source to a payment account
     * @param {string} id ID of the entity
     * @param {PostFundingSourceLinkPaymentAccountRequest} [postFundingSourceLinkPaymentAccountRequest] 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postLinkAccountingPlatformPaymentAccount: (_0, _1, _2, _3, _4, ..._5) => __async(this, [_0, _1, _2, _3, _4, ..._5], function* (id, postFundingSourceLinkPaymentAccountRequest, expand, idempotencyKey, melioAccount, options = {}) {
      assertParamExists("postLinkAccountingPlatformPaymentAccount", "id", id);
      const localVarPath = `/funding-sources/{id}/link-accounting-platform-payment-account`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (expand !== void 0 && expand !== null) {
        localVarHeaderParameter["expand"] = String(JSON.stringify(expand));
      }
      if (idempotencyKey !== void 0 && idempotencyKey !== null) {
        localVarHeaderParameter["Idempotency-Key"] = String(idempotencyKey);
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postFundingSourceLinkPaymentAccountRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Update funding-sources plaid account
     * @summary Update funding-sources plaid account
     * @param {string} id ID of the entity
     * @param {PutFundingSourcesUpdatePlaidAccountRequest} [putFundingSourcesUpdatePlaidAccountRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    putFundingSourcesUpdatePlaidAccount: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (id, putFundingSourcesUpdatePlaidAccountRequest, options = {}) {
      assertParamExists("putFundingSourcesUpdatePlaidAccount", "id", id);
      const localVarPath = `/funding-sources/{id}/plaid-account`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "PUT" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(putFundingSourcesUpdatePlaidAccountRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    })
  };
};
var FundingSourcesApiFp = function(configuration) {
  const localVarAxiosParamCreator = FundingSourcesApiAxiosParamCreator(configuration);
  return {
    /**
     * Remove a Funding Source from the Account
     * @summary Delete a Funding Source
     * @param {string} id ID of the entity
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {boolean} [shouldDecrypt] Should decrypt the data
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteFundingSourcesFundingSourceId(id, expand, shouldDecrypt, idempotencyKey, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteFundingSourcesFundingSourceId(id, expand, shouldDecrypt, idempotencyKey, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Get a `FundingSource` object by your own internal ID number, rather than Melio\'s ID. Ask your Melio account manager the source of this number. This method may not be available for all partners or all funding source types; if not, you will get a 404 response code to your requests. 
     * @summary Get FundingSource by partner\'s internal ID
     * @param {string} id Partner\&#39;s ID for this funding source.
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getFundingSourceIdentify(id, expand, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getFundingSourceIdentify(id, expand, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Retrieve the Funding Sources of an Account
     * @summary Get all Funding Sources
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {FundingSourcesIncludeEnum} [include] 
     * @param {boolean} [shouldDecrypt] Should decrypt the data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getFundingSources(expand, melioAccount, include, shouldDecrypt, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getFundingSources(expand, melioAccount, include, shouldDecrypt, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Retrieve details about a specific Funding Source
     * @summary Retrieve a Funding Source
     * @param {string} id ID of the entity
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {boolean} [shouldDecrypt] Should decrypt the data
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getFundingSourcesFundingSourceId(id, expand, shouldDecrypt, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getFundingSourcesFundingSourceId(id, expand, shouldDecrypt, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Update a Funding Source.
     * @summary Update a Funding Source
     * @param {string} id ID of the entity
     * @param {PatchFundingSourcesRequest} [patchFundingSourcesRequest] 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {boolean} [shouldDecrypt] Should decrypt the data
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchFundingSourcesFundingSourceId(id, patchFundingSourcesRequest, expand, shouldDecrypt, idempotencyKey, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.patchFundingSourcesFundingSourceId(id, patchFundingSourcesRequest, expand, shouldDecrypt, idempotencyKey, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Create a new Funding Source for the Account.  The `type` field determines the contents of the `details` field, according to the following mapping: * `bank-account` => `BankAccount` * `plaid` => `PlaidDetails` * `card` => `Card`
     * @summary Create a Funding Source
     * @param {PostFundingSourcesRequest} [postFundingSourcesRequest] 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postFundingSources(postFundingSourcesRequest, expand, idempotencyKey, melioAccount, organizationId, userId, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postFundingSources(postFundingSourcesRequest, expand, idempotencyKey, melioAccount, organizationId, userId, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Verify a Funding Source with Micro Deposits
     * @summary Verify a Funding Source
     * @param {string} id ID of the entity
     * @param {PostFundingSourcesFundingSourceIdVerifyRequest | PostFundingSourcesVerifyRequest} [postFundingSourcesFundingSourceIdVerifyRequestPostFundingSourcesVerifyRequest] 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postFundingSourcesFundingSourceIdVerify(id, postFundingSourcesFundingSourceIdVerifyRequestPostFundingSourcesVerifyRequest, expand, idempotencyKey, melioAccount, organizationId, userId, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postFundingSourcesFundingSourceIdVerify(id, postFundingSourcesFundingSourceIdVerifyRequestPostFundingSourcesVerifyRequest, expand, idempotencyKey, melioAccount, organizationId, userId, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * This operation returns an access token for using plaid link
     * @summary Create access token for plaid link
     * @param {PostPlaidLinkTokenRequest} [postPlaidLinkTokenRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postFundingSourcesPlaidLinkToken(postPlaidLinkTokenRequest, idempotencyKey, melioAccount, organizationId, userId, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postFundingSourcesPlaidLinkToken(postPlaidLinkTokenRequest, idempotencyKey, melioAccount, organizationId, userId, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Link funding-source to an accounting platform\'s payment account.
     * @summary Link funding-source to a payment account
     * @param {string} id ID of the entity
     * @param {PostFundingSourceLinkPaymentAccountRequest} [postFundingSourceLinkPaymentAccountRequest] 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postLinkAccountingPlatformPaymentAccount(id, postFundingSourceLinkPaymentAccountRequest, expand, idempotencyKey, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postLinkAccountingPlatformPaymentAccount(id, postFundingSourceLinkPaymentAccountRequest, expand, idempotencyKey, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Update funding-sources plaid account
     * @summary Update funding-sources plaid account
     * @param {string} id ID of the entity
     * @param {PutFundingSourcesUpdatePlaidAccountRequest} [putFundingSourcesUpdatePlaidAccountRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    putFundingSourcesUpdatePlaidAccount(id, putFundingSourcesUpdatePlaidAccountRequest, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.putFundingSourcesUpdatePlaidAccount(id, putFundingSourcesUpdatePlaidAccountRequest, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    }
  };
};
var FundingSourcesApiClient = createApiFromFp(FundingSourcesApiFp);
var FundingSourcesApiFactory = function(configuration, basePath, axios2) {
  const localVarFp = FundingSourcesApiFp(configuration);
  return {
    /**
     * Remove a Funding Source from the Account
     * @summary Delete a Funding Source
     * @param {string} id ID of the entity
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {boolean} [shouldDecrypt] Should decrypt the data
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteFundingSourcesFundingSourceId(id, expand, shouldDecrypt, idempotencyKey, melioAccount, options) {
      return localVarFp.deleteFundingSourcesFundingSourceId(id, expand, shouldDecrypt, idempotencyKey, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Get a `FundingSource` object by your own internal ID number, rather than Melio\'s ID. Ask your Melio account manager the source of this number. This method may not be available for all partners or all funding source types; if not, you will get a 404 response code to your requests. 
     * @summary Get FundingSource by partner\'s internal ID
     * @param {string} id Partner\&#39;s ID for this funding source.
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getFundingSourceIdentify(id, expand, options) {
      return localVarFp.getFundingSourceIdentify(id, expand, options).then((request) => request(axios2, basePath));
    },
    /**
     * Retrieve the Funding Sources of an Account
     * @summary Get all Funding Sources
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {FundingSourcesIncludeEnum} [include] 
     * @param {boolean} [shouldDecrypt] Should decrypt the data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getFundingSources(expand, melioAccount, include, shouldDecrypt, options) {
      return localVarFp.getFundingSources(expand, melioAccount, include, shouldDecrypt, options).then((request) => request(axios2, basePath));
    },
    /**
     * Retrieve details about a specific Funding Source
     * @summary Retrieve a Funding Source
     * @param {string} id ID of the entity
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {boolean} [shouldDecrypt] Should decrypt the data
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getFundingSourcesFundingSourceId(id, expand, shouldDecrypt, melioAccount, options) {
      return localVarFp.getFundingSourcesFundingSourceId(id, expand, shouldDecrypt, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Update a Funding Source.
     * @summary Update a Funding Source
     * @param {string} id ID of the entity
     * @param {PatchFundingSourcesRequest} [patchFundingSourcesRequest] 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {boolean} [shouldDecrypt] Should decrypt the data
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchFundingSourcesFundingSourceId(id, patchFundingSourcesRequest, expand, shouldDecrypt, idempotencyKey, melioAccount, options) {
      return localVarFp.patchFundingSourcesFundingSourceId(id, patchFundingSourcesRequest, expand, shouldDecrypt, idempotencyKey, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Create a new Funding Source for the Account.  The `type` field determines the contents of the `details` field, according to the following mapping: * `bank-account` => `BankAccount` * `plaid` => `PlaidDetails` * `card` => `Card`
     * @summary Create a Funding Source
     * @param {PostFundingSourcesRequest} [postFundingSourcesRequest] 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postFundingSources(postFundingSourcesRequest, expand, idempotencyKey, melioAccount, organizationId, userId, options) {
      return localVarFp.postFundingSources(postFundingSourcesRequest, expand, idempotencyKey, melioAccount, organizationId, userId, options).then((request) => request(axios2, basePath));
    },
    /**
     * Verify a Funding Source with Micro Deposits
     * @summary Verify a Funding Source
     * @param {string} id ID of the entity
     * @param {PostFundingSourcesFundingSourceIdVerifyRequest | PostFundingSourcesVerifyRequest} [postFundingSourcesFundingSourceIdVerifyRequestPostFundingSourcesVerifyRequest] 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postFundingSourcesFundingSourceIdVerify(id, postFundingSourcesFundingSourceIdVerifyRequestPostFundingSourcesVerifyRequest, expand, idempotencyKey, melioAccount, organizationId, userId, options) {
      return localVarFp.postFundingSourcesFundingSourceIdVerify(id, postFundingSourcesFundingSourceIdVerifyRequestPostFundingSourcesVerifyRequest, expand, idempotencyKey, melioAccount, organizationId, userId, options).then((request) => request(axios2, basePath));
    },
    /**
     * This operation returns an access token for using plaid link
     * @summary Create access token for plaid link
     * @param {PostPlaidLinkTokenRequest} [postPlaidLinkTokenRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postFundingSourcesPlaidLinkToken(postPlaidLinkTokenRequest, idempotencyKey, melioAccount, organizationId, userId, options) {
      return localVarFp.postFundingSourcesPlaidLinkToken(postPlaidLinkTokenRequest, idempotencyKey, melioAccount, organizationId, userId, options).then((request) => request(axios2, basePath));
    },
    /**
     * Link funding-source to an accounting platform\'s payment account.
     * @summary Link funding-source to a payment account
     * @param {string} id ID of the entity
     * @param {PostFundingSourceLinkPaymentAccountRequest} [postFundingSourceLinkPaymentAccountRequest] 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postLinkAccountingPlatformPaymentAccount(id, postFundingSourceLinkPaymentAccountRequest, expand, idempotencyKey, melioAccount, options) {
      return localVarFp.postLinkAccountingPlatformPaymentAccount(id, postFundingSourceLinkPaymentAccountRequest, expand, idempotencyKey, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Update funding-sources plaid account
     * @summary Update funding-sources plaid account
     * @param {string} id ID of the entity
     * @param {PutFundingSourcesUpdatePlaidAccountRequest} [putFundingSourcesUpdatePlaidAccountRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    putFundingSourcesUpdatePlaidAccount(id, putFundingSourcesUpdatePlaidAccountRequest, options) {
      return localVarFp.putFundingSourcesUpdatePlaidAccount(id, putFundingSourcesUpdatePlaidAccountRequest, options).then((request) => request(axios2, basePath));
    }
  };
};
var FundingSourcesApi = class extends BaseAPI {
  /**
   * Remove a Funding Source from the Account
   * @summary Delete a Funding Source
   * @param {FundingSourcesApiDeleteFundingSourcesFundingSourceIdRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FundingSourcesApi
   */
  deleteFundingSourcesFundingSourceId(requestParameters, options) {
    return FundingSourcesApiFp(this.configuration).deleteFundingSourcesFundingSourceId(requestParameters.id, requestParameters.expand, requestParameters.shouldDecrypt, requestParameters.idempotencyKey, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Get a `FundingSource` object by your own internal ID number, rather than Melio\'s ID. Ask your Melio account manager the source of this number. This method may not be available for all partners or all funding source types; if not, you will get a 404 response code to your requests. 
   * @summary Get FundingSource by partner\'s internal ID
   * @param {FundingSourcesApiGetFundingSourceIdentifyRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FundingSourcesApi
   */
  getFundingSourceIdentify(requestParameters, options) {
    return FundingSourcesApiFp(this.configuration).getFundingSourceIdentify(requestParameters.id, requestParameters.expand, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Retrieve the Funding Sources of an Account
   * @summary Get all Funding Sources
   * @param {FundingSourcesApiGetFundingSourcesRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FundingSourcesApi
   */
  getFundingSources(requestParameters = {}, options) {
    return FundingSourcesApiFp(this.configuration).getFundingSources(requestParameters.expand, requestParameters.melioAccount, requestParameters.include, requestParameters.shouldDecrypt, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Retrieve details about a specific Funding Source
   * @summary Retrieve a Funding Source
   * @param {FundingSourcesApiGetFundingSourcesFundingSourceIdRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FundingSourcesApi
   */
  getFundingSourcesFundingSourceId(requestParameters, options) {
    return FundingSourcesApiFp(this.configuration).getFundingSourcesFundingSourceId(requestParameters.id, requestParameters.expand, requestParameters.shouldDecrypt, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Update a Funding Source.
   * @summary Update a Funding Source
   * @param {FundingSourcesApiPatchFundingSourcesFundingSourceIdRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FundingSourcesApi
   */
  patchFundingSourcesFundingSourceId(requestParameters, options) {
    return FundingSourcesApiFp(this.configuration).patchFundingSourcesFundingSourceId(requestParameters.id, requestParameters.patchFundingSourcesRequest, requestParameters.expand, requestParameters.shouldDecrypt, requestParameters.idempotencyKey, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Create a new Funding Source for the Account.  The `type` field determines the contents of the `details` field, according to the following mapping: * `bank-account` => `BankAccount` * `plaid` => `PlaidDetails` * `card` => `Card`
   * @summary Create a Funding Source
   * @param {FundingSourcesApiPostFundingSourcesRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FundingSourcesApi
   */
  postFundingSources(requestParameters = {}, options) {
    return FundingSourcesApiFp(this.configuration).postFundingSources(requestParameters.postFundingSourcesRequest, requestParameters.expand, requestParameters.idempotencyKey, requestParameters.melioAccount, requestParameters.organizationId, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Verify a Funding Source with Micro Deposits
   * @summary Verify a Funding Source
   * @param {FundingSourcesApiPostFundingSourcesFundingSourceIdVerifyRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FundingSourcesApi
   */
  postFundingSourcesFundingSourceIdVerify(requestParameters, options) {
    return FundingSourcesApiFp(this.configuration).postFundingSourcesFundingSourceIdVerify(requestParameters.id, requestParameters.postFundingSourcesFundingSourceIdVerifyRequestPostFundingSourcesVerifyRequest, requestParameters.expand, requestParameters.idempotencyKey, requestParameters.melioAccount, requestParameters.organizationId, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * This operation returns an access token for using plaid link
   * @summary Create access token for plaid link
   * @param {FundingSourcesApiPostFundingSourcesPlaidLinkTokenRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FundingSourcesApi
   */
  postFundingSourcesPlaidLinkToken(requestParameters = {}, options) {
    return FundingSourcesApiFp(this.configuration).postFundingSourcesPlaidLinkToken(requestParameters.postPlaidLinkTokenRequest, requestParameters.idempotencyKey, requestParameters.melioAccount, requestParameters.organizationId, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Link funding-source to an accounting platform\'s payment account.
   * @summary Link funding-source to a payment account
   * @param {FundingSourcesApiPostLinkAccountingPlatformPaymentAccountRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FundingSourcesApi
   */
  postLinkAccountingPlatformPaymentAccount(requestParameters, options) {
    return FundingSourcesApiFp(this.configuration).postLinkAccountingPlatformPaymentAccount(requestParameters.id, requestParameters.postFundingSourceLinkPaymentAccountRequest, requestParameters.expand, requestParameters.idempotencyKey, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Update funding-sources plaid account
   * @summary Update funding-sources plaid account
   * @param {FundingSourcesApiPutFundingSourcesUpdatePlaidAccountRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FundingSourcesApi
   */
  putFundingSourcesUpdatePlaidAccount(requestParameters, options) {
    return FundingSourcesApiFp(this.configuration).putFundingSourcesUpdatePlaidAccount(requestParameters.id, requestParameters.putFundingSourcesUpdatePlaidAccountRequest, options).then((request) => request(this.axios, this.basePath));
  }
};
var FundingSourcesApiInstance = createInstanceFromApiIClass(FundingSourcesApi);
var GetBillsBillIdAttachmentsApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * Get Bill attachments for synced bills and eBills.
     * @summary get bill attachments for synced bills and eBills
     * @param {string} id ID of the entity
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBillsBillIdAttachments: (_0, _1, _2, ..._3) => __async(this, [_0, _1, _2, ..._3], function* (id, expand, melioAccount, options = {}) {
      assertParamExists("getBillsBillIdAttachments", "id", id);
      const localVarPath = `/bills/{id}/attachments`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (expand !== void 0 && expand !== null) {
        localVarHeaderParameter["expand"] = String(JSON.stringify(expand));
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    })
  };
};
var GetBillsBillIdAttachmentsApiFp = function(configuration) {
  const localVarAxiosParamCreator = GetBillsBillIdAttachmentsApiAxiosParamCreator(configuration);
  return {
    /**
     * Get Bill attachments for synced bills and eBills.
     * @summary get bill attachments for synced bills and eBills
     * @param {string} id ID of the entity
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBillsBillIdAttachments(id, expand, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getBillsBillIdAttachments(id, expand, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    }
  };
};
var GetBillsBillIdAttachmentsApiClient = createApiFromFp(GetBillsBillIdAttachmentsApiFp);
var GetBillsBillIdAttachmentsApiFactory = function(configuration, basePath, axios2) {
  const localVarFp = GetBillsBillIdAttachmentsApiFp(configuration);
  return {
    /**
     * Get Bill attachments for synced bills and eBills.
     * @summary get bill attachments for synced bills and eBills
     * @param {string} id ID of the entity
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBillsBillIdAttachments(id, expand, melioAccount, options) {
      return localVarFp.getBillsBillIdAttachments(id, expand, melioAccount, options).then((request) => request(axios2, basePath));
    }
  };
};
var GetBillsBillIdAttachmentsApi = class extends BaseAPI {
  /**
   * Get Bill attachments for synced bills and eBills.
   * @summary get bill attachments for synced bills and eBills
   * @param {GetBillsBillIdAttachmentsApiGetBillsBillIdAttachmentsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof GetBillsBillIdAttachmentsApi
   */
  getBillsBillIdAttachments(requestParameters, options) {
    return GetBillsBillIdAttachmentsApiFp(this.configuration).getBillsBillIdAttachments(requestParameters.id, requestParameters.expand, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
};
var GetBillsBillIdAttachmentsApiInstance = createInstanceFromApiIClass(GetBillsBillIdAttachmentsApi);
var InboxItemsApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * Retrieve a list of all unpaid bills, scanned invoices, pending payment requests and payments
     * @summary Retrieve all the items that unpaid bills, scanned invoices, pending payment requests and payments
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [searchTerm] Limit returned objects to those that contain the specified search string. Search is a case-insensitive, substring match against a subset of fields in the object. See the method documentation to learn which fields can be matched by the &#x60;searchTerm&#x60; value. [Read more](https://docs.melio.com/docs/melio-data-api/getting-started#simple_search) 
     * @param {InboxItemTypesEnum | Array<InboxItemTypesEnum>} [inboxItemTypes] 
     * @param {Array<InboxItemsSortQueryParam>} [sort] Sort query parameter - sort data by entity fields
     * @param {number} [limit] A limit on the number of records to be returned.
     * @param {PaginationCursor} [cursor] Used to page through page through results when the &#x60;totalCount&#x60; is more than the current set of results. To page, specify \&quot;cursor[prev]&#x3D;_&lt;prev_token&gt;_\&quot; or \&quot;cursor[next]&#x3D;_&lt;next_token&gt;_\&quot; as a URL parameter. 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getInboxItems: (_0, _1, _2, _3, _4, _5, ..._6) => __async(this, [_0, _1, _2, _3, _4, _5, ..._6], function* (expand, searchTerm, inboxItemTypes, sort, limit, cursor, options = {}) {
      const localVarPath = `/inbox-items`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (expand !== void 0) {
        localVarQueryParameter["expand"] = expand;
      }
      if (searchTerm !== void 0) {
        localVarQueryParameter["searchTerm"] = searchTerm;
      }
      if (inboxItemTypes !== void 0) {
        localVarQueryParameter["inboxItemTypes"] = inboxItemTypes;
      }
      if (sort) {
        localVarQueryParameter["sort"] = sort;
      }
      if (limit !== void 0) {
        localVarQueryParameter["limit"] = limit;
      }
      if (cursor !== void 0) {
        localVarQueryParameter["cursor"] = cursor;
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    })
  };
};
var InboxItemsApiFp = function(configuration) {
  const localVarAxiosParamCreator = InboxItemsApiAxiosParamCreator(configuration);
  return {
    /**
     * Retrieve a list of all unpaid bills, scanned invoices, pending payment requests and payments
     * @summary Retrieve all the items that unpaid bills, scanned invoices, pending payment requests and payments
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [searchTerm] Limit returned objects to those that contain the specified search string. Search is a case-insensitive, substring match against a subset of fields in the object. See the method documentation to learn which fields can be matched by the &#x60;searchTerm&#x60; value. [Read more](https://docs.melio.com/docs/melio-data-api/getting-started#simple_search) 
     * @param {InboxItemTypesEnum | Array<InboxItemTypesEnum>} [inboxItemTypes] 
     * @param {Array<InboxItemsSortQueryParam>} [sort] Sort query parameter - sort data by entity fields
     * @param {number} [limit] A limit on the number of records to be returned.
     * @param {PaginationCursor} [cursor] Used to page through page through results when the &#x60;totalCount&#x60; is more than the current set of results. To page, specify \&quot;cursor[prev]&#x3D;_&lt;prev_token&gt;_\&quot; or \&quot;cursor[next]&#x3D;_&lt;next_token&gt;_\&quot; as a URL parameter. 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getInboxItems(expand, searchTerm, inboxItemTypes, sort, limit, cursor, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getInboxItems(expand, searchTerm, inboxItemTypes, sort, limit, cursor, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    }
  };
};
var InboxItemsApiClient = createApiFromFp(InboxItemsApiFp);
var InboxItemsApiFactory = function(configuration, basePath, axios2) {
  const localVarFp = InboxItemsApiFp(configuration);
  return {
    /**
     * Retrieve a list of all unpaid bills, scanned invoices, pending payment requests and payments
     * @summary Retrieve all the items that unpaid bills, scanned invoices, pending payment requests and payments
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [searchTerm] Limit returned objects to those that contain the specified search string. Search is a case-insensitive, substring match against a subset of fields in the object. See the method documentation to learn which fields can be matched by the &#x60;searchTerm&#x60; value. [Read more](https://docs.melio.com/docs/melio-data-api/getting-started#simple_search) 
     * @param {InboxItemTypesEnum | Array<InboxItemTypesEnum>} [inboxItemTypes] 
     * @param {Array<InboxItemsSortQueryParam>} [sort] Sort query parameter - sort data by entity fields
     * @param {number} [limit] A limit on the number of records to be returned.
     * @param {PaginationCursor} [cursor] Used to page through page through results when the &#x60;totalCount&#x60; is more than the current set of results. To page, specify \&quot;cursor[prev]&#x3D;_&lt;prev_token&gt;_\&quot; or \&quot;cursor[next]&#x3D;_&lt;next_token&gt;_\&quot; as a URL parameter. 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getInboxItems(expand, searchTerm, inboxItemTypes, sort, limit, cursor, options) {
      return localVarFp.getInboxItems(expand, searchTerm, inboxItemTypes, sort, limit, cursor, options).then((request) => request(axios2, basePath));
    }
  };
};
var InboxItemsApi = class extends BaseAPI {
  /**
   * Retrieve a list of all unpaid bills, scanned invoices, pending payment requests and payments
   * @summary Retrieve all the items that unpaid bills, scanned invoices, pending payment requests and payments
   * @param {InboxItemsApiGetInboxItemsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InboxItemsApi
   */
  getInboxItems(requestParameters = {}, options) {
    return InboxItemsApiFp(this.configuration).getInboxItems(requestParameters.expand, requestParameters.searchTerm, requestParameters.inboxItemTypes, requestParameters.sort, requestParameters.limit, requestParameters.cursor, options).then((request) => request(this.axios, this.basePath));
  }
};
var InboxItemsApiInstance = createInstanceFromApiIClass(InboxItemsApi);
var IndustriesApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * List of all industry types, filtered by the q parameter and with provided query limit (default 20).
     * @summary Retrieve all filtered industry types
     * @param {string} q The name of the industry type to query
     * @param {number} [limit] The number of items to include in the returned list
     * @param {boolean} [sixDigitOnly] Retrieve only 6-digit NAICS codes, which provide the highest level of industry specificity.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getIndustryTypes: (_0, _1, _2, ..._3) => __async(this, [_0, _1, _2, ..._3], function* (q, limit, sixDigitOnly, options = {}) {
      assertParamExists("getIndustryTypes", "q", q);
      const localVarPath = `/industry-types`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      if (q !== void 0) {
        localVarQueryParameter["q"] = q;
      }
      if (limit !== void 0) {
        localVarQueryParameter["limit"] = limit;
      }
      if (sixDigitOnly !== void 0) {
        localVarQueryParameter["sixDigitOnly"] = sixDigitOnly;
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    })
  };
};
var IndustriesApiFp = function(configuration) {
  const localVarAxiosParamCreator = IndustriesApiAxiosParamCreator(configuration);
  return {
    /**
     * List of all industry types, filtered by the q parameter and with provided query limit (default 20).
     * @summary Retrieve all filtered industry types
     * @param {string} q The name of the industry type to query
     * @param {number} [limit] The number of items to include in the returned list
     * @param {boolean} [sixDigitOnly] Retrieve only 6-digit NAICS codes, which provide the highest level of industry specificity.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getIndustryTypes(q, limit, sixDigitOnly, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getIndustryTypes(q, limit, sixDigitOnly, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    }
  };
};
var IndustriesApiClient = createApiFromFp(IndustriesApiFp);
var IndustriesApiFactory = function(configuration, basePath, axios2) {
  const localVarFp = IndustriesApiFp(configuration);
  return {
    /**
     * List of all industry types, filtered by the q parameter and with provided query limit (default 20).
     * @summary Retrieve all filtered industry types
     * @param {string} q The name of the industry type to query
     * @param {number} [limit] The number of items to include in the returned list
     * @param {boolean} [sixDigitOnly] Retrieve only 6-digit NAICS codes, which provide the highest level of industry specificity.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getIndustryTypes(q, limit, sixDigitOnly, options) {
      return localVarFp.getIndustryTypes(q, limit, sixDigitOnly, options).then((request) => request(axios2, basePath));
    }
  };
};
var IndustriesApi = class extends BaseAPI {
  /**
   * List of all industry types, filtered by the q parameter and with provided query limit (default 20).
   * @summary Retrieve all filtered industry types
   * @param {IndustriesApiGetIndustryTypesRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof IndustriesApi
   */
  getIndustryTypes(requestParameters, options) {
    return IndustriesApiFp(this.configuration).getIndustryTypes(requestParameters.q, requestParameters.limit, requestParameters.sixDigitOnly, options).then((request) => request(this.axios, this.basePath));
  }
};
var IndustriesApiInstance = createInstanceFromApiIClass(IndustriesApi);
var IndustryApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * Retrieve list of industries.
     * @summary Retrieve list of industries.
     * @param {string} [melioAccount] The &#x60;Melio-Account&#x60; header is used when a Partner wants to perform an operation on behalf of one of its Accounts. It contains the Account\&#39;s ID which returned when creating the Account, or when retrieving all of the Partner\&#39;s Accounts. Note that most operations are not permitted without the presence of this header.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getIndustries: (_0, ..._1) => __async(this, [_0, ..._1], function* (melioAccount, options = {}) {
      const localVarPath = `/account-receivable/industries`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Retrieve industry by id
     * @summary Retrieve industry by id
     * @param {string} id Id of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getIndustryById: (_0, ..._1) => __async(this, [_0, ..._1], function* (id, options = {}) {
      assertParamExists("getIndustryById", "id", id);
      const localVarPath = `/account-receivable/industries/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    })
  };
};
var IndustryApiFp = function(configuration) {
  const localVarAxiosParamCreator = IndustryApiAxiosParamCreator(configuration);
  return {
    /**
     * Retrieve list of industries.
     * @summary Retrieve list of industries.
     * @param {string} [melioAccount] The &#x60;Melio-Account&#x60; header is used when a Partner wants to perform an operation on behalf of one of its Accounts. It contains the Account\&#39;s ID which returned when creating the Account, or when retrieving all of the Partner\&#39;s Accounts. Note that most operations are not permitted without the presence of this header.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getIndustries(melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getIndustries(melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Retrieve industry by id
     * @summary Retrieve industry by id
     * @param {string} id Id of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getIndustryById(id, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getIndustryById(id, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    }
  };
};
var IndustryApiClient = createApiFromFp(IndustryApiFp);
var IndustryApiFactory = function(configuration, basePath, axios2) {
  const localVarFp = IndustryApiFp(configuration);
  return {
    /**
     * Retrieve list of industries.
     * @summary Retrieve list of industries.
     * @param {string} [melioAccount] The &#x60;Melio-Account&#x60; header is used when a Partner wants to perform an operation on behalf of one of its Accounts. It contains the Account\&#39;s ID which returned when creating the Account, or when retrieving all of the Partner\&#39;s Accounts. Note that most operations are not permitted without the presence of this header.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getIndustries(melioAccount, options) {
      return localVarFp.getIndustries(melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Retrieve industry by id
     * @summary Retrieve industry by id
     * @param {string} id Id of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getIndustryById(id, options) {
      return localVarFp.getIndustryById(id, options).then((request) => request(axios2, basePath));
    }
  };
};
var IndustryApi = class extends BaseAPI {
  /**
   * Retrieve list of industries.
   * @summary Retrieve list of industries.
   * @param {IndustryApiGetIndustriesRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof IndustryApi
   */
  getIndustries(requestParameters = {}, options) {
    return IndustryApiFp(this.configuration).getIndustries(requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Retrieve industry by id
   * @summary Retrieve industry by id
   * @param {IndustryApiGetIndustryByIdRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof IndustryApi
   */
  getIndustryById(requestParameters, options) {
    return IndustryApiFp(this.configuration).getIndustryById(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
  }
};
var IndustryApiInstance = createInstanceFromApiIClass(IndustryApi);
var InternationalApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * 
     * @summary Get all supported international currencies
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getInternationalCurrencies: (_0, ..._1) => __async(this, [_0, ..._1], function* (melioAccount, options = {}) {
      const localVarPath = `/international/currencies`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * 
     * @summary Get an international exchange rate for a specific currency
     * @param {string} foreignCurrency The foreign currency
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {number} [foreignAmount] An optional foreign amount to use for the rate calculation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getInternationalRate: (_0, _1, _2, ..._3) => __async(this, [_0, _1, _2, ..._3], function* (foreignCurrency, melioAccount, foreignAmount, options = {}) {
      assertParamExists("getInternationalRate", "foreignCurrency", foreignCurrency);
      const localVarPath = `/international/rate`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (foreignCurrency !== void 0) {
        localVarQueryParameter["foreignCurrency"] = foreignCurrency;
      }
      if (foreignAmount !== void 0) {
        localVarQueryParameter["foreignAmount"] = foreignAmount;
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * 
     * @summary Get all supported international exchange rates
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getInternationalRates: (_0, ..._1) => __async(this, [_0, ..._1], function* (melioAccount, options = {}) {
      const localVarPath = `/international/rates`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * 
     * @param {PostInternationalQuoteRequest} [postInternationalQuoteRequest] 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postInternationalQuote: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (postInternationalQuoteRequest, melioAccount, options = {}) {
      const localVarPath = `/international/quote`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postInternationalQuoteRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * 
     * @param {PostInternationalQuotesRequest} [postInternationalQuotesRequest] 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postInternationalQuotes: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (postInternationalQuotesRequest, melioAccount, options = {}) {
      const localVarPath = `/international/quotes`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postInternationalQuotesRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    })
  };
};
var InternationalApiFp = function(configuration) {
  const localVarAxiosParamCreator = InternationalApiAxiosParamCreator(configuration);
  return {
    /**
     * 
     * @summary Get all supported international currencies
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getInternationalCurrencies(melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getInternationalCurrencies(melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * 
     * @summary Get an international exchange rate for a specific currency
     * @param {string} foreignCurrency The foreign currency
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {number} [foreignAmount] An optional foreign amount to use for the rate calculation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getInternationalRate(foreignCurrency, melioAccount, foreignAmount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getInternationalRate(foreignCurrency, melioAccount, foreignAmount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * 
     * @summary Get all supported international exchange rates
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getInternationalRates(melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getInternationalRates(melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * 
     * @param {PostInternationalQuoteRequest} [postInternationalQuoteRequest] 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postInternationalQuote(postInternationalQuoteRequest, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postInternationalQuote(postInternationalQuoteRequest, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * 
     * @param {PostInternationalQuotesRequest} [postInternationalQuotesRequest] 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postInternationalQuotes(postInternationalQuotesRequest, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postInternationalQuotes(postInternationalQuotesRequest, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    }
  };
};
var InternationalApiClient = createApiFromFp(InternationalApiFp);
var InternationalApiFactory = function(configuration, basePath, axios2) {
  const localVarFp = InternationalApiFp(configuration);
  return {
    /**
     * 
     * @summary Get all supported international currencies
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getInternationalCurrencies(melioAccount, options) {
      return localVarFp.getInternationalCurrencies(melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * 
     * @summary Get an international exchange rate for a specific currency
     * @param {string} foreignCurrency The foreign currency
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {number} [foreignAmount] An optional foreign amount to use for the rate calculation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getInternationalRate(foreignCurrency, melioAccount, foreignAmount, options) {
      return localVarFp.getInternationalRate(foreignCurrency, melioAccount, foreignAmount, options).then((request) => request(axios2, basePath));
    },
    /**
     * 
     * @summary Get all supported international exchange rates
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getInternationalRates(melioAccount, options) {
      return localVarFp.getInternationalRates(melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * 
     * @param {PostInternationalQuoteRequest} [postInternationalQuoteRequest] 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postInternationalQuote(postInternationalQuoteRequest, melioAccount, options) {
      return localVarFp.postInternationalQuote(postInternationalQuoteRequest, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * 
     * @param {PostInternationalQuotesRequest} [postInternationalQuotesRequest] 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postInternationalQuotes(postInternationalQuotesRequest, melioAccount, options) {
      return localVarFp.postInternationalQuotes(postInternationalQuotesRequest, melioAccount, options).then((request) => request(axios2, basePath));
    }
  };
};
var InternationalApi = class extends BaseAPI {
  /**
   * 
   * @summary Get all supported international currencies
   * @param {InternationalApiGetInternationalCurrenciesRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InternationalApi
   */
  getInternationalCurrencies(requestParameters = {}, options) {
    return InternationalApiFp(this.configuration).getInternationalCurrencies(requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Get an international exchange rate for a specific currency
   * @param {InternationalApiGetInternationalRateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InternationalApi
   */
  getInternationalRate(requestParameters, options) {
    return InternationalApiFp(this.configuration).getInternationalRate(requestParameters.foreignCurrency, requestParameters.melioAccount, requestParameters.foreignAmount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Get all supported international exchange rates
   * @param {InternationalApiGetInternationalRatesRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InternationalApi
   */
  getInternationalRates(requestParameters = {}, options) {
    return InternationalApiFp(this.configuration).getInternationalRates(requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * 
   * @param {InternationalApiPostInternationalQuoteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InternationalApi
   */
  postInternationalQuote(requestParameters = {}, options) {
    return InternationalApiFp(this.configuration).postInternationalQuote(requestParameters.postInternationalQuoteRequest, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * 
   * @param {InternationalApiPostInternationalQuotesRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InternationalApi
   */
  postInternationalQuotes(requestParameters = {}, options) {
    return InternationalApiFp(this.configuration).postInternationalQuotes(requestParameters.postInternationalQuotesRequest, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
};
var InternationalApiInstance = createInstanceFromApiIClass(InternationalApi);
var InvoiceDiscountsApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * This operation deletes a invoice discount by id
     * @summary Delete a invoice discount by id
     * @param {string} id Id of the entity
     * @param {string} [melioAccount] The &#x60;Melio-Account&#x60; header is used when a Partner wants to perform an operation on behalf of one of its Accounts. It contains the Account\&#39;s ID which returned when creating the Account, or when retrieving all of the Partner\&#39;s Accounts. Note that most operations are not permitted without the presence of this header.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteInvoiceDiscountById: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (id, melioAccount, options = {}) {
      assertParamExists("deleteInvoiceDiscountById", "id", id);
      const localVarPath = `/account-receivable/invoice-discount/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "DELETE" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Get a invoice discount by ID
     * @summary Get a invoice discount
     * @param {string} id Id of the entity
     * @param {string} [melioAccount] The &#x60;Melio-Account&#x60; header is used when a Partner wants to perform an operation on behalf of one of its Accounts. It contains the Account\&#39;s ID which returned when creating the Account, or when retrieving all of the Partner\&#39;s Accounts. Note that most operations are not permitted without the presence of this header.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getInvoiceDiscountById: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (id, melioAccount, options = {}) {
      assertParamExists("getInvoiceDiscountById", "id", id);
      const localVarPath = `/account-receivable/invoice-discount/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Retrieve a list of invoice discounts of organization
     * @summary Retrieve organization invoice discounts
     * @param {string} [melioAccount] The &#x60;Melio-Account&#x60; header is used when a Partner wants to perform an operation on behalf of one of its Accounts. It contains the Account\&#39;s ID which returned when creating the Account, or when retrieving all of the Partner\&#39;s Accounts. Note that most operations are not permitted without the presence of this header.
     * @param {number} [start] Start position
     * @param {number} [limit] Maximum number of results to return
     * @param {string} [sort] Sorting order
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getInvoiceDiscounts: (_0, _1, _2, _3, ..._4) => __async(this, [_0, _1, _2, _3, ..._4], function* (melioAccount, start, limit, sort, options = {}) {
      const localVarPath = `/account-receivable/invoice-discount`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (start !== void 0) {
        localVarQueryParameter["start"] = start;
      }
      if (limit !== void 0) {
        localVarQueryParameter["limit"] = limit;
      }
      if (sort !== void 0) {
        localVarQueryParameter["sort"] = sort;
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Create a new invoice discount.
     * @summary Create invoice discount
     * @param {PostInvoiceDiscountRequest} [postInvoiceDiscountRequest] 
     * @param {string} [melioAccount] The &#x60;Melio-Account&#x60; header is used when a Partner wants to perform an operation on behalf of one of its Accounts. It contains the Account\&#39;s ID which returned when creating the Account, or when retrieving all of the Partner\&#39;s Accounts. Note that most operations are not permitted without the presence of this header.
     * @param {SchemasExpand} [expand] Expand header parameters - use for expanding responses for POST &amp; PATCH requests
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postInvoiceDiscount: (_0, _1, _2, ..._3) => __async(this, [_0, _1, _2, ..._3], function* (postInvoiceDiscountRequest, melioAccount, expand, options = {}) {
      const localVarPath = `/account-receivable/invoice-discount`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      if (expand !== void 0 && expand !== null) {
        localVarHeaderParameter["expand"] = String(JSON.stringify(expand));
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postInvoiceDiscountRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Update a invoice discount by ID
     * @summary Update invoice discount
     * @param {string} id Id of the entity
     * @param {PatchInvoiceDiscountRequest} [patchInvoiceDiscountRequest] 
     * @param {string} [melioAccount] The &#x60;Melio-Account&#x60; header is used when a Partner wants to perform an operation on behalf of one of its Accounts. It contains the Account\&#39;s ID which returned when creating the Account, or when retrieving all of the Partner\&#39;s Accounts. Note that most operations are not permitted without the presence of this header.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateInvoiceDiscountById: (_0, _1, _2, ..._3) => __async(this, [_0, _1, _2, ..._3], function* (id, patchInvoiceDiscountRequest, melioAccount, options = {}) {
      assertParamExists("updateInvoiceDiscountById", "id", id);
      const localVarPath = `/account-receivable/invoice-discount/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "PATCH" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(patchInvoiceDiscountRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    })
  };
};
var InvoiceDiscountsApiFp = function(configuration) {
  const localVarAxiosParamCreator = InvoiceDiscountsApiAxiosParamCreator(configuration);
  return {
    /**
     * This operation deletes a invoice discount by id
     * @summary Delete a invoice discount by id
     * @param {string} id Id of the entity
     * @param {string} [melioAccount] The &#x60;Melio-Account&#x60; header is used when a Partner wants to perform an operation on behalf of one of its Accounts. It contains the Account\&#39;s ID which returned when creating the Account, or when retrieving all of the Partner\&#39;s Accounts. Note that most operations are not permitted without the presence of this header.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteInvoiceDiscountById(id, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteInvoiceDiscountById(id, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Get a invoice discount by ID
     * @summary Get a invoice discount
     * @param {string} id Id of the entity
     * @param {string} [melioAccount] The &#x60;Melio-Account&#x60; header is used when a Partner wants to perform an operation on behalf of one of its Accounts. It contains the Account\&#39;s ID which returned when creating the Account, or when retrieving all of the Partner\&#39;s Accounts. Note that most operations are not permitted without the presence of this header.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getInvoiceDiscountById(id, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getInvoiceDiscountById(id, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Retrieve a list of invoice discounts of organization
     * @summary Retrieve organization invoice discounts
     * @param {string} [melioAccount] The &#x60;Melio-Account&#x60; header is used when a Partner wants to perform an operation on behalf of one of its Accounts. It contains the Account\&#39;s ID which returned when creating the Account, or when retrieving all of the Partner\&#39;s Accounts. Note that most operations are not permitted without the presence of this header.
     * @param {number} [start] Start position
     * @param {number} [limit] Maximum number of results to return
     * @param {string} [sort] Sorting order
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getInvoiceDiscounts(melioAccount, start, limit, sort, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getInvoiceDiscounts(melioAccount, start, limit, sort, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Create a new invoice discount.
     * @summary Create invoice discount
     * @param {PostInvoiceDiscountRequest} [postInvoiceDiscountRequest] 
     * @param {string} [melioAccount] The &#x60;Melio-Account&#x60; header is used when a Partner wants to perform an operation on behalf of one of its Accounts. It contains the Account\&#39;s ID which returned when creating the Account, or when retrieving all of the Partner\&#39;s Accounts. Note that most operations are not permitted without the presence of this header.
     * @param {SchemasExpand} [expand] Expand header parameters - use for expanding responses for POST &amp; PATCH requests
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postInvoiceDiscount(postInvoiceDiscountRequest, melioAccount, expand, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postInvoiceDiscount(postInvoiceDiscountRequest, melioAccount, expand, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Update a invoice discount by ID
     * @summary Update invoice discount
     * @param {string} id Id of the entity
     * @param {PatchInvoiceDiscountRequest} [patchInvoiceDiscountRequest] 
     * @param {string} [melioAccount] The &#x60;Melio-Account&#x60; header is used when a Partner wants to perform an operation on behalf of one of its Accounts. It contains the Account\&#39;s ID which returned when creating the Account, or when retrieving all of the Partner\&#39;s Accounts. Note that most operations are not permitted without the presence of this header.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateInvoiceDiscountById(id, patchInvoiceDiscountRequest, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.updateInvoiceDiscountById(id, patchInvoiceDiscountRequest, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    }
  };
};
var InvoiceDiscountsApiClient = createApiFromFp(InvoiceDiscountsApiFp);
var InvoiceDiscountsApiFactory = function(configuration, basePath, axios2) {
  const localVarFp = InvoiceDiscountsApiFp(configuration);
  return {
    /**
     * This operation deletes a invoice discount by id
     * @summary Delete a invoice discount by id
     * @param {string} id Id of the entity
     * @param {string} [melioAccount] The &#x60;Melio-Account&#x60; header is used when a Partner wants to perform an operation on behalf of one of its Accounts. It contains the Account\&#39;s ID which returned when creating the Account, or when retrieving all of the Partner\&#39;s Accounts. Note that most operations are not permitted without the presence of this header.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteInvoiceDiscountById(id, melioAccount, options) {
      return localVarFp.deleteInvoiceDiscountById(id, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Get a invoice discount by ID
     * @summary Get a invoice discount
     * @param {string} id Id of the entity
     * @param {string} [melioAccount] The &#x60;Melio-Account&#x60; header is used when a Partner wants to perform an operation on behalf of one of its Accounts. It contains the Account\&#39;s ID which returned when creating the Account, or when retrieving all of the Partner\&#39;s Accounts. Note that most operations are not permitted without the presence of this header.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getInvoiceDiscountById(id, melioAccount, options) {
      return localVarFp.getInvoiceDiscountById(id, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Retrieve a list of invoice discounts of organization
     * @summary Retrieve organization invoice discounts
     * @param {string} [melioAccount] The &#x60;Melio-Account&#x60; header is used when a Partner wants to perform an operation on behalf of one of its Accounts. It contains the Account\&#39;s ID which returned when creating the Account, or when retrieving all of the Partner\&#39;s Accounts. Note that most operations are not permitted without the presence of this header.
     * @param {number} [start] Start position
     * @param {number} [limit] Maximum number of results to return
     * @param {string} [sort] Sorting order
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getInvoiceDiscounts(melioAccount, start, limit, sort, options) {
      return localVarFp.getInvoiceDiscounts(melioAccount, start, limit, sort, options).then((request) => request(axios2, basePath));
    },
    /**
     * Create a new invoice discount.
     * @summary Create invoice discount
     * @param {PostInvoiceDiscountRequest} [postInvoiceDiscountRequest] 
     * @param {string} [melioAccount] The &#x60;Melio-Account&#x60; header is used when a Partner wants to perform an operation on behalf of one of its Accounts. It contains the Account\&#39;s ID which returned when creating the Account, or when retrieving all of the Partner\&#39;s Accounts. Note that most operations are not permitted without the presence of this header.
     * @param {SchemasExpand} [expand] Expand header parameters - use for expanding responses for POST &amp; PATCH requests
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postInvoiceDiscount(postInvoiceDiscountRequest, melioAccount, expand, options) {
      return localVarFp.postInvoiceDiscount(postInvoiceDiscountRequest, melioAccount, expand, options).then((request) => request(axios2, basePath));
    },
    /**
     * Update a invoice discount by ID
     * @summary Update invoice discount
     * @param {string} id Id of the entity
     * @param {PatchInvoiceDiscountRequest} [patchInvoiceDiscountRequest] 
     * @param {string} [melioAccount] The &#x60;Melio-Account&#x60; header is used when a Partner wants to perform an operation on behalf of one of its Accounts. It contains the Account\&#39;s ID which returned when creating the Account, or when retrieving all of the Partner\&#39;s Accounts. Note that most operations are not permitted without the presence of this header.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateInvoiceDiscountById(id, patchInvoiceDiscountRequest, melioAccount, options) {
      return localVarFp.updateInvoiceDiscountById(id, patchInvoiceDiscountRequest, melioAccount, options).then((request) => request(axios2, basePath));
    }
  };
};
var InvoiceDiscountsApi = class extends BaseAPI {
  /**
   * This operation deletes a invoice discount by id
   * @summary Delete a invoice discount by id
   * @param {InvoiceDiscountsApiDeleteInvoiceDiscountByIdRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InvoiceDiscountsApi
   */
  deleteInvoiceDiscountById(requestParameters, options) {
    return InvoiceDiscountsApiFp(this.configuration).deleteInvoiceDiscountById(requestParameters.id, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Get a invoice discount by ID
   * @summary Get a invoice discount
   * @param {InvoiceDiscountsApiGetInvoiceDiscountByIdRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InvoiceDiscountsApi
   */
  getInvoiceDiscountById(requestParameters, options) {
    return InvoiceDiscountsApiFp(this.configuration).getInvoiceDiscountById(requestParameters.id, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Retrieve a list of invoice discounts of organization
   * @summary Retrieve organization invoice discounts
   * @param {InvoiceDiscountsApiGetInvoiceDiscountsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InvoiceDiscountsApi
   */
  getInvoiceDiscounts(requestParameters = {}, options) {
    return InvoiceDiscountsApiFp(this.configuration).getInvoiceDiscounts(requestParameters.melioAccount, requestParameters.start, requestParameters.limit, requestParameters.sort, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Create a new invoice discount.
   * @summary Create invoice discount
   * @param {InvoiceDiscountsApiPostInvoiceDiscountRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InvoiceDiscountsApi
   */
  postInvoiceDiscount(requestParameters = {}, options) {
    return InvoiceDiscountsApiFp(this.configuration).postInvoiceDiscount(requestParameters.postInvoiceDiscountRequest, requestParameters.melioAccount, requestParameters.expand, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Update a invoice discount by ID
   * @summary Update invoice discount
   * @param {InvoiceDiscountsApiUpdateInvoiceDiscountByIdRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InvoiceDiscountsApi
   */
  updateInvoiceDiscountById(requestParameters, options) {
    return InvoiceDiscountsApiFp(this.configuration).updateInvoiceDiscountById(requestParameters.id, requestParameters.patchInvoiceDiscountRequest, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
};
var InvoiceDiscountsApiInstance = createInstanceFromApiIClass(InvoiceDiscountsApi);
var InvoiceExpandedApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * Retrieve an expanded invoice by id
     * @summary Retrieve invoice with expanded info (calculations of the invoice) by id
     * @param {string} id Id of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getExpandedInvoice: (_0, ..._1) => __async(this, [_0, ..._1], function* (id, options = {}) {
      assertParamExists("getExpandedInvoice", "id", id);
      const localVarPath = `/account-receivable/invoice/{id}/expanded`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    })
  };
};
var InvoiceExpandedApiFp = function(configuration) {
  const localVarAxiosParamCreator = InvoiceExpandedApiAxiosParamCreator(configuration);
  return {
    /**
     * Retrieve an expanded invoice by id
     * @summary Retrieve invoice with expanded info (calculations of the invoice) by id
     * @param {string} id Id of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getExpandedInvoice(id, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getExpandedInvoice(id, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    }
  };
};
var InvoiceExpandedApiClient = createApiFromFp(InvoiceExpandedApiFp);
var InvoiceExpandedApiFactory = function(configuration, basePath, axios2) {
  const localVarFp = InvoiceExpandedApiFp(configuration);
  return {
    /**
     * Retrieve an expanded invoice by id
     * @summary Retrieve invoice with expanded info (calculations of the invoice) by id
     * @param {string} id Id of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getExpandedInvoice(id, options) {
      return localVarFp.getExpandedInvoice(id, options).then((request) => request(axios2, basePath));
    }
  };
};
var InvoiceExpandedApi = class extends BaseAPI {
  /**
   * Retrieve an expanded invoice by id
   * @summary Retrieve invoice with expanded info (calculations of the invoice) by id
   * @param {InvoiceExpandedApiGetExpandedInvoiceRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InvoiceExpandedApi
   */
  getExpandedInvoice(requestParameters, options) {
    return InvoiceExpandedApiFp(this.configuration).getExpandedInvoice(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
  }
};
var InvoiceExpandedApiInstance = createInstanceFromApiIClass(InvoiceExpandedApi);
var InvoicePreferencesApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * Retrieve an list of invoice preferences record of an organization
     * @summary Retrieve invoice preferences by organization id
     * @param {string} [melioAccount] The &#x60;Melio-Account&#x60; header is used when a Partner wants to perform an operation on behalf of one of its Accounts. It contains the Account\&#39;s ID which returned when creating the Account, or when retrieving all of the Partner\&#39;s Accounts. Note that most operations are not permitted without the presence of this header.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getInvoicePreferences: (_0, ..._1) => __async(this, [_0, ..._1], function* (melioAccount, options = {}) {
      const localVarPath = `/account-receivable/invoice-preferences`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Update an Invoice Preferences by organization ID
     * @summary Update an Invoice Preferences
     * @param {PatchInvoicePreferencesRequest} [patchInvoicePreferencesRequest] 
     * @param {string} [melioAccount] The &#x60;Melio-Account&#x60; header is used when a Partner wants to perform an operation on behalf of one of its Accounts. It contains the Account\&#39;s ID which returned when creating the Account, or when retrieving all of the Partner\&#39;s Accounts. Note that most operations are not permitted without the presence of this header.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateInvoicePreferences: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (patchInvoicePreferencesRequest, melioAccount, options = {}) {
      const localVarPath = `/account-receivable/invoice-preferences`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "PATCH" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(patchInvoicePreferencesRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    })
  };
};
var InvoicePreferencesApiFp = function(configuration) {
  const localVarAxiosParamCreator = InvoicePreferencesApiAxiosParamCreator(configuration);
  return {
    /**
     * Retrieve an list of invoice preferences record of an organization
     * @summary Retrieve invoice preferences by organization id
     * @param {string} [melioAccount] The &#x60;Melio-Account&#x60; header is used when a Partner wants to perform an operation on behalf of one of its Accounts. It contains the Account\&#39;s ID which returned when creating the Account, or when retrieving all of the Partner\&#39;s Accounts. Note that most operations are not permitted without the presence of this header.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getInvoicePreferences(melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getInvoicePreferences(melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Update an Invoice Preferences by organization ID
     * @summary Update an Invoice Preferences
     * @param {PatchInvoicePreferencesRequest} [patchInvoicePreferencesRequest] 
     * @param {string} [melioAccount] The &#x60;Melio-Account&#x60; header is used when a Partner wants to perform an operation on behalf of one of its Accounts. It contains the Account\&#39;s ID which returned when creating the Account, or when retrieving all of the Partner\&#39;s Accounts. Note that most operations are not permitted without the presence of this header.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateInvoicePreferences(patchInvoicePreferencesRequest, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.updateInvoicePreferences(patchInvoicePreferencesRequest, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    }
  };
};
var InvoicePreferencesApiClient = createApiFromFp(InvoicePreferencesApiFp);
var InvoicePreferencesApiFactory = function(configuration, basePath, axios2) {
  const localVarFp = InvoicePreferencesApiFp(configuration);
  return {
    /**
     * Retrieve an list of invoice preferences record of an organization
     * @summary Retrieve invoice preferences by organization id
     * @param {string} [melioAccount] The &#x60;Melio-Account&#x60; header is used when a Partner wants to perform an operation on behalf of one of its Accounts. It contains the Account\&#39;s ID which returned when creating the Account, or when retrieving all of the Partner\&#39;s Accounts. Note that most operations are not permitted without the presence of this header.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getInvoicePreferences(melioAccount, options) {
      return localVarFp.getInvoicePreferences(melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Update an Invoice Preferences by organization ID
     * @summary Update an Invoice Preferences
     * @param {PatchInvoicePreferencesRequest} [patchInvoicePreferencesRequest] 
     * @param {string} [melioAccount] The &#x60;Melio-Account&#x60; header is used when a Partner wants to perform an operation on behalf of one of its Accounts. It contains the Account\&#39;s ID which returned when creating the Account, or when retrieving all of the Partner\&#39;s Accounts. Note that most operations are not permitted without the presence of this header.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateInvoicePreferences(patchInvoicePreferencesRequest, melioAccount, options) {
      return localVarFp.updateInvoicePreferences(patchInvoicePreferencesRequest, melioAccount, options).then((request) => request(axios2, basePath));
    }
  };
};
var InvoicePreferencesApi = class extends BaseAPI {
  /**
   * Retrieve an list of invoice preferences record of an organization
   * @summary Retrieve invoice preferences by organization id
   * @param {InvoicePreferencesApiGetInvoicePreferencesRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InvoicePreferencesApi
   */
  getInvoicePreferences(requestParameters = {}, options) {
    return InvoicePreferencesApiFp(this.configuration).getInvoicePreferences(requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Update an Invoice Preferences by organization ID
   * @summary Update an Invoice Preferences
   * @param {InvoicePreferencesApiUpdateInvoicePreferencesRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InvoicePreferencesApi
   */
  updateInvoicePreferences(requestParameters = {}, options) {
    return InvoicePreferencesApiFp(this.configuration).updateInvoicePreferences(requestParameters.patchInvoicePreferencesRequest, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
};
var InvoicePreferencesApiInstance = createInstanceFromApiIClass(InvoicePreferencesApi);
var InvoiceTimelineApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * Retrieve invoice timeline, by invoice id
     * @summary Retrieve invoice timeline by invoice id
     * @param {string} id Id of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getInvoiceTimeline: (_0, ..._1) => __async(this, [_0, ..._1], function* (id, options = {}) {
      assertParamExists("getInvoiceTimeline", "id", id);
      const localVarPath = `/account-receivable/invoice/{id}/timeline`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    })
  };
};
var InvoiceTimelineApiFp = function(configuration) {
  const localVarAxiosParamCreator = InvoiceTimelineApiAxiosParamCreator(configuration);
  return {
    /**
     * Retrieve invoice timeline, by invoice id
     * @summary Retrieve invoice timeline by invoice id
     * @param {string} id Id of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getInvoiceTimeline(id, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getInvoiceTimeline(id, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    }
  };
};
var InvoiceTimelineApiClient = createApiFromFp(InvoiceTimelineApiFp);
var InvoiceTimelineApiFactory = function(configuration, basePath, axios2) {
  const localVarFp = InvoiceTimelineApiFp(configuration);
  return {
    /**
     * Retrieve invoice timeline, by invoice id
     * @summary Retrieve invoice timeline by invoice id
     * @param {string} id Id of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getInvoiceTimeline(id, options) {
      return localVarFp.getInvoiceTimeline(id, options).then((request) => request(axios2, basePath));
    }
  };
};
var InvoiceTimelineApi = class extends BaseAPI {
  /**
   * Retrieve invoice timeline, by invoice id
   * @summary Retrieve invoice timeline by invoice id
   * @param {InvoiceTimelineApiGetInvoiceTimelineRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InvoiceTimelineApi
   */
  getInvoiceTimeline(requestParameters, options) {
    return InvoiceTimelineApiFp(this.configuration).getInvoiceTimeline(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
  }
};
var InvoiceTimelineApiInstance = createInstanceFromApiIClass(InvoiceTimelineApi);
var InvoicesApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * This operation deletes an invoice by ID
     * @summary Delete an invoice by id
     * @param {string} id Id of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteInvoicesInvoiceId: (_0, ..._1) => __async(this, [_0, ..._1], function* (id, options = {}) {
      assertParamExists("deleteInvoicesInvoiceId", "id", id);
      const localVarPath = `/account-receivable/invoice/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "DELETE" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Retrieve a list of invoices of user organization
     * @summary Retrieve organization invoices
     * @param {string} [melioAccount] The &#x60;Melio-Account&#x60; header is used when a Partner wants to perform an operation on behalf of one of its Accounts. It contains the Account\&#39;s ID which returned when creating the Account, or when retrieving all of the Partner\&#39;s Accounts. Note that most operations are not permitted without the presence of this header.
     * @param {InvoiceStatusQueryParam} [invoiceStatus] Filter invoices by one or multiple statuses
     * @param {string | number} [searchTerm] Search term query parameters - filter data by a word or phrase
     * @param {string} [customerId] Filter invoices by customerId
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {Date} [after] get all results who were updated after a specific date
     * @param {InvoiceSortQueryParam} [sort] Sort query parameter - sort data by entity fields
     * @param {DateRange} [updatedAtRange] Filter invoices by updated date
     * @param {DateRange} [dueDateRange] Filter invoices by due date
     * @param {number} [limit] A limit on the number of records to be returned.
     * @param {number} [pageNumber] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getInvoices: (_0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, ..._12) => __async(this, [_0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, ..._12], function* (melioAccount, invoiceStatus, searchTerm, customerId, organizationId, userId, after, sort, updatedAtRange, dueDateRange, limit, pageNumber, options = {}) {
      const localVarPath = `/account-receivable/invoice`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (invoiceStatus !== void 0) {
        localVarQueryParameter["invoiceStatus"] = invoiceStatus;
      }
      if (searchTerm !== void 0) {
        localVarQueryParameter["searchTerm"] = searchTerm;
      }
      if (customerId !== void 0) {
        localVarQueryParameter["customerId"] = customerId;
      }
      if (after !== void 0) {
        localVarQueryParameter["after"] = after instanceof Date ? after.toISOString() : after;
      }
      if (sort !== void 0) {
        localVarQueryParameter["sort"] = sort;
      }
      if (updatedAtRange !== void 0) {
        localVarQueryParameter["updatedAtRange"] = updatedAtRange;
      }
      if (dueDateRange !== void 0) {
        localVarQueryParameter["dueDateRange"] = dueDateRange;
      }
      if (limit !== void 0) {
        localVarQueryParameter["limit"] = limit;
      }
      if (pageNumber !== void 0) {
        localVarQueryParameter["pageNumber"] = pageNumber;
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      if (organizationId !== void 0 && organizationId !== null) {
        localVarHeaderParameter["Organization-id"] = String(organizationId);
      }
      if (userId !== void 0 && userId !== null) {
        localVarHeaderParameter["User-id"] = String(userId);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Get an Invoice
     * @summary Get an Invoice
     * @param {string} id Id of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getInvoicesInvoiceId: (_0, ..._1) => __async(this, [_0, ..._1], function* (id, options = {}) {
      assertParamExists("getInvoicesInvoiceId", "id", id);
      const localVarPath = `/account-receivable/invoice/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Retrieve mark as paid payment details by invoice id
     * @summary Retrieve mark as paid payment details by invoice id
     * @param {string} id Id of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getMarkedAsPaidDetails: (_0, ..._1) => __async(this, [_0, ..._1], function* (id, options = {}) {
      assertParamExists("getMarkedAsPaidDetails", "id", id);
      const localVarPath = `/account-receivable/invoice/{id}/mark-as-paid`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Update light invoice
     * @summary Update light invoice
     * @param {string} id Id of the entity
     * @param {PatchLightInvoiceRequest} [patchLightInvoiceRequest] 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {SchemasExpand} [expand] Expand header parameters - use for expanding responses for POST &amp; PATCH requests
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchInvoiceLight: (_0, _1, _2, _3, _4, ..._5) => __async(this, [_0, _1, _2, _3, _4, ..._5], function* (id, patchLightInvoiceRequest, organizationId, userId, expand, options = {}) {
      assertParamExists("patchInvoiceLight", "id", id);
      const localVarPath = `/account-receivable/invoice/light/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "PATCH" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (organizationId !== void 0 && organizationId !== null) {
        localVarHeaderParameter["Organization-id"] = String(organizationId);
      }
      if (userId !== void 0 && userId !== null) {
        localVarHeaderParameter["User-id"] = String(userId);
      }
      if (expand !== void 0 && expand !== null) {
        localVarHeaderParameter["expand"] = String(JSON.stringify(expand));
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(patchLightInvoiceRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Update an Invoice by ID
     * @summary Update an Invoice
     * @param {string} id Id of the entity
     * @param {PatchInvoiceRequest} [patchInvoiceRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchInvoicesInvoiceId: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (id, patchInvoiceRequest, options = {}) {
      assertParamExists("patchInvoicesInvoiceId", "id", id);
      const localVarPath = `/account-receivable/invoice/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "PATCH" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(patchInvoiceRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Update a new marked as paid record.
     * @summary Update marked as paid payment details
     * @param {string} id Id of the entity
     * @param {PatchMarkedAsPaidRequest} [patchMarkedAsPaidRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchMarkAsPaidDetails: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (id, patchMarkedAsPaidRequest, options = {}) {
      assertParamExists("patchMarkAsPaidDetails", "id", id);
      const localVarPath = `/account-receivable/invoice/{id}/mark-as-paid`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "PATCH" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(patchMarkedAsPaidRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Create a new Invoice.
     * @summary Create a Invoice
     * @param {PostInvoicesRequest} [postInvoicesRequest] 
     * @param {string} [melioAccount] The &#x60;Melio-Account&#x60; header is used when a Partner wants to perform an operation on behalf of one of its Accounts. It contains the Account\&#39;s ID which returned when creating the Account, or when retrieving all of the Partner\&#39;s Accounts. Note that most operations are not permitted without the presence of this header.
     * @param {InvoiceStatusQueryParam} [invoiceStatus] Filter invoices by one or multiple statuses
     * @param {string | number} [searchTerm] Search term query parameters - filter data by a word or phrase
     * @param {string} [customerId] Filter invoices by customerId
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {SchemasExpand} [expand] Expand header parameters - use for expanding responses for POST &amp; PATCH requests
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postInvoices: (_0, _1, _2, _3, _4, _5, _6, _7, ..._8) => __async(this, [_0, _1, _2, _3, _4, _5, _6, _7, ..._8], function* (postInvoicesRequest, melioAccount, invoiceStatus, searchTerm, customerId, organizationId, userId, expand, options = {}) {
      const localVarPath = `/account-receivable/invoice`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (invoiceStatus !== void 0) {
        localVarQueryParameter["invoiceStatus"] = invoiceStatus;
      }
      if (searchTerm !== void 0) {
        localVarQueryParameter["searchTerm"] = searchTerm;
      }
      if (customerId !== void 0) {
        localVarQueryParameter["customerId"] = customerId;
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      if (organizationId !== void 0 && organizationId !== null) {
        localVarHeaderParameter["Organization-id"] = String(organizationId);
      }
      if (userId !== void 0 && userId !== null) {
        localVarHeaderParameter["User-id"] = String(userId);
      }
      if (expand !== void 0 && expand !== null) {
        localVarHeaderParameter["expand"] = String(JSON.stringify(expand));
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postInvoicesRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Create light issued invoice
     * @summary Create light issued invoice
     * @param {PostLightInvoiceRequest} [postLightInvoiceRequest] 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {SchemasExpand} [expand] Expand header parameters - use for expanding responses for POST &amp; PATCH requests
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postInvoicesLight: (_0, _1, _2, _3, ..._4) => __async(this, [_0, _1, _2, _3, ..._4], function* (postLightInvoiceRequest, organizationId, userId, expand, options = {}) {
      const localVarPath = `/account-receivable/invoice/light`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (organizationId !== void 0 && organizationId !== null) {
        localVarHeaderParameter["Organization-id"] = String(organizationId);
      }
      if (userId !== void 0 && userId !== null) {
        localVarHeaderParameter["User-id"] = String(userId);
      }
      if (expand !== void 0 && expand !== null) {
        localVarHeaderParameter["expand"] = String(JSON.stringify(expand));
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postLightInvoiceRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Create a new marked as paid record.
     * @summary Create a marked as paid payment details
     * @param {string} id Id of the entity
     * @param {PostMarkedAsPaidRequest} [postMarkedAsPaidRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postMarkAsPaidDetails: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (id, postMarkedAsPaidRequest, options = {}) {
      assertParamExists("postMarkAsPaidDetails", "id", id);
      const localVarPath = `/account-receivable/invoice/{id}/mark-as-paid`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postMarkedAsPaidRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Mark invoice as unpaid
     * @summary Mark invoice as unpaid
     * @param {string} id Id of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postMarkAsUnpaid: (_0, ..._1) => __async(this, [_0, ..._1], function* (id, options = {}) {
      assertParamExists("postMarkAsUnpaid", "id", id);
      const localVarPath = `/account-receivable/invoice/{id}/mark-as-unpaid`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Retrieve the raw data summary of an invoice by payload
     * @summary Retrieve invoice calculations summary by payload
     * @param {PostInvoiceSummaryRawDataRequest} [postInvoiceSummaryRawDataRequest] 
     * @param {SchemasExpand} [expand] Expand header parameters - use for expanding responses for POST &amp; PATCH requests
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postRawSummaryInvoice: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (postInvoiceSummaryRawDataRequest, expand, options = {}) {
      const localVarPath = `/account-receivable/invoice/summary/raw`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (expand !== void 0 && expand !== null) {
        localVarHeaderParameter["expand"] = String(JSON.stringify(expand));
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postInvoiceSummaryRawDataRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Retrieve the view content of an invoice by payload
     * @summary Retrieve invoice view content by payload
     * @param {PostInvoicesRequest} [postInvoicesRequest] 
     * @param {SchemasExpand} [expand] Expand header parameters - use for expanding responses for POST &amp; PATCH requests
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postViewInvoice: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (postInvoicesRequest, expand, options = {}) {
      const localVarPath = `/account-receivable/invoice/view`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (expand !== void 0 && expand !== null) {
        localVarHeaderParameter["expand"] = String(JSON.stringify(expand));
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postInvoicesRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * 
     * @summary Retrieve invoice email preview by id
     * @param {string} id Id of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    previewInvoiceEmailId: (_0, ..._1) => __async(this, [_0, ..._1], function* (id, options = {}) {
      assertParamExists("previewInvoiceEmailId", "id", id);
      const localVarPath = `/account-receivable/invoice/{id}/preview/email`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * 
     * @summary Retrieve invoice view content by id
     * @param {string} id Id of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    previewInvoiceId: (_0, ..._1) => __async(this, [_0, ..._1], function* (id, options = {}) {
      assertParamExists("previewInvoiceId", "id", id);
      const localVarPath = `/account-receivable/invoice/{id}/view`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * This operation cancel an invoice
     * @summary Cancel invoice
     * @param {string} id Id of the entity
     * @param {PutCancelInvoiceRequest} [putCancelInvoiceRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    putInvoiceCancel: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (id, putCancelInvoiceRequest, options = {}) {
      assertParamExists("putInvoiceCancel", "id", id);
      const localVarPath = `/account-receivable/invoice/{id}/cancel`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "PUT" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(putCancelInvoiceRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Update an Invoice by ID
     * @summary Update an Invoice
     * @param {string} id Id of the entity
     * @param {PutInvoiceRequest} [putInvoiceRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    putInvoicesInvoiceId: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (id, putInvoiceRequest, options = {}) {
      assertParamExists("putInvoicesInvoiceId", "id", id);
      const localVarPath = `/account-receivable/invoice/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "PUT" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(putInvoiceRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * This operation shared an invoice by ID - creates a share link and change the status to pending
     * @summary Shared an invoice by id
     * @param {string} id Id of the entity
     * @param {PostShareInvoiceRequest} [postShareInvoiceRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sharedInvoicesInvoiceId: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (id, postShareInvoiceRequest, options = {}) {
      assertParamExists("sharedInvoicesInvoiceId", "id", id);
      const localVarPath = `/account-receivable/invoice/{id}/share`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postShareInvoiceRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    })
  };
};
var InvoicesApiFp = function(configuration) {
  const localVarAxiosParamCreator = InvoicesApiAxiosParamCreator(configuration);
  return {
    /**
     * This operation deletes an invoice by ID
     * @summary Delete an invoice by id
     * @param {string} id Id of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteInvoicesInvoiceId(id, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteInvoicesInvoiceId(id, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Retrieve a list of invoices of user organization
     * @summary Retrieve organization invoices
     * @param {string} [melioAccount] The &#x60;Melio-Account&#x60; header is used when a Partner wants to perform an operation on behalf of one of its Accounts. It contains the Account\&#39;s ID which returned when creating the Account, or when retrieving all of the Partner\&#39;s Accounts. Note that most operations are not permitted without the presence of this header.
     * @param {InvoiceStatusQueryParam} [invoiceStatus] Filter invoices by one or multiple statuses
     * @param {string | number} [searchTerm] Search term query parameters - filter data by a word or phrase
     * @param {string} [customerId] Filter invoices by customerId
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {Date} [after] get all results who were updated after a specific date
     * @param {InvoiceSortQueryParam} [sort] Sort query parameter - sort data by entity fields
     * @param {DateRange} [updatedAtRange] Filter invoices by updated date
     * @param {DateRange} [dueDateRange] Filter invoices by due date
     * @param {number} [limit] A limit on the number of records to be returned.
     * @param {number} [pageNumber] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getInvoices(melioAccount, invoiceStatus, searchTerm, customerId, organizationId, userId, after, sort, updatedAtRange, dueDateRange, limit, pageNumber, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getInvoices(melioAccount, invoiceStatus, searchTerm, customerId, organizationId, userId, after, sort, updatedAtRange, dueDateRange, limit, pageNumber, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Get an Invoice
     * @summary Get an Invoice
     * @param {string} id Id of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getInvoicesInvoiceId(id, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getInvoicesInvoiceId(id, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Retrieve mark as paid payment details by invoice id
     * @summary Retrieve mark as paid payment details by invoice id
     * @param {string} id Id of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getMarkedAsPaidDetails(id, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getMarkedAsPaidDetails(id, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Update light invoice
     * @summary Update light invoice
     * @param {string} id Id of the entity
     * @param {PatchLightInvoiceRequest} [patchLightInvoiceRequest] 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {SchemasExpand} [expand] Expand header parameters - use for expanding responses for POST &amp; PATCH requests
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchInvoiceLight(id, patchLightInvoiceRequest, organizationId, userId, expand, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.patchInvoiceLight(id, patchLightInvoiceRequest, organizationId, userId, expand, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Update an Invoice by ID
     * @summary Update an Invoice
     * @param {string} id Id of the entity
     * @param {PatchInvoiceRequest} [patchInvoiceRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchInvoicesInvoiceId(id, patchInvoiceRequest, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.patchInvoicesInvoiceId(id, patchInvoiceRequest, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Update a new marked as paid record.
     * @summary Update marked as paid payment details
     * @param {string} id Id of the entity
     * @param {PatchMarkedAsPaidRequest} [patchMarkedAsPaidRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchMarkAsPaidDetails(id, patchMarkedAsPaidRequest, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.patchMarkAsPaidDetails(id, patchMarkedAsPaidRequest, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Create a new Invoice.
     * @summary Create a Invoice
     * @param {PostInvoicesRequest} [postInvoicesRequest] 
     * @param {string} [melioAccount] The &#x60;Melio-Account&#x60; header is used when a Partner wants to perform an operation on behalf of one of its Accounts. It contains the Account\&#39;s ID which returned when creating the Account, or when retrieving all of the Partner\&#39;s Accounts. Note that most operations are not permitted without the presence of this header.
     * @param {InvoiceStatusQueryParam} [invoiceStatus] Filter invoices by one or multiple statuses
     * @param {string | number} [searchTerm] Search term query parameters - filter data by a word or phrase
     * @param {string} [customerId] Filter invoices by customerId
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {SchemasExpand} [expand] Expand header parameters - use for expanding responses for POST &amp; PATCH requests
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postInvoices(postInvoicesRequest, melioAccount, invoiceStatus, searchTerm, customerId, organizationId, userId, expand, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postInvoices(postInvoicesRequest, melioAccount, invoiceStatus, searchTerm, customerId, organizationId, userId, expand, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Create light issued invoice
     * @summary Create light issued invoice
     * @param {PostLightInvoiceRequest} [postLightInvoiceRequest] 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {SchemasExpand} [expand] Expand header parameters - use for expanding responses for POST &amp; PATCH requests
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postInvoicesLight(postLightInvoiceRequest, organizationId, userId, expand, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postInvoicesLight(postLightInvoiceRequest, organizationId, userId, expand, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Create a new marked as paid record.
     * @summary Create a marked as paid payment details
     * @param {string} id Id of the entity
     * @param {PostMarkedAsPaidRequest} [postMarkedAsPaidRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postMarkAsPaidDetails(id, postMarkedAsPaidRequest, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postMarkAsPaidDetails(id, postMarkedAsPaidRequest, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Mark invoice as unpaid
     * @summary Mark invoice as unpaid
     * @param {string} id Id of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postMarkAsUnpaid(id, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postMarkAsUnpaid(id, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Retrieve the raw data summary of an invoice by payload
     * @summary Retrieve invoice calculations summary by payload
     * @param {PostInvoiceSummaryRawDataRequest} [postInvoiceSummaryRawDataRequest] 
     * @param {SchemasExpand} [expand] Expand header parameters - use for expanding responses for POST &amp; PATCH requests
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postRawSummaryInvoice(postInvoiceSummaryRawDataRequest, expand, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postRawSummaryInvoice(postInvoiceSummaryRawDataRequest, expand, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Retrieve the view content of an invoice by payload
     * @summary Retrieve invoice view content by payload
     * @param {PostInvoicesRequest} [postInvoicesRequest] 
     * @param {SchemasExpand} [expand] Expand header parameters - use for expanding responses for POST &amp; PATCH requests
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postViewInvoice(postInvoicesRequest, expand, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postViewInvoice(postInvoicesRequest, expand, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * 
     * @summary Retrieve invoice email preview by id
     * @param {string} id Id of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    previewInvoiceEmailId(id, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.previewInvoiceEmailId(id, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * 
     * @summary Retrieve invoice view content by id
     * @param {string} id Id of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    previewInvoiceId(id, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.previewInvoiceId(id, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * This operation cancel an invoice
     * @summary Cancel invoice
     * @param {string} id Id of the entity
     * @param {PutCancelInvoiceRequest} [putCancelInvoiceRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    putInvoiceCancel(id, putCancelInvoiceRequest, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.putInvoiceCancel(id, putCancelInvoiceRequest, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Update an Invoice by ID
     * @summary Update an Invoice
     * @param {string} id Id of the entity
     * @param {PutInvoiceRequest} [putInvoiceRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    putInvoicesInvoiceId(id, putInvoiceRequest, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.putInvoicesInvoiceId(id, putInvoiceRequest, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * This operation shared an invoice by ID - creates a share link and change the status to pending
     * @summary Shared an invoice by id
     * @param {string} id Id of the entity
     * @param {PostShareInvoiceRequest} [postShareInvoiceRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sharedInvoicesInvoiceId(id, postShareInvoiceRequest, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.sharedInvoicesInvoiceId(id, postShareInvoiceRequest, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    }
  };
};
var InvoicesApiClient = createApiFromFp(InvoicesApiFp);
var InvoicesApiFactory = function(configuration, basePath, axios2) {
  const localVarFp = InvoicesApiFp(configuration);
  return {
    /**
     * This operation deletes an invoice by ID
     * @summary Delete an invoice by id
     * @param {string} id Id of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteInvoicesInvoiceId(id, options) {
      return localVarFp.deleteInvoicesInvoiceId(id, options).then((request) => request(axios2, basePath));
    },
    /**
     * Retrieve a list of invoices of user organization
     * @summary Retrieve organization invoices
     * @param {string} [melioAccount] The &#x60;Melio-Account&#x60; header is used when a Partner wants to perform an operation on behalf of one of its Accounts. It contains the Account\&#39;s ID which returned when creating the Account, or when retrieving all of the Partner\&#39;s Accounts. Note that most operations are not permitted without the presence of this header.
     * @param {InvoiceStatusQueryParam} [invoiceStatus] Filter invoices by one or multiple statuses
     * @param {string | number} [searchTerm] Search term query parameters - filter data by a word or phrase
     * @param {string} [customerId] Filter invoices by customerId
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {Date} [after] get all results who were updated after a specific date
     * @param {InvoiceSortQueryParam} [sort] Sort query parameter - sort data by entity fields
     * @param {DateRange} [updatedAtRange] Filter invoices by updated date
     * @param {DateRange} [dueDateRange] Filter invoices by due date
     * @param {number} [limit] A limit on the number of records to be returned.
     * @param {number} [pageNumber] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getInvoices(melioAccount, invoiceStatus, searchTerm, customerId, organizationId, userId, after, sort, updatedAtRange, dueDateRange, limit, pageNumber, options) {
      return localVarFp.getInvoices(melioAccount, invoiceStatus, searchTerm, customerId, organizationId, userId, after, sort, updatedAtRange, dueDateRange, limit, pageNumber, options).then((request) => request(axios2, basePath));
    },
    /**
     * Get an Invoice
     * @summary Get an Invoice
     * @param {string} id Id of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getInvoicesInvoiceId(id, options) {
      return localVarFp.getInvoicesInvoiceId(id, options).then((request) => request(axios2, basePath));
    },
    /**
     * Retrieve mark as paid payment details by invoice id
     * @summary Retrieve mark as paid payment details by invoice id
     * @param {string} id Id of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getMarkedAsPaidDetails(id, options) {
      return localVarFp.getMarkedAsPaidDetails(id, options).then((request) => request(axios2, basePath));
    },
    /**
     * Update light invoice
     * @summary Update light invoice
     * @param {string} id Id of the entity
     * @param {PatchLightInvoiceRequest} [patchLightInvoiceRequest] 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {SchemasExpand} [expand] Expand header parameters - use for expanding responses for POST &amp; PATCH requests
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchInvoiceLight(id, patchLightInvoiceRequest, organizationId, userId, expand, options) {
      return localVarFp.patchInvoiceLight(id, patchLightInvoiceRequest, organizationId, userId, expand, options).then((request) => request(axios2, basePath));
    },
    /**
     * Update an Invoice by ID
     * @summary Update an Invoice
     * @param {string} id Id of the entity
     * @param {PatchInvoiceRequest} [patchInvoiceRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchInvoicesInvoiceId(id, patchInvoiceRequest, options) {
      return localVarFp.patchInvoicesInvoiceId(id, patchInvoiceRequest, options).then((request) => request(axios2, basePath));
    },
    /**
     * Update a new marked as paid record.
     * @summary Update marked as paid payment details
     * @param {string} id Id of the entity
     * @param {PatchMarkedAsPaidRequest} [patchMarkedAsPaidRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchMarkAsPaidDetails(id, patchMarkedAsPaidRequest, options) {
      return localVarFp.patchMarkAsPaidDetails(id, patchMarkedAsPaidRequest, options).then((request) => request(axios2, basePath));
    },
    /**
     * Create a new Invoice.
     * @summary Create a Invoice
     * @param {PostInvoicesRequest} [postInvoicesRequest] 
     * @param {string} [melioAccount] The &#x60;Melio-Account&#x60; header is used when a Partner wants to perform an operation on behalf of one of its Accounts. It contains the Account\&#39;s ID which returned when creating the Account, or when retrieving all of the Partner\&#39;s Accounts. Note that most operations are not permitted without the presence of this header.
     * @param {InvoiceStatusQueryParam} [invoiceStatus] Filter invoices by one or multiple statuses
     * @param {string | number} [searchTerm] Search term query parameters - filter data by a word or phrase
     * @param {string} [customerId] Filter invoices by customerId
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {SchemasExpand} [expand] Expand header parameters - use for expanding responses for POST &amp; PATCH requests
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postInvoices(postInvoicesRequest, melioAccount, invoiceStatus, searchTerm, customerId, organizationId, userId, expand, options) {
      return localVarFp.postInvoices(postInvoicesRequest, melioAccount, invoiceStatus, searchTerm, customerId, organizationId, userId, expand, options).then((request) => request(axios2, basePath));
    },
    /**
     * Create light issued invoice
     * @summary Create light issued invoice
     * @param {PostLightInvoiceRequest} [postLightInvoiceRequest] 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {SchemasExpand} [expand] Expand header parameters - use for expanding responses for POST &amp; PATCH requests
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postInvoicesLight(postLightInvoiceRequest, organizationId, userId, expand, options) {
      return localVarFp.postInvoicesLight(postLightInvoiceRequest, organizationId, userId, expand, options).then((request) => request(axios2, basePath));
    },
    /**
     * Create a new marked as paid record.
     * @summary Create a marked as paid payment details
     * @param {string} id Id of the entity
     * @param {PostMarkedAsPaidRequest} [postMarkedAsPaidRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postMarkAsPaidDetails(id, postMarkedAsPaidRequest, options) {
      return localVarFp.postMarkAsPaidDetails(id, postMarkedAsPaidRequest, options).then((request) => request(axios2, basePath));
    },
    /**
     * Mark invoice as unpaid
     * @summary Mark invoice as unpaid
     * @param {string} id Id of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postMarkAsUnpaid(id, options) {
      return localVarFp.postMarkAsUnpaid(id, options).then((request) => request(axios2, basePath));
    },
    /**
     * Retrieve the raw data summary of an invoice by payload
     * @summary Retrieve invoice calculations summary by payload
     * @param {PostInvoiceSummaryRawDataRequest} [postInvoiceSummaryRawDataRequest] 
     * @param {SchemasExpand} [expand] Expand header parameters - use for expanding responses for POST &amp; PATCH requests
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postRawSummaryInvoice(postInvoiceSummaryRawDataRequest, expand, options) {
      return localVarFp.postRawSummaryInvoice(postInvoiceSummaryRawDataRequest, expand, options).then((request) => request(axios2, basePath));
    },
    /**
     * Retrieve the view content of an invoice by payload
     * @summary Retrieve invoice view content by payload
     * @param {PostInvoicesRequest} [postInvoicesRequest] 
     * @param {SchemasExpand} [expand] Expand header parameters - use for expanding responses for POST &amp; PATCH requests
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postViewInvoice(postInvoicesRequest, expand, options) {
      return localVarFp.postViewInvoice(postInvoicesRequest, expand, options).then((request) => request(axios2, basePath));
    },
    /**
     * 
     * @summary Retrieve invoice email preview by id
     * @param {string} id Id of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    previewInvoiceEmailId(id, options) {
      return localVarFp.previewInvoiceEmailId(id, options).then((request) => request(axios2, basePath));
    },
    /**
     * 
     * @summary Retrieve invoice view content by id
     * @param {string} id Id of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    previewInvoiceId(id, options) {
      return localVarFp.previewInvoiceId(id, options).then((request) => request(axios2, basePath));
    },
    /**
     * This operation cancel an invoice
     * @summary Cancel invoice
     * @param {string} id Id of the entity
     * @param {PutCancelInvoiceRequest} [putCancelInvoiceRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    putInvoiceCancel(id, putCancelInvoiceRequest, options) {
      return localVarFp.putInvoiceCancel(id, putCancelInvoiceRequest, options).then((request) => request(axios2, basePath));
    },
    /**
     * Update an Invoice by ID
     * @summary Update an Invoice
     * @param {string} id Id of the entity
     * @param {PutInvoiceRequest} [putInvoiceRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    putInvoicesInvoiceId(id, putInvoiceRequest, options) {
      return localVarFp.putInvoicesInvoiceId(id, putInvoiceRequest, options).then((request) => request(axios2, basePath));
    },
    /**
     * This operation shared an invoice by ID - creates a share link and change the status to pending
     * @summary Shared an invoice by id
     * @param {string} id Id of the entity
     * @param {PostShareInvoiceRequest} [postShareInvoiceRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sharedInvoicesInvoiceId(id, postShareInvoiceRequest, options) {
      return localVarFp.sharedInvoicesInvoiceId(id, postShareInvoiceRequest, options).then((request) => request(axios2, basePath));
    }
  };
};
var InvoicesApi = class extends BaseAPI {
  /**
   * This operation deletes an invoice by ID
   * @summary Delete an invoice by id
   * @param {InvoicesApiDeleteInvoicesInvoiceIdRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InvoicesApi
   */
  deleteInvoicesInvoiceId(requestParameters, options) {
    return InvoicesApiFp(this.configuration).deleteInvoicesInvoiceId(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Retrieve a list of invoices of user organization
   * @summary Retrieve organization invoices
   * @param {InvoicesApiGetInvoicesRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InvoicesApi
   */
  getInvoices(requestParameters = {}, options) {
    return InvoicesApiFp(this.configuration).getInvoices(requestParameters.melioAccount, requestParameters.invoiceStatus, requestParameters.searchTerm, requestParameters.customerId, requestParameters.organizationId, requestParameters.userId, requestParameters.after, requestParameters.sort, requestParameters.updatedAtRange, requestParameters.dueDateRange, requestParameters.limit, requestParameters.pageNumber, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Get an Invoice
   * @summary Get an Invoice
   * @param {InvoicesApiGetInvoicesInvoiceIdRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InvoicesApi
   */
  getInvoicesInvoiceId(requestParameters, options) {
    return InvoicesApiFp(this.configuration).getInvoicesInvoiceId(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Retrieve mark as paid payment details by invoice id
   * @summary Retrieve mark as paid payment details by invoice id
   * @param {InvoicesApiGetMarkedAsPaidDetailsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InvoicesApi
   */
  getMarkedAsPaidDetails(requestParameters, options) {
    return InvoicesApiFp(this.configuration).getMarkedAsPaidDetails(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Update light invoice
   * @summary Update light invoice
   * @param {InvoicesApiPatchInvoiceLightRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InvoicesApi
   */
  patchInvoiceLight(requestParameters, options) {
    return InvoicesApiFp(this.configuration).patchInvoiceLight(requestParameters.id, requestParameters.patchLightInvoiceRequest, requestParameters.organizationId, requestParameters.userId, requestParameters.expand, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Update an Invoice by ID
   * @summary Update an Invoice
   * @param {InvoicesApiPatchInvoicesInvoiceIdRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InvoicesApi
   */
  patchInvoicesInvoiceId(requestParameters, options) {
    return InvoicesApiFp(this.configuration).patchInvoicesInvoiceId(requestParameters.id, requestParameters.patchInvoiceRequest, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Update a new marked as paid record.
   * @summary Update marked as paid payment details
   * @param {InvoicesApiPatchMarkAsPaidDetailsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InvoicesApi
   */
  patchMarkAsPaidDetails(requestParameters, options) {
    return InvoicesApiFp(this.configuration).patchMarkAsPaidDetails(requestParameters.id, requestParameters.patchMarkedAsPaidRequest, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Create a new Invoice.
   * @summary Create a Invoice
   * @param {InvoicesApiPostInvoicesRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InvoicesApi
   */
  postInvoices(requestParameters = {}, options) {
    return InvoicesApiFp(this.configuration).postInvoices(requestParameters.postInvoicesRequest, requestParameters.melioAccount, requestParameters.invoiceStatus, requestParameters.searchTerm, requestParameters.customerId, requestParameters.organizationId, requestParameters.userId, requestParameters.expand, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Create light issued invoice
   * @summary Create light issued invoice
   * @param {InvoicesApiPostInvoicesLightRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InvoicesApi
   */
  postInvoicesLight(requestParameters = {}, options) {
    return InvoicesApiFp(this.configuration).postInvoicesLight(requestParameters.postLightInvoiceRequest, requestParameters.organizationId, requestParameters.userId, requestParameters.expand, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Create a new marked as paid record.
   * @summary Create a marked as paid payment details
   * @param {InvoicesApiPostMarkAsPaidDetailsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InvoicesApi
   */
  postMarkAsPaidDetails(requestParameters, options) {
    return InvoicesApiFp(this.configuration).postMarkAsPaidDetails(requestParameters.id, requestParameters.postMarkedAsPaidRequest, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Mark invoice as unpaid
   * @summary Mark invoice as unpaid
   * @param {InvoicesApiPostMarkAsUnpaidRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InvoicesApi
   */
  postMarkAsUnpaid(requestParameters, options) {
    return InvoicesApiFp(this.configuration).postMarkAsUnpaid(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Retrieve the raw data summary of an invoice by payload
   * @summary Retrieve invoice calculations summary by payload
   * @param {InvoicesApiPostRawSummaryInvoiceRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InvoicesApi
   */
  postRawSummaryInvoice(requestParameters = {}, options) {
    return InvoicesApiFp(this.configuration).postRawSummaryInvoice(requestParameters.postInvoiceSummaryRawDataRequest, requestParameters.expand, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Retrieve the view content of an invoice by payload
   * @summary Retrieve invoice view content by payload
   * @param {InvoicesApiPostViewInvoiceRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InvoicesApi
   */
  postViewInvoice(requestParameters = {}, options) {
    return InvoicesApiFp(this.configuration).postViewInvoice(requestParameters.postInvoicesRequest, requestParameters.expand, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Retrieve invoice email preview by id
   * @param {InvoicesApiPreviewInvoiceEmailIdRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InvoicesApi
   */
  previewInvoiceEmailId(requestParameters, options) {
    return InvoicesApiFp(this.configuration).previewInvoiceEmailId(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Retrieve invoice view content by id
   * @param {InvoicesApiPreviewInvoiceIdRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InvoicesApi
   */
  previewInvoiceId(requestParameters, options) {
    return InvoicesApiFp(this.configuration).previewInvoiceId(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * This operation cancel an invoice
   * @summary Cancel invoice
   * @param {InvoicesApiPutInvoiceCancelRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InvoicesApi
   */
  putInvoiceCancel(requestParameters, options) {
    return InvoicesApiFp(this.configuration).putInvoiceCancel(requestParameters.id, requestParameters.putCancelInvoiceRequest, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Update an Invoice by ID
   * @summary Update an Invoice
   * @param {InvoicesApiPutInvoicesInvoiceIdRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InvoicesApi
   */
  putInvoicesInvoiceId(requestParameters, options) {
    return InvoicesApiFp(this.configuration).putInvoicesInvoiceId(requestParameters.id, requestParameters.putInvoiceRequest, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * This operation shared an invoice by ID - creates a share link and change the status to pending
   * @summary Shared an invoice by id
   * @param {InvoicesApiSharedInvoicesInvoiceIdRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InvoicesApi
   */
  sharedInvoicesInvoiceId(requestParameters, options) {
    return InvoicesApiFp(this.configuration).sharedInvoicesInvoiceId(requestParameters.id, requestParameters.postShareInvoiceRequest, options).then((request) => request(this.axios, this.basePath));
  }
};
var InvoicesApiInstance = createInstanceFromApiIClass(InvoicesApi);
var JoinOrganizationRequestsApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * Gets Join Organization Request
     * @summary Gets Join Organization Request
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    joinOrganizationRequestGet: (_0, _1, _2, ..._3) => __async(this, [_0, _1, _2, ..._3], function* (id, melioAccount, idempotencyKey, options = {}) {
      assertParamExists("joinOrganizationRequestGet", "id", id);
      const localVarPath = `/join-organization-requests/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      if (idempotencyKey !== void 0 && idempotencyKey !== null) {
        localVarHeaderParameter["Idempotency-Key"] = String(idempotencyKey);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Cancels Join Organization Request
     * @summary Cancels Join Organization Request
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    joinOrganizationRequestsCancel: (_0, _1, _2, ..._3) => __async(this, [_0, _1, _2, ..._3], function* (id, melioAccount, idempotencyKey, options = {}) {
      assertParamExists("joinOrganizationRequestsCancel", "id", id);
      const localVarPath = `/join-organization-requests/{id}/cancel`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      if (idempotencyKey !== void 0 && idempotencyKey !== null) {
        localVarHeaderParameter["Idempotency-Key"] = String(idempotencyKey);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Creates a new Join Organization Request
     * @summary Creates Join Organization Request
     * @param {PostJoinOrganizationRequestsRequest} [postJoinOrganizationRequestsRequest] 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    joinOrganizationRequestsCreate: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (postJoinOrganizationRequestsRequest, melioAccount, options = {}) {
      const localVarPath = `/join-organization-requests`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postJoinOrganizationRequestsRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Gets all relevant user related Join Organization Requests
     * @summary Gets Join Organization Requests
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    joinOrganizationRequestsGet: (_0, ..._1) => __async(this, [_0, ..._1], function* (melioAccount, options = {}) {
      const localVarPath = `/join-organization-requests`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Resends Join Organization Request
     * @summary Resends Join Organization Request
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    joinOrganizationRequestsResend: (_0, _1, _2, ..._3) => __async(this, [_0, _1, _2, ..._3], function* (id, melioAccount, idempotencyKey, options = {}) {
      assertParamExists("joinOrganizationRequestsResend", "id", id);
      const localVarPath = `/join-organization-requests/{id}/resend`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      if (idempotencyKey !== void 0 && idempotencyKey !== null) {
        localVarHeaderParameter["Idempotency-Key"] = String(idempotencyKey);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    })
  };
};
var JoinOrganizationRequestsApiFp = function(configuration) {
  const localVarAxiosParamCreator = JoinOrganizationRequestsApiAxiosParamCreator(configuration);
  return {
    /**
     * Gets Join Organization Request
     * @summary Gets Join Organization Request
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    joinOrganizationRequestGet(id, melioAccount, idempotencyKey, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.joinOrganizationRequestGet(id, melioAccount, idempotencyKey, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Cancels Join Organization Request
     * @summary Cancels Join Organization Request
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    joinOrganizationRequestsCancel(id, melioAccount, idempotencyKey, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.joinOrganizationRequestsCancel(id, melioAccount, idempotencyKey, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Creates a new Join Organization Request
     * @summary Creates Join Organization Request
     * @param {PostJoinOrganizationRequestsRequest} [postJoinOrganizationRequestsRequest] 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    joinOrganizationRequestsCreate(postJoinOrganizationRequestsRequest, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.joinOrganizationRequestsCreate(postJoinOrganizationRequestsRequest, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Gets all relevant user related Join Organization Requests
     * @summary Gets Join Organization Requests
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    joinOrganizationRequestsGet(melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.joinOrganizationRequestsGet(melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Resends Join Organization Request
     * @summary Resends Join Organization Request
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    joinOrganizationRequestsResend(id, melioAccount, idempotencyKey, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.joinOrganizationRequestsResend(id, melioAccount, idempotencyKey, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    }
  };
};
var JoinOrganizationRequestsApiClient = createApiFromFp(JoinOrganizationRequestsApiFp);
var JoinOrganizationRequestsApiFactory = function(configuration, basePath, axios2) {
  const localVarFp = JoinOrganizationRequestsApiFp(configuration);
  return {
    /**
     * Gets Join Organization Request
     * @summary Gets Join Organization Request
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    joinOrganizationRequestGet(id, melioAccount, idempotencyKey, options) {
      return localVarFp.joinOrganizationRequestGet(id, melioAccount, idempotencyKey, options).then((request) => request(axios2, basePath));
    },
    /**
     * Cancels Join Organization Request
     * @summary Cancels Join Organization Request
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    joinOrganizationRequestsCancel(id, melioAccount, idempotencyKey, options) {
      return localVarFp.joinOrganizationRequestsCancel(id, melioAccount, idempotencyKey, options).then((request) => request(axios2, basePath));
    },
    /**
     * Creates a new Join Organization Request
     * @summary Creates Join Organization Request
     * @param {PostJoinOrganizationRequestsRequest} [postJoinOrganizationRequestsRequest] 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    joinOrganizationRequestsCreate(postJoinOrganizationRequestsRequest, melioAccount, options) {
      return localVarFp.joinOrganizationRequestsCreate(postJoinOrganizationRequestsRequest, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Gets all relevant user related Join Organization Requests
     * @summary Gets Join Organization Requests
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    joinOrganizationRequestsGet(melioAccount, options) {
      return localVarFp.joinOrganizationRequestsGet(melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Resends Join Organization Request
     * @summary Resends Join Organization Request
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    joinOrganizationRequestsResend(id, melioAccount, idempotencyKey, options) {
      return localVarFp.joinOrganizationRequestsResend(id, melioAccount, idempotencyKey, options).then((request) => request(axios2, basePath));
    }
  };
};
var JoinOrganizationRequestsApi = class extends BaseAPI {
  /**
   * Gets Join Organization Request
   * @summary Gets Join Organization Request
   * @param {JoinOrganizationRequestsApiJoinOrganizationRequestGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof JoinOrganizationRequestsApi
   */
  joinOrganizationRequestGet(requestParameters, options) {
    return JoinOrganizationRequestsApiFp(this.configuration).joinOrganizationRequestGet(requestParameters.id, requestParameters.melioAccount, requestParameters.idempotencyKey, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Cancels Join Organization Request
   * @summary Cancels Join Organization Request
   * @param {JoinOrganizationRequestsApiJoinOrganizationRequestsCancelRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof JoinOrganizationRequestsApi
   */
  joinOrganizationRequestsCancel(requestParameters, options) {
    return JoinOrganizationRequestsApiFp(this.configuration).joinOrganizationRequestsCancel(requestParameters.id, requestParameters.melioAccount, requestParameters.idempotencyKey, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Creates a new Join Organization Request
   * @summary Creates Join Organization Request
   * @param {JoinOrganizationRequestsApiJoinOrganizationRequestsCreateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof JoinOrganizationRequestsApi
   */
  joinOrganizationRequestsCreate(requestParameters = {}, options) {
    return JoinOrganizationRequestsApiFp(this.configuration).joinOrganizationRequestsCreate(requestParameters.postJoinOrganizationRequestsRequest, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Gets all relevant user related Join Organization Requests
   * @summary Gets Join Organization Requests
   * @param {JoinOrganizationRequestsApiJoinOrganizationRequestsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof JoinOrganizationRequestsApi
   */
  joinOrganizationRequestsGet(requestParameters = {}, options) {
    return JoinOrganizationRequestsApiFp(this.configuration).joinOrganizationRequestsGet(requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Resends Join Organization Request
   * @summary Resends Join Organization Request
   * @param {JoinOrganizationRequestsApiJoinOrganizationRequestsResendRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof JoinOrganizationRequestsApi
   */
  joinOrganizationRequestsResend(requestParameters, options) {
    return JoinOrganizationRequestsApiFp(this.configuration).joinOrganizationRequestsResend(requestParameters.id, requestParameters.melioAccount, requestParameters.idempotencyKey, options).then((request) => request(this.axios, this.basePath));
  }
};
var JoinOrganizationRequestsApiInstance = createInstanceFromApiIClass(JoinOrganizationRequestsApi);
var MicroDepositApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * Verify Micro Deposit for the Delivery Method.
     * @summary Verify micro deposit
     * @param {PostDeliveryMethodsVerifyMicroDepositRequest} [postDeliveryMethodsVerifyMicroDepositRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postDeliveryMethodsVerifyMicroDeposit: (_0, _1, _2, ..._3) => __async(this, [_0, _1, _2, ..._3], function* (postDeliveryMethodsVerifyMicroDepositRequest, idempotencyKey, melioAccount, options = {}) {
      const localVarPath = `/delivery-methods/verify-micro-deposit`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (idempotencyKey !== void 0 && idempotencyKey !== null) {
        localVarHeaderParameter["Idempotency-Key"] = String(idempotencyKey);
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postDeliveryMethodsVerifyMicroDepositRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    })
  };
};
var MicroDepositApiFp = function(configuration) {
  const localVarAxiosParamCreator = MicroDepositApiAxiosParamCreator(configuration);
  return {
    /**
     * Verify Micro Deposit for the Delivery Method.
     * @summary Verify micro deposit
     * @param {PostDeliveryMethodsVerifyMicroDepositRequest} [postDeliveryMethodsVerifyMicroDepositRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postDeliveryMethodsVerifyMicroDeposit(postDeliveryMethodsVerifyMicroDepositRequest, idempotencyKey, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postDeliveryMethodsVerifyMicroDeposit(postDeliveryMethodsVerifyMicroDepositRequest, idempotencyKey, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    }
  };
};
var MicroDepositApiClient = createApiFromFp(MicroDepositApiFp);
var MicroDepositApiFactory = function(configuration, basePath, axios2) {
  const localVarFp = MicroDepositApiFp(configuration);
  return {
    /**
     * Verify Micro Deposit for the Delivery Method.
     * @summary Verify micro deposit
     * @param {PostDeliveryMethodsVerifyMicroDepositRequest} [postDeliveryMethodsVerifyMicroDepositRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postDeliveryMethodsVerifyMicroDeposit(postDeliveryMethodsVerifyMicroDepositRequest, idempotencyKey, melioAccount, options) {
      return localVarFp.postDeliveryMethodsVerifyMicroDeposit(postDeliveryMethodsVerifyMicroDepositRequest, idempotencyKey, melioAccount, options).then((request) => request(axios2, basePath));
    }
  };
};
var MicroDepositApi = class extends BaseAPI {
  /**
   * Verify Micro Deposit for the Delivery Method.
   * @summary Verify micro deposit
   * @param {MicroDepositApiPostDeliveryMethodsVerifyMicroDepositRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MicroDepositApi
   */
  postDeliveryMethodsVerifyMicroDeposit(requestParameters = {}, options) {
    return MicroDepositApiFp(this.configuration).postDeliveryMethodsVerifyMicroDeposit(requestParameters.postDeliveryMethodsVerifyMicroDepositRequest, requestParameters.idempotencyKey, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
};
var MicroDepositApiInstance = createInstanceFromApiIClass(MicroDepositApi);
var NotificationPreferencesApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * List of all notification preferences, filtered by organizationId.
     * @summary Retrieve all notification preferences
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getNotificationPreferences: (_0, _1, _2, ..._3) => __async(this, [_0, _1, _2, ..._3], function* (melioAccount, organizationId, userId, options = {}) {
      const localVarPath = `/notification-preferences`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      if (organizationId !== void 0 && organizationId !== null) {
        localVarHeaderParameter["Organization-id"] = String(organizationId);
      }
      if (userId !== void 0 && userId !== null) {
        localVarHeaderParameter["User-id"] = String(userId);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Update notification preferences.
     * @summary Update notification preferences
     * @param {PatchNotificationPreferencesRequest} [patchNotificationPreferencesRequest] 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    setNotificationPreferences: (_0, _1, _2, _3, ..._4) => __async(this, [_0, _1, _2, _3, ..._4], function* (patchNotificationPreferencesRequest, melioAccount, organizationId, userId, options = {}) {
      const localVarPath = `/notification-preferences`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "PATCH" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      if (organizationId !== void 0 && organizationId !== null) {
        localVarHeaderParameter["Organization-id"] = String(organizationId);
      }
      if (userId !== void 0 && userId !== null) {
        localVarHeaderParameter["User-id"] = String(userId);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(patchNotificationPreferencesRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    })
  };
};
var NotificationPreferencesApiFp = function(configuration) {
  const localVarAxiosParamCreator = NotificationPreferencesApiAxiosParamCreator(configuration);
  return {
    /**
     * List of all notification preferences, filtered by organizationId.
     * @summary Retrieve all notification preferences
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getNotificationPreferences(melioAccount, organizationId, userId, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getNotificationPreferences(melioAccount, organizationId, userId, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Update notification preferences.
     * @summary Update notification preferences
     * @param {PatchNotificationPreferencesRequest} [patchNotificationPreferencesRequest] 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    setNotificationPreferences(patchNotificationPreferencesRequest, melioAccount, organizationId, userId, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.setNotificationPreferences(patchNotificationPreferencesRequest, melioAccount, organizationId, userId, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    }
  };
};
var NotificationPreferencesApiClient = createApiFromFp(NotificationPreferencesApiFp);
var NotificationPreferencesApiFactory = function(configuration, basePath, axios2) {
  const localVarFp = NotificationPreferencesApiFp(configuration);
  return {
    /**
     * List of all notification preferences, filtered by organizationId.
     * @summary Retrieve all notification preferences
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getNotificationPreferences(melioAccount, organizationId, userId, options) {
      return localVarFp.getNotificationPreferences(melioAccount, organizationId, userId, options).then((request) => request(axios2, basePath));
    },
    /**
     * Update notification preferences.
     * @summary Update notification preferences
     * @param {PatchNotificationPreferencesRequest} [patchNotificationPreferencesRequest] 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    setNotificationPreferences(patchNotificationPreferencesRequest, melioAccount, organizationId, userId, options) {
      return localVarFp.setNotificationPreferences(patchNotificationPreferencesRequest, melioAccount, organizationId, userId, options).then((request) => request(axios2, basePath));
    }
  };
};
var NotificationPreferencesApi = class extends BaseAPI {
  /**
   * List of all notification preferences, filtered by organizationId.
   * @summary Retrieve all notification preferences
   * @param {NotificationPreferencesApiGetNotificationPreferencesRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof NotificationPreferencesApi
   */
  getNotificationPreferences(requestParameters = {}, options) {
    return NotificationPreferencesApiFp(this.configuration).getNotificationPreferences(requestParameters.melioAccount, requestParameters.organizationId, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Update notification preferences.
   * @summary Update notification preferences
   * @param {NotificationPreferencesApiSetNotificationPreferencesRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof NotificationPreferencesApi
   */
  setNotificationPreferences(requestParameters = {}, options) {
    return NotificationPreferencesApiFp(this.configuration).setNotificationPreferences(requestParameters.patchNotificationPreferencesRequest, requestParameters.melioAccount, requestParameters.organizationId, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
  }
};
var NotificationPreferencesApiInstance = createInstanceFromApiIClass(NotificationPreferencesApi);
var NotificationsApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * Retrieve a specific notification preference by notification name
     * @summary Retrieve notification preferences by notification name
     * @param {NotificationsNames} notificationName notification name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getNotificationPreferencesByNotificationName: (_0, ..._1) => __async(this, [_0, ..._1], function* (notificationName, options = {}) {
      assertParamExists("getNotificationPreferencesByNotificationName", "notificationName", notificationName);
      const localVarPath = `/account-receivable/notifications/{notificationName}`.replace(`{${"notificationName"}}`, encodeURIComponent(String(notificationName)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Retrieve a list of notifications preferences
     * @summary Retrieve notifications preferences
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getNotificationsPreferences: (..._0) => __async(this, [..._0], function* (options = {}) {
      const localVarPath = `/account-receivable/notifications`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Update an notification preference by notification name
     * @summary Update an notification preference by notification name
     * @param {NotificationsNames} notificationName notification name
     * @param {PutNotificationPreferencesByNameRequest} [putNotificationPreferencesByNameRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    putNotificationPreferencesByNotificationName: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (notificationName, putNotificationPreferencesByNameRequest, options = {}) {
      assertParamExists("putNotificationPreferencesByNotificationName", "notificationName", notificationName);
      const localVarPath = `/account-receivable/notifications/{notificationName}`.replace(`{${"notificationName"}}`, encodeURIComponent(String(notificationName)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "PUT" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(putNotificationPreferencesByNameRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    })
  };
};
var NotificationsApiFp = function(configuration) {
  const localVarAxiosParamCreator = NotificationsApiAxiosParamCreator(configuration);
  return {
    /**
     * Retrieve a specific notification preference by notification name
     * @summary Retrieve notification preferences by notification name
     * @param {NotificationsNames} notificationName notification name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getNotificationPreferencesByNotificationName(notificationName, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getNotificationPreferencesByNotificationName(notificationName, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Retrieve a list of notifications preferences
     * @summary Retrieve notifications preferences
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getNotificationsPreferences(options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getNotificationsPreferences(options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Update an notification preference by notification name
     * @summary Update an notification preference by notification name
     * @param {NotificationsNames} notificationName notification name
     * @param {PutNotificationPreferencesByNameRequest} [putNotificationPreferencesByNameRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    putNotificationPreferencesByNotificationName(notificationName, putNotificationPreferencesByNameRequest, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.putNotificationPreferencesByNotificationName(notificationName, putNotificationPreferencesByNameRequest, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    }
  };
};
var NotificationsApiClient = createApiFromFp(NotificationsApiFp);
var NotificationsApiFactory = function(configuration, basePath, axios2) {
  const localVarFp = NotificationsApiFp(configuration);
  return {
    /**
     * Retrieve a specific notification preference by notification name
     * @summary Retrieve notification preferences by notification name
     * @param {NotificationsNames} notificationName notification name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getNotificationPreferencesByNotificationName(notificationName, options) {
      return localVarFp.getNotificationPreferencesByNotificationName(notificationName, options).then((request) => request(axios2, basePath));
    },
    /**
     * Retrieve a list of notifications preferences
     * @summary Retrieve notifications preferences
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getNotificationsPreferences(options) {
      return localVarFp.getNotificationsPreferences(options).then((request) => request(axios2, basePath));
    },
    /**
     * Update an notification preference by notification name
     * @summary Update an notification preference by notification name
     * @param {NotificationsNames} notificationName notification name
     * @param {PutNotificationPreferencesByNameRequest} [putNotificationPreferencesByNameRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    putNotificationPreferencesByNotificationName(notificationName, putNotificationPreferencesByNameRequest, options) {
      return localVarFp.putNotificationPreferencesByNotificationName(notificationName, putNotificationPreferencesByNameRequest, options).then((request) => request(axios2, basePath));
    }
  };
};
var NotificationsApi = class extends BaseAPI {
  /**
   * Retrieve a specific notification preference by notification name
   * @summary Retrieve notification preferences by notification name
   * @param {NotificationsApiGetNotificationPreferencesByNotificationNameRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof NotificationsApi
   */
  getNotificationPreferencesByNotificationName(requestParameters, options) {
    return NotificationsApiFp(this.configuration).getNotificationPreferencesByNotificationName(requestParameters.notificationName, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Retrieve a list of notifications preferences
   * @summary Retrieve notifications preferences
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof NotificationsApi
   */
  getNotificationsPreferences(options) {
    return NotificationsApiFp(this.configuration).getNotificationsPreferences(options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Update an notification preference by notification name
   * @summary Update an notification preference by notification name
   * @param {NotificationsApiPutNotificationPreferencesByNotificationNameRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof NotificationsApi
   */
  putNotificationPreferencesByNotificationName(requestParameters, options) {
    return NotificationsApiFp(this.configuration).putNotificationPreferencesByNotificationName(requestParameters.notificationName, requestParameters.putNotificationPreferencesByNameRequest, options).then((request) => request(this.axios, this.basePath));
  }
};
var NotificationsApiInstance = createInstanceFromApiIClass(NotificationsApi);
var OnboardingApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * Retrieve onboarding user stored data.
     * @summary Retrieve onboarding user organization data.
     * @param {string} [melioAccount] The &#x60;Melio-Account&#x60; header is used when a Partner wants to perform an operation on behalf of one of its Accounts. It contains the Account\&#39;s ID which returned when creating the Account, or when retrieving all of the Partner\&#39;s Accounts. Note that most operations are not permitted without the presence of this header.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOnboarding: (_0, ..._1) => __async(this, [_0, ..._1], function* (melioAccount, options = {}) {
      const localVarPath = `/account-receivable/onboarding`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Update onboarding organization data.
     * @summary Update onboarding organization data.
     * @param {PatchOnBoardingRequest} [patchOnBoardingRequest] 
     * @param {string} [melioAccount] The &#x60;Melio-Account&#x60; header is used when a Partner wants to perform an operation on behalf of one of its Accounts. It contains the Account\&#39;s ID which returned when creating the Account, or when retrieving all of the Partner\&#39;s Accounts. Note that most operations are not permitted without the presence of this header.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchOnboarding: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (patchOnBoardingRequest, melioAccount, options = {}) {
      const localVarPath = `/account-receivable/onboarding`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "PATCH" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(patchOnBoardingRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Submit onboarding form.
     * @summary Submit onboarding form.
     * @param {string} [melioAccount] The &#x60;Melio-Account&#x60; header is used when a Partner wants to perform an operation on behalf of one of its Accounts. It contains the Account\&#39;s ID which returned when creating the Account, or when retrieving all of the Partner\&#39;s Accounts. Note that most operations are not permitted without the presence of this header.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postOnboarding: (_0, ..._1) => __async(this, [_0, ..._1], function* (melioAccount, options = {}) {
      const localVarPath = `/account-receivable/onboarding`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    })
  };
};
var OnboardingApiFp = function(configuration) {
  const localVarAxiosParamCreator = OnboardingApiAxiosParamCreator(configuration);
  return {
    /**
     * Retrieve onboarding user stored data.
     * @summary Retrieve onboarding user organization data.
     * @param {string} [melioAccount] The &#x60;Melio-Account&#x60; header is used when a Partner wants to perform an operation on behalf of one of its Accounts. It contains the Account\&#39;s ID which returned when creating the Account, or when retrieving all of the Partner\&#39;s Accounts. Note that most operations are not permitted without the presence of this header.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOnboarding(melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getOnboarding(melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Update onboarding organization data.
     * @summary Update onboarding organization data.
     * @param {PatchOnBoardingRequest} [patchOnBoardingRequest] 
     * @param {string} [melioAccount] The &#x60;Melio-Account&#x60; header is used when a Partner wants to perform an operation on behalf of one of its Accounts. It contains the Account\&#39;s ID which returned when creating the Account, or when retrieving all of the Partner\&#39;s Accounts. Note that most operations are not permitted without the presence of this header.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchOnboarding(patchOnBoardingRequest, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.patchOnboarding(patchOnBoardingRequest, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Submit onboarding form.
     * @summary Submit onboarding form.
     * @param {string} [melioAccount] The &#x60;Melio-Account&#x60; header is used when a Partner wants to perform an operation on behalf of one of its Accounts. It contains the Account\&#39;s ID which returned when creating the Account, or when retrieving all of the Partner\&#39;s Accounts. Note that most operations are not permitted without the presence of this header.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postOnboarding(melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postOnboarding(melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    }
  };
};
var OnboardingApiClient = createApiFromFp(OnboardingApiFp);
var OnboardingApiFactory = function(configuration, basePath, axios2) {
  const localVarFp = OnboardingApiFp(configuration);
  return {
    /**
     * Retrieve onboarding user stored data.
     * @summary Retrieve onboarding user organization data.
     * @param {string} [melioAccount] The &#x60;Melio-Account&#x60; header is used when a Partner wants to perform an operation on behalf of one of its Accounts. It contains the Account\&#39;s ID which returned when creating the Account, or when retrieving all of the Partner\&#39;s Accounts. Note that most operations are not permitted without the presence of this header.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOnboarding(melioAccount, options) {
      return localVarFp.getOnboarding(melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Update onboarding organization data.
     * @summary Update onboarding organization data.
     * @param {PatchOnBoardingRequest} [patchOnBoardingRequest] 
     * @param {string} [melioAccount] The &#x60;Melio-Account&#x60; header is used when a Partner wants to perform an operation on behalf of one of its Accounts. It contains the Account\&#39;s ID which returned when creating the Account, or when retrieving all of the Partner\&#39;s Accounts. Note that most operations are not permitted without the presence of this header.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchOnboarding(patchOnBoardingRequest, melioAccount, options) {
      return localVarFp.patchOnboarding(patchOnBoardingRequest, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Submit onboarding form.
     * @summary Submit onboarding form.
     * @param {string} [melioAccount] The &#x60;Melio-Account&#x60; header is used when a Partner wants to perform an operation on behalf of one of its Accounts. It contains the Account\&#39;s ID which returned when creating the Account, or when retrieving all of the Partner\&#39;s Accounts. Note that most operations are not permitted without the presence of this header.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postOnboarding(melioAccount, options) {
      return localVarFp.postOnboarding(melioAccount, options).then((request) => request(axios2, basePath));
    }
  };
};
var OnboardingApi = class extends BaseAPI {
  /**
   * Retrieve onboarding user stored data.
   * @summary Retrieve onboarding user organization data.
   * @param {OnboardingApiGetOnboardingRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OnboardingApi
   */
  getOnboarding(requestParameters = {}, options) {
    return OnboardingApiFp(this.configuration).getOnboarding(requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Update onboarding organization data.
   * @summary Update onboarding organization data.
   * @param {OnboardingApiPatchOnboardingRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OnboardingApi
   */
  patchOnboarding(requestParameters = {}, options) {
    return OnboardingApiFp(this.configuration).patchOnboarding(requestParameters.patchOnBoardingRequest, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Submit onboarding form.
   * @summary Submit onboarding form.
   * @param {OnboardingApiPostOnboardingRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OnboardingApi
   */
  postOnboarding(requestParameters = {}, options) {
    return OnboardingApiFp(this.configuration).postOnboarding(requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
};
var OnboardingApiInstance = createInstanceFromApiIClass(OnboardingApi);
var OnboardingStatusApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * Retrieve onboarding enrollment status.
     * @summary Retrieve onboarding enrollment status.
     * @param {string} [melioAccount] The &#x60;Melio-Account&#x60; header is used when a Partner wants to perform an operation on behalf of one of its Accounts. It contains the Account\&#39;s ID which returned when creating the Account, or when retrieving all of the Partner\&#39;s Accounts. Note that most operations are not permitted without the presence of this header.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOnboardingStatus: (_0, ..._1) => __async(this, [_0, ..._1], function* (melioAccount, options = {}) {
      const localVarPath = `/account-receivable/onboarding/status`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    })
  };
};
var OnboardingStatusApiFp = function(configuration) {
  const localVarAxiosParamCreator = OnboardingStatusApiAxiosParamCreator(configuration);
  return {
    /**
     * Retrieve onboarding enrollment status.
     * @summary Retrieve onboarding enrollment status.
     * @param {string} [melioAccount] The &#x60;Melio-Account&#x60; header is used when a Partner wants to perform an operation on behalf of one of its Accounts. It contains the Account\&#39;s ID which returned when creating the Account, or when retrieving all of the Partner\&#39;s Accounts. Note that most operations are not permitted without the presence of this header.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOnboardingStatus(melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getOnboardingStatus(melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    }
  };
};
var OnboardingStatusApiClient = createApiFromFp(OnboardingStatusApiFp);
var OnboardingStatusApiFactory = function(configuration, basePath, axios2) {
  const localVarFp = OnboardingStatusApiFp(configuration);
  return {
    /**
     * Retrieve onboarding enrollment status.
     * @summary Retrieve onboarding enrollment status.
     * @param {string} [melioAccount] The &#x60;Melio-Account&#x60; header is used when a Partner wants to perform an operation on behalf of one of its Accounts. It contains the Account\&#39;s ID which returned when creating the Account, or when retrieving all of the Partner\&#39;s Accounts. Note that most operations are not permitted without the presence of this header.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOnboardingStatus(melioAccount, options) {
      return localVarFp.getOnboardingStatus(melioAccount, options).then((request) => request(axios2, basePath));
    }
  };
};
var OnboardingStatusApi = class extends BaseAPI {
  /**
   * Retrieve onboarding enrollment status.
   * @summary Retrieve onboarding enrollment status.
   * @param {OnboardingStatusApiGetOnboardingStatusRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OnboardingStatusApi
   */
  getOnboardingStatus(requestParameters = {}, options) {
    return OnboardingStatusApiFp(this.configuration).getOnboardingStatus(requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
};
var OnboardingStatusApiInstance = createInstanceFromApiIClass(OnboardingStatusApi);
var OrganizationBeneficialOwnersApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * Delete an organization beneficial owner
     * @summary Delete an organization beneficial owner
     * @param {string} id ID of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteOrganizationBeneficialOwnersOwnerId: (_0, ..._1) => __async(this, [_0, ..._1], function* (id, options = {}) {
      assertParamExists("deleteOrganizationBeneficialOwnersOwnerId", "id", id);
      const localVarPath = `/organization-beneficial-owners/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "DELETE" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Retrieve all organization beneficial owners
     * @summary Retrieve all organization beneficial owners
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOrganizationBeneficialOwners: (..._0) => __async(this, [..._0], function* (options = {}) {
      const localVarPath = `/organization-beneficial-owners`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Retrieve an organization beneficial owner using its ID.
     * @summary Retrieve an organization beneficial owner
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOrganizationBeneficialOwnersOwnerId: (_0, _1, _2, ..._3) => __async(this, [_0, _1, _2, ..._3], function* (id, melioAccount, expand, options = {}) {
      assertParamExists("getOrganizationBeneficialOwnersOwnerId", "id", id);
      const localVarPath = `/organization-beneficial-owners/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (expand !== void 0) {
        localVarQueryParameter["expand"] = expand;
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * update an organization beneficial owner
     * @summary update an organization beneficial owner
     * @param {string} id ID of the entity
     * @param {PatchOrganizationBeneficialOwnerRequest} [patchOrganizationBeneficialOwnerRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchOrganizationBeneficialOwnersOwnerId: (_0, _1, _2, _3, ..._4) => __async(this, [_0, _1, _2, _3, ..._4], function* (id, patchOrganizationBeneficialOwnerRequest, idempotencyKey, melioAccount, options = {}) {
      assertParamExists("patchOrganizationBeneficialOwnersOwnerId", "id", id);
      const localVarPath = `/organization-beneficial-owners/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "PATCH" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (idempotencyKey !== void 0 && idempotencyKey !== null) {
        localVarHeaderParameter["Idempotency-Key"] = String(idempotencyKey);
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(patchOrganizationBeneficialOwnerRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * create an organization beneficial owner
     * @summary create an organization beneficial owner
     * @param {PostOrganizationBeneficialOwnerRequest} [postOrganizationBeneficialOwnerRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postOrganizationBeneficialOwners: (_0, _1, _2, ..._3) => __async(this, [_0, _1, _2, ..._3], function* (postOrganizationBeneficialOwnerRequest, idempotencyKey, melioAccount, options = {}) {
      const localVarPath = `/organization-beneficial-owners`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (idempotencyKey !== void 0 && idempotencyKey !== null) {
        localVarHeaderParameter["Idempotency-Key"] = String(idempotencyKey);
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postOrganizationBeneficialOwnerRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Create multiple organization beneficial owners based on a provided list.
     * @summary Create multiple organization beneficial owners
     * @param {Array<PostOrganizationBeneficialOwnerRequest>} [postOrganizationBeneficialOwnerRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postOrganizationBeneficialOwnersBulk: (_0, _1, _2, ..._3) => __async(this, [_0, _1, _2, ..._3], function* (postOrganizationBeneficialOwnerRequest, idempotencyKey, melioAccount, options = {}) {
      const localVarPath = `/organization-beneficial-owners/bulk`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (idempotencyKey !== void 0 && idempotencyKey !== null) {
        localVarHeaderParameter["Idempotency-Key"] = String(idempotencyKey);
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postOrganizationBeneficialOwnerRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    })
  };
};
var OrganizationBeneficialOwnersApiFp = function(configuration) {
  const localVarAxiosParamCreator = OrganizationBeneficialOwnersApiAxiosParamCreator(configuration);
  return {
    /**
     * Delete an organization beneficial owner
     * @summary Delete an organization beneficial owner
     * @param {string} id ID of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteOrganizationBeneficialOwnersOwnerId(id, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOrganizationBeneficialOwnersOwnerId(id, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Retrieve all organization beneficial owners
     * @summary Retrieve all organization beneficial owners
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOrganizationBeneficialOwners(options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getOrganizationBeneficialOwners(options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Retrieve an organization beneficial owner using its ID.
     * @summary Retrieve an organization beneficial owner
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOrganizationBeneficialOwnersOwnerId(id, melioAccount, expand, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getOrganizationBeneficialOwnersOwnerId(id, melioAccount, expand, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * update an organization beneficial owner
     * @summary update an organization beneficial owner
     * @param {string} id ID of the entity
     * @param {PatchOrganizationBeneficialOwnerRequest} [patchOrganizationBeneficialOwnerRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchOrganizationBeneficialOwnersOwnerId(id, patchOrganizationBeneficialOwnerRequest, idempotencyKey, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.patchOrganizationBeneficialOwnersOwnerId(id, patchOrganizationBeneficialOwnerRequest, idempotencyKey, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * create an organization beneficial owner
     * @summary create an organization beneficial owner
     * @param {PostOrganizationBeneficialOwnerRequest} [postOrganizationBeneficialOwnerRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postOrganizationBeneficialOwners(postOrganizationBeneficialOwnerRequest, idempotencyKey, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postOrganizationBeneficialOwners(postOrganizationBeneficialOwnerRequest, idempotencyKey, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Create multiple organization beneficial owners based on a provided list.
     * @summary Create multiple organization beneficial owners
     * @param {Array<PostOrganizationBeneficialOwnerRequest>} [postOrganizationBeneficialOwnerRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postOrganizationBeneficialOwnersBulk(postOrganizationBeneficialOwnerRequest, idempotencyKey, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postOrganizationBeneficialOwnersBulk(postOrganizationBeneficialOwnerRequest, idempotencyKey, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    }
  };
};
var OrganizationBeneficialOwnersApiClient = createApiFromFp(OrganizationBeneficialOwnersApiFp);
var OrganizationBeneficialOwnersApiFactory = function(configuration, basePath, axios2) {
  const localVarFp = OrganizationBeneficialOwnersApiFp(configuration);
  return {
    /**
     * Delete an organization beneficial owner
     * @summary Delete an organization beneficial owner
     * @param {string} id ID of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteOrganizationBeneficialOwnersOwnerId(id, options) {
      return localVarFp.deleteOrganizationBeneficialOwnersOwnerId(id, options).then((request) => request(axios2, basePath));
    },
    /**
     * Retrieve all organization beneficial owners
     * @summary Retrieve all organization beneficial owners
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOrganizationBeneficialOwners(options) {
      return localVarFp.getOrganizationBeneficialOwners(options).then((request) => request(axios2, basePath));
    },
    /**
     * Retrieve an organization beneficial owner using its ID.
     * @summary Retrieve an organization beneficial owner
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOrganizationBeneficialOwnersOwnerId(id, melioAccount, expand, options) {
      return localVarFp.getOrganizationBeneficialOwnersOwnerId(id, melioAccount, expand, options).then((request) => request(axios2, basePath));
    },
    /**
     * update an organization beneficial owner
     * @summary update an organization beneficial owner
     * @param {string} id ID of the entity
     * @param {PatchOrganizationBeneficialOwnerRequest} [patchOrganizationBeneficialOwnerRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchOrganizationBeneficialOwnersOwnerId(id, patchOrganizationBeneficialOwnerRequest, idempotencyKey, melioAccount, options) {
      return localVarFp.patchOrganizationBeneficialOwnersOwnerId(id, patchOrganizationBeneficialOwnerRequest, idempotencyKey, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * create an organization beneficial owner
     * @summary create an organization beneficial owner
     * @param {PostOrganizationBeneficialOwnerRequest} [postOrganizationBeneficialOwnerRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postOrganizationBeneficialOwners(postOrganizationBeneficialOwnerRequest, idempotencyKey, melioAccount, options) {
      return localVarFp.postOrganizationBeneficialOwners(postOrganizationBeneficialOwnerRequest, idempotencyKey, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Create multiple organization beneficial owners based on a provided list.
     * @summary Create multiple organization beneficial owners
     * @param {Array<PostOrganizationBeneficialOwnerRequest>} [postOrganizationBeneficialOwnerRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postOrganizationBeneficialOwnersBulk(postOrganizationBeneficialOwnerRequest, idempotencyKey, melioAccount, options) {
      return localVarFp.postOrganizationBeneficialOwnersBulk(postOrganizationBeneficialOwnerRequest, idempotencyKey, melioAccount, options).then((request) => request(axios2, basePath));
    }
  };
};
var OrganizationBeneficialOwnersApi = class extends BaseAPI {
  /**
   * Delete an organization beneficial owner
   * @summary Delete an organization beneficial owner
   * @param {OrganizationBeneficialOwnersApiDeleteOrganizationBeneficialOwnersOwnerIdRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrganizationBeneficialOwnersApi
   */
  deleteOrganizationBeneficialOwnersOwnerId(requestParameters, options) {
    return OrganizationBeneficialOwnersApiFp(this.configuration).deleteOrganizationBeneficialOwnersOwnerId(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Retrieve all organization beneficial owners
   * @summary Retrieve all organization beneficial owners
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrganizationBeneficialOwnersApi
   */
  getOrganizationBeneficialOwners(options) {
    return OrganizationBeneficialOwnersApiFp(this.configuration).getOrganizationBeneficialOwners(options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Retrieve an organization beneficial owner using its ID.
   * @summary Retrieve an organization beneficial owner
   * @param {OrganizationBeneficialOwnersApiGetOrganizationBeneficialOwnersOwnerIdRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrganizationBeneficialOwnersApi
   */
  getOrganizationBeneficialOwnersOwnerId(requestParameters, options) {
    return OrganizationBeneficialOwnersApiFp(this.configuration).getOrganizationBeneficialOwnersOwnerId(requestParameters.id, requestParameters.melioAccount, requestParameters.expand, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * update an organization beneficial owner
   * @summary update an organization beneficial owner
   * @param {OrganizationBeneficialOwnersApiPatchOrganizationBeneficialOwnersOwnerIdRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrganizationBeneficialOwnersApi
   */
  patchOrganizationBeneficialOwnersOwnerId(requestParameters, options) {
    return OrganizationBeneficialOwnersApiFp(this.configuration).patchOrganizationBeneficialOwnersOwnerId(requestParameters.id, requestParameters.patchOrganizationBeneficialOwnerRequest, requestParameters.idempotencyKey, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * create an organization beneficial owner
   * @summary create an organization beneficial owner
   * @param {OrganizationBeneficialOwnersApiPostOrganizationBeneficialOwnersRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrganizationBeneficialOwnersApi
   */
  postOrganizationBeneficialOwners(requestParameters = {}, options) {
    return OrganizationBeneficialOwnersApiFp(this.configuration).postOrganizationBeneficialOwners(requestParameters.postOrganizationBeneficialOwnerRequest, requestParameters.idempotencyKey, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Create multiple organization beneficial owners based on a provided list.
   * @summary Create multiple organization beneficial owners
   * @param {OrganizationBeneficialOwnersApiPostOrganizationBeneficialOwnersBulkRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrganizationBeneficialOwnersApi
   */
  postOrganizationBeneficialOwnersBulk(requestParameters = {}, options) {
    return OrganizationBeneficialOwnersApiFp(this.configuration).postOrganizationBeneficialOwnersBulk(requestParameters.postOrganizationBeneficialOwnerRequest, requestParameters.idempotencyKey, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
};
var OrganizationBeneficialOwnersApiInstance = createInstanceFromApiIClass(OrganizationBeneficialOwnersApi);
var OrganizationPreferencesApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * List of all organization preferences, filtered by organizationId.
     * @summary Retrieve all organization preference
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOrganizationPreferences: (..._0) => __async(this, [..._0], function* (options = {}) {
      const localVarPath = `/organization-preferences`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Retrieve an organization preference by key
     * @summary Retrieve an organization preference by key
     * @param {string} organizationPreferenceKey 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOrganizationPreferencesOrganizationPreferenceKey: (_0, ..._1) => __async(this, [_0, ..._1], function* (organizationPreferenceKey, options = {}) {
      assertParamExists("getOrganizationPreferencesOrganizationPreferenceKey", "organizationPreferenceKey", organizationPreferenceKey);
      const localVarPath = `/organization-preferences/{organizationPreferenceKey}`.replace(`{${"organizationPreferenceKey"}}`, encodeURIComponent(String(organizationPreferenceKey)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Update or create organization preference.
     * @summary Update or create organization preference
     * @param {SetOrganizationPreferenceRequest} [setOrganizationPreferenceRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    setOrganizationPreferences: (_0, ..._1) => __async(this, [_0, ..._1], function* (setOrganizationPreferenceRequest, options = {}) {
      const localVarPath = `/organization-preferences`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(setOrganizationPreferenceRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    })
  };
};
var OrganizationPreferencesApiFp = function(configuration) {
  const localVarAxiosParamCreator = OrganizationPreferencesApiAxiosParamCreator(configuration);
  return {
    /**
     * List of all organization preferences, filtered by organizationId.
     * @summary Retrieve all organization preference
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOrganizationPreferences(options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getOrganizationPreferences(options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Retrieve an organization preference by key
     * @summary Retrieve an organization preference by key
     * @param {string} organizationPreferenceKey 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOrganizationPreferencesOrganizationPreferenceKey(organizationPreferenceKey, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getOrganizationPreferencesOrganizationPreferenceKey(organizationPreferenceKey, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Update or create organization preference.
     * @summary Update or create organization preference
     * @param {SetOrganizationPreferenceRequest} [setOrganizationPreferenceRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    setOrganizationPreferences(setOrganizationPreferenceRequest, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.setOrganizationPreferences(setOrganizationPreferenceRequest, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    }
  };
};
var OrganizationPreferencesApiClient = createApiFromFp(OrganizationPreferencesApiFp);
var OrganizationPreferencesApiFactory = function(configuration, basePath, axios2) {
  const localVarFp = OrganizationPreferencesApiFp(configuration);
  return {
    /**
     * List of all organization preferences, filtered by organizationId.
     * @summary Retrieve all organization preference
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOrganizationPreferences(options) {
      return localVarFp.getOrganizationPreferences(options).then((request) => request(axios2, basePath));
    },
    /**
     * Retrieve an organization preference by key
     * @summary Retrieve an organization preference by key
     * @param {string} organizationPreferenceKey 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOrganizationPreferencesOrganizationPreferenceKey(organizationPreferenceKey, options) {
      return localVarFp.getOrganizationPreferencesOrganizationPreferenceKey(organizationPreferenceKey, options).then((request) => request(axios2, basePath));
    },
    /**
     * Update or create organization preference.
     * @summary Update or create organization preference
     * @param {SetOrganizationPreferenceRequest} [setOrganizationPreferenceRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    setOrganizationPreferences(setOrganizationPreferenceRequest, options) {
      return localVarFp.setOrganizationPreferences(setOrganizationPreferenceRequest, options).then((request) => request(axios2, basePath));
    }
  };
};
var OrganizationPreferencesApi = class extends BaseAPI {
  /**
   * List of all organization preferences, filtered by organizationId.
   * @summary Retrieve all organization preference
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrganizationPreferencesApi
   */
  getOrganizationPreferences(options) {
    return OrganizationPreferencesApiFp(this.configuration).getOrganizationPreferences(options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Retrieve an organization preference by key
   * @summary Retrieve an organization preference by key
   * @param {OrganizationPreferencesApiGetOrganizationPreferencesOrganizationPreferenceKeyRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrganizationPreferencesApi
   */
  getOrganizationPreferencesOrganizationPreferenceKey(requestParameters, options) {
    return OrganizationPreferencesApiFp(this.configuration).getOrganizationPreferencesOrganizationPreferenceKey(requestParameters.organizationPreferenceKey, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Update or create organization preference.
   * @summary Update or create organization preference
   * @param {OrganizationPreferencesApiSetOrganizationPreferencesRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrganizationPreferencesApi
   */
  setOrganizationPreferences(requestParameters = {}, options) {
    return OrganizationPreferencesApiFp(this.configuration).setOrganizationPreferences(requestParameters.setOrganizationPreferenceRequest, options).then((request) => request(this.axios, this.basePath));
  }
};
var OrganizationPreferencesApiInstance = createInstanceFromApiIClass(OrganizationPreferencesApi);
var OrganizationsApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * Retrieve all the organizations that belongs to the current user
     * @summary Retrieve all the organizations related to current user
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOrganizations: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (expand, melioAccount, options = {}) {
      const localVarPath = `/organizations`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (expand !== void 0) {
        localVarQueryParameter["expand"] = expand;
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Creates a new Organization, attaches the user who initiated the call to the newly created organization with non-owner role, and invites supposed owner to join the organization.
     * @summary Creates an Organization on behalf of its owner
     * @param {PostOrganizationsOnBehalfRequest} [postOrganizationsOnBehalfRequest] 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    organizationsOnBehalfPost: (_0, _1, _2, ..._3) => __async(this, [_0, _1, _2, ..._3], function* (postOrganizationsOnBehalfRequest, melioAccount, expand, options = {}) {
      const localVarPath = `/organizations/onbehalf`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (expand !== void 0) {
        localVarQueryParameter["expand"] = expand;
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postOrganizationsOnBehalfRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Create an Organization(company) and set current User as Organization owner.
     * @summary Create owned Organization
     * @param {PostOrganizationsRequest} [postOrganizationsRequest] 
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postOrganizations: (_0, _1, _2, ..._3) => __async(this, [_0, _1, _2, ..._3], function* (postOrganizationsRequest, expand, melioAccount, options = {}) {
      const localVarPath = `/organizations`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (expand !== void 0) {
        localVarQueryParameter["expand"] = expand;
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postOrganizationsRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    })
  };
};
var OrganizationsApiFp = function(configuration) {
  const localVarAxiosParamCreator = OrganizationsApiAxiosParamCreator(configuration);
  return {
    /**
     * Retrieve all the organizations that belongs to the current user
     * @summary Retrieve all the organizations related to current user
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOrganizations(expand, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getOrganizations(expand, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Creates a new Organization, attaches the user who initiated the call to the newly created organization with non-owner role, and invites supposed owner to join the organization.
     * @summary Creates an Organization on behalf of its owner
     * @param {PostOrganizationsOnBehalfRequest} [postOrganizationsOnBehalfRequest] 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    organizationsOnBehalfPost(postOrganizationsOnBehalfRequest, melioAccount, expand, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.organizationsOnBehalfPost(postOrganizationsOnBehalfRequest, melioAccount, expand, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Create an Organization(company) and set current User as Organization owner.
     * @summary Create owned Organization
     * @param {PostOrganizationsRequest} [postOrganizationsRequest] 
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postOrganizations(postOrganizationsRequest, expand, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postOrganizations(postOrganizationsRequest, expand, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    }
  };
};
var OrganizationsApiClient = createApiFromFp(OrganizationsApiFp);
var OrganizationsApiFactory = function(configuration, basePath, axios2) {
  const localVarFp = OrganizationsApiFp(configuration);
  return {
    /**
     * Retrieve all the organizations that belongs to the current user
     * @summary Retrieve all the organizations related to current user
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOrganizations(expand, melioAccount, options) {
      return localVarFp.getOrganizations(expand, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Creates a new Organization, attaches the user who initiated the call to the newly created organization with non-owner role, and invites supposed owner to join the organization.
     * @summary Creates an Organization on behalf of its owner
     * @param {PostOrganizationsOnBehalfRequest} [postOrganizationsOnBehalfRequest] 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    organizationsOnBehalfPost(postOrganizationsOnBehalfRequest, melioAccount, expand, options) {
      return localVarFp.organizationsOnBehalfPost(postOrganizationsOnBehalfRequest, melioAccount, expand, options).then((request) => request(axios2, basePath));
    },
    /**
     * Create an Organization(company) and set current User as Organization owner.
     * @summary Create owned Organization
     * @param {PostOrganizationsRequest} [postOrganizationsRequest] 
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postOrganizations(postOrganizationsRequest, expand, melioAccount, options) {
      return localVarFp.postOrganizations(postOrganizationsRequest, expand, melioAccount, options).then((request) => request(axios2, basePath));
    }
  };
};
var OrganizationsApi = class extends BaseAPI {
  /**
   * Retrieve all the organizations that belongs to the current user
   * @summary Retrieve all the organizations related to current user
   * @param {OrganizationsApiGetOrganizationsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrganizationsApi
   */
  getOrganizations(requestParameters = {}, options) {
    return OrganizationsApiFp(this.configuration).getOrganizations(requestParameters.expand, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Creates a new Organization, attaches the user who initiated the call to the newly created organization with non-owner role, and invites supposed owner to join the organization.
   * @summary Creates an Organization on behalf of its owner
   * @param {OrganizationsApiOrganizationsOnBehalfPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrganizationsApi
   */
  organizationsOnBehalfPost(requestParameters = {}, options) {
    return OrganizationsApiFp(this.configuration).organizationsOnBehalfPost(requestParameters.postOrganizationsOnBehalfRequest, requestParameters.melioAccount, requestParameters.expand, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Create an Organization(company) and set current User as Organization owner.
   * @summary Create owned Organization
   * @param {OrganizationsApiPostOrganizationsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrganizationsApi
   */
  postOrganizations(requestParameters = {}, options) {
    return OrganizationsApiFp(this.configuration).postOrganizations(requestParameters.postOrganizationsRequest, requestParameters.expand, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
};
var OrganizationsApiInstance = createInstanceFromApiIClass(OrganizationsApi);
var PartnersApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSyncMigration: (..._0) => __async(this, [..._0], function* (options = {}) {
      const localVarPath = `/sync/migration`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    })
  };
};
var PartnersApiFp = function(configuration) {
  const localVarAxiosParamCreator = PartnersApiAxiosParamCreator(configuration);
  return {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSyncMigration(options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getSyncMigration(options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    }
  };
};
var PartnersApiClient = createApiFromFp(PartnersApiFp);
var PartnersApiFactory = function(configuration, basePath, axios2) {
  const localVarFp = PartnersApiFp(configuration);
  return {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSyncMigration(options) {
      return localVarFp.getSyncMigration(options).then((request) => request(axios2, basePath));
    }
  };
};
var PartnersApi = class extends BaseAPI {
  /**
   * 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PartnersApi
   */
  getSyncMigration(options) {
    return PartnersApiFp(this.configuration).getSyncMigration(options).then((request) => request(this.axios, this.basePath));
  }
};
var PartnersApiInstance = createInstanceFromApiIClass(PartnersApi);
var PaymentApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * Create bill and scheduled payment for authenticated guest payor by payment request in order to pay a payment
     * @summary Create bill and scheduled payment for authenticated guest payor by payment request in order to pay a payment
     * @param {PostPayorPayPaymentRequest} [postPayorPayPaymentRequest] Provide payment request link and funding source id to allow payor to pay
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postPayorPayPayment: (_0, ..._1) => __async(this, [_0, ..._1], function* (postPayorPayPaymentRequest, options = {}) {
      const localVarPath = `/account-receivable/payor/pay`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postPayorPayPaymentRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    })
  };
};
var PaymentApiFp = function(configuration) {
  const localVarAxiosParamCreator = PaymentApiAxiosParamCreator(configuration);
  return {
    /**
     * Create bill and scheduled payment for authenticated guest payor by payment request in order to pay a payment
     * @summary Create bill and scheduled payment for authenticated guest payor by payment request in order to pay a payment
     * @param {PostPayorPayPaymentRequest} [postPayorPayPaymentRequest] Provide payment request link and funding source id to allow payor to pay
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postPayorPayPayment(postPayorPayPaymentRequest, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postPayorPayPayment(postPayorPayPaymentRequest, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    }
  };
};
var PaymentApiClient = createApiFromFp(PaymentApiFp);
var PaymentApiFactory = function(configuration, basePath, axios2) {
  const localVarFp = PaymentApiFp(configuration);
  return {
    /**
     * Create bill and scheduled payment for authenticated guest payor by payment request in order to pay a payment
     * @summary Create bill and scheduled payment for authenticated guest payor by payment request in order to pay a payment
     * @param {PostPayorPayPaymentRequest} [postPayorPayPaymentRequest] Provide payment request link and funding source id to allow payor to pay
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postPayorPayPayment(postPayorPayPaymentRequest, options) {
      return localVarFp.postPayorPayPayment(postPayorPayPaymentRequest, options).then((request) => request(axios2, basePath));
    }
  };
};
var PaymentApi = class extends BaseAPI {
  /**
   * Create bill and scheduled payment for authenticated guest payor by payment request in order to pay a payment
   * @summary Create bill and scheduled payment for authenticated guest payor by payment request in order to pay a payment
   * @param {PaymentApiPostPayorPayPaymentRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentApi
   */
  postPayorPayPayment(requestParameters = {}, options) {
    return PaymentApiFp(this.configuration).postPayorPayPayment(requestParameters.postPayorPayPaymentRequest, options).then((request) => request(this.axios, this.basePath));
  }
};
var PaymentApiInstance = createInstanceFromApiIClass(PaymentApi);
var PaymentGetRequiredDocumentsApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * This operation gets the risk request of files of the Payment
     * @summary get the risk request of the payment for files
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPaymentRequiredDocuments: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (id, melioAccount, options = {}) {
      assertParamExists("getPaymentRequiredDocuments", "id", id);
      const localVarPath = `/payments/{id}/required-documents`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    })
  };
};
var PaymentGetRequiredDocumentsApiFp = function(configuration) {
  const localVarAxiosParamCreator = PaymentGetRequiredDocumentsApiAxiosParamCreator(configuration);
  return {
    /**
     * This operation gets the risk request of files of the Payment
     * @summary get the risk request of the payment for files
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPaymentRequiredDocuments(id, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getPaymentRequiredDocuments(id, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    }
  };
};
var PaymentGetRequiredDocumentsApiClient = createApiFromFp(PaymentGetRequiredDocumentsApiFp);
var PaymentGetRequiredDocumentsApiFactory = function(configuration, basePath, axios2) {
  const localVarFp = PaymentGetRequiredDocumentsApiFp(configuration);
  return {
    /**
     * This operation gets the risk request of files of the Payment
     * @summary get the risk request of the payment for files
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPaymentRequiredDocuments(id, melioAccount, options) {
      return localVarFp.getPaymentRequiredDocuments(id, melioAccount, options).then((request) => request(axios2, basePath));
    }
  };
};
var PaymentGetRequiredDocumentsApi = class extends BaseAPI {
  /**
   * This operation gets the risk request of files of the Payment
   * @summary get the risk request of the payment for files
   * @param {PaymentGetRequiredDocumentsApiGetPaymentRequiredDocumentsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentGetRequiredDocumentsApi
   */
  getPaymentRequiredDocuments(requestParameters, options) {
    return PaymentGetRequiredDocumentsApiFp(this.configuration).getPaymentRequiredDocuments(requestParameters.id, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
};
var PaymentGetRequiredDocumentsApiInstance = createInstanceFromApiIClass(PaymentGetRequiredDocumentsApi);
var PaymentIntentsApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * Delete a Payment Intent.
     * @summary Delete a Payment Intent
     * @param {string} id ID of the entity
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deletePaymentIntentsPaymentIntentId: (_0, _1, _2, _3, _4, _5, ..._6) => __async(this, [_0, _1, _2, _3, _4, _5, ..._6], function* (id, expand, idempotencyKey, melioAccount, organizationId, userId, options = {}) {
      assertParamExists("deletePaymentIntentsPaymentIntentId", "id", id);
      const localVarPath = `/payment-intents/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "DELETE" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (expand !== void 0 && expand !== null) {
        localVarHeaderParameter["expand"] = String(JSON.stringify(expand));
      }
      if (idempotencyKey !== void 0 && idempotencyKey !== null) {
        localVarHeaderParameter["Idempotency-Key"] = String(idempotencyKey);
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      if (organizationId !== void 0 && organizationId !== null) {
        localVarHeaderParameter["Organization-id"] = String(organizationId);
      }
      if (userId !== void 0 && userId !== null) {
        localVarHeaderParameter["User-id"] = String(userId);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Retrieve all Payment Intents
     * @summary Retrieve all Payment Intents
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [search] Limit returned objects to those that satisfy the specified query. Query strings support logic and comparison against fields that you specify. See the method documentation to learn which fields can be included in your query, or [read more about query strings](https://docs.melio.com/docs/melio-data-api/getting-started#advanced_search).
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPaymentIntents: (_0, _1, _2, _3, _4, ..._5) => __async(this, [_0, _1, _2, _3, _4, ..._5], function* (expand, search, melioAccount, organizationId, userId, options = {}) {
      const localVarPath = `/payment-intents`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (expand !== void 0) {
        localVarQueryParameter["expand"] = expand;
      }
      if (search !== void 0) {
        localVarQueryParameter["search"] = search;
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      if (organizationId !== void 0 && organizationId !== null) {
        localVarHeaderParameter["Organization-id"] = String(organizationId);
      }
      if (userId !== void 0 && userId !== null) {
        localVarHeaderParameter["User-id"] = String(userId);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Retrieve a Payment Intent
     * @summary Retrieve a Payment Intent
     * @param {string} id ID of the entity
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPaymentIntentsPaymentIntentId: (_0, _1, _2, _3, _4, ..._5) => __async(this, [_0, _1, _2, _3, _4, ..._5], function* (id, expand, melioAccount, organizationId, userId, options = {}) {
      assertParamExists("getPaymentIntentsPaymentIntentId", "id", id);
      const localVarPath = `/payment-intents/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (expand !== void 0) {
        localVarQueryParameter["expand"] = expand;
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      if (organizationId !== void 0 && organizationId !== null) {
        localVarHeaderParameter["Organization-id"] = String(organizationId);
      }
      if (userId !== void 0 && userId !== null) {
        localVarHeaderParameter["User-id"] = String(userId);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Update multiple Payment Intents based on a provided list.
     * @summary Update multiple Payment Intents
     * @param {Array<PatchPaymentIntents>} [patchPaymentIntents] 
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchPaymentIntentsBulk: (_0, _1, _2, _3, _4, _5, ..._6) => __async(this, [_0, _1, _2, _3, _4, _5, ..._6], function* (patchPaymentIntents, expand, idempotencyKey, melioAccount, organizationId, userId, options = {}) {
      const localVarPath = `/payment-intents/bulk`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "PATCH" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (expand !== void 0) {
        localVarQueryParameter["expand"] = expand;
      }
      if (idempotencyKey !== void 0 && idempotencyKey !== null) {
        localVarHeaderParameter["Idempotency-Key"] = String(idempotencyKey);
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      if (organizationId !== void 0 && organizationId !== null) {
        localVarHeaderParameter["Organization-id"] = String(organizationId);
      }
      if (userId !== void 0 && userId !== null) {
        localVarHeaderParameter["User-id"] = String(userId);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(patchPaymentIntents, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Update an existing Payment Intent.  The request\'s body can be partial, and only provided fields will be overwritten. Set an optional field to `null` in order to remove its contents.
     * @summary Update a Payment Intent
     * @param {string} id ID of the entity
     * @param {PatchPaymentIntentsPaymentIntentIdRequest} [patchPaymentIntentsPaymentIntentIdRequest] 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchPaymentIntentsPaymentIntentId: (_0, _1, _2, _3, _4, _5, _6, ..._7) => __async(this, [_0, _1, _2, _3, _4, _5, _6, ..._7], function* (id, patchPaymentIntentsPaymentIntentIdRequest, expand, idempotencyKey, melioAccount, organizationId, userId, options = {}) {
      assertParamExists("patchPaymentIntentsPaymentIntentId", "id", id);
      const localVarPath = `/payment-intents/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "PATCH" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (expand !== void 0 && expand !== null) {
        localVarHeaderParameter["expand"] = String(JSON.stringify(expand));
      }
      if (idempotencyKey !== void 0 && idempotencyKey !== null) {
        localVarHeaderParameter["Idempotency-Key"] = String(idempotencyKey);
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      if (organizationId !== void 0 && organizationId !== null) {
        localVarHeaderParameter["Organization-id"] = String(organizationId);
      }
      if (userId !== void 0 && userId !== null) {
        localVarHeaderParameter["User-id"] = String(userId);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(patchPaymentIntentsPaymentIntentIdRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Create a Payment Intent
     * @summary Create a Payment Intent
     * @param {PostPaymentIntentsRequest} [postPaymentIntentsRequest] 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postPaymentIntents: (_0, _1, _2, _3, _4, _5, ..._6) => __async(this, [_0, _1, _2, _3, _4, _5, ..._6], function* (postPaymentIntentsRequest, expand, idempotencyKey, melioAccount, organizationId, userId, options = {}) {
      const localVarPath = `/payment-intents`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (expand !== void 0 && expand !== null) {
        localVarHeaderParameter["expand"] = String(JSON.stringify(expand));
      }
      if (idempotencyKey !== void 0 && idempotencyKey !== null) {
        localVarHeaderParameter["Idempotency-Key"] = String(idempotencyKey);
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      if (organizationId !== void 0 && organizationId !== null) {
        localVarHeaderParameter["Organization-id"] = String(organizationId);
      }
      if (userId !== void 0 && userId !== null) {
        localVarHeaderParameter["User-id"] = String(userId);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postPaymentIntentsRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Create multiple Payment Intents based on a provided list.
     * @summary Create multiple Payment Intents
     * @param {PostPaymentIntentsBulkRequest} [postPaymentIntentsBulkRequest] 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postPaymentIntentsBulk: (_0, _1, _2, _3, _4, _5, ..._6) => __async(this, [_0, _1, _2, _3, _4, _5, ..._6], function* (postPaymentIntentsBulkRequest, expand, idempotencyKey, melioAccount, organizationId, userId, options = {}) {
      const localVarPath = `/payment-intents/bulk`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (expand !== void 0 && expand !== null) {
        localVarHeaderParameter["expand"] = String(JSON.stringify(expand));
      }
      if (idempotencyKey !== void 0 && idempotencyKey !== null) {
        localVarHeaderParameter["Idempotency-Key"] = String(idempotencyKey);
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      if (organizationId !== void 0 && organizationId !== null) {
        localVarHeaderParameter["Organization-id"] = String(organizationId);
      }
      if (userId !== void 0 && userId !== null) {
        localVarHeaderParameter["User-id"] = String(userId);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postPaymentIntentsBulkRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Confirm batch of payment intents and produce payments based on the current configuration.
     * @summary Confirm a batch of Payment Intents
     * @param {PaymentIntentBatchParameters} paymentIntentBatchParameters Payment Intent Ids
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postPaymentIntentsPaymentIntentBatchConfirm: (_0, _1, _2, _3, _4, _5, ..._6) => __async(this, [_0, _1, _2, _3, _4, _5, ..._6], function* (paymentIntentBatchParameters, expand, idempotencyKey, melioAccount, organizationId, userId, options = {}) {
      assertParamExists("postPaymentIntentsPaymentIntentBatchConfirm", "paymentIntentBatchParameters", paymentIntentBatchParameters);
      const localVarPath = `/payment-intents/confirm`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (expand !== void 0 && expand !== null) {
        localVarHeaderParameter["expand"] = String(JSON.stringify(expand));
      }
      if (idempotencyKey !== void 0 && idempotencyKey !== null) {
        localVarHeaderParameter["Idempotency-Key"] = String(idempotencyKey);
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      if (organizationId !== void 0 && organizationId !== null) {
        localVarHeaderParameter["Organization-id"] = String(organizationId);
      }
      if (userId !== void 0 && userId !== null) {
        localVarHeaderParameter["User-id"] = String(userId);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(paymentIntentBatchParameters, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Confirm this Payment Intent and produce a Payment based on the current configuration.
     * @summary Confirm a Payment Intent
     * @param {string} id ID of the entity
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postPaymentIntentsPaymentIntentIdConfirm: (_0, _1, _2, _3, _4, _5, ..._6) => __async(this, [_0, _1, _2, _3, _4, _5, ..._6], function* (id, expand, idempotencyKey, melioAccount, organizationId, userId, options = {}) {
      assertParamExists("postPaymentIntentsPaymentIntentIdConfirm", "id", id);
      const localVarPath = `/payment-intents/{id}/confirm`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (expand !== void 0 && expand !== null) {
        localVarHeaderParameter["expand"] = String(JSON.stringify(expand));
      }
      if (idempotencyKey !== void 0 && idempotencyKey !== null) {
        localVarHeaderParameter["Idempotency-Key"] = String(idempotencyKey);
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      if (organizationId !== void 0 && organizationId !== null) {
        localVarHeaderParameter["Organization-id"] = String(organizationId);
      }
      if (userId !== void 0 && userId !== null) {
        localVarHeaderParameter["User-id"] = String(userId);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    })
  };
};
var PaymentIntentsApiFp = function(configuration) {
  const localVarAxiosParamCreator = PaymentIntentsApiAxiosParamCreator(configuration);
  return {
    /**
     * Delete a Payment Intent.
     * @summary Delete a Payment Intent
     * @param {string} id ID of the entity
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deletePaymentIntentsPaymentIntentId(id, expand, idempotencyKey, melioAccount, organizationId, userId, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.deletePaymentIntentsPaymentIntentId(id, expand, idempotencyKey, melioAccount, organizationId, userId, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Retrieve all Payment Intents
     * @summary Retrieve all Payment Intents
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [search] Limit returned objects to those that satisfy the specified query. Query strings support logic and comparison against fields that you specify. See the method documentation to learn which fields can be included in your query, or [read more about query strings](https://docs.melio.com/docs/melio-data-api/getting-started#advanced_search).
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPaymentIntents(expand, search, melioAccount, organizationId, userId, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getPaymentIntents(expand, search, melioAccount, organizationId, userId, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Retrieve a Payment Intent
     * @summary Retrieve a Payment Intent
     * @param {string} id ID of the entity
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPaymentIntentsPaymentIntentId(id, expand, melioAccount, organizationId, userId, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getPaymentIntentsPaymentIntentId(id, expand, melioAccount, organizationId, userId, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Update multiple Payment Intents based on a provided list.
     * @summary Update multiple Payment Intents
     * @param {Array<PatchPaymentIntents>} [patchPaymentIntents] 
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchPaymentIntentsBulk(patchPaymentIntents, expand, idempotencyKey, melioAccount, organizationId, userId, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.patchPaymentIntentsBulk(patchPaymentIntents, expand, idempotencyKey, melioAccount, organizationId, userId, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Update an existing Payment Intent.  The request\'s body can be partial, and only provided fields will be overwritten. Set an optional field to `null` in order to remove its contents.
     * @summary Update a Payment Intent
     * @param {string} id ID of the entity
     * @param {PatchPaymentIntentsPaymentIntentIdRequest} [patchPaymentIntentsPaymentIntentIdRequest] 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchPaymentIntentsPaymentIntentId(id, patchPaymentIntentsPaymentIntentIdRequest, expand, idempotencyKey, melioAccount, organizationId, userId, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.patchPaymentIntentsPaymentIntentId(id, patchPaymentIntentsPaymentIntentIdRequest, expand, idempotencyKey, melioAccount, organizationId, userId, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Create a Payment Intent
     * @summary Create a Payment Intent
     * @param {PostPaymentIntentsRequest} [postPaymentIntentsRequest] 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postPaymentIntents(postPaymentIntentsRequest, expand, idempotencyKey, melioAccount, organizationId, userId, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postPaymentIntents(postPaymentIntentsRequest, expand, idempotencyKey, melioAccount, organizationId, userId, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Create multiple Payment Intents based on a provided list.
     * @summary Create multiple Payment Intents
     * @param {PostPaymentIntentsBulkRequest} [postPaymentIntentsBulkRequest] 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postPaymentIntentsBulk(postPaymentIntentsBulkRequest, expand, idempotencyKey, melioAccount, organizationId, userId, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postPaymentIntentsBulk(postPaymentIntentsBulkRequest, expand, idempotencyKey, melioAccount, organizationId, userId, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Confirm batch of payment intents and produce payments based on the current configuration.
     * @summary Confirm a batch of Payment Intents
     * @param {PaymentIntentBatchParameters} paymentIntentBatchParameters Payment Intent Ids
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postPaymentIntentsPaymentIntentBatchConfirm(paymentIntentBatchParameters, expand, idempotencyKey, melioAccount, organizationId, userId, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postPaymentIntentsPaymentIntentBatchConfirm(paymentIntentBatchParameters, expand, idempotencyKey, melioAccount, organizationId, userId, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Confirm this Payment Intent and produce a Payment based on the current configuration.
     * @summary Confirm a Payment Intent
     * @param {string} id ID of the entity
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postPaymentIntentsPaymentIntentIdConfirm(id, expand, idempotencyKey, melioAccount, organizationId, userId, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postPaymentIntentsPaymentIntentIdConfirm(id, expand, idempotencyKey, melioAccount, organizationId, userId, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    }
  };
};
var PaymentIntentsApiClient = createApiFromFp(PaymentIntentsApiFp);
var PaymentIntentsApiFactory = function(configuration, basePath, axios2) {
  const localVarFp = PaymentIntentsApiFp(configuration);
  return {
    /**
     * Delete a Payment Intent.
     * @summary Delete a Payment Intent
     * @param {string} id ID of the entity
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deletePaymentIntentsPaymentIntentId(id, expand, idempotencyKey, melioAccount, organizationId, userId, options) {
      return localVarFp.deletePaymentIntentsPaymentIntentId(id, expand, idempotencyKey, melioAccount, organizationId, userId, options).then((request) => request(axios2, basePath));
    },
    /**
     * Retrieve all Payment Intents
     * @summary Retrieve all Payment Intents
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [search] Limit returned objects to those that satisfy the specified query. Query strings support logic and comparison against fields that you specify. See the method documentation to learn which fields can be included in your query, or [read more about query strings](https://docs.melio.com/docs/melio-data-api/getting-started#advanced_search).
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPaymentIntents(expand, search, melioAccount, organizationId, userId, options) {
      return localVarFp.getPaymentIntents(expand, search, melioAccount, organizationId, userId, options).then((request) => request(axios2, basePath));
    },
    /**
     * Retrieve a Payment Intent
     * @summary Retrieve a Payment Intent
     * @param {string} id ID of the entity
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPaymentIntentsPaymentIntentId(id, expand, melioAccount, organizationId, userId, options) {
      return localVarFp.getPaymentIntentsPaymentIntentId(id, expand, melioAccount, organizationId, userId, options).then((request) => request(axios2, basePath));
    },
    /**
     * Update multiple Payment Intents based on a provided list.
     * @summary Update multiple Payment Intents
     * @param {Array<PatchPaymentIntents>} [patchPaymentIntents] 
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchPaymentIntentsBulk(patchPaymentIntents, expand, idempotencyKey, melioAccount, organizationId, userId, options) {
      return localVarFp.patchPaymentIntentsBulk(patchPaymentIntents, expand, idempotencyKey, melioAccount, organizationId, userId, options).then((request) => request(axios2, basePath));
    },
    /**
     * Update an existing Payment Intent.  The request\'s body can be partial, and only provided fields will be overwritten. Set an optional field to `null` in order to remove its contents.
     * @summary Update a Payment Intent
     * @param {string} id ID of the entity
     * @param {PatchPaymentIntentsPaymentIntentIdRequest} [patchPaymentIntentsPaymentIntentIdRequest] 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchPaymentIntentsPaymentIntentId(id, patchPaymentIntentsPaymentIntentIdRequest, expand, idempotencyKey, melioAccount, organizationId, userId, options) {
      return localVarFp.patchPaymentIntentsPaymentIntentId(id, patchPaymentIntentsPaymentIntentIdRequest, expand, idempotencyKey, melioAccount, organizationId, userId, options).then((request) => request(axios2, basePath));
    },
    /**
     * Create a Payment Intent
     * @summary Create a Payment Intent
     * @param {PostPaymentIntentsRequest} [postPaymentIntentsRequest] 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postPaymentIntents(postPaymentIntentsRequest, expand, idempotencyKey, melioAccount, organizationId, userId, options) {
      return localVarFp.postPaymentIntents(postPaymentIntentsRequest, expand, idempotencyKey, melioAccount, organizationId, userId, options).then((request) => request(axios2, basePath));
    },
    /**
     * Create multiple Payment Intents based on a provided list.
     * @summary Create multiple Payment Intents
     * @param {PostPaymentIntentsBulkRequest} [postPaymentIntentsBulkRequest] 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postPaymentIntentsBulk(postPaymentIntentsBulkRequest, expand, idempotencyKey, melioAccount, organizationId, userId, options) {
      return localVarFp.postPaymentIntentsBulk(postPaymentIntentsBulkRequest, expand, idempotencyKey, melioAccount, organizationId, userId, options).then((request) => request(axios2, basePath));
    },
    /**
     * Confirm batch of payment intents and produce payments based on the current configuration.
     * @summary Confirm a batch of Payment Intents
     * @param {PaymentIntentBatchParameters} paymentIntentBatchParameters Payment Intent Ids
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postPaymentIntentsPaymentIntentBatchConfirm(paymentIntentBatchParameters, expand, idempotencyKey, melioAccount, organizationId, userId, options) {
      return localVarFp.postPaymentIntentsPaymentIntentBatchConfirm(paymentIntentBatchParameters, expand, idempotencyKey, melioAccount, organizationId, userId, options).then((request) => request(axios2, basePath));
    },
    /**
     * Confirm this Payment Intent and produce a Payment based on the current configuration.
     * @summary Confirm a Payment Intent
     * @param {string} id ID of the entity
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postPaymentIntentsPaymentIntentIdConfirm(id, expand, idempotencyKey, melioAccount, organizationId, userId, options) {
      return localVarFp.postPaymentIntentsPaymentIntentIdConfirm(id, expand, idempotencyKey, melioAccount, organizationId, userId, options).then((request) => request(axios2, basePath));
    }
  };
};
var PaymentIntentsApi = class extends BaseAPI {
  /**
   * Delete a Payment Intent.
   * @summary Delete a Payment Intent
   * @param {PaymentIntentsApiDeletePaymentIntentsPaymentIntentIdRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentIntentsApi
   */
  deletePaymentIntentsPaymentIntentId(requestParameters, options) {
    return PaymentIntentsApiFp(this.configuration).deletePaymentIntentsPaymentIntentId(requestParameters.id, requestParameters.expand, requestParameters.idempotencyKey, requestParameters.melioAccount, requestParameters.organizationId, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Retrieve all Payment Intents
   * @summary Retrieve all Payment Intents
   * @param {PaymentIntentsApiGetPaymentIntentsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentIntentsApi
   */
  getPaymentIntents(requestParameters = {}, options) {
    return PaymentIntentsApiFp(this.configuration).getPaymentIntents(requestParameters.expand, requestParameters.search, requestParameters.melioAccount, requestParameters.organizationId, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Retrieve a Payment Intent
   * @summary Retrieve a Payment Intent
   * @param {PaymentIntentsApiGetPaymentIntentsPaymentIntentIdRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentIntentsApi
   */
  getPaymentIntentsPaymentIntentId(requestParameters, options) {
    return PaymentIntentsApiFp(this.configuration).getPaymentIntentsPaymentIntentId(requestParameters.id, requestParameters.expand, requestParameters.melioAccount, requestParameters.organizationId, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Update multiple Payment Intents based on a provided list.
   * @summary Update multiple Payment Intents
   * @param {PaymentIntentsApiPatchPaymentIntentsBulkRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentIntentsApi
   */
  patchPaymentIntentsBulk(requestParameters = {}, options) {
    return PaymentIntentsApiFp(this.configuration).patchPaymentIntentsBulk(requestParameters.patchPaymentIntents, requestParameters.expand, requestParameters.idempotencyKey, requestParameters.melioAccount, requestParameters.organizationId, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Update an existing Payment Intent.  The request\'s body can be partial, and only provided fields will be overwritten. Set an optional field to `null` in order to remove its contents.
   * @summary Update a Payment Intent
   * @param {PaymentIntentsApiPatchPaymentIntentsPaymentIntentIdRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentIntentsApi
   */
  patchPaymentIntentsPaymentIntentId(requestParameters, options) {
    return PaymentIntentsApiFp(this.configuration).patchPaymentIntentsPaymentIntentId(requestParameters.id, requestParameters.patchPaymentIntentsPaymentIntentIdRequest, requestParameters.expand, requestParameters.idempotencyKey, requestParameters.melioAccount, requestParameters.organizationId, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Create a Payment Intent
   * @summary Create a Payment Intent
   * @param {PaymentIntentsApiPostPaymentIntentsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentIntentsApi
   */
  postPaymentIntents(requestParameters = {}, options) {
    return PaymentIntentsApiFp(this.configuration).postPaymentIntents(requestParameters.postPaymentIntentsRequest, requestParameters.expand, requestParameters.idempotencyKey, requestParameters.melioAccount, requestParameters.organizationId, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Create multiple Payment Intents based on a provided list.
   * @summary Create multiple Payment Intents
   * @param {PaymentIntentsApiPostPaymentIntentsBulkRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentIntentsApi
   */
  postPaymentIntentsBulk(requestParameters = {}, options) {
    return PaymentIntentsApiFp(this.configuration).postPaymentIntentsBulk(requestParameters.postPaymentIntentsBulkRequest, requestParameters.expand, requestParameters.idempotencyKey, requestParameters.melioAccount, requestParameters.organizationId, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Confirm batch of payment intents and produce payments based on the current configuration.
   * @summary Confirm a batch of Payment Intents
   * @param {PaymentIntentsApiPostPaymentIntentsPaymentIntentBatchConfirmRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentIntentsApi
   */
  postPaymentIntentsPaymentIntentBatchConfirm(requestParameters, options) {
    return PaymentIntentsApiFp(this.configuration).postPaymentIntentsPaymentIntentBatchConfirm(requestParameters.paymentIntentBatchParameters, requestParameters.expand, requestParameters.idempotencyKey, requestParameters.melioAccount, requestParameters.organizationId, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Confirm this Payment Intent and produce a Payment based on the current configuration.
   * @summary Confirm a Payment Intent
   * @param {PaymentIntentsApiPostPaymentIntentsPaymentIntentIdConfirmRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentIntentsApi
   */
  postPaymentIntentsPaymentIntentIdConfirm(requestParameters, options) {
    return PaymentIntentsApiFp(this.configuration).postPaymentIntentsPaymentIntentIdConfirm(requestParameters.id, requestParameters.expand, requestParameters.idempotencyKey, requestParameters.melioAccount, requestParameters.organizationId, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
  }
};
var PaymentIntentsApiInstance = createInstanceFromApiIClass(PaymentIntentsApi);
var PaymentIntentsFromBillApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * Create a Payment Intent from a Bill
     * @summary Create a Payment Intent from a Bill
     * @param {PostPaymentIntentsFromBillRequest} [postPaymentIntentsFromBillRequest] 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postPaymentIntentsFromBill: (_0, _1, _2, _3, _4, _5, ..._6) => __async(this, [_0, _1, _2, _3, _4, _5, ..._6], function* (postPaymentIntentsFromBillRequest, expand, idempotencyKey, melioAccount, organizationId, userId, options = {}) {
      const localVarPath = `/payment-intents/from-bill`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (expand !== void 0 && expand !== null) {
        localVarHeaderParameter["expand"] = String(JSON.stringify(expand));
      }
      if (idempotencyKey !== void 0 && idempotencyKey !== null) {
        localVarHeaderParameter["Idempotency-Key"] = String(idempotencyKey);
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      if (organizationId !== void 0 && organizationId !== null) {
        localVarHeaderParameter["Organization-id"] = String(organizationId);
      }
      if (userId !== void 0 && userId !== null) {
        localVarHeaderParameter["User-id"] = String(userId);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postPaymentIntentsFromBillRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Create multiple Payment Intents from bill
     * @summary Create multiple Payment Intents from bill
     * @param {PostPaymentIntentsFromBillBulkRequest} [postPaymentIntentsFromBillBulkRequest] 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postPaymentIntentsFromBillBulk: (_0, _1, _2, _3, _4, _5, ..._6) => __async(this, [_0, _1, _2, _3, _4, _5, ..._6], function* (postPaymentIntentsFromBillBulkRequest, expand, idempotencyKey, melioAccount, organizationId, userId, options = {}) {
      const localVarPath = `/payment-intents/from-bill/bulk`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (expand !== void 0 && expand !== null) {
        localVarHeaderParameter["expand"] = String(JSON.stringify(expand));
      }
      if (idempotencyKey !== void 0 && idempotencyKey !== null) {
        localVarHeaderParameter["Idempotency-Key"] = String(idempotencyKey);
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      if (organizationId !== void 0 && organizationId !== null) {
        localVarHeaderParameter["Organization-id"] = String(organizationId);
      }
      if (userId !== void 0 && userId !== null) {
        localVarHeaderParameter["User-id"] = String(userId);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postPaymentIntentsFromBillBulkRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    })
  };
};
var PaymentIntentsFromBillApiFp = function(configuration) {
  const localVarAxiosParamCreator = PaymentIntentsFromBillApiAxiosParamCreator(configuration);
  return {
    /**
     * Create a Payment Intent from a Bill
     * @summary Create a Payment Intent from a Bill
     * @param {PostPaymentIntentsFromBillRequest} [postPaymentIntentsFromBillRequest] 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postPaymentIntentsFromBill(postPaymentIntentsFromBillRequest, expand, idempotencyKey, melioAccount, organizationId, userId, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postPaymentIntentsFromBill(postPaymentIntentsFromBillRequest, expand, idempotencyKey, melioAccount, organizationId, userId, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Create multiple Payment Intents from bill
     * @summary Create multiple Payment Intents from bill
     * @param {PostPaymentIntentsFromBillBulkRequest} [postPaymentIntentsFromBillBulkRequest] 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postPaymentIntentsFromBillBulk(postPaymentIntentsFromBillBulkRequest, expand, idempotencyKey, melioAccount, organizationId, userId, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postPaymentIntentsFromBillBulk(postPaymentIntentsFromBillBulkRequest, expand, idempotencyKey, melioAccount, organizationId, userId, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    }
  };
};
var PaymentIntentsFromBillApiClient = createApiFromFp(PaymentIntentsFromBillApiFp);
var PaymentIntentsFromBillApiFactory = function(configuration, basePath, axios2) {
  const localVarFp = PaymentIntentsFromBillApiFp(configuration);
  return {
    /**
     * Create a Payment Intent from a Bill
     * @summary Create a Payment Intent from a Bill
     * @param {PostPaymentIntentsFromBillRequest} [postPaymentIntentsFromBillRequest] 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postPaymentIntentsFromBill(postPaymentIntentsFromBillRequest, expand, idempotencyKey, melioAccount, organizationId, userId, options) {
      return localVarFp.postPaymentIntentsFromBill(postPaymentIntentsFromBillRequest, expand, idempotencyKey, melioAccount, organizationId, userId, options).then((request) => request(axios2, basePath));
    },
    /**
     * Create multiple Payment Intents from bill
     * @summary Create multiple Payment Intents from bill
     * @param {PostPaymentIntentsFromBillBulkRequest} [postPaymentIntentsFromBillBulkRequest] 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postPaymentIntentsFromBillBulk(postPaymentIntentsFromBillBulkRequest, expand, idempotencyKey, melioAccount, organizationId, userId, options) {
      return localVarFp.postPaymentIntentsFromBillBulk(postPaymentIntentsFromBillBulkRequest, expand, idempotencyKey, melioAccount, organizationId, userId, options).then((request) => request(axios2, basePath));
    }
  };
};
var PaymentIntentsFromBillApi = class extends BaseAPI {
  /**
   * Create a Payment Intent from a Bill
   * @summary Create a Payment Intent from a Bill
   * @param {PaymentIntentsFromBillApiPostPaymentIntentsFromBillRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentIntentsFromBillApi
   */
  postPaymentIntentsFromBill(requestParameters = {}, options) {
    return PaymentIntentsFromBillApiFp(this.configuration).postPaymentIntentsFromBill(requestParameters.postPaymentIntentsFromBillRequest, requestParameters.expand, requestParameters.idempotencyKey, requestParameters.melioAccount, requestParameters.organizationId, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Create multiple Payment Intents from bill
   * @summary Create multiple Payment Intents from bill
   * @param {PaymentIntentsFromBillApiPostPaymentIntentsFromBillBulkRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentIntentsFromBillApi
   */
  postPaymentIntentsFromBillBulk(requestParameters = {}, options) {
    return PaymentIntentsFromBillApiFp(this.configuration).postPaymentIntentsFromBillBulk(requestParameters.postPaymentIntentsFromBillBulkRequest, requestParameters.expand, requestParameters.idempotencyKey, requestParameters.melioAccount, requestParameters.organizationId, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
  }
};
var PaymentIntentsFromBillApiInstance = createInstanceFromApiIClass(PaymentIntentsFromBillApi);
var PaymentIntentsFromPaymentApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * Create a Payment Intent from a Payment
     * @summary Create a Payment Intent from a Payment
     * @param {PostPaymentIntentsFromPaymentRequest} [postPaymentIntentsFromPaymentRequest] 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postPaymentIntentsFromPayment: (_0, _1, _2, _3, _4, _5, ..._6) => __async(this, [_0, _1, _2, _3, _4, _5, ..._6], function* (postPaymentIntentsFromPaymentRequest, expand, idempotencyKey, melioAccount, organizationId, userId, options = {}) {
      const localVarPath = `/payment-intents/from-payment`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (expand !== void 0 && expand !== null) {
        localVarHeaderParameter["expand"] = String(JSON.stringify(expand));
      }
      if (idempotencyKey !== void 0 && idempotencyKey !== null) {
        localVarHeaderParameter["Idempotency-Key"] = String(idempotencyKey);
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      if (organizationId !== void 0 && organizationId !== null) {
        localVarHeaderParameter["Organization-id"] = String(organizationId);
      }
      if (userId !== void 0 && userId !== null) {
        localVarHeaderParameter["User-id"] = String(userId);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postPaymentIntentsFromPaymentRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    })
  };
};
var PaymentIntentsFromPaymentApiFp = function(configuration) {
  const localVarAxiosParamCreator = PaymentIntentsFromPaymentApiAxiosParamCreator(configuration);
  return {
    /**
     * Create a Payment Intent from a Payment
     * @summary Create a Payment Intent from a Payment
     * @param {PostPaymentIntentsFromPaymentRequest} [postPaymentIntentsFromPaymentRequest] 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postPaymentIntentsFromPayment(postPaymentIntentsFromPaymentRequest, expand, idempotencyKey, melioAccount, organizationId, userId, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postPaymentIntentsFromPayment(postPaymentIntentsFromPaymentRequest, expand, idempotencyKey, melioAccount, organizationId, userId, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    }
  };
};
var PaymentIntentsFromPaymentApiClient = createApiFromFp(PaymentIntentsFromPaymentApiFp);
var PaymentIntentsFromPaymentApiFactory = function(configuration, basePath, axios2) {
  const localVarFp = PaymentIntentsFromPaymentApiFp(configuration);
  return {
    /**
     * Create a Payment Intent from a Payment
     * @summary Create a Payment Intent from a Payment
     * @param {PostPaymentIntentsFromPaymentRequest} [postPaymentIntentsFromPaymentRequest] 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postPaymentIntentsFromPayment(postPaymentIntentsFromPaymentRequest, expand, idempotencyKey, melioAccount, organizationId, userId, options) {
      return localVarFp.postPaymentIntentsFromPayment(postPaymentIntentsFromPaymentRequest, expand, idempotencyKey, melioAccount, organizationId, userId, options).then((request) => request(axios2, basePath));
    }
  };
};
var PaymentIntentsFromPaymentApi = class extends BaseAPI {
  /**
   * Create a Payment Intent from a Payment
   * @summary Create a Payment Intent from a Payment
   * @param {PaymentIntentsFromPaymentApiPostPaymentIntentsFromPaymentRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentIntentsFromPaymentApi
   */
  postPaymentIntentsFromPayment(requestParameters = {}, options) {
    return PaymentIntentsFromPaymentApiFp(this.configuration).postPaymentIntentsFromPayment(requestParameters.postPaymentIntentsFromPaymentRequest, requestParameters.expand, requestParameters.idempotencyKey, requestParameters.melioAccount, requestParameters.organizationId, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
  }
};
var PaymentIntentsFromPaymentApiInstance = createInstanceFromApiIClass(PaymentIntentsFromPaymentApi);
var PaymentRequestsApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * Retrieve all Payment Requests
     * @summary Retrieve all Payment Requests
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [search] Limit returned objects to those that satisfy the specified query. Query strings support logic and comparison against fields that you specify. See the method documentation to learn which fields can be included in your query, or [read more about query strings](https://docs.melio.com/docs/melio-data-api/getting-started#advanced_search).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPaymentRequests: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (expand, search, options = {}) {
      const localVarPath = `/payment-requests`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (expand !== void 0) {
        localVarQueryParameter["expand"] = expand;
      }
      if (search !== void 0) {
        localVarQueryParameter["search"] = search;
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Retrieve a Payment Request
     * @summary Retrieve a Payment Request
     * @param {string} id ID of the entity
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPaymentRequestsPaymentRequestId: (_0, _1, _2, ..._3) => __async(this, [_0, _1, _2, ..._3], function* (id, expand, melioAccount, options = {}) {
      assertParamExists("getPaymentRequestsPaymentRequestId", "id", id);
      const localVarPath = `/payment-requests/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (expand !== void 0) {
        localVarQueryParameter["expand"] = expand;
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Approve the given Payment Requests.
     * @summary Approve Payment Requests
     * @param {PostPaymentRequestsApproveBulkRequest} [postPaymentRequestsApproveBulkRequest] 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postPaymentRequestsApproveBulk: (_0, _1, _2, ..._3) => __async(this, [_0, _1, _2, ..._3], function* (postPaymentRequestsApproveBulkRequest, expand, melioAccount, options = {}) {
      const localVarPath = `/payment-requests/approve/bulk`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (expand !== void 0 && expand !== null) {
        localVarHeaderParameter["expand"] = String(JSON.stringify(expand));
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postPaymentRequestsApproveBulkRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Cancel the given Payment Requests.
     * @summary Cancel Payment Requests
     * @param {PostPaymentRequestsCancelBulkRequest} [postPaymentRequestsCancelBulkRequest] 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postPaymentRequestsCancelBulk: (_0, _1, _2, ..._3) => __async(this, [_0, _1, _2, ..._3], function* (postPaymentRequestsCancelBulkRequest, expand, melioAccount, options = {}) {
      const localVarPath = `/payment-requests/cancel/bulk`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (expand !== void 0 && expand !== null) {
        localVarHeaderParameter["expand"] = String(JSON.stringify(expand));
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postPaymentRequestsCancelBulkRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Approve the given Payment Request.
     * @summary Approve a Payment Request
     * @param {string} id ID of the entity
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    putPaymentRequestsPaymentRequestIdApprove: (_0, _1, _2, _3, ..._4) => __async(this, [_0, _1, _2, _3, ..._4], function* (id, expand, idempotencyKey, melioAccount, options = {}) {
      assertParamExists("putPaymentRequestsPaymentRequestIdApprove", "id", id);
      const localVarPath = `/payment-requests/{id}/approve`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (expand !== void 0 && expand !== null) {
        localVarHeaderParameter["expand"] = String(JSON.stringify(expand));
      }
      if (idempotencyKey !== void 0 && idempotencyKey !== null) {
        localVarHeaderParameter["Idempotency-Key"] = String(idempotencyKey);
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Cancel the given Payment Request.
     * @summary Cancel a Payment Request
     * @param {string} id ID of the entity
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    putPaymentRequestsPaymentRequestIdCancel: (_0, _1, _2, _3, ..._4) => __async(this, [_0, _1, _2, _3, ..._4], function* (id, expand, idempotencyKey, melioAccount, options = {}) {
      assertParamExists("putPaymentRequestsPaymentRequestIdCancel", "id", id);
      const localVarPath = `/payment-requests/{id}/cancel`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (expand !== void 0 && expand !== null) {
        localVarHeaderParameter["expand"] = String(JSON.stringify(expand));
      }
      if (idempotencyKey !== void 0 && idempotencyKey !== null) {
        localVarHeaderParameter["Idempotency-Key"] = String(idempotencyKey);
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    })
  };
};
var PaymentRequestsApiFp = function(configuration) {
  const localVarAxiosParamCreator = PaymentRequestsApiAxiosParamCreator(configuration);
  return {
    /**
     * Retrieve all Payment Requests
     * @summary Retrieve all Payment Requests
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [search] Limit returned objects to those that satisfy the specified query. Query strings support logic and comparison against fields that you specify. See the method documentation to learn which fields can be included in your query, or [read more about query strings](https://docs.melio.com/docs/melio-data-api/getting-started#advanced_search).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPaymentRequests(expand, search, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getPaymentRequests(expand, search, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Retrieve a Payment Request
     * @summary Retrieve a Payment Request
     * @param {string} id ID of the entity
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPaymentRequestsPaymentRequestId(id, expand, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getPaymentRequestsPaymentRequestId(id, expand, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Approve the given Payment Requests.
     * @summary Approve Payment Requests
     * @param {PostPaymentRequestsApproveBulkRequest} [postPaymentRequestsApproveBulkRequest] 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postPaymentRequestsApproveBulk(postPaymentRequestsApproveBulkRequest, expand, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postPaymentRequestsApproveBulk(postPaymentRequestsApproveBulkRequest, expand, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Cancel the given Payment Requests.
     * @summary Cancel Payment Requests
     * @param {PostPaymentRequestsCancelBulkRequest} [postPaymentRequestsCancelBulkRequest] 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postPaymentRequestsCancelBulk(postPaymentRequestsCancelBulkRequest, expand, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postPaymentRequestsCancelBulk(postPaymentRequestsCancelBulkRequest, expand, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Approve the given Payment Request.
     * @summary Approve a Payment Request
     * @param {string} id ID of the entity
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    putPaymentRequestsPaymentRequestIdApprove(id, expand, idempotencyKey, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.putPaymentRequestsPaymentRequestIdApprove(id, expand, idempotencyKey, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Cancel the given Payment Request.
     * @summary Cancel a Payment Request
     * @param {string} id ID of the entity
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    putPaymentRequestsPaymentRequestIdCancel(id, expand, idempotencyKey, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.putPaymentRequestsPaymentRequestIdCancel(id, expand, idempotencyKey, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    }
  };
};
var PaymentRequestsApiClient = createApiFromFp(PaymentRequestsApiFp);
var PaymentRequestsApiFactory = function(configuration, basePath, axios2) {
  const localVarFp = PaymentRequestsApiFp(configuration);
  return {
    /**
     * Retrieve all Payment Requests
     * @summary Retrieve all Payment Requests
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [search] Limit returned objects to those that satisfy the specified query. Query strings support logic and comparison against fields that you specify. See the method documentation to learn which fields can be included in your query, or [read more about query strings](https://docs.melio.com/docs/melio-data-api/getting-started#advanced_search).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPaymentRequests(expand, search, options) {
      return localVarFp.getPaymentRequests(expand, search, options).then((request) => request(axios2, basePath));
    },
    /**
     * Retrieve a Payment Request
     * @summary Retrieve a Payment Request
     * @param {string} id ID of the entity
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPaymentRequestsPaymentRequestId(id, expand, melioAccount, options) {
      return localVarFp.getPaymentRequestsPaymentRequestId(id, expand, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Approve the given Payment Requests.
     * @summary Approve Payment Requests
     * @param {PostPaymentRequestsApproveBulkRequest} [postPaymentRequestsApproveBulkRequest] 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postPaymentRequestsApproveBulk(postPaymentRequestsApproveBulkRequest, expand, melioAccount, options) {
      return localVarFp.postPaymentRequestsApproveBulk(postPaymentRequestsApproveBulkRequest, expand, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Cancel the given Payment Requests.
     * @summary Cancel Payment Requests
     * @param {PostPaymentRequestsCancelBulkRequest} [postPaymentRequestsCancelBulkRequest] 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postPaymentRequestsCancelBulk(postPaymentRequestsCancelBulkRequest, expand, melioAccount, options) {
      return localVarFp.postPaymentRequestsCancelBulk(postPaymentRequestsCancelBulkRequest, expand, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Approve the given Payment Request.
     * @summary Approve a Payment Request
     * @param {string} id ID of the entity
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    putPaymentRequestsPaymentRequestIdApprove(id, expand, idempotencyKey, melioAccount, options) {
      return localVarFp.putPaymentRequestsPaymentRequestIdApprove(id, expand, idempotencyKey, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Cancel the given Payment Request.
     * @summary Cancel a Payment Request
     * @param {string} id ID of the entity
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    putPaymentRequestsPaymentRequestIdCancel(id, expand, idempotencyKey, melioAccount, options) {
      return localVarFp.putPaymentRequestsPaymentRequestIdCancel(id, expand, idempotencyKey, melioAccount, options).then((request) => request(axios2, basePath));
    }
  };
};
var PaymentRequestsApi = class extends BaseAPI {
  /**
   * Retrieve all Payment Requests
   * @summary Retrieve all Payment Requests
   * @param {PaymentRequestsApiGetPaymentRequestsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentRequestsApi
   */
  getPaymentRequests(requestParameters = {}, options) {
    return PaymentRequestsApiFp(this.configuration).getPaymentRequests(requestParameters.expand, requestParameters.search, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Retrieve a Payment Request
   * @summary Retrieve a Payment Request
   * @param {PaymentRequestsApiGetPaymentRequestsPaymentRequestIdRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentRequestsApi
   */
  getPaymentRequestsPaymentRequestId(requestParameters, options) {
    return PaymentRequestsApiFp(this.configuration).getPaymentRequestsPaymentRequestId(requestParameters.id, requestParameters.expand, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Approve the given Payment Requests.
   * @summary Approve Payment Requests
   * @param {PaymentRequestsApiPostPaymentRequestsApproveBulkRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentRequestsApi
   */
  postPaymentRequestsApproveBulk(requestParameters = {}, options) {
    return PaymentRequestsApiFp(this.configuration).postPaymentRequestsApproveBulk(requestParameters.postPaymentRequestsApproveBulkRequest, requestParameters.expand, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Cancel the given Payment Requests.
   * @summary Cancel Payment Requests
   * @param {PaymentRequestsApiPostPaymentRequestsCancelBulkRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentRequestsApi
   */
  postPaymentRequestsCancelBulk(requestParameters = {}, options) {
    return PaymentRequestsApiFp(this.configuration).postPaymentRequestsCancelBulk(requestParameters.postPaymentRequestsCancelBulkRequest, requestParameters.expand, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Approve the given Payment Request.
   * @summary Approve a Payment Request
   * @param {PaymentRequestsApiPutPaymentRequestsPaymentRequestIdApproveRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentRequestsApi
   */
  putPaymentRequestsPaymentRequestIdApprove(requestParameters, options) {
    return PaymentRequestsApiFp(this.configuration).putPaymentRequestsPaymentRequestIdApprove(requestParameters.id, requestParameters.expand, requestParameters.idempotencyKey, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Cancel the given Payment Request.
   * @summary Cancel a Payment Request
   * @param {PaymentRequestsApiPutPaymentRequestsPaymentRequestIdCancelRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentRequestsApi
   */
  putPaymentRequestsPaymentRequestIdCancel(requestParameters, options) {
    return PaymentRequestsApiFp(this.configuration).putPaymentRequestsPaymentRequestIdCancel(requestParameters.id, requestParameters.expand, requestParameters.idempotencyKey, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
};
var PaymentRequestsApiInstance = createInstanceFromApiIClass(PaymentRequestsApi);
var PaymentsApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * Cancel a Payment and delete it from the system.  <!-- theme: info --> > The `Melio-Account` header is required when using API Key security. 
     * @summary Delete a Payment
     * @param {string} id ID of the entity
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deletePaymentsPaymentId: (_0, _1, _2, ..._3) => __async(this, [_0, _1, _2, ..._3], function* (id, organizationId, userId, options = {}) {
      assertParamExists("deletePaymentsPaymentId", "id", id);
      const localVarPath = `/payments/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "DELETE" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (organizationId !== void 0 && organizationId !== null) {
        localVarHeaderParameter["Organization-id"] = String(organizationId);
      }
      if (userId !== void 0 && userId !== null) {
        localVarHeaderParameter["User-id"] = String(userId);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * This operation gets the approval decisions of the Payment
     * @summary get the approval decisions of the payment
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPaymentApprovalDecisions: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (id, melioAccount, options = {}) {
      assertParamExists("getPaymentApprovalDecisions", "id", id);
      const localVarPath = `/payments/{id}/approval-decisions`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * This operation gets the confirmation of the Payment
     * @summary gets the payment confirmation document
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPaymentConfirmationDocument: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (id, melioAccount, options = {}) {
      assertParamExists("getPaymentConfirmationDocument", "id", id);
      const localVarPath = `/payments/{id}/confirmation`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Payment estimated time of arrival dates calculator
     * @summary Payment estimated time of arrival dates calculator
     * @param {Array<string>} paymentIds 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPaymentEtaDates: (_0, ..._1) => __async(this, [_0, ..._1], function* (paymentIds, options = {}) {
      assertParamExists("getPaymentEtaDates", "paymentIds", paymentIds);
      const localVarPath = `/payments/eta-dates`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (paymentIds) {
        localVarQueryParameter["paymentIds"] = paymentIds;
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * This operation gets the pending approvers of the Payment
     * @summary get the pending approvers of the payment
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPaymentPendingApprovers: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (id, melioAccount, options = {}) {
      assertParamExists("getPaymentPendingApprovers", "id", id);
      const localVarPath = `/payments/{id}/pending-approvers`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * This operation gets the receipt of the Payment
     * @summary get the receipt of the payment
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPaymentReceipt: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (id, melioAccount, options = {}) {
      assertParamExists("getPaymentReceipt", "id", id);
      const localVarPath = `/payments/{id}/receipt`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * This operation gets the risk request of files of the Payment
     * @summary get the risk request of the payment for files
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPaymentRequiredDocuments: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (id, melioAccount, options = {}) {
      assertParamExists("getPaymentRequiredDocuments", "id", id);
      const localVarPath = `/payments/{id}/required-documents`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * This operation gets the receipt of the Payment that the vendor paid
     * @summary get the receipt of the payment paid by vendor
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPaymentVendorReceipt: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (id, melioAccount, options = {}) {
      assertParamExists("getPaymentVendorReceipt", "id", id);
      const localVarPath = `/payments/{id}/vendor-receipt`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Retrieve all Payment objects for the current Account with this partner. Payments can have any status.  <!-- theme: info --> > The `Melio-Account` header is required when using API Key security.  [`searchTerm` parameter searches](https://docs.melio.com/docs/melio-data-api/getting-started#simple_search) are checked against the following fields: - `vendor.name` - `amount` - `id` - `bills.invoice.number`  [`search` parameter searches](https://docs.melio.com/docs/melio-data-api/getting-started#advanced_search) can be matched against the following result fields: - `vendor.name` - `vendor.contact.name` - `vendor.id` - `paymentIntent.id` - `payment.status` - `payment.approvalDecisionStatus` - `bill.balance` - `bill.status` - `payment.id` - `bill.id` - `payment.collectStatus` - `payment.fundingSourceId` 
     * @summary Retrieve all Payments for this account
     * @param {string} [paymentIntentId] 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [searchTerm] Limit returned objects to those that contain the specified search string. Search is a case-insensitive, substring match against a subset of fields in the object. See the method documentation to learn which fields can be matched by the &#x60;searchTerm&#x60; value. [Read more](https://docs.melio.com/docs/melio-data-api/getting-started#simple_search) 
     * @param {string} [search] Limit returned objects to those that satisfy the specified query. Query strings support logic and comparison against fields that you specify. See the method documentation to learn which fields can be included in your query, or [read more about query strings](https://docs.melio.com/docs/melio-data-api/getting-started#advanced_search).
     * @param {Array<PaymentsSortQueryParam>} [sort] Sort query parameter - sort data by specified entity fields
     * @param {number} [limit] A limit on the number of records to be returned.
     * @param {PaginationCursor} [cursor] Used to page through page through results when the &#x60;totalCount&#x60; is more than the current set of results. To page, specify \&quot;cursor[prev]&#x3D;_&lt;prev_token&gt;_\&quot; or \&quot;cursor[next]&#x3D;_&lt;next_token&gt;_\&quot; as a URL parameter. 
     * @param {boolean} [pendingCurrentUserApproval] If true, show only pending payments that require approval by the current user. If false, do not filter by approval requirements.
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPayments: (_0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, ..._11) => __async(this, [_0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, ..._11], function* (paymentIntentId, melioAccount, expand, searchTerm, search, sort, limit, cursor, pendingCurrentUserApproval, organizationId, userId, options = {}) {
      const localVarPath = `/payments`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (paymentIntentId !== void 0) {
        localVarQueryParameter["paymentIntentId"] = paymentIntentId;
      }
      if (expand !== void 0) {
        localVarQueryParameter["expand"] = expand;
      }
      if (searchTerm !== void 0) {
        localVarQueryParameter["searchTerm"] = searchTerm;
      }
      if (search !== void 0) {
        localVarQueryParameter["search"] = search;
      }
      if (sort) {
        localVarQueryParameter["sort"] = sort;
      }
      if (limit !== void 0) {
        localVarQueryParameter["limit"] = limit;
      }
      if (cursor !== void 0) {
        localVarQueryParameter["cursor"] = cursor;
      }
      if (pendingCurrentUserApproval !== void 0) {
        localVarQueryParameter["pendingCurrentUserApproval"] = pendingCurrentUserApproval;
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      if (organizationId !== void 0 && organizationId !== null) {
        localVarHeaderParameter["Organization-id"] = String(organizationId);
      }
      if (userId !== void 0 && userId !== null) {
        localVarHeaderParameter["User-id"] = String(userId);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Retrieve a Payment using its ID.
     * @summary Retrieve a Payment
     * @param {string} id ID of the entity
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPaymentsPaymentId: (_0, _1, _2, ..._3) => __async(this, [_0, _1, _2, ..._3], function* (id, expand, melioAccount, options = {}) {
      assertParamExists("getPaymentsPaymentId", "id", id);
      const localVarPath = `/payments/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (expand !== void 0) {
        localVarQueryParameter["expand"] = expand;
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Attach files to documents request
     * @summary Attach files to documents request
     * @param {string} requestId 
     * @param {PaymentAttachFilesRequest} [paymentAttachFilesRequest] 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postAttachFilesRequiredDocuments: (_0, _1, _2, ..._3) => __async(this, [_0, _1, _2, ..._3], function* (requestId, paymentAttachFilesRequest, melioAccount, options = {}) {
      assertParamExists("postAttachFilesRequiredDocuments", "requestId", requestId);
      const localVarPath = `/payments/required-documents/{requestId}`.replace(`{${"requestId"}}`, encodeURIComponent(String(requestId)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(paymentAttachFilesRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * This operation creates fee payment
     * @summary create fee payment by payment details
     * @param {CreateFeePaymentParameters} createFeePaymentParameters create payment parameters
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postFeePayment: (_0, _1, _2, ..._3) => __async(this, [_0, _1, _2, ..._3], function* (createFeePaymentParameters, organizationId, userId, options = {}) {
      assertParamExists("postFeePayment", "createFeePaymentParameters", createFeePaymentParameters);
      const localVarPath = `/fee-payments`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (organizationId !== void 0 && organizationId !== null) {
        localVarHeaderParameter["Organization-id"] = String(organizationId);
      }
      if (userId !== void 0 && userId !== null) {
        localVarHeaderParameter["User-id"] = String(userId);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(createFeePaymentParameters, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * This operation get payment details and create payment
     * @summary create payment by payment details
     * @param {CreatePaymentParameters} createPaymentParameters create payment parameters
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postPayment: (_0, _1, _2, ..._3) => __async(this, [_0, _1, _2, ..._3], function* (createPaymentParameters, organizationId, userId, options = {}) {
      assertParamExists("postPayment", "createPaymentParameters", createPaymentParameters);
      const localVarPath = `/payments`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (organizationId !== void 0 && organizationId !== null) {
        localVarHeaderParameter["Organization-id"] = String(organizationId);
      }
      if (userId !== void 0 && userId !== null) {
        localVarHeaderParameter["User-id"] = String(userId);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(createPaymentParameters, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * This operation calculates the fees for a Payment
     * @summary get the calculated fee for payment
     * @param {PaymentFeeCalculationParameters} paymentFeeCalculationParameters payment overwrite parameters
     * @param {string} id ID of the entity
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postPaymentCalculateFee: (_0, _1, _2, _3, ..._4) => __async(this, [_0, _1, _2, _3, ..._4], function* (paymentFeeCalculationParameters, id, idempotencyKey, melioAccount, options = {}) {
      assertParamExists("postPaymentCalculateFee", "paymentFeeCalculationParameters", paymentFeeCalculationParameters);
      assertParamExists("postPaymentCalculateFee", "id", id);
      const localVarPath = `/payments/{id}/calculate-fee`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (idempotencyKey !== void 0 && idempotencyKey !== null) {
        localVarHeaderParameter["Idempotency-Key"] = String(idempotencyKey);
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(paymentFeeCalculationParameters, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Create an approval decision for existing Payments.
     * @summary Create multiple approval decisions for payments
     * @param {PostPaymentsBatchApprovalDecisionRequest | PostPaymentsBatchApprovalDecisionV2Request} [postPaymentsBatchApprovalDecisionRequestPostPaymentsBatchApprovalDecisionV2Request] 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postPaymentsBatchApprovalDecision: (_0, _1, _2, _3, _4, _5, ..._6) => __async(this, [_0, _1, _2, _3, _4, _5, ..._6], function* (postPaymentsBatchApprovalDecisionRequestPostPaymentsBatchApprovalDecisionV2Request, expand, idempotencyKey, melioAccount, organizationId, userId, options = {}) {
      const localVarPath = `/payments/batch-approval-decision`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (expand !== void 0 && expand !== null) {
        localVarHeaderParameter["expand"] = String(JSON.stringify(expand));
      }
      if (idempotencyKey !== void 0 && idempotencyKey !== null) {
        localVarHeaderParameter["Idempotency-Key"] = String(idempotencyKey);
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      if (organizationId !== void 0 && organizationId !== null) {
        localVarHeaderParameter["Organization-id"] = String(organizationId);
      }
      if (userId !== void 0 && userId !== null) {
        localVarHeaderParameter["User-id"] = String(userId);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postPaymentsBatchApprovalDecisionRequestPostPaymentsBatchApprovalDecisionV2Request, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * 
     * @summary delete payments
     * @param {PostPaymentsBatchDeleteRequest} [postPaymentsBatchDeleteRequest] 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postPaymentsBatchDelete: (_0, _1, _2, _3, ..._4) => __async(this, [_0, _1, _2, _3, ..._4], function* (postPaymentsBatchDeleteRequest, melioAccount, organizationId, userId, options = {}) {
      const localVarPath = `/payments/batch-delete`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      if (organizationId !== void 0 && organizationId !== null) {
        localVarHeaderParameter["Organization-id"] = String(organizationId);
      }
      if (userId !== void 0 && userId !== null) {
        localVarHeaderParameter["User-id"] = String(userId);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postPaymentsBatchDeleteRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Create multiple Payments based on a provided list.
     * @summary Create multiple Payments
     * @param {CreatePaymentsBulkRequestParameters} [createPaymentsBulkRequestParameters] 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postPaymentsBulk: (_0, _1, _2, _3, ..._4) => __async(this, [_0, _1, _2, _3, ..._4], function* (createPaymentsBulkRequestParameters, expand, idempotencyKey, melioAccount, options = {}) {
      const localVarPath = `/payments/bulk`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (expand !== void 0 && expand !== null) {
        localVarHeaderParameter["expand"] = String(JSON.stringify(expand));
      }
      if (idempotencyKey !== void 0 && idempotencyKey !== null) {
        localVarHeaderParameter["Idempotency-Key"] = String(idempotencyKey);
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(createPaymentsBulkRequestParameters, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Cancels a payment.
     * @summary Cancel a payment
     * @param {string} id ID of the entity
     * @param {PostPaymentsPaymentIdCancelRequest} [postPaymentsPaymentIdCancelRequest] 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postPaymentsPaymentIdCancel: (_0, _1, _2, _3, ..._4) => __async(this, [_0, _1, _2, _3, ..._4], function* (id, postPaymentsPaymentIdCancelRequest, expand, melioAccount, options = {}) {
      assertParamExists("postPaymentsPaymentIdCancel", "id", id);
      const localVarPath = `/payments/{id}/cancel`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (expand !== void 0 && expand !== null) {
        localVarHeaderParameter["expand"] = String(JSON.stringify(expand));
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postPaymentsPaymentIdCancelRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Mark as paid existing Failed Payment. The request\'s body can be partial, and only provided fields will be overwritten. Set an optional field to `null` in order to remove its contents.
     * @summary create a mark as paid payment
     * @param {string} id ID of the entity
     * @param {PostPaymentsPaymentIdMarkAsPaidRequest} [postPaymentsPaymentIdMarkAsPaidRequest] 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postPaymentsPaymentIdMarkAsPaid: (_0, _1, _2, _3, ..._4) => __async(this, [_0, _1, _2, _3, ..._4], function* (id, postPaymentsPaymentIdMarkAsPaidRequest, expand, melioAccount, options = {}) {
      assertParamExists("postPaymentsPaymentIdMarkAsPaid", "id", id);
      const localVarPath = `/payments/{id}/mark-as-paid`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (expand !== void 0 && expand !== null) {
        localVarHeaderParameter["expand"] = String(JSON.stringify(expand));
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postPaymentsPaymentIdMarkAsPaidRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * This operation get payment details and create a test payment from a test bill
     * @summary create a test payment by payment details
     * @param {CreateTestPaymentParameters} createTestPaymentParameters create payment parameters
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postTestPayment: (_0, _1, _2, ..._3) => __async(this, [_0, _1, _2, ..._3], function* (createTestPaymentParameters, organizationId, userId, options = {}) {
      assertParamExists("postTestPayment", "createTestPaymentParameters", createTestPaymentParameters);
      const localVarPath = `/payments/test`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (organizationId !== void 0 && organizationId !== null) {
        localVarHeaderParameter["Organization-id"] = String(organizationId);
      }
      if (userId !== void 0 && userId !== null) {
        localVarHeaderParameter["User-id"] = String(userId);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(createTestPaymentParameters, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Refund failed payment.
     * @summary Refund failed payment
     * @param {string} paymentId 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    refundPayment: (_0, _1, _2, _3, ..._4) => __async(this, [_0, _1, _2, _3, ..._4], function* (paymentId, idempotencyKey, melioAccount, expand, options = {}) {
      assertParamExists("refundPayment", "paymentId", paymentId);
      const localVarPath = `/payments/{paymentId}/refund`.replace(`{${"paymentId"}}`, encodeURIComponent(String(paymentId)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (expand !== void 0) {
        localVarQueryParameter["expand"] = expand;
      }
      if (idempotencyKey !== void 0 && idempotencyKey !== null) {
        localVarHeaderParameter["Idempotency-Key"] = String(idempotencyKey);
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Retry to collect  a payment, possibly passing in new details to update it with them before.
     * @summary Retry to collect a payment with new details
     * @param {string} paymentId 
     * @param {RetryPaymentRequest} [retryPaymentRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    retryCollectPaymentWithDetails: (_0, _1, _2, _3, ..._4) => __async(this, [_0, _1, _2, _3, ..._4], function* (paymentId, retryPaymentRequest, idempotencyKey, melioAccount, options = {}) {
      assertParamExists("retryCollectPaymentWithDetails", "paymentId", paymentId);
      const localVarPath = `/payments/{paymentId}/retryCollect`.replace(`{${"paymentId"}}`, encodeURIComponent(String(paymentId)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (idempotencyKey !== void 0 && idempotencyKey !== null) {
        localVarHeaderParameter["Idempotency-Key"] = String(idempotencyKey);
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(retryPaymentRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Retry to deliver a payment, possibly passing in new details to update it with them before.
     * @summary Retry to deliver a payment with new details
     * @param {string} paymentId 
     * @param {RetryPaymentRequest} [retryPaymentRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    retryDeliverPaymentWithDetails: (_0, _1, _2, _3, ..._4) => __async(this, [_0, _1, _2, _3, ..._4], function* (paymentId, retryPaymentRequest, idempotencyKey, melioAccount, options = {}) {
      assertParamExists("retryDeliverPaymentWithDetails", "paymentId", paymentId);
      const localVarPath = `/payments/{paymentId}/retryDeliver`.replace(`{${"paymentId"}}`, encodeURIComponent(String(paymentId)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (idempotencyKey !== void 0 && idempotencyKey !== null) {
        localVarHeaderParameter["Idempotency-Key"] = String(idempotencyKey);
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(retryPaymentRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Retry a payment, possibly passing in new details to update it with them before.
     * @summary Retry a payment with new details
     * @param {string} paymentId 
     * @param {RetryPaymentRequest} [retryPaymentRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    retryPaymentWithDetails: (_0, _1, _2, _3, _4, _5, ..._6) => __async(this, [_0, _1, _2, _3, _4, _5, ..._6], function* (paymentId, retryPaymentRequest, idempotencyKey, melioAccount, organizationId, userId, options = {}) {
      assertParamExists("retryPaymentWithDetails", "paymentId", paymentId);
      const localVarPath = `/payments/{paymentId}/retry`.replace(`{${"paymentId"}}`, encodeURIComponent(String(paymentId)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (idempotencyKey !== void 0 && idempotencyKey !== null) {
        localVarHeaderParameter["Idempotency-Key"] = String(idempotencyKey);
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      if (organizationId !== void 0 && organizationId !== null) {
        localVarHeaderParameter["Organization-id"] = String(organizationId);
      }
      if (userId !== void 0 && userId !== null) {
        localVarHeaderParameter["User-id"] = String(userId);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(retryPaymentRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Update Payment meta data.
     * @summary Update a Payment meta data
     * @param {string} id ID of the entity
     * @param {UpdatePaymentMetaDataPayload} [updatePaymentMetaDataPayload] 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updatePaymentsMetaDataPaymentId: (_0, _1, _2, _3, _4, _5, _6, ..._7) => __async(this, [_0, _1, _2, _3, _4, _5, _6, ..._7], function* (id, updatePaymentMetaDataPayload, expand, idempotencyKey, melioAccount, organizationId, userId, options = {}) {
      assertParamExists("updatePaymentsMetaDataPaymentId", "id", id);
      const localVarPath = `/payments-meta-data/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "PATCH" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (expand !== void 0 && expand !== null) {
        localVarHeaderParameter["expand"] = String(JSON.stringify(expand));
      }
      if (idempotencyKey !== void 0 && idempotencyKey !== null) {
        localVarHeaderParameter["Idempotency-Key"] = String(idempotencyKey);
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      if (organizationId !== void 0 && organizationId !== null) {
        localVarHeaderParameter["Organization-id"] = String(organizationId);
      }
      if (userId !== void 0 && userId !== null) {
        localVarHeaderParameter["User-id"] = String(userId);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(updatePaymentMetaDataPayload, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Update a Payment.
     * @summary Update a Payment
     * @param {string} id ID of the entity
     * @param {UpdatePaymentPayload} [updatePaymentPayload] 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updatePaymentsPaymentId: (_0, _1, _2, _3, _4, ..._5) => __async(this, [_0, _1, _2, _3, _4, ..._5], function* (id, updatePaymentPayload, expand, idempotencyKey, melioAccount, options = {}) {
      assertParamExists("updatePaymentsPaymentId", "id", id);
      const localVarPath = `/payments/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "PATCH" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (expand !== void 0 && expand !== null) {
        localVarHeaderParameter["expand"] = String(JSON.stringify(expand));
      }
      if (idempotencyKey !== void 0 && idempotencyKey !== null) {
        localVarHeaderParameter["Idempotency-Key"] = String(idempotencyKey);
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(updatePaymentPayload, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Void and refund undeposited check.
     * @summary Void and refund payment
     * @param {string} paymentId 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    voidAndRefundPayment: (_0, _1, _2, _3, ..._4) => __async(this, [_0, _1, _2, _3, ..._4], function* (paymentId, idempotencyKey, melioAccount, expand, options = {}) {
      assertParamExists("voidAndRefundPayment", "paymentId", paymentId);
      const localVarPath = `/payments/{paymentId}/void-and-refund`.replace(`{${"paymentId"}}`, encodeURIComponent(String(paymentId)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (expand !== void 0) {
        localVarQueryParameter["expand"] = expand;
      }
      if (idempotencyKey !== void 0 && idempotencyKey !== null) {
        localVarHeaderParameter["Idempotency-Key"] = String(idempotencyKey);
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Void and resend undeposited check.
     * @summary Void and resend payment
     * @param {string} paymentId 
     * @param {VoidAndResendPaymentRequest} [voidAndResendPaymentRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    voidAndResendPayment: (_0, _1, _2, _3, _4, ..._5) => __async(this, [_0, _1, _2, _3, _4, ..._5], function* (paymentId, voidAndResendPaymentRequest, idempotencyKey, melioAccount, expand, options = {}) {
      assertParamExists("voidAndResendPayment", "paymentId", paymentId);
      const localVarPath = `/payments/{paymentId}/void-and-resend`.replace(`{${"paymentId"}}`, encodeURIComponent(String(paymentId)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (expand !== void 0) {
        localVarQueryParameter["expand"] = expand;
      }
      if (idempotencyKey !== void 0 && idempotencyKey !== null) {
        localVarHeaderParameter["Idempotency-Key"] = String(idempotencyKey);
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(voidAndResendPaymentRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    })
  };
};
var PaymentsApiFp = function(configuration) {
  const localVarAxiosParamCreator = PaymentsApiAxiosParamCreator(configuration);
  return {
    /**
     * Cancel a Payment and delete it from the system.  <!-- theme: info --> > The `Melio-Account` header is required when using API Key security. 
     * @summary Delete a Payment
     * @param {string} id ID of the entity
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deletePaymentsPaymentId(id, organizationId, userId, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.deletePaymentsPaymentId(id, organizationId, userId, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * This operation gets the approval decisions of the Payment
     * @summary get the approval decisions of the payment
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPaymentApprovalDecisions(id, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getPaymentApprovalDecisions(id, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * This operation gets the confirmation of the Payment
     * @summary gets the payment confirmation document
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPaymentConfirmationDocument(id, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getPaymentConfirmationDocument(id, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Payment estimated time of arrival dates calculator
     * @summary Payment estimated time of arrival dates calculator
     * @param {Array<string>} paymentIds 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPaymentEtaDates(paymentIds, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getPaymentEtaDates(paymentIds, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * This operation gets the pending approvers of the Payment
     * @summary get the pending approvers of the payment
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPaymentPendingApprovers(id, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getPaymentPendingApprovers(id, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * This operation gets the receipt of the Payment
     * @summary get the receipt of the payment
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPaymentReceipt(id, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getPaymentReceipt(id, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * This operation gets the risk request of files of the Payment
     * @summary get the risk request of the payment for files
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPaymentRequiredDocuments(id, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getPaymentRequiredDocuments(id, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * This operation gets the receipt of the Payment that the vendor paid
     * @summary get the receipt of the payment paid by vendor
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPaymentVendorReceipt(id, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getPaymentVendorReceipt(id, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Retrieve all Payment objects for the current Account with this partner. Payments can have any status.  <!-- theme: info --> > The `Melio-Account` header is required when using API Key security.  [`searchTerm` parameter searches](https://docs.melio.com/docs/melio-data-api/getting-started#simple_search) are checked against the following fields: - `vendor.name` - `amount` - `id` - `bills.invoice.number`  [`search` parameter searches](https://docs.melio.com/docs/melio-data-api/getting-started#advanced_search) can be matched against the following result fields: - `vendor.name` - `vendor.contact.name` - `vendor.id` - `paymentIntent.id` - `payment.status` - `payment.approvalDecisionStatus` - `bill.balance` - `bill.status` - `payment.id` - `bill.id` - `payment.collectStatus` - `payment.fundingSourceId` 
     * @summary Retrieve all Payments for this account
     * @param {string} [paymentIntentId] 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [searchTerm] Limit returned objects to those that contain the specified search string. Search is a case-insensitive, substring match against a subset of fields in the object. See the method documentation to learn which fields can be matched by the &#x60;searchTerm&#x60; value. [Read more](https://docs.melio.com/docs/melio-data-api/getting-started#simple_search) 
     * @param {string} [search] Limit returned objects to those that satisfy the specified query. Query strings support logic and comparison against fields that you specify. See the method documentation to learn which fields can be included in your query, or [read more about query strings](https://docs.melio.com/docs/melio-data-api/getting-started#advanced_search).
     * @param {Array<PaymentsSortQueryParam>} [sort] Sort query parameter - sort data by specified entity fields
     * @param {number} [limit] A limit on the number of records to be returned.
     * @param {PaginationCursor} [cursor] Used to page through page through results when the &#x60;totalCount&#x60; is more than the current set of results. To page, specify \&quot;cursor[prev]&#x3D;_&lt;prev_token&gt;_\&quot; or \&quot;cursor[next]&#x3D;_&lt;next_token&gt;_\&quot; as a URL parameter. 
     * @param {boolean} [pendingCurrentUserApproval] If true, show only pending payments that require approval by the current user. If false, do not filter by approval requirements.
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPayments(paymentIntentId, melioAccount, expand, searchTerm, search, sort, limit, cursor, pendingCurrentUserApproval, organizationId, userId, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getPayments(paymentIntentId, melioAccount, expand, searchTerm, search, sort, limit, cursor, pendingCurrentUserApproval, organizationId, userId, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Retrieve a Payment using its ID.
     * @summary Retrieve a Payment
     * @param {string} id ID of the entity
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPaymentsPaymentId(id, expand, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getPaymentsPaymentId(id, expand, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Attach files to documents request
     * @summary Attach files to documents request
     * @param {string} requestId 
     * @param {PaymentAttachFilesRequest} [paymentAttachFilesRequest] 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postAttachFilesRequiredDocuments(requestId, paymentAttachFilesRequest, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postAttachFilesRequiredDocuments(requestId, paymentAttachFilesRequest, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * This operation creates fee payment
     * @summary create fee payment by payment details
     * @param {CreateFeePaymentParameters} createFeePaymentParameters create payment parameters
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postFeePayment(createFeePaymentParameters, organizationId, userId, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postFeePayment(createFeePaymentParameters, organizationId, userId, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * This operation get payment details and create payment
     * @summary create payment by payment details
     * @param {CreatePaymentParameters} createPaymentParameters create payment parameters
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postPayment(createPaymentParameters, organizationId, userId, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postPayment(createPaymentParameters, organizationId, userId, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * This operation calculates the fees for a Payment
     * @summary get the calculated fee for payment
     * @param {PaymentFeeCalculationParameters} paymentFeeCalculationParameters payment overwrite parameters
     * @param {string} id ID of the entity
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postPaymentCalculateFee(paymentFeeCalculationParameters, id, idempotencyKey, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postPaymentCalculateFee(paymentFeeCalculationParameters, id, idempotencyKey, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Create an approval decision for existing Payments.
     * @summary Create multiple approval decisions for payments
     * @param {PostPaymentsBatchApprovalDecisionRequest | PostPaymentsBatchApprovalDecisionV2Request} [postPaymentsBatchApprovalDecisionRequestPostPaymentsBatchApprovalDecisionV2Request] 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postPaymentsBatchApprovalDecision(postPaymentsBatchApprovalDecisionRequestPostPaymentsBatchApprovalDecisionV2Request, expand, idempotencyKey, melioAccount, organizationId, userId, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postPaymentsBatchApprovalDecision(postPaymentsBatchApprovalDecisionRequestPostPaymentsBatchApprovalDecisionV2Request, expand, idempotencyKey, melioAccount, organizationId, userId, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * 
     * @summary delete payments
     * @param {PostPaymentsBatchDeleteRequest} [postPaymentsBatchDeleteRequest] 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postPaymentsBatchDelete(postPaymentsBatchDeleteRequest, melioAccount, organizationId, userId, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postPaymentsBatchDelete(postPaymentsBatchDeleteRequest, melioAccount, organizationId, userId, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Create multiple Payments based on a provided list.
     * @summary Create multiple Payments
     * @param {CreatePaymentsBulkRequestParameters} [createPaymentsBulkRequestParameters] 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postPaymentsBulk(createPaymentsBulkRequestParameters, expand, idempotencyKey, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postPaymentsBulk(createPaymentsBulkRequestParameters, expand, idempotencyKey, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Cancels a payment.
     * @summary Cancel a payment
     * @param {string} id ID of the entity
     * @param {PostPaymentsPaymentIdCancelRequest} [postPaymentsPaymentIdCancelRequest] 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postPaymentsPaymentIdCancel(id, postPaymentsPaymentIdCancelRequest, expand, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postPaymentsPaymentIdCancel(id, postPaymentsPaymentIdCancelRequest, expand, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Mark as paid existing Failed Payment. The request\'s body can be partial, and only provided fields will be overwritten. Set an optional field to `null` in order to remove its contents.
     * @summary create a mark as paid payment
     * @param {string} id ID of the entity
     * @param {PostPaymentsPaymentIdMarkAsPaidRequest} [postPaymentsPaymentIdMarkAsPaidRequest] 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postPaymentsPaymentIdMarkAsPaid(id, postPaymentsPaymentIdMarkAsPaidRequest, expand, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postPaymentsPaymentIdMarkAsPaid(id, postPaymentsPaymentIdMarkAsPaidRequest, expand, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * This operation get payment details and create a test payment from a test bill
     * @summary create a test payment by payment details
     * @param {CreateTestPaymentParameters} createTestPaymentParameters create payment parameters
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postTestPayment(createTestPaymentParameters, organizationId, userId, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postTestPayment(createTestPaymentParameters, organizationId, userId, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Refund failed payment.
     * @summary Refund failed payment
     * @param {string} paymentId 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    refundPayment(paymentId, idempotencyKey, melioAccount, expand, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.refundPayment(paymentId, idempotencyKey, melioAccount, expand, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Retry to collect  a payment, possibly passing in new details to update it with them before.
     * @summary Retry to collect a payment with new details
     * @param {string} paymentId 
     * @param {RetryPaymentRequest} [retryPaymentRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    retryCollectPaymentWithDetails(paymentId, retryPaymentRequest, idempotencyKey, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.retryCollectPaymentWithDetails(paymentId, retryPaymentRequest, idempotencyKey, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Retry to deliver a payment, possibly passing in new details to update it with them before.
     * @summary Retry to deliver a payment with new details
     * @param {string} paymentId 
     * @param {RetryPaymentRequest} [retryPaymentRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    retryDeliverPaymentWithDetails(paymentId, retryPaymentRequest, idempotencyKey, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.retryDeliverPaymentWithDetails(paymentId, retryPaymentRequest, idempotencyKey, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Retry a payment, possibly passing in new details to update it with them before.
     * @summary Retry a payment with new details
     * @param {string} paymentId 
     * @param {RetryPaymentRequest} [retryPaymentRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    retryPaymentWithDetails(paymentId, retryPaymentRequest, idempotencyKey, melioAccount, organizationId, userId, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.retryPaymentWithDetails(paymentId, retryPaymentRequest, idempotencyKey, melioAccount, organizationId, userId, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Update Payment meta data.
     * @summary Update a Payment meta data
     * @param {string} id ID of the entity
     * @param {UpdatePaymentMetaDataPayload} [updatePaymentMetaDataPayload] 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updatePaymentsMetaDataPaymentId(id, updatePaymentMetaDataPayload, expand, idempotencyKey, melioAccount, organizationId, userId, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.updatePaymentsMetaDataPaymentId(id, updatePaymentMetaDataPayload, expand, idempotencyKey, melioAccount, organizationId, userId, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Update a Payment.
     * @summary Update a Payment
     * @param {string} id ID of the entity
     * @param {UpdatePaymentPayload} [updatePaymentPayload] 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updatePaymentsPaymentId(id, updatePaymentPayload, expand, idempotencyKey, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.updatePaymentsPaymentId(id, updatePaymentPayload, expand, idempotencyKey, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Void and refund undeposited check.
     * @summary Void and refund payment
     * @param {string} paymentId 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    voidAndRefundPayment(paymentId, idempotencyKey, melioAccount, expand, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.voidAndRefundPayment(paymentId, idempotencyKey, melioAccount, expand, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Void and resend undeposited check.
     * @summary Void and resend payment
     * @param {string} paymentId 
     * @param {VoidAndResendPaymentRequest} [voidAndResendPaymentRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    voidAndResendPayment(paymentId, voidAndResendPaymentRequest, idempotencyKey, melioAccount, expand, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.voidAndResendPayment(paymentId, voidAndResendPaymentRequest, idempotencyKey, melioAccount, expand, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    }
  };
};
var PaymentsApiClient = createApiFromFp(PaymentsApiFp);
var PaymentsApiFactory = function(configuration, basePath, axios2) {
  const localVarFp = PaymentsApiFp(configuration);
  return {
    /**
     * Cancel a Payment and delete it from the system.  <!-- theme: info --> > The `Melio-Account` header is required when using API Key security. 
     * @summary Delete a Payment
     * @param {string} id ID of the entity
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deletePaymentsPaymentId(id, organizationId, userId, options) {
      return localVarFp.deletePaymentsPaymentId(id, organizationId, userId, options).then((request) => request(axios2, basePath));
    },
    /**
     * This operation gets the approval decisions of the Payment
     * @summary get the approval decisions of the payment
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPaymentApprovalDecisions(id, melioAccount, options) {
      return localVarFp.getPaymentApprovalDecisions(id, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * This operation gets the confirmation of the Payment
     * @summary gets the payment confirmation document
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPaymentConfirmationDocument(id, melioAccount, options) {
      return localVarFp.getPaymentConfirmationDocument(id, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Payment estimated time of arrival dates calculator
     * @summary Payment estimated time of arrival dates calculator
     * @param {Array<string>} paymentIds 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPaymentEtaDates(paymentIds, options) {
      return localVarFp.getPaymentEtaDates(paymentIds, options).then((request) => request(axios2, basePath));
    },
    /**
     * This operation gets the pending approvers of the Payment
     * @summary get the pending approvers of the payment
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPaymentPendingApprovers(id, melioAccount, options) {
      return localVarFp.getPaymentPendingApprovers(id, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * This operation gets the receipt of the Payment
     * @summary get the receipt of the payment
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPaymentReceipt(id, melioAccount, options) {
      return localVarFp.getPaymentReceipt(id, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * This operation gets the risk request of files of the Payment
     * @summary get the risk request of the payment for files
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPaymentRequiredDocuments(id, melioAccount, options) {
      return localVarFp.getPaymentRequiredDocuments(id, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * This operation gets the receipt of the Payment that the vendor paid
     * @summary get the receipt of the payment paid by vendor
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPaymentVendorReceipt(id, melioAccount, options) {
      return localVarFp.getPaymentVendorReceipt(id, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Retrieve all Payment objects for the current Account with this partner. Payments can have any status.  <!-- theme: info --> > The `Melio-Account` header is required when using API Key security.  [`searchTerm` parameter searches](https://docs.melio.com/docs/melio-data-api/getting-started#simple_search) are checked against the following fields: - `vendor.name` - `amount` - `id` - `bills.invoice.number`  [`search` parameter searches](https://docs.melio.com/docs/melio-data-api/getting-started#advanced_search) can be matched against the following result fields: - `vendor.name` - `vendor.contact.name` - `vendor.id` - `paymentIntent.id` - `payment.status` - `payment.approvalDecisionStatus` - `bill.balance` - `bill.status` - `payment.id` - `bill.id` - `payment.collectStatus` - `payment.fundingSourceId` 
     * @summary Retrieve all Payments for this account
     * @param {string} [paymentIntentId] 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [searchTerm] Limit returned objects to those that contain the specified search string. Search is a case-insensitive, substring match against a subset of fields in the object. See the method documentation to learn which fields can be matched by the &#x60;searchTerm&#x60; value. [Read more](https://docs.melio.com/docs/melio-data-api/getting-started#simple_search) 
     * @param {string} [search] Limit returned objects to those that satisfy the specified query. Query strings support logic and comparison against fields that you specify. See the method documentation to learn which fields can be included in your query, or [read more about query strings](https://docs.melio.com/docs/melio-data-api/getting-started#advanced_search).
     * @param {Array<PaymentsSortQueryParam>} [sort] Sort query parameter - sort data by specified entity fields
     * @param {number} [limit] A limit on the number of records to be returned.
     * @param {PaginationCursor} [cursor] Used to page through page through results when the &#x60;totalCount&#x60; is more than the current set of results. To page, specify \&quot;cursor[prev]&#x3D;_&lt;prev_token&gt;_\&quot; or \&quot;cursor[next]&#x3D;_&lt;next_token&gt;_\&quot; as a URL parameter. 
     * @param {boolean} [pendingCurrentUserApproval] If true, show only pending payments that require approval by the current user. If false, do not filter by approval requirements.
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPayments(paymentIntentId, melioAccount, expand, searchTerm, search, sort, limit, cursor, pendingCurrentUserApproval, organizationId, userId, options) {
      return localVarFp.getPayments(paymentIntentId, melioAccount, expand, searchTerm, search, sort, limit, cursor, pendingCurrentUserApproval, organizationId, userId, options).then((request) => request(axios2, basePath));
    },
    /**
     * Retrieve a Payment using its ID.
     * @summary Retrieve a Payment
     * @param {string} id ID of the entity
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPaymentsPaymentId(id, expand, melioAccount, options) {
      return localVarFp.getPaymentsPaymentId(id, expand, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Attach files to documents request
     * @summary Attach files to documents request
     * @param {string} requestId 
     * @param {PaymentAttachFilesRequest} [paymentAttachFilesRequest] 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postAttachFilesRequiredDocuments(requestId, paymentAttachFilesRequest, melioAccount, options) {
      return localVarFp.postAttachFilesRequiredDocuments(requestId, paymentAttachFilesRequest, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * This operation creates fee payment
     * @summary create fee payment by payment details
     * @param {CreateFeePaymentParameters} createFeePaymentParameters create payment parameters
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postFeePayment(createFeePaymentParameters, organizationId, userId, options) {
      return localVarFp.postFeePayment(createFeePaymentParameters, organizationId, userId, options).then((request) => request(axios2, basePath));
    },
    /**
     * This operation get payment details and create payment
     * @summary create payment by payment details
     * @param {CreatePaymentParameters} createPaymentParameters create payment parameters
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postPayment(createPaymentParameters, organizationId, userId, options) {
      return localVarFp.postPayment(createPaymentParameters, organizationId, userId, options).then((request) => request(axios2, basePath));
    },
    /**
     * This operation calculates the fees for a Payment
     * @summary get the calculated fee for payment
     * @param {PaymentFeeCalculationParameters} paymentFeeCalculationParameters payment overwrite parameters
     * @param {string} id ID of the entity
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postPaymentCalculateFee(paymentFeeCalculationParameters, id, idempotencyKey, melioAccount, options) {
      return localVarFp.postPaymentCalculateFee(paymentFeeCalculationParameters, id, idempotencyKey, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Create an approval decision for existing Payments.
     * @summary Create multiple approval decisions for payments
     * @param {PostPaymentsBatchApprovalDecisionRequest | PostPaymentsBatchApprovalDecisionV2Request} [postPaymentsBatchApprovalDecisionRequestPostPaymentsBatchApprovalDecisionV2Request] 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postPaymentsBatchApprovalDecision(postPaymentsBatchApprovalDecisionRequestPostPaymentsBatchApprovalDecisionV2Request, expand, idempotencyKey, melioAccount, organizationId, userId, options) {
      return localVarFp.postPaymentsBatchApprovalDecision(postPaymentsBatchApprovalDecisionRequestPostPaymentsBatchApprovalDecisionV2Request, expand, idempotencyKey, melioAccount, organizationId, userId, options).then((request) => request(axios2, basePath));
    },
    /**
     * 
     * @summary delete payments
     * @param {PostPaymentsBatchDeleteRequest} [postPaymentsBatchDeleteRequest] 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postPaymentsBatchDelete(postPaymentsBatchDeleteRequest, melioAccount, organizationId, userId, options) {
      return localVarFp.postPaymentsBatchDelete(postPaymentsBatchDeleteRequest, melioAccount, organizationId, userId, options).then((request) => request(axios2, basePath));
    },
    /**
     * Create multiple Payments based on a provided list.
     * @summary Create multiple Payments
     * @param {CreatePaymentsBulkRequestParameters} [createPaymentsBulkRequestParameters] 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postPaymentsBulk(createPaymentsBulkRequestParameters, expand, idempotencyKey, melioAccount, options) {
      return localVarFp.postPaymentsBulk(createPaymentsBulkRequestParameters, expand, idempotencyKey, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Cancels a payment.
     * @summary Cancel a payment
     * @param {string} id ID of the entity
     * @param {PostPaymentsPaymentIdCancelRequest} [postPaymentsPaymentIdCancelRequest] 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postPaymentsPaymentIdCancel(id, postPaymentsPaymentIdCancelRequest, expand, melioAccount, options) {
      return localVarFp.postPaymentsPaymentIdCancel(id, postPaymentsPaymentIdCancelRequest, expand, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Mark as paid existing Failed Payment. The request\'s body can be partial, and only provided fields will be overwritten. Set an optional field to `null` in order to remove its contents.
     * @summary create a mark as paid payment
     * @param {string} id ID of the entity
     * @param {PostPaymentsPaymentIdMarkAsPaidRequest} [postPaymentsPaymentIdMarkAsPaidRequest] 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postPaymentsPaymentIdMarkAsPaid(id, postPaymentsPaymentIdMarkAsPaidRequest, expand, melioAccount, options) {
      return localVarFp.postPaymentsPaymentIdMarkAsPaid(id, postPaymentsPaymentIdMarkAsPaidRequest, expand, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * This operation get payment details and create a test payment from a test bill
     * @summary create a test payment by payment details
     * @param {CreateTestPaymentParameters} createTestPaymentParameters create payment parameters
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postTestPayment(createTestPaymentParameters, organizationId, userId, options) {
      return localVarFp.postTestPayment(createTestPaymentParameters, organizationId, userId, options).then((request) => request(axios2, basePath));
    },
    /**
     * Refund failed payment.
     * @summary Refund failed payment
     * @param {string} paymentId 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    refundPayment(paymentId, idempotencyKey, melioAccount, expand, options) {
      return localVarFp.refundPayment(paymentId, idempotencyKey, melioAccount, expand, options).then((request) => request(axios2, basePath));
    },
    /**
     * Retry to collect  a payment, possibly passing in new details to update it with them before.
     * @summary Retry to collect a payment with new details
     * @param {string} paymentId 
     * @param {RetryPaymentRequest} [retryPaymentRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    retryCollectPaymentWithDetails(paymentId, retryPaymentRequest, idempotencyKey, melioAccount, options) {
      return localVarFp.retryCollectPaymentWithDetails(paymentId, retryPaymentRequest, idempotencyKey, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Retry to deliver a payment, possibly passing in new details to update it with them before.
     * @summary Retry to deliver a payment with new details
     * @param {string} paymentId 
     * @param {RetryPaymentRequest} [retryPaymentRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    retryDeliverPaymentWithDetails(paymentId, retryPaymentRequest, idempotencyKey, melioAccount, options) {
      return localVarFp.retryDeliverPaymentWithDetails(paymentId, retryPaymentRequest, idempotencyKey, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Retry a payment, possibly passing in new details to update it with them before.
     * @summary Retry a payment with new details
     * @param {string} paymentId 
     * @param {RetryPaymentRequest} [retryPaymentRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    retryPaymentWithDetails(paymentId, retryPaymentRequest, idempotencyKey, melioAccount, organizationId, userId, options) {
      return localVarFp.retryPaymentWithDetails(paymentId, retryPaymentRequest, idempotencyKey, melioAccount, organizationId, userId, options).then((request) => request(axios2, basePath));
    },
    /**
     * Update Payment meta data.
     * @summary Update a Payment meta data
     * @param {string} id ID of the entity
     * @param {UpdatePaymentMetaDataPayload} [updatePaymentMetaDataPayload] 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updatePaymentsMetaDataPaymentId(id, updatePaymentMetaDataPayload, expand, idempotencyKey, melioAccount, organizationId, userId, options) {
      return localVarFp.updatePaymentsMetaDataPaymentId(id, updatePaymentMetaDataPayload, expand, idempotencyKey, melioAccount, organizationId, userId, options).then((request) => request(axios2, basePath));
    },
    /**
     * Update a Payment.
     * @summary Update a Payment
     * @param {string} id ID of the entity
     * @param {UpdatePaymentPayload} [updatePaymentPayload] 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updatePaymentsPaymentId(id, updatePaymentPayload, expand, idempotencyKey, melioAccount, options) {
      return localVarFp.updatePaymentsPaymentId(id, updatePaymentPayload, expand, idempotencyKey, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Void and refund undeposited check.
     * @summary Void and refund payment
     * @param {string} paymentId 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    voidAndRefundPayment(paymentId, idempotencyKey, melioAccount, expand, options) {
      return localVarFp.voidAndRefundPayment(paymentId, idempotencyKey, melioAccount, expand, options).then((request) => request(axios2, basePath));
    },
    /**
     * Void and resend undeposited check.
     * @summary Void and resend payment
     * @param {string} paymentId 
     * @param {VoidAndResendPaymentRequest} [voidAndResendPaymentRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    voidAndResendPayment(paymentId, voidAndResendPaymentRequest, idempotencyKey, melioAccount, expand, options) {
      return localVarFp.voidAndResendPayment(paymentId, voidAndResendPaymentRequest, idempotencyKey, melioAccount, expand, options).then((request) => request(axios2, basePath));
    }
  };
};
var PaymentsApi = class extends BaseAPI {
  /**
   * Cancel a Payment and delete it from the system.  <!-- theme: info --> > The `Melio-Account` header is required when using API Key security. 
   * @summary Delete a Payment
   * @param {PaymentsApiDeletePaymentsPaymentIdRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentsApi
   */
  deletePaymentsPaymentId(requestParameters, options) {
    return PaymentsApiFp(this.configuration).deletePaymentsPaymentId(requestParameters.id, requestParameters.organizationId, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * This operation gets the approval decisions of the Payment
   * @summary get the approval decisions of the payment
   * @param {PaymentsApiGetPaymentApprovalDecisionsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentsApi
   */
  getPaymentApprovalDecisions(requestParameters, options) {
    return PaymentsApiFp(this.configuration).getPaymentApprovalDecisions(requestParameters.id, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * This operation gets the confirmation of the Payment
   * @summary gets the payment confirmation document
   * @param {PaymentsApiGetPaymentConfirmationDocumentRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentsApi
   */
  getPaymentConfirmationDocument(requestParameters, options) {
    return PaymentsApiFp(this.configuration).getPaymentConfirmationDocument(requestParameters.id, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Payment estimated time of arrival dates calculator
   * @summary Payment estimated time of arrival dates calculator
   * @param {PaymentsApiGetPaymentEtaDatesRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentsApi
   */
  getPaymentEtaDates(requestParameters, options) {
    return PaymentsApiFp(this.configuration).getPaymentEtaDates(requestParameters.paymentIds, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * This operation gets the pending approvers of the Payment
   * @summary get the pending approvers of the payment
   * @param {PaymentsApiGetPaymentPendingApproversRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentsApi
   */
  getPaymentPendingApprovers(requestParameters, options) {
    return PaymentsApiFp(this.configuration).getPaymentPendingApprovers(requestParameters.id, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * This operation gets the receipt of the Payment
   * @summary get the receipt of the payment
   * @param {PaymentsApiGetPaymentReceiptRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentsApi
   */
  getPaymentReceipt(requestParameters, options) {
    return PaymentsApiFp(this.configuration).getPaymentReceipt(requestParameters.id, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * This operation gets the risk request of files of the Payment
   * @summary get the risk request of the payment for files
   * @param {PaymentsApiGetPaymentRequiredDocumentsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentsApi
   */
  getPaymentRequiredDocuments(requestParameters, options) {
    return PaymentsApiFp(this.configuration).getPaymentRequiredDocuments(requestParameters.id, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * This operation gets the receipt of the Payment that the vendor paid
   * @summary get the receipt of the payment paid by vendor
   * @param {PaymentsApiGetPaymentVendorReceiptRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentsApi
   */
  getPaymentVendorReceipt(requestParameters, options) {
    return PaymentsApiFp(this.configuration).getPaymentVendorReceipt(requestParameters.id, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Retrieve all Payment objects for the current Account with this partner. Payments can have any status.  <!-- theme: info --> > The `Melio-Account` header is required when using API Key security.  [`searchTerm` parameter searches](https://docs.melio.com/docs/melio-data-api/getting-started#simple_search) are checked against the following fields: - `vendor.name` - `amount` - `id` - `bills.invoice.number`  [`search` parameter searches](https://docs.melio.com/docs/melio-data-api/getting-started#advanced_search) can be matched against the following result fields: - `vendor.name` - `vendor.contact.name` - `vendor.id` - `paymentIntent.id` - `payment.status` - `payment.approvalDecisionStatus` - `bill.balance` - `bill.status` - `payment.id` - `bill.id` - `payment.collectStatus` - `payment.fundingSourceId` 
   * @summary Retrieve all Payments for this account
   * @param {PaymentsApiGetPaymentsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentsApi
   */
  getPayments(requestParameters = {}, options) {
    return PaymentsApiFp(this.configuration).getPayments(requestParameters.paymentIntentId, requestParameters.melioAccount, requestParameters.expand, requestParameters.searchTerm, requestParameters.search, requestParameters.sort, requestParameters.limit, requestParameters.cursor, requestParameters.pendingCurrentUserApproval, requestParameters.organizationId, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Retrieve a Payment using its ID.
   * @summary Retrieve a Payment
   * @param {PaymentsApiGetPaymentsPaymentIdRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentsApi
   */
  getPaymentsPaymentId(requestParameters, options) {
    return PaymentsApiFp(this.configuration).getPaymentsPaymentId(requestParameters.id, requestParameters.expand, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Attach files to documents request
   * @summary Attach files to documents request
   * @param {PaymentsApiPostAttachFilesRequiredDocumentsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentsApi
   */
  postAttachFilesRequiredDocuments(requestParameters, options) {
    return PaymentsApiFp(this.configuration).postAttachFilesRequiredDocuments(requestParameters.requestId, requestParameters.paymentAttachFilesRequest, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * This operation creates fee payment
   * @summary create fee payment by payment details
   * @param {PaymentsApiPostFeePaymentRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentsApi
   */
  postFeePayment(requestParameters, options) {
    return PaymentsApiFp(this.configuration).postFeePayment(requestParameters.createFeePaymentParameters, requestParameters.organizationId, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * This operation get payment details and create payment
   * @summary create payment by payment details
   * @param {PaymentsApiPostPaymentRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentsApi
   */
  postPayment(requestParameters, options) {
    return PaymentsApiFp(this.configuration).postPayment(requestParameters.createPaymentParameters, requestParameters.organizationId, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * This operation calculates the fees for a Payment
   * @summary get the calculated fee for payment
   * @param {PaymentsApiPostPaymentCalculateFeeRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentsApi
   */
  postPaymentCalculateFee(requestParameters, options) {
    return PaymentsApiFp(this.configuration).postPaymentCalculateFee(requestParameters.paymentFeeCalculationParameters, requestParameters.id, requestParameters.idempotencyKey, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Create an approval decision for existing Payments.
   * @summary Create multiple approval decisions for payments
   * @param {PaymentsApiPostPaymentsBatchApprovalDecisionRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentsApi
   */
  postPaymentsBatchApprovalDecision(requestParameters = {}, options) {
    return PaymentsApiFp(this.configuration).postPaymentsBatchApprovalDecision(requestParameters.postPaymentsBatchApprovalDecisionRequestPostPaymentsBatchApprovalDecisionV2Request, requestParameters.expand, requestParameters.idempotencyKey, requestParameters.melioAccount, requestParameters.organizationId, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * 
   * @summary delete payments
   * @param {PaymentsApiPostPaymentsBatchDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentsApi
   */
  postPaymentsBatchDelete(requestParameters = {}, options) {
    return PaymentsApiFp(this.configuration).postPaymentsBatchDelete(requestParameters.postPaymentsBatchDeleteRequest, requestParameters.melioAccount, requestParameters.organizationId, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Create multiple Payments based on a provided list.
   * @summary Create multiple Payments
   * @param {PaymentsApiPostPaymentsBulkRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentsApi
   */
  postPaymentsBulk(requestParameters = {}, options) {
    return PaymentsApiFp(this.configuration).postPaymentsBulk(requestParameters.createPaymentsBulkRequestParameters, requestParameters.expand, requestParameters.idempotencyKey, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Cancels a payment.
   * @summary Cancel a payment
   * @param {PaymentsApiPostPaymentsPaymentIdCancelRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentsApi
   */
  postPaymentsPaymentIdCancel(requestParameters, options) {
    return PaymentsApiFp(this.configuration).postPaymentsPaymentIdCancel(requestParameters.id, requestParameters.postPaymentsPaymentIdCancelRequest, requestParameters.expand, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Mark as paid existing Failed Payment. The request\'s body can be partial, and only provided fields will be overwritten. Set an optional field to `null` in order to remove its contents.
   * @summary create a mark as paid payment
   * @param {PaymentsApiPostPaymentsPaymentIdMarkAsPaidRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentsApi
   */
  postPaymentsPaymentIdMarkAsPaid(requestParameters, options) {
    return PaymentsApiFp(this.configuration).postPaymentsPaymentIdMarkAsPaid(requestParameters.id, requestParameters.postPaymentsPaymentIdMarkAsPaidRequest, requestParameters.expand, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * This operation get payment details and create a test payment from a test bill
   * @summary create a test payment by payment details
   * @param {PaymentsApiPostTestPaymentRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentsApi
   */
  postTestPayment(requestParameters, options) {
    return PaymentsApiFp(this.configuration).postTestPayment(requestParameters.createTestPaymentParameters, requestParameters.organizationId, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Refund failed payment.
   * @summary Refund failed payment
   * @param {PaymentsApiRefundPaymentRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentsApi
   */
  refundPayment(requestParameters, options) {
    return PaymentsApiFp(this.configuration).refundPayment(requestParameters.paymentId, requestParameters.idempotencyKey, requestParameters.melioAccount, requestParameters.expand, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Retry to collect  a payment, possibly passing in new details to update it with them before.
   * @summary Retry to collect a payment with new details
   * @param {PaymentsApiRetryCollectPaymentWithDetailsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentsApi
   */
  retryCollectPaymentWithDetails(requestParameters, options) {
    return PaymentsApiFp(this.configuration).retryCollectPaymentWithDetails(requestParameters.paymentId, requestParameters.retryPaymentRequest, requestParameters.idempotencyKey, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Retry to deliver a payment, possibly passing in new details to update it with them before.
   * @summary Retry to deliver a payment with new details
   * @param {PaymentsApiRetryDeliverPaymentWithDetailsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentsApi
   */
  retryDeliverPaymentWithDetails(requestParameters, options) {
    return PaymentsApiFp(this.configuration).retryDeliverPaymentWithDetails(requestParameters.paymentId, requestParameters.retryPaymentRequest, requestParameters.idempotencyKey, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Retry a payment, possibly passing in new details to update it with them before.
   * @summary Retry a payment with new details
   * @param {PaymentsApiRetryPaymentWithDetailsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentsApi
   */
  retryPaymentWithDetails(requestParameters, options) {
    return PaymentsApiFp(this.configuration).retryPaymentWithDetails(requestParameters.paymentId, requestParameters.retryPaymentRequest, requestParameters.idempotencyKey, requestParameters.melioAccount, requestParameters.organizationId, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Update Payment meta data.
   * @summary Update a Payment meta data
   * @param {PaymentsApiUpdatePaymentsMetaDataPaymentIdRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentsApi
   */
  updatePaymentsMetaDataPaymentId(requestParameters, options) {
    return PaymentsApiFp(this.configuration).updatePaymentsMetaDataPaymentId(requestParameters.id, requestParameters.updatePaymentMetaDataPayload, requestParameters.expand, requestParameters.idempotencyKey, requestParameters.melioAccount, requestParameters.organizationId, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Update a Payment.
   * @summary Update a Payment
   * @param {PaymentsApiUpdatePaymentsPaymentIdRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentsApi
   */
  updatePaymentsPaymentId(requestParameters, options) {
    return PaymentsApiFp(this.configuration).updatePaymentsPaymentId(requestParameters.id, requestParameters.updatePaymentPayload, requestParameters.expand, requestParameters.idempotencyKey, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Void and refund undeposited check.
   * @summary Void and refund payment
   * @param {PaymentsApiVoidAndRefundPaymentRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentsApi
   */
  voidAndRefundPayment(requestParameters, options) {
    return PaymentsApiFp(this.configuration).voidAndRefundPayment(requestParameters.paymentId, requestParameters.idempotencyKey, requestParameters.melioAccount, requestParameters.expand, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Void and resend undeposited check.
   * @summary Void and resend payment
   * @param {PaymentsApiVoidAndResendPaymentRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentsApi
   */
  voidAndResendPayment(requestParameters, options) {
    return PaymentsApiFp(this.configuration).voidAndResendPayment(requestParameters.paymentId, requestParameters.voidAndResendPaymentRequest, requestParameters.idempotencyKey, requestParameters.melioAccount, requestParameters.expand, options).then((request) => request(this.axios, this.basePath));
  }
};
var PaymentsApiInstance = createInstanceFromApiIClass(PaymentsApi);
var PaymentsAttachFilesRequestApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * Attach files to documents request
     * @summary Attach files to documents request
     * @param {string} requestId 
     * @param {PaymentAttachFilesRequest} [paymentAttachFilesRequest] 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postAttachFilesRequiredDocuments: (_0, _1, _2, ..._3) => __async(this, [_0, _1, _2, ..._3], function* (requestId, paymentAttachFilesRequest, melioAccount, options = {}) {
      assertParamExists("postAttachFilesRequiredDocuments", "requestId", requestId);
      const localVarPath = `/payments/required-documents/{requestId}`.replace(`{${"requestId"}}`, encodeURIComponent(String(requestId)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(paymentAttachFilesRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    })
  };
};
var PaymentsAttachFilesRequestApiFp = function(configuration) {
  const localVarAxiosParamCreator = PaymentsAttachFilesRequestApiAxiosParamCreator(configuration);
  return {
    /**
     * Attach files to documents request
     * @summary Attach files to documents request
     * @param {string} requestId 
     * @param {PaymentAttachFilesRequest} [paymentAttachFilesRequest] 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postAttachFilesRequiredDocuments(requestId, paymentAttachFilesRequest, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postAttachFilesRequiredDocuments(requestId, paymentAttachFilesRequest, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    }
  };
};
var PaymentsAttachFilesRequestApiClient = createApiFromFp(PaymentsAttachFilesRequestApiFp);
var PaymentsAttachFilesRequestApiFactory = function(configuration, basePath, axios2) {
  const localVarFp = PaymentsAttachFilesRequestApiFp(configuration);
  return {
    /**
     * Attach files to documents request
     * @summary Attach files to documents request
     * @param {string} requestId 
     * @param {PaymentAttachFilesRequest} [paymentAttachFilesRequest] 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postAttachFilesRequiredDocuments(requestId, paymentAttachFilesRequest, melioAccount, options) {
      return localVarFp.postAttachFilesRequiredDocuments(requestId, paymentAttachFilesRequest, melioAccount, options).then((request) => request(axios2, basePath));
    }
  };
};
var PaymentsAttachFilesRequestApi = class extends BaseAPI {
  /**
   * Attach files to documents request
   * @summary Attach files to documents request
   * @param {PaymentsAttachFilesRequestApiPostAttachFilesRequiredDocumentsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentsAttachFilesRequestApi
   */
  postAttachFilesRequiredDocuments(requestParameters, options) {
    return PaymentsAttachFilesRequestApiFp(this.configuration).postAttachFilesRequiredDocuments(requestParameters.requestId, requestParameters.paymentAttachFilesRequest, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
};
var PaymentsAttachFilesRequestApiInstance = createInstanceFromApiIClass(PaymentsAttachFilesRequestApi);
var PayorApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * Create a new Funding Source for the Account.  The `type` field determines the contents of the `details` field, according to the following mapping: * `plaid` => `PlaidDetails` * `card` => `Card`
     * @summary Creates a funding source for an authenticated guest payor
     * @param {PostPayorFundingSourceRequest} [postPayorFundingSourceRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postPayorFundingSource: (_0, ..._1) => __async(this, [_0, ..._1], function* (postPayorFundingSourceRequest, options = {}) {
      const localVarPath = `/account-receivable/payor/funding-source`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postPayorFundingSourceRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Create organization and vendor for authenticated guest payor
     * @summary Create organization and vendor for authenticated guest payor
     * @param {PostPayorOnboardingRequest} [postPayorOnboardingRequest] Provide payment request link and email to complete payor onboarding
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postPayorOnboarding: (_0, ..._1) => __async(this, [_0, ..._1], function* (postPayorOnboardingRequest, options = {}) {
      const localVarPath = `/account-receivable/payor/onboarding`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postPayorOnboardingRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Create bill and scheduled payment for authenticated guest payor by payment request in order to pay a payment
     * @summary Create bill and scheduled payment for authenticated guest payor by payment request in order to pay a payment
     * @param {PostPayorPayPaymentRequest} [postPayorPayPaymentRequest] Provide payment request link and funding source id to allow payor to pay
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postPayorPayPayment: (_0, ..._1) => __async(this, [_0, ..._1], function* (postPayorPayPaymentRequest, options = {}) {
      const localVarPath = `/account-receivable/payor/pay`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postPayorPayPaymentRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    })
  };
};
var PayorApiFp = function(configuration) {
  const localVarAxiosParamCreator = PayorApiAxiosParamCreator(configuration);
  return {
    /**
     * Create a new Funding Source for the Account.  The `type` field determines the contents of the `details` field, according to the following mapping: * `plaid` => `PlaidDetails` * `card` => `Card`
     * @summary Creates a funding source for an authenticated guest payor
     * @param {PostPayorFundingSourceRequest} [postPayorFundingSourceRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postPayorFundingSource(postPayorFundingSourceRequest, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postPayorFundingSource(postPayorFundingSourceRequest, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Create organization and vendor for authenticated guest payor
     * @summary Create organization and vendor for authenticated guest payor
     * @param {PostPayorOnboardingRequest} [postPayorOnboardingRequest] Provide payment request link and email to complete payor onboarding
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postPayorOnboarding(postPayorOnboardingRequest, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postPayorOnboarding(postPayorOnboardingRequest, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Create bill and scheduled payment for authenticated guest payor by payment request in order to pay a payment
     * @summary Create bill and scheduled payment for authenticated guest payor by payment request in order to pay a payment
     * @param {PostPayorPayPaymentRequest} [postPayorPayPaymentRequest] Provide payment request link and funding source id to allow payor to pay
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postPayorPayPayment(postPayorPayPaymentRequest, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postPayorPayPayment(postPayorPayPaymentRequest, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    }
  };
};
var PayorApiClient = createApiFromFp(PayorApiFp);
var PayorApiFactory = function(configuration, basePath, axios2) {
  const localVarFp = PayorApiFp(configuration);
  return {
    /**
     * Create a new Funding Source for the Account.  The `type` field determines the contents of the `details` field, according to the following mapping: * `plaid` => `PlaidDetails` * `card` => `Card`
     * @summary Creates a funding source for an authenticated guest payor
     * @param {PostPayorFundingSourceRequest} [postPayorFundingSourceRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postPayorFundingSource(postPayorFundingSourceRequest, options) {
      return localVarFp.postPayorFundingSource(postPayorFundingSourceRequest, options).then((request) => request(axios2, basePath));
    },
    /**
     * Create organization and vendor for authenticated guest payor
     * @summary Create organization and vendor for authenticated guest payor
     * @param {PostPayorOnboardingRequest} [postPayorOnboardingRequest] Provide payment request link and email to complete payor onboarding
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postPayorOnboarding(postPayorOnboardingRequest, options) {
      return localVarFp.postPayorOnboarding(postPayorOnboardingRequest, options).then((request) => request(axios2, basePath));
    },
    /**
     * Create bill and scheduled payment for authenticated guest payor by payment request in order to pay a payment
     * @summary Create bill and scheduled payment for authenticated guest payor by payment request in order to pay a payment
     * @param {PostPayorPayPaymentRequest} [postPayorPayPaymentRequest] Provide payment request link and funding source id to allow payor to pay
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postPayorPayPayment(postPayorPayPaymentRequest, options) {
      return localVarFp.postPayorPayPayment(postPayorPayPaymentRequest, options).then((request) => request(axios2, basePath));
    }
  };
};
var PayorApi = class extends BaseAPI {
  /**
   * Create a new Funding Source for the Account.  The `type` field determines the contents of the `details` field, according to the following mapping: * `plaid` => `PlaidDetails` * `card` => `Card`
   * @summary Creates a funding source for an authenticated guest payor
   * @param {PayorApiPostPayorFundingSourceRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PayorApi
   */
  postPayorFundingSource(requestParameters = {}, options) {
    return PayorApiFp(this.configuration).postPayorFundingSource(requestParameters.postPayorFundingSourceRequest, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Create organization and vendor for authenticated guest payor
   * @summary Create organization and vendor for authenticated guest payor
   * @param {PayorApiPostPayorOnboardingRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PayorApi
   */
  postPayorOnboarding(requestParameters = {}, options) {
    return PayorApiFp(this.configuration).postPayorOnboarding(requestParameters.postPayorOnboardingRequest, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Create bill and scheduled payment for authenticated guest payor by payment request in order to pay a payment
   * @summary Create bill and scheduled payment for authenticated guest payor by payment request in order to pay a payment
   * @param {PayorApiPostPayorPayPaymentRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PayorApi
   */
  postPayorPayPayment(requestParameters = {}, options) {
    return PayorApiFp(this.configuration).postPayorPayPayment(requestParameters.postPayorPayPaymentRequest, options).then((request) => request(this.axios, this.basePath));
  }
};
var PayorApiInstance = createInstanceFromApiIClass(PayorApi);
var PersonasApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * 
     * @summary Upsert a list of verified personas
     * @param {Array<UpsertOrganizationVerifiedPersonaRequest>} [upsertOrganizationVerifiedPersonaRequest] 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bulkUpsertVerifiedPersonas: (_0, _1, _2, ..._3) => __async(this, [_0, _1, _2, ..._3], function* (upsertOrganizationVerifiedPersonaRequest, melioAccount, idempotencyKey, options = {}) {
      const localVarPath = `/verified-personas/bulk-upsert`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      if (idempotencyKey !== void 0 && idempotencyKey !== null) {
        localVarHeaderParameter["Idempotency-Key"] = String(idempotencyKey);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(upsertOrganizationVerifiedPersonaRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Retrieve all verified personas within the same organization of the active account
     * @summary Retrieve all verified personas of an organization
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getVerifiedPersonas: (_0, ..._1) => __async(this, [_0, ..._1], function* (melioAccount, options = {}) {
      const localVarPath = `/verified-personas`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    })
  };
};
var PersonasApiFp = function(configuration) {
  const localVarAxiosParamCreator = PersonasApiAxiosParamCreator(configuration);
  return {
    /**
     * 
     * @summary Upsert a list of verified personas
     * @param {Array<UpsertOrganizationVerifiedPersonaRequest>} [upsertOrganizationVerifiedPersonaRequest] 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bulkUpsertVerifiedPersonas(upsertOrganizationVerifiedPersonaRequest, melioAccount, idempotencyKey, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.bulkUpsertVerifiedPersonas(upsertOrganizationVerifiedPersonaRequest, melioAccount, idempotencyKey, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Retrieve all verified personas within the same organization of the active account
     * @summary Retrieve all verified personas of an organization
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getVerifiedPersonas(melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getVerifiedPersonas(melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    }
  };
};
var PersonasApiClient = createApiFromFp(PersonasApiFp);
var PersonasApiFactory = function(configuration, basePath, axios2) {
  const localVarFp = PersonasApiFp(configuration);
  return {
    /**
     * 
     * @summary Upsert a list of verified personas
     * @param {Array<UpsertOrganizationVerifiedPersonaRequest>} [upsertOrganizationVerifiedPersonaRequest] 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bulkUpsertVerifiedPersonas(upsertOrganizationVerifiedPersonaRequest, melioAccount, idempotencyKey, options) {
      return localVarFp.bulkUpsertVerifiedPersonas(upsertOrganizationVerifiedPersonaRequest, melioAccount, idempotencyKey, options).then((request) => request(axios2, basePath));
    },
    /**
     * Retrieve all verified personas within the same organization of the active account
     * @summary Retrieve all verified personas of an organization
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getVerifiedPersonas(melioAccount, options) {
      return localVarFp.getVerifiedPersonas(melioAccount, options).then((request) => request(axios2, basePath));
    }
  };
};
var PersonasApi = class extends BaseAPI {
  /**
   * 
   * @summary Upsert a list of verified personas
   * @param {PersonasApiBulkUpsertVerifiedPersonasRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PersonasApi
   */
  bulkUpsertVerifiedPersonas(requestParameters = {}, options) {
    return PersonasApiFp(this.configuration).bulkUpsertVerifiedPersonas(requestParameters.upsertOrganizationVerifiedPersonaRequest, requestParameters.melioAccount, requestParameters.idempotencyKey, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Retrieve all verified personas within the same organization of the active account
   * @summary Retrieve all verified personas of an organization
   * @param {PersonasApiGetVerifiedPersonasRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PersonasApi
   */
  getVerifiedPersonas(requestParameters = {}, options) {
    return PersonasApiFp(this.configuration).getVerifiedPersonas(requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
};
var PersonasApiInstance = createInstanceFromApiIClass(PersonasApi);
var PlansApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * 
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPlan: (_0, _1, _2, _3, ..._4) => __async(this, [_0, _1, _2, _3, ..._4], function* (id, melioAccount, organizationId, userId, options = {}) {
      assertParamExists("getPlan", "id", id);
      const localVarPath = `/plans/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      if (organizationId !== void 0 && organizationId !== null) {
        localVarHeaderParameter["Organization-id"] = String(organizationId);
      }
      if (userId !== void 0 && userId !== null) {
        localVarHeaderParameter["User-id"] = String(userId);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPlans: (_0, _1, _2, ..._3) => __async(this, [_0, _1, _2, ..._3], function* (melioAccount, organizationId, userId, options = {}) {
      const localVarPath = `/plans`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      if (organizationId !== void 0 && organizationId !== null) {
        localVarHeaderParameter["Organization-id"] = String(organizationId);
      }
      if (userId !== void 0 && userId !== null) {
        localVarHeaderParameter["User-id"] = String(userId);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPlansMe: (_0, _1, _2, ..._3) => __async(this, [_0, _1, _2, ..._3], function* (melioAccount, organizationId, userId, options = {}) {
      const localVarPath = `/plans/me`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      if (organizationId !== void 0 && organizationId !== null) {
        localVarHeaderParameter["Organization-id"] = String(organizationId);
      }
      if (userId !== void 0 && userId !== null) {
        localVarHeaderParameter["User-id"] = String(userId);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    })
  };
};
var PlansApiFp = function(configuration) {
  const localVarAxiosParamCreator = PlansApiAxiosParamCreator(configuration);
  return {
    /**
     * 
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPlan(id, melioAccount, organizationId, userId, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getPlan(id, melioAccount, organizationId, userId, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPlans(melioAccount, organizationId, userId, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getPlans(melioAccount, organizationId, userId, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPlansMe(melioAccount, organizationId, userId, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getPlansMe(melioAccount, organizationId, userId, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    }
  };
};
var PlansApiClient = createApiFromFp(PlansApiFp);
var PlansApiFactory = function(configuration, basePath, axios2) {
  const localVarFp = PlansApiFp(configuration);
  return {
    /**
     * 
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPlan(id, melioAccount, organizationId, userId, options) {
      return localVarFp.getPlan(id, melioAccount, organizationId, userId, options).then((request) => request(axios2, basePath));
    },
    /**
     * 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPlans(melioAccount, organizationId, userId, options) {
      return localVarFp.getPlans(melioAccount, organizationId, userId, options).then((request) => request(axios2, basePath));
    },
    /**
     * 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPlansMe(melioAccount, organizationId, userId, options) {
      return localVarFp.getPlansMe(melioAccount, organizationId, userId, options).then((request) => request(axios2, basePath));
    }
  };
};
var PlansApi = class extends BaseAPI {
  /**
   * 
   * @param {PlansApiGetPlanRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlansApi
   */
  getPlan(requestParameters, options) {
    return PlansApiFp(this.configuration).getPlan(requestParameters.id, requestParameters.melioAccount, requestParameters.organizationId, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * 
   * @param {PlansApiGetPlansRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlansApi
   */
  getPlans(requestParameters = {}, options) {
    return PlansApiFp(this.configuration).getPlans(requestParameters.melioAccount, requestParameters.organizationId, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * 
   * @param {PlansApiGetPlansMeRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlansApi
   */
  getPlansMe(requestParameters = {}, options) {
    return PlansApiFp(this.configuration).getPlansMe(requestParameters.melioAccount, requestParameters.organizationId, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
  }
};
var PlansApiInstance = createInstanceFromApiIClass(PlansApi);
var PublicPayorApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * Retrieve payment request details for the payor by paymentRequestLink
     * @summary Retrieve payment request details for the payor by paymentRequestLink
     * @param {string} paymentRequestLink Payment request link
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPaymentRequestDetails: (_0, ..._1) => __async(this, [_0, ..._1], function* (paymentRequestLink, options = {}) {
      assertParamExists("getPaymentRequestDetails", "paymentRequestLink", paymentRequestLink);
      const localVarPath = `/account-receivable/public/payment-request-details/{paymentRequestLink}`.replace(`{${"paymentRequestLink"}}`, encodeURIComponent(String(paymentRequestLink)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Get payment widget url for external payment processor
     * @summary Get payment widget url for external payment processor
     * @param {PaymentWidgetFundingSourceType} paymentWidgetFundingSourceType 
     * @param {string} paymentRequestLink Payment request link
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPaymentWidgetUrl: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (paymentWidgetFundingSourceType, paymentRequestLink, options = {}) {
      assertParamExists("getPaymentWidgetUrl", "paymentWidgetFundingSourceType", paymentWidgetFundingSourceType);
      assertParamExists("getPaymentWidgetUrl", "paymentRequestLink", paymentRequestLink);
      const localVarPath = `/account-receivable/public/payment-widget-url/{paymentRequestLink}/{paymentWidgetFundingSourceType}`.replace(`{${"paymentWidgetFundingSourceType"}}`, encodeURIComponent(String(paymentWidgetFundingSourceType))).replace(`{${"paymentRequestLink"}}`, encodeURIComponent(String(paymentRequestLink)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Retrieve public basic details of the guest payor user by token for a specific payment request
     * @summary Retrieve the guest payor user details by token for a specific payment request
     * @param {string} paymentRequestLink Payment request link
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPublicPayorPaymentRequestUserDetails: (_0, ..._1) => __async(this, [_0, ..._1], function* (paymentRequestLink, options = {}) {
      assertParamExists("getPublicPayorPaymentRequestUserDetails", "paymentRequestLink", paymentRequestLink);
      const localVarPath = `/account-receivable/public/payment-request/{paymentRequestLink}/user-details`.replace(`{${"paymentRequestLink"}}`, encodeURIComponent(String(paymentRequestLink)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Retrieve public basic details of the guest payor user for a specific payment request
     * @summary Retrieve the guest payor user details for a specific payment request
     * @param {string} paymentRequestLink Payment request link
     * @param {string} userEmail User email
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPublicPayorPaymentRequestUserDetailsByEmail: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (paymentRequestLink, userEmail, options = {}) {
      assertParamExists("getPublicPayorPaymentRequestUserDetailsByEmail", "paymentRequestLink", paymentRequestLink);
      assertParamExists("getPublicPayorPaymentRequestUserDetailsByEmail", "userEmail", userEmail);
      const localVarPath = `/account-receivable/public/payment-request/{paymentRequestLink}/user-details/{userEmail}`.replace(`{${"paymentRequestLink"}}`, encodeURIComponent(String(paymentRequestLink))).replace(`{${"userEmail"}}`, encodeURIComponent(String(userEmail)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Retrieve updated payment request link in case the payment request was updated
     * @summary Retrieve updated payment request link in case the payment request was updated
     * @param {string} paymentRequestLink Payment request link
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUpdatedPaymentRequestLink: (_0, ..._1) => __async(this, [_0, ..._1], function* (paymentRequestLink, options = {}) {
      assertParamExists("getUpdatedPaymentRequestLink", "paymentRequestLink", paymentRequestLink);
      const localVarPath = `/account-receivable/public/updated-payment-request-link/{paymentRequestLink}`.replace(`{${"paymentRequestLink"}}`, encodeURIComponent(String(paymentRequestLink)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Sends OTP email to guest payor
     * @summary Sends OTP email to guest payor
     * @param {PostSendOTPRequest} [postSendOTPRequest] Provide an email address for email verification
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postPublicPayorOtpStart: (_0, ..._1) => __async(this, [_0, ..._1], function* (postSendOTPRequest, options = {}) {
      const localVarPath = `/account-receivable/public/otp/start`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postSendOTPRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Verifies OTP and returns token if valid
     * @summary Verifies OTP and returns token
     * @param {PostVerifyOTPRequest} [postVerifyOTPRequest] Provide an OTP for verification
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postPublicPayorOtpVerify: (_0, ..._1) => __async(this, [_0, ..._1], function* (postVerifyOTPRequest, options = {}) {
      const localVarPath = `/account-receivable/public/otp/verify`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postVerifyOTPRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    })
  };
};
var PublicPayorApiFp = function(configuration) {
  const localVarAxiosParamCreator = PublicPayorApiAxiosParamCreator(configuration);
  return {
    /**
     * Retrieve payment request details for the payor by paymentRequestLink
     * @summary Retrieve payment request details for the payor by paymentRequestLink
     * @param {string} paymentRequestLink Payment request link
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPaymentRequestDetails(paymentRequestLink, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getPaymentRequestDetails(paymentRequestLink, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Get payment widget url for external payment processor
     * @summary Get payment widget url for external payment processor
     * @param {PaymentWidgetFundingSourceType} paymentWidgetFundingSourceType 
     * @param {string} paymentRequestLink Payment request link
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPaymentWidgetUrl(paymentWidgetFundingSourceType, paymentRequestLink, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getPaymentWidgetUrl(paymentWidgetFundingSourceType, paymentRequestLink, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Retrieve public basic details of the guest payor user by token for a specific payment request
     * @summary Retrieve the guest payor user details by token for a specific payment request
     * @param {string} paymentRequestLink Payment request link
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPublicPayorPaymentRequestUserDetails(paymentRequestLink, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getPublicPayorPaymentRequestUserDetails(paymentRequestLink, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Retrieve public basic details of the guest payor user for a specific payment request
     * @summary Retrieve the guest payor user details for a specific payment request
     * @param {string} paymentRequestLink Payment request link
     * @param {string} userEmail User email
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPublicPayorPaymentRequestUserDetailsByEmail(paymentRequestLink, userEmail, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getPublicPayorPaymentRequestUserDetailsByEmail(paymentRequestLink, userEmail, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Retrieve updated payment request link in case the payment request was updated
     * @summary Retrieve updated payment request link in case the payment request was updated
     * @param {string} paymentRequestLink Payment request link
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUpdatedPaymentRequestLink(paymentRequestLink, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getUpdatedPaymentRequestLink(paymentRequestLink, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Sends OTP email to guest payor
     * @summary Sends OTP email to guest payor
     * @param {PostSendOTPRequest} [postSendOTPRequest] Provide an email address for email verification
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postPublicPayorOtpStart(postSendOTPRequest, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postPublicPayorOtpStart(postSendOTPRequest, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Verifies OTP and returns token if valid
     * @summary Verifies OTP and returns token
     * @param {PostVerifyOTPRequest} [postVerifyOTPRequest] Provide an OTP for verification
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postPublicPayorOtpVerify(postVerifyOTPRequest, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postPublicPayorOtpVerify(postVerifyOTPRequest, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    }
  };
};
var PublicPayorApiClient = createApiFromFp(PublicPayorApiFp);
var PublicPayorApiFactory = function(configuration, basePath, axios2) {
  const localVarFp = PublicPayorApiFp(configuration);
  return {
    /**
     * Retrieve payment request details for the payor by paymentRequestLink
     * @summary Retrieve payment request details for the payor by paymentRequestLink
     * @param {string} paymentRequestLink Payment request link
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPaymentRequestDetails(paymentRequestLink, options) {
      return localVarFp.getPaymentRequestDetails(paymentRequestLink, options).then((request) => request(axios2, basePath));
    },
    /**
     * Get payment widget url for external payment processor
     * @summary Get payment widget url for external payment processor
     * @param {PaymentWidgetFundingSourceType} paymentWidgetFundingSourceType 
     * @param {string} paymentRequestLink Payment request link
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPaymentWidgetUrl(paymentWidgetFundingSourceType, paymentRequestLink, options) {
      return localVarFp.getPaymentWidgetUrl(paymentWidgetFundingSourceType, paymentRequestLink, options).then((request) => request(axios2, basePath));
    },
    /**
     * Retrieve public basic details of the guest payor user by token for a specific payment request
     * @summary Retrieve the guest payor user details by token for a specific payment request
     * @param {string} paymentRequestLink Payment request link
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPublicPayorPaymentRequestUserDetails(paymentRequestLink, options) {
      return localVarFp.getPublicPayorPaymentRequestUserDetails(paymentRequestLink, options).then((request) => request(axios2, basePath));
    },
    /**
     * Retrieve public basic details of the guest payor user for a specific payment request
     * @summary Retrieve the guest payor user details for a specific payment request
     * @param {string} paymentRequestLink Payment request link
     * @param {string} userEmail User email
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPublicPayorPaymentRequestUserDetailsByEmail(paymentRequestLink, userEmail, options) {
      return localVarFp.getPublicPayorPaymentRequestUserDetailsByEmail(paymentRequestLink, userEmail, options).then((request) => request(axios2, basePath));
    },
    /**
     * Retrieve updated payment request link in case the payment request was updated
     * @summary Retrieve updated payment request link in case the payment request was updated
     * @param {string} paymentRequestLink Payment request link
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUpdatedPaymentRequestLink(paymentRequestLink, options) {
      return localVarFp.getUpdatedPaymentRequestLink(paymentRequestLink, options).then((request) => request(axios2, basePath));
    },
    /**
     * Sends OTP email to guest payor
     * @summary Sends OTP email to guest payor
     * @param {PostSendOTPRequest} [postSendOTPRequest] Provide an email address for email verification
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postPublicPayorOtpStart(postSendOTPRequest, options) {
      return localVarFp.postPublicPayorOtpStart(postSendOTPRequest, options).then((request) => request(axios2, basePath));
    },
    /**
     * Verifies OTP and returns token if valid
     * @summary Verifies OTP and returns token
     * @param {PostVerifyOTPRequest} [postVerifyOTPRequest] Provide an OTP for verification
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postPublicPayorOtpVerify(postVerifyOTPRequest, options) {
      return localVarFp.postPublicPayorOtpVerify(postVerifyOTPRequest, options).then((request) => request(axios2, basePath));
    }
  };
};
var PublicPayorApi = class extends BaseAPI {
  /**
   * Retrieve payment request details for the payor by paymentRequestLink
   * @summary Retrieve payment request details for the payor by paymentRequestLink
   * @param {PublicPayorApiGetPaymentRequestDetailsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PublicPayorApi
   */
  getPaymentRequestDetails(requestParameters, options) {
    return PublicPayorApiFp(this.configuration).getPaymentRequestDetails(requestParameters.paymentRequestLink, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Get payment widget url for external payment processor
   * @summary Get payment widget url for external payment processor
   * @param {PublicPayorApiGetPaymentWidgetUrlRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PublicPayorApi
   */
  getPaymentWidgetUrl(requestParameters, options) {
    return PublicPayorApiFp(this.configuration).getPaymentWidgetUrl(requestParameters.paymentWidgetFundingSourceType, requestParameters.paymentRequestLink, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Retrieve public basic details of the guest payor user by token for a specific payment request
   * @summary Retrieve the guest payor user details by token for a specific payment request
   * @param {PublicPayorApiGetPublicPayorPaymentRequestUserDetailsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PublicPayorApi
   */
  getPublicPayorPaymentRequestUserDetails(requestParameters, options) {
    return PublicPayorApiFp(this.configuration).getPublicPayorPaymentRequestUserDetails(requestParameters.paymentRequestLink, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Retrieve public basic details of the guest payor user for a specific payment request
   * @summary Retrieve the guest payor user details for a specific payment request
   * @param {PublicPayorApiGetPublicPayorPaymentRequestUserDetailsByEmailRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PublicPayorApi
   */
  getPublicPayorPaymentRequestUserDetailsByEmail(requestParameters, options) {
    return PublicPayorApiFp(this.configuration).getPublicPayorPaymentRequestUserDetailsByEmail(requestParameters.paymentRequestLink, requestParameters.userEmail, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Retrieve updated payment request link in case the payment request was updated
   * @summary Retrieve updated payment request link in case the payment request was updated
   * @param {PublicPayorApiGetUpdatedPaymentRequestLinkRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PublicPayorApi
   */
  getUpdatedPaymentRequestLink(requestParameters, options) {
    return PublicPayorApiFp(this.configuration).getUpdatedPaymentRequestLink(requestParameters.paymentRequestLink, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Sends OTP email to guest payor
   * @summary Sends OTP email to guest payor
   * @param {PublicPayorApiPostPublicPayorOtpStartRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PublicPayorApi
   */
  postPublicPayorOtpStart(requestParameters = {}, options) {
    return PublicPayorApiFp(this.configuration).postPublicPayorOtpStart(requestParameters.postSendOTPRequest, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Verifies OTP and returns token if valid
   * @summary Verifies OTP and returns token
   * @param {PublicPayorApiPostPublicPayorOtpVerifyRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PublicPayorApi
   */
  postPublicPayorOtpVerify(requestParameters = {}, options) {
    return PublicPayorApiFp(this.configuration).postPublicPayorOtpVerify(requestParameters.postVerifyOTPRequest, options).then((request) => request(this.axios, this.basePath));
  }
};
var PublicPayorApiInstance = createInstanceFromApiIClass(PublicPayorApi);
var ReceivingMethodsApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * Create receiving method from funding source for a receiving method
     * @summary Create receiving method from funding source for a receiving method
     * @param {PostDeliveryMethodFromFundingRequest} [postDeliveryMethodFromFundingRequest] Provide selected funding source that will be used for the receiving method
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postDeliveryMethodFromFundingSource: (_0, ..._1) => __async(this, [_0, ..._1], function* (postDeliveryMethodFromFundingRequest, options = {}) {
      const localVarPath = `/account-receivable/delivery-methods/from-funding-source`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postDeliveryMethodFromFundingRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    })
  };
};
var ReceivingMethodsApiFp = function(configuration) {
  const localVarAxiosParamCreator = ReceivingMethodsApiAxiosParamCreator(configuration);
  return {
    /**
     * Create receiving method from funding source for a receiving method
     * @summary Create receiving method from funding source for a receiving method
     * @param {PostDeliveryMethodFromFundingRequest} [postDeliveryMethodFromFundingRequest] Provide selected funding source that will be used for the receiving method
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postDeliveryMethodFromFundingSource(postDeliveryMethodFromFundingRequest, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postDeliveryMethodFromFundingSource(postDeliveryMethodFromFundingRequest, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    }
  };
};
var ReceivingMethodsApiClient = createApiFromFp(ReceivingMethodsApiFp);
var ReceivingMethodsApiFactory = function(configuration, basePath, axios2) {
  const localVarFp = ReceivingMethodsApiFp(configuration);
  return {
    /**
     * Create receiving method from funding source for a receiving method
     * @summary Create receiving method from funding source for a receiving method
     * @param {PostDeliveryMethodFromFundingRequest} [postDeliveryMethodFromFundingRequest] Provide selected funding source that will be used for the receiving method
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postDeliveryMethodFromFundingSource(postDeliveryMethodFromFundingRequest, options) {
      return localVarFp.postDeliveryMethodFromFundingSource(postDeliveryMethodFromFundingRequest, options).then((request) => request(axios2, basePath));
    }
  };
};
var ReceivingMethodsApi = class extends BaseAPI {
  /**
   * Create receiving method from funding source for a receiving method
   * @summary Create receiving method from funding source for a receiving method
   * @param {ReceivingMethodsApiPostDeliveryMethodFromFundingSourceRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReceivingMethodsApi
   */
  postDeliveryMethodFromFundingSource(requestParameters = {}, options) {
    return ReceivingMethodsApiFp(this.configuration).postDeliveryMethodFromFundingSource(requestParameters.postDeliveryMethodFromFundingRequest, options).then((request) => request(this.axios, this.basePath));
  }
};
var ReceivingMethodsApiInstance = createInstanceFromApiIClass(ReceivingMethodsApi);
var RecommendedVendorsApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * Retrieve a list of Recommended Vendors
     * @summary Retrieve all Recommended Vendors
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getRecommendedVendors: (_0, ..._1) => __async(this, [_0, ..._1], function* (expand, options = {}) {
      const localVarPath = `/recommended-vendors`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (expand !== void 0 && expand !== null) {
        localVarHeaderParameter["expand"] = String(JSON.stringify(expand));
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    })
  };
};
var RecommendedVendorsApiFp = function(configuration) {
  const localVarAxiosParamCreator = RecommendedVendorsApiAxiosParamCreator(configuration);
  return {
    /**
     * Retrieve a list of Recommended Vendors
     * @summary Retrieve all Recommended Vendors
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getRecommendedVendors(expand, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getRecommendedVendors(expand, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    }
  };
};
var RecommendedVendorsApiClient = createApiFromFp(RecommendedVendorsApiFp);
var RecommendedVendorsApiFactory = function(configuration, basePath, axios2) {
  const localVarFp = RecommendedVendorsApiFp(configuration);
  return {
    /**
     * Retrieve a list of Recommended Vendors
     * @summary Retrieve all Recommended Vendors
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getRecommendedVendors(expand, options) {
      return localVarFp.getRecommendedVendors(expand, options).then((request) => request(axios2, basePath));
    }
  };
};
var RecommendedVendorsApi = class extends BaseAPI {
  /**
   * Retrieve a list of Recommended Vendors
   * @summary Retrieve all Recommended Vendors
   * @param {RecommendedVendorsApiGetRecommendedVendorsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RecommendedVendorsApi
   */
  getRecommendedVendors(requestParameters = {}, options) {
    return RecommendedVendorsApiFp(this.configuration).getRecommendedVendors(requestParameters.expand, options).then((request) => request(this.axios, this.basePath));
  }
};
var RecommendedVendorsApiInstance = createInstanceFromApiIClass(RecommendedVendorsApi);
var ReportsApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * create a payments report in specific date range.
     * @summary create a payments report
     * @param {PostPaymentsReportRequest} [postPaymentsReportRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postPaymentsReport: (_0, _1, _2, ..._3) => __async(this, [_0, _1, _2, ..._3], function* (postPaymentsReportRequest, idempotencyKey, melioAccount, options = {}) {
      const localVarPath = `/reports/payments`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (idempotencyKey !== void 0 && idempotencyKey !== null) {
        localVarHeaderParameter["Idempotency-Key"] = String(idempotencyKey);
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postPaymentsReportRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    })
  };
};
var ReportsApiFp = function(configuration) {
  const localVarAxiosParamCreator = ReportsApiAxiosParamCreator(configuration);
  return {
    /**
     * create a payments report in specific date range.
     * @summary create a payments report
     * @param {PostPaymentsReportRequest} [postPaymentsReportRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postPaymentsReport(postPaymentsReportRequest, idempotencyKey, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postPaymentsReport(postPaymentsReportRequest, idempotencyKey, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    }
  };
};
var ReportsApiClient = createApiFromFp(ReportsApiFp);
var ReportsApiFactory = function(configuration, basePath, axios2) {
  const localVarFp = ReportsApiFp(configuration);
  return {
    /**
     * create a payments report in specific date range.
     * @summary create a payments report
     * @param {PostPaymentsReportRequest} [postPaymentsReportRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postPaymentsReport(postPaymentsReportRequest, idempotencyKey, melioAccount, options) {
      return localVarFp.postPaymentsReport(postPaymentsReportRequest, idempotencyKey, melioAccount, options).then((request) => request(axios2, basePath));
    }
  };
};
var ReportsApi = class extends BaseAPI {
  /**
   * create a payments report in specific date range.
   * @summary create a payments report
   * @param {ReportsApiPostPaymentsReportRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReportsApi
   */
  postPaymentsReport(requestParameters = {}, options) {
    return ReportsApiFp(this.configuration).postPaymentsReport(requestParameters.postPaymentsReportRequest, requestParameters.idempotencyKey, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
};
var ReportsApiInstance = createInstanceFromApiIClass(ReportsApi);
var ScannedInvoicesApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * Delete scanned invoice by Id.
     * @summary Delete scanned invoice by Id.
     * @param {string} id ID of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteScannedInvoicesScannedInvoiceId: (_0, ..._1) => __async(this, [_0, ..._1], function* (id, options = {}) {
      assertParamExists("deleteScannedInvoicesScannedInvoiceId", "id", id);
      const localVarPath = `/scanned-invoices/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "DELETE" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Return all scanned invoices for this account.  [`search` parameter searches](https://docs.melio.com/docs/melio-data-api/getting-started#advanced_search) can be matched against the following result fields: - `scannedInvoice.id`  <!-- theme: info --> > The `Melio-Account` header is required when using API Key security. 
     * @summary Retrieve all scanned invoices
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [search] Limit returned objects to those that satisfy the specified query. Query strings support logic and comparison against fields that you specify. See the method documentation to learn which fields can be included in your query, or [read more about query strings](https://docs.melio.com/docs/melio-data-api/getting-started#advanced_search).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getScannedInvoices: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (melioAccount, search, options = {}) {
      const localVarPath = `/scanned-invoices`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (search !== void 0) {
        localVarQueryParameter["search"] = search;
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Retrieve a Scanned invoice using its ID
     * @summary Retrieve a scanned invoice by id
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getScannedInvoicesScannedInvoiceId: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (id, melioAccount, options = {}) {
      assertParamExists("getScannedInvoicesScannedInvoiceId", "id", id);
      const localVarPath = `/scanned-invoices/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * 
     * @summary delete scanned invoices
     * @param {PostScannedInvoiceBatchDeleteRequest} [postScannedInvoiceBatchDeleteRequest] 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postScannedInvoiceBatchDelete: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (postScannedInvoiceBatchDeleteRequest, melioAccount, options = {}) {
      const localVarPath = `/scanned-invoices/batch-delete`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postScannedInvoiceBatchDeleteRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Create multiple scanned invoices with core-api mutation
     * @summary Create multiple scanned invoices
     * @param {Array<any>} [files] 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postScannedInvoices: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (files, melioAccount, options = {}) {
      const localVarPath = `/scanned-invoices/bulk`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      const localVarFormParams = new (configuration && configuration.formDataCtor || FormData)();
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      if (files) {
        files.forEach((element) => {
          localVarFormParams.append("files", element);
        });
      }
      localVarHeaderParameter["Content-Type"] = "multipart/form-data";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = localVarFormParams;
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Mark existing scanned invoice as paid
     * @summary create a mark as paid payment
     * @param {string} id ID of the entity
     * @param {PostScannedInvoicesScannedInvoiceIdMarkAsPaidRequest} [postScannedInvoicesScannedInvoiceIdMarkAsPaidRequest] 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postScannedInvoicesScannedInvoiceIdMarkAsPaid: (_0, _1, _2, ..._3) => __async(this, [_0, _1, _2, ..._3], function* (id, postScannedInvoicesScannedInvoiceIdMarkAsPaidRequest, melioAccount, options = {}) {
      assertParamExists("postScannedInvoicesScannedInvoiceIdMarkAsPaid", "id", id);
      const localVarPath = `/scanned-invoices/{id}/mark-as-paid`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postScannedInvoicesScannedInvoiceIdMarkAsPaidRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    })
  };
};
var ScannedInvoicesApiFp = function(configuration) {
  const localVarAxiosParamCreator = ScannedInvoicesApiAxiosParamCreator(configuration);
  return {
    /**
     * Delete scanned invoice by Id.
     * @summary Delete scanned invoice by Id.
     * @param {string} id ID of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteScannedInvoicesScannedInvoiceId(id, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteScannedInvoicesScannedInvoiceId(id, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Return all scanned invoices for this account.  [`search` parameter searches](https://docs.melio.com/docs/melio-data-api/getting-started#advanced_search) can be matched against the following result fields: - `scannedInvoice.id`  <!-- theme: info --> > The `Melio-Account` header is required when using API Key security. 
     * @summary Retrieve all scanned invoices
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [search] Limit returned objects to those that satisfy the specified query. Query strings support logic and comparison against fields that you specify. See the method documentation to learn which fields can be included in your query, or [read more about query strings](https://docs.melio.com/docs/melio-data-api/getting-started#advanced_search).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getScannedInvoices(melioAccount, search, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getScannedInvoices(melioAccount, search, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Retrieve a Scanned invoice using its ID
     * @summary Retrieve a scanned invoice by id
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getScannedInvoicesScannedInvoiceId(id, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getScannedInvoicesScannedInvoiceId(id, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * 
     * @summary delete scanned invoices
     * @param {PostScannedInvoiceBatchDeleteRequest} [postScannedInvoiceBatchDeleteRequest] 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postScannedInvoiceBatchDelete(postScannedInvoiceBatchDeleteRequest, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postScannedInvoiceBatchDelete(postScannedInvoiceBatchDeleteRequest, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Create multiple scanned invoices with core-api mutation
     * @summary Create multiple scanned invoices
     * @param {Array<any>} [files] 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postScannedInvoices(files, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postScannedInvoices(files, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Mark existing scanned invoice as paid
     * @summary create a mark as paid payment
     * @param {string} id ID of the entity
     * @param {PostScannedInvoicesScannedInvoiceIdMarkAsPaidRequest} [postScannedInvoicesScannedInvoiceIdMarkAsPaidRequest] 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postScannedInvoicesScannedInvoiceIdMarkAsPaid(id, postScannedInvoicesScannedInvoiceIdMarkAsPaidRequest, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postScannedInvoicesScannedInvoiceIdMarkAsPaid(id, postScannedInvoicesScannedInvoiceIdMarkAsPaidRequest, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    }
  };
};
var ScannedInvoicesApiClient = createApiFromFp(ScannedInvoicesApiFp);
var ScannedInvoicesApiFactory = function(configuration, basePath, axios2) {
  const localVarFp = ScannedInvoicesApiFp(configuration);
  return {
    /**
     * Delete scanned invoice by Id.
     * @summary Delete scanned invoice by Id.
     * @param {string} id ID of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteScannedInvoicesScannedInvoiceId(id, options) {
      return localVarFp.deleteScannedInvoicesScannedInvoiceId(id, options).then((request) => request(axios2, basePath));
    },
    /**
     * Return all scanned invoices for this account.  [`search` parameter searches](https://docs.melio.com/docs/melio-data-api/getting-started#advanced_search) can be matched against the following result fields: - `scannedInvoice.id`  <!-- theme: info --> > The `Melio-Account` header is required when using API Key security. 
     * @summary Retrieve all scanned invoices
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [search] Limit returned objects to those that satisfy the specified query. Query strings support logic and comparison against fields that you specify. See the method documentation to learn which fields can be included in your query, or [read more about query strings](https://docs.melio.com/docs/melio-data-api/getting-started#advanced_search).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getScannedInvoices(melioAccount, search, options) {
      return localVarFp.getScannedInvoices(melioAccount, search, options).then((request) => request(axios2, basePath));
    },
    /**
     * Retrieve a Scanned invoice using its ID
     * @summary Retrieve a scanned invoice by id
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getScannedInvoicesScannedInvoiceId(id, melioAccount, options) {
      return localVarFp.getScannedInvoicesScannedInvoiceId(id, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * 
     * @summary delete scanned invoices
     * @param {PostScannedInvoiceBatchDeleteRequest} [postScannedInvoiceBatchDeleteRequest] 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postScannedInvoiceBatchDelete(postScannedInvoiceBatchDeleteRequest, melioAccount, options) {
      return localVarFp.postScannedInvoiceBatchDelete(postScannedInvoiceBatchDeleteRequest, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Create multiple scanned invoices with core-api mutation
     * @summary Create multiple scanned invoices
     * @param {Array<any>} [files] 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postScannedInvoices(files, melioAccount, options) {
      return localVarFp.postScannedInvoices(files, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Mark existing scanned invoice as paid
     * @summary create a mark as paid payment
     * @param {string} id ID of the entity
     * @param {PostScannedInvoicesScannedInvoiceIdMarkAsPaidRequest} [postScannedInvoicesScannedInvoiceIdMarkAsPaidRequest] 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postScannedInvoicesScannedInvoiceIdMarkAsPaid(id, postScannedInvoicesScannedInvoiceIdMarkAsPaidRequest, melioAccount, options) {
      return localVarFp.postScannedInvoicesScannedInvoiceIdMarkAsPaid(id, postScannedInvoicesScannedInvoiceIdMarkAsPaidRequest, melioAccount, options).then((request) => request(axios2, basePath));
    }
  };
};
var ScannedInvoicesApi = class extends BaseAPI {
  /**
   * Delete scanned invoice by Id.
   * @summary Delete scanned invoice by Id.
   * @param {ScannedInvoicesApiDeleteScannedInvoicesScannedInvoiceIdRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ScannedInvoicesApi
   */
  deleteScannedInvoicesScannedInvoiceId(requestParameters, options) {
    return ScannedInvoicesApiFp(this.configuration).deleteScannedInvoicesScannedInvoiceId(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Return all scanned invoices for this account.  [`search` parameter searches](https://docs.melio.com/docs/melio-data-api/getting-started#advanced_search) can be matched against the following result fields: - `scannedInvoice.id`  <!-- theme: info --> > The `Melio-Account` header is required when using API Key security. 
   * @summary Retrieve all scanned invoices
   * @param {ScannedInvoicesApiGetScannedInvoicesRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ScannedInvoicesApi
   */
  getScannedInvoices(requestParameters = {}, options) {
    return ScannedInvoicesApiFp(this.configuration).getScannedInvoices(requestParameters.melioAccount, requestParameters.search, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Retrieve a Scanned invoice using its ID
   * @summary Retrieve a scanned invoice by id
   * @param {ScannedInvoicesApiGetScannedInvoicesScannedInvoiceIdRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ScannedInvoicesApi
   */
  getScannedInvoicesScannedInvoiceId(requestParameters, options) {
    return ScannedInvoicesApiFp(this.configuration).getScannedInvoicesScannedInvoiceId(requestParameters.id, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * 
   * @summary delete scanned invoices
   * @param {ScannedInvoicesApiPostScannedInvoiceBatchDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ScannedInvoicesApi
   */
  postScannedInvoiceBatchDelete(requestParameters = {}, options) {
    return ScannedInvoicesApiFp(this.configuration).postScannedInvoiceBatchDelete(requestParameters.postScannedInvoiceBatchDeleteRequest, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Create multiple scanned invoices with core-api mutation
   * @summary Create multiple scanned invoices
   * @param {ScannedInvoicesApiPostScannedInvoicesRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ScannedInvoicesApi
   */
  postScannedInvoices(requestParameters = {}, options) {
    return ScannedInvoicesApiFp(this.configuration).postScannedInvoices(requestParameters.files, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Mark existing scanned invoice as paid
   * @summary create a mark as paid payment
   * @param {ScannedInvoicesApiPostScannedInvoicesScannedInvoiceIdMarkAsPaidRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ScannedInvoicesApi
   */
  postScannedInvoicesScannedInvoiceIdMarkAsPaid(requestParameters, options) {
    return ScannedInvoicesApiFp(this.configuration).postScannedInvoicesScannedInvoiceIdMarkAsPaid(requestParameters.id, requestParameters.postScannedInvoicesScannedInvoiceIdMarkAsPaidRequest, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
};
var ScannedInvoicesApiInstance = createInstanceFromApiIClass(ScannedInvoicesApi);
var ServiceChargeCatalogsApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * This operation deletes a service charge catalog by ID
     * @summary Delete a service charge catalog by id
     * @param {string} id Id of the entity
     * @param {string} [melioAccount] The &#x60;Melio-Account&#x60; header is used when a Partner wants to perform an operation on behalf of one of its Accounts. It contains the Account\&#39;s ID which returned when creating the Account, or when retrieving all of the Partner\&#39;s Accounts. Note that most operations are not permitted without the presence of this header.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteServiceChargeCatalogById: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (id, melioAccount, options = {}) {
      assertParamExists("deleteServiceChargeCatalogById", "id", id);
      const localVarPath = `/account-receivable/service-charge-catalog/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "DELETE" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Get a service charge catalog by ID
     * @summary Get a service charge catalog
     * @param {string} id Id of the entity
     * @param {string} [melioAccount] The &#x60;Melio-Account&#x60; header is used when a Partner wants to perform an operation on behalf of one of its Accounts. It contains the Account\&#39;s ID which returned when creating the Account, or when retrieving all of the Partner\&#39;s Accounts. Note that most operations are not permitted without the presence of this header.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getServiceChargeCatalogById: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (id, melioAccount, options = {}) {
      assertParamExists("getServiceChargeCatalogById", "id", id);
      const localVarPath = `/account-receivable/service-charge-catalog/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Retrieve a list of service charge catalogs of an organization
     * @summary Retrieve organization service charge catalog
     * @param {string} [melioAccount] The &#x60;Melio-Account&#x60; header is used when a Partner wants to perform an operation on behalf of one of its Accounts. It contains the Account\&#39;s ID which returned when creating the Account, or when retrieving all of the Partner\&#39;s Accounts. Note that most operations are not permitted without the presence of this header.
     * @param {number} [start] Start position
     * @param {number} [limit] Maximum number of results to return
     * @param {string} [sort] Sorting order
     * @param {string} [search] Search keyword
     * @param {Array<string>} [ids] Ids to filter by
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getServiceChargeCatalogs: (_0, _1, _2, _3, _4, _5, ..._6) => __async(this, [_0, _1, _2, _3, _4, _5, ..._6], function* (melioAccount, start, limit, sort, search, ids, options = {}) {
      const localVarPath = `/account-receivable/service-charge-catalog`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (start !== void 0) {
        localVarQueryParameter["start"] = start;
      }
      if (limit !== void 0) {
        localVarQueryParameter["limit"] = limit;
      }
      if (sort !== void 0) {
        localVarQueryParameter["sort"] = sort;
      }
      if (search !== void 0) {
        localVarQueryParameter["search"] = search;
      }
      if (ids) {
        localVarQueryParameter["ids"] = ids;
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Create a new service charge catalog
     * @summary Create a Service Charge Catalog
     * @param {PostServiceChargeCatalogRequest} [postServiceChargeCatalogRequest] 
     * @param {string} [melioAccount] The &#x60;Melio-Account&#x60; header is used when a Partner wants to perform an operation on behalf of one of its Accounts. It contains the Account\&#39;s ID which returned when creating the Account, or when retrieving all of the Partner\&#39;s Accounts. Note that most operations are not permitted without the presence of this header.
     * @param {SchemasExpand} [expand] Expand header parameters - use for expanding responses for POST &amp; PATCH requests
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postServiceChargeCatalog: (_0, _1, _2, ..._3) => __async(this, [_0, _1, _2, ..._3], function* (postServiceChargeCatalogRequest, melioAccount, expand, options = {}) {
      const localVarPath = `/account-receivable/service-charge-catalog`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      if (expand !== void 0 && expand !== null) {
        localVarHeaderParameter["expand"] = String(JSON.stringify(expand));
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postServiceChargeCatalogRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Update a Service Charge Catalog by ID
     * @summary Update a Service Charge Catalog
     * @param {string} id Id of the entity
     * @param {PatchServiceChargeCatalogRequest} [patchServiceChargeCatalogRequest] 
     * @param {string} [melioAccount] The &#x60;Melio-Account&#x60; header is used when a Partner wants to perform an operation on behalf of one of its Accounts. It contains the Account\&#39;s ID which returned when creating the Account, or when retrieving all of the Partner\&#39;s Accounts. Note that most operations are not permitted without the presence of this header.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateServiceChargeCatalogById: (_0, _1, _2, ..._3) => __async(this, [_0, _1, _2, ..._3], function* (id, patchServiceChargeCatalogRequest, melioAccount, options = {}) {
      assertParamExists("updateServiceChargeCatalogById", "id", id);
      const localVarPath = `/account-receivable/service-charge-catalog/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "PATCH" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(patchServiceChargeCatalogRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    })
  };
};
var ServiceChargeCatalogsApiFp = function(configuration) {
  const localVarAxiosParamCreator = ServiceChargeCatalogsApiAxiosParamCreator(configuration);
  return {
    /**
     * This operation deletes a service charge catalog by ID
     * @summary Delete a service charge catalog by id
     * @param {string} id Id of the entity
     * @param {string} [melioAccount] The &#x60;Melio-Account&#x60; header is used when a Partner wants to perform an operation on behalf of one of its Accounts. It contains the Account\&#39;s ID which returned when creating the Account, or when retrieving all of the Partner\&#39;s Accounts. Note that most operations are not permitted without the presence of this header.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteServiceChargeCatalogById(id, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteServiceChargeCatalogById(id, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Get a service charge catalog by ID
     * @summary Get a service charge catalog
     * @param {string} id Id of the entity
     * @param {string} [melioAccount] The &#x60;Melio-Account&#x60; header is used when a Partner wants to perform an operation on behalf of one of its Accounts. It contains the Account\&#39;s ID which returned when creating the Account, or when retrieving all of the Partner\&#39;s Accounts. Note that most operations are not permitted without the presence of this header.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getServiceChargeCatalogById(id, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getServiceChargeCatalogById(id, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Retrieve a list of service charge catalogs of an organization
     * @summary Retrieve organization service charge catalog
     * @param {string} [melioAccount] The &#x60;Melio-Account&#x60; header is used when a Partner wants to perform an operation on behalf of one of its Accounts. It contains the Account\&#39;s ID which returned when creating the Account, or when retrieving all of the Partner\&#39;s Accounts. Note that most operations are not permitted without the presence of this header.
     * @param {number} [start] Start position
     * @param {number} [limit] Maximum number of results to return
     * @param {string} [sort] Sorting order
     * @param {string} [search] Search keyword
     * @param {Array<string>} [ids] Ids to filter by
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getServiceChargeCatalogs(melioAccount, start, limit, sort, search, ids, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getServiceChargeCatalogs(melioAccount, start, limit, sort, search, ids, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Create a new service charge catalog
     * @summary Create a Service Charge Catalog
     * @param {PostServiceChargeCatalogRequest} [postServiceChargeCatalogRequest] 
     * @param {string} [melioAccount] The &#x60;Melio-Account&#x60; header is used when a Partner wants to perform an operation on behalf of one of its Accounts. It contains the Account\&#39;s ID which returned when creating the Account, or when retrieving all of the Partner\&#39;s Accounts. Note that most operations are not permitted without the presence of this header.
     * @param {SchemasExpand} [expand] Expand header parameters - use for expanding responses for POST &amp; PATCH requests
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postServiceChargeCatalog(postServiceChargeCatalogRequest, melioAccount, expand, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postServiceChargeCatalog(postServiceChargeCatalogRequest, melioAccount, expand, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Update a Service Charge Catalog by ID
     * @summary Update a Service Charge Catalog
     * @param {string} id Id of the entity
     * @param {PatchServiceChargeCatalogRequest} [patchServiceChargeCatalogRequest] 
     * @param {string} [melioAccount] The &#x60;Melio-Account&#x60; header is used when a Partner wants to perform an operation on behalf of one of its Accounts. It contains the Account\&#39;s ID which returned when creating the Account, or when retrieving all of the Partner\&#39;s Accounts. Note that most operations are not permitted without the presence of this header.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateServiceChargeCatalogById(id, patchServiceChargeCatalogRequest, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.updateServiceChargeCatalogById(id, patchServiceChargeCatalogRequest, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    }
  };
};
var ServiceChargeCatalogsApiClient = createApiFromFp(ServiceChargeCatalogsApiFp);
var ServiceChargeCatalogsApiFactory = function(configuration, basePath, axios2) {
  const localVarFp = ServiceChargeCatalogsApiFp(configuration);
  return {
    /**
     * This operation deletes a service charge catalog by ID
     * @summary Delete a service charge catalog by id
     * @param {string} id Id of the entity
     * @param {string} [melioAccount] The &#x60;Melio-Account&#x60; header is used when a Partner wants to perform an operation on behalf of one of its Accounts. It contains the Account\&#39;s ID which returned when creating the Account, or when retrieving all of the Partner\&#39;s Accounts. Note that most operations are not permitted without the presence of this header.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteServiceChargeCatalogById(id, melioAccount, options) {
      return localVarFp.deleteServiceChargeCatalogById(id, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Get a service charge catalog by ID
     * @summary Get a service charge catalog
     * @param {string} id Id of the entity
     * @param {string} [melioAccount] The &#x60;Melio-Account&#x60; header is used when a Partner wants to perform an operation on behalf of one of its Accounts. It contains the Account\&#39;s ID which returned when creating the Account, or when retrieving all of the Partner\&#39;s Accounts. Note that most operations are not permitted without the presence of this header.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getServiceChargeCatalogById(id, melioAccount, options) {
      return localVarFp.getServiceChargeCatalogById(id, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Retrieve a list of service charge catalogs of an organization
     * @summary Retrieve organization service charge catalog
     * @param {string} [melioAccount] The &#x60;Melio-Account&#x60; header is used when a Partner wants to perform an operation on behalf of one of its Accounts. It contains the Account\&#39;s ID which returned when creating the Account, or when retrieving all of the Partner\&#39;s Accounts. Note that most operations are not permitted without the presence of this header.
     * @param {number} [start] Start position
     * @param {number} [limit] Maximum number of results to return
     * @param {string} [sort] Sorting order
     * @param {string} [search] Search keyword
     * @param {Array<string>} [ids] Ids to filter by
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getServiceChargeCatalogs(melioAccount, start, limit, sort, search, ids, options) {
      return localVarFp.getServiceChargeCatalogs(melioAccount, start, limit, sort, search, ids, options).then((request) => request(axios2, basePath));
    },
    /**
     * Create a new service charge catalog
     * @summary Create a Service Charge Catalog
     * @param {PostServiceChargeCatalogRequest} [postServiceChargeCatalogRequest] 
     * @param {string} [melioAccount] The &#x60;Melio-Account&#x60; header is used when a Partner wants to perform an operation on behalf of one of its Accounts. It contains the Account\&#39;s ID which returned when creating the Account, or when retrieving all of the Partner\&#39;s Accounts. Note that most operations are not permitted without the presence of this header.
     * @param {SchemasExpand} [expand] Expand header parameters - use for expanding responses for POST &amp; PATCH requests
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postServiceChargeCatalog(postServiceChargeCatalogRequest, melioAccount, expand, options) {
      return localVarFp.postServiceChargeCatalog(postServiceChargeCatalogRequest, melioAccount, expand, options).then((request) => request(axios2, basePath));
    },
    /**
     * Update a Service Charge Catalog by ID
     * @summary Update a Service Charge Catalog
     * @param {string} id Id of the entity
     * @param {PatchServiceChargeCatalogRequest} [patchServiceChargeCatalogRequest] 
     * @param {string} [melioAccount] The &#x60;Melio-Account&#x60; header is used when a Partner wants to perform an operation on behalf of one of its Accounts. It contains the Account\&#39;s ID which returned when creating the Account, or when retrieving all of the Partner\&#39;s Accounts. Note that most operations are not permitted without the presence of this header.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateServiceChargeCatalogById(id, patchServiceChargeCatalogRequest, melioAccount, options) {
      return localVarFp.updateServiceChargeCatalogById(id, patchServiceChargeCatalogRequest, melioAccount, options).then((request) => request(axios2, basePath));
    }
  };
};
var ServiceChargeCatalogsApi = class extends BaseAPI {
  /**
   * This operation deletes a service charge catalog by ID
   * @summary Delete a service charge catalog by id
   * @param {ServiceChargeCatalogsApiDeleteServiceChargeCatalogByIdRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ServiceChargeCatalogsApi
   */
  deleteServiceChargeCatalogById(requestParameters, options) {
    return ServiceChargeCatalogsApiFp(this.configuration).deleteServiceChargeCatalogById(requestParameters.id, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Get a service charge catalog by ID
   * @summary Get a service charge catalog
   * @param {ServiceChargeCatalogsApiGetServiceChargeCatalogByIdRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ServiceChargeCatalogsApi
   */
  getServiceChargeCatalogById(requestParameters, options) {
    return ServiceChargeCatalogsApiFp(this.configuration).getServiceChargeCatalogById(requestParameters.id, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Retrieve a list of service charge catalogs of an organization
   * @summary Retrieve organization service charge catalog
   * @param {ServiceChargeCatalogsApiGetServiceChargeCatalogsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ServiceChargeCatalogsApi
   */
  getServiceChargeCatalogs(requestParameters = {}, options) {
    return ServiceChargeCatalogsApiFp(this.configuration).getServiceChargeCatalogs(requestParameters.melioAccount, requestParameters.start, requestParameters.limit, requestParameters.sort, requestParameters.search, requestParameters.ids, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Create a new service charge catalog
   * @summary Create a Service Charge Catalog
   * @param {ServiceChargeCatalogsApiPostServiceChargeCatalogRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ServiceChargeCatalogsApi
   */
  postServiceChargeCatalog(requestParameters = {}, options) {
    return ServiceChargeCatalogsApiFp(this.configuration).postServiceChargeCatalog(requestParameters.postServiceChargeCatalogRequest, requestParameters.melioAccount, requestParameters.expand, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Update a Service Charge Catalog by ID
   * @summary Update a Service Charge Catalog
   * @param {ServiceChargeCatalogsApiUpdateServiceChargeCatalogByIdRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ServiceChargeCatalogsApi
   */
  updateServiceChargeCatalogById(requestParameters, options) {
    return ServiceChargeCatalogsApiFp(this.configuration).updateServiceChargeCatalogById(requestParameters.id, requestParameters.patchServiceChargeCatalogRequest, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
};
var ServiceChargeCatalogsApiInstance = createInstanceFromApiIClass(ServiceChargeCatalogsApi);
var ServicesApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * Payment Calendar calculator
     * @summary Payment Calendar calculator
     * @param {PostPaymentCalendarRequest} [postPaymentCalendarRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postServicesPaymentCalendar: (_0, _1, _2, ..._3) => __async(this, [_0, _1, _2, ..._3], function* (postPaymentCalendarRequest, idempotencyKey, melioAccount, options = {}) {
      const localVarPath = `/services/payment-calendar`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (idempotencyKey !== void 0 && idempotencyKey !== null) {
        localVarHeaderParameter["Idempotency-Key"] = String(idempotencyKey);
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postPaymentCalendarRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Payment Calendar bulk calculator
     * @summary Payment Calendar bulk calculator
     * @param {Array<PostPaymentCalendarRequest>} [postPaymentCalendarRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postServicesPaymentCalendarBulk: (_0, _1, _2, ..._3) => __async(this, [_0, _1, _2, ..._3], function* (postPaymentCalendarRequest, idempotencyKey, melioAccount, options = {}) {
      const localVarPath = `/services/payment-calendar/bulk`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (idempotencyKey !== void 0 && idempotencyKey !== null) {
        localVarHeaderParameter["Idempotency-Key"] = String(idempotencyKey);
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postPaymentCalendarRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Payment settings calculator.
     * @summary Payment settings calculator
     * @param {PostPaymentSettingsCalculatorRequest} [postPaymentSettingsCalculatorRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {boolean} [fillWithDefaults] fill rest of payment settings with defaults
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postServicesPaymentSettings: (_0, _1, _2, _3, _4, ..._5) => __async(this, [_0, _1, _2, _3, _4, ..._5], function* (postPaymentSettingsCalculatorRequest, idempotencyKey, melioAccount, expand, fillWithDefaults, options = {}) {
      const localVarPath = `/services/payment-settings`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (fillWithDefaults !== void 0) {
        localVarQueryParameter["fillWithDefaults"] = fillWithDefaults;
      }
      if (idempotencyKey !== void 0 && idempotencyKey !== null) {
        localVarHeaderParameter["Idempotency-Key"] = String(idempotencyKey);
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      if (expand !== void 0 && expand !== null) {
        localVarHeaderParameter["expand"] = String(JSON.stringify(expand));
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postPaymentSettingsCalculatorRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Payment settings bulk calculator.
     * @summary Payment settings bulk calculator
     * @param {Array<PostPaymentSettingsCalculatorRequest>} [postPaymentSettingsCalculatorRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {boolean} [fillWithDefaults] fill rest of payment settings with defaults
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postServicesPaymentSettingsBulk: (_0, _1, _2, _3, _4, ..._5) => __async(this, [_0, _1, _2, _3, _4, ..._5], function* (postPaymentSettingsCalculatorRequest, idempotencyKey, melioAccount, expand, fillWithDefaults, options = {}) {
      const localVarPath = `/services/payment-settings/bulk`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (fillWithDefaults !== void 0) {
        localVarQueryParameter["fillWithDefaults"] = fillWithDefaults;
      }
      if (idempotencyKey !== void 0 && idempotencyKey !== null) {
        localVarHeaderParameter["Idempotency-Key"] = String(idempotencyKey);
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      if (expand !== void 0 && expand !== null) {
        localVarHeaderParameter["expand"] = String(JSON.stringify(expand));
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postPaymentSettingsCalculatorRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Payment settings check approval requirement
     * @summary Payment settings check approval requirement
     * @param {PostPaymentSettingsCheckApprovalRequirementRequest} [postPaymentSettingsCheckApprovalRequirementRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postServicesPaymentSettingsCheckApprovalRequirement: (_0, _1, _2, ..._3) => __async(this, [_0, _1, _2, ..._3], function* (postPaymentSettingsCheckApprovalRequirementRequest, idempotencyKey, melioAccount, options = {}) {
      const localVarPath = `/services/payment-settings/check-approval-requirement`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (idempotencyKey !== void 0 && idempotencyKey !== null) {
        localVarHeaderParameter["Idempotency-Key"] = String(idempotencyKey);
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postPaymentSettingsCheckApprovalRequirementRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Verify an address.
     * @summary Verify address
     * @param {PostAddressValidationParams} [postAddressValidationParams] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postServicesVerifyAddress: (_0, _1, _2, ..._3) => __async(this, [_0, _1, _2, ..._3], function* (postAddressValidationParams, idempotencyKey, melioAccount, options = {}) {
      const localVarPath = `/services/verify-address`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (idempotencyKey !== void 0 && idempotencyKey !== null) {
        localVarHeaderParameter["Idempotency-Key"] = String(idempotencyKey);
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postAddressValidationParams, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Verify a credit/debit card.
     * @summary Verify card
     * @param {PostVerifyCardRequest} [postVerifyCardRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postServicesVerifyCard: (_0, _1, _2, ..._3) => __async(this, [_0, _1, _2, ..._3], function* (postVerifyCardRequest, idempotencyKey, melioAccount, options = {}) {
      const localVarPath = `/services/verify-card`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (idempotencyKey !== void 0 && idempotencyKey !== null) {
        localVarHeaderParameter["Idempotency-Key"] = String(idempotencyKey);
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postVerifyCardRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    })
  };
};
var ServicesApiFp = function(configuration) {
  const localVarAxiosParamCreator = ServicesApiAxiosParamCreator(configuration);
  return {
    /**
     * Payment Calendar calculator
     * @summary Payment Calendar calculator
     * @param {PostPaymentCalendarRequest} [postPaymentCalendarRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postServicesPaymentCalendar(postPaymentCalendarRequest, idempotencyKey, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postServicesPaymentCalendar(postPaymentCalendarRequest, idempotencyKey, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Payment Calendar bulk calculator
     * @summary Payment Calendar bulk calculator
     * @param {Array<PostPaymentCalendarRequest>} [postPaymentCalendarRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postServicesPaymentCalendarBulk(postPaymentCalendarRequest, idempotencyKey, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postServicesPaymentCalendarBulk(postPaymentCalendarRequest, idempotencyKey, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Payment settings calculator.
     * @summary Payment settings calculator
     * @param {PostPaymentSettingsCalculatorRequest} [postPaymentSettingsCalculatorRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {boolean} [fillWithDefaults] fill rest of payment settings with defaults
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postServicesPaymentSettings(postPaymentSettingsCalculatorRequest, idempotencyKey, melioAccount, expand, fillWithDefaults, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postServicesPaymentSettings(postPaymentSettingsCalculatorRequest, idempotencyKey, melioAccount, expand, fillWithDefaults, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Payment settings bulk calculator.
     * @summary Payment settings bulk calculator
     * @param {Array<PostPaymentSettingsCalculatorRequest>} [postPaymentSettingsCalculatorRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {boolean} [fillWithDefaults] fill rest of payment settings with defaults
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postServicesPaymentSettingsBulk(postPaymentSettingsCalculatorRequest, idempotencyKey, melioAccount, expand, fillWithDefaults, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postServicesPaymentSettingsBulk(postPaymentSettingsCalculatorRequest, idempotencyKey, melioAccount, expand, fillWithDefaults, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Payment settings check approval requirement
     * @summary Payment settings check approval requirement
     * @param {PostPaymentSettingsCheckApprovalRequirementRequest} [postPaymentSettingsCheckApprovalRequirementRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postServicesPaymentSettingsCheckApprovalRequirement(postPaymentSettingsCheckApprovalRequirementRequest, idempotencyKey, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postServicesPaymentSettingsCheckApprovalRequirement(postPaymentSettingsCheckApprovalRequirementRequest, idempotencyKey, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Verify an address.
     * @summary Verify address
     * @param {PostAddressValidationParams} [postAddressValidationParams] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postServicesVerifyAddress(postAddressValidationParams, idempotencyKey, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postServicesVerifyAddress(postAddressValidationParams, idempotencyKey, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Verify a credit/debit card.
     * @summary Verify card
     * @param {PostVerifyCardRequest} [postVerifyCardRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postServicesVerifyCard(postVerifyCardRequest, idempotencyKey, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postServicesVerifyCard(postVerifyCardRequest, idempotencyKey, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    }
  };
};
var ServicesApiClient = createApiFromFp(ServicesApiFp);
var ServicesApiFactory = function(configuration, basePath, axios2) {
  const localVarFp = ServicesApiFp(configuration);
  return {
    /**
     * Payment Calendar calculator
     * @summary Payment Calendar calculator
     * @param {PostPaymentCalendarRequest} [postPaymentCalendarRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postServicesPaymentCalendar(postPaymentCalendarRequest, idempotencyKey, melioAccount, options) {
      return localVarFp.postServicesPaymentCalendar(postPaymentCalendarRequest, idempotencyKey, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Payment Calendar bulk calculator
     * @summary Payment Calendar bulk calculator
     * @param {Array<PostPaymentCalendarRequest>} [postPaymentCalendarRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postServicesPaymentCalendarBulk(postPaymentCalendarRequest, idempotencyKey, melioAccount, options) {
      return localVarFp.postServicesPaymentCalendarBulk(postPaymentCalendarRequest, idempotencyKey, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Payment settings calculator.
     * @summary Payment settings calculator
     * @param {PostPaymentSettingsCalculatorRequest} [postPaymentSettingsCalculatorRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {boolean} [fillWithDefaults] fill rest of payment settings with defaults
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postServicesPaymentSettings(postPaymentSettingsCalculatorRequest, idempotencyKey, melioAccount, expand, fillWithDefaults, options) {
      return localVarFp.postServicesPaymentSettings(postPaymentSettingsCalculatorRequest, idempotencyKey, melioAccount, expand, fillWithDefaults, options).then((request) => request(axios2, basePath));
    },
    /**
     * Payment settings bulk calculator.
     * @summary Payment settings bulk calculator
     * @param {Array<PostPaymentSettingsCalculatorRequest>} [postPaymentSettingsCalculatorRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {boolean} [fillWithDefaults] fill rest of payment settings with defaults
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postServicesPaymentSettingsBulk(postPaymentSettingsCalculatorRequest, idempotencyKey, melioAccount, expand, fillWithDefaults, options) {
      return localVarFp.postServicesPaymentSettingsBulk(postPaymentSettingsCalculatorRequest, idempotencyKey, melioAccount, expand, fillWithDefaults, options).then((request) => request(axios2, basePath));
    },
    /**
     * Payment settings check approval requirement
     * @summary Payment settings check approval requirement
     * @param {PostPaymentSettingsCheckApprovalRequirementRequest} [postPaymentSettingsCheckApprovalRequirementRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postServicesPaymentSettingsCheckApprovalRequirement(postPaymentSettingsCheckApprovalRequirementRequest, idempotencyKey, melioAccount, options) {
      return localVarFp.postServicesPaymentSettingsCheckApprovalRequirement(postPaymentSettingsCheckApprovalRequirementRequest, idempotencyKey, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Verify an address.
     * @summary Verify address
     * @param {PostAddressValidationParams} [postAddressValidationParams] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postServicesVerifyAddress(postAddressValidationParams, idempotencyKey, melioAccount, options) {
      return localVarFp.postServicesVerifyAddress(postAddressValidationParams, idempotencyKey, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Verify a credit/debit card.
     * @summary Verify card
     * @param {PostVerifyCardRequest} [postVerifyCardRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postServicesVerifyCard(postVerifyCardRequest, idempotencyKey, melioAccount, options) {
      return localVarFp.postServicesVerifyCard(postVerifyCardRequest, idempotencyKey, melioAccount, options).then((request) => request(axios2, basePath));
    }
  };
};
var ServicesApi = class extends BaseAPI {
  /**
   * Payment Calendar calculator
   * @summary Payment Calendar calculator
   * @param {ServicesApiPostServicesPaymentCalendarRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ServicesApi
   */
  postServicesPaymentCalendar(requestParameters = {}, options) {
    return ServicesApiFp(this.configuration).postServicesPaymentCalendar(requestParameters.postPaymentCalendarRequest, requestParameters.idempotencyKey, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Payment Calendar bulk calculator
   * @summary Payment Calendar bulk calculator
   * @param {ServicesApiPostServicesPaymentCalendarBulkRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ServicesApi
   */
  postServicesPaymentCalendarBulk(requestParameters = {}, options) {
    return ServicesApiFp(this.configuration).postServicesPaymentCalendarBulk(requestParameters.postPaymentCalendarRequest, requestParameters.idempotencyKey, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Payment settings calculator.
   * @summary Payment settings calculator
   * @param {ServicesApiPostServicesPaymentSettingsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ServicesApi
   */
  postServicesPaymentSettings(requestParameters = {}, options) {
    return ServicesApiFp(this.configuration).postServicesPaymentSettings(requestParameters.postPaymentSettingsCalculatorRequest, requestParameters.idempotencyKey, requestParameters.melioAccount, requestParameters.expand, requestParameters.fillWithDefaults, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Payment settings bulk calculator.
   * @summary Payment settings bulk calculator
   * @param {ServicesApiPostServicesPaymentSettingsBulkRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ServicesApi
   */
  postServicesPaymentSettingsBulk(requestParameters = {}, options) {
    return ServicesApiFp(this.configuration).postServicesPaymentSettingsBulk(requestParameters.postPaymentSettingsCalculatorRequest, requestParameters.idempotencyKey, requestParameters.melioAccount, requestParameters.expand, requestParameters.fillWithDefaults, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Payment settings check approval requirement
   * @summary Payment settings check approval requirement
   * @param {ServicesApiPostServicesPaymentSettingsCheckApprovalRequirementRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ServicesApi
   */
  postServicesPaymentSettingsCheckApprovalRequirement(requestParameters = {}, options) {
    return ServicesApiFp(this.configuration).postServicesPaymentSettingsCheckApprovalRequirement(requestParameters.postPaymentSettingsCheckApprovalRequirementRequest, requestParameters.idempotencyKey, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Verify an address.
   * @summary Verify address
   * @param {ServicesApiPostServicesVerifyAddressRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ServicesApi
   */
  postServicesVerifyAddress(requestParameters = {}, options) {
    return ServicesApiFp(this.configuration).postServicesVerifyAddress(requestParameters.postAddressValidationParams, requestParameters.idempotencyKey, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Verify a credit/debit card.
   * @summary Verify card
   * @param {ServicesApiPostServicesVerifyCardRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ServicesApi
   */
  postServicesVerifyCard(requestParameters = {}, options) {
    return ServicesApiFp(this.configuration).postServicesVerifyCard(requestParameters.postVerifyCardRequest, requestParameters.idempotencyKey, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
};
var ServicesApiInstance = createInstanceFromApiIClass(ServicesApi);
var SignaturesApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * Delete a Signature.
     * @summary Delete a Signature
     * @param {string} id ID of the entity
     * @param {string} signatureId 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteSignaturesSignatureId: (_0, _1, _2, ..._3) => __async(this, [_0, _1, _2, ..._3], function* (id, signatureId, melioAccount, options = {}) {
      assertParamExists("deleteSignaturesSignatureId", "id", id);
      assertParamExists("deleteSignaturesSignatureId", "signatureId", signatureId);
      const localVarPath = `/agreements/{id}/signatures/{signatureId}`.replace(`{${"id"}}`, encodeURIComponent(String(id))).replace(`{${"signatureId"}}`, encodeURIComponent(String(signatureId)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "DELETE" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Retrieve a list of all Signatures
     * @summary Retrieve all Signatures
     * @param {string} id ID of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSignatures: (_0, ..._1) => __async(this, [_0, ..._1], function* (id, options = {}) {
      assertParamExists("getSignatures", "id", id);
      const localVarPath = `/agreements/{id}/signatures`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Retrieve a Signature using its ID.
     * @summary Retrieve a Signature
     * @param {string} id ID of the entity
     * @param {string} signatureId 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSignaturesSignatureId: (_0, _1, _2, ..._3) => __async(this, [_0, _1, _2, ..._3], function* (id, signatureId, melioAccount, options = {}) {
      assertParamExists("getSignaturesSignatureId", "id", id);
      assertParamExists("getSignaturesSignatureId", "signatureId", signatureId);
      const localVarPath = `/agreements/{id}/signatures/{signatureId}`.replace(`{${"id"}}`, encodeURIComponent(String(id))).replace(`{${"signatureId"}}`, encodeURIComponent(String(signatureId)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Create a Signature.
     * @summary Create a Signature
     * @param {string} id ID of the entity
     * @param {SignatureCreateParams} [signatureCreateParams] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postSignatures: (_0, _1, _2, _3, ..._4) => __async(this, [_0, _1, _2, _3, ..._4], function* (id, signatureCreateParams, idempotencyKey, melioAccount, options = {}) {
      assertParamExists("postSignatures", "id", id);
      const localVarPath = `/agreements/{id}/signatures`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (idempotencyKey !== void 0 && idempotencyKey !== null) {
        localVarHeaderParameter["Idempotency-Key"] = String(idempotencyKey);
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(signatureCreateParams, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    })
  };
};
var SignaturesApiFp = function(configuration) {
  const localVarAxiosParamCreator = SignaturesApiAxiosParamCreator(configuration);
  return {
    /**
     * Delete a Signature.
     * @summary Delete a Signature
     * @param {string} id ID of the entity
     * @param {string} signatureId 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteSignaturesSignatureId(id, signatureId, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteSignaturesSignatureId(id, signatureId, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Retrieve a list of all Signatures
     * @summary Retrieve all Signatures
     * @param {string} id ID of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSignatures(id, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getSignatures(id, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Retrieve a Signature using its ID.
     * @summary Retrieve a Signature
     * @param {string} id ID of the entity
     * @param {string} signatureId 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSignaturesSignatureId(id, signatureId, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getSignaturesSignatureId(id, signatureId, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Create a Signature.
     * @summary Create a Signature
     * @param {string} id ID of the entity
     * @param {SignatureCreateParams} [signatureCreateParams] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postSignatures(id, signatureCreateParams, idempotencyKey, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postSignatures(id, signatureCreateParams, idempotencyKey, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    }
  };
};
var SignaturesApiClient = createApiFromFp(SignaturesApiFp);
var SignaturesApiFactory = function(configuration, basePath, axios2) {
  const localVarFp = SignaturesApiFp(configuration);
  return {
    /**
     * Delete a Signature.
     * @summary Delete a Signature
     * @param {string} id ID of the entity
     * @param {string} signatureId 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteSignaturesSignatureId(id, signatureId, melioAccount, options) {
      return localVarFp.deleteSignaturesSignatureId(id, signatureId, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Retrieve a list of all Signatures
     * @summary Retrieve all Signatures
     * @param {string} id ID of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSignatures(id, options) {
      return localVarFp.getSignatures(id, options).then((request) => request(axios2, basePath));
    },
    /**
     * Retrieve a Signature using its ID.
     * @summary Retrieve a Signature
     * @param {string} id ID of the entity
     * @param {string} signatureId 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSignaturesSignatureId(id, signatureId, melioAccount, options) {
      return localVarFp.getSignaturesSignatureId(id, signatureId, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Create a Signature.
     * @summary Create a Signature
     * @param {string} id ID of the entity
     * @param {SignatureCreateParams} [signatureCreateParams] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postSignatures(id, signatureCreateParams, idempotencyKey, melioAccount, options) {
      return localVarFp.postSignatures(id, signatureCreateParams, idempotencyKey, melioAccount, options).then((request) => request(axios2, basePath));
    }
  };
};
var SignaturesApi = class extends BaseAPI {
  /**
   * Delete a Signature.
   * @summary Delete a Signature
   * @param {SignaturesApiDeleteSignaturesSignatureIdRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SignaturesApi
   */
  deleteSignaturesSignatureId(requestParameters, options) {
    return SignaturesApiFp(this.configuration).deleteSignaturesSignatureId(requestParameters.id, requestParameters.signatureId, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Retrieve a list of all Signatures
   * @summary Retrieve all Signatures
   * @param {SignaturesApiGetSignaturesRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SignaturesApi
   */
  getSignatures(requestParameters, options) {
    return SignaturesApiFp(this.configuration).getSignatures(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Retrieve a Signature using its ID.
   * @summary Retrieve a Signature
   * @param {SignaturesApiGetSignaturesSignatureIdRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SignaturesApi
   */
  getSignaturesSignatureId(requestParameters, options) {
    return SignaturesApiFp(this.configuration).getSignaturesSignatureId(requestParameters.id, requestParameters.signatureId, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Create a Signature.
   * @summary Create a Signature
   * @param {SignaturesApiPostSignaturesRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SignaturesApi
   */
  postSignatures(requestParameters, options) {
    return SignaturesApiFp(this.configuration).postSignatures(requestParameters.id, requestParameters.signatureCreateParams, requestParameters.idempotencyKey, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
};
var SignaturesApiInstance = createInstanceFromApiIClass(SignaturesApi);
var SubscriptionOrganizationsApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSubscriptionOrganization: (_0, _1, _2, ..._3) => __async(this, [_0, _1, _2, ..._3], function* (melioAccount, organizationId, userId, options = {}) {
      const localVarPath = `/subscription-organizations`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      if (organizationId !== void 0 && organizationId !== null) {
        localVarHeaderParameter["Organization-id"] = String(organizationId);
      }
      if (userId !== void 0 && userId !== null) {
        localVarHeaderParameter["User-id"] = String(userId);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    })
  };
};
var SubscriptionOrganizationsApiFp = function(configuration) {
  const localVarAxiosParamCreator = SubscriptionOrganizationsApiAxiosParamCreator(configuration);
  return {
    /**
     * 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSubscriptionOrganization(melioAccount, organizationId, userId, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getSubscriptionOrganization(melioAccount, organizationId, userId, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    }
  };
};
var SubscriptionOrganizationsApiClient = createApiFromFp(SubscriptionOrganizationsApiFp);
var SubscriptionOrganizationsApiFactory = function(configuration, basePath, axios2) {
  const localVarFp = SubscriptionOrganizationsApiFp(configuration);
  return {
    /**
     * 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSubscriptionOrganization(melioAccount, organizationId, userId, options) {
      return localVarFp.getSubscriptionOrganization(melioAccount, organizationId, userId, options).then((request) => request(axios2, basePath));
    }
  };
};
var SubscriptionOrganizationsApi = class extends BaseAPI {
  /**
   * 
   * @param {SubscriptionOrganizationsApiGetSubscriptionOrganizationRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SubscriptionOrganizationsApi
   */
  getSubscriptionOrganization(requestParameters = {}, options) {
    return SubscriptionOrganizationsApiFp(this.configuration).getSubscriptionOrganization(requestParameters.melioAccount, requestParameters.organizationId, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
  }
};
var SubscriptionOrganizationsApiInstance = createInstanceFromApiIClass(SubscriptionOrganizationsApi);
var SubscriptionSyncedPaymentsApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSubscriptionsSyncedPayments: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (organizationId, userId, options = {}) {
      const localVarPath = `/subscriptions/synced-payments-count`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (organizationId !== void 0 && organizationId !== null) {
        localVarHeaderParameter["Organization-id"] = String(organizationId);
      }
      if (userId !== void 0 && userId !== null) {
        localVarHeaderParameter["User-id"] = String(userId);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    })
  };
};
var SubscriptionSyncedPaymentsApiFp = function(configuration) {
  const localVarAxiosParamCreator = SubscriptionSyncedPaymentsApiAxiosParamCreator(configuration);
  return {
    /**
     * 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSubscriptionsSyncedPayments(organizationId, userId, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getSubscriptionsSyncedPayments(organizationId, userId, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    }
  };
};
var SubscriptionSyncedPaymentsApiClient = createApiFromFp(SubscriptionSyncedPaymentsApiFp);
var SubscriptionSyncedPaymentsApiFactory = function(configuration, basePath, axios2) {
  const localVarFp = SubscriptionSyncedPaymentsApiFp(configuration);
  return {
    /**
     * 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSubscriptionsSyncedPayments(organizationId, userId, options) {
      return localVarFp.getSubscriptionsSyncedPayments(organizationId, userId, options).then((request) => request(axios2, basePath));
    }
  };
};
var SubscriptionSyncedPaymentsApi = class extends BaseAPI {
  /**
   * 
   * @param {SubscriptionSyncedPaymentsApiGetSubscriptionsSyncedPaymentsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SubscriptionSyncedPaymentsApi
   */
  getSubscriptionsSyncedPayments(requestParameters = {}, options) {
    return SubscriptionSyncedPaymentsApiFp(this.configuration).getSubscriptionsSyncedPayments(requestParameters.organizationId, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
  }
};
var SubscriptionSyncedPaymentsApiInstance = createInstanceFromApiIClass(SubscriptionSyncedPaymentsApi);
var SubscriptionsApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * 
     * @param {string} key 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPromoCode: (_0, _1, _2, _3, ..._4) => __async(this, [_0, _1, _2, _3, ..._4], function* (key, melioAccount, organizationId, userId, options = {}) {
      assertParamExists("getPromoCode", "key", key);
      const localVarPath = `/promo-codes/{key}`.replace(`{${"key"}}`, encodeURIComponent(String(key)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      if (organizationId !== void 0 && organizationId !== null) {
        localVarHeaderParameter["Organization-id"] = String(organizationId);
      }
      if (userId !== void 0 && userId !== null) {
        localVarHeaderParameter["User-id"] = String(userId);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * 
     * @param {string} id Get subscription receipt data pdf as base64
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSubscriptionReceiptPdf: (_0, _1, _2, _3, ..._4) => __async(this, [_0, _1, _2, _3, ..._4], function* (id, melioAccount, organizationId, userId, options = {}) {
      assertParamExists("getSubscriptionReceiptPdf", "id", id);
      const localVarPath = `/subscriptions/receipt/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      if (organizationId !== void 0 && organizationId !== null) {
        localVarHeaderParameter["Organization-id"] = String(organizationId);
      }
      if (userId !== void 0 && userId !== null) {
        localVarHeaderParameter["User-id"] = String(userId);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Retrieve all billings for subscriptions
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSubscriptionsBillings: (_0, _1, _2, ..._3) => __async(this, [_0, _1, _2, ..._3], function* (melioAccount, organizationId, userId, options = {}) {
      const localVarPath = `/subscriptions/billings`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      if (organizationId !== void 0 && organizationId !== null) {
        localVarHeaderParameter["Organization-id"] = String(organizationId);
      }
      if (userId !== void 0 && userId !== null) {
        localVarHeaderParameter["User-id"] = String(userId);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSubscriptionsFeatures: (_0, _1, _2, ..._3) => __async(this, [_0, _1, _2, ..._3], function* (melioAccount, organizationId, userId, options = {}) {
      const localVarPath = `/subscriptions/features`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      if (organizationId !== void 0 && organizationId !== null) {
        localVarHeaderParameter["Organization-id"] = String(organizationId);
      }
      if (userId !== void 0 && userId !== null) {
        localVarHeaderParameter["User-id"] = String(userId);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSubscriptionsMe: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (organizationId, userId, options = {}) {
      const localVarPath = `/subscriptions/me`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (organizationId !== void 0 && organizationId !== null) {
        localVarHeaderParameter["Organization-id"] = String(organizationId);
      }
      if (userId !== void 0 && userId !== null) {
        localVarHeaderParameter["User-id"] = String(userId);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * 
     * @param {PatchSubscriptionMeRequest} [patchSubscriptionMeRequest] 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchSubscriptionsMe: (_0, _1, _2, _3, ..._4) => __async(this, [_0, _1, _2, _3, ..._4], function* (patchSubscriptionMeRequest, organizationId, userId, idempotencyKey, options = {}) {
      const localVarPath = `/subscriptions/me`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "PATCH" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (organizationId !== void 0 && organizationId !== null) {
        localVarHeaderParameter["Organization-id"] = String(organizationId);
      }
      if (userId !== void 0 && userId !== null) {
        localVarHeaderParameter["User-id"] = String(userId);
      }
      if (idempotencyKey !== void 0 && idempotencyKey !== null) {
        localVarHeaderParameter["Idempotency-Key"] = String(idempotencyKey);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(patchSubscriptionMeRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * 
     * @param {PostSubscriptionRequest} [postSubscriptionRequest] 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postSubscriptions: (_0, _1, _2, _3, ..._4) => __async(this, [_0, _1, _2, _3, ..._4], function* (postSubscriptionRequest, melioAccount, organizationId, userId, options = {}) {
      const localVarPath = `/subscriptions`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      if (organizationId !== void 0 && organizationId !== null) {
        localVarHeaderParameter["Organization-id"] = String(organizationId);
      }
      if (userId !== void 0 && userId !== null) {
        localVarHeaderParameter["User-id"] = String(userId);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postSubscriptionRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * 
     * @summary Create a subscription preview
     * @param {PostSubscriptionPreviewRequest} [postSubscriptionPreviewRequest] 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postSubscriptionsPreview: (_0, _1, _2, _3, ..._4) => __async(this, [_0, _1, _2, _3, ..._4], function* (postSubscriptionPreviewRequest, melioAccount, organizationId, userId, options = {}) {
      const localVarPath = `/subscriptions/preview`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      if (organizationId !== void 0 && organizationId !== null) {
        localVarHeaderParameter["Organization-id"] = String(organizationId);
      }
      if (userId !== void 0 && userId !== null) {
        localVarHeaderParameter["User-id"] = String(userId);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postSubscriptionPreviewRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    })
  };
};
var SubscriptionsApiFp = function(configuration) {
  const localVarAxiosParamCreator = SubscriptionsApiAxiosParamCreator(configuration);
  return {
    /**
     * 
     * @param {string} key 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPromoCode(key, melioAccount, organizationId, userId, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getPromoCode(key, melioAccount, organizationId, userId, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * 
     * @param {string} id Get subscription receipt data pdf as base64
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSubscriptionReceiptPdf(id, melioAccount, organizationId, userId, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getSubscriptionReceiptPdf(id, melioAccount, organizationId, userId, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Retrieve all billings for subscriptions
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSubscriptionsBillings(melioAccount, organizationId, userId, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getSubscriptionsBillings(melioAccount, organizationId, userId, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSubscriptionsFeatures(melioAccount, organizationId, userId, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getSubscriptionsFeatures(melioAccount, organizationId, userId, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSubscriptionsMe(organizationId, userId, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getSubscriptionsMe(organizationId, userId, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * 
     * @param {PatchSubscriptionMeRequest} [patchSubscriptionMeRequest] 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchSubscriptionsMe(patchSubscriptionMeRequest, organizationId, userId, idempotencyKey, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.patchSubscriptionsMe(patchSubscriptionMeRequest, organizationId, userId, idempotencyKey, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * 
     * @param {PostSubscriptionRequest} [postSubscriptionRequest] 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postSubscriptions(postSubscriptionRequest, melioAccount, organizationId, userId, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postSubscriptions(postSubscriptionRequest, melioAccount, organizationId, userId, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * 
     * @summary Create a subscription preview
     * @param {PostSubscriptionPreviewRequest} [postSubscriptionPreviewRequest] 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postSubscriptionsPreview(postSubscriptionPreviewRequest, melioAccount, organizationId, userId, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postSubscriptionsPreview(postSubscriptionPreviewRequest, melioAccount, organizationId, userId, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    }
  };
};
var SubscriptionsApiClient = createApiFromFp(SubscriptionsApiFp);
var SubscriptionsApiFactory = function(configuration, basePath, axios2) {
  const localVarFp = SubscriptionsApiFp(configuration);
  return {
    /**
     * 
     * @param {string} key 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPromoCode(key, melioAccount, organizationId, userId, options) {
      return localVarFp.getPromoCode(key, melioAccount, organizationId, userId, options).then((request) => request(axios2, basePath));
    },
    /**
     * 
     * @param {string} id Get subscription receipt data pdf as base64
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSubscriptionReceiptPdf(id, melioAccount, organizationId, userId, options) {
      return localVarFp.getSubscriptionReceiptPdf(id, melioAccount, organizationId, userId, options).then((request) => request(axios2, basePath));
    },
    /**
     * Retrieve all billings for subscriptions
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSubscriptionsBillings(melioAccount, organizationId, userId, options) {
      return localVarFp.getSubscriptionsBillings(melioAccount, organizationId, userId, options).then((request) => request(axios2, basePath));
    },
    /**
     * 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSubscriptionsFeatures(melioAccount, organizationId, userId, options) {
      return localVarFp.getSubscriptionsFeatures(melioAccount, organizationId, userId, options).then((request) => request(axios2, basePath));
    },
    /**
     * 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSubscriptionsMe(organizationId, userId, options) {
      return localVarFp.getSubscriptionsMe(organizationId, userId, options).then((request) => request(axios2, basePath));
    },
    /**
     * 
     * @param {PatchSubscriptionMeRequest} [patchSubscriptionMeRequest] 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchSubscriptionsMe(patchSubscriptionMeRequest, organizationId, userId, idempotencyKey, options) {
      return localVarFp.patchSubscriptionsMe(patchSubscriptionMeRequest, organizationId, userId, idempotencyKey, options).then((request) => request(axios2, basePath));
    },
    /**
     * 
     * @param {PostSubscriptionRequest} [postSubscriptionRequest] 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postSubscriptions(postSubscriptionRequest, melioAccount, organizationId, userId, options) {
      return localVarFp.postSubscriptions(postSubscriptionRequest, melioAccount, organizationId, userId, options).then((request) => request(axios2, basePath));
    },
    /**
     * 
     * @summary Create a subscription preview
     * @param {PostSubscriptionPreviewRequest} [postSubscriptionPreviewRequest] 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postSubscriptionsPreview(postSubscriptionPreviewRequest, melioAccount, organizationId, userId, options) {
      return localVarFp.postSubscriptionsPreview(postSubscriptionPreviewRequest, melioAccount, organizationId, userId, options).then((request) => request(axios2, basePath));
    }
  };
};
var SubscriptionsApi = class extends BaseAPI {
  /**
   * 
   * @param {SubscriptionsApiGetPromoCodeRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SubscriptionsApi
   */
  getPromoCode(requestParameters, options) {
    return SubscriptionsApiFp(this.configuration).getPromoCode(requestParameters.key, requestParameters.melioAccount, requestParameters.organizationId, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * 
   * @param {SubscriptionsApiGetSubscriptionReceiptPdfRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SubscriptionsApi
   */
  getSubscriptionReceiptPdf(requestParameters, options) {
    return SubscriptionsApiFp(this.configuration).getSubscriptionReceiptPdf(requestParameters.id, requestParameters.melioAccount, requestParameters.organizationId, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Retrieve all billings for subscriptions
   * @param {SubscriptionsApiGetSubscriptionsBillingsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SubscriptionsApi
   */
  getSubscriptionsBillings(requestParameters = {}, options) {
    return SubscriptionsApiFp(this.configuration).getSubscriptionsBillings(requestParameters.melioAccount, requestParameters.organizationId, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * 
   * @param {SubscriptionsApiGetSubscriptionsFeaturesRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SubscriptionsApi
   */
  getSubscriptionsFeatures(requestParameters = {}, options) {
    return SubscriptionsApiFp(this.configuration).getSubscriptionsFeatures(requestParameters.melioAccount, requestParameters.organizationId, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * 
   * @param {SubscriptionsApiGetSubscriptionsMeRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SubscriptionsApi
   */
  getSubscriptionsMe(requestParameters = {}, options) {
    return SubscriptionsApiFp(this.configuration).getSubscriptionsMe(requestParameters.organizationId, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * 
   * @param {SubscriptionsApiPatchSubscriptionsMeRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SubscriptionsApi
   */
  patchSubscriptionsMe(requestParameters = {}, options) {
    return SubscriptionsApiFp(this.configuration).patchSubscriptionsMe(requestParameters.patchSubscriptionMeRequest, requestParameters.organizationId, requestParameters.userId, requestParameters.idempotencyKey, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * 
   * @param {SubscriptionsApiPostSubscriptionsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SubscriptionsApi
   */
  postSubscriptions(requestParameters = {}, options) {
    return SubscriptionsApiFp(this.configuration).postSubscriptions(requestParameters.postSubscriptionRequest, requestParameters.melioAccount, requestParameters.organizationId, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Create a subscription preview
   * @param {SubscriptionsApiPostSubscriptionsPreviewRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SubscriptionsApi
   */
  postSubscriptionsPreview(requestParameters = {}, options) {
    return SubscriptionsApiFp(this.configuration).postSubscriptionsPreview(requestParameters.postSubscriptionPreviewRequest, requestParameters.melioAccount, requestParameters.organizationId, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
  }
};
var SubscriptionsApiInstance = createInstanceFromApiIClass(SubscriptionsApi);
var SupportApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * 
     * @summary get the zendesk schedule for support
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getZdSchedule: (..._0) => __async(this, [..._0], function* (options = {}) {
      const localVarPath = `/support/request-zendesk-schedule`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * 
     * @summary Get the smart form token to authenticate the user with support-service
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    issueSmartFormToken: (..._0) => __async(this, [..._0], function* (options = {}) {
      const localVarPath = `/support/issue-smart-form-token`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * 
     * @summary get the user zendesk token to authenticate the user with the zendesk widget
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    issueZendeskToken: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (organizationId, userId, options = {}) {
      const localVarPath = `/support/issue-zendesk-token`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (organizationId !== void 0 && organizationId !== null) {
        localVarHeaderParameter["Organization-id"] = String(organizationId);
      }
      if (userId !== void 0 && userId !== null) {
        localVarHeaderParameter["User-id"] = String(userId);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * 
     * @summary request a callback from the support team
     * @param {SupportRequestCallbackBody} [supportRequestCallbackBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postSupportRequestCallback: (_0, ..._1) => __async(this, [_0, ..._1], function* (supportRequestCallbackBody, options = {}) {
      const localVarPath = `/support/request-callback`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(supportRequestCallbackBody, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    })
  };
};
var SupportApiFp = function(configuration) {
  const localVarAxiosParamCreator = SupportApiAxiosParamCreator(configuration);
  return {
    /**
     * 
     * @summary get the zendesk schedule for support
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getZdSchedule(options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getZdSchedule(options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * 
     * @summary Get the smart form token to authenticate the user with support-service
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    issueSmartFormToken(options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.issueSmartFormToken(options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * 
     * @summary get the user zendesk token to authenticate the user with the zendesk widget
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    issueZendeskToken(organizationId, userId, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.issueZendeskToken(organizationId, userId, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * 
     * @summary request a callback from the support team
     * @param {SupportRequestCallbackBody} [supportRequestCallbackBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postSupportRequestCallback(supportRequestCallbackBody, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postSupportRequestCallback(supportRequestCallbackBody, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    }
  };
};
var SupportApiClient = createApiFromFp(SupportApiFp);
var SupportApiFactory = function(configuration, basePath, axios2) {
  const localVarFp = SupportApiFp(configuration);
  return {
    /**
     * 
     * @summary get the zendesk schedule for support
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getZdSchedule(options) {
      return localVarFp.getZdSchedule(options).then((request) => request(axios2, basePath));
    },
    /**
     * 
     * @summary Get the smart form token to authenticate the user with support-service
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    issueSmartFormToken(options) {
      return localVarFp.issueSmartFormToken(options).then((request) => request(axios2, basePath));
    },
    /**
     * 
     * @summary get the user zendesk token to authenticate the user with the zendesk widget
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    issueZendeskToken(organizationId, userId, options) {
      return localVarFp.issueZendeskToken(organizationId, userId, options).then((request) => request(axios2, basePath));
    },
    /**
     * 
     * @summary request a callback from the support team
     * @param {SupportRequestCallbackBody} [supportRequestCallbackBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postSupportRequestCallback(supportRequestCallbackBody, options) {
      return localVarFp.postSupportRequestCallback(supportRequestCallbackBody, options).then((request) => request(axios2, basePath));
    }
  };
};
var SupportApi = class extends BaseAPI {
  /**
   * 
   * @summary get the zendesk schedule for support
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SupportApi
   */
  getZdSchedule(options) {
    return SupportApiFp(this.configuration).getZdSchedule(options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Get the smart form token to authenticate the user with support-service
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SupportApi
   */
  issueSmartFormToken(options) {
    return SupportApiFp(this.configuration).issueSmartFormToken(options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * 
   * @summary get the user zendesk token to authenticate the user with the zendesk widget
   * @param {SupportApiIssueZendeskTokenRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SupportApi
   */
  issueZendeskToken(requestParameters = {}, options) {
    return SupportApiFp(this.configuration).issueZendeskToken(requestParameters.organizationId, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * 
   * @summary request a callback from the support team
   * @param {SupportApiPostSupportRequestCallbackRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SupportApi
   */
  postSupportRequestCallback(requestParameters = {}, options) {
    return SupportApiFp(this.configuration).postSupportRequestCallback(requestParameters.supportRequestCallbackBody, options).then((request) => request(this.axios, this.basePath));
  }
};
var SupportApiInstance = createInstanceFromApiIClass(SupportApi);
var SyncApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSyncMigration: (..._0) => __async(this, [..._0], function* (options = {}) {
      const localVarPath = `/sync/migration`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * 
     * @param {PostSyncRefreshRequest} [postSyncRefreshRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postSyncRefresh: (_0, ..._1) => __async(this, [_0, ..._1], function* (postSyncRefreshRequest, options = {}) {
      const localVarPath = `/sync/refresh`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postSyncRefreshRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    })
  };
};
var SyncApiFp = function(configuration) {
  const localVarAxiosParamCreator = SyncApiAxiosParamCreator(configuration);
  return {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSyncMigration(options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getSyncMigration(options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * 
     * @param {PostSyncRefreshRequest} [postSyncRefreshRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postSyncRefresh(postSyncRefreshRequest, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postSyncRefresh(postSyncRefreshRequest, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    }
  };
};
var SyncApiClient = createApiFromFp(SyncApiFp);
var SyncApiFactory = function(configuration, basePath, axios2) {
  const localVarFp = SyncApiFp(configuration);
  return {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSyncMigration(options) {
      return localVarFp.getSyncMigration(options).then((request) => request(axios2, basePath));
    },
    /**
     * 
     * @param {PostSyncRefreshRequest} [postSyncRefreshRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postSyncRefresh(postSyncRefreshRequest, options) {
      return localVarFp.postSyncRefresh(postSyncRefreshRequest, options).then((request) => request(axios2, basePath));
    }
  };
};
var SyncApi = class extends BaseAPI {
  /**
   * 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SyncApi
   */
  getSyncMigration(options) {
    return SyncApiFp(this.configuration).getSyncMigration(options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * 
   * @param {SyncApiPostSyncRefreshRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SyncApi
   */
  postSyncRefresh(requestParameters = {}, options) {
    return SyncApiFp(this.configuration).postSyncRefresh(requestParameters.postSyncRefreshRequest, options).then((request) => request(this.axios, this.basePath));
  }
};
var SyncApiInstance = createInstanceFromApiIClass(SyncApi);
var TaxRatesApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * This operation deletes a tax rate by ID
     * @summary Delete a tax rate by id
     * @param {string} id Id of the entity
     * @param {string} [melioAccount] The &#x60;Melio-Account&#x60; header is used when a Partner wants to perform an operation on behalf of one of its Accounts. It contains the Account\&#39;s ID which returned when creating the Account, or when retrieving all of the Partner\&#39;s Accounts. Note that most operations are not permitted without the presence of this header.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteTaxRateById: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (id, melioAccount, options = {}) {
      assertParamExists("deleteTaxRateById", "id", id);
      const localVarPath = `/account-receivable/tax-rate/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "DELETE" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Get a Tax Rate by ID
     * @summary Get a Tax Rate
     * @param {string} id Id of the entity
     * @param {string} [melioAccount] The &#x60;Melio-Account&#x60; header is used when a Partner wants to perform an operation on behalf of one of its Accounts. It contains the Account\&#39;s ID which returned when creating the Account, or when retrieving all of the Partner\&#39;s Accounts. Note that most operations are not permitted without the presence of this header.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTaxRateById: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (id, melioAccount, options = {}) {
      assertParamExists("getTaxRateById", "id", id);
      const localVarPath = `/account-receivable/tax-rate/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Retrieve a list of tax rates of organization
     * @summary Retrieve organization tax rates
     * @param {string} [melioAccount] The &#x60;Melio-Account&#x60; header is used when a Partner wants to perform an operation on behalf of one of its Accounts. It contains the Account\&#39;s ID which returned when creating the Account, or when retrieving all of the Partner\&#39;s Accounts. Note that most operations are not permitted without the presence of this header.
     * @param {number} [start] Start position
     * @param {number} [limit] Maximum number of results to return
     * @param {string} [sort] Sorting order
     * @param {string} [search] Search keyword
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTaxRates: (_0, _1, _2, _3, _4, ..._5) => __async(this, [_0, _1, _2, _3, _4, ..._5], function* (melioAccount, start, limit, sort, search, options = {}) {
      const localVarPath = `/account-receivable/tax-rate`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (start !== void 0) {
        localVarQueryParameter["start"] = start;
      }
      if (limit !== void 0) {
        localVarQueryParameter["limit"] = limit;
      }
      if (sort !== void 0) {
        localVarQueryParameter["sort"] = sort;
      }
      if (search !== void 0) {
        localVarQueryParameter["search"] = search;
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Create a new tax rate.
     * @summary Create a Tax Rate
     * @param {PostTaxRateRequest} [postTaxRateRequest] 
     * @param {string} [melioAccount] The &#x60;Melio-Account&#x60; header is used when a Partner wants to perform an operation on behalf of one of its Accounts. It contains the Account\&#39;s ID which returned when creating the Account, or when retrieving all of the Partner\&#39;s Accounts. Note that most operations are not permitted without the presence of this header.
     * @param {SchemasExpand} [expand] Expand header parameters - use for expanding responses for POST &amp; PATCH requests
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postTaxRate: (_0, _1, _2, ..._3) => __async(this, [_0, _1, _2, ..._3], function* (postTaxRateRequest, melioAccount, expand, options = {}) {
      const localVarPath = `/account-receivable/tax-rate`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      if (expand !== void 0 && expand !== null) {
        localVarHeaderParameter["expand"] = String(JSON.stringify(expand));
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postTaxRateRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Update a Tax Rate by ID
     * @summary Update a Tax Rate
     * @param {string} id Id of the entity
     * @param {PatchTaxRateRequest} [patchTaxRateRequest] 
     * @param {string} [melioAccount] The &#x60;Melio-Account&#x60; header is used when a Partner wants to perform an operation on behalf of one of its Accounts. It contains the Account\&#39;s ID which returned when creating the Account, or when retrieving all of the Partner\&#39;s Accounts. Note that most operations are not permitted without the presence of this header.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateTaxRateById: (_0, _1, _2, ..._3) => __async(this, [_0, _1, _2, ..._3], function* (id, patchTaxRateRequest, melioAccount, options = {}) {
      assertParamExists("updateTaxRateById", "id", id);
      const localVarPath = `/account-receivable/tax-rate/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "PATCH" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(patchTaxRateRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    })
  };
};
var TaxRatesApiFp = function(configuration) {
  const localVarAxiosParamCreator = TaxRatesApiAxiosParamCreator(configuration);
  return {
    /**
     * This operation deletes a tax rate by ID
     * @summary Delete a tax rate by id
     * @param {string} id Id of the entity
     * @param {string} [melioAccount] The &#x60;Melio-Account&#x60; header is used when a Partner wants to perform an operation on behalf of one of its Accounts. It contains the Account\&#39;s ID which returned when creating the Account, or when retrieving all of the Partner\&#39;s Accounts. Note that most operations are not permitted without the presence of this header.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteTaxRateById(id, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteTaxRateById(id, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Get a Tax Rate by ID
     * @summary Get a Tax Rate
     * @param {string} id Id of the entity
     * @param {string} [melioAccount] The &#x60;Melio-Account&#x60; header is used when a Partner wants to perform an operation on behalf of one of its Accounts. It contains the Account\&#39;s ID which returned when creating the Account, or when retrieving all of the Partner\&#39;s Accounts. Note that most operations are not permitted without the presence of this header.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTaxRateById(id, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getTaxRateById(id, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Retrieve a list of tax rates of organization
     * @summary Retrieve organization tax rates
     * @param {string} [melioAccount] The &#x60;Melio-Account&#x60; header is used when a Partner wants to perform an operation on behalf of one of its Accounts. It contains the Account\&#39;s ID which returned when creating the Account, or when retrieving all of the Partner\&#39;s Accounts. Note that most operations are not permitted without the presence of this header.
     * @param {number} [start] Start position
     * @param {number} [limit] Maximum number of results to return
     * @param {string} [sort] Sorting order
     * @param {string} [search] Search keyword
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTaxRates(melioAccount, start, limit, sort, search, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getTaxRates(melioAccount, start, limit, sort, search, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Create a new tax rate.
     * @summary Create a Tax Rate
     * @param {PostTaxRateRequest} [postTaxRateRequest] 
     * @param {string} [melioAccount] The &#x60;Melio-Account&#x60; header is used when a Partner wants to perform an operation on behalf of one of its Accounts. It contains the Account\&#39;s ID which returned when creating the Account, or when retrieving all of the Partner\&#39;s Accounts. Note that most operations are not permitted without the presence of this header.
     * @param {SchemasExpand} [expand] Expand header parameters - use for expanding responses for POST &amp; PATCH requests
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postTaxRate(postTaxRateRequest, melioAccount, expand, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postTaxRate(postTaxRateRequest, melioAccount, expand, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Update a Tax Rate by ID
     * @summary Update a Tax Rate
     * @param {string} id Id of the entity
     * @param {PatchTaxRateRequest} [patchTaxRateRequest] 
     * @param {string} [melioAccount] The &#x60;Melio-Account&#x60; header is used when a Partner wants to perform an operation on behalf of one of its Accounts. It contains the Account\&#39;s ID which returned when creating the Account, or when retrieving all of the Partner\&#39;s Accounts. Note that most operations are not permitted without the presence of this header.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateTaxRateById(id, patchTaxRateRequest, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.updateTaxRateById(id, patchTaxRateRequest, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    }
  };
};
var TaxRatesApiClient = createApiFromFp(TaxRatesApiFp);
var TaxRatesApiFactory = function(configuration, basePath, axios2) {
  const localVarFp = TaxRatesApiFp(configuration);
  return {
    /**
     * This operation deletes a tax rate by ID
     * @summary Delete a tax rate by id
     * @param {string} id Id of the entity
     * @param {string} [melioAccount] The &#x60;Melio-Account&#x60; header is used when a Partner wants to perform an operation on behalf of one of its Accounts. It contains the Account\&#39;s ID which returned when creating the Account, or when retrieving all of the Partner\&#39;s Accounts. Note that most operations are not permitted without the presence of this header.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteTaxRateById(id, melioAccount, options) {
      return localVarFp.deleteTaxRateById(id, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Get a Tax Rate by ID
     * @summary Get a Tax Rate
     * @param {string} id Id of the entity
     * @param {string} [melioAccount] The &#x60;Melio-Account&#x60; header is used when a Partner wants to perform an operation on behalf of one of its Accounts. It contains the Account\&#39;s ID which returned when creating the Account, or when retrieving all of the Partner\&#39;s Accounts. Note that most operations are not permitted without the presence of this header.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTaxRateById(id, melioAccount, options) {
      return localVarFp.getTaxRateById(id, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Retrieve a list of tax rates of organization
     * @summary Retrieve organization tax rates
     * @param {string} [melioAccount] The &#x60;Melio-Account&#x60; header is used when a Partner wants to perform an operation on behalf of one of its Accounts. It contains the Account\&#39;s ID which returned when creating the Account, or when retrieving all of the Partner\&#39;s Accounts. Note that most operations are not permitted without the presence of this header.
     * @param {number} [start] Start position
     * @param {number} [limit] Maximum number of results to return
     * @param {string} [sort] Sorting order
     * @param {string} [search] Search keyword
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTaxRates(melioAccount, start, limit, sort, search, options) {
      return localVarFp.getTaxRates(melioAccount, start, limit, sort, search, options).then((request) => request(axios2, basePath));
    },
    /**
     * Create a new tax rate.
     * @summary Create a Tax Rate
     * @param {PostTaxRateRequest} [postTaxRateRequest] 
     * @param {string} [melioAccount] The &#x60;Melio-Account&#x60; header is used when a Partner wants to perform an operation on behalf of one of its Accounts. It contains the Account\&#39;s ID which returned when creating the Account, or when retrieving all of the Partner\&#39;s Accounts. Note that most operations are not permitted without the presence of this header.
     * @param {SchemasExpand} [expand] Expand header parameters - use for expanding responses for POST &amp; PATCH requests
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postTaxRate(postTaxRateRequest, melioAccount, expand, options) {
      return localVarFp.postTaxRate(postTaxRateRequest, melioAccount, expand, options).then((request) => request(axios2, basePath));
    },
    /**
     * Update a Tax Rate by ID
     * @summary Update a Tax Rate
     * @param {string} id Id of the entity
     * @param {PatchTaxRateRequest} [patchTaxRateRequest] 
     * @param {string} [melioAccount] The &#x60;Melio-Account&#x60; header is used when a Partner wants to perform an operation on behalf of one of its Accounts. It contains the Account\&#39;s ID which returned when creating the Account, or when retrieving all of the Partner\&#39;s Accounts. Note that most operations are not permitted without the presence of this header.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateTaxRateById(id, patchTaxRateRequest, melioAccount, options) {
      return localVarFp.updateTaxRateById(id, patchTaxRateRequest, melioAccount, options).then((request) => request(axios2, basePath));
    }
  };
};
var TaxRatesApi = class extends BaseAPI {
  /**
   * This operation deletes a tax rate by ID
   * @summary Delete a tax rate by id
   * @param {TaxRatesApiDeleteTaxRateByIdRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TaxRatesApi
   */
  deleteTaxRateById(requestParameters, options) {
    return TaxRatesApiFp(this.configuration).deleteTaxRateById(requestParameters.id, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Get a Tax Rate by ID
   * @summary Get a Tax Rate
   * @param {TaxRatesApiGetTaxRateByIdRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TaxRatesApi
   */
  getTaxRateById(requestParameters, options) {
    return TaxRatesApiFp(this.configuration).getTaxRateById(requestParameters.id, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Retrieve a list of tax rates of organization
   * @summary Retrieve organization tax rates
   * @param {TaxRatesApiGetTaxRatesRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TaxRatesApi
   */
  getTaxRates(requestParameters = {}, options) {
    return TaxRatesApiFp(this.configuration).getTaxRates(requestParameters.melioAccount, requestParameters.start, requestParameters.limit, requestParameters.sort, requestParameters.search, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Create a new tax rate.
   * @summary Create a Tax Rate
   * @param {TaxRatesApiPostTaxRateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TaxRatesApi
   */
  postTaxRate(requestParameters = {}, options) {
    return TaxRatesApiFp(this.configuration).postTaxRate(requestParameters.postTaxRateRequest, requestParameters.melioAccount, requestParameters.expand, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Update a Tax Rate by ID
   * @summary Update a Tax Rate
   * @param {TaxRatesApiUpdateTaxRateByIdRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TaxRatesApi
   */
  updateTaxRateById(requestParameters, options) {
    return TaxRatesApiFp(this.configuration).updateTaxRateById(requestParameters.id, requestParameters.patchTaxRateRequest, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
};
var TaxRatesApiInstance = createInstanceFromApiIClass(TaxRatesApi);
var TaxpayerIdentificationRequestsApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * Create a request to Vendor to provide W-9 data
     * @summary Send a taxpayer identification request to collect W-9 data
     * @param {string} id ID of the entity
     * @param {PostVendorsVendorIdTaxpayerIdentificationRequestsRequest} [postVendorsVendorIdTaxpayerIdentificationRequestsRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postVendorsVendorIdTaxpayerIdentificationRequests: (_0, _1, _2, _3, ..._4) => __async(this, [_0, _1, _2, _3, ..._4], function* (id, postVendorsVendorIdTaxpayerIdentificationRequestsRequest, idempotencyKey, melioAccount, options = {}) {
      assertParamExists("postVendorsVendorIdTaxpayerIdentificationRequests", "id", id);
      const localVarPath = `/vendors/{id}/taxpayer-identification-requests`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (idempotencyKey !== void 0 && idempotencyKey !== null) {
        localVarHeaderParameter["Idempotency-Key"] = String(idempotencyKey);
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postVendorsVendorIdTaxpayerIdentificationRequestsRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Cancel a request to Vendor to provide W-9 data
     * @summary Cancel a taxpayer identification request to collect W-9 data
     * @param {string} id ID of the entity
     * @param {string} taxpayerIdentificationRequestId 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postVendorsVendorIdTaxpayerIdentificationRequestsTaxpayerIdentificationRequestIdCancel: (_0, _1, _2, ..._3) => __async(this, [_0, _1, _2, ..._3], function* (id, taxpayerIdentificationRequestId, melioAccount, options = {}) {
      assertParamExists("postVendorsVendorIdTaxpayerIdentificationRequestsTaxpayerIdentificationRequestIdCancel", "id", id);
      assertParamExists("postVendorsVendorIdTaxpayerIdentificationRequestsTaxpayerIdentificationRequestIdCancel", "taxpayerIdentificationRequestId", taxpayerIdentificationRequestId);
      const localVarPath = `/vendors/{id}/taxpayer-identification-requests/{taxpayerIdentificationRequestId}/cancel`.replace(`{${"id"}}`, encodeURIComponent(String(id))).replace(`{${"taxpayerIdentificationRequestId"}}`, encodeURIComponent(String(taxpayerIdentificationRequestId)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Resend a request to Vendor to provide W-9 data
     * @summary Resend a taxpayer identification request to collect W-9 data
     * @param {string} id ID of the entity
     * @param {string} taxpayerIdentificationRequestId 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postVendorsVendorIdTaxpayerIdentificationRequestsTaxpayerIdentificationRequestIdResend: (_0, _1, _2, ..._3) => __async(this, [_0, _1, _2, ..._3], function* (id, taxpayerIdentificationRequestId, melioAccount, options = {}) {
      assertParamExists("postVendorsVendorIdTaxpayerIdentificationRequestsTaxpayerIdentificationRequestIdResend", "id", id);
      assertParamExists("postVendorsVendorIdTaxpayerIdentificationRequestsTaxpayerIdentificationRequestIdResend", "taxpayerIdentificationRequestId", taxpayerIdentificationRequestId);
      const localVarPath = `/vendors/{id}/taxpayer-identification-requests/{taxpayerIdentificationRequestId}/resend`.replace(`{${"id"}}`, encodeURIComponent(String(id))).replace(`{${"taxpayerIdentificationRequestId"}}`, encodeURIComponent(String(taxpayerIdentificationRequestId)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    })
  };
};
var TaxpayerIdentificationRequestsApiFp = function(configuration) {
  const localVarAxiosParamCreator = TaxpayerIdentificationRequestsApiAxiosParamCreator(configuration);
  return {
    /**
     * Create a request to Vendor to provide W-9 data
     * @summary Send a taxpayer identification request to collect W-9 data
     * @param {string} id ID of the entity
     * @param {PostVendorsVendorIdTaxpayerIdentificationRequestsRequest} [postVendorsVendorIdTaxpayerIdentificationRequestsRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postVendorsVendorIdTaxpayerIdentificationRequests(id, postVendorsVendorIdTaxpayerIdentificationRequestsRequest, idempotencyKey, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postVendorsVendorIdTaxpayerIdentificationRequests(id, postVendorsVendorIdTaxpayerIdentificationRequestsRequest, idempotencyKey, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Cancel a request to Vendor to provide W-9 data
     * @summary Cancel a taxpayer identification request to collect W-9 data
     * @param {string} id ID of the entity
     * @param {string} taxpayerIdentificationRequestId 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postVendorsVendorIdTaxpayerIdentificationRequestsTaxpayerIdentificationRequestIdCancel(id, taxpayerIdentificationRequestId, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postVendorsVendorIdTaxpayerIdentificationRequestsTaxpayerIdentificationRequestIdCancel(id, taxpayerIdentificationRequestId, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Resend a request to Vendor to provide W-9 data
     * @summary Resend a taxpayer identification request to collect W-9 data
     * @param {string} id ID of the entity
     * @param {string} taxpayerIdentificationRequestId 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postVendorsVendorIdTaxpayerIdentificationRequestsTaxpayerIdentificationRequestIdResend(id, taxpayerIdentificationRequestId, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postVendorsVendorIdTaxpayerIdentificationRequestsTaxpayerIdentificationRequestIdResend(id, taxpayerIdentificationRequestId, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    }
  };
};
var TaxpayerIdentificationRequestsApiClient = createApiFromFp(TaxpayerIdentificationRequestsApiFp);
var TaxpayerIdentificationRequestsApiFactory = function(configuration, basePath, axios2) {
  const localVarFp = TaxpayerIdentificationRequestsApiFp(configuration);
  return {
    /**
     * Create a request to Vendor to provide W-9 data
     * @summary Send a taxpayer identification request to collect W-9 data
     * @param {string} id ID of the entity
     * @param {PostVendorsVendorIdTaxpayerIdentificationRequestsRequest} [postVendorsVendorIdTaxpayerIdentificationRequestsRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postVendorsVendorIdTaxpayerIdentificationRequests(id, postVendorsVendorIdTaxpayerIdentificationRequestsRequest, idempotencyKey, melioAccount, options) {
      return localVarFp.postVendorsVendorIdTaxpayerIdentificationRequests(id, postVendorsVendorIdTaxpayerIdentificationRequestsRequest, idempotencyKey, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Cancel a request to Vendor to provide W-9 data
     * @summary Cancel a taxpayer identification request to collect W-9 data
     * @param {string} id ID of the entity
     * @param {string} taxpayerIdentificationRequestId 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postVendorsVendorIdTaxpayerIdentificationRequestsTaxpayerIdentificationRequestIdCancel(id, taxpayerIdentificationRequestId, melioAccount, options) {
      return localVarFp.postVendorsVendorIdTaxpayerIdentificationRequestsTaxpayerIdentificationRequestIdCancel(id, taxpayerIdentificationRequestId, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Resend a request to Vendor to provide W-9 data
     * @summary Resend a taxpayer identification request to collect W-9 data
     * @param {string} id ID of the entity
     * @param {string} taxpayerIdentificationRequestId 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postVendorsVendorIdTaxpayerIdentificationRequestsTaxpayerIdentificationRequestIdResend(id, taxpayerIdentificationRequestId, melioAccount, options) {
      return localVarFp.postVendorsVendorIdTaxpayerIdentificationRequestsTaxpayerIdentificationRequestIdResend(id, taxpayerIdentificationRequestId, melioAccount, options).then((request) => request(axios2, basePath));
    }
  };
};
var TaxpayerIdentificationRequestsApi = class extends BaseAPI {
  /**
   * Create a request to Vendor to provide W-9 data
   * @summary Send a taxpayer identification request to collect W-9 data
   * @param {TaxpayerIdentificationRequestsApiPostVendorsVendorIdTaxpayerIdentificationRequestsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TaxpayerIdentificationRequestsApi
   */
  postVendorsVendorIdTaxpayerIdentificationRequests(requestParameters, options) {
    return TaxpayerIdentificationRequestsApiFp(this.configuration).postVendorsVendorIdTaxpayerIdentificationRequests(requestParameters.id, requestParameters.postVendorsVendorIdTaxpayerIdentificationRequestsRequest, requestParameters.idempotencyKey, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Cancel a request to Vendor to provide W-9 data
   * @summary Cancel a taxpayer identification request to collect W-9 data
   * @param {TaxpayerIdentificationRequestsApiPostVendorsVendorIdTaxpayerIdentificationRequestsTaxpayerIdentificationRequestIdCancelRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TaxpayerIdentificationRequestsApi
   */
  postVendorsVendorIdTaxpayerIdentificationRequestsTaxpayerIdentificationRequestIdCancel(requestParameters, options) {
    return TaxpayerIdentificationRequestsApiFp(this.configuration).postVendorsVendorIdTaxpayerIdentificationRequestsTaxpayerIdentificationRequestIdCancel(requestParameters.id, requestParameters.taxpayerIdentificationRequestId, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Resend a request to Vendor to provide W-9 data
   * @summary Resend a taxpayer identification request to collect W-9 data
   * @param {TaxpayerIdentificationRequestsApiPostVendorsVendorIdTaxpayerIdentificationRequestsTaxpayerIdentificationRequestIdResendRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TaxpayerIdentificationRequestsApi
   */
  postVendorsVendorIdTaxpayerIdentificationRequestsTaxpayerIdentificationRequestIdResend(requestParameters, options) {
    return TaxpayerIdentificationRequestsApiFp(this.configuration).postVendorsVendorIdTaxpayerIdentificationRequestsTaxpayerIdentificationRequestIdResend(requestParameters.id, requestParameters.taxpayerIdentificationRequestId, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
};
var TaxpayerIdentificationRequestsApiInstance = createInstanceFromApiIClass(TaxpayerIdentificationRequestsApi);
var TaxpayerInfoApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * Remove a Taxpayer Info
     * @summary Delete a Taxpayer Info
     * @param {string} id ID of the entity
     * @param {string} taxpayerInfoId 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteTaxpayerInfoTaxpayerInfoId: (_0, _1, _2, _3, ..._4) => __async(this, [_0, _1, _2, _3, ..._4], function* (id, taxpayerInfoId, idempotencyKey, melioAccount, options = {}) {
      assertParamExists("deleteTaxpayerInfoTaxpayerInfoId", "id", id);
      assertParamExists("deleteTaxpayerInfoTaxpayerInfoId", "taxpayerInfoId", taxpayerInfoId);
      const localVarPath = `/vendors/{id}/taxpayer-info/{taxpayerInfoId}`.replace(`{${"id"}}`, encodeURIComponent(String(id))).replace(`{${"taxpayerInfoId"}}`, encodeURIComponent(String(taxpayerInfoId)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "DELETE" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (idempotencyKey !== void 0 && idempotencyKey !== null) {
        localVarHeaderParameter["Idempotency-Key"] = String(idempotencyKey);
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Get a Taxpayer Info
     * @summary Get a Taxpayer Info
     * @param {string} id ID of the entity
     * @param {string} taxpayerInfoId 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTaxpayerInfoTaxpayerInfoId: (_0, _1, _2, _3, ..._4) => __async(this, [_0, _1, _2, _3, ..._4], function* (id, taxpayerInfoId, idempotencyKey, melioAccount, options = {}) {
      assertParamExists("getTaxpayerInfoTaxpayerInfoId", "id", id);
      assertParamExists("getTaxpayerInfoTaxpayerInfoId", "taxpayerInfoId", taxpayerInfoId);
      const localVarPath = `/vendors/{id}/taxpayer-info/{taxpayerInfoId}`.replace(`{${"id"}}`, encodeURIComponent(String(id))).replace(`{${"taxpayerInfoId"}}`, encodeURIComponent(String(taxpayerInfoId)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (idempotencyKey !== void 0 && idempotencyKey !== null) {
        localVarHeaderParameter["Idempotency-Key"] = String(idempotencyKey);
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Create a taxpayer information, allows to persist W-9 file data
     * @summary Create a taxpayer information, allows to persist W-9 file data
     * @param {string} id ID of the entity
     * @param {any} [file] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postVendorsVendorIdTaxpayerInfo: (_0, _1, _2, _3, ..._4) => __async(this, [_0, _1, _2, _3, ..._4], function* (id, file, idempotencyKey, melioAccount, options = {}) {
      assertParamExists("postVendorsVendorIdTaxpayerInfo", "id", id);
      const localVarPath = `/vendors/{id}/taxpayer-info`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      const localVarFormParams = new (configuration && configuration.formDataCtor || FormData)();
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (idempotencyKey !== void 0 && idempotencyKey !== null) {
        localVarHeaderParameter["Idempotency-Key"] = String(idempotencyKey);
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      if (file !== void 0) {
        localVarFormParams.append("file", file);
      }
      localVarHeaderParameter["Content-Type"] = "multipart/form-data";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = localVarFormParams;
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    })
  };
};
var TaxpayerInfoApiFp = function(configuration) {
  const localVarAxiosParamCreator = TaxpayerInfoApiAxiosParamCreator(configuration);
  return {
    /**
     * Remove a Taxpayer Info
     * @summary Delete a Taxpayer Info
     * @param {string} id ID of the entity
     * @param {string} taxpayerInfoId 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteTaxpayerInfoTaxpayerInfoId(id, taxpayerInfoId, idempotencyKey, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteTaxpayerInfoTaxpayerInfoId(id, taxpayerInfoId, idempotencyKey, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Get a Taxpayer Info
     * @summary Get a Taxpayer Info
     * @param {string} id ID of the entity
     * @param {string} taxpayerInfoId 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTaxpayerInfoTaxpayerInfoId(id, taxpayerInfoId, idempotencyKey, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getTaxpayerInfoTaxpayerInfoId(id, taxpayerInfoId, idempotencyKey, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Create a taxpayer information, allows to persist W-9 file data
     * @summary Create a taxpayer information, allows to persist W-9 file data
     * @param {string} id ID of the entity
     * @param {any} [file] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postVendorsVendorIdTaxpayerInfo(id, file, idempotencyKey, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postVendorsVendorIdTaxpayerInfo(id, file, idempotencyKey, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    }
  };
};
var TaxpayerInfoApiClient = createApiFromFp(TaxpayerInfoApiFp);
var TaxpayerInfoApiFactory = function(configuration, basePath, axios2) {
  const localVarFp = TaxpayerInfoApiFp(configuration);
  return {
    /**
     * Remove a Taxpayer Info
     * @summary Delete a Taxpayer Info
     * @param {string} id ID of the entity
     * @param {string} taxpayerInfoId 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteTaxpayerInfoTaxpayerInfoId(id, taxpayerInfoId, idempotencyKey, melioAccount, options) {
      return localVarFp.deleteTaxpayerInfoTaxpayerInfoId(id, taxpayerInfoId, idempotencyKey, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Get a Taxpayer Info
     * @summary Get a Taxpayer Info
     * @param {string} id ID of the entity
     * @param {string} taxpayerInfoId 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTaxpayerInfoTaxpayerInfoId(id, taxpayerInfoId, idempotencyKey, melioAccount, options) {
      return localVarFp.getTaxpayerInfoTaxpayerInfoId(id, taxpayerInfoId, idempotencyKey, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Create a taxpayer information, allows to persist W-9 file data
     * @summary Create a taxpayer information, allows to persist W-9 file data
     * @param {string} id ID of the entity
     * @param {any} [file] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postVendorsVendorIdTaxpayerInfo(id, file, idempotencyKey, melioAccount, options) {
      return localVarFp.postVendorsVendorIdTaxpayerInfo(id, file, idempotencyKey, melioAccount, options).then((request) => request(axios2, basePath));
    }
  };
};
var TaxpayerInfoApi = class extends BaseAPI {
  /**
   * Remove a Taxpayer Info
   * @summary Delete a Taxpayer Info
   * @param {TaxpayerInfoApiDeleteTaxpayerInfoTaxpayerInfoIdRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TaxpayerInfoApi
   */
  deleteTaxpayerInfoTaxpayerInfoId(requestParameters, options) {
    return TaxpayerInfoApiFp(this.configuration).deleteTaxpayerInfoTaxpayerInfoId(requestParameters.id, requestParameters.taxpayerInfoId, requestParameters.idempotencyKey, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Get a Taxpayer Info
   * @summary Get a Taxpayer Info
   * @param {TaxpayerInfoApiGetTaxpayerInfoTaxpayerInfoIdRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TaxpayerInfoApi
   */
  getTaxpayerInfoTaxpayerInfoId(requestParameters, options) {
    return TaxpayerInfoApiFp(this.configuration).getTaxpayerInfoTaxpayerInfoId(requestParameters.id, requestParameters.taxpayerInfoId, requestParameters.idempotencyKey, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Create a taxpayer information, allows to persist W-9 file data
   * @summary Create a taxpayer information, allows to persist W-9 file data
   * @param {TaxpayerInfoApiPostVendorsVendorIdTaxpayerInfoRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TaxpayerInfoApi
   */
  postVendorsVendorIdTaxpayerInfo(requestParameters, options) {
    return TaxpayerInfoApiFp(this.configuration).postVendorsVendorIdTaxpayerInfo(requestParameters.id, requestParameters.file, requestParameters.idempotencyKey, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
};
var TaxpayerInfoApiInstance = createInstanceFromApiIClass(TaxpayerInfoApi);
var TodosApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * Return all tasks for this user.
     * @summary Retrieve all todo items
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {Date} [overdueDate] Now query parameter - date according to user timezone
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTodos: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (expand, overdueDate, options = {}) {
      const localVarPath = `/todos`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (expand !== void 0) {
        localVarQueryParameter["expand"] = expand;
      }
      if (overdueDate !== void 0) {
        localVarQueryParameter["overdueDate"] = overdueDate instanceof Date ? overdueDate.toISOString() : overdueDate;
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    })
  };
};
var TodosApiFp = function(configuration) {
  const localVarAxiosParamCreator = TodosApiAxiosParamCreator(configuration);
  return {
    /**
     * Return all tasks for this user.
     * @summary Retrieve all todo items
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {Date} [overdueDate] Now query parameter - date according to user timezone
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTodos(expand, overdueDate, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getTodos(expand, overdueDate, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    }
  };
};
var TodosApiClient = createApiFromFp(TodosApiFp);
var TodosApiFactory = function(configuration, basePath, axios2) {
  const localVarFp = TodosApiFp(configuration);
  return {
    /**
     * Return all tasks for this user.
     * @summary Retrieve all todo items
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {Date} [overdueDate] Now query parameter - date according to user timezone
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTodos(expand, overdueDate, options) {
      return localVarFp.getTodos(expand, overdueDate, options).then((request) => request(axios2, basePath));
    }
  };
};
var TodosApi = class extends BaseAPI {
  /**
   * Return all tasks for this user.
   * @summary Retrieve all todo items
   * @param {TodosApiGetTodosRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TodosApi
   */
  getTodos(requestParameters = {}, options) {
    return TodosApiFp(this.configuration).getTodos(requestParameters.expand, requestParameters.overdueDate, options).then((request) => request(this.axios, this.basePath));
  }
};
var TodosApiInstance = createInstanceFromApiIClass(TodosApi);
var UnilateralRequestsApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * Get a list of a Vendor\'s Unilateral Requests.
     * @summary Retrieve Vendor\'s unilateral requests
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getVendorsVendorIdUnilateralRequests: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (id, melioAccount, options = {}) {
      assertParamExists("getVendorsVendorIdUnilateralRequests", "id", id);
      const localVarPath = `/vendors/{id}/unilateral-requests`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Get if the vendor is valid for resending to him a unilateral request
     * @summary Returns whether vendor is valid for resend unilateral request
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getVendorsVendorIdUnilateralRequestsValidationForResend: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (id, melioAccount, options = {}) {
      assertParamExists("getVendorsVendorIdUnilateralRequestsValidationForResend", "id", id);
      const localVarPath = `/vendors/{id}/unilateral-requests/validation-for-resend`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Create a Unilateral Request of a Vendor
     * @summary Create a Unilateral Request of a Vendor
     * @param {string} id ID of the entity
     * @param {PostVendorsVendorIdUnilateralRequestsRequest} [postVendorsVendorIdUnilateralRequestsRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postVendorsVendorIdUnilateralRequests: (_0, _1, _2, _3, ..._4) => __async(this, [_0, _1, _2, _3, ..._4], function* (id, postVendorsVendorIdUnilateralRequestsRequest, idempotencyKey, melioAccount, options = {}) {
      assertParamExists("postVendorsVendorIdUnilateralRequests", "id", id);
      const localVarPath = `/vendors/{id}/unilateral-requests`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (idempotencyKey !== void 0 && idempotencyKey !== null) {
        localVarHeaderParameter["Idempotency-Key"] = String(idempotencyKey);
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postVendorsVendorIdUnilateralRequestsRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    })
  };
};
var UnilateralRequestsApiFp = function(configuration) {
  const localVarAxiosParamCreator = UnilateralRequestsApiAxiosParamCreator(configuration);
  return {
    /**
     * Get a list of a Vendor\'s Unilateral Requests.
     * @summary Retrieve Vendor\'s unilateral requests
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getVendorsVendorIdUnilateralRequests(id, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getVendorsVendorIdUnilateralRequests(id, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Get if the vendor is valid for resending to him a unilateral request
     * @summary Returns whether vendor is valid for resend unilateral request
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getVendorsVendorIdUnilateralRequestsValidationForResend(id, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getVendorsVendorIdUnilateralRequestsValidationForResend(id, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Create a Unilateral Request of a Vendor
     * @summary Create a Unilateral Request of a Vendor
     * @param {string} id ID of the entity
     * @param {PostVendorsVendorIdUnilateralRequestsRequest} [postVendorsVendorIdUnilateralRequestsRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postVendorsVendorIdUnilateralRequests(id, postVendorsVendorIdUnilateralRequestsRequest, idempotencyKey, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postVendorsVendorIdUnilateralRequests(id, postVendorsVendorIdUnilateralRequestsRequest, idempotencyKey, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    }
  };
};
var UnilateralRequestsApiClient = createApiFromFp(UnilateralRequestsApiFp);
var UnilateralRequestsApiFactory = function(configuration, basePath, axios2) {
  const localVarFp = UnilateralRequestsApiFp(configuration);
  return {
    /**
     * Get a list of a Vendor\'s Unilateral Requests.
     * @summary Retrieve Vendor\'s unilateral requests
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getVendorsVendorIdUnilateralRequests(id, melioAccount, options) {
      return localVarFp.getVendorsVendorIdUnilateralRequests(id, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Get if the vendor is valid for resending to him a unilateral request
     * @summary Returns whether vendor is valid for resend unilateral request
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getVendorsVendorIdUnilateralRequestsValidationForResend(id, melioAccount, options) {
      return localVarFp.getVendorsVendorIdUnilateralRequestsValidationForResend(id, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Create a Unilateral Request of a Vendor
     * @summary Create a Unilateral Request of a Vendor
     * @param {string} id ID of the entity
     * @param {PostVendorsVendorIdUnilateralRequestsRequest} [postVendorsVendorIdUnilateralRequestsRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postVendorsVendorIdUnilateralRequests(id, postVendorsVendorIdUnilateralRequestsRequest, idempotencyKey, melioAccount, options) {
      return localVarFp.postVendorsVendorIdUnilateralRequests(id, postVendorsVendorIdUnilateralRequestsRequest, idempotencyKey, melioAccount, options).then((request) => request(axios2, basePath));
    }
  };
};
var UnilateralRequestsApi = class extends BaseAPI {
  /**
   * Get a list of a Vendor\'s Unilateral Requests.
   * @summary Retrieve Vendor\'s unilateral requests
   * @param {UnilateralRequestsApiGetVendorsVendorIdUnilateralRequestsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UnilateralRequestsApi
   */
  getVendorsVendorIdUnilateralRequests(requestParameters, options) {
    return UnilateralRequestsApiFp(this.configuration).getVendorsVendorIdUnilateralRequests(requestParameters.id, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Get if the vendor is valid for resending to him a unilateral request
   * @summary Returns whether vendor is valid for resend unilateral request
   * @param {UnilateralRequestsApiGetVendorsVendorIdUnilateralRequestsValidationForResendRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UnilateralRequestsApi
   */
  getVendorsVendorIdUnilateralRequestsValidationForResend(requestParameters, options) {
    return UnilateralRequestsApiFp(this.configuration).getVendorsVendorIdUnilateralRequestsValidationForResend(requestParameters.id, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Create a Unilateral Request of a Vendor
   * @summary Create a Unilateral Request of a Vendor
   * @param {UnilateralRequestsApiPostVendorsVendorIdUnilateralRequestsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UnilateralRequestsApi
   */
  postVendorsVendorIdUnilateralRequests(requestParameters, options) {
    return UnilateralRequestsApiFp(this.configuration).postVendorsVendorIdUnilateralRequests(requestParameters.id, requestParameters.postVendorsVendorIdUnilateralRequestsRequest, requestParameters.idempotencyKey, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
};
var UnilateralRequestsApiInstance = createInstanceFromApiIClass(UnilateralRequestsApi);
var UserPreferencesApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * List of all user preferences, filtered by userId.
     * @summary Retrieve all user preferences
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUserPreferences: (..._0) => __async(this, [..._0], function* (options = {}) {
      const localVarPath = `/user-preferences`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Retrieve an user preference by key
     * @summary Retrieve an user preference by key
     * @param {string} userPreferenceKey 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUserPreferencesUserPreferenceKey: (_0, ..._1) => __async(this, [_0, ..._1], function* (userPreferenceKey, options = {}) {
      assertParamExists("getUserPreferencesUserPreferenceKey", "userPreferenceKey", userPreferenceKey);
      const localVarPath = `/user-preferences/{userPreferenceKey}`.replace(`{${"userPreferenceKey"}}`, encodeURIComponent(String(userPreferenceKey)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Update or create user preference.
     * @summary Update or create user preference
     * @param {SetUserPreferenceRequest} [setUserPreferenceRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    setUserPreferences: (_0, ..._1) => __async(this, [_0, ..._1], function* (setUserPreferenceRequest, options = {}) {
      const localVarPath = `/user-preferences`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(setUserPreferenceRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    })
  };
};
var UserPreferencesApiFp = function(configuration) {
  const localVarAxiosParamCreator = UserPreferencesApiAxiosParamCreator(configuration);
  return {
    /**
     * List of all user preferences, filtered by userId.
     * @summary Retrieve all user preferences
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUserPreferences(options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getUserPreferences(options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Retrieve an user preference by key
     * @summary Retrieve an user preference by key
     * @param {string} userPreferenceKey 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUserPreferencesUserPreferenceKey(userPreferenceKey, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getUserPreferencesUserPreferenceKey(userPreferenceKey, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Update or create user preference.
     * @summary Update or create user preference
     * @param {SetUserPreferenceRequest} [setUserPreferenceRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    setUserPreferences(setUserPreferenceRequest, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.setUserPreferences(setUserPreferenceRequest, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    }
  };
};
var UserPreferencesApiClient = createApiFromFp(UserPreferencesApiFp);
var UserPreferencesApiFactory = function(configuration, basePath, axios2) {
  const localVarFp = UserPreferencesApiFp(configuration);
  return {
    /**
     * List of all user preferences, filtered by userId.
     * @summary Retrieve all user preferences
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUserPreferences(options) {
      return localVarFp.getUserPreferences(options).then((request) => request(axios2, basePath));
    },
    /**
     * Retrieve an user preference by key
     * @summary Retrieve an user preference by key
     * @param {string} userPreferenceKey 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUserPreferencesUserPreferenceKey(userPreferenceKey, options) {
      return localVarFp.getUserPreferencesUserPreferenceKey(userPreferenceKey, options).then((request) => request(axios2, basePath));
    },
    /**
     * Update or create user preference.
     * @summary Update or create user preference
     * @param {SetUserPreferenceRequest} [setUserPreferenceRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    setUserPreferences(setUserPreferenceRequest, options) {
      return localVarFp.setUserPreferences(setUserPreferenceRequest, options).then((request) => request(axios2, basePath));
    }
  };
};
var UserPreferencesApi = class extends BaseAPI {
  /**
   * List of all user preferences, filtered by userId.
   * @summary Retrieve all user preferences
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserPreferencesApi
   */
  getUserPreferences(options) {
    return UserPreferencesApiFp(this.configuration).getUserPreferences(options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Retrieve an user preference by key
   * @summary Retrieve an user preference by key
   * @param {UserPreferencesApiGetUserPreferencesUserPreferenceKeyRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserPreferencesApi
   */
  getUserPreferencesUserPreferenceKey(requestParameters, options) {
    return UserPreferencesApiFp(this.configuration).getUserPreferencesUserPreferenceKey(requestParameters.userPreferenceKey, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Update or create user preference.
   * @summary Update or create user preference
   * @param {UserPreferencesApiSetUserPreferencesRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserPreferencesApi
   */
  setUserPreferences(requestParameters = {}, options) {
    return UserPreferencesApiFp(this.configuration).setUserPreferences(requestParameters.setUserPreferenceRequest, options).then((request) => request(this.axios, this.basePath));
  }
};
var UserPreferencesApiInstance = createInstanceFromApiIClass(UserPreferencesApi);
var VendorGroupsApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * delete a vendor group
     * @summary delete a vendor group
     * @param {string} id ID of the entity
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteVendorGroupsVendorGroupId: (_0, _1, _2, ..._3) => __async(this, [_0, _1, _2, ..._3], function* (id, organizationId, userId, options = {}) {
      assertParamExists("deleteVendorGroupsVendorGroupId", "id", id);
      const localVarPath = `/vendor-groups/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "DELETE" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (organizationId !== void 0 && organizationId !== null) {
        localVarHeaderParameter["Organization-id"] = String(organizationId);
      }
      if (userId !== void 0 && userId !== null) {
        localVarHeaderParameter["User-id"] = String(userId);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * retrieve the vendor groups
     * @summary retrieve the vendor groups
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getVendorGroups: (..._0) => __async(this, [..._0], function* (options = {}) {
      const localVarPath = `/vendor-groups`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * create a vendor group
     * @summary create a vendor group
     * @param {PostVendorGroupsRequest} postVendorGroupsRequest create vendor group parameters
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postVendorGroups: (_0, _1, _2, ..._3) => __async(this, [_0, _1, _2, ..._3], function* (postVendorGroupsRequest, organizationId, userId, options = {}) {
      assertParamExists("postVendorGroups", "postVendorGroupsRequest", postVendorGroupsRequest);
      const localVarPath = `/vendor-groups`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (organizationId !== void 0 && organizationId !== null) {
        localVarHeaderParameter["Organization-id"] = String(organizationId);
      }
      if (userId !== void 0 && userId !== null) {
        localVarHeaderParameter["User-id"] = String(userId);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postVendorGroupsRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * edit the vendor groups
     * @summary edit the vendor group
     * @param {PatchVendorGroupsRequest} patchVendorGroupsRequest edit vendor group parameters
     * @param {string} id ID of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postVendorGroupsVendorGroupId: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (patchVendorGroupsRequest, id, options = {}) {
      assertParamExists("postVendorGroupsVendorGroupId", "patchVendorGroupsRequest", patchVendorGroupsRequest);
      assertParamExists("postVendorGroupsVendorGroupId", "id", id);
      const localVarPath = `/vendor-groups/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "PATCH" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(patchVendorGroupsRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    })
  };
};
var VendorGroupsApiFp = function(configuration) {
  const localVarAxiosParamCreator = VendorGroupsApiAxiosParamCreator(configuration);
  return {
    /**
     * delete a vendor group
     * @summary delete a vendor group
     * @param {string} id ID of the entity
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteVendorGroupsVendorGroupId(id, organizationId, userId, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteVendorGroupsVendorGroupId(id, organizationId, userId, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * retrieve the vendor groups
     * @summary retrieve the vendor groups
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getVendorGroups(options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getVendorGroups(options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * create a vendor group
     * @summary create a vendor group
     * @param {PostVendorGroupsRequest} postVendorGroupsRequest create vendor group parameters
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postVendorGroups(postVendorGroupsRequest, organizationId, userId, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postVendorGroups(postVendorGroupsRequest, organizationId, userId, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * edit the vendor groups
     * @summary edit the vendor group
     * @param {PatchVendorGroupsRequest} patchVendorGroupsRequest edit vendor group parameters
     * @param {string} id ID of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postVendorGroupsVendorGroupId(patchVendorGroupsRequest, id, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postVendorGroupsVendorGroupId(patchVendorGroupsRequest, id, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    }
  };
};
var VendorGroupsApiClient = createApiFromFp(VendorGroupsApiFp);
var VendorGroupsApiFactory = function(configuration, basePath, axios2) {
  const localVarFp = VendorGroupsApiFp(configuration);
  return {
    /**
     * delete a vendor group
     * @summary delete a vendor group
     * @param {string} id ID of the entity
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteVendorGroupsVendorGroupId(id, organizationId, userId, options) {
      return localVarFp.deleteVendorGroupsVendorGroupId(id, organizationId, userId, options).then((request) => request(axios2, basePath));
    },
    /**
     * retrieve the vendor groups
     * @summary retrieve the vendor groups
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getVendorGroups(options) {
      return localVarFp.getVendorGroups(options).then((request) => request(axios2, basePath));
    },
    /**
     * create a vendor group
     * @summary create a vendor group
     * @param {PostVendorGroupsRequest} postVendorGroupsRequest create vendor group parameters
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postVendorGroups(postVendorGroupsRequest, organizationId, userId, options) {
      return localVarFp.postVendorGroups(postVendorGroupsRequest, organizationId, userId, options).then((request) => request(axios2, basePath));
    },
    /**
     * edit the vendor groups
     * @summary edit the vendor group
     * @param {PatchVendorGroupsRequest} patchVendorGroupsRequest edit vendor group parameters
     * @param {string} id ID of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postVendorGroupsVendorGroupId(patchVendorGroupsRequest, id, options) {
      return localVarFp.postVendorGroupsVendorGroupId(patchVendorGroupsRequest, id, options).then((request) => request(axios2, basePath));
    }
  };
};
var VendorGroupsApi = class extends BaseAPI {
  /**
   * delete a vendor group
   * @summary delete a vendor group
   * @param {VendorGroupsApiDeleteVendorGroupsVendorGroupIdRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VendorGroupsApi
   */
  deleteVendorGroupsVendorGroupId(requestParameters, options) {
    return VendorGroupsApiFp(this.configuration).deleteVendorGroupsVendorGroupId(requestParameters.id, requestParameters.organizationId, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * retrieve the vendor groups
   * @summary retrieve the vendor groups
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VendorGroupsApi
   */
  getVendorGroups(options) {
    return VendorGroupsApiFp(this.configuration).getVendorGroups(options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * create a vendor group
   * @summary create a vendor group
   * @param {VendorGroupsApiPostVendorGroupsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VendorGroupsApi
   */
  postVendorGroups(requestParameters, options) {
    return VendorGroupsApiFp(this.configuration).postVendorGroups(requestParameters.postVendorGroupsRequest, requestParameters.organizationId, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * edit the vendor groups
   * @summary edit the vendor group
   * @param {VendorGroupsApiPostVendorGroupsVendorGroupIdRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VendorGroupsApi
   */
  postVendorGroupsVendorGroupId(requestParameters, options) {
    return VendorGroupsApiFp(this.configuration).postVendorGroupsVendorGroupId(requestParameters.patchVendorGroupsRequest, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
  }
};
var VendorGroupsApiInstance = createInstanceFromApiIClass(VendorGroupsApi);
var VendorsApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * Accept organization id and local vendor id of the same business and match them at business directory
     * @summary Matching between local vendor and owned-by vendor at Business directory
     * @param {string} id ID of the entity
     * @param {PostVendorsCopyDeliveryMethodRequest} [postVendorsCopyDeliveryMethodRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    copyDeliveryMethodFromOwnedVendorToLocalVendor: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (id, postVendorsCopyDeliveryMethodRequest, options = {}) {
      assertParamExists("copyDeliveryMethodFromOwnedVendorToLocalVendor", "id", id);
      const localVarPath = `/vendors/{id}/copy-delivery-method-from-owned-vendor`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postVendorsCopyDeliveryMethodRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Delete a managed vendor\'s auto payment
     * @summary Delete a managed vendor\'s auto payment
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteAutoPayment: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (id, melioAccount, options = {}) {
      assertParamExists("deleteAutoPayment", "id", id);
      const localVarPath = `/vendors/{id}/auto-payment`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "DELETE" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * 
     * @summary cancel vendor ebills subscription
     * @param {string} id ID of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteEbillsSubscription: (_0, ..._1) => __async(this, [_0, ..._1], function* (id, options = {}) {
      assertParamExists("deleteEbillsSubscription", "id", id);
      const localVarPath = `/vendors/{id}/ebills-subscription`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "DELETE" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Remove a Taxpayer Info
     * @summary Delete a Taxpayer Info
     * @param {string} id ID of the entity
     * @param {string} taxpayerInfoId 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteTaxpayerInfoTaxpayerInfoId: (_0, _1, _2, _3, ..._4) => __async(this, [_0, _1, _2, _3, ..._4], function* (id, taxpayerInfoId, idempotencyKey, melioAccount, options = {}) {
      assertParamExists("deleteTaxpayerInfoTaxpayerInfoId", "id", id);
      assertParamExists("deleteTaxpayerInfoTaxpayerInfoId", "taxpayerInfoId", taxpayerInfoId);
      const localVarPath = `/vendors/{id}/taxpayer-info/{taxpayerInfoId}`.replace(`{${"id"}}`, encodeURIComponent(String(id))).replace(`{${"taxpayerInfoId"}}`, encodeURIComponent(String(taxpayerInfoId)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "DELETE" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (idempotencyKey !== void 0 && idempotencyKey !== null) {
        localVarHeaderParameter["Idempotency-Key"] = String(idempotencyKey);
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Removing a Vendor from an Account.
     * @summary Delete a Vendor
     * @param {string} id ID of the entity
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteVendorsVendorId: (_0, _1, _2, _3, _4, _5, ..._6) => __async(this, [_0, _1, _2, _3, _4, _5, ..._6], function* (id, expand, idempotencyKey, melioAccount, organizationId, userId, options = {}) {
      assertParamExists("deleteVendorsVendorId", "id", id);
      const localVarPath = `/vendors/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "DELETE" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (expand !== void 0 && expand !== null) {
        localVarHeaderParameter["expand"] = String(JSON.stringify(expand));
      }
      if (idempotencyKey !== void 0 && idempotencyKey !== null) {
        localVarHeaderParameter["Idempotency-Key"] = String(idempotencyKey);
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      if (organizationId !== void 0 && organizationId !== null) {
        localVarHeaderParameter["Organization-id"] = String(organizationId);
      }
      if (userId !== void 0 && userId !== null) {
        localVarHeaderParameter["User-id"] = String(userId);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Get a managed vendor\'s auto payment
     * @summary Get a managed vendor\'s auto payment
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAutoPayment: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (id, melioAccount, options = {}) {
      assertParamExists("getAutoPayment", "id", id);
      const localVarPath = `/vendors/{id}/auto-payment`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Get a managed vendor\'s auto payment options
     * @summary Get a managed vendor\'s auto payment options
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAutoPaymentOptions: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (id, melioAccount, options = {}) {
      assertParamExists("getAutoPaymentOptions", "id", id);
      const localVarPath = `/vendors/{id}/auto-payment/options`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Get a Taxpayer Info
     * @summary Get a Taxpayer Info
     * @param {string} id ID of the entity
     * @param {string} taxpayerInfoId 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTaxpayerInfoTaxpayerInfoId: (_0, _1, _2, _3, ..._4) => __async(this, [_0, _1, _2, _3, ..._4], function* (id, taxpayerInfoId, idempotencyKey, melioAccount, options = {}) {
      assertParamExists("getTaxpayerInfoTaxpayerInfoId", "id", id);
      assertParamExists("getTaxpayerInfoTaxpayerInfoId", "taxpayerInfoId", taxpayerInfoId);
      const localVarPath = `/vendors/{id}/taxpayer-info/{taxpayerInfoId}`.replace(`{${"id"}}`, encodeURIComponent(String(id))).replace(`{${"taxpayerInfoId"}}`, encodeURIComponent(String(taxpayerInfoId)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (idempotencyKey !== void 0 && idempotencyKey !== null) {
        localVarHeaderParameter["Idempotency-Key"] = String(idempotencyKey);
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Get a vendor\'s ebill subscription form
     * @summary Get a vendor\'s ebill subscription form
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getVendorEbillsSubscriptionForm: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (id, melioAccount, options = {}) {
      assertParamExists("getVendorEbillsSubscriptionForm", "id", id);
      const localVarPath = `/vendors/{id}/ebills-subscription/options`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Get a list of the fields that can be edited for a vendor.
     * @summary Get a list of the fields that can be edited for a vendor.
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getVendorEditableFields: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (id, melioAccount, options = {}) {
      assertParamExists("getVendorEditableFields", "id", id);
      const localVarPath = `/vendors/{id}/editable-fields`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Get a vendor\'s unmasked account number
     * @summary Get a vendor\'s unmasked account number
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getVendorUnmaskedAccountNumber: (_0, _1, _2, _3, ..._4) => __async(this, [_0, _1, _2, _3, ..._4], function* (id, melioAccount, organizationId, userId, options = {}) {
      assertParamExists("getVendorUnmaskedAccountNumber", "id", id);
      const localVarPath = `/vendors/{id}/unmasked-account-number`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      if (organizationId !== void 0 && organizationId !== null) {
        localVarHeaderParameter["Organization-id"] = String(organizationId);
      }
      if (userId !== void 0 && userId !== null) {
        localVarHeaderParameter["User-id"] = String(userId);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Retrieve a list of Vendors that are attached to an Account
     * @summary Retrieve all Vendors
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {string} [searchTerm] Limit returned objects to those that contain the specified search string. Search is a case-insensitive, substring match against a subset of fields in the object. See the method documentation to learn which fields can be matched by the &#x60;searchTerm&#x60; value. [Read more](https://docs.melio.com/docs/melio-data-api/getting-started#simple_search) 
     * @param {Array<VendorsSortQueryParam>} [sort] Sort query parameter - sort data by entity fields
     * @param {string} [search] Limit returned objects to those that satisfy the specified query. Query strings support logic and comparison against fields that you specify. See the method documentation to learn which fields can be included in your query, or [read more about query strings](https://docs.melio.com/docs/melio-data-api/getting-started#advanced_search).
     * @param {number} [limit] A limit on the number of records to be returned.
     * @param {PaginationCursor} [cursor] Used to page through page through results when the &#x60;totalCount&#x60; is more than the current set of results. To page, specify \&quot;cursor[prev]&#x3D;_&lt;prev_token&gt;_\&quot; or \&quot;cursor[next]&#x3D;_&lt;next_token&gt;_\&quot; as a URL parameter. 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getVendors: (_0, _1, _2, _3, _4, _5, _6, _7, ..._8) => __async(this, [_0, _1, _2, _3, _4, _5, _6, _7, ..._8], function* (expand, organizationId, userId, searchTerm, sort, search, limit, cursor, options = {}) {
      const localVarPath = `/vendors`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (expand !== void 0) {
        localVarQueryParameter["expand"] = expand;
      }
      if (searchTerm !== void 0) {
        localVarQueryParameter["searchTerm"] = searchTerm;
      }
      if (sort) {
        localVarQueryParameter["sort"] = sort;
      }
      if (search !== void 0) {
        localVarQueryParameter["search"] = search;
      }
      if (limit !== void 0) {
        localVarQueryParameter["limit"] = limit;
      }
      if (cursor !== void 0) {
        localVarQueryParameter["cursor"] = cursor;
      }
      if (organizationId !== void 0 && organizationId !== null) {
        localVarHeaderParameter["Organization-id"] = String(organizationId);
      }
      if (userId !== void 0 && userId !== null) {
        localVarHeaderParameter["User-id"] = String(userId);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Retrieve a single Vendor using its ID.
     * @summary Retrieve a Vendor
     * @param {string} id ID of the entity
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getVendorsVendorId: (_0, _1, _2, _3, _4, ..._5) => __async(this, [_0, _1, _2, _3, _4, ..._5], function* (id, expand, melioAccount, organizationId, userId, options = {}) {
      assertParamExists("getVendorsVendorId", "id", id);
      const localVarPath = `/vendors/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (expand !== void 0) {
        localVarQueryParameter["expand"] = expand;
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      if (organizationId !== void 0 && organizationId !== null) {
        localVarHeaderParameter["Organization-id"] = String(organizationId);
      }
      if (userId !== void 0 && userId !== null) {
        localVarHeaderParameter["User-id"] = String(userId);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Retrieve Vendor supported delivery method types
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getVendorsVendorIdDeliveryMethodTypeOptions: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (id, melioAccount, options = {}) {
      assertParamExists("getVendorsVendorIdDeliveryMethodTypeOptions", "id", id);
      const localVarPath = `/vendors/{id}/delivery-method-type-options`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Get a list of a Vendor\'s Delivery Methods, that can be used to sent funds to.
     * @summary Retrieve a Vendor\'s Delivery Methods
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getVendorsVendorIdDeliveryMethods: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (id, melioAccount, options = {}) {
      assertParamExists("getVendorsVendorIdDeliveryMethods", "id", id);
      const localVarPath = `/vendors/{id}/delivery-methods`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Retrieve Vendor Stats.
     * @summary Retrieve Vendor Stats
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getVendorsVendorIdStats: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (id, melioAccount, options = {}) {
      assertParamExists("getVendorsVendorIdStats", "id", id);
      const localVarPath = `/vendors/{id}/stats`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Get a list of a Vendor\'s Unilateral Requests.
     * @summary Retrieve Vendor\'s unilateral requests
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getVendorsVendorIdUnilateralRequests: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (id, melioAccount, options = {}) {
      assertParamExists("getVendorsVendorIdUnilateralRequests", "id", id);
      const localVarPath = `/vendors/{id}/unilateral-requests`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Get if the vendor is valid for resending to him a unilateral request
     * @summary Returns whether vendor is valid for resend unilateral request
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getVendorsVendorIdUnilateralRequestsValidationForResend: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (id, melioAccount, options = {}) {
      assertParamExists("getVendorsVendorIdUnilateralRequestsValidationForResend", "id", id);
      const localVarPath = `/vendors/{id}/unilateral-requests/validation-for-resend`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Update a managed vendor\'s auto payment
     * @summary Update a managed vendor\'s auto payment
     * @param {PatchVendorAutoPaymentRequest} patchVendorAutoPaymentRequest 
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchAutoPayment: (_0, _1, _2, ..._3) => __async(this, [_0, _1, _2, ..._3], function* (patchVendorAutoPaymentRequest, id, melioAccount, options = {}) {
      assertParamExists("patchAutoPayment", "patchVendorAutoPaymentRequest", patchVendorAutoPaymentRequest);
      assertParamExists("patchAutoPayment", "id", id);
      const localVarPath = `/vendors/{id}/auto-payment`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "PATCH" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(patchVendorAutoPaymentRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Update an existing Vendor.  The request\'s body can be partial, and only provided fields will be overwritten. Set an optional field to `null` in order to remove its contents.
     * @summary Update a Vendor
     * @param {string} id ID of the entity
     * @param {PatchVendorsVendorIdRequest} [patchVendorsVendorIdRequest] 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchVendorsVendorId: (_0, _1, _2, _3, _4, _5, _6, ..._7) => __async(this, [_0, _1, _2, _3, _4, _5, _6, ..._7], function* (id, patchVendorsVendorIdRequest, expand, idempotencyKey, melioAccount, organizationId, userId, options = {}) {
      assertParamExists("patchVendorsVendorId", "id", id);
      const localVarPath = `/vendors/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "PATCH" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (expand !== void 0 && expand !== null) {
        localVarHeaderParameter["expand"] = String(JSON.stringify(expand));
      }
      if (idempotencyKey !== void 0 && idempotencyKey !== null) {
        localVarHeaderParameter["Idempotency-Key"] = String(idempotencyKey);
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      if (organizationId !== void 0 && organizationId !== null) {
        localVarHeaderParameter["Organization-id"] = String(organizationId);
      }
      if (userId !== void 0 && userId !== null) {
        localVarHeaderParameter["User-id"] = String(userId);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(patchVendorsVendorIdRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Create a managed vendor\'s auto payment
     * @summary Create a managed vendor\'s auto payment
     * @param {PostVendorAutoPaymentRequest} postVendorAutoPaymentRequest 
     * @param {string} id ID of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postAutoPayment: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (postVendorAutoPaymentRequest, id, options = {}) {
      assertParamExists("postAutoPayment", "postVendorAutoPaymentRequest", postVendorAutoPaymentRequest);
      assertParamExists("postAutoPayment", "id", id);
      const localVarPath = `/vendors/{id}/auto-payment`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postVendorAutoPaymentRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * 
     * @summary create vendor ebills subscription
     * @param {PostVendorEbillsSubscriptionRequest} postVendorEbillsSubscriptionRequest vendor ebills subscription parameters
     * @param {string} id ID of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postEbillsSubscription: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (postVendorEbillsSubscriptionRequest, id, options = {}) {
      assertParamExists("postEbillsSubscription", "postVendorEbillsSubscriptionRequest", postVendorEbillsSubscriptionRequest);
      assertParamExists("postEbillsSubscription", "id", id);
      const localVarPath = `/vendors/{id}/ebills-subscription`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postVendorEbillsSubscriptionRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Create (attach) a Vendor to an Account.
     * @summary Create a Vendor
     * @param {PostVendorsRequest} [postVendorsRequest] 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postVendors: (_0, _1, _2, _3, _4, _5, ..._6) => __async(this, [_0, _1, _2, _3, _4, _5, ..._6], function* (postVendorsRequest, expand, organizationId, userId, idempotencyKey, melioAccount, options = {}) {
      const localVarPath = `/vendors`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (expand !== void 0 && expand !== null) {
        localVarHeaderParameter["expand"] = String(JSON.stringify(expand));
      }
      if (organizationId !== void 0 && organizationId !== null) {
        localVarHeaderParameter["Organization-id"] = String(organizationId);
      }
      if (userId !== void 0 && userId !== null) {
        localVarHeaderParameter["User-id"] = String(userId);
      }
      if (idempotencyKey !== void 0 && idempotencyKey !== null) {
        localVarHeaderParameter["Idempotency-Key"] = String(idempotencyKey);
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postVendorsRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Create (attach) multiple Vendors to an Account, based on a provided list of business entities.
     * @summary Create multiple Vendors
     * @param {PostVendorsBulkRequest} [postVendorsBulkRequest] 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postVendorsBulk: (_0, _1, _2, _3, _4, _5, ..._6) => __async(this, [_0, _1, _2, _3, _4, _5, ..._6], function* (postVendorsBulkRequest, expand, idempotencyKey, melioAccount, organizationId, userId, options = {}) {
      const localVarPath = `/vendors/bulk`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (expand !== void 0 && expand !== null) {
        localVarHeaderParameter["expand"] = String(JSON.stringify(expand));
      }
      if (idempotencyKey !== void 0 && idempotencyKey !== null) {
        localVarHeaderParameter["Idempotency-Key"] = String(idempotencyKey);
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      if (organizationId !== void 0 && organizationId !== null) {
        localVarHeaderParameter["Organization-id"] = String(organizationId);
      }
      if (userId !== void 0 && userId !== null) {
        localVarHeaderParameter["User-id"] = String(userId);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postVendorsBulkRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Validate the creation of multiple Vendors to an Account, based on a provided list of business entities.
     * @summary Validate creation of multiple Vendors
     * @param {PostVendorsBulkRequest} [postVendorsBulkRequest] 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postVendorsBulkValidate: (_0, _1, _2, _3, ..._4) => __async(this, [_0, _1, _2, _3, ..._4], function* (postVendorsBulkRequest, expand, idempotencyKey, melioAccount, options = {}) {
      const localVarPath = `/vendors/bulk/validate`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (expand !== void 0 && expand !== null) {
        localVarHeaderParameter["expand"] = String(JSON.stringify(expand));
      }
      if (idempotencyKey !== void 0 && idempotencyKey !== null) {
        localVarHeaderParameter["Idempotency-Key"] = String(idempotencyKey);
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postVendorsBulkRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Link existing Melio vendor to directory.
     * @summary Link existing Melio vendor to directory
     * @param {string} id ID of the entity
     * @param {PostVendorsLinkToDirectoryRequest} [postVendorsLinkToDirectoryRequest] 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postVendorsLinkToDirectory: (_0, _1, _2, _3, _4, _5, _6, ..._7) => __async(this, [_0, _1, _2, _3, _4, _5, _6, ..._7], function* (id, postVendorsLinkToDirectoryRequest, expand, idempotencyKey, melioAccount, organizationId, userId, options = {}) {
      assertParamExists("postVendorsLinkToDirectory", "id", id);
      const localVarPath = `/vendors/{id}/link-to-directory`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (expand !== void 0 && expand !== null) {
        localVarHeaderParameter["expand"] = String(JSON.stringify(expand));
      }
      if (idempotencyKey !== void 0 && idempotencyKey !== null) {
        localVarHeaderParameter["Idempotency-Key"] = String(idempotencyKey);
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      if (organizationId !== void 0 && organizationId !== null) {
        localVarHeaderParameter["Organization-id"] = String(organizationId);
      }
      if (userId !== void 0 && userId !== null) {
        localVarHeaderParameter["User-id"] = String(userId);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postVendorsLinkToDirectoryRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Create a Vendor\'s Delivery Method
     * @summary Create a Vendor\'s Delivery Method
     * @param {string} id ID of the entity
     * @param {PostDeliveryMethodsRequest} [body] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postVendorsVendorIdDeliveryMethods: (_0, _1, _2, _3, ..._4) => __async(this, [_0, _1, _2, _3, ..._4], function* (id, body, idempotencyKey, melioAccount, options = {}) {
      assertParamExists("postVendorsVendorIdDeliveryMethods", "id", id);
      const localVarPath = `/vendors/{id}/delivery-methods`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (idempotencyKey !== void 0 && idempotencyKey !== null) {
        localVarHeaderParameter["Idempotency-Key"] = String(idempotencyKey);
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Create a request to Vendor to provide W-9 data
     * @summary Send a taxpayer identification request to collect W-9 data
     * @param {string} id ID of the entity
     * @param {PostVendorsVendorIdTaxpayerIdentificationRequestsRequest} [postVendorsVendorIdTaxpayerIdentificationRequestsRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postVendorsVendorIdTaxpayerIdentificationRequests: (_0, _1, _2, _3, ..._4) => __async(this, [_0, _1, _2, _3, ..._4], function* (id, postVendorsVendorIdTaxpayerIdentificationRequestsRequest, idempotencyKey, melioAccount, options = {}) {
      assertParamExists("postVendorsVendorIdTaxpayerIdentificationRequests", "id", id);
      const localVarPath = `/vendors/{id}/taxpayer-identification-requests`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (idempotencyKey !== void 0 && idempotencyKey !== null) {
        localVarHeaderParameter["Idempotency-Key"] = String(idempotencyKey);
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postVendorsVendorIdTaxpayerIdentificationRequestsRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Cancel a request to Vendor to provide W-9 data
     * @summary Cancel a taxpayer identification request to collect W-9 data
     * @param {string} id ID of the entity
     * @param {string} taxpayerIdentificationRequestId 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postVendorsVendorIdTaxpayerIdentificationRequestsTaxpayerIdentificationRequestIdCancel: (_0, _1, _2, ..._3) => __async(this, [_0, _1, _2, ..._3], function* (id, taxpayerIdentificationRequestId, melioAccount, options = {}) {
      assertParamExists("postVendorsVendorIdTaxpayerIdentificationRequestsTaxpayerIdentificationRequestIdCancel", "id", id);
      assertParamExists("postVendorsVendorIdTaxpayerIdentificationRequestsTaxpayerIdentificationRequestIdCancel", "taxpayerIdentificationRequestId", taxpayerIdentificationRequestId);
      const localVarPath = `/vendors/{id}/taxpayer-identification-requests/{taxpayerIdentificationRequestId}/cancel`.replace(`{${"id"}}`, encodeURIComponent(String(id))).replace(`{${"taxpayerIdentificationRequestId"}}`, encodeURIComponent(String(taxpayerIdentificationRequestId)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Resend a request to Vendor to provide W-9 data
     * @summary Resend a taxpayer identification request to collect W-9 data
     * @param {string} id ID of the entity
     * @param {string} taxpayerIdentificationRequestId 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postVendorsVendorIdTaxpayerIdentificationRequestsTaxpayerIdentificationRequestIdResend: (_0, _1, _2, ..._3) => __async(this, [_0, _1, _2, ..._3], function* (id, taxpayerIdentificationRequestId, melioAccount, options = {}) {
      assertParamExists("postVendorsVendorIdTaxpayerIdentificationRequestsTaxpayerIdentificationRequestIdResend", "id", id);
      assertParamExists("postVendorsVendorIdTaxpayerIdentificationRequestsTaxpayerIdentificationRequestIdResend", "taxpayerIdentificationRequestId", taxpayerIdentificationRequestId);
      const localVarPath = `/vendors/{id}/taxpayer-identification-requests/{taxpayerIdentificationRequestId}/resend`.replace(`{${"id"}}`, encodeURIComponent(String(id))).replace(`{${"taxpayerIdentificationRequestId"}}`, encodeURIComponent(String(taxpayerIdentificationRequestId)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Create a taxpayer information, allows to persist W-9 file data
     * @summary Create a taxpayer information, allows to persist W-9 file data
     * @param {string} id ID of the entity
     * @param {any} [file] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postVendorsVendorIdTaxpayerInfo: (_0, _1, _2, _3, ..._4) => __async(this, [_0, _1, _2, _3, ..._4], function* (id, file, idempotencyKey, melioAccount, options = {}) {
      assertParamExists("postVendorsVendorIdTaxpayerInfo", "id", id);
      const localVarPath = `/vendors/{id}/taxpayer-info`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      const localVarFormParams = new (configuration && configuration.formDataCtor || FormData)();
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (idempotencyKey !== void 0 && idempotencyKey !== null) {
        localVarHeaderParameter["Idempotency-Key"] = String(idempotencyKey);
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      if (file !== void 0) {
        localVarFormParams.append("file", file);
      }
      localVarHeaderParameter["Content-Type"] = "multipart/form-data";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = localVarFormParams;
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Create a Unilateral Request of a Vendor
     * @summary Create a Unilateral Request of a Vendor
     * @param {string} id ID of the entity
     * @param {PostVendorsVendorIdUnilateralRequestsRequest} [postVendorsVendorIdUnilateralRequestsRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postVendorsVendorIdUnilateralRequests: (_0, _1, _2, _3, ..._4) => __async(this, [_0, _1, _2, _3, ..._4], function* (id, postVendorsVendorIdUnilateralRequestsRequest, idempotencyKey, melioAccount, options = {}) {
      assertParamExists("postVendorsVendorIdUnilateralRequests", "id", id);
      const localVarPath = `/vendors/{id}/unilateral-requests`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (idempotencyKey !== void 0 && idempotencyKey !== null) {
        localVarHeaderParameter["Idempotency-Key"] = String(idempotencyKey);
      }
      if (melioAccount !== void 0 && melioAccount !== null) {
        localVarHeaderParameter["Melio-Account"] = String(melioAccount);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postVendorsVendorIdUnilateralRequestsRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    })
  };
};
var VendorsApiFp = function(configuration) {
  const localVarAxiosParamCreator = VendorsApiAxiosParamCreator(configuration);
  return {
    /**
     * Accept organization id and local vendor id of the same business and match them at business directory
     * @summary Matching between local vendor and owned-by vendor at Business directory
     * @param {string} id ID of the entity
     * @param {PostVendorsCopyDeliveryMethodRequest} [postVendorsCopyDeliveryMethodRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    copyDeliveryMethodFromOwnedVendorToLocalVendor(id, postVendorsCopyDeliveryMethodRequest, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.copyDeliveryMethodFromOwnedVendorToLocalVendor(id, postVendorsCopyDeliveryMethodRequest, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Delete a managed vendor\'s auto payment
     * @summary Delete a managed vendor\'s auto payment
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteAutoPayment(id, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteAutoPayment(id, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * 
     * @summary cancel vendor ebills subscription
     * @param {string} id ID of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteEbillsSubscription(id, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteEbillsSubscription(id, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Remove a Taxpayer Info
     * @summary Delete a Taxpayer Info
     * @param {string} id ID of the entity
     * @param {string} taxpayerInfoId 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteTaxpayerInfoTaxpayerInfoId(id, taxpayerInfoId, idempotencyKey, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteTaxpayerInfoTaxpayerInfoId(id, taxpayerInfoId, idempotencyKey, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Removing a Vendor from an Account.
     * @summary Delete a Vendor
     * @param {string} id ID of the entity
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteVendorsVendorId(id, expand, idempotencyKey, melioAccount, organizationId, userId, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteVendorsVendorId(id, expand, idempotencyKey, melioAccount, organizationId, userId, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Get a managed vendor\'s auto payment
     * @summary Get a managed vendor\'s auto payment
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAutoPayment(id, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getAutoPayment(id, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Get a managed vendor\'s auto payment options
     * @summary Get a managed vendor\'s auto payment options
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAutoPaymentOptions(id, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getAutoPaymentOptions(id, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Get a Taxpayer Info
     * @summary Get a Taxpayer Info
     * @param {string} id ID of the entity
     * @param {string} taxpayerInfoId 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTaxpayerInfoTaxpayerInfoId(id, taxpayerInfoId, idempotencyKey, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getTaxpayerInfoTaxpayerInfoId(id, taxpayerInfoId, idempotencyKey, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Get a vendor\'s ebill subscription form
     * @summary Get a vendor\'s ebill subscription form
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getVendorEbillsSubscriptionForm(id, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getVendorEbillsSubscriptionForm(id, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Get a list of the fields that can be edited for a vendor.
     * @summary Get a list of the fields that can be edited for a vendor.
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getVendorEditableFields(id, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getVendorEditableFields(id, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Get a vendor\'s unmasked account number
     * @summary Get a vendor\'s unmasked account number
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getVendorUnmaskedAccountNumber(id, melioAccount, organizationId, userId, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getVendorUnmaskedAccountNumber(id, melioAccount, organizationId, userId, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Retrieve a list of Vendors that are attached to an Account
     * @summary Retrieve all Vendors
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {string} [searchTerm] Limit returned objects to those that contain the specified search string. Search is a case-insensitive, substring match against a subset of fields in the object. See the method documentation to learn which fields can be matched by the &#x60;searchTerm&#x60; value. [Read more](https://docs.melio.com/docs/melio-data-api/getting-started#simple_search) 
     * @param {Array<VendorsSortQueryParam>} [sort] Sort query parameter - sort data by entity fields
     * @param {string} [search] Limit returned objects to those that satisfy the specified query. Query strings support logic and comparison against fields that you specify. See the method documentation to learn which fields can be included in your query, or [read more about query strings](https://docs.melio.com/docs/melio-data-api/getting-started#advanced_search).
     * @param {number} [limit] A limit on the number of records to be returned.
     * @param {PaginationCursor} [cursor] Used to page through page through results when the &#x60;totalCount&#x60; is more than the current set of results. To page, specify \&quot;cursor[prev]&#x3D;_&lt;prev_token&gt;_\&quot; or \&quot;cursor[next]&#x3D;_&lt;next_token&gt;_\&quot; as a URL parameter. 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getVendors(expand, organizationId, userId, searchTerm, sort, search, limit, cursor, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getVendors(expand, organizationId, userId, searchTerm, sort, search, limit, cursor, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Retrieve a single Vendor using its ID.
     * @summary Retrieve a Vendor
     * @param {string} id ID of the entity
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getVendorsVendorId(id, expand, melioAccount, organizationId, userId, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getVendorsVendorId(id, expand, melioAccount, organizationId, userId, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Retrieve Vendor supported delivery method types
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getVendorsVendorIdDeliveryMethodTypeOptions(id, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getVendorsVendorIdDeliveryMethodTypeOptions(id, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Get a list of a Vendor\'s Delivery Methods, that can be used to sent funds to.
     * @summary Retrieve a Vendor\'s Delivery Methods
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getVendorsVendorIdDeliveryMethods(id, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getVendorsVendorIdDeliveryMethods(id, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Retrieve Vendor Stats.
     * @summary Retrieve Vendor Stats
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getVendorsVendorIdStats(id, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getVendorsVendorIdStats(id, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Get a list of a Vendor\'s Unilateral Requests.
     * @summary Retrieve Vendor\'s unilateral requests
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getVendorsVendorIdUnilateralRequests(id, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getVendorsVendorIdUnilateralRequests(id, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Get if the vendor is valid for resending to him a unilateral request
     * @summary Returns whether vendor is valid for resend unilateral request
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getVendorsVendorIdUnilateralRequestsValidationForResend(id, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getVendorsVendorIdUnilateralRequestsValidationForResend(id, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Update a managed vendor\'s auto payment
     * @summary Update a managed vendor\'s auto payment
     * @param {PatchVendorAutoPaymentRequest} patchVendorAutoPaymentRequest 
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchAutoPayment(patchVendorAutoPaymentRequest, id, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.patchAutoPayment(patchVendorAutoPaymentRequest, id, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Update an existing Vendor.  The request\'s body can be partial, and only provided fields will be overwritten. Set an optional field to `null` in order to remove its contents.
     * @summary Update a Vendor
     * @param {string} id ID of the entity
     * @param {PatchVendorsVendorIdRequest} [patchVendorsVendorIdRequest] 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchVendorsVendorId(id, patchVendorsVendorIdRequest, expand, idempotencyKey, melioAccount, organizationId, userId, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.patchVendorsVendorId(id, patchVendorsVendorIdRequest, expand, idempotencyKey, melioAccount, organizationId, userId, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Create a managed vendor\'s auto payment
     * @summary Create a managed vendor\'s auto payment
     * @param {PostVendorAutoPaymentRequest} postVendorAutoPaymentRequest 
     * @param {string} id ID of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postAutoPayment(postVendorAutoPaymentRequest, id, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postAutoPayment(postVendorAutoPaymentRequest, id, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * 
     * @summary create vendor ebills subscription
     * @param {PostVendorEbillsSubscriptionRequest} postVendorEbillsSubscriptionRequest vendor ebills subscription parameters
     * @param {string} id ID of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postEbillsSubscription(postVendorEbillsSubscriptionRequest, id, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postEbillsSubscription(postVendorEbillsSubscriptionRequest, id, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Create (attach) a Vendor to an Account.
     * @summary Create a Vendor
     * @param {PostVendorsRequest} [postVendorsRequest] 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postVendors(postVendorsRequest, expand, organizationId, userId, idempotencyKey, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postVendors(postVendorsRequest, expand, organizationId, userId, idempotencyKey, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Create (attach) multiple Vendors to an Account, based on a provided list of business entities.
     * @summary Create multiple Vendors
     * @param {PostVendorsBulkRequest} [postVendorsBulkRequest] 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postVendorsBulk(postVendorsBulkRequest, expand, idempotencyKey, melioAccount, organizationId, userId, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postVendorsBulk(postVendorsBulkRequest, expand, idempotencyKey, melioAccount, organizationId, userId, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Validate the creation of multiple Vendors to an Account, based on a provided list of business entities.
     * @summary Validate creation of multiple Vendors
     * @param {PostVendorsBulkRequest} [postVendorsBulkRequest] 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postVendorsBulkValidate(postVendorsBulkRequest, expand, idempotencyKey, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postVendorsBulkValidate(postVendorsBulkRequest, expand, idempotencyKey, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Link existing Melio vendor to directory.
     * @summary Link existing Melio vendor to directory
     * @param {string} id ID of the entity
     * @param {PostVendorsLinkToDirectoryRequest} [postVendorsLinkToDirectoryRequest] 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postVendorsLinkToDirectory(id, postVendorsLinkToDirectoryRequest, expand, idempotencyKey, melioAccount, organizationId, userId, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postVendorsLinkToDirectory(id, postVendorsLinkToDirectoryRequest, expand, idempotencyKey, melioAccount, organizationId, userId, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Create a Vendor\'s Delivery Method
     * @summary Create a Vendor\'s Delivery Method
     * @param {string} id ID of the entity
     * @param {PostDeliveryMethodsRequest} [body] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postVendorsVendorIdDeliveryMethods(id, body, idempotencyKey, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postVendorsVendorIdDeliveryMethods(id, body, idempotencyKey, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Create a request to Vendor to provide W-9 data
     * @summary Send a taxpayer identification request to collect W-9 data
     * @param {string} id ID of the entity
     * @param {PostVendorsVendorIdTaxpayerIdentificationRequestsRequest} [postVendorsVendorIdTaxpayerIdentificationRequestsRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postVendorsVendorIdTaxpayerIdentificationRequests(id, postVendorsVendorIdTaxpayerIdentificationRequestsRequest, idempotencyKey, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postVendorsVendorIdTaxpayerIdentificationRequests(id, postVendorsVendorIdTaxpayerIdentificationRequestsRequest, idempotencyKey, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Cancel a request to Vendor to provide W-9 data
     * @summary Cancel a taxpayer identification request to collect W-9 data
     * @param {string} id ID of the entity
     * @param {string} taxpayerIdentificationRequestId 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postVendorsVendorIdTaxpayerIdentificationRequestsTaxpayerIdentificationRequestIdCancel(id, taxpayerIdentificationRequestId, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postVendorsVendorIdTaxpayerIdentificationRequestsTaxpayerIdentificationRequestIdCancel(id, taxpayerIdentificationRequestId, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Resend a request to Vendor to provide W-9 data
     * @summary Resend a taxpayer identification request to collect W-9 data
     * @param {string} id ID of the entity
     * @param {string} taxpayerIdentificationRequestId 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postVendorsVendorIdTaxpayerIdentificationRequestsTaxpayerIdentificationRequestIdResend(id, taxpayerIdentificationRequestId, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postVendorsVendorIdTaxpayerIdentificationRequestsTaxpayerIdentificationRequestIdResend(id, taxpayerIdentificationRequestId, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Create a taxpayer information, allows to persist W-9 file data
     * @summary Create a taxpayer information, allows to persist W-9 file data
     * @param {string} id ID of the entity
     * @param {any} [file] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postVendorsVendorIdTaxpayerInfo(id, file, idempotencyKey, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postVendorsVendorIdTaxpayerInfo(id, file, idempotencyKey, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Create a Unilateral Request of a Vendor
     * @summary Create a Unilateral Request of a Vendor
     * @param {string} id ID of the entity
     * @param {PostVendorsVendorIdUnilateralRequestsRequest} [postVendorsVendorIdUnilateralRequestsRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postVendorsVendorIdUnilateralRequests(id, postVendorsVendorIdUnilateralRequestsRequest, idempotencyKey, melioAccount, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postVendorsVendorIdUnilateralRequests(id, postVendorsVendorIdUnilateralRequestsRequest, idempotencyKey, melioAccount, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    }
  };
};
var VendorsApiClient = createApiFromFp(VendorsApiFp);
var VendorsApiFactory = function(configuration, basePath, axios2) {
  const localVarFp = VendorsApiFp(configuration);
  return {
    /**
     * Accept organization id and local vendor id of the same business and match them at business directory
     * @summary Matching between local vendor and owned-by vendor at Business directory
     * @param {string} id ID of the entity
     * @param {PostVendorsCopyDeliveryMethodRequest} [postVendorsCopyDeliveryMethodRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    copyDeliveryMethodFromOwnedVendorToLocalVendor(id, postVendorsCopyDeliveryMethodRequest, options) {
      return localVarFp.copyDeliveryMethodFromOwnedVendorToLocalVendor(id, postVendorsCopyDeliveryMethodRequest, options).then((request) => request(axios2, basePath));
    },
    /**
     * Delete a managed vendor\'s auto payment
     * @summary Delete a managed vendor\'s auto payment
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteAutoPayment(id, melioAccount, options) {
      return localVarFp.deleteAutoPayment(id, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * 
     * @summary cancel vendor ebills subscription
     * @param {string} id ID of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteEbillsSubscription(id, options) {
      return localVarFp.deleteEbillsSubscription(id, options).then((request) => request(axios2, basePath));
    },
    /**
     * Remove a Taxpayer Info
     * @summary Delete a Taxpayer Info
     * @param {string} id ID of the entity
     * @param {string} taxpayerInfoId 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteTaxpayerInfoTaxpayerInfoId(id, taxpayerInfoId, idempotencyKey, melioAccount, options) {
      return localVarFp.deleteTaxpayerInfoTaxpayerInfoId(id, taxpayerInfoId, idempotencyKey, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Removing a Vendor from an Account.
     * @summary Delete a Vendor
     * @param {string} id ID of the entity
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteVendorsVendorId(id, expand, idempotencyKey, melioAccount, organizationId, userId, options) {
      return localVarFp.deleteVendorsVendorId(id, expand, idempotencyKey, melioAccount, organizationId, userId, options).then((request) => request(axios2, basePath));
    },
    /**
     * Get a managed vendor\'s auto payment
     * @summary Get a managed vendor\'s auto payment
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAutoPayment(id, melioAccount, options) {
      return localVarFp.getAutoPayment(id, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Get a managed vendor\'s auto payment options
     * @summary Get a managed vendor\'s auto payment options
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAutoPaymentOptions(id, melioAccount, options) {
      return localVarFp.getAutoPaymentOptions(id, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Get a Taxpayer Info
     * @summary Get a Taxpayer Info
     * @param {string} id ID of the entity
     * @param {string} taxpayerInfoId 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTaxpayerInfoTaxpayerInfoId(id, taxpayerInfoId, idempotencyKey, melioAccount, options) {
      return localVarFp.getTaxpayerInfoTaxpayerInfoId(id, taxpayerInfoId, idempotencyKey, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Get a vendor\'s ebill subscription form
     * @summary Get a vendor\'s ebill subscription form
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getVendorEbillsSubscriptionForm(id, melioAccount, options) {
      return localVarFp.getVendorEbillsSubscriptionForm(id, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Get a list of the fields that can be edited for a vendor.
     * @summary Get a list of the fields that can be edited for a vendor.
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getVendorEditableFields(id, melioAccount, options) {
      return localVarFp.getVendorEditableFields(id, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Get a vendor\'s unmasked account number
     * @summary Get a vendor\'s unmasked account number
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getVendorUnmaskedAccountNumber(id, melioAccount, organizationId, userId, options) {
      return localVarFp.getVendorUnmaskedAccountNumber(id, melioAccount, organizationId, userId, options).then((request) => request(axios2, basePath));
    },
    /**
     * Retrieve a list of Vendors that are attached to an Account
     * @summary Retrieve all Vendors
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {string} [searchTerm] Limit returned objects to those that contain the specified search string. Search is a case-insensitive, substring match against a subset of fields in the object. See the method documentation to learn which fields can be matched by the &#x60;searchTerm&#x60; value. [Read more](https://docs.melio.com/docs/melio-data-api/getting-started#simple_search) 
     * @param {Array<VendorsSortQueryParam>} [sort] Sort query parameter - sort data by entity fields
     * @param {string} [search] Limit returned objects to those that satisfy the specified query. Query strings support logic and comparison against fields that you specify. See the method documentation to learn which fields can be included in your query, or [read more about query strings](https://docs.melio.com/docs/melio-data-api/getting-started#advanced_search).
     * @param {number} [limit] A limit on the number of records to be returned.
     * @param {PaginationCursor} [cursor] Used to page through page through results when the &#x60;totalCount&#x60; is more than the current set of results. To page, specify \&quot;cursor[prev]&#x3D;_&lt;prev_token&gt;_\&quot; or \&quot;cursor[next]&#x3D;_&lt;next_token&gt;_\&quot; as a URL parameter. 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getVendors(expand, organizationId, userId, searchTerm, sort, search, limit, cursor, options) {
      return localVarFp.getVendors(expand, organizationId, userId, searchTerm, sort, search, limit, cursor, options).then((request) => request(axios2, basePath));
    },
    /**
     * Retrieve a single Vendor using its ID.
     * @summary Retrieve a Vendor
     * @param {string} id ID of the entity
     * @param {Expand} [expand] Used to limit data in the returned object to specified fields as a query parameter. See the object or endpoint documentation to see which fields are supported in your request. You can also specify this as a header. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getVendorsVendorId(id, expand, melioAccount, organizationId, userId, options) {
      return localVarFp.getVendorsVendorId(id, expand, melioAccount, organizationId, userId, options).then((request) => request(axios2, basePath));
    },
    /**
     * Retrieve Vendor supported delivery method types
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getVendorsVendorIdDeliveryMethodTypeOptions(id, melioAccount, options) {
      return localVarFp.getVendorsVendorIdDeliveryMethodTypeOptions(id, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Get a list of a Vendor\'s Delivery Methods, that can be used to sent funds to.
     * @summary Retrieve a Vendor\'s Delivery Methods
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getVendorsVendorIdDeliveryMethods(id, melioAccount, options) {
      return localVarFp.getVendorsVendorIdDeliveryMethods(id, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Retrieve Vendor Stats.
     * @summary Retrieve Vendor Stats
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getVendorsVendorIdStats(id, melioAccount, options) {
      return localVarFp.getVendorsVendorIdStats(id, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Get a list of a Vendor\'s Unilateral Requests.
     * @summary Retrieve Vendor\'s unilateral requests
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getVendorsVendorIdUnilateralRequests(id, melioAccount, options) {
      return localVarFp.getVendorsVendorIdUnilateralRequests(id, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Get if the vendor is valid for resending to him a unilateral request
     * @summary Returns whether vendor is valid for resend unilateral request
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getVendorsVendorIdUnilateralRequestsValidationForResend(id, melioAccount, options) {
      return localVarFp.getVendorsVendorIdUnilateralRequestsValidationForResend(id, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Update a managed vendor\'s auto payment
     * @summary Update a managed vendor\'s auto payment
     * @param {PatchVendorAutoPaymentRequest} patchVendorAutoPaymentRequest 
     * @param {string} id ID of the entity
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchAutoPayment(patchVendorAutoPaymentRequest, id, melioAccount, options) {
      return localVarFp.patchAutoPayment(patchVendorAutoPaymentRequest, id, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Update an existing Vendor.  The request\'s body can be partial, and only provided fields will be overwritten. Set an optional field to `null` in order to remove its contents.
     * @summary Update a Vendor
     * @param {string} id ID of the entity
     * @param {PatchVendorsVendorIdRequest} [patchVendorsVendorIdRequest] 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchVendorsVendorId(id, patchVendorsVendorIdRequest, expand, idempotencyKey, melioAccount, organizationId, userId, options) {
      return localVarFp.patchVendorsVendorId(id, patchVendorsVendorIdRequest, expand, idempotencyKey, melioAccount, organizationId, userId, options).then((request) => request(axios2, basePath));
    },
    /**
     * Create a managed vendor\'s auto payment
     * @summary Create a managed vendor\'s auto payment
     * @param {PostVendorAutoPaymentRequest} postVendorAutoPaymentRequest 
     * @param {string} id ID of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postAutoPayment(postVendorAutoPaymentRequest, id, options) {
      return localVarFp.postAutoPayment(postVendorAutoPaymentRequest, id, options).then((request) => request(axios2, basePath));
    },
    /**
     * 
     * @summary create vendor ebills subscription
     * @param {PostVendorEbillsSubscriptionRequest} postVendorEbillsSubscriptionRequest vendor ebills subscription parameters
     * @param {string} id ID of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postEbillsSubscription(postVendorEbillsSubscriptionRequest, id, options) {
      return localVarFp.postEbillsSubscription(postVendorEbillsSubscriptionRequest, id, options).then((request) => request(axios2, basePath));
    },
    /**
     * Create (attach) a Vendor to an Account.
     * @summary Create a Vendor
     * @param {PostVendorsRequest} [postVendorsRequest] 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postVendors(postVendorsRequest, expand, organizationId, userId, idempotencyKey, melioAccount, options) {
      return localVarFp.postVendors(postVendorsRequest, expand, organizationId, userId, idempotencyKey, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Create (attach) multiple Vendors to an Account, based on a provided list of business entities.
     * @summary Create multiple Vendors
     * @param {PostVendorsBulkRequest} [postVendorsBulkRequest] 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postVendorsBulk(postVendorsBulkRequest, expand, idempotencyKey, melioAccount, organizationId, userId, options) {
      return localVarFp.postVendorsBulk(postVendorsBulkRequest, expand, idempotencyKey, melioAccount, organizationId, userId, options).then((request) => request(axios2, basePath));
    },
    /**
     * Validate the creation of multiple Vendors to an Account, based on a provided list of business entities.
     * @summary Validate creation of multiple Vendors
     * @param {PostVendorsBulkRequest} [postVendorsBulkRequest] 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postVendorsBulkValidate(postVendorsBulkRequest, expand, idempotencyKey, melioAccount, options) {
      return localVarFp.postVendorsBulkValidate(postVendorsBulkRequest, expand, idempotencyKey, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Link existing Melio vendor to directory.
     * @summary Link existing Melio vendor to directory
     * @param {string} id ID of the entity
     * @param {PostVendorsLinkToDirectoryRequest} [postVendorsLinkToDirectoryRequest] 
     * @param {Expand} [expand] Which fields to include in the response. You can provide expand parameters in either a header or as a query parameter. See _Data expansion_ in the [Getting started guide](/docs/melio-data-api/getting-started#filtering). 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {string} [organizationId] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postVendorsLinkToDirectory(id, postVendorsLinkToDirectoryRequest, expand, idempotencyKey, melioAccount, organizationId, userId, options) {
      return localVarFp.postVendorsLinkToDirectory(id, postVendorsLinkToDirectoryRequest, expand, idempotencyKey, melioAccount, organizationId, userId, options).then((request) => request(axios2, basePath));
    },
    /**
     * Create a Vendor\'s Delivery Method
     * @summary Create a Vendor\'s Delivery Method
     * @param {string} id ID of the entity
     * @param {PostDeliveryMethodsRequest} [body] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postVendorsVendorIdDeliveryMethods(id, body, idempotencyKey, melioAccount, options) {
      return localVarFp.postVendorsVendorIdDeliveryMethods(id, body, idempotencyKey, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Create a request to Vendor to provide W-9 data
     * @summary Send a taxpayer identification request to collect W-9 data
     * @param {string} id ID of the entity
     * @param {PostVendorsVendorIdTaxpayerIdentificationRequestsRequest} [postVendorsVendorIdTaxpayerIdentificationRequestsRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postVendorsVendorIdTaxpayerIdentificationRequests(id, postVendorsVendorIdTaxpayerIdentificationRequestsRequest, idempotencyKey, melioAccount, options) {
      return localVarFp.postVendorsVendorIdTaxpayerIdentificationRequests(id, postVendorsVendorIdTaxpayerIdentificationRequestsRequest, idempotencyKey, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Cancel a request to Vendor to provide W-9 data
     * @summary Cancel a taxpayer identification request to collect W-9 data
     * @param {string} id ID of the entity
     * @param {string} taxpayerIdentificationRequestId 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postVendorsVendorIdTaxpayerIdentificationRequestsTaxpayerIdentificationRequestIdCancel(id, taxpayerIdentificationRequestId, melioAccount, options) {
      return localVarFp.postVendorsVendorIdTaxpayerIdentificationRequestsTaxpayerIdentificationRequestIdCancel(id, taxpayerIdentificationRequestId, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Resend a request to Vendor to provide W-9 data
     * @summary Resend a taxpayer identification request to collect W-9 data
     * @param {string} id ID of the entity
     * @param {string} taxpayerIdentificationRequestId 
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postVendorsVendorIdTaxpayerIdentificationRequestsTaxpayerIdentificationRequestIdResend(id, taxpayerIdentificationRequestId, melioAccount, options) {
      return localVarFp.postVendorsVendorIdTaxpayerIdentificationRequestsTaxpayerIdentificationRequestIdResend(id, taxpayerIdentificationRequestId, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Create a taxpayer information, allows to persist W-9 file data
     * @summary Create a taxpayer information, allows to persist W-9 file data
     * @param {string} id ID of the entity
     * @param {any} [file] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postVendorsVendorIdTaxpayerInfo(id, file, idempotencyKey, melioAccount, options) {
      return localVarFp.postVendorsVendorIdTaxpayerInfo(id, file, idempotencyKey, melioAccount, options).then((request) => request(axios2, basePath));
    },
    /**
     * Create a Unilateral Request of a Vendor
     * @summary Create a Unilateral Request of a Vendor
     * @param {string} id ID of the entity
     * @param {PostVendorsVendorIdUnilateralRequestsRequest} [postVendorsVendorIdUnilateralRequestsRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {string} [melioAccount] Identifies the Melio account against which you are making this API call. Retrieve the Melio account ID by calling &#x60;GET .../accounts/identify&#x60;. **Required when using [API Key security](https://melio-docs.stoplight.io/docs/melio-data-api/getting-started#security-header).** 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postVendorsVendorIdUnilateralRequests(id, postVendorsVendorIdUnilateralRequestsRequest, idempotencyKey, melioAccount, options) {
      return localVarFp.postVendorsVendorIdUnilateralRequests(id, postVendorsVendorIdUnilateralRequestsRequest, idempotencyKey, melioAccount, options).then((request) => request(axios2, basePath));
    }
  };
};
var VendorsApi = class extends BaseAPI {
  /**
   * Accept organization id and local vendor id of the same business and match them at business directory
   * @summary Matching between local vendor and owned-by vendor at Business directory
   * @param {VendorsApiCopyDeliveryMethodFromOwnedVendorToLocalVendorRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VendorsApi
   */
  copyDeliveryMethodFromOwnedVendorToLocalVendor(requestParameters, options) {
    return VendorsApiFp(this.configuration).copyDeliveryMethodFromOwnedVendorToLocalVendor(requestParameters.id, requestParameters.postVendorsCopyDeliveryMethodRequest, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Delete a managed vendor\'s auto payment
   * @summary Delete a managed vendor\'s auto payment
   * @param {VendorsApiDeleteAutoPaymentRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VendorsApi
   */
  deleteAutoPayment(requestParameters, options) {
    return VendorsApiFp(this.configuration).deleteAutoPayment(requestParameters.id, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * 
   * @summary cancel vendor ebills subscription
   * @param {VendorsApiDeleteEbillsSubscriptionRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VendorsApi
   */
  deleteEbillsSubscription(requestParameters, options) {
    return VendorsApiFp(this.configuration).deleteEbillsSubscription(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Remove a Taxpayer Info
   * @summary Delete a Taxpayer Info
   * @param {VendorsApiDeleteTaxpayerInfoTaxpayerInfoIdRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VendorsApi
   */
  deleteTaxpayerInfoTaxpayerInfoId(requestParameters, options) {
    return VendorsApiFp(this.configuration).deleteTaxpayerInfoTaxpayerInfoId(requestParameters.id, requestParameters.taxpayerInfoId, requestParameters.idempotencyKey, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Removing a Vendor from an Account.
   * @summary Delete a Vendor
   * @param {VendorsApiDeleteVendorsVendorIdRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VendorsApi
   */
  deleteVendorsVendorId(requestParameters, options) {
    return VendorsApiFp(this.configuration).deleteVendorsVendorId(requestParameters.id, requestParameters.expand, requestParameters.idempotencyKey, requestParameters.melioAccount, requestParameters.organizationId, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Get a managed vendor\'s auto payment
   * @summary Get a managed vendor\'s auto payment
   * @param {VendorsApiGetAutoPaymentRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VendorsApi
   */
  getAutoPayment(requestParameters, options) {
    return VendorsApiFp(this.configuration).getAutoPayment(requestParameters.id, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Get a managed vendor\'s auto payment options
   * @summary Get a managed vendor\'s auto payment options
   * @param {VendorsApiGetAutoPaymentOptionsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VendorsApi
   */
  getAutoPaymentOptions(requestParameters, options) {
    return VendorsApiFp(this.configuration).getAutoPaymentOptions(requestParameters.id, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Get a Taxpayer Info
   * @summary Get a Taxpayer Info
   * @param {VendorsApiGetTaxpayerInfoTaxpayerInfoIdRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VendorsApi
   */
  getTaxpayerInfoTaxpayerInfoId(requestParameters, options) {
    return VendorsApiFp(this.configuration).getTaxpayerInfoTaxpayerInfoId(requestParameters.id, requestParameters.taxpayerInfoId, requestParameters.idempotencyKey, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Get a vendor\'s ebill subscription form
   * @summary Get a vendor\'s ebill subscription form
   * @param {VendorsApiGetVendorEbillsSubscriptionFormRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VendorsApi
   */
  getVendorEbillsSubscriptionForm(requestParameters, options) {
    return VendorsApiFp(this.configuration).getVendorEbillsSubscriptionForm(requestParameters.id, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Get a list of the fields that can be edited for a vendor.
   * @summary Get a list of the fields that can be edited for a vendor.
   * @param {VendorsApiGetVendorEditableFieldsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VendorsApi
   */
  getVendorEditableFields(requestParameters, options) {
    return VendorsApiFp(this.configuration).getVendorEditableFields(requestParameters.id, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Get a vendor\'s unmasked account number
   * @summary Get a vendor\'s unmasked account number
   * @param {VendorsApiGetVendorUnmaskedAccountNumberRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VendorsApi
   */
  getVendorUnmaskedAccountNumber(requestParameters, options) {
    return VendorsApiFp(this.configuration).getVendorUnmaskedAccountNumber(requestParameters.id, requestParameters.melioAccount, requestParameters.organizationId, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Retrieve a list of Vendors that are attached to an Account
   * @summary Retrieve all Vendors
   * @param {VendorsApiGetVendorsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VendorsApi
   */
  getVendors(requestParameters = {}, options) {
    return VendorsApiFp(this.configuration).getVendors(requestParameters.expand, requestParameters.organizationId, requestParameters.userId, requestParameters.searchTerm, requestParameters.sort, requestParameters.search, requestParameters.limit, requestParameters.cursor, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Retrieve a single Vendor using its ID.
   * @summary Retrieve a Vendor
   * @param {VendorsApiGetVendorsVendorIdRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VendorsApi
   */
  getVendorsVendorId(requestParameters, options) {
    return VendorsApiFp(this.configuration).getVendorsVendorId(requestParameters.id, requestParameters.expand, requestParameters.melioAccount, requestParameters.organizationId, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Retrieve Vendor supported delivery method types
   * @param {VendorsApiGetVendorsVendorIdDeliveryMethodTypeOptionsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VendorsApi
   */
  getVendorsVendorIdDeliveryMethodTypeOptions(requestParameters, options) {
    return VendorsApiFp(this.configuration).getVendorsVendorIdDeliveryMethodTypeOptions(requestParameters.id, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Get a list of a Vendor\'s Delivery Methods, that can be used to sent funds to.
   * @summary Retrieve a Vendor\'s Delivery Methods
   * @param {VendorsApiGetVendorsVendorIdDeliveryMethodsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VendorsApi
   */
  getVendorsVendorIdDeliveryMethods(requestParameters, options) {
    return VendorsApiFp(this.configuration).getVendorsVendorIdDeliveryMethods(requestParameters.id, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Retrieve Vendor Stats.
   * @summary Retrieve Vendor Stats
   * @param {VendorsApiGetVendorsVendorIdStatsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VendorsApi
   */
  getVendorsVendorIdStats(requestParameters, options) {
    return VendorsApiFp(this.configuration).getVendorsVendorIdStats(requestParameters.id, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Get a list of a Vendor\'s Unilateral Requests.
   * @summary Retrieve Vendor\'s unilateral requests
   * @param {VendorsApiGetVendorsVendorIdUnilateralRequestsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VendorsApi
   */
  getVendorsVendorIdUnilateralRequests(requestParameters, options) {
    return VendorsApiFp(this.configuration).getVendorsVendorIdUnilateralRequests(requestParameters.id, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Get if the vendor is valid for resending to him a unilateral request
   * @summary Returns whether vendor is valid for resend unilateral request
   * @param {VendorsApiGetVendorsVendorIdUnilateralRequestsValidationForResendRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VendorsApi
   */
  getVendorsVendorIdUnilateralRequestsValidationForResend(requestParameters, options) {
    return VendorsApiFp(this.configuration).getVendorsVendorIdUnilateralRequestsValidationForResend(requestParameters.id, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Update a managed vendor\'s auto payment
   * @summary Update a managed vendor\'s auto payment
   * @param {VendorsApiPatchAutoPaymentRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VendorsApi
   */
  patchAutoPayment(requestParameters, options) {
    return VendorsApiFp(this.configuration).patchAutoPayment(requestParameters.patchVendorAutoPaymentRequest, requestParameters.id, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Update an existing Vendor.  The request\'s body can be partial, and only provided fields will be overwritten. Set an optional field to `null` in order to remove its contents.
   * @summary Update a Vendor
   * @param {VendorsApiPatchVendorsVendorIdRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VendorsApi
   */
  patchVendorsVendorId(requestParameters, options) {
    return VendorsApiFp(this.configuration).patchVendorsVendorId(requestParameters.id, requestParameters.patchVendorsVendorIdRequest, requestParameters.expand, requestParameters.idempotencyKey, requestParameters.melioAccount, requestParameters.organizationId, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Create a managed vendor\'s auto payment
   * @summary Create a managed vendor\'s auto payment
   * @param {VendorsApiPostAutoPaymentRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VendorsApi
   */
  postAutoPayment(requestParameters, options) {
    return VendorsApiFp(this.configuration).postAutoPayment(requestParameters.postVendorAutoPaymentRequest, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * 
   * @summary create vendor ebills subscription
   * @param {VendorsApiPostEbillsSubscriptionRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VendorsApi
   */
  postEbillsSubscription(requestParameters, options) {
    return VendorsApiFp(this.configuration).postEbillsSubscription(requestParameters.postVendorEbillsSubscriptionRequest, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Create (attach) a Vendor to an Account.
   * @summary Create a Vendor
   * @param {VendorsApiPostVendorsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VendorsApi
   */
  postVendors(requestParameters = {}, options) {
    return VendorsApiFp(this.configuration).postVendors(requestParameters.postVendorsRequest, requestParameters.expand, requestParameters.organizationId, requestParameters.userId, requestParameters.idempotencyKey, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Create (attach) multiple Vendors to an Account, based on a provided list of business entities.
   * @summary Create multiple Vendors
   * @param {VendorsApiPostVendorsBulkRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VendorsApi
   */
  postVendorsBulk(requestParameters = {}, options) {
    return VendorsApiFp(this.configuration).postVendorsBulk(requestParameters.postVendorsBulkRequest, requestParameters.expand, requestParameters.idempotencyKey, requestParameters.melioAccount, requestParameters.organizationId, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Validate the creation of multiple Vendors to an Account, based on a provided list of business entities.
   * @summary Validate creation of multiple Vendors
   * @param {VendorsApiPostVendorsBulkValidateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VendorsApi
   */
  postVendorsBulkValidate(requestParameters = {}, options) {
    return VendorsApiFp(this.configuration).postVendorsBulkValidate(requestParameters.postVendorsBulkRequest, requestParameters.expand, requestParameters.idempotencyKey, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Link existing Melio vendor to directory.
   * @summary Link existing Melio vendor to directory
   * @param {VendorsApiPostVendorsLinkToDirectoryRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VendorsApi
   */
  postVendorsLinkToDirectory(requestParameters, options) {
    return VendorsApiFp(this.configuration).postVendorsLinkToDirectory(requestParameters.id, requestParameters.postVendorsLinkToDirectoryRequest, requestParameters.expand, requestParameters.idempotencyKey, requestParameters.melioAccount, requestParameters.organizationId, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Create a Vendor\'s Delivery Method
   * @summary Create a Vendor\'s Delivery Method
   * @param {VendorsApiPostVendorsVendorIdDeliveryMethodsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VendorsApi
   */
  postVendorsVendorIdDeliveryMethods(requestParameters, options) {
    return VendorsApiFp(this.configuration).postVendorsVendorIdDeliveryMethods(requestParameters.id, requestParameters.body, requestParameters.idempotencyKey, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Create a request to Vendor to provide W-9 data
   * @summary Send a taxpayer identification request to collect W-9 data
   * @param {VendorsApiPostVendorsVendorIdTaxpayerIdentificationRequestsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VendorsApi
   */
  postVendorsVendorIdTaxpayerIdentificationRequests(requestParameters, options) {
    return VendorsApiFp(this.configuration).postVendorsVendorIdTaxpayerIdentificationRequests(requestParameters.id, requestParameters.postVendorsVendorIdTaxpayerIdentificationRequestsRequest, requestParameters.idempotencyKey, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Cancel a request to Vendor to provide W-9 data
   * @summary Cancel a taxpayer identification request to collect W-9 data
   * @param {VendorsApiPostVendorsVendorIdTaxpayerIdentificationRequestsTaxpayerIdentificationRequestIdCancelRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VendorsApi
   */
  postVendorsVendorIdTaxpayerIdentificationRequestsTaxpayerIdentificationRequestIdCancel(requestParameters, options) {
    return VendorsApiFp(this.configuration).postVendorsVendorIdTaxpayerIdentificationRequestsTaxpayerIdentificationRequestIdCancel(requestParameters.id, requestParameters.taxpayerIdentificationRequestId, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Resend a request to Vendor to provide W-9 data
   * @summary Resend a taxpayer identification request to collect W-9 data
   * @param {VendorsApiPostVendorsVendorIdTaxpayerIdentificationRequestsTaxpayerIdentificationRequestIdResendRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VendorsApi
   */
  postVendorsVendorIdTaxpayerIdentificationRequestsTaxpayerIdentificationRequestIdResend(requestParameters, options) {
    return VendorsApiFp(this.configuration).postVendorsVendorIdTaxpayerIdentificationRequestsTaxpayerIdentificationRequestIdResend(requestParameters.id, requestParameters.taxpayerIdentificationRequestId, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Create a taxpayer information, allows to persist W-9 file data
   * @summary Create a taxpayer information, allows to persist W-9 file data
   * @param {VendorsApiPostVendorsVendorIdTaxpayerInfoRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VendorsApi
   */
  postVendorsVendorIdTaxpayerInfo(requestParameters, options) {
    return VendorsApiFp(this.configuration).postVendorsVendorIdTaxpayerInfo(requestParameters.id, requestParameters.file, requestParameters.idempotencyKey, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Create a Unilateral Request of a Vendor
   * @summary Create a Unilateral Request of a Vendor
   * @param {VendorsApiPostVendorsVendorIdUnilateralRequestsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VendorsApi
   */
  postVendorsVendorIdUnilateralRequests(requestParameters, options) {
    return VendorsApiFp(this.configuration).postVendorsVendorIdUnilateralRequests(requestParameters.id, requestParameters.postVendorsVendorIdUnilateralRequestsRequest, requestParameters.idempotencyKey, requestParameters.melioAccount, options).then((request) => request(this.axios, this.basePath));
  }
};
var VendorsApiInstance = createInstanceFromApiIClass(VendorsApi);
var VexAuthenticationApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * This operation sends email verification code to a given email
     * @summary Send email verification code
     * @param {PostSendEmailValidationCodeRequest} [postSendEmailValidationCodeRequest] Send email verification code data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postAuthGuestSendEmailValidationCode: (_0, ..._1) => __async(this, [_0, ..._1], function* (postSendEmailValidationCodeRequest, options = {}) {
      const localVarPath = `/vex/auth/guest/send-email-validation-code`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postSendEmailValidationCodeRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * This route validates the email and validation code, and if successful returns an auth JWT
     * @summary Validate the email and 2FA code and return a JWT if valid
     * @param {PostResolveEmailVerificationRequest} [postResolveEmailVerificationRequest] Send email verification code data
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postAuthGuestVerifyValidationCode: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (postResolveEmailVerificationRequest, idempotencyKey, options = {}) {
      const localVarPath = `/vex/auth/guest/resolve-email-verification`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      if (idempotencyKey !== void 0 && idempotencyKey !== null) {
        localVarHeaderParameter["Idempotency-Key"] = String(idempotencyKey);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postResolveEmailVerificationRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * This operation exchanges the email received token to an access one
     * @summary Exchange email to access tokens
     * @param {PostVexExchangeRequest} [postVexExchangeRequest] Exchange from public email to access token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postVexAuthExchange: (_0, ..._1) => __async(this, [_0, ..._1], function* (postVexExchangeRequest, options = {}) {
      const localVarPath = `/vex/auth/exchange`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postVexExchangeRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * This operation changes the active organization
     * @summary Change the active organization
     * @param {string} id ID of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postVexAuthSwitchOrganization: (_0, ..._1) => __async(this, [_0, ..._1], function* (id, options = {}) {
      assertParamExists("postVexAuthSwitchOrganization", "id", id);
      const localVarPath = `/vex/auth/switch-organization/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    })
  };
};
var VexAuthenticationApiFp = function(configuration) {
  const localVarAxiosParamCreator = VexAuthenticationApiAxiosParamCreator(configuration);
  return {
    /**
     * This operation sends email verification code to a given email
     * @summary Send email verification code
     * @param {PostSendEmailValidationCodeRequest} [postSendEmailValidationCodeRequest] Send email verification code data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postAuthGuestSendEmailValidationCode(postSendEmailValidationCodeRequest, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postAuthGuestSendEmailValidationCode(postSendEmailValidationCodeRequest, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * This route validates the email and validation code, and if successful returns an auth JWT
     * @summary Validate the email and 2FA code and return a JWT if valid
     * @param {PostResolveEmailVerificationRequest} [postResolveEmailVerificationRequest] Send email verification code data
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postAuthGuestVerifyValidationCode(postResolveEmailVerificationRequest, idempotencyKey, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postAuthGuestVerifyValidationCode(postResolveEmailVerificationRequest, idempotencyKey, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * This operation exchanges the email received token to an access one
     * @summary Exchange email to access tokens
     * @param {PostVexExchangeRequest} [postVexExchangeRequest] Exchange from public email to access token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postVexAuthExchange(postVexExchangeRequest, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postVexAuthExchange(postVexExchangeRequest, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * This operation changes the active organization
     * @summary Change the active organization
     * @param {string} id ID of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postVexAuthSwitchOrganization(id, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postVexAuthSwitchOrganization(id, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    }
  };
};
var VexAuthenticationApiClient = createApiFromFp(VexAuthenticationApiFp);
var VexAuthenticationApiFactory = function(configuration, basePath, axios2) {
  const localVarFp = VexAuthenticationApiFp(configuration);
  return {
    /**
     * This operation sends email verification code to a given email
     * @summary Send email verification code
     * @param {PostSendEmailValidationCodeRequest} [postSendEmailValidationCodeRequest] Send email verification code data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postAuthGuestSendEmailValidationCode(postSendEmailValidationCodeRequest, options) {
      return localVarFp.postAuthGuestSendEmailValidationCode(postSendEmailValidationCodeRequest, options).then((request) => request(axios2, basePath));
    },
    /**
     * This route validates the email and validation code, and if successful returns an auth JWT
     * @summary Validate the email and 2FA code and return a JWT if valid
     * @param {PostResolveEmailVerificationRequest} [postResolveEmailVerificationRequest] Send email verification code data
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postAuthGuestVerifyValidationCode(postResolveEmailVerificationRequest, idempotencyKey, options) {
      return localVarFp.postAuthGuestVerifyValidationCode(postResolveEmailVerificationRequest, idempotencyKey, options).then((request) => request(axios2, basePath));
    },
    /**
     * This operation exchanges the email received token to an access one
     * @summary Exchange email to access tokens
     * @param {PostVexExchangeRequest} [postVexExchangeRequest] Exchange from public email to access token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postVexAuthExchange(postVexExchangeRequest, options) {
      return localVarFp.postVexAuthExchange(postVexExchangeRequest, options).then((request) => request(axios2, basePath));
    },
    /**
     * This operation changes the active organization
     * @summary Change the active organization
     * @param {string} id ID of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postVexAuthSwitchOrganization(id, options) {
      return localVarFp.postVexAuthSwitchOrganization(id, options).then((request) => request(axios2, basePath));
    }
  };
};
var VexAuthenticationApi = class extends BaseAPI {
  /**
   * This operation sends email verification code to a given email
   * @summary Send email verification code
   * @param {VexAuthenticationApiPostAuthGuestSendEmailValidationCodeRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VexAuthenticationApi
   */
  postAuthGuestSendEmailValidationCode(requestParameters = {}, options) {
    return VexAuthenticationApiFp(this.configuration).postAuthGuestSendEmailValidationCode(requestParameters.postSendEmailValidationCodeRequest, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * This route validates the email and validation code, and if successful returns an auth JWT
   * @summary Validate the email and 2FA code and return a JWT if valid
   * @param {VexAuthenticationApiPostAuthGuestVerifyValidationCodeRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VexAuthenticationApi
   */
  postAuthGuestVerifyValidationCode(requestParameters = {}, options) {
    return VexAuthenticationApiFp(this.configuration).postAuthGuestVerifyValidationCode(requestParameters.postResolveEmailVerificationRequest, requestParameters.idempotencyKey, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * This operation exchanges the email received token to an access one
   * @summary Exchange email to access tokens
   * @param {VexAuthenticationApiPostVexAuthExchangeRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VexAuthenticationApi
   */
  postVexAuthExchange(requestParameters = {}, options) {
    return VexAuthenticationApiFp(this.configuration).postVexAuthExchange(requestParameters.postVexExchangeRequest, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * This operation changes the active organization
   * @summary Change the active organization
   * @param {VexAuthenticationApiPostVexAuthSwitchOrganizationRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VexAuthenticationApi
   */
  postVexAuthSwitchOrganization(requestParameters, options) {
    return VexAuthenticationApiFp(this.configuration).postVexAuthSwitchOrganization(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
  }
};
var VexAuthenticationApiInstance = createInstanceFromApiIClass(VexAuthenticationApi);
var VexDeliveryMethodsApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * Accept unilateral payment by copy owned-by delivery-method to local vendor
     * @summary Accept payment for unilateral flow
     * @param {string} id ID of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    acceptUnilateralPayment: (_0, ..._1) => __async(this, [_0, ..._1], function* (id, options = {}) {
      assertParamExists("acceptUnilateralPayment", "id", id);
      const localVarPath = `/vex/delivery-methods/{id}/accept-unilateral-payment`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Rtp eligibility check
     * @summary Rtp eligibility check
     * @param {string} id ID of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDeliveryMethodsRtpEligibility: (_0, ..._1) => __async(this, [_0, ..._1], function* (id, options = {}) {
      assertParamExists("getDeliveryMethodsRtpEligibility", "id", id);
      const localVarPath = `/vex/delivery-methods/{id}/rtp-eligibility`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Create a new bank account delivery method
     * @summary Create a new ACH DM
     * @param {PostVexDeliveryMethodRequest} [postVexDeliveryMethodRequest] Create a new ACH DM
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postVexDeliveryMethods: (_0, ..._1) => __async(this, [_0, ..._1], function* (postVexDeliveryMethodRequest, options = {}) {
      const localVarPath = `/vex/delivery-methods/ach`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postVexDeliveryMethodRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    })
  };
};
var VexDeliveryMethodsApiFp = function(configuration) {
  const localVarAxiosParamCreator = VexDeliveryMethodsApiAxiosParamCreator(configuration);
  return {
    /**
     * Accept unilateral payment by copy owned-by delivery-method to local vendor
     * @summary Accept payment for unilateral flow
     * @param {string} id ID of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    acceptUnilateralPayment(id, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.acceptUnilateralPayment(id, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Rtp eligibility check
     * @summary Rtp eligibility check
     * @param {string} id ID of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDeliveryMethodsRtpEligibility(id, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getDeliveryMethodsRtpEligibility(id, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Create a new bank account delivery method
     * @summary Create a new ACH DM
     * @param {PostVexDeliveryMethodRequest} [postVexDeliveryMethodRequest] Create a new ACH DM
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postVexDeliveryMethods(postVexDeliveryMethodRequest, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postVexDeliveryMethods(postVexDeliveryMethodRequest, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    }
  };
};
var VexDeliveryMethodsApiClient = createApiFromFp(VexDeliveryMethodsApiFp);
var VexDeliveryMethodsApiFactory = function(configuration, basePath, axios2) {
  const localVarFp = VexDeliveryMethodsApiFp(configuration);
  return {
    /**
     * Accept unilateral payment by copy owned-by delivery-method to local vendor
     * @summary Accept payment for unilateral flow
     * @param {string} id ID of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    acceptUnilateralPayment(id, options) {
      return localVarFp.acceptUnilateralPayment(id, options).then((request) => request(axios2, basePath));
    },
    /**
     * Rtp eligibility check
     * @summary Rtp eligibility check
     * @param {string} id ID of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDeliveryMethodsRtpEligibility(id, options) {
      return localVarFp.getDeliveryMethodsRtpEligibility(id, options).then((request) => request(axios2, basePath));
    },
    /**
     * Create a new bank account delivery method
     * @summary Create a new ACH DM
     * @param {PostVexDeliveryMethodRequest} [postVexDeliveryMethodRequest] Create a new ACH DM
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postVexDeliveryMethods(postVexDeliveryMethodRequest, options) {
      return localVarFp.postVexDeliveryMethods(postVexDeliveryMethodRequest, options).then((request) => request(axios2, basePath));
    }
  };
};
var VexDeliveryMethodsApi = class extends BaseAPI {
  /**
   * Accept unilateral payment by copy owned-by delivery-method to local vendor
   * @summary Accept payment for unilateral flow
   * @param {VexDeliveryMethodsApiAcceptUnilateralPaymentRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VexDeliveryMethodsApi
   */
  acceptUnilateralPayment(requestParameters, options) {
    return VexDeliveryMethodsApiFp(this.configuration).acceptUnilateralPayment(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Rtp eligibility check
   * @summary Rtp eligibility check
   * @param {VexDeliveryMethodsApiGetDeliveryMethodsRtpEligibilityRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VexDeliveryMethodsApi
   */
  getDeliveryMethodsRtpEligibility(requestParameters, options) {
    return VexDeliveryMethodsApiFp(this.configuration).getDeliveryMethodsRtpEligibility(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Create a new bank account delivery method
   * @summary Create a new ACH DM
   * @param {VexDeliveryMethodsApiPostVexDeliveryMethodsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VexDeliveryMethodsApi
   */
  postVexDeliveryMethods(requestParameters = {}, options) {
    return VexDeliveryMethodsApiFp(this.configuration).postVexDeliveryMethods(requestParameters.postVexDeliveryMethodRequest, options).then((request) => request(this.axios, this.basePath));
  }
};
var VexDeliveryMethodsApiInstance = createInstanceFromApiIClass(VexDeliveryMethodsApi);
var VexFTIApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * Return partner brand, fees and prefilled data for presenting an onboarding session for an partner\'s vendor
     * @summary Get session details for onboarding a vendor
     * @param {string} sessionUuid The External ID of the onboarding session
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getVendorOnboardingSessionByUuid: (_0, ..._1) => __async(this, [_0, ..._1], function* (sessionUuid, options = {}) {
      assertParamExists("getVendorOnboardingSessionByUuid", "sessionUuid", sessionUuid);
      const localVarPath = `/vex/guest/vendor-onboarding/{sessionUuid}`.replace(`{${"sessionUuid"}}`, encodeURIComponent(String(sessionUuid)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Complete FTI onboarding session
     * @summary Register organization to Follow the Invoice by completing the partner-initiated session.
     * @param {string} id ID of the entity
     * @param {string} sessionUuid The External ID of the onboarding session
     * @param {object} [body] Complete Onboarding to FTI in current session
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postOrganizationRegisterToFtiBySessionUuid: (_0, _1, _2, ..._3) => __async(this, [_0, _1, _2, ..._3], function* (id, sessionUuid, body, options = {}) {
      assertParamExists("postOrganizationRegisterToFtiBySessionUuid", "id", id);
      assertParamExists("postOrganizationRegisterToFtiBySessionUuid", "sessionUuid", sessionUuid);
      const localVarPath = `/vex/organizations/{id}/fti/{sessionUuid}`.replace(`{${"id"}}`, encodeURIComponent(String(id))).replace(`{${"sessionUuid"}}`, encodeURIComponent(String(sessionUuid)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    })
  };
};
var VexFTIApiFp = function(configuration) {
  const localVarAxiosParamCreator = VexFTIApiAxiosParamCreator(configuration);
  return {
    /**
     * Return partner brand, fees and prefilled data for presenting an onboarding session for an partner\'s vendor
     * @summary Get session details for onboarding a vendor
     * @param {string} sessionUuid The External ID of the onboarding session
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getVendorOnboardingSessionByUuid(sessionUuid, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getVendorOnboardingSessionByUuid(sessionUuid, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Complete FTI onboarding session
     * @summary Register organization to Follow the Invoice by completing the partner-initiated session.
     * @param {string} id ID of the entity
     * @param {string} sessionUuid The External ID of the onboarding session
     * @param {object} [body] Complete Onboarding to FTI in current session
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postOrganizationRegisterToFtiBySessionUuid(id, sessionUuid, body, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postOrganizationRegisterToFtiBySessionUuid(id, sessionUuid, body, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    }
  };
};
var VexFTIApiClient = createApiFromFp(VexFTIApiFp);
var VexFTIApiFactory = function(configuration, basePath, axios2) {
  const localVarFp = VexFTIApiFp(configuration);
  return {
    /**
     * Return partner brand, fees and prefilled data for presenting an onboarding session for an partner\'s vendor
     * @summary Get session details for onboarding a vendor
     * @param {string} sessionUuid The External ID of the onboarding session
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getVendorOnboardingSessionByUuid(sessionUuid, options) {
      return localVarFp.getVendorOnboardingSessionByUuid(sessionUuid, options).then((request) => request(axios2, basePath));
    },
    /**
     * Complete FTI onboarding session
     * @summary Register organization to Follow the Invoice by completing the partner-initiated session.
     * @param {string} id ID of the entity
     * @param {string} sessionUuid The External ID of the onboarding session
     * @param {object} [body] Complete Onboarding to FTI in current session
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postOrganizationRegisterToFtiBySessionUuid(id, sessionUuid, body, options) {
      return localVarFp.postOrganizationRegisterToFtiBySessionUuid(id, sessionUuid, body, options).then((request) => request(axios2, basePath));
    }
  };
};
var VexFTIApi = class extends BaseAPI {
  /**
   * Return partner brand, fees and prefilled data for presenting an onboarding session for an partner\'s vendor
   * @summary Get session details for onboarding a vendor
   * @param {VexFTIApiGetVendorOnboardingSessionByUuidRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VexFTIApi
   */
  getVendorOnboardingSessionByUuid(requestParameters, options) {
    return VexFTIApiFp(this.configuration).getVendorOnboardingSessionByUuid(requestParameters.sessionUuid, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Complete FTI onboarding session
   * @summary Register organization to Follow the Invoice by completing the partner-initiated session.
   * @param {VexFTIApiPostOrganizationRegisterToFtiBySessionUuidRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VexFTIApi
   */
  postOrganizationRegisterToFtiBySessionUuid(requestParameters, options) {
    return VexFTIApiFp(this.configuration).postOrganizationRegisterToFtiBySessionUuid(requestParameters.id, requestParameters.sessionUuid, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
  }
};
var VexFTIApiInstance = createInstanceFromApiIClass(VexFTIApi);
var VexGuestApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * Accepts paymentId for shifting from and response with dm to shift to.
     * @summary Get payment shift to delivery method
     * @param {string} id ID of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getShiftPaymentDeliveryMethod: (_0, ..._1) => __async(this, [_0, ..._1], function* (id, options = {}) {
      assertParamExists("getShiftPaymentDeliveryMethod", "id", id);
      const localVarPath = `/vex/guest/payment/{id}/shift-payment-delivery-method`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Return partner brand, fees and prefilled data for presenting an onboarding session for an partner\'s vendor
     * @summary Get session details for onboarding a vendor
     * @param {string} sessionUuid The External ID of the onboarding session
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getVendorOnboardingSessionByUuid: (_0, ..._1) => __async(this, [_0, ..._1], function* (sessionUuid, options = {}) {
      assertParamExists("getVendorOnboardingSessionByUuid", "sessionUuid", sessionUuid);
      const localVarPath = `/vex/guest/vendor-onboarding/{sessionUuid}`.replace(`{${"sessionUuid"}}`, encodeURIComponent(String(sessionUuid)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * This operation fetches a guest\'s payment
     * @summary Fetch a guest\'s payment
     * @param {string} id ID of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getVexGuestPayment: (_0, ..._1) => __async(this, [_0, ..._1], function* (id, options = {}) {
      assertParamExists("getVexGuestPayment", "id", id);
      const localVarPath = `/vex/guest/payment/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * This operation get SUVC delivery method details for vendor
     * @summary Get single use virtual card by payment id
     * @param {string} id ID of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getVirtualCard: (_0, ..._1) => __async(this, [_0, ..._1], function* (id, options = {}) {
      assertParamExists("getVirtualCard", "id", id);
      const localVarPath = `/vex/guest/suvc/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * 
     * @summary Re activate expired virtual card
     * @param {string} id ID of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postVexReActivateVirtualCard: (_0, ..._1) => __async(this, [_0, ..._1], function* (id, options = {}) {
      assertParamExists("postVexReActivateVirtualCard", "id", id);
      const localVarPath = `/vex/guest/suvc/{id}/re-activate-card`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * shift from virtual card to ACH when vendor already has ACH delivery method
     * @summary Shift payment delivery method from virtual card to exists ACH
     * @param {string} id ID of the entity
     * @param {PostShiftVirtualCardToAchRequest} [postShiftVirtualCardToAchRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    shiftVirtualCardToExistsAch: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (id, postShiftVirtualCardToAchRequest, options = {}) {
      assertParamExists("shiftVirtualCardToExistsAch", "id", id);
      const localVarPath = `/vex/guest/payment/{id}/shift-virtual-card-to-ach`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postShiftVirtualCardToAchRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    })
  };
};
var VexGuestApiFp = function(configuration) {
  const localVarAxiosParamCreator = VexGuestApiAxiosParamCreator(configuration);
  return {
    /**
     * Accepts paymentId for shifting from and response with dm to shift to.
     * @summary Get payment shift to delivery method
     * @param {string} id ID of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getShiftPaymentDeliveryMethod(id, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getShiftPaymentDeliveryMethod(id, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Return partner brand, fees and prefilled data for presenting an onboarding session for an partner\'s vendor
     * @summary Get session details for onboarding a vendor
     * @param {string} sessionUuid The External ID of the onboarding session
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getVendorOnboardingSessionByUuid(sessionUuid, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getVendorOnboardingSessionByUuid(sessionUuid, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * This operation fetches a guest\'s payment
     * @summary Fetch a guest\'s payment
     * @param {string} id ID of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getVexGuestPayment(id, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getVexGuestPayment(id, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * This operation get SUVC delivery method details for vendor
     * @summary Get single use virtual card by payment id
     * @param {string} id ID of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getVirtualCard(id, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getVirtualCard(id, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * 
     * @summary Re activate expired virtual card
     * @param {string} id ID of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postVexReActivateVirtualCard(id, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postVexReActivateVirtualCard(id, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * shift from virtual card to ACH when vendor already has ACH delivery method
     * @summary Shift payment delivery method from virtual card to exists ACH
     * @param {string} id ID of the entity
     * @param {PostShiftVirtualCardToAchRequest} [postShiftVirtualCardToAchRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    shiftVirtualCardToExistsAch(id, postShiftVirtualCardToAchRequest, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.shiftVirtualCardToExistsAch(id, postShiftVirtualCardToAchRequest, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    }
  };
};
var VexGuestApiClient = createApiFromFp(VexGuestApiFp);
var VexGuestApiFactory = function(configuration, basePath, axios2) {
  const localVarFp = VexGuestApiFp(configuration);
  return {
    /**
     * Accepts paymentId for shifting from and response with dm to shift to.
     * @summary Get payment shift to delivery method
     * @param {string} id ID of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getShiftPaymentDeliveryMethod(id, options) {
      return localVarFp.getShiftPaymentDeliveryMethod(id, options).then((request) => request(axios2, basePath));
    },
    /**
     * Return partner brand, fees and prefilled data for presenting an onboarding session for an partner\'s vendor
     * @summary Get session details for onboarding a vendor
     * @param {string} sessionUuid The External ID of the onboarding session
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getVendorOnboardingSessionByUuid(sessionUuid, options) {
      return localVarFp.getVendorOnboardingSessionByUuid(sessionUuid, options).then((request) => request(axios2, basePath));
    },
    /**
     * This operation fetches a guest\'s payment
     * @summary Fetch a guest\'s payment
     * @param {string} id ID of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getVexGuestPayment(id, options) {
      return localVarFp.getVexGuestPayment(id, options).then((request) => request(axios2, basePath));
    },
    /**
     * This operation get SUVC delivery method details for vendor
     * @summary Get single use virtual card by payment id
     * @param {string} id ID of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getVirtualCard(id, options) {
      return localVarFp.getVirtualCard(id, options).then((request) => request(axios2, basePath));
    },
    /**
     * 
     * @summary Re activate expired virtual card
     * @param {string} id ID of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postVexReActivateVirtualCard(id, options) {
      return localVarFp.postVexReActivateVirtualCard(id, options).then((request) => request(axios2, basePath));
    },
    /**
     * shift from virtual card to ACH when vendor already has ACH delivery method
     * @summary Shift payment delivery method from virtual card to exists ACH
     * @param {string} id ID of the entity
     * @param {PostShiftVirtualCardToAchRequest} [postShiftVirtualCardToAchRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    shiftVirtualCardToExistsAch(id, postShiftVirtualCardToAchRequest, options) {
      return localVarFp.shiftVirtualCardToExistsAch(id, postShiftVirtualCardToAchRequest, options).then((request) => request(axios2, basePath));
    }
  };
};
var VexGuestApi = class extends BaseAPI {
  /**
   * Accepts paymentId for shifting from and response with dm to shift to.
   * @summary Get payment shift to delivery method
   * @param {VexGuestApiGetShiftPaymentDeliveryMethodRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VexGuestApi
   */
  getShiftPaymentDeliveryMethod(requestParameters, options) {
    return VexGuestApiFp(this.configuration).getShiftPaymentDeliveryMethod(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Return partner brand, fees and prefilled data for presenting an onboarding session for an partner\'s vendor
   * @summary Get session details for onboarding a vendor
   * @param {VexGuestApiGetVendorOnboardingSessionByUuidRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VexGuestApi
   */
  getVendorOnboardingSessionByUuid(requestParameters, options) {
    return VexGuestApiFp(this.configuration).getVendorOnboardingSessionByUuid(requestParameters.sessionUuid, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * This operation fetches a guest\'s payment
   * @summary Fetch a guest\'s payment
   * @param {VexGuestApiGetVexGuestPaymentRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VexGuestApi
   */
  getVexGuestPayment(requestParameters, options) {
    return VexGuestApiFp(this.configuration).getVexGuestPayment(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * This operation get SUVC delivery method details for vendor
   * @summary Get single use virtual card by payment id
   * @param {VexGuestApiGetVirtualCardRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VexGuestApi
   */
  getVirtualCard(requestParameters, options) {
    return VexGuestApiFp(this.configuration).getVirtualCard(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Re activate expired virtual card
   * @param {VexGuestApiPostVexReActivateVirtualCardRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VexGuestApi
   */
  postVexReActivateVirtualCard(requestParameters, options) {
    return VexGuestApiFp(this.configuration).postVexReActivateVirtualCard(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * shift from virtual card to ACH when vendor already has ACH delivery method
   * @summary Shift payment delivery method from virtual card to exists ACH
   * @param {VexGuestApiShiftVirtualCardToExistsAchRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VexGuestApi
   */
  shiftVirtualCardToExistsAch(requestParameters, options) {
    return VexGuestApiFp(this.configuration).shiftVirtualCardToExistsAch(requestParameters.id, requestParameters.postShiftVirtualCardToAchRequest, options).then((request) => request(this.axios, this.basePath));
  }
};
var VexGuestApiInstance = createInstanceFromApiIClass(VexGuestApi);
var VexGuestDeliveryMethodsApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * This endpoint is handling delivery method creation for guest vendors
     * @summary Post vex guest create delivery methods
     * @param {PostVexGuestDeliveryMethodRequest} [postVexGuestDeliveryMethodRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postVexGuestDeliveryMethod: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (postVexGuestDeliveryMethodRequest, idempotencyKey, options = {}) {
      const localVarPath = `/vex/guest/delivery-method`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      if (idempotencyKey !== void 0 && idempotencyKey !== null) {
        localVarHeaderParameter["Idempotency-Key"] = String(idempotencyKey);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postVexGuestDeliveryMethodRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    })
  };
};
var VexGuestDeliveryMethodsApiFp = function(configuration) {
  const localVarAxiosParamCreator = VexGuestDeliveryMethodsApiAxiosParamCreator(configuration);
  return {
    /**
     * This endpoint is handling delivery method creation for guest vendors
     * @summary Post vex guest create delivery methods
     * @param {PostVexGuestDeliveryMethodRequest} [postVexGuestDeliveryMethodRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postVexGuestDeliveryMethod(postVexGuestDeliveryMethodRequest, idempotencyKey, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postVexGuestDeliveryMethod(postVexGuestDeliveryMethodRequest, idempotencyKey, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    }
  };
};
var VexGuestDeliveryMethodsApiClient = createApiFromFp(VexGuestDeliveryMethodsApiFp);
var VexGuestDeliveryMethodsApiFactory = function(configuration, basePath, axios2) {
  const localVarFp = VexGuestDeliveryMethodsApiFp(configuration);
  return {
    /**
     * This endpoint is handling delivery method creation for guest vendors
     * @summary Post vex guest create delivery methods
     * @param {PostVexGuestDeliveryMethodRequest} [postVexGuestDeliveryMethodRequest] 
     * @param {string} [idempotencyKey] Unique idempotency key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postVexGuestDeliveryMethod(postVexGuestDeliveryMethodRequest, idempotencyKey, options) {
      return localVarFp.postVexGuestDeliveryMethod(postVexGuestDeliveryMethodRequest, idempotencyKey, options).then((request) => request(axios2, basePath));
    }
  };
};
var VexGuestDeliveryMethodsApi = class extends BaseAPI {
  /**
   * This endpoint is handling delivery method creation for guest vendors
   * @summary Post vex guest create delivery methods
   * @param {VexGuestDeliveryMethodsApiPostVexGuestDeliveryMethodRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VexGuestDeliveryMethodsApi
   */
  postVexGuestDeliveryMethod(requestParameters = {}, options) {
    return VexGuestDeliveryMethodsApiFp(this.configuration).postVexGuestDeliveryMethod(requestParameters.postVexGuestDeliveryMethodRequest, requestParameters.idempotencyKey, options).then((request) => request(this.axios, this.basePath));
  }
};
var VexGuestDeliveryMethodsApiInstance = createInstanceFromApiIClass(VexGuestDeliveryMethodsApi);
var VexGuestPaymentApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * Return the unilateral ordered delivery method type options for an individual payment
     * @summary Get vex guest payment ordered unilateral delivery methods options
     * @param {string} id ID of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getVexGuestPaymentUnilateralOrderedDeliveryMethodTypeOptions: (_0, ..._1) => __async(this, [_0, ..._1], function* (id, options = {}) {
      assertParamExists("getVexGuestPaymentUnilateralOrderedDeliveryMethodTypeOptions", "id", id);
      const localVarPath = `/vex/guest/payment/{id}/unilateral/ordered-delivery-method-type-options`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Collect and return offer options for an individual payment
     * @summary Get vex guest payment upgrade offers
     * @param {string} id ID of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getVexGuestPaymentUpgradeOffers: (_0, ..._1) => __async(this, [_0, ..._1], function* (id, options = {}) {
      assertParamExists("getVexGuestPaymentUpgradeOffers", "id", id);
      const localVarPath = `/vex/guest/payment/{id}/upgrade-offers`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Update the offer option for an individual payment
     * @summary Post vex guest payment upgrade
     * @param {string} id ID of the entity
     * @param {PostVexGuestPaymentUpgradeRequest} [postVexGuestPaymentUpgradeRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postVexGuestPaymentUpgrade: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (id, postVexGuestPaymentUpgradeRequest, options = {}) {
      assertParamExists("postVexGuestPaymentUpgrade", "id", id);
      const localVarPath = `/vex/guest/payment/{id}/upgrade`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postVexGuestPaymentUpgradeRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    })
  };
};
var VexGuestPaymentApiFp = function(configuration) {
  const localVarAxiosParamCreator = VexGuestPaymentApiAxiosParamCreator(configuration);
  return {
    /**
     * Return the unilateral ordered delivery method type options for an individual payment
     * @summary Get vex guest payment ordered unilateral delivery methods options
     * @param {string} id ID of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getVexGuestPaymentUnilateralOrderedDeliveryMethodTypeOptions(id, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getVexGuestPaymentUnilateralOrderedDeliveryMethodTypeOptions(id, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Collect and return offer options for an individual payment
     * @summary Get vex guest payment upgrade offers
     * @param {string} id ID of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getVexGuestPaymentUpgradeOffers(id, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getVexGuestPaymentUpgradeOffers(id, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Update the offer option for an individual payment
     * @summary Post vex guest payment upgrade
     * @param {string} id ID of the entity
     * @param {PostVexGuestPaymentUpgradeRequest} [postVexGuestPaymentUpgradeRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postVexGuestPaymentUpgrade(id, postVexGuestPaymentUpgradeRequest, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postVexGuestPaymentUpgrade(id, postVexGuestPaymentUpgradeRequest, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    }
  };
};
var VexGuestPaymentApiClient = createApiFromFp(VexGuestPaymentApiFp);
var VexGuestPaymentApiFactory = function(configuration, basePath, axios2) {
  const localVarFp = VexGuestPaymentApiFp(configuration);
  return {
    /**
     * Return the unilateral ordered delivery method type options for an individual payment
     * @summary Get vex guest payment ordered unilateral delivery methods options
     * @param {string} id ID of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getVexGuestPaymentUnilateralOrderedDeliveryMethodTypeOptions(id, options) {
      return localVarFp.getVexGuestPaymentUnilateralOrderedDeliveryMethodTypeOptions(id, options).then((request) => request(axios2, basePath));
    },
    /**
     * Collect and return offer options for an individual payment
     * @summary Get vex guest payment upgrade offers
     * @param {string} id ID of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getVexGuestPaymentUpgradeOffers(id, options) {
      return localVarFp.getVexGuestPaymentUpgradeOffers(id, options).then((request) => request(axios2, basePath));
    },
    /**
     * Update the offer option for an individual payment
     * @summary Post vex guest payment upgrade
     * @param {string} id ID of the entity
     * @param {PostVexGuestPaymentUpgradeRequest} [postVexGuestPaymentUpgradeRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postVexGuestPaymentUpgrade(id, postVexGuestPaymentUpgradeRequest, options) {
      return localVarFp.postVexGuestPaymentUpgrade(id, postVexGuestPaymentUpgradeRequest, options).then((request) => request(axios2, basePath));
    }
  };
};
var VexGuestPaymentApi = class extends BaseAPI {
  /**
   * Return the unilateral ordered delivery method type options for an individual payment
   * @summary Get vex guest payment ordered unilateral delivery methods options
   * @param {VexGuestPaymentApiGetVexGuestPaymentUnilateralOrderedDeliveryMethodTypeOptionsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VexGuestPaymentApi
   */
  getVexGuestPaymentUnilateralOrderedDeliveryMethodTypeOptions(requestParameters, options) {
    return VexGuestPaymentApiFp(this.configuration).getVexGuestPaymentUnilateralOrderedDeliveryMethodTypeOptions(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Collect and return offer options for an individual payment
   * @summary Get vex guest payment upgrade offers
   * @param {VexGuestPaymentApiGetVexGuestPaymentUpgradeOffersRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VexGuestPaymentApi
   */
  getVexGuestPaymentUpgradeOffers(requestParameters, options) {
    return VexGuestPaymentApiFp(this.configuration).getVexGuestPaymentUpgradeOffers(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Update the offer option for an individual payment
   * @summary Post vex guest payment upgrade
   * @param {VexGuestPaymentApiPostVexGuestPaymentUpgradeRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VexGuestPaymentApi
   */
  postVexGuestPaymentUpgrade(requestParameters, options) {
    return VexGuestPaymentApiFp(this.configuration).postVexGuestPaymentUpgrade(requestParameters.id, requestParameters.postVexGuestPaymentUpgradeRequest, options).then((request) => request(this.axios, this.basePath));
  }
};
var VexGuestPaymentApiInstance = createInstanceFromApiIClass(VexGuestPaymentApi);
var VexGuestVendorApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * This operation fetches vendor preferences
     * @summary Fetch vendor preferences
     * @param {string} id ID of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getVexGuestVendorPreferences: (_0, ..._1) => __async(this, [_0, ..._1], function* (id, options = {}) {
      assertParamExists("getVexGuestVendorPreferences", "id", id);
      const localVarPath = `/vex/guest/vendor/{id}/preferences`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * This operation creates or updates vendor preferred premium methods
     * @summary Create or update vendor preferred premium methods
     * @param {string} id ID of the entity
     * @param {PostVexGuestVendorPreferencesPremiumMethodsRequest} [postVexGuestVendorPreferencesPremiumMethodsRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postVexGuestVendorPreferencesPremiumMethods: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (id, postVexGuestVendorPreferencesPremiumMethodsRequest, options = {}) {
      assertParamExists("postVexGuestVendorPreferencesPremiumMethods", "id", id);
      const localVarPath = `/vex/guest/vendor/{id}/preferences/premium-methods`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(postVexGuestVendorPreferencesPremiumMethodsRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    })
  };
};
var VexGuestVendorApiFp = function(configuration) {
  const localVarAxiosParamCreator = VexGuestVendorApiAxiosParamCreator(configuration);
  return {
    /**
     * This operation fetches vendor preferences
     * @summary Fetch vendor preferences
     * @param {string} id ID of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getVexGuestVendorPreferences(id, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getVexGuestVendorPreferences(id, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * This operation creates or updates vendor preferred premium methods
     * @summary Create or update vendor preferred premium methods
     * @param {string} id ID of the entity
     * @param {PostVexGuestVendorPreferencesPremiumMethodsRequest} [postVexGuestVendorPreferencesPremiumMethodsRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postVexGuestVendorPreferencesPremiumMethods(id, postVexGuestVendorPreferencesPremiumMethodsRequest, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postVexGuestVendorPreferencesPremiumMethods(id, postVexGuestVendorPreferencesPremiumMethodsRequest, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    }
  };
};
var VexGuestVendorApiClient = createApiFromFp(VexGuestVendorApiFp);
var VexGuestVendorApiFactory = function(configuration, basePath, axios2) {
  const localVarFp = VexGuestVendorApiFp(configuration);
  return {
    /**
     * This operation fetches vendor preferences
     * @summary Fetch vendor preferences
     * @param {string} id ID of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getVexGuestVendorPreferences(id, options) {
      return localVarFp.getVexGuestVendorPreferences(id, options).then((request) => request(axios2, basePath));
    },
    /**
     * This operation creates or updates vendor preferred premium methods
     * @summary Create or update vendor preferred premium methods
     * @param {string} id ID of the entity
     * @param {PostVexGuestVendorPreferencesPremiumMethodsRequest} [postVexGuestVendorPreferencesPremiumMethodsRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postVexGuestVendorPreferencesPremiumMethods(id, postVexGuestVendorPreferencesPremiumMethodsRequest, options) {
      return localVarFp.postVexGuestVendorPreferencesPremiumMethods(id, postVexGuestVendorPreferencesPremiumMethodsRequest, options).then((request) => request(axios2, basePath));
    }
  };
};
var VexGuestVendorApi = class extends BaseAPI {
  /**
   * This operation fetches vendor preferences
   * @summary Fetch vendor preferences
   * @param {VexGuestVendorApiGetVexGuestVendorPreferencesRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VexGuestVendorApi
   */
  getVexGuestVendorPreferences(requestParameters, options) {
    return VexGuestVendorApiFp(this.configuration).getVexGuestVendorPreferences(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * This operation creates or updates vendor preferred premium methods
   * @summary Create or update vendor preferred premium methods
   * @param {VexGuestVendorApiPostVexGuestVendorPreferencesPremiumMethodsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VexGuestVendorApi
   */
  postVexGuestVendorPreferencesPremiumMethods(requestParameters, options) {
    return VexGuestVendorApiFp(this.configuration).postVexGuestVendorPreferencesPremiumMethods(requestParameters.id, requestParameters.postVexGuestVendorPreferencesPremiumMethodsRequest, options).then((request) => request(this.axios, this.basePath));
  }
};
var VexGuestVendorApiInstance = createInstanceFromApiIClass(VexGuestVendorApi);
var VexGuestW9ApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * Retrieves the status of w9 request
     * @summary Retrieves the status of w9 request
     * @param {string} id ID of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getVexGuestW9RequestStatus: (_0, ..._1) => __async(this, [_0, ..._1], function* (id, options = {}) {
      assertParamExists("getVexGuestW9RequestStatus", "id", id);
      const localVarPath = `/vex/guest/w9/{id}/status`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * This endpoint is handling w9 request completed
     * @summary vex guest request w9  completed
     * @param {string} id ID of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postVexGuestW9RequestCompleted: (_0, ..._1) => __async(this, [_0, ..._1], function* (id, options = {}) {
      assertParamExists("postVexGuestW9RequestCompleted", "id", id);
      const localVarPath = `/vex/guest/w9/{id}/request-completed`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * This endpoint is handling w9 request-form
     * @summary Post vex guest create request-form
     * @param {string} id ID of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postVexGuestW9RequestForm: (_0, ..._1) => __async(this, [_0, ..._1], function* (id, options = {}) {
      assertParamExists("postVexGuestW9RequestForm", "id", id);
      const localVarPath = `/vex/guest/w9/{id}/request-form`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * 
     * @summary post request w9 upload file
     * @param {string} id ID of the entity
     * @param {any} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postVexRequestW9UploadFile: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (id, file, options = {}) {
      assertParamExists("postVexRequestW9UploadFile", "id", id);
      const localVarPath = `/vex/guest/w9/{id}/upload-file`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      const localVarFormParams = new (configuration && configuration.formDataCtor || FormData)();
      if (file !== void 0) {
        localVarFormParams.append("file", file);
      }
      localVarHeaderParameter["Content-Type"] = "multipart/form-data";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = localVarFormParams;
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    })
  };
};
var VexGuestW9ApiFp = function(configuration) {
  const localVarAxiosParamCreator = VexGuestW9ApiAxiosParamCreator(configuration);
  return {
    /**
     * Retrieves the status of w9 request
     * @summary Retrieves the status of w9 request
     * @param {string} id ID of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getVexGuestW9RequestStatus(id, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getVexGuestW9RequestStatus(id, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * This endpoint is handling w9 request completed
     * @summary vex guest request w9  completed
     * @param {string} id ID of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postVexGuestW9RequestCompleted(id, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postVexGuestW9RequestCompleted(id, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * This endpoint is handling w9 request-form
     * @summary Post vex guest create request-form
     * @param {string} id ID of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postVexGuestW9RequestForm(id, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postVexGuestW9RequestForm(id, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * 
     * @summary post request w9 upload file
     * @param {string} id ID of the entity
     * @param {any} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postVexRequestW9UploadFile(id, file, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.postVexRequestW9UploadFile(id, file, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    }
  };
};
var VexGuestW9ApiClient = createApiFromFp(VexGuestW9ApiFp);
var VexGuestW9ApiFactory = function(configuration, basePath, axios2) {
  const localVarFp = VexGuestW9ApiFp(configuration);
  return {
    /**
     * Retrieves the status of w9 request
     * @summary Retrieves the status of w9 request
     * @param {string} id ID of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getVexGuestW9RequestStatus(id, options) {
      return localVarFp.getVexGuestW9RequestStatus(id, options).then((request) => request(axios2, basePath));
    },
    /**
     * This endpoint is handling w9 request completed
     * @summary vex guest request w9  completed
     * @param {string} id ID of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postVexGuestW9RequestCompleted(id, options) {
      return localVarFp.postVexGuestW9RequestCompleted(id, options).then((request) => request(axios2, basePath));
    },
    /**
     * This endpoint is handling w9 request-form
     * @summary Post vex guest create request-form
     * @param {string} id ID of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postVexGuestW9RequestForm(id, options) {
      return localVarFp.postVexGuestW9RequestForm(id, options).then((request) => request(axios2, basePath));
    },
    /**
     * 
     * @summary post request w9 upload file
     * @param {string} id ID of the entity
     * @param {any} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postVexRequestW9UploadFile(id, file, options) {
      return localVarFp.postVexRequestW9UploadFile(id, file, options).then((request) => request(axios2, basePath));
    }
  };
};
var VexGuestW9Api = class extends BaseAPI {
  /**
   * Retrieves the status of w9 request
   * @summary Retrieves the status of w9 request
   * @param {VexGuestW9ApiGetVexGuestW9RequestStatusRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VexGuestW9Api
   */
  getVexGuestW9RequestStatus(requestParameters, options) {
    return VexGuestW9ApiFp(this.configuration).getVexGuestW9RequestStatus(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * This endpoint is handling w9 request completed
   * @summary vex guest request w9  completed
   * @param {VexGuestW9ApiPostVexGuestW9RequestCompletedRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VexGuestW9Api
   */
  postVexGuestW9RequestCompleted(requestParameters, options) {
    return VexGuestW9ApiFp(this.configuration).postVexGuestW9RequestCompleted(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * This endpoint is handling w9 request-form
   * @summary Post vex guest create request-form
   * @param {VexGuestW9ApiPostVexGuestW9RequestFormRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VexGuestW9Api
   */
  postVexGuestW9RequestForm(requestParameters, options) {
    return VexGuestW9ApiFp(this.configuration).postVexGuestW9RequestForm(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * 
   * @summary post request w9 upload file
   * @param {VexGuestW9ApiPostVexRequestW9UploadFileRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VexGuestW9Api
   */
  postVexRequestW9UploadFile(requestParameters, options) {
    return VexGuestW9ApiFp(this.configuration).postVexRequestW9UploadFile(requestParameters.id, requestParameters.file, options).then((request) => request(this.axios, this.basePath));
  }
};
var VexGuestW9ApiInstance = createInstanceFromApiIClass(VexGuestW9Api);
var VexLinkStatusApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * This operation fetches the organization\'s link status to MSN business
     * @summary Fetch organization link status for MSN registration
     * @param {string} id ID of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getMsnLinkStatus: (_0, ..._1) => __async(this, [_0, ..._1], function* (id, options = {}) {
      assertParamExists("getMsnLinkStatus", "id", id);
      const localVarPath = `/vex/organizations/{id}/msn-link-status`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    })
  };
};
var VexLinkStatusApiFp = function(configuration) {
  const localVarAxiosParamCreator = VexLinkStatusApiAxiosParamCreator(configuration);
  return {
    /**
     * This operation fetches the organization\'s link status to MSN business
     * @summary Fetch organization link status for MSN registration
     * @param {string} id ID of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getMsnLinkStatus(id, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getMsnLinkStatus(id, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    }
  };
};
var VexLinkStatusApiClient = createApiFromFp(VexLinkStatusApiFp);
var VexLinkStatusApiFactory = function(configuration, basePath, axios2) {
  const localVarFp = VexLinkStatusApiFp(configuration);
  return {
    /**
     * This operation fetches the organization\'s link status to MSN business
     * @summary Fetch organization link status for MSN registration
     * @param {string} id ID of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getMsnLinkStatus(id, options) {
      return localVarFp.getMsnLinkStatus(id, options).then((request) => request(axios2, basePath));
    }
  };
};
var VexLinkStatusApi = class extends BaseAPI {
  /**
   * This operation fetches the organization\'s link status to MSN business
   * @summary Fetch organization link status for MSN registration
   * @param {VexLinkStatusApiGetMsnLinkStatusRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VexLinkStatusApi
   */
  getMsnLinkStatus(requestParameters, options) {
    return VexLinkStatusApiFp(this.configuration).getMsnLinkStatus(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
  }
};
var VexLinkStatusApiInstance = createInstanceFromApiIClass(VexLinkStatusApi);
var VexOrganizationsApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * Get the current user organization
     * @summary Get the current user organization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getMyOrganization: (..._0) => __async(this, [..._0], function* (options = {}) {
      const localVarPath = `/vex/organizations/me`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * 
     * @summary Get all of the selected organization\'s delivery methods
     * @param {string} id ID of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOrganizationDeliveryMethods: (_0, ..._1) => __async(this, [_0, ..._1], function* (id, options = {}) {
      assertParamExists("getOrganizationDeliveryMethods", "id", id);
      const localVarPath = `/vex/organizations/{id}/delivery-methods`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Get a map of id <> name of the user\'s organizations
     * @summary Get a map of id <> name of the user\'s organizations
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getVexMyOrganizations: (..._0) => __async(this, [..._0], function* (options = {}) {
      const localVarPath = `/vex/organizations`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      yield setBearerAuthToObject(localVarHeaderParameter, configuration);
      yield setApiKeyToObject(localVarHeaderParameter, "API-Key", configuration);
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }),
    /**
     * Update vendor organization
     * @summary Update vendor organization
     * @param {string} id ID of the entity
     * @param {PutOrganizationRequest} [putOrganizationRequest] Update vendor organization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    putOrganization: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (id, putOrganizationRequest, options = {}) {
      assertParamExists("putOrganization", "id", id);
      const localVarPath = `/vex/organizations/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "PUT" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      localVarHeaderParameter["Content-Type"] = "application/json";
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(putOrganizationRequest, localVarRequestOptions, configuration);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    })
  };
};
var VexOrganizationsApiFp = function(configuration) {
  const localVarAxiosParamCreator = VexOrganizationsApiAxiosParamCreator(configuration);
  return {
    /**
     * Get the current user organization
     * @summary Get the current user organization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getMyOrganization(options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getMyOrganization(options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * 
     * @summary Get all of the selected organization\'s delivery methods
     * @param {string} id ID of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOrganizationDeliveryMethods(id, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getOrganizationDeliveryMethods(id, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Get a map of id <> name of the user\'s organizations
     * @summary Get a map of id <> name of the user\'s organizations
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getVexMyOrganizations(options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getVexMyOrganizations(options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    },
    /**
     * Update vendor organization
     * @summary Update vendor organization
     * @param {string} id ID of the entity
     * @param {PutOrganizationRequest} [putOrganizationRequest] Update vendor organization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    putOrganization(id, putOrganizationRequest, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.putOrganization(id, putOrganizationRequest, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    }
  };
};
var VexOrganizationsApiClient = createApiFromFp(VexOrganizationsApiFp);
var VexOrganizationsApiFactory = function(configuration, basePath, axios2) {
  const localVarFp = VexOrganizationsApiFp(configuration);
  return {
    /**
     * Get the current user organization
     * @summary Get the current user organization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getMyOrganization(options) {
      return localVarFp.getMyOrganization(options).then((request) => request(axios2, basePath));
    },
    /**
     * 
     * @summary Get all of the selected organization\'s delivery methods
     * @param {string} id ID of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOrganizationDeliveryMethods(id, options) {
      return localVarFp.getOrganizationDeliveryMethods(id, options).then((request) => request(axios2, basePath));
    },
    /**
     * Get a map of id <> name of the user\'s organizations
     * @summary Get a map of id <> name of the user\'s organizations
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getVexMyOrganizations(options) {
      return localVarFp.getVexMyOrganizations(options).then((request) => request(axios2, basePath));
    },
    /**
     * Update vendor organization
     * @summary Update vendor organization
     * @param {string} id ID of the entity
     * @param {PutOrganizationRequest} [putOrganizationRequest] Update vendor organization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    putOrganization(id, putOrganizationRequest, options) {
      return localVarFp.putOrganization(id, putOrganizationRequest, options).then((request) => request(axios2, basePath));
    }
  };
};
var VexOrganizationsApi = class extends BaseAPI {
  /**
   * Get the current user organization
   * @summary Get the current user organization
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VexOrganizationsApi
   */
  getMyOrganization(options) {
    return VexOrganizationsApiFp(this.configuration).getMyOrganization(options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Get all of the selected organization\'s delivery methods
   * @param {VexOrganizationsApiGetOrganizationDeliveryMethodsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VexOrganizationsApi
   */
  getOrganizationDeliveryMethods(requestParameters, options) {
    return VexOrganizationsApiFp(this.configuration).getOrganizationDeliveryMethods(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Get a map of id <> name of the user\'s organizations
   * @summary Get a map of id <> name of the user\'s organizations
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VexOrganizationsApi
   */
  getVexMyOrganizations(options) {
    return VexOrganizationsApiFp(this.configuration).getVexMyOrganizations(options).then((request) => request(this.axios, this.basePath));
  }
  /**
   * Update vendor organization
   * @summary Update vendor organization
   * @param {VexOrganizationsApiPutOrganizationRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VexOrganizationsApi
   */
  putOrganization(requestParameters, options) {
    return VexOrganizationsApiFp(this.configuration).putOrganization(requestParameters.id, requestParameters.putOrganizationRequest, options).then((request) => request(this.axios, this.basePath));
  }
};
var VexOrganizationsApiInstance = createInstanceFromApiIClass(VexOrganizationsApi);
var VexOwnedVendorsApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * Retrieves the cap limit settings for every DM type set for the vendor
     * @summary Retrieves the cap limit settings for every DM type set for the vendor
     * @param {string} id ID of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getVexVendorsCapLimitSettings: (_0, ..._1) => __async(this, [_0, ..._1], function* (id, options = {}) {
      assertParamExists("getVexVendorsCapLimitSettings", "id", id);
      const localVarPath = `/vex/vendors/{id}/cap-limit-settings`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    })
  };
};
var VexOwnedVendorsApiFp = function(configuration) {
  const localVarAxiosParamCreator = VexOwnedVendorsApiAxiosParamCreator(configuration);
  return {
    /**
     * Retrieves the cap limit settings for every DM type set for the vendor
     * @summary Retrieves the cap limit settings for every DM type set for the vendor
     * @param {string} id ID of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getVexVendorsCapLimitSettings(id, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getVexVendorsCapLimitSettings(id, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    }
  };
};
var VexOwnedVendorsApiClient = createApiFromFp(VexOwnedVendorsApiFp);
var VexOwnedVendorsApiFactory = function(configuration, basePath, axios2) {
  const localVarFp = VexOwnedVendorsApiFp(configuration);
  return {
    /**
     * Retrieves the cap limit settings for every DM type set for the vendor
     * @summary Retrieves the cap limit settings for every DM type set for the vendor
     * @param {string} id ID of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getVexVendorsCapLimitSettings(id, options) {
      return localVarFp.getVexVendorsCapLimitSettings(id, options).then((request) => request(axios2, basePath));
    }
  };
};
var VexOwnedVendorsApi = class extends BaseAPI {
  /**
   * Retrieves the cap limit settings for every DM type set for the vendor
   * @summary Retrieves the cap limit settings for every DM type set for the vendor
   * @param {VexOwnedVendorsApiGetVexVendorsCapLimitSettingsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VexOwnedVendorsApi
   */
  getVexVendorsCapLimitSettings(requestParameters, options) {
    return VexOwnedVendorsApiFp(this.configuration).getVexVendorsCapLimitSettings(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
  }
};
var VexOwnedVendorsApiInstance = createInstanceFromApiIClass(VexOwnedVendorsApi);
var VexPaymentsApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * This operation fetches a payment
     * @summary Fetch a payment
     * @param {string} id ID of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getVexPayment: (_0, ..._1) => __async(this, [_0, ..._1], function* (id, options = {}) {
      assertParamExists("getVexPayment", "id", id);
      const localVarPath = `/vex/payments/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      localVarRequestOptions.params = localVarQueryParameter;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    })
  };
};
var VexPaymentsApiFp = function(configuration) {
  const localVarAxiosParamCreator = VexPaymentsApiAxiosParamCreator(configuration);
  return {
    /**
     * This operation fetches a payment
     * @summary Fetch a payment
     * @param {string} id ID of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getVexPayment(id, options) {
      return __async(this, null, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getVexPayment(id, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios2, BASE_PATH, configuration);
      });
    }
  };
};
var VexPaymentsApiClient = createApiFromFp(VexPaymentsApiFp);
var VexPaymentsApiFactory = function(configuration, basePath, axios2) {
  const localVarFp = VexPaymentsApiFp(configuration);
  return {
    /**
     * This operation fetches a payment
     * @summary Fetch a payment
     * @param {string} id ID of the entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getVexPayment(id, options) {
      return localVarFp.getVexPayment(id, options).then((request) => request(axios2, basePath));
    }
  };
};
var VexPaymentsApi = class extends BaseAPI {
  /**
   * This operation fetches a payment
   * @summary Fetch a payment
   * @param {VexPaymentsApiGetVexPaymentRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VexPaymentsApi
   */
  getVexPayment(requestParameters, options) {
    return VexPaymentsApiFp(this.configuration).getVexPayment(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
  }
};
var VexPaymentsApiInstance = createInstanceFromApiIClass(VexPaymentsApi);

// configuration.ts
var Configuration = class {
  constructor(param = {}) {
    this.apiKey = param.apiKey;
    this.username = param.username;
    this.password = param.password;
    this.accessToken = param.accessToken;
    this.basePath = param.basePath;
    this.baseOptions = param.baseOptions;
    this.formDataCtor = param.formDataCtor;
  }
  /**
   * Check if the given MIME is a JSON MIME.
   * JSON MIME examples:
   *   application/json
   *   application/json; charset=UTF8
   *   APPLICATION/JSON
   *   application/vnd.company+json
   * @param mime - MIME (Multipurpose Internet Mail Extensions)
   * @return True if the given MIME is JSON, false otherwise.
   */
  isJsonMime(mime) {
    const jsonMime = new RegExp("^(application/json|[^;/ 	]+/[^;/ 	]+[+]json)[ 	]*(;.*)?$", "i");
    return mime !== null && (jsonMime.test(mime) || mime.toLowerCase() === "application/json-patch+json");
  }
};

// client/utils/data-utils.ts
function extractData(res) {
  return res.data.data;
}
export {
  ARCombinedInvoicePaymentRequestDisplayStatusEnum,
  ARCombinedInvoicePaymentRequestStatusEnum,
  ARCurrency,
  AREnrollmentStatusEnum,
  ARErrorCode,
  ARFeeValueTypeEnum,
  ARInvoiceDisplayStatusEnum,
  ARInvoiceExpandedDisplayStatusEnum,
  ARInvoiceExpandedStatusEnum,
  ARInvoiceStatusEnum,
  ARPaymentRequestApprovalStatusEnum,
  ARPaymentRequestCreateOriginEnum,
  ARPaymentRequestFeesPaidByEnum,
  ARPaymentRequestSentFromEnum,
  ARPaymentRequestStatusEnum,
  ARSortQueryParamOrderEnum,
  AccountAllOfStatusEnum,
  AccountStatusEnum,
  AccountantsFirmClientApi,
  AccountantsFirmClientApiAxiosParamCreator,
  AccountantsFirmClientApiClient,
  AccountantsFirmClientApiFactory,
  AccountantsFirmClientApiFp,
  AccountantsFirmClientApiInstance,
  AccountantsUserServicesApi,
  AccountantsUserServicesApiAxiosParamCreator,
  AccountantsUserServicesApiClient,
  AccountantsUserServicesApiFactory,
  AccountantsUserServicesApiFp,
  AccountantsUserServicesApiInstance,
  AccountingFirmOrganizationBillingFeeApi,
  AccountingFirmOrganizationBillingFeeApiAxiosParamCreator,
  AccountingFirmOrganizationBillingFeeApiClient,
  AccountingFirmOrganizationBillingFeeApiFactory,
  AccountingFirmOrganizationBillingFeeApiFp,
  AccountingFirmOrganizationBillingFeeApiInstance,
  AccountingPlatformBillLabelOptionStatusEnum,
  AccountingPlatformBillLineItemLabelOptionStatusEnum,
  AccountingPlatformBillLineItemLabelStatusEnum,
  AccountingPlatformConnectionStatus,
  AccountingPlatformPostSyncEntityRequestSyncEntityEnum,
  AccountingPlatformPostSyncEntityResponseDataEntityEnum,
  AccountingPlatformSlug,
  AccountingPlatformSyncStatus,
  AccountingPlatformsApi,
  AccountingPlatformsApiAxiosParamCreator,
  AccountingPlatformsApiClient,
  AccountingPlatformsApiFactory,
  AccountingPlatformsApiFp,
  AccountingPlatformsApiInstance,
  AccountsApi,
  AccountsApiAxiosParamCreator,
  AccountsApiClient,
  AccountsApiFactory,
  AccountsApiFp,
  AccountsApiInstance,
  AccountsLimitationsApi,
  AccountsLimitationsApiAxiosParamCreator,
  AccountsLimitationsApiClient,
  AccountsLimitationsApiFactory,
  AccountsLimitationsApiFp,
  AccountsLimitationsApiInstance,
  ActionTokenTarget,
  AgreementType,
  AgreementsApi,
  AgreementsApiAxiosParamCreator,
  AgreementsApiClient,
  AgreementsApiFactory,
  AgreementsApiFp,
  AgreementsApiInstance,
  AllowedMccApi,
  AllowedMccApiAxiosParamCreator,
  AllowedMccApiClient,
  AllowedMccApiFactory,
  AllowedMccApiFp,
  AllowedMccApiInstance,
  ApiKeys,
  ApplyForFinancingBusinessType,
  ApplyForFinancingStatus,
  ApprovalDecisionActionIneligibleReasonEnum,
  ApprovalDecisionStatus,
  ApprovalRequirementStatus,
  ApprovalWorkflowsApi,
  ApprovalWorkflowsApiAxiosParamCreator,
  ApprovalWorkflowsApiClient,
  ApprovalWorkflowsApiFactory,
  ApprovalWorkflowsApiFp,
  ApprovalWorkflowsApiInstance,
  AssociatedType,
  AuthApi,
  AuthApiAxiosParamCreator,
  AuthApiClient,
  AuthApiFactory,
  AuthApiFp,
  AuthApiInstance,
  AutoPayApi,
  AutoPayApiAxiosParamCreator,
  AutoPayApiClient,
  AutoPayApiFactory,
  AutoPayApiFp,
  AutoPayApiInstance,
  AutoPayStatus,
  AutoPaymentAmountTypeEnum,
  AutoPaymentDeliveryDateTypeEnum,
  BASE_PATH,
  BankAccountType,
  BankAccountVerifiedStatusEnum,
  BankAccountsApi,
  BankAccountsApiAxiosParamCreator,
  BankAccountsApiClient,
  BankAccountsApiFactory,
  BankAccountsApiFp,
  BankAccountsApiInstance,
  BankFsTypeOptionTypeEnum,
  BaseAPI,
  BillApi,
  BillApiAxiosParamCreator,
  BillApiClient,
  BillApiFactory,
  BillApiFp,
  BillApiInstance,
  BillSubscriptionEndPolicyEnum,
  BillSubscriptionErrorCode,
  BillSubscriptionIntervalTypeEnum,
  BillSubscriptionManagedBy,
  BillSubscriptionRequestNoEndPolicyAllOfEndPolicyEnum,
  BillSubscriptionRequestNoEndPolicyEndPolicyEnum,
  BillSubscriptionRequestWithEndDateAllOfEndPolicyEnum,
  BillSubscriptionRequestWithEndDateEndPolicyEnum,
  BillSubscriptionRequestWithNumOfOccurrencesAllOfEndPolicyEnum,
  BillSubscriptionRequestWithNumOfOccurrencesEndPolicyEnum,
  BillSubscriptionStatus,
  BillSubscriptionsApi,
  BillSubscriptionsApiAxiosParamCreator,
  BillSubscriptionsApiClient,
  BillSubscriptionsApiFactory,
  BillSubscriptionsApiFp,
  BillSubscriptionsApiInstance,
  BillingFeeSettingBillingFeeTypeEnum,
  BillingFeeSettingsApi,
  BillingFeeSettingsApiAxiosParamCreator,
  BillingFeeSettingsApiClient,
  BillingFeeSettingsApiFactory,
  BillingFeeSettingsApiFp,
  BillingFeeSettingsApiInstance,
  BillsApi,
  BillsApiAxiosParamCreator,
  BillsApiClient,
  BillsApiFactory,
  BillsApiFp,
  BillsApiInstance,
  BillsSortQueryParamAllOfFieldEnum,
  BillsSortQueryParamFieldEnum,
  BillsSortQueryParamOrderEnum,
  BillsSyncAmazonApi,
  BillsSyncAmazonApiAxiosParamCreator,
  BillsSyncAmazonApiClient,
  BillsSyncAmazonApiFactory,
  BillsSyncAmazonApiFp,
  BillsSyncAmazonApiInstance,
  BillsSyncApi,
  BillsSyncApiAxiosParamCreator,
  BillsSyncApiClient,
  BillsSyncApiFactory,
  BillsSyncApiFp,
  BillsSyncApiInstance,
  BillsSyncGmailApi,
  BillsSyncGmailApiAxiosParamCreator,
  BillsSyncGmailApiClient,
  BillsSyncGmailApiFactory,
  BillsSyncGmailApiFp,
  BillsSyncGmailApiInstance,
  BillsSyncStatusEnum,
  BulkErrorResponseStatusEnum,
  BusinessDirectoryApi,
  BusinessDirectoryApiAxiosParamCreator,
  BusinessDirectoryApiClient,
  BusinessDirectoryApiFactory,
  BusinessDirectoryApiFp,
  BusinessDirectoryApiInstance,
  BusinessGeography,
  BusinessStructure,
  BusinessType,
  BusinessesApi,
  BusinessesApiAxiosParamCreator,
  BusinessesApiClient,
  BusinessesApiFactory,
  BusinessesApiFp,
  BusinessesApiInstance,
  COLLECTION_FORMATS,
  CancelActionInEligibleReasonEnum,
  CapitalOneProviderAllowedPartners,
  CardDirection,
  CardFsTypeOptionTypeEnum,
  CardNetwork,
  CardType,
  CatalogItemsApi,
  CatalogItemsApiAxiosParamCreator,
  CatalogItemsApiClient,
  CatalogItemsApiFactory,
  CatalogItemsApiFp,
  CatalogItemsApiInstance,
  CategoryBasedBillLineItemBaseTypeEnum,
  CategoryBasedBillLineItemResponseTypeEnum,
  CategoryBasedBillLineItemTypeEnum,
  CompanyComplianceEntityInformationMissingFieldsNameEnum,
  CompanyType,
  Configuration,
  ConflictedFieldType,
  CreateFeePaymentParametersCreateMethodEnum,
  CreatedByTypeEnum,
  Currency,
  CustomerTypeEnum,
  CustomerTypeRequestPayloadEnum,
  CustomersApi,
  CustomersApiAxiosParamCreator,
  CustomersApiClient,
  CustomersApiFactory,
  CustomersApiFp,
  CustomersApiInstance,
  CustomersDashboardApi,
  CustomersDashboardApiAxiosParamCreator,
  CustomersDashboardApiClient,
  CustomersDashboardApiFactory,
  CustomersDashboardApiFp,
  CustomersDashboardApiInstance,
  CustomersDashboardSortQueryParamAllOfFieldEnum,
  CustomersDashboardSortQueryParamFieldEnum,
  CustomersDashboardSortQueryParamOrderEnum,
  CustomersSortQueryParamAllOfFieldEnum,
  CustomersSortQueryParamFieldEnum,
  CustomersSortQueryParamOrderEnum,
  DefaultApi,
  DefaultApiAxiosParamCreator,
  DefaultApiClient,
  DefaultApiFactory,
  DefaultApiFp,
  DefaultApiInstance,
  DeleteActionInEligibleReasonEnum,
  DeliveryMethodAccountType,
  DeliveryMethodType,
  DeliveryMethodTypeOptionsApi,
  DeliveryMethodTypeOptionsApiAxiosParamCreator,
  DeliveryMethodTypeOptionsApiClient,
  DeliveryMethodTypeOptionsApiFactory,
  DeliveryMethodTypeOptionsApiFp,
  DeliveryMethodTypeOptionsApiInstance,
  DeliveryMethodUpdateType,
  DeliveryMethodsApi,
  DeliveryMethodsApiAxiosParamCreator,
  DeliveryMethodsApiClient,
  DeliveryMethodsApiFactory,
  DeliveryMethodsApiFp,
  DeliveryMethodsApiInstance,
  DeliveryPreferenceType,
  DemoRequestsApi,
  DemoRequestsApiAxiosParamCreator,
  DemoRequestsApiClient,
  DemoRequestsApiFactory,
  DemoRequestsApiFp,
  DemoRequestsApiInstance,
  EBillStatus,
  EBillsSubscriptionsApi,
  EBillsSubscriptionsApiAxiosParamCreator,
  EBillsSubscriptionsApiClient,
  EBillsSubscriptionsApiFactory,
  EBillsSubscriptionsApiFp,
  EBillsSubscriptionsApiInstance,
  EbillsSubscriptionOptionsReceivingOptionNameEnum,
  EditActionInEligibleReasonEnum,
  EncryptionApi,
  EncryptionApiAxiosParamCreator,
  EncryptionApiClient,
  EncryptionApiFactory,
  EncryptionApiFp,
  EncryptionApiInstance,
  ExternalTarget,
  FeatureFlagsApi,
  FeatureFlagsApiAxiosParamCreator,
  FeatureFlagsApiClient,
  FeatureFlagsApiFactory,
  FeatureFlagsApiFp,
  FeatureFlagsApiInstance,
  FeeCatalogValueTypeEnum,
  FeeCatalogsApi,
  FeeCatalogsApiAxiosParamCreator,
  FeeCatalogsApiClient,
  FeeCatalogsApiFactory,
  FeeCatalogsApiFp,
  FeeCatalogsApiInstance,
  FeeFundingSourceType,
  FeeType,
  FeesApi,
  FeesApiAxiosParamCreator,
  FeesApiClient,
  FeesApiFactory,
  FeesApiFp,
  FeesApiInstance,
  FeesPaidByEnum,
  FileOCRDataLineItemTypeEnum,
  FilesApi,
  FilesApiAxiosParamCreator,
  FilesApiClient,
  FilesApiFactory,
  FilesApiFp,
  FilesApiInstance,
  FinancingApi,
  FinancingApiAxiosParamCreator,
  FinancingApiClient,
  FinancingApiFactory,
  FinancingApiFp,
  FinancingApiInstance,
  FinancingEligibilityStatus,
  FinancingPaymentIneligibilityReason,
  FinancingProvider,
  FirmAccessLevel,
  FiservBusinessesResultDirectoryNameEnum,
  FiservProviderAllowedPartners,
  FlexFsTypeOptionTypeEnum,
  FundingSourceBankAccountAllOfTypeEnum,
  FundingSourceBankAccountTypeEnum,
  FundingSourceCardAllOfTypeEnum,
  FundingSourceCardTypeEnum,
  FundingSourceEntitlementType,
  FundingSourceFlexAccountAllOfTypeEnum,
  FundingSourceFlexAccountTypeEnum,
  FundingSourceOptionTypeEnum,
  FundingSourceType,
  FundingSourcesApi,
  FundingSourcesApiAxiosParamCreator,
  FundingSourcesApiClient,
  FundingSourcesApiFactory,
  FundingSourcesApiFp,
  FundingSourcesApiInstance,
  FundingSourcesIncludeEnum,
  FundingSourcesVerifyRequestMicroDepositsTypeEnum,
  FundingSourcesVerifyRequestPlaidTypeEnum,
  GetBillsBillIdAttachmentsApi,
  GetBillsBillIdAttachmentsApiAxiosParamCreator,
  GetBillsBillIdAttachmentsApiClient,
  GetBillsBillIdAttachmentsApiFactory,
  GetBillsBillIdAttachmentsApiFp,
  GetBillsBillIdAttachmentsApiInstance,
  GetSyncMigrationResponseDataStatusEnum,
  GetVexGuestPaymentResponseDataStatusEnum,
  GetVirtualCardAcceptanceResponseDataStatusEnum,
  InboxEmailAllOfOriginEnum,
  InboxEmailOriginEnum,
  InboxItemBillTypeEnum,
  InboxItemPaymentRequestTypeEnum,
  InboxItemPaymentTypeEnum,
  InboxItemScannedInvoiceTypeEnum,
  InboxItemTypesEnum,
  InboxItemsApi,
  InboxItemsApiAxiosParamCreator,
  InboxItemsApiClient,
  InboxItemsApiFactory,
  InboxItemsApiFp,
  InboxItemsApiInstance,
  InboxItemsSortQueryParamAllOfFieldEnum,
  InboxItemsSortQueryParamFieldEnum,
  InboxItemsSortQueryParamOrderEnum,
  IndustriesApi,
  IndustriesApiAxiosParamCreator,
  IndustriesApiClient,
  IndustriesApiFactory,
  IndustriesApiFp,
  IndustriesApiInstance,
  IndustryApi,
  IndustryApiAxiosParamCreator,
  IndustryApiClient,
  IndustryApiFactory,
  IndustryApiFp,
  IndustryApiInstance,
  InitialManagedByType,
  InstallmentStatus,
  InternationalAccountBicSwiftIdentifierTypeEnum,
  InternationalAccountIbanIdentifierTypeEnum,
  InternationalAccountIdentifierTypeEnum,
  InternationalApi,
  InternationalApiAxiosParamCreator,
  InternationalApiClient,
  InternationalApiFactory,
  InternationalApiFp,
  InternationalApiInstance,
  InternationalBillingEnum,
  InvalidReason,
  InvitationStatus,
  InvoiceDataSourceEntityTypeEnum,
  InvoiceDiscountTypeEnum,
  InvoiceDiscountsApi,
  InvoiceDiscountsApiAxiosParamCreator,
  InvoiceDiscountsApiClient,
  InvoiceDiscountsApiFactory,
  InvoiceDiscountsApiFp,
  InvoiceDiscountsApiInstance,
  InvoiceExpandedApi,
  InvoiceExpandedApiAxiosParamCreator,
  InvoiceExpandedApiClient,
  InvoiceExpandedApiFactory,
  InvoiceExpandedApiFp,
  InvoiceExpandedApiInstance,
  InvoiceExpandedSummaryDisplayStatusEnum,
  InvoiceExpandedSummaryStatusEnum,
  InvoicePreferencesApi,
  InvoicePreferencesApiAxiosParamCreator,
  InvoicePreferencesApiClient,
  InvoicePreferencesApiFactory,
  InvoicePreferencesApiFp,
  InvoicePreferencesApiInstance,
  InvoiceSortQueryParamAllOfFieldEnum,
  InvoiceSortQueryParamFieldEnum,
  InvoiceSortQueryParamOrderEnum,
  InvoiceStatus,
  InvoiceTimelineApi,
  InvoiceTimelineApiAxiosParamCreator,
  InvoiceTimelineApiClient,
  InvoiceTimelineApiFactory,
  InvoiceTimelineApiFp,
  InvoiceTimelineApiInstance,
  InvoiceTimelineEmailTypeEnum,
  InvoicesApi,
  InvoicesApiAxiosParamCreator,
  InvoicesApiClient,
  InvoicesApiFactory,
  InvoicesApiFp,
  InvoicesApiInstance,
  ItemBasedBillLineItemBaseTypeEnum,
  ItemBasedBillLineItemResponseTypeEnum,
  ItemBasedBillLineItemTypeEnum,
  JoinOrganizationRequestRole,
  JoinOrganizationRequestStatus,
  JoinOrganizationRequestsApi,
  JoinOrganizationRequestsApiAxiosParamCreator,
  JoinOrganizationRequestsApiClient,
  JoinOrganizationRequestsApiFactory,
  JoinOrganizationRequestsApiFp,
  JoinOrganizationRequestsApiInstance,
  LoanStatus,
  ManagedAccountDeliveryTypeEnum,
  MeasurementUnit,
  MicroDepositApi,
  MicroDepositApiAxiosParamCreator,
  MicroDepositApiClient,
  MicroDepositApiFactory,
  MicroDepositApiFp,
  MicroDepositApiInstance,
  MsnOrigin,
  NotificationPreferencesApi,
  NotificationPreferencesApiAxiosParamCreator,
  NotificationPreferencesApiClient,
  NotificationPreferencesApiFactory,
  NotificationPreferencesApiFp,
  NotificationPreferencesApiInstance,
  NotificationsApi,
  NotificationsApiAxiosParamCreator,
  NotificationsApiClient,
  NotificationsApiFactory,
  NotificationsApiFp,
  NotificationsApiInstance,
  NotificationsNames,
  NullableInternationalBillingEnum,
  NullableInternationalRiskEnum,
  OAuthAccountNotCreatedReason,
  OAuthAccountStatus,
  OTPVerifyForbiddenErrorCode,
  OnboardingApi,
  OnboardingApiAxiosParamCreator,
  OnboardingApiClient,
  OnboardingApiFactory,
  OnboardingApiFp,
  OnboardingApiInstance,
  OnboardingStatusApi,
  OnboardingStatusApiAxiosParamCreator,
  OnboardingStatusApiClient,
  OnboardingStatusApiFactory,
  OnboardingStatusApiFp,
  OnboardingStatusApiInstance,
  OrgFinancingIneligibilityReason,
  OrgFinancingProviderStatusAllOf1ProviderEnum,
  OrgFinancingProviderStatusAllOf1StatusEnum,
  OrgFinancingProviderStatusProviderEnum,
  OrgFinancingProviderStatusStatusEnum,
  OrganizationBeneficialOwnersApi,
  OrganizationBeneficialOwnersApiAxiosParamCreator,
  OrganizationBeneficialOwnersApiClient,
  OrganizationBeneficialOwnersApiFactory,
  OrganizationBeneficialOwnersApiFp,
  OrganizationBeneficialOwnersApiInstance,
  OrganizationBusinessType,
  OrganizationFailureReason,
  OrganizationPreferencesApi,
  OrganizationPreferencesApiAxiosParamCreator,
  OrganizationPreferencesApiClient,
  OrganizationPreferencesApiFactory,
  OrganizationPreferencesApiFp,
  OrganizationPreferencesApiInstance,
  OrganizationToBusinessLinkStatus,
  OrganizationVerifiedPersonaTypeEnum,
  OrganizationsApi,
  OrganizationsApiAxiosParamCreator,
  OrganizationsApiClient,
  OrganizationsApiFactory,
  OrganizationsApiFp,
  OrganizationsApiInstance,
  PartnerName,
  PartnersApi,
  PartnersApiAxiosParamCreator,
  PartnersApiClient,
  PartnersApiFactory,
  PartnersApiFp,
  PartnersApiInstance,
  PatchBillSubscriptionsRequestEndPolicyEnum,
  PatchBillsBillIdRequestLineItemCreateOperationEnum,
  PatchBillsBillIdRequestLineItemDeleteOperationEnum,
  PatchBillsBillIdRequestLineItemLabelCreateOperationEnum,
  PatchBillsBillIdRequestLineItemLabelDeleteOperationEnum,
  PatchBillsBillIdRequestLineItemLabelUpdateOperationEnum,
  PatchBillsBillIdRequestLineItemUpdateOperationEnum,
  PatchCategoryBillLineItemUpdateTypeEnum,
  PatchItemBillLineItemUpdateTypeEnum,
  PatchMarkedAsPaidRequestMethodEnum,
  PaymentAllOfApprovalDecisionStatusEnum,
  PaymentAllOfStatusEnum,
  PaymentApi,
  PaymentApiAxiosParamCreator,
  PaymentApiClient,
  PaymentApiFactory,
  PaymentApiFp,
  PaymentApiInstance,
  PaymentApprovalDecisionStatusEnum,
  PaymentCreateMethodEnum,
  PaymentDeliveryPreferenceEnum,
  PaymentDisabledActionNameEnum,
  PaymentErrorCode,
  PaymentFailureReason,
  PaymentFailureType,
  PaymentGetRequiredDocumentsApi,
  PaymentGetRequiredDocumentsApiAxiosParamCreator,
  PaymentGetRequiredDocumentsApiClient,
  PaymentGetRequiredDocumentsApiFactory,
  PaymentGetRequiredDocumentsApiFp,
  PaymentGetRequiredDocumentsApiInstance,
  PaymentIntentAllOfStatusEnum,
  PaymentIntentPatchBulkSuccessStatusEnum,
  PaymentIntentStatusEnum,
  PaymentIntentsApi,
  PaymentIntentsApiAxiosParamCreator,
  PaymentIntentsApiClient,
  PaymentIntentsApiFactory,
  PaymentIntentsApiFp,
  PaymentIntentsApiInstance,
  PaymentIntentsFromBillApi,
  PaymentIntentsFromBillApiAxiosParamCreator,
  PaymentIntentsFromBillApiClient,
  PaymentIntentsFromBillApiFactory,
  PaymentIntentsFromBillApiFp,
  PaymentIntentsFromBillApiInstance,
  PaymentIntentsFromPaymentApi,
  PaymentIntentsFromPaymentApiAxiosParamCreator,
  PaymentIntentsFromPaymentApiClient,
  PaymentIntentsFromPaymentApiFactory,
  PaymentIntentsFromPaymentApiFp,
  PaymentIntentsFromPaymentApiInstance,
  PaymentProcessStatusEnum,
  PaymentRequestAllOfStatusEnum,
  PaymentRequestStatusEnum,
  PaymentRequestsApi,
  PaymentRequestsApiAxiosParamCreator,
  PaymentRequestsApiClient,
  PaymentRequestsApiFactory,
  PaymentRequestsApiFp,
  PaymentRequestsApiInstance,
  PaymentStatus,
  PaymentStatusEnum,
  PaymentTimelineItemFlowEnum,
  PaymentTimelineItemStatusEnum,
  PaymentTimelineItemTargetAccountTypeEnum,
  PaymentUpgradeOfferOptionEnum,
  PaymentWidgetFundingSourceType,
  PaymentsApi,
  PaymentsApiAxiosParamCreator,
  PaymentsApiClient,
  PaymentsApiFactory,
  PaymentsApiFp,
  PaymentsApiInstance,
  PaymentsAttachFilesRequestApi,
  PaymentsAttachFilesRequestApiAxiosParamCreator,
  PaymentsAttachFilesRequestApiClient,
  PaymentsAttachFilesRequestApiFactory,
  PaymentsAttachFilesRequestApiFp,
  PaymentsAttachFilesRequestApiInstance,
  PaymentsSortQueryParamAllOfFieldEnum,
  PaymentsSortQueryParamFieldEnum,
  PaymentsSortQueryParamOrderEnum,
  PayorApi,
  PayorApiAxiosParamCreator,
  PayorApiClient,
  PayorApiFactory,
  PayorApiFp,
  PayorApiInstance,
  PermissionLevel,
  PersonasApi,
  PersonasApiAxiosParamCreator,
  PersonasApiClient,
  PersonasApiFactory,
  PersonasApiFp,
  PersonasApiInstance,
  PlaidAccountVerificationStatusEnum,
  PlansApi,
  PlansApiAxiosParamCreator,
  PlansApiClient,
  PlansApiFactory,
  PlansApiFp,
  PlansApiInstance,
  PostAccountingPlatformPaymentAccountRequestTypeEnum,
  PostApprovalDecisionEnum,
  PostBillingFeeSettingsRequestBillingFeeTypeEnum,
  PostDeliveryMethodsPlaidLinkTokenRequestTypeEnum,
  PostFundingSourcesRequestTypeEnum,
  PostMarkedAsPaidRequestMethodEnum,
  PostPayorFundingSourceRequestTypeEnum,
  PostPlaidLinkTokenRegistrationRequestTypeEnum,
  PostPlaidLinkTokenVerificationRequestTypeEnum,
  PostShareInvoiceRequestSentFromEnum,
  PostShareInvoiceRequestTypeEnum,
  PostVendorEbillsSubscriptionRequestReceivingOptionEnum,
  PostVendorsManagedFiservManagedByEnum,
  PostVendorsRequestAnalyticsMetadataFlowEnum,
  PromoCodeStatusEnum,
  PromoCodeUpToPeriodsUpToPeriodsTypeEnum,
  PublicPayorApi,
  PublicPayorApiAxiosParamCreator,
  PublicPayorApiClient,
  PublicPayorApiFactory,
  PublicPayorApiFp,
  PublicPayorApiInstance,
  PushToDebitActionInEligibleReasonEnum,
  ReceivablePaymentDetailsBaseMethodEnum,
  ReceivablePaymentDetailsBasePaymentStatusEnum,
  ReceivablePaymentDetailsBaseSourceEnum,
  ReceivablePaymentDetailsMethodEnum,
  ReceivablePaymentDetailsPaymentStatusEnum,
  ReceivablePaymentDetailsSourceEnum,
  ReceivingMethodType,
  ReceivingMethodsApi,
  ReceivingMethodsApiAxiosParamCreator,
  ReceivingMethodsApiClient,
  ReceivingMethodsApiFactory,
  ReceivingMethodsApiFp,
  ReceivingMethodsApiInstance,
  RecommendedVendorTypeEnum,
  RecommendedVendorsApi,
  RecommendedVendorsApiAxiosParamCreator,
  RecommendedVendorsApiClient,
  RecommendedVendorsApiFactory,
  RecommendedVendorsApiFp,
  RecommendedVendorsApiInstance,
  RefundStatusEnum,
  RepaymentTermsIneligibilityReason,
  ReportsApi,
  ReportsApiAxiosParamCreator,
  ReportsApiClient,
  ReportsApiFactory,
  ReportsApiFp,
  ReportsApiInstance,
  RequiredError,
  ResponseStatusError,
  ResponseStatusSuccess,
  RoleType,
  RoleUniqueNames,
  ScannedInvoiceLineItemAllOfTypeEnum,
  ScannedInvoiceLineItemTypeEnum,
  ScannedInvoicesApi,
  ScannedInvoicesApiAxiosParamCreator,
  ScannedInvoicesApiClient,
  ScannedInvoicesApiFactory,
  ScannedInvoicesApiFp,
  ScannedInvoicesApiInstance,
  ServerConfig,
  ServiceChargeCatalogsApi,
  ServiceChargeCatalogsApiAxiosParamCreator,
  ServiceChargeCatalogsApiClient,
  ServiceChargeCatalogsApiFactory,
  ServiceChargeCatalogsApiFp,
  ServiceChargeCatalogsApiInstance,
  ServiceChargeTypeEnum,
  ServicesApi,
  ServicesApiAxiosParamCreator,
  ServicesApiClient,
  ServicesApiFactory,
  ServicesApiFp,
  ServicesApiInstance,
  SignatureCreateParamsAgreeEnum,
  SignaturesApi,
  SignaturesApiAxiosParamCreator,
  SignaturesApiClient,
  SignaturesApiFactory,
  SignaturesApiFp,
  SignaturesApiInstance,
  SortQueryParamOrderEnum,
  SubscriptionBillingCycleEnum,
  SubscriptionBillingHistoryItemStatusEnum,
  SubscriptionBillingItemChargeTypeEnum,
  SubscriptionBillingItemMeasurementUnit,
  SubscriptionErrorCode,
  SubscriptionOrganizationsApi,
  SubscriptionOrganizationsApiAxiosParamCreator,
  SubscriptionOrganizationsApiClient,
  SubscriptionOrganizationsApiFactory,
  SubscriptionOrganizationsApiFp,
  SubscriptionOrganizationsApiInstance,
  SubscriptionSyncedPaymentsApi,
  SubscriptionSyncedPaymentsApiAxiosParamCreator,
  SubscriptionSyncedPaymentsApiClient,
  SubscriptionSyncedPaymentsApiFactory,
  SubscriptionSyncedPaymentsApiFp,
  SubscriptionSyncedPaymentsApiInstance,
  SubscriptionsApi,
  SubscriptionsApiAxiosParamCreator,
  SubscriptionsApiClient,
  SubscriptionsApiFactory,
  SubscriptionsApiFp,
  SubscriptionsApiInstance,
  SupportApi,
  SupportApiAxiosParamCreator,
  SupportApiClient,
  SupportApiFactory,
  SupportApiFp,
  SupportApiInstance,
  SyncApi,
  SyncApiAxiosParamCreator,
  SyncApiClient,
  SyncApiFactory,
  SyncApiFp,
  SyncApiInstance,
  TaxIdTypeEnum,
  TaxRatesApi,
  TaxRatesApiAxiosParamCreator,
  TaxRatesApiClient,
  TaxRatesApiFactory,
  TaxRatesApiFp,
  TaxRatesApiInstance,
  TaxpayerIdentificationRequestAllOfStatusEnum,
  TaxpayerIdentificationRequestErrorCode,
  TaxpayerIdentificationRequestStatus,
  TaxpayerIdentificationRequestStatusEnum,
  TaxpayerIdentificationRequestsApi,
  TaxpayerIdentificationRequestsApiAxiosParamCreator,
  TaxpayerIdentificationRequestsApiClient,
  TaxpayerIdentificationRequestsApiFactory,
  TaxpayerIdentificationRequestsApiFp,
  TaxpayerIdentificationRequestsApiInstance,
  TaxpayerInfoApi,
  TaxpayerInfoApiAxiosParamCreator,
  TaxpayerInfoApiClient,
  TaxpayerInfoApiFactory,
  TaxpayerInfoApiFp,
  TaxpayerInfoApiInstance,
  Tier,
  TodoActivateCollaboratorsTypeEnum,
  TodoFailedPaymentTypeEnum,
  TodoOverdueIn7DaysInboxItemsTypeEnum,
  TodoOverdueInMoreThan7DaysInboxItemsTypeEnum,
  TodoOverdueInboxItemsTypeEnum,
  TodoPaymentsToApproveTypeEnum,
  TodosApi,
  TodosApiAxiosParamCreator,
  TodosApiClient,
  TodosApiFactory,
  TodosApiFp,
  TodosApiInstance,
  TokenProvider,
  TrackerTimelineStatusEnum,
  UnilateralRequestAllOfStatusEnum,
  UnilateralRequestStatusEnum,
  UnilateralRequestsApi,
  UnilateralRequestsApiAxiosParamCreator,
  UnilateralRequestsApiClient,
  UnilateralRequestsApiFactory,
  UnilateralRequestsApiFp,
  UnilateralRequestsApiInstance,
  UnsupportedDeliveryMethodTypeReason,
  UnsupportedDeliveryPreferenceReason,
  UnsupportedFsReasons,
  UploadErrorCode,
  UploadRequestObjectCompletedUploadStatusEnum,
  UploadRequestObjectFailedUploadStatusEnum,
  UploadRequestObjectPendingUploadStatusEnum,
  UserComplianceEntityInformationMissingFieldsNameEnum,
  UserPreferencesApi,
  UserPreferencesApiAxiosParamCreator,
  UserPreferencesApiClient,
  UserPreferencesApiFactory,
  UserPreferencesApiFp,
  UserPreferencesApiInstance,
  UserRegistrationFlowEnum,
  UserRole,
  UserRoleErrorAllOfErrorCodeEnum,
  UserRoleErrorErrorCodeEnum,
  UserTypes,
  VEXErrorCodes,
  VendorGroupsApi,
  VendorGroupsApiAxiosParamCreator,
  VendorGroupsApiClient,
  VendorGroupsApiFactory,
  VendorGroupsApiFp,
  VendorGroupsApiInstance,
  VendorManagedBy,
  VendorPersistentFastEligibilityTypeEnum,
  VendorPreferredPremiumMethodsEnum,
  VendorPremiumMethodsStateEnum,
  VendorWarningCodeEnum,
  VendorsApi,
  VendorsApiAxiosParamCreator,
  VendorsApiClient,
  VendorsApiFactory,
  VendorsApiFp,
  VendorsApiInstance,
  VendorsSortQueryParamAllOfFieldEnum,
  VendorsSortQueryParamFieldEnum,
  VendorsSortQueryParamOrderEnum,
  VerifyQuickBooksDesktopConnectionStatus,
  VexAuthenticationApi,
  VexAuthenticationApiAxiosParamCreator,
  VexAuthenticationApiClient,
  VexAuthenticationApiFactory,
  VexAuthenticationApiFp,
  VexAuthenticationApiInstance,
  VexDeliveryMethodsApi,
  VexDeliveryMethodsApiAxiosParamCreator,
  VexDeliveryMethodsApiClient,
  VexDeliveryMethodsApiFactory,
  VexDeliveryMethodsApiFp,
  VexDeliveryMethodsApiInstance,
  VexFTIApi,
  VexFTIApiAxiosParamCreator,
  VexFTIApiClient,
  VexFTIApiFactory,
  VexFTIApiFp,
  VexFTIApiInstance,
  VexGuestApi,
  VexGuestApiAxiosParamCreator,
  VexGuestApiClient,
  VexGuestApiFactory,
  VexGuestApiFp,
  VexGuestApiInstance,
  VexGuestDeliveryMethodsApi,
  VexGuestDeliveryMethodsApiAxiosParamCreator,
  VexGuestDeliveryMethodsApiClient,
  VexGuestDeliveryMethodsApiFactory,
  VexGuestDeliveryMethodsApiFp,
  VexGuestDeliveryMethodsApiInstance,
  VexGuestPaymentApi,
  VexGuestPaymentApiAxiosParamCreator,
  VexGuestPaymentApiClient,
  VexGuestPaymentApiFactory,
  VexGuestPaymentApiFp,
  VexGuestPaymentApiInstance,
  VexGuestVendorApi,
  VexGuestVendorApiAxiosParamCreator,
  VexGuestVendorApiClient,
  VexGuestVendorApiFactory,
  VexGuestVendorApiFp,
  VexGuestVendorApiInstance,
  VexGuestW9Api,
  VexGuestW9ApiAxiosParamCreator,
  VexGuestW9ApiClient,
  VexGuestW9ApiFactory,
  VexGuestW9ApiFp,
  VexGuestW9ApiInstance,
  VexLinkStatusApi,
  VexLinkStatusApiAxiosParamCreator,
  VexLinkStatusApiClient,
  VexLinkStatusApiFactory,
  VexLinkStatusApiFp,
  VexLinkStatusApiInstance,
  VexOrganizationsApi,
  VexOrganizationsApiAxiosParamCreator,
  VexOrganizationsApiClient,
  VexOrganizationsApiFactory,
  VexOrganizationsApiFp,
  VexOrganizationsApiInstance,
  VexOwnedVendorsApi,
  VexOwnedVendorsApiAxiosParamCreator,
  VexOwnedVendorsApiClient,
  VexOwnedVendorsApiFactory,
  VexOwnedVendorsApiFp,
  VexOwnedVendorsApiInstance,
  VexPaymentsApi,
  VexPaymentsApiAxiosParamCreator,
  VexPaymentsApiClient,
  VexPaymentsApiFactory,
  VexPaymentsApiFp,
  VexPaymentsApiInstance,
  VoidAndRefundActionIneligibleReasonEnum,
  VoidAndResendActionIneligibleReasonEnum,
  VoidCheckStatusEnum,
  WorkflowActionsRolesTypeEnum,
  WorkflowActionsUsersTypeEnum,
  WorkflowCollaboratorsConditionTypeEnum,
  WorkflowCollaboratorsRolesFilterByEnum,
  WorkflowCollaboratorsSpecificFilterByEnum,
  WorkflowCriteriaOperatorEnum,
  WorkflowNumericConditionConfigurationOperatorEnum,
  WorkflowNumericConditionTypeEnum,
  WorkflowPaymentAmountConditionAttributeEnum,
  WorkflowPaymentCreatedByConditionAttributeEnum,
  WorkflowPaymentVendorConditionAttributeEnum,
  WorkflowVendorsConditionTypeEnum,
  extractData
};
